webpackJsonp([251955352258861],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = curry;
	
	
	// eslint-disable-next-line no-unused-vars
	function curried(f, length, acc) {
	  return function fn() {
	    // eslint-disable-next-line prefer-rest-params
	    var combined = acc.concat(Array.prototype.slice.call(arguments));
	    return combined.length >= length ? f.apply(this, combined) : curried(f, length, combined);
	  };
	}
	
	// eslint-disable-next-line no-redeclare
	
	// eslint-disable-next-line no-redeclare
	
	// eslint-disable-next-line no-unused-vars
	
	
	// Type definitions taken from https://github.com/gcanti/flow-static-land/blob/master/src/Fun.js
	function curry(f) {
	  // eslint-disable-line no-redeclare
	  return curried(f, f.length, []);
	}
	module.exports = exports["default"];

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	module.exports = visit
	
	var is = __webpack_require__(56)
	
	var CONTINUE = true
	var SKIP = 'skip'
	var EXIT = false
	
	visit.CONTINUE = CONTINUE
	visit.SKIP = SKIP
	visit.EXIT = EXIT
	
	function visit(tree, test, visitor, reverse) {
	  if (typeof test === 'function' && typeof visitor !== 'function') {
	    reverse = visitor
	    visitor = test
	    test = null
	  }
	
	  one(tree)
	
	  /* Visit a single node. */
	  function one(node, index, parent) {
	    var result
	
	    index = index || (parent ? 0 : null)
	
	    if (!test || node.type === test || is(test, node, index, parent || null)) {
	      result = visitor(node, index, parent || null)
	    }
	
	    if (result === EXIT) {
	      return result
	    }
	
	    if (node.children && result !== SKIP) {
	      return all(node.children, node) === EXIT ? EXIT : result
	    }
	
	    return result
	  }
	
	  /* Visit children in `parent`. */
	  function all(children, parent) {
	    var step = reverse ? -1 : 1
	    var index = (reverse ? children.length : -1) + step
	    var child
	    var result
	
	    while (index > -1 && index < children.length) {
	      child = children[index]
	      result = child && one(child, index, parent)
	
	      if (result === EXIT) {
	        return result
	      }
	
	      index = typeof result === 'number' ? result : index + step
	    }
	
	    return CONTINUE
	  }
	}


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rgb = /*#__PURE__*/__webpack_require__(42);
	
	var _rgb2 = /*#__PURE__*/_interopRequireDefault(_rgb);
	
	var _rgba = /*#__PURE__*/__webpack_require__(25);
	
	var _rgba2 = /*#__PURE__*/_interopRequireDefault(_rgba);
	
	var _hsl = /*#__PURE__*/__webpack_require__(59);
	
	var _hsl2 = /*#__PURE__*/_interopRequireDefault(_hsl);
	
	var _hsla = /*#__PURE__*/__webpack_require__(60);
	
	var _hsla2 = /*#__PURE__*/_interopRequireDefault(_hsla);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isRgb = function isRgb(color) {
	  return typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number' && (typeof color.alpha !== 'number' || typeof color.alpha === 'undefined');
	};
	
	var isRgba = function isRgba(color) {
	  return typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number' && typeof color.alpha === 'number';
	};
	
	var isHsl = function isHsl(color) {
	  return typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && (typeof color.alpha !== 'number' || typeof color.alpha === 'undefined');
	};
	
	var isHsla = function isHsla(color) {
	  return typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && typeof color.alpha === 'number';
	};
	
	var errMsg = 'Passed invalid argument to toColorString, please pass a RgbColor, RgbaColor, HslColor or HslaColor object.';
	
	/**
	 * Converts a RgbColor, RgbaColor, HslColor or HslaColor object to a color string.
	 * This util is useful in case you only know on runtime which color object is
	 * used. Otherwise we recommend to rely on `rgb`, `rgba`, `hsl` or `hsla`.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: toColorString({ red: 255, green: 205, blue: 100 }),
	 *   background: toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 }),
	 *   background: toColorString({ hue: 240, saturation: 1, lightness: 0.5 }),
	 *   background: toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 }),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${toColorString({ red: 255, green: 205, blue: 100 })};
	 *   background: ${toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 })};
	 *   background: ${toColorString({ hue: 240, saturation: 1, lightness: 0.5 })};
	 *   background: ${toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 })};
	 * `
	 *
	 * // CSS in JS Output
	 * element {
	 *   background: "#ffcd64";
	 *   background: "rgba(255,205,100,0.72)";
	 *   background: "#00f";
	 *   background: "rgba(179,25,25,0.72)";
	 * }
	 */
	
	function toColorString(color) {
	  if (typeof color !== 'object') throw new Error(errMsg);
	  if (isRgba(color)) return (0, _rgba2.default)(color);
	  if (isRgb(color)) return (0, _rgb2.default)(color);
	  if (isHsla(color)) return (0, _hsla2.default)(color);
	  if (isHsl(color)) return (0, _hsl2.default)(color);
	
	  throw new Error(errMsg);
	}
	
	exports.default = toColorString;
	module.exports = exports['default'];

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _parseToRgb = /*#__PURE__*/__webpack_require__(15);
	
	var _parseToRgb2 = /*#__PURE__*/_interopRequireDefault(_parseToRgb);
	
	var _rgbToHsl = /*#__PURE__*/__webpack_require__(154);
	
	var _rgbToHsl2 = /*#__PURE__*/_interopRequireDefault(_rgbToHsl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Returns an HslColor or HslaColor object. This utility function is only useful
	 * if want to extract a color component. With the color util `toColorString` you
	 * can convert a HslColor or HslaColor object back to a string.
	 *
	 * @example
	 * // Assigns `{ red: 255, green: 0, blue: 0 }` to color1
	 * const color1 = 'rgb(255, 0, 0)';
	 * // Assigns `{ red: 92, green: 102, blue: 112, alpha: 0.75 }` to color2
	 * const color2 = 'hsla(210, 10%, 40%, 0.75)';
	 */
	function parseToHsl(color) {
	  // Note: At a later stage we can optimize this function as right now a hsl
	  // color would be parsed converted to rgb values and converted back to hsl.
	  return (0, _rgbToHsl2.default)((0, _parseToRgb2.default)(color));
	}
	
	exports.default = parseToHsl;
	module.exports = exports['default'];

/***/ }),
/* 9 */,
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var wrapped = __webpack_require__(476);
	
	module.exports = factory;
	
	function factory(id, rule) {
	  var parts = id.split(':');
	  var source = parts[0];
	  var ruleId = parts[1];
	  var fn = wrapped(rule);
	
	  /* istanbul ignore if - possibly useful if externalised later. */
	  if (!ruleId) {
	    ruleId = source;
	    source = null;
	  }
	
	  attacher.displayName = id;
	
	  return attacher;
	
	  function attacher(raw) {
	    var config = coerce(ruleId, raw);
	    var severity = config[0];
	    var options = config[1];
	    var fatal = severity === 2;
	
	    return severity ? transformer : undefined;
	
	    function transformer(tree, file, next) {
	      var index = file.messages.length;
	
	      fn(tree, file, options, done);
	
	      function done(err) {
	        var messages = file.messages;
	        var message;
	
	        /* Add the error, if not already properly added. */
	        /* istanbul ignore if - only happens for incorrect plugins */
	        if (err && messages.indexOf(err) === -1) {
	          try {
	            file.fail(err);
	          } catch (err) {}
	        }
	
	        while (index < messages.length) {
	          message = messages[index];
	          message.ruleId = ruleId;
	          message.source = source;
	          message.fatal = fatal;
	
	          index++;
	        }
	
	        next();
	      }
	    }
	  }
	}
	
	/* Coerce a value to a severity--options tuple. */
	function coerce(name, value) {
	  var def = 1;
	  var result;
	  var level;
	
	  /* istanbul ignore if - Handled by unified in v6.0.0 */
	  if (typeof value === 'boolean') {
	    result = [value];
	  } else if (value == null) {
	    result = [def];
	  } else if (
	    typeof value === 'object' &&
	    (
	      typeof value[0] === 'number' ||
	      typeof value[0] === 'boolean' ||
	      typeof value[0] === 'string'
	    )
	  ) {
	    result = value.concat();
	  } else {
	    result = [1, value];
	  }
	
	  level = result[0];
	
	  if (typeof level === 'boolean') {
	    level = level ? 1 : 0;
	  } else if (typeof level === 'string') {
	    if (level === 'off') {
	      level = 0;
	    } else if (level === 'on' || level === 'warn') {
	      level = 1;
	    } else if (level === 'error') {
	      level = 2;
	    } else {
	      level = 1;
	      result = [level, result];
	    }
	  }
	
	  if (level < 0 || level > 2) {
	    throw new Error(
	      'Invalid severity `' + level + '` for `' + name + '`, ' +
	      'expected 0, 1, or 2'
	    );
	  }
	
	  result[0] = level;
	
	  return result;
	}


/***/ }),
/* 11 */
/***/ (function(module, exports) {

	'use strict'
	
	/* Expose. */
	module.exports = generated
	
	/* Detect if a node was available in the original document. */
	function generated(node) {
	  var position = optional(optional(node).position)
	  var start = optional(position.start)
	  var end = optional(position.end)
	
	  return !start.line || !start.column || !end.line || !end.column
	}
	
	/* Return `value` if it’s an object, an empty object
	 * otherwise. */
	function optional(value) {
	  return value && typeof value === 'object' ? value : {}
	}


/***/ }),
/* 12 */
/***/ (function(module, exports) {

	module.exports = extend
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	function extend() {
	    var target = {}
	
	    for (var i = 0; i < arguments.length; i++) {
	        var source = arguments[i]
	
	        for (var key in source) {
	            if (hasOwnProperty.call(source, key)) {
	                target[key] = source[key]
	            }
	        }
	    }
	
	    return target
	}


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = all;
	
	var trim = __webpack_require__(22);
	var one = __webpack_require__(196);
	
	/* Transform the children of `parent`. */
	function all(h, parent) {
	  var nodes = parent.children || [];
	  var length = nodes.length;
	  var values = [];
	  var index = -1;
	  var result;
	  var head;
	
	  while (++index < length) {
	    result = one(h, nodes[index], parent);
	
	    if (result) {
	      if (index && nodes[index - 1].type === 'break') {
	        if (result.value) {
	          result.value = trim.left(result.value);
	        }
	
	        head = result.children && result.children[0];
	
	        if (head && head.value) {
	          head.value = trim.left(head.value);
	        }
	      }
	
	      values = values.concat(result);
	    }
	  }
	
	  return values;
	}


/***/ }),
/* 14 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = whitespace
	
	var fromCode = String.fromCharCode
	var re = /\s/
	
	/* Check if the given character code, or the character
	 * code at the first character, is a whitespace character. */
	function whitespace(character) {
	  return re.test(
	    typeof character === 'number' ? fromCode(character) : character.charAt(0)
	  )
	}


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _hslToRgb = /*#__PURE__*/__webpack_require__(44);
	
	var _hslToRgb2 = /*#__PURE__*/_interopRequireDefault(_hslToRgb);
	
	var _nameToHex = /*#__PURE__*/__webpack_require__(153);
	
	var _nameToHex2 = /*#__PURE__*/_interopRequireDefault(_nameToHex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var hexRegex = /^#[a-fA-F0-9]{6}$/;
	var reducedHexRegex = /^#[a-fA-F0-9]{3}$/;
	var rgbRegex = /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/;
	var rgbaRegex = /^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/;
	var hslRegex = /^hsl\(\s*(\d{1,3})\s*,\s*(\d{1,3})%\s*,\s*(\d{1,3})%\s*\)$/;
	var hslaRegex = /^hsla\(\s*(\d{1,3})\s*,\s*(\d{1,3})%\s*,\s*(\d{1,3})%\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/;
	
	/**
	 * Returns an RgbColor or RgbaColor object. This utility function is only useful
	 * if want to extract a color component. With the color util `toColorString` you
	 * can convert a RgbColor or RgbaColor object back to a string.
	 *
	 * @example
	 * // Assigns `{ red: 255, green: 0, blue: 0 }` to color1
	 * const color1 = 'rgb(255, 0, 0)';
	 * // Assigns `{ red: 92, green: 102, blue: 112, alpha: 0.75 }` to color2
	 * const color2 = 'hsla(210, 10%, 40%, 0.75)';
	 */
	function parseToRgb(color) {
	  if (typeof color !== 'string') {
	    throw new Error('Passed an incorrect argument to a color function, please pass a string representation of a color.');
	  }
	  var normalizedColor = (0, _nameToHex2.default)(color);
	  if (normalizedColor.match(hexRegex)) {
	    return {
	      red: parseInt('' + normalizedColor[1] + normalizedColor[2], 16),
	      green: parseInt('' + normalizedColor[3] + normalizedColor[4], 16),
	      blue: parseInt('' + normalizedColor[5] + normalizedColor[6], 16)
	    };
	  }
	  if (normalizedColor.match(reducedHexRegex)) {
	    return {
	      red: parseInt('' + normalizedColor[1] + normalizedColor[1], 16),
	      green: parseInt('' + normalizedColor[2] + normalizedColor[2], 16),
	      blue: parseInt('' + normalizedColor[3] + normalizedColor[3], 16)
	    };
	  }
	  var rgbMatched = rgbRegex.exec(normalizedColor);
	  if (rgbMatched) {
	    return {
	      red: parseInt('' + rgbMatched[1], 10),
	      green: parseInt('' + rgbMatched[2], 10),
	      blue: parseInt('' + rgbMatched[3], 10)
	    };
	  }
	  var rgbaMatched = rgbaRegex.exec(normalizedColor);
	  if (rgbaMatched) {
	    return {
	      red: parseInt('' + rgbaMatched[1], 10),
	      green: parseInt('' + rgbaMatched[2], 10),
	      blue: parseInt('' + rgbaMatched[3], 10),
	      alpha: parseFloat('' + rgbaMatched[4])
	    };
	  }
	  var hslMatched = hslRegex.exec(normalizedColor);
	  if (hslMatched) {
	    var hue = parseInt('' + hslMatched[1], 10);
	    var saturation = parseInt('' + hslMatched[2], 10) / 100;
	    var lightness = parseInt('' + hslMatched[3], 10) / 100;
	    var rgbColorString = 'rgb(' + (0, _hslToRgb2.default)(hue, saturation, lightness) + ')';
	    var hslRgbMatched = rgbRegex.exec(rgbColorString);
	    return {
	      red: parseInt('' + hslRgbMatched[1], 10),
	      green: parseInt('' + hslRgbMatched[2], 10),
	      blue: parseInt('' + hslRgbMatched[3], 10)
	    };
	  }
	  var hslaMatched = hslaRegex.exec(normalizedColor);
	  if (hslaMatched) {
	    var _hue = parseInt('' + hslaMatched[1], 10);
	    var _saturation = parseInt('' + hslaMatched[2], 10) / 100;
	    var _lightness = parseInt('' + hslaMatched[3], 10) / 100;
	    var _rgbColorString = 'rgb(' + (0, _hslToRgb2.default)(_hue, _saturation, _lightness) + ')';
	    var _hslRgbMatched = rgbRegex.exec(_rgbColorString);
	    return {
	      red: parseInt('' + _hslRgbMatched[1], 10),
	      green: parseInt('' + _hslRgbMatched[2], 10),
	      blue: parseInt('' + _hslRgbMatched[3], 10),
	      alpha: parseFloat('' + hslaMatched[4])
	    };
	  }
	  throw new Error("Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.");
	}
	
	exports.default = parseToRgb;
	module.exports = exports['default'];

/***/ }),
/* 16 */
/***/ (function(module, exports) {

	/*!
	 * repeat-string <https://github.com/jonschlinkert/repeat-string>
	 *
	 * Copyright (c) 2014-2015, Jon Schlinkert.
	 * Licensed under the MIT License.
	 */
	
	'use strict';
	
	/**
	 * Results cache
	 */
	
	var res = '';
	var cache;
	
	/**
	 * Expose `repeat`
	 */
	
	module.exports = repeat;
	
	/**
	 * Repeat the given `string` the specified `number`
	 * of times.
	 *
	 * **Example:**
	 *
	 * ```js
	 * var repeat = require('repeat-string');
	 * repeat('A', 5);
	 * //=> AAAAA
	 * ```
	 *
	 * @param {String} `string` The string to repeat
	 * @param {Number} `number` The number of times to repeat the string
	 * @return {String} Repeated string
	 * @api public
	 */
	
	function repeat(str, num) {
	  if (typeof str !== 'string') {
	    throw new TypeError('expected a string');
	  }
	
	  // cover common, quick use cases
	  if (num === 1) return str;
	  if (num === 2) return str + str;
	
	  var max = str.length * num;
	  if (cache !== str || typeof cache === 'undefined') {
	    cache = str;
	    res = '';
	  } else if (res.length >= max) {
	    return res.substr(0, max);
	  }
	
	  while (max > res.length && num > 1) {
	    if (num & 1) {
	      res += str;
	    }
	
	    num >>= 1;
	    str += str;
	  }
	
	  res += str;
	  res = res.substr(0, max);
	  return res;
	}


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var assign = __webpack_require__(33);
	
	
	module.exports = function u (type, props, value) {
	  if (value == null && (typeof props != 'object' || Array.isArray(props))) {
	    value = props;
	    props = {};
	  }
	
	  return assign({}, props, { type: String(type) },
	                value != null && (Array.isArray(value)
	                                  ? { children: value }
	                                  : { value: String(value) }));
	};


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _capitalizeString = /*#__PURE__*/__webpack_require__(61);
	
	var _capitalizeString2 = /*#__PURE__*/_interopRequireDefault(_capitalizeString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var positionMap = ['Top', 'Right', 'Bottom', 'Left'];
	
	
	function generateProperty(property, position) {
	  if (!property) return position.toLowerCase();
	  var splitProperty = property.split('-');
	  if (splitProperty.length > 1) {
	    splitProperty.splice(1, 0, position);
	    return splitProperty.reduce(function (acc, val) {
	      return '' + acc + (0, _capitalizeString2.default)(val);
	    });
	  }
	  var joinedProperty = property.replace(/([a-z])([A-Z])/g, '$1' + position + '$2');
	  return property === joinedProperty ? '' + property + position : joinedProperty;
	}
	
	function generateStyles(property, valuesWithDefaults) {
	  var styles = {};
	  for (var i = 0; i < valuesWithDefaults.length; i += 1) {
	    if (valuesWithDefaults[i] || valuesWithDefaults[i] === 0) {
	      styles[generateProperty(property, positionMap[i])] = valuesWithDefaults[i];
	    }
	  }
	  return styles;
	}
	
	/**
	 * A helper that enables shorthand for direction based properties. It accepts a property (hyphenated or camelCased) and up to four values that map to top, right, bottom, and left, respectively. You can optionally pass an empty string to get only the directional values as properties. You can also optionally pass a null argument for a directional value to ignore it.
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   ...directionalProperty('padding', '12px', '24px', '36px', '48px')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   ${directionalProperty('padding', '12px', '24px', '36px', '48px')}
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * div {
	 *   'paddingTop': '12px',
	 *   'paddingRight': '24px',
	 *   'paddingBottom': '36px',
	 *   'paddingLeft': '48px'
	 * }
	 */
	
	function directionalProperty(property) {
	  for (var _len = arguments.length, values = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    values[_key - 1] = arguments[_key];
	  }
	
	  //  prettier-ignore
	  var firstValue = values[0],
	      _values$ = values[1],
	      secondValue = _values$ === undefined ? firstValue : _values$,
	      _values$2 = values[2],
	      thirdValue = _values$2 === undefined ? firstValue : _values$2,
	      _values$3 = values[3],
	      fourthValue = _values$3 === undefined ? secondValue : _values$3;
	
	  var valuesWithDefaults = [firstValue, secondValue, thirdValue, fourthValue];
	  return generateStyles(property, valuesWithDefaults);
	}
	
	exports.default = directionalProperty;
	module.exports = exports['default'];

/***/ }),
/* 19 */
/***/ (function(module, exports) {

	'use strict'
	
	/* Expose. */
	var position = exports
	
	position.start = factory('start')
	position.end = factory('end')
	
	/* Factory to get a `type` point in the positional info of a node. */
	function factory(type) {
	  point.displayName = type
	
	  return point
	
	  /* Get a point in `node.position` at a bound `type`. */
	  function point(node) {
	    var point = (node && node.position && node.position[type]) || {}
	
	    return {
	      line: point.line || null,
	      column: point.column || null,
	      offset: isNaN(point.offset) ? null : point.offset
	    }
	  }
	}


/***/ }),
/* 20 */,
/* 21 */,
/* 22 */
/***/ (function(module, exports) {

	
	exports = module.exports = trim;
	
	function trim(str){
	  return str.replace(/^\s*|\s*$/g, '');
	}
	
	exports.left = function(str){
	  return str.replace(/^\s*/, '');
	};
	
	exports.right = function(str){
	  return str.replace(/\s*$/, '');
	};


/***/ }),
/* 23 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function guard(lowerBoundary, upperBoundary, value) {
	  return Math.max(lowerBoundary, Math.min(upperBoundary, value));
	}
	
	exports.default = guard;
	module.exports = exports["default"];

/***/ }),
/* 24 */,
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rgb = /*#__PURE__*/__webpack_require__(42);
	
	var _rgb2 = /*#__PURE__*/_interopRequireDefault(_rgb);
	
	var _parseToRgb = /*#__PURE__*/__webpack_require__(15);
	
	var _parseToRgb2 = /*#__PURE__*/_interopRequireDefault(_parseToRgb);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
	 *
	 * Can also be used to fade a color by passing a hex value or named CSS color along with an alpha value.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: rgba(255, 205, 100, 0.7),
	 *   background: rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 }),
	 *   background: rgba(255, 205, 100, 1),
	 *   background: rgba('#ffffff', 0.4),
	 *   background: rgba('black', 0.7),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${rgba(255, 205, 100, 0.7)};
	 *   background: ${rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 })};
	 *   background: ${rgba(255, 205, 100, 1)};
	 *   background: ${rgba('#ffffff', 0.4)};
	 *   background: ${rgba('black', 0.7)};
	 * `
	 *
	 * // CSS in JS Output
	 *
	 * element {
	 *   background: "rgba(255,205,100,0.7)";
	 *   background: "rgba(255,205,100,0.7)";
	 *   background: "#ffcd64";
	 *   background: "rgba(255,255,255,0.4)";
	 *   background: "rgba(0,0,0,0.7)";
	 * }
	 */
	function rgba(firstValue, secondValue, thirdValue, fourthValue) {
	  if (typeof firstValue === 'string' && typeof secondValue === 'number') {
	    var rgbValue = (0, _parseToRgb2.default)(firstValue);
	    return 'rgba(' + rgbValue.red + ',' + rgbValue.green + ',' + rgbValue.blue + ',' + secondValue + ')';
	  } else if (typeof firstValue === 'number' && typeof secondValue === 'number' && typeof thirdValue === 'number' && typeof fourthValue === 'number') {
	    return fourthValue >= 1 ? (0, _rgb2.default)(firstValue, secondValue, thirdValue) : 'rgba(' + firstValue + ',' + secondValue + ',' + thirdValue + ',' + fourthValue + ')';
	  } else if (typeof firstValue === 'object' && secondValue === undefined && thirdValue === undefined && fourthValue === undefined) {
	    return firstValue.alpha >= 1 ? (0, _rgb2.default)(firstValue.red, firstValue.green, firstValue.blue) : 'rgba(' + firstValue.red + ',' + firstValue.green + ',' + firstValue.blue + ',' + firstValue.alpha + ')';
	  }
	
	  throw new Error('Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).');
	}
	
	exports.default = rgba;
	module.exports = exports['default'];

/***/ }),
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = wrap;
	
	var u = __webpack_require__(17);
	
	/* Wrap `nodes` with newlines between each entry.
	 * Optionally adds newlines at the start and end. */
	function wrap(nodes, loose) {
	  var result = [];
	  var index = -1;
	  var length = nodes.length;
	
	  if (loose) {
	    result.push(u('text', '\n'));
	  }
	
	  while (++index < length) {
	    if (index) {
	      result.push(u('text', '\n'));
	    }
	
	    result.push(nodes[index]);
	  }
	
	  if (loose && nodes.length !== 0) {
	    result.push(u('text', '\n'));
	  }
	
	  return result;
	}


/***/ }),
/* 36 */,
/* 37 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 38 */,
/* 39 */,
/* 40 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = decimal
	
	/* Check if the given character code, or the character
	 * code at the first character, is decimal. */
	function decimal(character) {
	  var code = typeof character === 'string' ? character.charCodeAt(0) : character
	
	  return code >= 48 && code <= 57 /* 0-9 */
	}


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _rgba = /*#__PURE__*/__webpack_require__(25);
	
	var _rgba2 = /*#__PURE__*/_interopRequireDefault(_rgba);
	
	var _parseToRgb = /*#__PURE__*/__webpack_require__(15);
	
	var _parseToRgb2 = /*#__PURE__*/_interopRequireDefault(_parseToRgb);
	
	var _curry = /*#__PURE__*/__webpack_require__(5);
	
	var _curry2 = /*#__PURE__*/_interopRequireDefault(_curry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Mixes two colors together by calculating the average of each of the RGB components.
	 *
	 * By default the weight is 0.5 meaning that half of the first color and half the second
	 * color should be used. Optionally the weight can be modified by providing a number
	 * as the first argument. 0.25 means that a quarter of the first color and three quarters
	 * of the second color should be used.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: mix(0.5, '#f00', '#00f')
	 *   background: mix(0.25, '#f00', '#00f')
	 *   background: mix(0.5, 'rgba(255, 0, 0, 0.5)', '#00f')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${mix(0.5, '#f00', '#00f')};
	 *   background: ${mix(0.25, '#f00', '#00f')};
	 *   background: ${mix(0.5, 'rgba(255, 0, 0, 0.5)', '#00f')};
	 * `
	 *
	 * // CSS in JS Output
	 *
	 * element {
	 *   background: "#7f007f";
	 *   background: "#3f00bf";
	 *   background: "rgba(63, 0, 191, 0.75)";
	 * }
	 */
	function mix() {
	  var weight = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0.5;
	  var color = arguments[1];
	  var otherColor = arguments[2];
	
	  var parsedColor1 = (0, _parseToRgb2.default)(color);
	  var color1 = _extends({}, parsedColor1, {
	    alpha: typeof parsedColor1.alpha === 'number' ? parsedColor1.alpha : 1
	  });
	
	  var parsedColor2 = (0, _parseToRgb2.default)(otherColor);
	  var color2 = _extends({}, parsedColor2, {
	    alpha: typeof parsedColor2.alpha === 'number' ? parsedColor2.alpha : 1
	
	    // The formular is copied from the original Sass implementation:
	    // http://sass-lang.com/documentation/Sass/Script/Functions.html#mix-instance_method
	  });var alphaDelta = color1.alpha - color2.alpha;
	  var x = weight * 2 - 1;
	  var y = x * alphaDelta === -1 ? x : x + alphaDelta;
	  var z = 1 + x * alphaDelta;
	  var weight1 = (y / z + 1) / 2.0;
	  var weight2 = 1 - weight1;
	
	  var mixedColor = {
	    red: Math.floor(color1.red * weight1 + color2.red * weight2),
	    green: Math.floor(color1.green * weight1 + color2.green * weight2),
	    blue: Math.floor(color1.blue * weight1 + color2.blue * weight2),
	    alpha: color1.alpha + (color2.alpha - color1.alpha) * (weight / 1.0)
	  };
	
	  return (0, _rgba2.default)(mixedColor);
	}
	
	var curriedMix = /*#__PURE__*/(0, _curry2.default)(mix);
	exports.default = curriedMix;
	module.exports = exports['default'];

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reduceHexValue = /*#__PURE__*/__webpack_require__(65);
	
	var _reduceHexValue2 = /*#__PURE__*/_interopRequireDefault(_reduceHexValue);
	
	var _numberToHex = /*#__PURE__*/__webpack_require__(63);
	
	var _numberToHex2 = /*#__PURE__*/_interopRequireDefault(_numberToHex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Returns a string value for the color. The returned result is the smallest possible hex notation.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: rgb(255, 205, 100),
	 *   background: rgb({ red: 255, green: 205, blue: 100 }),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${rgb(255, 205, 100)};
	 *   background: ${rgb({ red: 255, green: 205, blue: 100 })};
	 * `
	 *
	 * // CSS in JS Output
	 *
	 * element {
	 *   background: "#ffcd64";
	 *   background: "#ffcd64";
	 * }
	 */
	function rgb(value, green, blue) {
	  if (typeof value === 'number' && typeof green === 'number' && typeof blue === 'number') {
	    return (0, _reduceHexValue2.default)('#' + (0, _numberToHex2.default)(value) + (0, _numberToHex2.default)(green) + (0, _numberToHex2.default)(blue));
	  } else if (typeof value === 'object' && green === undefined && blue === undefined) {
	    return (0, _reduceHexValue2.default)('#' + (0, _numberToHex2.default)(value.red) + (0, _numberToHex2.default)(value.green) + (0, _numberToHex2.default)(value.blue));
	  }
	
	  throw new Error('Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).');
	}
	
	exports.default = rgb;
	module.exports = exports['default'];

/***/ }),
/* 43 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	/**
	 * Strip the unit from a given CSS value, returning just the number. (or the original value if an invalid string was passed)
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   '--dimension': stripUnit('100px')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   --dimension: ${stripUnit('100px')}
	 * `
	 *
	 * // CSS in JS Output
	 *
	 * element {
	 *   '--dimension': 100
	 * }
	 */
	
	function stripUnit(value) {
	  var unitlessValue = parseFloat(value);
	  if (isNaN(unitlessValue)) return value;
	  return unitlessValue;
	}
	
	exports.default = stripUnit;
	module.exports = exports["default"];

/***/ }),
/* 44 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	function colorToInt(color) {
	  return Math.round(color * 255);
	}
	
	function convertToInt(red, green, blue) {
	  return colorToInt(red) + "," + colorToInt(green) + "," + colorToInt(blue);
	}
	
	function hslToRgb(hue, saturation, lightness) {
	  var convert = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : convertToInt;
	
	  if (saturation === 0) {
	    // achromatic
	    return convert(lightness, lightness, lightness);
	  }
	
	  // formular from https://en.wikipedia.org/wiki/HSL_and_HSV
	  var huePrime = hue % 360 / 60;
	  var chroma = (1 - Math.abs(2 * lightness - 1)) * saturation;
	  var secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
	
	  var red = 0;
	  var green = 0;
	  var blue = 0;
	
	  if (huePrime >= 0 && huePrime < 1) {
	    red = chroma;
	    green = secondComponent;
	  } else if (huePrime >= 1 && huePrime < 2) {
	    red = secondComponent;
	    green = chroma;
	  } else if (huePrime >= 2 && huePrime < 3) {
	    green = chroma;
	    blue = secondComponent;
	  } else if (huePrime >= 3 && huePrime < 4) {
	    green = secondComponent;
	    blue = chroma;
	  } else if (huePrime >= 4 && huePrime < 5) {
	    red = secondComponent;
	    blue = chroma;
	  } else if (huePrime >= 5 && huePrime < 6) {
	    red = chroma;
	    blue = secondComponent;
	  }
	
	  var lightnessModification = lightness - chroma / 2;
	  var finalRed = red + lightnessModification;
	  var finalGreen = green + lightnessModification;
	  var finalBlue = blue + lightnessModification;
	  return convert(finalRed, finalGreen, finalBlue);
	}
	
	exports.default = hslToRgb;
	module.exports = exports["default"];

/***/ }),
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-geo/ Version 1.6.3. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(276)) :
		typeof define === 'function' && define.amd ? define(['exports', 'd3-array'], factory) :
		(factory((global.d3 = global.d3 || {}),global.d3));
	}(this, (function (exports,d3Array) { 'use strict';
	
	// Adds floating point numbers with twice the normal precision.
	// Reference: J. R. Shewchuk, Adaptive Precision Floating-Point Arithmetic and
	// Fast Robust Geometric Predicates, Discrete & Computational Geometry 18(3)
	// 305–363 (1997).
	// Code adapted from GeographicLib by Charles F. F. Karney,
	// http://geographiclib.sourceforge.net/
	
	var adder = function() {
	  return new Adder;
	};
	
	function Adder() {
	  this.reset();
	}
	
	Adder.prototype = {
	  constructor: Adder,
	  reset: function() {
	    this.s = // rounded value
	    this.t = 0; // exact error
	  },
	  add: function(y) {
	    add(temp, y, this.t);
	    add(this, temp.s, this.s);
	    if (this.s) this.t += temp.t;
	    else this.s = temp.t;
	  },
	  valueOf: function() {
	    return this.s;
	  }
	};
	
	var temp = new Adder;
	
	function add(adder, a, b) {
	  var x = adder.s = a + b,
	      bv = x - a,
	      av = x - bv;
	  adder.t = (a - av) + (b - bv);
	}
	
	var epsilon = 1e-6;
	var epsilon2 = 1e-12;
	var pi = Math.PI;
	var halfPi = pi / 2;
	var quarterPi = pi / 4;
	var tau = pi * 2;
	
	var degrees = 180 / pi;
	var radians = pi / 180;
	
	var abs = Math.abs;
	var atan = Math.atan;
	var atan2 = Math.atan2;
	var cos = Math.cos;
	var ceil = Math.ceil;
	var exp = Math.exp;
	
	var log = Math.log;
	var pow = Math.pow;
	var sin = Math.sin;
	var sign = Math.sign || function(x) { return x > 0 ? 1 : x < 0 ? -1 : 0; };
	var sqrt = Math.sqrt;
	var tan = Math.tan;
	
	function acos(x) {
	  return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
	}
	
	function asin(x) {
	  return x > 1 ? halfPi : x < -1 ? -halfPi : Math.asin(x);
	}
	
	function haversin(x) {
	  return (x = sin(x / 2)) * x;
	}
	
	function noop() {}
	
	function streamGeometry(geometry, stream) {
	  if (geometry && streamGeometryType.hasOwnProperty(geometry.type)) {
	    streamGeometryType[geometry.type](geometry, stream);
	  }
	}
	
	var streamObjectType = {
	  Feature: function(object, stream) {
	    streamGeometry(object.geometry, stream);
	  },
	  FeatureCollection: function(object, stream) {
	    var features = object.features, i = -1, n = features.length;
	    while (++i < n) streamGeometry(features[i].geometry, stream);
	  }
	};
	
	var streamGeometryType = {
	  Sphere: function(object, stream) {
	    stream.sphere();
	  },
	  Point: function(object, stream) {
	    object = object.coordinates;
	    stream.point(object[0], object[1], object[2]);
	  },
	  MultiPoint: function(object, stream) {
	    var coordinates = object.coordinates, i = -1, n = coordinates.length;
	    while (++i < n) object = coordinates[i], stream.point(object[0], object[1], object[2]);
	  },
	  LineString: function(object, stream) {
	    streamLine(object.coordinates, stream, 0);
	  },
	  MultiLineString: function(object, stream) {
	    var coordinates = object.coordinates, i = -1, n = coordinates.length;
	    while (++i < n) streamLine(coordinates[i], stream, 0);
	  },
	  Polygon: function(object, stream) {
	    streamPolygon(object.coordinates, stream);
	  },
	  MultiPolygon: function(object, stream) {
	    var coordinates = object.coordinates, i = -1, n = coordinates.length;
	    while (++i < n) streamPolygon(coordinates[i], stream);
	  },
	  GeometryCollection: function(object, stream) {
	    var geometries = object.geometries, i = -1, n = geometries.length;
	    while (++i < n) streamGeometry(geometries[i], stream);
	  }
	};
	
	function streamLine(coordinates, stream, closed) {
	  var i = -1, n = coordinates.length - closed, coordinate;
	  stream.lineStart();
	  while (++i < n) coordinate = coordinates[i], stream.point(coordinate[0], coordinate[1], coordinate[2]);
	  stream.lineEnd();
	}
	
	function streamPolygon(coordinates, stream) {
	  var i = -1, n = coordinates.length;
	  stream.polygonStart();
	  while (++i < n) streamLine(coordinates[i], stream, 1);
	  stream.polygonEnd();
	}
	
	var geoStream = function(object, stream) {
	  if (object && streamObjectType.hasOwnProperty(object.type)) {
	    streamObjectType[object.type](object, stream);
	  } else {
	    streamGeometry(object, stream);
	  }
	};
	
	var areaRingSum = adder();
	
	var areaSum = adder();
	var lambda00;
	var phi00;
	var lambda0;
	var cosPhi0;
	var sinPhi0;
	
	var areaStream = {
	  point: noop,
	  lineStart: noop,
	  lineEnd: noop,
	  polygonStart: function() {
	    areaRingSum.reset();
	    areaStream.lineStart = areaRingStart;
	    areaStream.lineEnd = areaRingEnd;
	  },
	  polygonEnd: function() {
	    var areaRing = +areaRingSum;
	    areaSum.add(areaRing < 0 ? tau + areaRing : areaRing);
	    this.lineStart = this.lineEnd = this.point = noop;
	  },
	  sphere: function() {
	    areaSum.add(tau);
	  }
	};
	
	function areaRingStart() {
	  areaStream.point = areaPointFirst;
	}
	
	function areaRingEnd() {
	  areaPoint(lambda00, phi00);
	}
	
	function areaPointFirst(lambda, phi) {
	  areaStream.point = areaPoint;
	  lambda00 = lambda, phi00 = phi;
	  lambda *= radians, phi *= radians;
	  lambda0 = lambda, cosPhi0 = cos(phi = phi / 2 + quarterPi), sinPhi0 = sin(phi);
	}
	
	function areaPoint(lambda, phi) {
	  lambda *= radians, phi *= radians;
	  phi = phi / 2 + quarterPi; // half the angular distance from south pole
	
	  // Spherical excess E for a spherical triangle with vertices: south pole,
	  // previous point, current point.  Uses a formula derived from Cagnoli’s
	  // theorem.  See Todhunter, Spherical Trig. (1871), Sec. 103, Eq. (2).
	  var dLambda = lambda - lambda0,
	      sdLambda = dLambda >= 0 ? 1 : -1,
	      adLambda = sdLambda * dLambda,
	      cosPhi = cos(phi),
	      sinPhi = sin(phi),
	      k = sinPhi0 * sinPhi,
	      u = cosPhi0 * cosPhi + k * cos(adLambda),
	      v = k * sdLambda * sin(adLambda);
	  areaRingSum.add(atan2(v, u));
	
	  // Advance the previous points.
	  lambda0 = lambda, cosPhi0 = cosPhi, sinPhi0 = sinPhi;
	}
	
	var area = function(object) {
	  areaSum.reset();
	  geoStream(object, areaStream);
	  return areaSum * 2;
	};
	
	function spherical(cartesian) {
	  return [atan2(cartesian[1], cartesian[0]), asin(cartesian[2])];
	}
	
	function cartesian(spherical) {
	  var lambda = spherical[0], phi = spherical[1], cosPhi = cos(phi);
	  return [cosPhi * cos(lambda), cosPhi * sin(lambda), sin(phi)];
	}
	
	function cartesianDot(a, b) {
	  return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
	}
	
	function cartesianCross(a, b) {
	  return [a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0]];
	}
	
	// TODO return a
	function cartesianAddInPlace(a, b) {
	  a[0] += b[0], a[1] += b[1], a[2] += b[2];
	}
	
	function cartesianScale(vector, k) {
	  return [vector[0] * k, vector[1] * k, vector[2] * k];
	}
	
	// TODO return d
	function cartesianNormalizeInPlace(d) {
	  var l = sqrt(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
	  d[0] /= l, d[1] /= l, d[2] /= l;
	}
	
	var lambda0$1;
	var phi0;
	var lambda1;
	var phi1;
	var lambda2;
	var lambda00$1;
	var phi00$1;
	var p0;
	var deltaSum = adder();
	var ranges;
	var range$1;
	
	var boundsStream = {
	  point: boundsPoint,
	  lineStart: boundsLineStart,
	  lineEnd: boundsLineEnd,
	  polygonStart: function() {
	    boundsStream.point = boundsRingPoint;
	    boundsStream.lineStart = boundsRingStart;
	    boundsStream.lineEnd = boundsRingEnd;
	    deltaSum.reset();
	    areaStream.polygonStart();
	  },
	  polygonEnd: function() {
	    areaStream.polygonEnd();
	    boundsStream.point = boundsPoint;
	    boundsStream.lineStart = boundsLineStart;
	    boundsStream.lineEnd = boundsLineEnd;
	    if (areaRingSum < 0) lambda0$1 = -(lambda1 = 180), phi0 = -(phi1 = 90);
	    else if (deltaSum > epsilon) phi1 = 90;
	    else if (deltaSum < -epsilon) phi0 = -90;
	    range$1[0] = lambda0$1, range$1[1] = lambda1;
	  }
	};
	
	function boundsPoint(lambda, phi) {
	  ranges.push(range$1 = [lambda0$1 = lambda, lambda1 = lambda]);
	  if (phi < phi0) phi0 = phi;
	  if (phi > phi1) phi1 = phi;
	}
	
	function linePoint(lambda, phi) {
	  var p = cartesian([lambda * radians, phi * radians]);
	  if (p0) {
	    var normal = cartesianCross(p0, p),
	        equatorial = [normal[1], -normal[0], 0],
	        inflection = cartesianCross(equatorial, normal);
	    cartesianNormalizeInPlace(inflection);
	    inflection = spherical(inflection);
	    var delta = lambda - lambda2,
	        sign$$1 = delta > 0 ? 1 : -1,
	        lambdai = inflection[0] * degrees * sign$$1,
	        phii,
	        antimeridian = abs(delta) > 180;
	    if (antimeridian ^ (sign$$1 * lambda2 < lambdai && lambdai < sign$$1 * lambda)) {
	      phii = inflection[1] * degrees;
	      if (phii > phi1) phi1 = phii;
	    } else if (lambdai = (lambdai + 360) % 360 - 180, antimeridian ^ (sign$$1 * lambda2 < lambdai && lambdai < sign$$1 * lambda)) {
	      phii = -inflection[1] * degrees;
	      if (phii < phi0) phi0 = phii;
	    } else {
	      if (phi < phi0) phi0 = phi;
	      if (phi > phi1) phi1 = phi;
	    }
	    if (antimeridian) {
	      if (lambda < lambda2) {
	        if (angle(lambda0$1, lambda) > angle(lambda0$1, lambda1)) lambda1 = lambda;
	      } else {
	        if (angle(lambda, lambda1) > angle(lambda0$1, lambda1)) lambda0$1 = lambda;
	      }
	    } else {
	      if (lambda1 >= lambda0$1) {
	        if (lambda < lambda0$1) lambda0$1 = lambda;
	        if (lambda > lambda1) lambda1 = lambda;
	      } else {
	        if (lambda > lambda2) {
	          if (angle(lambda0$1, lambda) > angle(lambda0$1, lambda1)) lambda1 = lambda;
	        } else {
	          if (angle(lambda, lambda1) > angle(lambda0$1, lambda1)) lambda0$1 = lambda;
	        }
	      }
	    }
	  } else {
	    ranges.push(range$1 = [lambda0$1 = lambda, lambda1 = lambda]);
	  }
	  if (phi < phi0) phi0 = phi;
	  if (phi > phi1) phi1 = phi;
	  p0 = p, lambda2 = lambda;
	}
	
	function boundsLineStart() {
	  boundsStream.point = linePoint;
	}
	
	function boundsLineEnd() {
	  range$1[0] = lambda0$1, range$1[1] = lambda1;
	  boundsStream.point = boundsPoint;
	  p0 = null;
	}
	
	function boundsRingPoint(lambda, phi) {
	  if (p0) {
	    var delta = lambda - lambda2;
	    deltaSum.add(abs(delta) > 180 ? delta + (delta > 0 ? 360 : -360) : delta);
	  } else {
	    lambda00$1 = lambda, phi00$1 = phi;
	  }
	  areaStream.point(lambda, phi);
	  linePoint(lambda, phi);
	}
	
	function boundsRingStart() {
	  areaStream.lineStart();
	}
	
	function boundsRingEnd() {
	  boundsRingPoint(lambda00$1, phi00$1);
	  areaStream.lineEnd();
	  if (abs(deltaSum) > epsilon) lambda0$1 = -(lambda1 = 180);
	  range$1[0] = lambda0$1, range$1[1] = lambda1;
	  p0 = null;
	}
	
	// Finds the left-right distance between two longitudes.
	// This is almost the same as (lambda1 - lambda0 + 360°) % 360°, except that we want
	// the distance between ±180° to be 360°.
	function angle(lambda0, lambda1) {
	  return (lambda1 -= lambda0) < 0 ? lambda1 + 360 : lambda1;
	}
	
	function rangeCompare(a, b) {
	  return a[0] - b[0];
	}
	
	function rangeContains(range$$1, x) {
	  return range$$1[0] <= range$$1[1] ? range$$1[0] <= x && x <= range$$1[1] : x < range$$1[0] || range$$1[1] < x;
	}
	
	var bounds = function(feature) {
	  var i, n, a, b, merged, deltaMax, delta;
	
	  phi1 = lambda1 = -(lambda0$1 = phi0 = Infinity);
	  ranges = [];
	  geoStream(feature, boundsStream);
	
	  // First, sort ranges by their minimum longitudes.
	  if (n = ranges.length) {
	    ranges.sort(rangeCompare);
	
	    // Then, merge any ranges that overlap.
	    for (i = 1, a = ranges[0], merged = [a]; i < n; ++i) {
	      b = ranges[i];
	      if (rangeContains(a, b[0]) || rangeContains(a, b[1])) {
	        if (angle(a[0], b[1]) > angle(a[0], a[1])) a[1] = b[1];
	        if (angle(b[0], a[1]) > angle(a[0], a[1])) a[0] = b[0];
	      } else {
	        merged.push(a = b);
	      }
	    }
	
	    // Finally, find the largest gap between the merged ranges.
	    // The final bounding box will be the inverse of this gap.
	    for (deltaMax = -Infinity, n = merged.length - 1, i = 0, a = merged[n]; i <= n; a = b, ++i) {
	      b = merged[i];
	      if ((delta = angle(a[1], b[0])) > deltaMax) deltaMax = delta, lambda0$1 = b[0], lambda1 = a[1];
	    }
	  }
	
	  ranges = range$1 = null;
	
	  return lambda0$1 === Infinity || phi0 === Infinity
	      ? [[NaN, NaN], [NaN, NaN]]
	      : [[lambda0$1, phi0], [lambda1, phi1]];
	};
	
	var W0;
	var W1;
	var X0;
	var Y0;
	var Z0;
	var X1;
	var Y1;
	var Z1;
	var X2;
	var Y2;
	var Z2;
	var lambda00$2;
	var phi00$2;
	var x0;
	var y0;
	var z0; // previous point
	
	var centroidStream = {
	  sphere: noop,
	  point: centroidPoint,
	  lineStart: centroidLineStart,
	  lineEnd: centroidLineEnd,
	  polygonStart: function() {
	    centroidStream.lineStart = centroidRingStart;
	    centroidStream.lineEnd = centroidRingEnd;
	  },
	  polygonEnd: function() {
	    centroidStream.lineStart = centroidLineStart;
	    centroidStream.lineEnd = centroidLineEnd;
	  }
	};
	
	// Arithmetic mean of Cartesian vectors.
	function centroidPoint(lambda, phi) {
	  lambda *= radians, phi *= radians;
	  var cosPhi = cos(phi);
	  centroidPointCartesian(cosPhi * cos(lambda), cosPhi * sin(lambda), sin(phi));
	}
	
	function centroidPointCartesian(x, y, z) {
	  ++W0;
	  X0 += (x - X0) / W0;
	  Y0 += (y - Y0) / W0;
	  Z0 += (z - Z0) / W0;
	}
	
	function centroidLineStart() {
	  centroidStream.point = centroidLinePointFirst;
	}
	
	function centroidLinePointFirst(lambda, phi) {
	  lambda *= radians, phi *= radians;
	  var cosPhi = cos(phi);
	  x0 = cosPhi * cos(lambda);
	  y0 = cosPhi * sin(lambda);
	  z0 = sin(phi);
	  centroidStream.point = centroidLinePoint;
	  centroidPointCartesian(x0, y0, z0);
	}
	
	function centroidLinePoint(lambda, phi) {
	  lambda *= radians, phi *= radians;
	  var cosPhi = cos(phi),
	      x = cosPhi * cos(lambda),
	      y = cosPhi * sin(lambda),
	      z = sin(phi),
	      w = atan2(sqrt((w = y0 * z - z0 * y) * w + (w = z0 * x - x0 * z) * w + (w = x0 * y - y0 * x) * w), x0 * x + y0 * y + z0 * z);
	  W1 += w;
	  X1 += w * (x0 + (x0 = x));
	  Y1 += w * (y0 + (y0 = y));
	  Z1 += w * (z0 + (z0 = z));
	  centroidPointCartesian(x0, y0, z0);
	}
	
	function centroidLineEnd() {
	  centroidStream.point = centroidPoint;
	}
	
	// See J. E. Brock, The Inertia Tensor for a Spherical Triangle,
	// J. Applied Mechanics 42, 239 (1975).
	function centroidRingStart() {
	  centroidStream.point = centroidRingPointFirst;
	}
	
	function centroidRingEnd() {
	  centroidRingPoint(lambda00$2, phi00$2);
	  centroidStream.point = centroidPoint;
	}
	
	function centroidRingPointFirst(lambda, phi) {
	  lambda00$2 = lambda, phi00$2 = phi;
	  lambda *= radians, phi *= radians;
	  centroidStream.point = centroidRingPoint;
	  var cosPhi = cos(phi);
	  x0 = cosPhi * cos(lambda);
	  y0 = cosPhi * sin(lambda);
	  z0 = sin(phi);
	  centroidPointCartesian(x0, y0, z0);
	}
	
	function centroidRingPoint(lambda, phi) {
	  lambda *= radians, phi *= radians;
	  var cosPhi = cos(phi),
	      x = cosPhi * cos(lambda),
	      y = cosPhi * sin(lambda),
	      z = sin(phi),
	      cx = y0 * z - z0 * y,
	      cy = z0 * x - x0 * z,
	      cz = x0 * y - y0 * x,
	      m = sqrt(cx * cx + cy * cy + cz * cz),
	      w = asin(m), // line weight = angle
	      v = m && -w / m; // area weight multiplier
	  X2 += v * cx;
	  Y2 += v * cy;
	  Z2 += v * cz;
	  W1 += w;
	  X1 += w * (x0 + (x0 = x));
	  Y1 += w * (y0 + (y0 = y));
	  Z1 += w * (z0 + (z0 = z));
	  centroidPointCartesian(x0, y0, z0);
	}
	
	var centroid = function(object) {
	  W0 = W1 =
	  X0 = Y0 = Z0 =
	  X1 = Y1 = Z1 =
	  X2 = Y2 = Z2 = 0;
	  geoStream(object, centroidStream);
	
	  var x = X2,
	      y = Y2,
	      z = Z2,
	      m = x * x + y * y + z * z;
	
	  // If the area-weighted ccentroid is undefined, fall back to length-weighted ccentroid.
	  if (m < epsilon2) {
	    x = X1, y = Y1, z = Z1;
	    // If the feature has zero length, fall back to arithmetic mean of point vectors.
	    if (W1 < epsilon) x = X0, y = Y0, z = Z0;
	    m = x * x + y * y + z * z;
	    // If the feature still has an undefined ccentroid, then return.
	    if (m < epsilon2) return [NaN, NaN];
	  }
	
	  return [atan2(y, x) * degrees, asin(z / sqrt(m)) * degrees];
	};
	
	var constant = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	var compose = function(a, b) {
	
	  function compose(x, y) {
	    return x = a(x, y), b(x[0], x[1]);
	  }
	
	  if (a.invert && b.invert) compose.invert = function(x, y) {
	    return x = b.invert(x, y), x && a.invert(x[0], x[1]);
	  };
	
	  return compose;
	};
	
	function rotationIdentity(lambda, phi) {
	  return [lambda > pi ? lambda - tau : lambda < -pi ? lambda + tau : lambda, phi];
	}
	
	rotationIdentity.invert = rotationIdentity;
	
	function rotateRadians(deltaLambda, deltaPhi, deltaGamma) {
	  return (deltaLambda %= tau) ? (deltaPhi || deltaGamma ? compose(rotationLambda(deltaLambda), rotationPhiGamma(deltaPhi, deltaGamma))
	    : rotationLambda(deltaLambda))
	    : (deltaPhi || deltaGamma ? rotationPhiGamma(deltaPhi, deltaGamma)
	    : rotationIdentity);
	}
	
	function forwardRotationLambda(deltaLambda) {
	  return function(lambda, phi) {
	    return lambda += deltaLambda, [lambda > pi ? lambda - tau : lambda < -pi ? lambda + tau : lambda, phi];
	  };
	}
	
	function rotationLambda(deltaLambda) {
	  var rotation = forwardRotationLambda(deltaLambda);
	  rotation.invert = forwardRotationLambda(-deltaLambda);
	  return rotation;
	}
	
	function rotationPhiGamma(deltaPhi, deltaGamma) {
	  var cosDeltaPhi = cos(deltaPhi),
	      sinDeltaPhi = sin(deltaPhi),
	      cosDeltaGamma = cos(deltaGamma),
	      sinDeltaGamma = sin(deltaGamma);
	
	  function rotation(lambda, phi) {
	    var cosPhi = cos(phi),
	        x = cos(lambda) * cosPhi,
	        y = sin(lambda) * cosPhi,
	        z = sin(phi),
	        k = z * cosDeltaPhi + x * sinDeltaPhi;
	    return [
	      atan2(y * cosDeltaGamma - k * sinDeltaGamma, x * cosDeltaPhi - z * sinDeltaPhi),
	      asin(k * cosDeltaGamma + y * sinDeltaGamma)
	    ];
	  }
	
	  rotation.invert = function(lambda, phi) {
	    var cosPhi = cos(phi),
	        x = cos(lambda) * cosPhi,
	        y = sin(lambda) * cosPhi,
	        z = sin(phi),
	        k = z * cosDeltaGamma - y * sinDeltaGamma;
	    return [
	      atan2(y * cosDeltaGamma + z * sinDeltaGamma, x * cosDeltaPhi + k * sinDeltaPhi),
	      asin(k * cosDeltaPhi - x * sinDeltaPhi)
	    ];
	  };
	
	  return rotation;
	}
	
	var rotation = function(rotate) {
	  rotate = rotateRadians(rotate[0] * radians, rotate[1] * radians, rotate.length > 2 ? rotate[2] * radians : 0);
	
	  function forward(coordinates) {
	    coordinates = rotate(coordinates[0] * radians, coordinates[1] * radians);
	    return coordinates[0] *= degrees, coordinates[1] *= degrees, coordinates;
	  }
	
	  forward.invert = function(coordinates) {
	    coordinates = rotate.invert(coordinates[0] * radians, coordinates[1] * radians);
	    return coordinates[0] *= degrees, coordinates[1] *= degrees, coordinates;
	  };
	
	  return forward;
	};
	
	// Generates a circle centered at [0°, 0°], with a given radius and precision.
	function circleStream(stream, radius, delta, direction, t0, t1) {
	  if (!delta) return;
	  var cosRadius = cos(radius),
	      sinRadius = sin(radius),
	      step = direction * delta;
	  if (t0 == null) {
	    t0 = radius + direction * tau;
	    t1 = radius - step / 2;
	  } else {
	    t0 = circleRadius(cosRadius, t0);
	    t1 = circleRadius(cosRadius, t1);
	    if (direction > 0 ? t0 < t1 : t0 > t1) t0 += direction * tau;
	  }
	  for (var point, t = t0; direction > 0 ? t > t1 : t < t1; t -= step) {
	    point = spherical([cosRadius, -sinRadius * cos(t), -sinRadius * sin(t)]);
	    stream.point(point[0], point[1]);
	  }
	}
	
	// Returns the signed angle of a cartesian point relative to [cosRadius, 0, 0].
	function circleRadius(cosRadius, point) {
	  point = cartesian(point), point[0] -= cosRadius;
	  cartesianNormalizeInPlace(point);
	  var radius = acos(-point[1]);
	  return ((-point[2] < 0 ? -radius : radius) + tau - epsilon) % tau;
	}
	
	var circle = function() {
	  var center = constant([0, 0]),
	      radius = constant(90),
	      precision = constant(6),
	      ring,
	      rotate,
	      stream = {point: point};
	
	  function point(x, y) {
	    ring.push(x = rotate(x, y));
	    x[0] *= degrees, x[1] *= degrees;
	  }
	
	  function circle() {
	    var c = center.apply(this, arguments),
	        r = radius.apply(this, arguments) * radians,
	        p = precision.apply(this, arguments) * radians;
	    ring = [];
	    rotate = rotateRadians(-c[0] * radians, -c[1] * radians, 0).invert;
	    circleStream(stream, r, p, 1);
	    c = {type: "Polygon", coordinates: [ring]};
	    ring = rotate = null;
	    return c;
	  }
	
	  circle.center = function(_) {
	    return arguments.length ? (center = typeof _ === "function" ? _ : constant([+_[0], +_[1]]), circle) : center;
	  };
	
	  circle.radius = function(_) {
	    return arguments.length ? (radius = typeof _ === "function" ? _ : constant(+_), circle) : radius;
	  };
	
	  circle.precision = function(_) {
	    return arguments.length ? (precision = typeof _ === "function" ? _ : constant(+_), circle) : precision;
	  };
	
	  return circle;
	};
	
	var clipBuffer = function() {
	  var lines = [],
	      line;
	  return {
	    point: function(x, y) {
	      line.push([x, y]);
	    },
	    lineStart: function() {
	      lines.push(line = []);
	    },
	    lineEnd: noop,
	    rejoin: function() {
	      if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
	    },
	    result: function() {
	      var result = lines;
	      lines = [];
	      line = null;
	      return result;
	    }
	  };
	};
	
	var clipLine = function(a, b, x0, y0, x1, y1) {
	  var ax = a[0],
	      ay = a[1],
	      bx = b[0],
	      by = b[1],
	      t0 = 0,
	      t1 = 1,
	      dx = bx - ax,
	      dy = by - ay,
	      r;
	
	  r = x0 - ax;
	  if (!dx && r > 0) return;
	  r /= dx;
	  if (dx < 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  } else if (dx > 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  }
	
	  r = x1 - ax;
	  if (!dx && r < 0) return;
	  r /= dx;
	  if (dx < 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  } else if (dx > 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  }
	
	  r = y0 - ay;
	  if (!dy && r > 0) return;
	  r /= dy;
	  if (dy < 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  } else if (dy > 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  }
	
	  r = y1 - ay;
	  if (!dy && r < 0) return;
	  r /= dy;
	  if (dy < 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  } else if (dy > 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  }
	
	  if (t0 > 0) a[0] = ax + t0 * dx, a[1] = ay + t0 * dy;
	  if (t1 < 1) b[0] = ax + t1 * dx, b[1] = ay + t1 * dy;
	  return true;
	};
	
	var pointEqual = function(a, b) {
	  return abs(a[0] - b[0]) < epsilon && abs(a[1] - b[1]) < epsilon;
	};
	
	function Intersection(point, points, other, entry) {
	  this.x = point;
	  this.z = points;
	  this.o = other; // another intersection
	  this.e = entry; // is an entry?
	  this.v = false; // visited
	  this.n = this.p = null; // next & previous
	}
	
	// A generalized polygon clipping algorithm: given a polygon that has been cut
	// into its visible line segments, and rejoins the segments by interpolating
	// along the clip edge.
	var clipPolygon = function(segments, compareIntersection, startInside, interpolate, stream) {
	  var subject = [],
	      clip = [],
	      i,
	      n;
	
	  segments.forEach(function(segment) {
	    if ((n = segment.length - 1) <= 0) return;
	    var n, p0 = segment[0], p1 = segment[n], x;
	
	    // If the first and last points of a segment are coincident, then treat as a
	    // closed ring. TODO if all rings are closed, then the winding order of the
	    // exterior ring should be checked.
	    if (pointEqual(p0, p1)) {
	      stream.lineStart();
	      for (i = 0; i < n; ++i) stream.point((p0 = segment[i])[0], p0[1]);
	      stream.lineEnd();
	      return;
	    }
	
	    subject.push(x = new Intersection(p0, segment, null, true));
	    clip.push(x.o = new Intersection(p0, null, x, false));
	    subject.push(x = new Intersection(p1, segment, null, false));
	    clip.push(x.o = new Intersection(p1, null, x, true));
	  });
	
	  if (!subject.length) return;
	
	  clip.sort(compareIntersection);
	  link(subject);
	  link(clip);
	
	  for (i = 0, n = clip.length; i < n; ++i) {
	    clip[i].e = startInside = !startInside;
	  }
	
	  var start = subject[0],
	      points,
	      point;
	
	  while (1) {
	    // Find first unvisited intersection.
	    var current = start,
	        isSubject = true;
	    while (current.v) if ((current = current.n) === start) return;
	    points = current.z;
	    stream.lineStart();
	    do {
	      current.v = current.o.v = true;
	      if (current.e) {
	        if (isSubject) {
	          for (i = 0, n = points.length; i < n; ++i) stream.point((point = points[i])[0], point[1]);
	        } else {
	          interpolate(current.x, current.n.x, 1, stream);
	        }
	        current = current.n;
	      } else {
	        if (isSubject) {
	          points = current.p.z;
	          for (i = points.length - 1; i >= 0; --i) stream.point((point = points[i])[0], point[1]);
	        } else {
	          interpolate(current.x, current.p.x, -1, stream);
	        }
	        current = current.p;
	      }
	      current = current.o;
	      points = current.z;
	      isSubject = !isSubject;
	    } while (!current.v);
	    stream.lineEnd();
	  }
	};
	
	function link(array) {
	  if (!(n = array.length)) return;
	  var n,
	      i = 0,
	      a = array[0],
	      b;
	  while (++i < n) {
	    a.n = b = array[i];
	    b.p = a;
	    a = b;
	  }
	  a.n = b = array[0];
	  b.p = a;
	}
	
	var clipMax = 1e9;
	var clipMin = -clipMax;
	
	// TODO Use d3-polygon’s polygonContains here for the ring check?
	// TODO Eliminate duplicate buffering in clipBuffer and polygon.push?
	
	function clipExtent(x0, y0, x1, y1) {
	
	  function visible(x, y) {
	    return x0 <= x && x <= x1 && y0 <= y && y <= y1;
	  }
	
	  function interpolate(from, to, direction, stream) {
	    var a = 0, a1 = 0;
	    if (from == null
	        || (a = corner(from, direction)) !== (a1 = corner(to, direction))
	        || comparePoint(from, to) < 0 ^ direction > 0) {
	      do stream.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
	      while ((a = (a + direction + 4) % 4) !== a1);
	    } else {
	      stream.point(to[0], to[1]);
	    }
	  }
	
	  function corner(p, direction) {
	    return abs(p[0] - x0) < epsilon ? direction > 0 ? 0 : 3
	        : abs(p[0] - x1) < epsilon ? direction > 0 ? 2 : 1
	        : abs(p[1] - y0) < epsilon ? direction > 0 ? 1 : 0
	        : direction > 0 ? 3 : 2; // abs(p[1] - y1) < epsilon
	  }
	
	  function compareIntersection(a, b) {
	    return comparePoint(a.x, b.x);
	  }
	
	  function comparePoint(a, b) {
	    var ca = corner(a, 1),
	        cb = corner(b, 1);
	    return ca !== cb ? ca - cb
	        : ca === 0 ? b[1] - a[1]
	        : ca === 1 ? a[0] - b[0]
	        : ca === 2 ? a[1] - b[1]
	        : b[0] - a[0];
	  }
	
	  return function(stream) {
	    var activeStream = stream,
	        bufferStream = clipBuffer(),
	        segments,
	        polygon,
	        ring,
	        x__, y__, v__, // first point
	        x_, y_, v_, // previous point
	        first,
	        clean;
	
	    var clipStream = {
	      point: point,
	      lineStart: lineStart,
	      lineEnd: lineEnd,
	      polygonStart: polygonStart,
	      polygonEnd: polygonEnd
	    };
	
	    function point(x, y) {
	      if (visible(x, y)) activeStream.point(x, y);
	    }
	
	    function polygonInside() {
	      var winding = 0;
	
	      for (var i = 0, n = polygon.length; i < n; ++i) {
	        for (var ring = polygon[i], j = 1, m = ring.length, point = ring[0], a0, a1, b0 = point[0], b1 = point[1]; j < m; ++j) {
	          a0 = b0, a1 = b1, point = ring[j], b0 = point[0], b1 = point[1];
	          if (a1 <= y1) { if (b1 > y1 && (b0 - a0) * (y1 - a1) > (b1 - a1) * (x0 - a0)) ++winding; }
	          else { if (b1 <= y1 && (b0 - a0) * (y1 - a1) < (b1 - a1) * (x0 - a0)) --winding; }
	        }
	      }
	
	      return winding;
	    }
	
	    // Buffer geometry within a polygon and then clip it en masse.
	    function polygonStart() {
	      activeStream = bufferStream, segments = [], polygon = [], clean = true;
	    }
	
	    function polygonEnd() {
	      var startInside = polygonInside(),
	          cleanInside = clean && startInside,
	          visible = (segments = d3Array.merge(segments)).length;
	      if (cleanInside || visible) {
	        stream.polygonStart();
	        if (cleanInside) {
	          stream.lineStart();
	          interpolate(null, null, 1, stream);
	          stream.lineEnd();
	        }
	        if (visible) {
	          clipPolygon(segments, compareIntersection, startInside, interpolate, stream);
	        }
	        stream.polygonEnd();
	      }
	      activeStream = stream, segments = polygon = ring = null;
	    }
	
	    function lineStart() {
	      clipStream.point = linePoint;
	      if (polygon) polygon.push(ring = []);
	      first = true;
	      v_ = false;
	      x_ = y_ = NaN;
	    }
	
	    // TODO rather than special-case polygons, simply handle them separately.
	    // Ideally, coincident intersection points should be jittered to avoid
	    // clipping issues.
	    function lineEnd() {
	      if (segments) {
	        linePoint(x__, y__);
	        if (v__ && v_) bufferStream.rejoin();
	        segments.push(bufferStream.result());
	      }
	      clipStream.point = point;
	      if (v_) activeStream.lineEnd();
	    }
	
	    function linePoint(x, y) {
	      var v = visible(x, y);
	      if (polygon) ring.push([x, y]);
	      if (first) {
	        x__ = x, y__ = y, v__ = v;
	        first = false;
	        if (v) {
	          activeStream.lineStart();
	          activeStream.point(x, y);
	        }
	      } else {
	        if (v && v_) activeStream.point(x, y);
	        else {
	          var a = [x_ = Math.max(clipMin, Math.min(clipMax, x_)), y_ = Math.max(clipMin, Math.min(clipMax, y_))],
	              b = [x = Math.max(clipMin, Math.min(clipMax, x)), y = Math.max(clipMin, Math.min(clipMax, y))];
	          if (clipLine(a, b, x0, y0, x1, y1)) {
	            if (!v_) {
	              activeStream.lineStart();
	              activeStream.point(a[0], a[1]);
	            }
	            activeStream.point(b[0], b[1]);
	            if (!v) activeStream.lineEnd();
	            clean = false;
	          } else if (v) {
	            activeStream.lineStart();
	            activeStream.point(x, y);
	            clean = false;
	          }
	        }
	      }
	      x_ = x, y_ = y, v_ = v;
	    }
	
	    return clipStream;
	  };
	}
	
	var extent = function() {
	  var x0 = 0,
	      y0 = 0,
	      x1 = 960,
	      y1 = 500,
	      cache,
	      cacheStream,
	      clip;
	
	  return clip = {
	    stream: function(stream) {
	      return cache && cacheStream === stream ? cache : cache = clipExtent(x0, y0, x1, y1)(cacheStream = stream);
	    },
	    extent: function(_) {
	      return arguments.length ? (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1], cache = cacheStream = null, clip) : [[x0, y0], [x1, y1]];
	    }
	  };
	};
	
	var sum = adder();
	
	var polygonContains = function(polygon, point) {
	  var lambda = point[0],
	      phi = point[1],
	      normal = [sin(lambda), -cos(lambda), 0],
	      angle = 0,
	      winding = 0;
	
	  sum.reset();
	
	  for (var i = 0, n = polygon.length; i < n; ++i) {
	    if (!(m = (ring = polygon[i]).length)) continue;
	    var ring,
	        m,
	        point0 = ring[m - 1],
	        lambda0 = point0[0],
	        phi0 = point0[1] / 2 + quarterPi,
	        sinPhi0 = sin(phi0),
	        cosPhi0 = cos(phi0);
	
	    for (var j = 0; j < m; ++j, lambda0 = lambda1, sinPhi0 = sinPhi1, cosPhi0 = cosPhi1, point0 = point1) {
	      var point1 = ring[j],
	          lambda1 = point1[0],
	          phi1 = point1[1] / 2 + quarterPi,
	          sinPhi1 = sin(phi1),
	          cosPhi1 = cos(phi1),
	          delta = lambda1 - lambda0,
	          sign$$1 = delta >= 0 ? 1 : -1,
	          absDelta = sign$$1 * delta,
	          antimeridian = absDelta > pi,
	          k = sinPhi0 * sinPhi1;
	
	      sum.add(atan2(k * sign$$1 * sin(absDelta), cosPhi0 * cosPhi1 + k * cos(absDelta)));
	      angle += antimeridian ? delta + sign$$1 * tau : delta;
	
	      // Are the longitudes either side of the point’s meridian (lambda),
	      // and are the latitudes smaller than the parallel (phi)?
	      if (antimeridian ^ lambda0 >= lambda ^ lambda1 >= lambda) {
	        var arc = cartesianCross(cartesian(point0), cartesian(point1));
	        cartesianNormalizeInPlace(arc);
	        var intersection = cartesianCross(normal, arc);
	        cartesianNormalizeInPlace(intersection);
	        var phiArc = (antimeridian ^ delta >= 0 ? -1 : 1) * asin(intersection[2]);
	        if (phi > phiArc || phi === phiArc && (arc[0] || arc[1])) {
	          winding += antimeridian ^ delta >= 0 ? 1 : -1;
	        }
	      }
	    }
	  }
	
	  // First, determine whether the South pole is inside or outside:
	  //
	  // It is inside if:
	  // * the polygon winds around it in a clockwise direction.
	  // * the polygon does not (cumulatively) wind around it, but has a negative
	  //   (counter-clockwise) area.
	  //
	  // Second, count the (signed) number of times a segment crosses a lambda
	  // from the point to the South pole.  If it is zero, then the point is the
	  // same side as the South pole.
	
	  return (angle < -epsilon || angle < epsilon && sum < -epsilon) ^ (winding & 1);
	};
	
	var lengthSum = adder();
	var lambda0$2;
	var sinPhi0$1;
	var cosPhi0$1;
	
	var lengthStream = {
	  sphere: noop,
	  point: noop,
	  lineStart: lengthLineStart,
	  lineEnd: noop,
	  polygonStart: noop,
	  polygonEnd: noop
	};
	
	function lengthLineStart() {
	  lengthStream.point = lengthPointFirst;
	  lengthStream.lineEnd = lengthLineEnd;
	}
	
	function lengthLineEnd() {
	  lengthStream.point = lengthStream.lineEnd = noop;
	}
	
	function lengthPointFirst(lambda, phi) {
	  lambda *= radians, phi *= radians;
	  lambda0$2 = lambda, sinPhi0$1 = sin(phi), cosPhi0$1 = cos(phi);
	  lengthStream.point = lengthPoint;
	}
	
	function lengthPoint(lambda, phi) {
	  lambda *= radians, phi *= radians;
	  var sinPhi = sin(phi),
	      cosPhi = cos(phi),
	      delta = abs(lambda - lambda0$2),
	      cosDelta = cos(delta),
	      sinDelta = sin(delta),
	      x = cosPhi * sinDelta,
	      y = cosPhi0$1 * sinPhi - sinPhi0$1 * cosPhi * cosDelta,
	      z = sinPhi0$1 * sinPhi + cosPhi0$1 * cosPhi * cosDelta;
	  lengthSum.add(atan2(sqrt(x * x + y * y), z));
	  lambda0$2 = lambda, sinPhi0$1 = sinPhi, cosPhi0$1 = cosPhi;
	}
	
	var length = function(object) {
	  lengthSum.reset();
	  geoStream(object, lengthStream);
	  return +lengthSum;
	};
	
	var coordinates = [null, null];
	var object = {type: "LineString", coordinates: coordinates};
	
	var distance = function(a, b) {
	  coordinates[0] = a;
	  coordinates[1] = b;
	  return length(object);
	};
	
	var containsObjectType = {
	  Feature: function(object, point) {
	    return containsGeometry(object.geometry, point);
	  },
	  FeatureCollection: function(object, point) {
	    var features = object.features, i = -1, n = features.length;
	    while (++i < n) if (containsGeometry(features[i].geometry, point)) return true;
	    return false;
	  }
	};
	
	var containsGeometryType = {
	  Sphere: function() {
	    return true;
	  },
	  Point: function(object, point) {
	    return containsPoint(object.coordinates, point);
	  },
	  MultiPoint: function(object, point) {
	    var coordinates = object.coordinates, i = -1, n = coordinates.length;
	    while (++i < n) if (containsPoint(coordinates[i], point)) return true;
	    return false;
	  },
	  LineString: function(object, point) {
	    return containsLine(object.coordinates, point);
	  },
	  MultiLineString: function(object, point) {
	    var coordinates = object.coordinates, i = -1, n = coordinates.length;
	    while (++i < n) if (containsLine(coordinates[i], point)) return true;
	    return false;
	  },
	  Polygon: function(object, point) {
	    return containsPolygon(object.coordinates, point);
	  },
	  MultiPolygon: function(object, point) {
	    var coordinates = object.coordinates, i = -1, n = coordinates.length;
	    while (++i < n) if (containsPolygon(coordinates[i], point)) return true;
	    return false;
	  },
	  GeometryCollection: function(object, point) {
	    var geometries = object.geometries, i = -1, n = geometries.length;
	    while (++i < n) if (containsGeometry(geometries[i], point)) return true;
	    return false;
	  }
	};
	
	function containsGeometry(geometry, point) {
	  return geometry && containsGeometryType.hasOwnProperty(geometry.type)
	      ? containsGeometryType[geometry.type](geometry, point)
	      : false;
	}
	
	function containsPoint(coordinates, point) {
	  return distance(coordinates, point) === 0;
	}
	
	function containsLine(coordinates, point) {
	  var ab = distance(coordinates[0], coordinates[1]),
	      ao = distance(coordinates[0], point),
	      ob = distance(point, coordinates[1]);
	  return ao + ob <= ab + epsilon;
	}
	
	function containsPolygon(coordinates, point) {
	  return !!polygonContains(coordinates.map(ringRadians), pointRadians(point));
	}
	
	function ringRadians(ring) {
	  return ring = ring.map(pointRadians), ring.pop(), ring;
	}
	
	function pointRadians(point) {
	  return [point[0] * radians, point[1] * radians];
	}
	
	var contains = function(object, point) {
	  return (object && containsObjectType.hasOwnProperty(object.type)
	      ? containsObjectType[object.type]
	      : containsGeometry)(object, point);
	};
	
	function graticuleX(y0, y1, dy) {
	  var y = d3Array.range(y0, y1 - epsilon, dy).concat(y1);
	  return function(x) { return y.map(function(y) { return [x, y]; }); };
	}
	
	function graticuleY(x0, x1, dx) {
	  var x = d3Array.range(x0, x1 - epsilon, dx).concat(x1);
	  return function(y) { return x.map(function(x) { return [x, y]; }); };
	}
	
	function graticule() {
	  var x1, x0, X1, X0,
	      y1, y0, Y1, Y0,
	      dx = 10, dy = dx, DX = 90, DY = 360,
	      x, y, X, Y,
	      precision = 2.5;
	
	  function graticule() {
	    return {type: "MultiLineString", coordinates: lines()};
	  }
	
	  function lines() {
	    return d3Array.range(ceil(X0 / DX) * DX, X1, DX).map(X)
	        .concat(d3Array.range(ceil(Y0 / DY) * DY, Y1, DY).map(Y))
	        .concat(d3Array.range(ceil(x0 / dx) * dx, x1, dx).filter(function(x) { return abs(x % DX) > epsilon; }).map(x))
	        .concat(d3Array.range(ceil(y0 / dy) * dy, y1, dy).filter(function(y) { return abs(y % DY) > epsilon; }).map(y));
	  }
	
	  graticule.lines = function() {
	    return lines().map(function(coordinates) { return {type: "LineString", coordinates: coordinates}; });
	  };
	
	  graticule.outline = function() {
	    return {
	      type: "Polygon",
	      coordinates: [
	        X(X0).concat(
	        Y(Y1).slice(1),
	        X(X1).reverse().slice(1),
	        Y(Y0).reverse().slice(1))
	      ]
	    };
	  };
	
	  graticule.extent = function(_) {
	    if (!arguments.length) return graticule.extentMinor();
	    return graticule.extentMajor(_).extentMinor(_);
	  };
	
	  graticule.extentMajor = function(_) {
	    if (!arguments.length) return [[X0, Y0], [X1, Y1]];
	    X0 = +_[0][0], X1 = +_[1][0];
	    Y0 = +_[0][1], Y1 = +_[1][1];
	    if (X0 > X1) _ = X0, X0 = X1, X1 = _;
	    if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
	    return graticule.precision(precision);
	  };
	
	  graticule.extentMinor = function(_) {
	    if (!arguments.length) return [[x0, y0], [x1, y1]];
	    x0 = +_[0][0], x1 = +_[1][0];
	    y0 = +_[0][1], y1 = +_[1][1];
	    if (x0 > x1) _ = x0, x0 = x1, x1 = _;
	    if (y0 > y1) _ = y0, y0 = y1, y1 = _;
	    return graticule.precision(precision);
	  };
	
	  graticule.step = function(_) {
	    if (!arguments.length) return graticule.stepMinor();
	    return graticule.stepMajor(_).stepMinor(_);
	  };
	
	  graticule.stepMajor = function(_) {
	    if (!arguments.length) return [DX, DY];
	    DX = +_[0], DY = +_[1];
	    return graticule;
	  };
	
	  graticule.stepMinor = function(_) {
	    if (!arguments.length) return [dx, dy];
	    dx = +_[0], dy = +_[1];
	    return graticule;
	  };
	
	  graticule.precision = function(_) {
	    if (!arguments.length) return precision;
	    precision = +_;
	    x = graticuleX(y0, y1, 90);
	    y = graticuleY(x0, x1, precision);
	    X = graticuleX(Y0, Y1, 90);
	    Y = graticuleY(X0, X1, precision);
	    return graticule;
	  };
	
	  return graticule
	      .extentMajor([[-180, -90 + epsilon], [180, 90 - epsilon]])
	      .extentMinor([[-180, -80 - epsilon], [180, 80 + epsilon]]);
	}
	
	function graticule10() {
	  return graticule()();
	}
	
	var interpolate = function(a, b) {
	  var x0 = a[0] * radians,
	      y0 = a[1] * radians,
	      x1 = b[0] * radians,
	      y1 = b[1] * radians,
	      cy0 = cos(y0),
	      sy0 = sin(y0),
	      cy1 = cos(y1),
	      sy1 = sin(y1),
	      kx0 = cy0 * cos(x0),
	      ky0 = cy0 * sin(x0),
	      kx1 = cy1 * cos(x1),
	      ky1 = cy1 * sin(x1),
	      d = 2 * asin(sqrt(haversin(y1 - y0) + cy0 * cy1 * haversin(x1 - x0))),
	      k = sin(d);
	
	  var interpolate = d ? function(t) {
	    var B = sin(t *= d) / k,
	        A = sin(d - t) / k,
	        x = A * kx0 + B * kx1,
	        y = A * ky0 + B * ky1,
	        z = A * sy0 + B * sy1;
	    return [
	      atan2(y, x) * degrees,
	      atan2(z, sqrt(x * x + y * y)) * degrees
	    ];
	  } : function() {
	    return [x0 * degrees, y0 * degrees];
	  };
	
	  interpolate.distance = d;
	
	  return interpolate;
	};
	
	var identity = function(x) {
	  return x;
	};
	
	var areaSum$1 = adder();
	var areaRingSum$1 = adder();
	var x00;
	var y00;
	var x0$1;
	var y0$1;
	
	var areaStream$1 = {
	  point: noop,
	  lineStart: noop,
	  lineEnd: noop,
	  polygonStart: function() {
	    areaStream$1.lineStart = areaRingStart$1;
	    areaStream$1.lineEnd = areaRingEnd$1;
	  },
	  polygonEnd: function() {
	    areaStream$1.lineStart = areaStream$1.lineEnd = areaStream$1.point = noop;
	    areaSum$1.add(abs(areaRingSum$1));
	    areaRingSum$1.reset();
	  },
	  result: function() {
	    var area = areaSum$1 / 2;
	    areaSum$1.reset();
	    return area;
	  }
	};
	
	function areaRingStart$1() {
	  areaStream$1.point = areaPointFirst$1;
	}
	
	function areaPointFirst$1(x, y) {
	  areaStream$1.point = areaPoint$1;
	  x00 = x0$1 = x, y00 = y0$1 = y;
	}
	
	function areaPoint$1(x, y) {
	  areaRingSum$1.add(y0$1 * x - x0$1 * y);
	  x0$1 = x, y0$1 = y;
	}
	
	function areaRingEnd$1() {
	  areaPoint$1(x00, y00);
	}
	
	var x0$2 = Infinity;
	var y0$2 = x0$2;
	var x1 = -x0$2;
	var y1 = x1;
	
	var boundsStream$1 = {
	  point: boundsPoint$1,
	  lineStart: noop,
	  lineEnd: noop,
	  polygonStart: noop,
	  polygonEnd: noop,
	  result: function() {
	    var bounds = [[x0$2, y0$2], [x1, y1]];
	    x1 = y1 = -(y0$2 = x0$2 = Infinity);
	    return bounds;
	  }
	};
	
	function boundsPoint$1(x, y) {
	  if (x < x0$2) x0$2 = x;
	  if (x > x1) x1 = x;
	  if (y < y0$2) y0$2 = y;
	  if (y > y1) y1 = y;
	}
	
	// TODO Enforce positive area for exterior, negative area for interior?
	
	var X0$1 = 0;
	var Y0$1 = 0;
	var Z0$1 = 0;
	var X1$1 = 0;
	var Y1$1 = 0;
	var Z1$1 = 0;
	var X2$1 = 0;
	var Y2$1 = 0;
	var Z2$1 = 0;
	var x00$1;
	var y00$1;
	var x0$3;
	var y0$3;
	
	var centroidStream$1 = {
	  point: centroidPoint$1,
	  lineStart: centroidLineStart$1,
	  lineEnd: centroidLineEnd$1,
	  polygonStart: function() {
	    centroidStream$1.lineStart = centroidRingStart$1;
	    centroidStream$1.lineEnd = centroidRingEnd$1;
	  },
	  polygonEnd: function() {
	    centroidStream$1.point = centroidPoint$1;
	    centroidStream$1.lineStart = centroidLineStart$1;
	    centroidStream$1.lineEnd = centroidLineEnd$1;
	  },
	  result: function() {
	    var centroid = Z2$1 ? [X2$1 / Z2$1, Y2$1 / Z2$1]
	        : Z1$1 ? [X1$1 / Z1$1, Y1$1 / Z1$1]
	        : Z0$1 ? [X0$1 / Z0$1, Y0$1 / Z0$1]
	        : [NaN, NaN];
	    X0$1 = Y0$1 = Z0$1 =
	    X1$1 = Y1$1 = Z1$1 =
	    X2$1 = Y2$1 = Z2$1 = 0;
	    return centroid;
	  }
	};
	
	function centroidPoint$1(x, y) {
	  X0$1 += x;
	  Y0$1 += y;
	  ++Z0$1;
	}
	
	function centroidLineStart$1() {
	  centroidStream$1.point = centroidPointFirstLine;
	}
	
	function centroidPointFirstLine(x, y) {
	  centroidStream$1.point = centroidPointLine;
	  centroidPoint$1(x0$3 = x, y0$3 = y);
	}
	
	function centroidPointLine(x, y) {
	  var dx = x - x0$3, dy = y - y0$3, z = sqrt(dx * dx + dy * dy);
	  X1$1 += z * (x0$3 + x) / 2;
	  Y1$1 += z * (y0$3 + y) / 2;
	  Z1$1 += z;
	  centroidPoint$1(x0$3 = x, y0$3 = y);
	}
	
	function centroidLineEnd$1() {
	  centroidStream$1.point = centroidPoint$1;
	}
	
	function centroidRingStart$1() {
	  centroidStream$1.point = centroidPointFirstRing;
	}
	
	function centroidRingEnd$1() {
	  centroidPointRing(x00$1, y00$1);
	}
	
	function centroidPointFirstRing(x, y) {
	  centroidStream$1.point = centroidPointRing;
	  centroidPoint$1(x00$1 = x0$3 = x, y00$1 = y0$3 = y);
	}
	
	function centroidPointRing(x, y) {
	  var dx = x - x0$3,
	      dy = y - y0$3,
	      z = sqrt(dx * dx + dy * dy);
	
	  X1$1 += z * (x0$3 + x) / 2;
	  Y1$1 += z * (y0$3 + y) / 2;
	  Z1$1 += z;
	
	  z = y0$3 * x - x0$3 * y;
	  X2$1 += z * (x0$3 + x);
	  Y2$1 += z * (y0$3 + y);
	  Z2$1 += z * 3;
	  centroidPoint$1(x0$3 = x, y0$3 = y);
	}
	
	function PathContext(context) {
	  this._context = context;
	}
	
	PathContext.prototype = {
	  _radius: 4.5,
	  pointRadius: function(_) {
	    return this._radius = _, this;
	  },
	  polygonStart: function() {
	    this._line = 0;
	  },
	  polygonEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line === 0) this._context.closePath();
	    this._point = NaN;
	  },
	  point: function(x, y) {
	    switch (this._point) {
	      case 0: {
	        this._context.moveTo(x, y);
	        this._point = 1;
	        break;
	      }
	      case 1: {
	        this._context.lineTo(x, y);
	        break;
	      }
	      default: {
	        this._context.moveTo(x + this._radius, y);
	        this._context.arc(x, y, this._radius, 0, tau);
	        break;
	      }
	    }
	  },
	  result: noop
	};
	
	var lengthSum$1 = adder();
	var lengthRing;
	var x00$2;
	var y00$2;
	var x0$4;
	var y0$4;
	
	var lengthStream$1 = {
	  point: noop,
	  lineStart: function() {
	    lengthStream$1.point = lengthPointFirst$1;
	  },
	  lineEnd: function() {
	    if (lengthRing) lengthPoint$1(x00$2, y00$2);
	    lengthStream$1.point = noop;
	  },
	  polygonStart: function() {
	    lengthRing = true;
	  },
	  polygonEnd: function() {
	    lengthRing = null;
	  },
	  result: function() {
	    var length = +lengthSum$1;
	    lengthSum$1.reset();
	    return length;
	  }
	};
	
	function lengthPointFirst$1(x, y) {
	  lengthStream$1.point = lengthPoint$1;
	  x00$2 = x0$4 = x, y00$2 = y0$4 = y;
	}
	
	function lengthPoint$1(x, y) {
	  x0$4 -= x, y0$4 -= y;
	  lengthSum$1.add(sqrt(x0$4 * x0$4 + y0$4 * y0$4));
	  x0$4 = x, y0$4 = y;
	}
	
	function PathString() {
	  this._string = [];
	}
	
	PathString.prototype = {
	  _circle: circle$1(4.5),
	  pointRadius: function(_) {
	    return this._circle = circle$1(_), this;
	  },
	  polygonStart: function() {
	    this._line = 0;
	  },
	  polygonEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line === 0) this._string.push("Z");
	    this._point = NaN;
	  },
	  point: function(x, y) {
	    switch (this._point) {
	      case 0: {
	        this._string.push("M", x, ",", y);
	        this._point = 1;
	        break;
	      }
	      case 1: {
	        this._string.push("L", x, ",", y);
	        break;
	      }
	      default: {
	        this._string.push("M", x, ",", y, this._circle);
	        break;
	      }
	    }
	  },
	  result: function() {
	    if (this._string.length) {
	      var result = this._string.join("");
	      this._string = [];
	      return result;
	    }
	  }
	};
	
	function circle$1(radius) {
	  return "m0," + radius
	      + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius
	      + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius
	      + "z";
	}
	
	var index = function(projection, context) {
	  var pointRadius = 4.5,
	      projectionStream,
	      contextStream;
	
	  function path(object) {
	    if (object) {
	      if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
	      geoStream(object, projectionStream(contextStream));
	    }
	    return contextStream.result();
	  }
	
	  path.area = function(object) {
	    geoStream(object, projectionStream(areaStream$1));
	    return areaStream$1.result();
	  };
	
	  path.measure = function(object) {
	    geoStream(object, projectionStream(lengthStream$1));
	    return lengthStream$1.result();
	  };
	
	  path.bounds = function(object) {
	    geoStream(object, projectionStream(boundsStream$1));
	    return boundsStream$1.result();
	  };
	
	  path.centroid = function(object) {
	    geoStream(object, projectionStream(centroidStream$1));
	    return centroidStream$1.result();
	  };
	
	  path.projection = function(_) {
	    return arguments.length ? (projectionStream = _ == null ? (projection = null, identity) : (projection = _).stream, path) : projection;
	  };
	
	  path.context = function(_) {
	    if (!arguments.length) return context;
	    contextStream = _ == null ? (context = null, new PathString) : new PathContext(context = _);
	    if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
	    return path;
	  };
	
	  path.pointRadius = function(_) {
	    if (!arguments.length) return pointRadius;
	    pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
	    return path;
	  };
	
	  return path.projection(projection).context(context);
	};
	
	var clip = function(pointVisible, clipLine, interpolate, start) {
	  return function(rotate, sink) {
	    var line = clipLine(sink),
	        rotatedStart = rotate.invert(start[0], start[1]),
	        ringBuffer = clipBuffer(),
	        ringSink = clipLine(ringBuffer),
	        polygonStarted = false,
	        polygon,
	        segments,
	        ring;
	
	    var clip = {
	      point: point,
	      lineStart: lineStart,
	      lineEnd: lineEnd,
	      polygonStart: function() {
	        clip.point = pointRing;
	        clip.lineStart = ringStart;
	        clip.lineEnd = ringEnd;
	        segments = [];
	        polygon = [];
	      },
	      polygonEnd: function() {
	        clip.point = point;
	        clip.lineStart = lineStart;
	        clip.lineEnd = lineEnd;
	        segments = d3Array.merge(segments);
	        var startInside = polygonContains(polygon, rotatedStart);
	        if (segments.length) {
	          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
	          clipPolygon(segments, compareIntersection, startInside, interpolate, sink);
	        } else if (startInside) {
	          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
	          sink.lineStart();
	          interpolate(null, null, 1, sink);
	          sink.lineEnd();
	        }
	        if (polygonStarted) sink.polygonEnd(), polygonStarted = false;
	        segments = polygon = null;
	      },
	      sphere: function() {
	        sink.polygonStart();
	        sink.lineStart();
	        interpolate(null, null, 1, sink);
	        sink.lineEnd();
	        sink.polygonEnd();
	      }
	    };
	
	    function point(lambda, phi) {
	      var point = rotate(lambda, phi);
	      if (pointVisible(lambda = point[0], phi = point[1])) sink.point(lambda, phi);
	    }
	
	    function pointLine(lambda, phi) {
	      var point = rotate(lambda, phi);
	      line.point(point[0], point[1]);
	    }
	
	    function lineStart() {
	      clip.point = pointLine;
	      line.lineStart();
	    }
	
	    function lineEnd() {
	      clip.point = point;
	      line.lineEnd();
	    }
	
	    function pointRing(lambda, phi) {
	      ring.push([lambda, phi]);
	      var point = rotate(lambda, phi);
	      ringSink.point(point[0], point[1]);
	    }
	
	    function ringStart() {
	      ringSink.lineStart();
	      ring = [];
	    }
	
	    function ringEnd() {
	      pointRing(ring[0][0], ring[0][1]);
	      ringSink.lineEnd();
	
	      var clean = ringSink.clean(),
	          ringSegments = ringBuffer.result(),
	          i, n = ringSegments.length, m,
	          segment,
	          point;
	
	      ring.pop();
	      polygon.push(ring);
	      ring = null;
	
	      if (!n) return;
	
	      // No intersections.
	      if (clean & 1) {
	        segment = ringSegments[0];
	        if ((m = segment.length - 1) > 0) {
	          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
	          sink.lineStart();
	          for (i = 0; i < m; ++i) sink.point((point = segment[i])[0], point[1]);
	          sink.lineEnd();
	        }
	        return;
	      }
	
	      // Rejoin connected segments.
	      // TODO reuse ringBuffer.rejoin()?
	      if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));
	
	      segments.push(ringSegments.filter(validSegment));
	    }
	
	    return clip;
	  };
	};
	
	function validSegment(segment) {
	  return segment.length > 1;
	}
	
	// Intersections are sorted along the clip edge. For both antimeridian cutting
	// and circle clipping, the same comparison is used.
	function compareIntersection(a, b) {
	  return ((a = a.x)[0] < 0 ? a[1] - halfPi - epsilon : halfPi - a[1])
	       - ((b = b.x)[0] < 0 ? b[1] - halfPi - epsilon : halfPi - b[1]);
	}
	
	var clipAntimeridian = clip(
	  function() { return true; },
	  clipAntimeridianLine,
	  clipAntimeridianInterpolate,
	  [-pi, -halfPi]
	);
	
	// Takes a line and cuts into visible segments. Return values: 0 - there were
	// intersections or the line was empty; 1 - no intersections; 2 - there were
	// intersections, and the first and last segments should be rejoined.
	function clipAntimeridianLine(stream) {
	  var lambda0 = NaN,
	      phi0 = NaN,
	      sign0 = NaN,
	      clean; // no intersections
	
	  return {
	    lineStart: function() {
	      stream.lineStart();
	      clean = 1;
	    },
	    point: function(lambda1, phi1) {
	      var sign1 = lambda1 > 0 ? pi : -pi,
	          delta = abs(lambda1 - lambda0);
	      if (abs(delta - pi) < epsilon) { // line crosses a pole
	        stream.point(lambda0, phi0 = (phi0 + phi1) / 2 > 0 ? halfPi : -halfPi);
	        stream.point(sign0, phi0);
	        stream.lineEnd();
	        stream.lineStart();
	        stream.point(sign1, phi0);
	        stream.point(lambda1, phi0);
	        clean = 0;
	      } else if (sign0 !== sign1 && delta >= pi) { // line crosses antimeridian
	        if (abs(lambda0 - sign0) < epsilon) lambda0 -= sign0 * epsilon; // handle degeneracies
	        if (abs(lambda1 - sign1) < epsilon) lambda1 -= sign1 * epsilon;
	        phi0 = clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1);
	        stream.point(sign0, phi0);
	        stream.lineEnd();
	        stream.lineStart();
	        stream.point(sign1, phi0);
	        clean = 0;
	      }
	      stream.point(lambda0 = lambda1, phi0 = phi1);
	      sign0 = sign1;
	    },
	    lineEnd: function() {
	      stream.lineEnd();
	      lambda0 = phi0 = NaN;
	    },
	    clean: function() {
	      return 2 - clean; // if intersections, rejoin first and last segments
	    }
	  };
	}
	
	function clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1) {
	  var cosPhi0,
	      cosPhi1,
	      sinLambda0Lambda1 = sin(lambda0 - lambda1);
	  return abs(sinLambda0Lambda1) > epsilon
	      ? atan((sin(phi0) * (cosPhi1 = cos(phi1)) * sin(lambda1)
	          - sin(phi1) * (cosPhi0 = cos(phi0)) * sin(lambda0))
	          / (cosPhi0 * cosPhi1 * sinLambda0Lambda1))
	      : (phi0 + phi1) / 2;
	}
	
	function clipAntimeridianInterpolate(from, to, direction, stream) {
	  var phi;
	  if (from == null) {
	    phi = direction * halfPi;
	    stream.point(-pi, phi);
	    stream.point(0, phi);
	    stream.point(pi, phi);
	    stream.point(pi, 0);
	    stream.point(pi, -phi);
	    stream.point(0, -phi);
	    stream.point(-pi, -phi);
	    stream.point(-pi, 0);
	    stream.point(-pi, phi);
	  } else if (abs(from[0] - to[0]) > epsilon) {
	    var lambda = from[0] < to[0] ? pi : -pi;
	    phi = direction * lambda / 2;
	    stream.point(-lambda, phi);
	    stream.point(0, phi);
	    stream.point(lambda, phi);
	  } else {
	    stream.point(to[0], to[1]);
	  }
	}
	
	var clipCircle = function(radius, delta) {
	  var cr = cos(radius),
	      smallRadius = cr > 0,
	      notHemisphere = abs(cr) > epsilon; // TODO optimise for this common case
	
	  function interpolate(from, to, direction, stream) {
	    circleStream(stream, radius, delta, direction, from, to);
	  }
	
	  function visible(lambda, phi) {
	    return cos(lambda) * cos(phi) > cr;
	  }
	
	  // Takes a line and cuts into visible segments. Return values used for polygon
	  // clipping: 0 - there were intersections or the line was empty; 1 - no
	  // intersections 2 - there were intersections, and the first and last segments
	  // should be rejoined.
	  function clipLine(stream) {
	    var point0, // previous point
	        c0, // code for previous point
	        v0, // visibility of previous point
	        v00, // visibility of first point
	        clean; // no intersections
	    return {
	      lineStart: function() {
	        v00 = v0 = false;
	        clean = 1;
	      },
	      point: function(lambda, phi) {
	        var point1 = [lambda, phi],
	            point2,
	            v = visible(lambda, phi),
	            c = smallRadius
	              ? v ? 0 : code(lambda, phi)
	              : v ? code(lambda + (lambda < 0 ? pi : -pi), phi) : 0;
	        if (!point0 && (v00 = v0 = v)) stream.lineStart();
	        // Handle degeneracies.
	        // TODO ignore if not clipping polygons.
	        if (v !== v0) {
	          point2 = intersect(point0, point1);
	          if (pointEqual(point0, point2) || pointEqual(point1, point2)) {
	            point1[0] += epsilon;
	            point1[1] += epsilon;
	            v = visible(point1[0], point1[1]);
	          }
	        }
	        if (v !== v0) {
	          clean = 0;
	          if (v) {
	            // outside going in
	            stream.lineStart();
	            point2 = intersect(point1, point0);
	            stream.point(point2[0], point2[1]);
	          } else {
	            // inside going out
	            point2 = intersect(point0, point1);
	            stream.point(point2[0], point2[1]);
	            stream.lineEnd();
	          }
	          point0 = point2;
	        } else if (notHemisphere && point0 && smallRadius ^ v) {
	          var t;
	          // If the codes for two points are different, or are both zero,
	          // and there this segment intersects with the small circle.
	          if (!(c & c0) && (t = intersect(point1, point0, true))) {
	            clean = 0;
	            if (smallRadius) {
	              stream.lineStart();
	              stream.point(t[0][0], t[0][1]);
	              stream.point(t[1][0], t[1][1]);
	              stream.lineEnd();
	            } else {
	              stream.point(t[1][0], t[1][1]);
	              stream.lineEnd();
	              stream.lineStart();
	              stream.point(t[0][0], t[0][1]);
	            }
	          }
	        }
	        if (v && (!point0 || !pointEqual(point0, point1))) {
	          stream.point(point1[0], point1[1]);
	        }
	        point0 = point1, v0 = v, c0 = c;
	      },
	      lineEnd: function() {
	        if (v0) stream.lineEnd();
	        point0 = null;
	      },
	      // Rejoin first and last segments if there were intersections and the first
	      // and last points were visible.
	      clean: function() {
	        return clean | ((v00 && v0) << 1);
	      }
	    };
	  }
	
	  // Intersects the great circle between a and b with the clip circle.
	  function intersect(a, b, two) {
	    var pa = cartesian(a),
	        pb = cartesian(b);
	
	    // We have two planes, n1.p = d1 and n2.p = d2.
	    // Find intersection line p(t) = c1 n1 + c2 n2 + t (n1 ⨯ n2).
	    var n1 = [1, 0, 0], // normal
	        n2 = cartesianCross(pa, pb),
	        n2n2 = cartesianDot(n2, n2),
	        n1n2 = n2[0], // cartesianDot(n1, n2),
	        determinant = n2n2 - n1n2 * n1n2;
	
	    // Two polar points.
	    if (!determinant) return !two && a;
	
	    var c1 =  cr * n2n2 / determinant,
	        c2 = -cr * n1n2 / determinant,
	        n1xn2 = cartesianCross(n1, n2),
	        A = cartesianScale(n1, c1),
	        B = cartesianScale(n2, c2);
	    cartesianAddInPlace(A, B);
	
	    // Solve |p(t)|^2 = 1.
	    var u = n1xn2,
	        w = cartesianDot(A, u),
	        uu = cartesianDot(u, u),
	        t2 = w * w - uu * (cartesianDot(A, A) - 1);
	
	    if (t2 < 0) return;
	
	    var t = sqrt(t2),
	        q = cartesianScale(u, (-w - t) / uu);
	    cartesianAddInPlace(q, A);
	    q = spherical(q);
	
	    if (!two) return q;
	
	    // Two intersection points.
	    var lambda0 = a[0],
	        lambda1 = b[0],
	        phi0 = a[1],
	        phi1 = b[1],
	        z;
	
	    if (lambda1 < lambda0) z = lambda0, lambda0 = lambda1, lambda1 = z;
	
	    var delta = lambda1 - lambda0,
	        polar = abs(delta - pi) < epsilon,
	        meridian = polar || delta < epsilon;
	
	    if (!polar && phi1 < phi0) z = phi0, phi0 = phi1, phi1 = z;
	
	    // Check that the first point is between a and b.
	    if (meridian
	        ? polar
	          ? phi0 + phi1 > 0 ^ q[1] < (abs(q[0] - lambda0) < epsilon ? phi0 : phi1)
	          : phi0 <= q[1] && q[1] <= phi1
	        : delta > pi ^ (lambda0 <= q[0] && q[0] <= lambda1)) {
	      var q1 = cartesianScale(u, (-w + t) / uu);
	      cartesianAddInPlace(q1, A);
	      return [q, spherical(q1)];
	    }
	  }
	
	  // Generates a 4-bit vector representing the location of a point relative to
	  // the small circle's bounding box.
	  function code(lambda, phi) {
	    var r = smallRadius ? radius : pi - radius,
	        code = 0;
	    if (lambda < -r) code |= 1; // left
	    else if (lambda > r) code |= 2; // right
	    if (phi < -r) code |= 4; // below
	    else if (phi > r) code |= 8; // above
	    return code;
	  }
	
	  return clip(visible, clipLine, interpolate, smallRadius ? [0, -radius] : [-pi, radius - pi]);
	};
	
	var transform = function(methods) {
	  return {
	    stream: transformer(methods)
	  };
	};
	
	function transformer(methods) {
	  return function(stream) {
	    var s = new TransformStream;
	    for (var key in methods) s[key] = methods[key];
	    s.stream = stream;
	    return s;
	  };
	}
	
	function TransformStream() {}
	
	TransformStream.prototype = {
	  constructor: TransformStream,
	  point: function(x, y) { this.stream.point(x, y); },
	  sphere: function() { this.stream.sphere(); },
	  lineStart: function() { this.stream.lineStart(); },
	  lineEnd: function() { this.stream.lineEnd(); },
	  polygonStart: function() { this.stream.polygonStart(); },
	  polygonEnd: function() { this.stream.polygonEnd(); }
	};
	
	function fitExtent(projection, extent, object) {
	  var w = extent[1][0] - extent[0][0],
	      h = extent[1][1] - extent[0][1],
	      clip = projection.clipExtent && projection.clipExtent();
	
	  projection
	      .scale(150)
	      .translate([0, 0]);
	
	  if (clip != null) projection.clipExtent(null);
	
	  geoStream(object, projection.stream(boundsStream$1));
	
	  var b = boundsStream$1.result(),
	      k = Math.min(w / (b[1][0] - b[0][0]), h / (b[1][1] - b[0][1])),
	      x = +extent[0][0] + (w - k * (b[1][0] + b[0][0])) / 2,
	      y = +extent[0][1] + (h - k * (b[1][1] + b[0][1])) / 2;
	
	  if (clip != null) projection.clipExtent(clip);
	
	  return projection
	      .scale(k * 150)
	      .translate([x, y]);
	}
	
	function fitSize(projection, size, object) {
	  return fitExtent(projection, [[0, 0], size], object);
	}
	
	var maxDepth = 16;
	var cosMinDistance = cos(30 * radians); // cos(minimum angular distance)
	
	var resample = function(project, delta2) {
	  return +delta2 ? resample$1(project, delta2) : resampleNone(project);
	};
	
	function resampleNone(project) {
	  return transformer({
	    point: function(x, y) {
	      x = project(x, y);
	      this.stream.point(x[0], x[1]);
	    }
	  });
	}
	
	function resample$1(project, delta2) {
	
	  function resampleLineTo(x0, y0, lambda0, a0, b0, c0, x1, y1, lambda1, a1, b1, c1, depth, stream) {
	    var dx = x1 - x0,
	        dy = y1 - y0,
	        d2 = dx * dx + dy * dy;
	    if (d2 > 4 * delta2 && depth--) {
	      var a = a0 + a1,
	          b = b0 + b1,
	          c = c0 + c1,
	          m = sqrt(a * a + b * b + c * c),
	          phi2 = asin(c /= m),
	          lambda2 = abs(abs(c) - 1) < epsilon || abs(lambda0 - lambda1) < epsilon ? (lambda0 + lambda1) / 2 : atan2(b, a),
	          p = project(lambda2, phi2),
	          x2 = p[0],
	          y2 = p[1],
	          dx2 = x2 - x0,
	          dy2 = y2 - y0,
	          dz = dy * dx2 - dx * dy2;
	      if (dz * dz / d2 > delta2 // perpendicular projected distance
	          || abs((dx * dx2 + dy * dy2) / d2 - 0.5) > 0.3 // midpoint close to an end
	          || a0 * a1 + b0 * b1 + c0 * c1 < cosMinDistance) { // angular distance
	        resampleLineTo(x0, y0, lambda0, a0, b0, c0, x2, y2, lambda2, a /= m, b /= m, c, depth, stream);
	        stream.point(x2, y2);
	        resampleLineTo(x2, y2, lambda2, a, b, c, x1, y1, lambda1, a1, b1, c1, depth, stream);
	      }
	    }
	  }
	  return function(stream) {
	    var lambda00, x00, y00, a00, b00, c00, // first point
	        lambda0, x0, y0, a0, b0, c0; // previous point
	
	    var resampleStream = {
	      point: point,
	      lineStart: lineStart,
	      lineEnd: lineEnd,
	      polygonStart: function() { stream.polygonStart(); resampleStream.lineStart = ringStart; },
	      polygonEnd: function() { stream.polygonEnd(); resampleStream.lineStart = lineStart; }
	    };
	
	    function point(x, y) {
	      x = project(x, y);
	      stream.point(x[0], x[1]);
	    }
	
	    function lineStart() {
	      x0 = NaN;
	      resampleStream.point = linePoint;
	      stream.lineStart();
	    }
	
	    function linePoint(lambda, phi) {
	      var c = cartesian([lambda, phi]), p = project(lambda, phi);
	      resampleLineTo(x0, y0, lambda0, a0, b0, c0, x0 = p[0], y0 = p[1], lambda0 = lambda, a0 = c[0], b0 = c[1], c0 = c[2], maxDepth, stream);
	      stream.point(x0, y0);
	    }
	
	    function lineEnd() {
	      resampleStream.point = point;
	      stream.lineEnd();
	    }
	
	    function ringStart() {
	      lineStart();
	      resampleStream.point = ringPoint;
	      resampleStream.lineEnd = ringEnd;
	    }
	
	    function ringPoint(lambda, phi) {
	      linePoint(lambda00 = lambda, phi), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
	      resampleStream.point = linePoint;
	    }
	
	    function ringEnd() {
	      resampleLineTo(x0, y0, lambda0, a0, b0, c0, x00, y00, lambda00, a00, b00, c00, maxDepth, stream);
	      resampleStream.lineEnd = lineEnd;
	      lineEnd();
	    }
	
	    return resampleStream;
	  };
	}
	
	var transformRadians = transformer({
	  point: function(x, y) {
	    this.stream.point(x * radians, y * radians);
	  }
	});
	
	function projection(project) {
	  return projectionMutator(function() { return project; })();
	}
	
	function projectionMutator(projectAt) {
	  var project,
	      k = 150, // scale
	      x = 480, y = 250, // translate
	      dx, dy, lambda = 0, phi = 0, // center
	      deltaLambda = 0, deltaPhi = 0, deltaGamma = 0, rotate, projectRotate, // rotate
	      theta = null, preclip = clipAntimeridian, // clip angle
	      x0 = null, y0, x1, y1, postclip = identity, // clip extent
	      delta2 = 0.5, projectResample = resample(projectTransform, delta2), // precision
	      cache,
	      cacheStream;
	
	  function projection(point) {
	    point = projectRotate(point[0] * radians, point[1] * radians);
	    return [point[0] * k + dx, dy - point[1] * k];
	  }
	
	  function invert(point) {
	    point = projectRotate.invert((point[0] - dx) / k, (dy - point[1]) / k);
	    return point && [point[0] * degrees, point[1] * degrees];
	  }
	
	  function projectTransform(x, y) {
	    return x = project(x, y), [x[0] * k + dx, dy - x[1] * k];
	  }
	
	  projection.stream = function(stream) {
	    return cache && cacheStream === stream ? cache : cache = transformRadians(preclip(rotate, projectResample(postclip(cacheStream = stream))));
	  };
	
	  projection.clipAngle = function(_) {
	    return arguments.length ? (preclip = +_ ? clipCircle(theta = _ * radians, 6 * radians) : (theta = null, clipAntimeridian), reset()) : theta * degrees;
	  };
	
	  projection.clipExtent = function(_) {
	    return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, identity) : clipExtent(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [[x0, y0], [x1, y1]];
	  };
	
	  projection.scale = function(_) {
	    return arguments.length ? (k = +_, recenter()) : k;
	  };
	
	  projection.translate = function(_) {
	    return arguments.length ? (x = +_[0], y = +_[1], recenter()) : [x, y];
	  };
	
	  projection.center = function(_) {
	    return arguments.length ? (lambda = _[0] % 360 * radians, phi = _[1] % 360 * radians, recenter()) : [lambda * degrees, phi * degrees];
	  };
	
	  projection.rotate = function(_) {
	    return arguments.length ? (deltaLambda = _[0] % 360 * radians, deltaPhi = _[1] % 360 * radians, deltaGamma = _.length > 2 ? _[2] % 360 * radians : 0, recenter()) : [deltaLambda * degrees, deltaPhi * degrees, deltaGamma * degrees];
	  };
	
	  projection.precision = function(_) {
	    return arguments.length ? (projectResample = resample(projectTransform, delta2 = _ * _), reset()) : sqrt(delta2);
	  };
	
	  projection.fitExtent = function(extent, object) {
	    return fitExtent(projection, extent, object);
	  };
	
	  projection.fitSize = function(size, object) {
	    return fitSize(projection, size, object);
	  };
	
	  function recenter() {
	    projectRotate = compose(rotate = rotateRadians(deltaLambda, deltaPhi, deltaGamma), project);
	    var center = project(lambda, phi);
	    dx = x - center[0] * k;
	    dy = y + center[1] * k;
	    return reset();
	  }
	
	  function reset() {
	    cache = cacheStream = null;
	    return projection;
	  }
	
	  return function() {
	    project = projectAt.apply(this, arguments);
	    projection.invert = project.invert && invert;
	    return recenter();
	  };
	}
	
	function conicProjection(projectAt) {
	  var phi0 = 0,
	      phi1 = pi / 3,
	      m = projectionMutator(projectAt),
	      p = m(phi0, phi1);
	
	  p.parallels = function(_) {
	    return arguments.length ? m(phi0 = _[0] * radians, phi1 = _[1] * radians) : [phi0 * degrees, phi1 * degrees];
	  };
	
	  return p;
	}
	
	function cylindricalEqualAreaRaw(phi0) {
	  var cosPhi0 = cos(phi0);
	
	  function forward(lambda, phi) {
	    return [lambda * cosPhi0, sin(phi) / cosPhi0];
	  }
	
	  forward.invert = function(x, y) {
	    return [x / cosPhi0, asin(y * cosPhi0)];
	  };
	
	  return forward;
	}
	
	function conicEqualAreaRaw(y0, y1) {
	  var sy0 = sin(y0), n = (sy0 + sin(y1)) / 2;
	
	  // Are the parallels symmetrical around the Equator?
	  if (abs(n) < epsilon) return cylindricalEqualAreaRaw(y0);
	
	  var c = 1 + sy0 * (2 * n - sy0), r0 = sqrt(c) / n;
	
	  function project(x, y) {
	    var r = sqrt(c - 2 * n * sin(y)) / n;
	    return [r * sin(x *= n), r0 - r * cos(x)];
	  }
	
	  project.invert = function(x, y) {
	    var r0y = r0 - y;
	    return [atan2(x, abs(r0y)) / n * sign(r0y), asin((c - (x * x + r0y * r0y) * n * n) / (2 * n))];
	  };
	
	  return project;
	}
	
	var conicEqualArea = function() {
	  return conicProjection(conicEqualAreaRaw)
	      .scale(155.424)
	      .center([0, 33.6442]);
	};
	
	var albers = function() {
	  return conicEqualArea()
	      .parallels([29.5, 45.5])
	      .scale(1070)
	      .translate([480, 250])
	      .rotate([96, 0])
	      .center([-0.6, 38.7]);
	};
	
	// The projections must have mutually exclusive clip regions on the sphere,
	// as this will avoid emitting interleaving lines and polygons.
	function multiplex(streams) {
	  var n = streams.length;
	  return {
	    point: function(x, y) { var i = -1; while (++i < n) streams[i].point(x, y); },
	    sphere: function() { var i = -1; while (++i < n) streams[i].sphere(); },
	    lineStart: function() { var i = -1; while (++i < n) streams[i].lineStart(); },
	    lineEnd: function() { var i = -1; while (++i < n) streams[i].lineEnd(); },
	    polygonStart: function() { var i = -1; while (++i < n) streams[i].polygonStart(); },
	    polygonEnd: function() { var i = -1; while (++i < n) streams[i].polygonEnd(); }
	  };
	}
	
	// A composite projection for the United States, configured by default for
	// 960×500. The projection also works quite well at 960×600 if you change the
	// scale to 1285 and adjust the translate accordingly. The set of standard
	// parallels for each region comes from USGS, which is published here:
	// http://egsc.usgs.gov/isb/pubs/MapProjections/projections.html#albers
	var albersUsa = function() {
	  var cache,
	      cacheStream,
	      lower48 = albers(), lower48Point,
	      alaska = conicEqualArea().rotate([154, 0]).center([-2, 58.5]).parallels([55, 65]), alaskaPoint, // EPSG:3338
	      hawaii = conicEqualArea().rotate([157, 0]).center([-3, 19.9]).parallels([8, 18]), hawaiiPoint, // ESRI:102007
	      point, pointStream = {point: function(x, y) { point = [x, y]; }};
	
	  function albersUsa(coordinates) {
	    var x = coordinates[0], y = coordinates[1];
	    return point = null,
	        (lower48Point.point(x, y), point)
	        || (alaskaPoint.point(x, y), point)
	        || (hawaiiPoint.point(x, y), point);
	  }
	
	  albersUsa.invert = function(coordinates) {
	    var k = lower48.scale(),
	        t = lower48.translate(),
	        x = (coordinates[0] - t[0]) / k,
	        y = (coordinates[1] - t[1]) / k;
	    return (y >= 0.120 && y < 0.234 && x >= -0.425 && x < -0.214 ? alaska
	        : y >= 0.166 && y < 0.234 && x >= -0.214 && x < -0.115 ? hawaii
	        : lower48).invert(coordinates);
	  };
	
	  albersUsa.stream = function(stream) {
	    return cache && cacheStream === stream ? cache : cache = multiplex([lower48.stream(cacheStream = stream), alaska.stream(stream), hawaii.stream(stream)]);
	  };
	
	  albersUsa.precision = function(_) {
	    if (!arguments.length) return lower48.precision();
	    lower48.precision(_), alaska.precision(_), hawaii.precision(_);
	    return reset();
	  };
	
	  albersUsa.scale = function(_) {
	    if (!arguments.length) return lower48.scale();
	    lower48.scale(_), alaska.scale(_ * 0.35), hawaii.scale(_);
	    return albersUsa.translate(lower48.translate());
	  };
	
	  albersUsa.translate = function(_) {
	    if (!arguments.length) return lower48.translate();
	    var k = lower48.scale(), x = +_[0], y = +_[1];
	
	    lower48Point = lower48
	        .translate(_)
	        .clipExtent([[x - 0.455 * k, y - 0.238 * k], [x + 0.455 * k, y + 0.238 * k]])
	        .stream(pointStream);
	
	    alaskaPoint = alaska
	        .translate([x - 0.307 * k, y + 0.201 * k])
	        .clipExtent([[x - 0.425 * k + epsilon, y + 0.120 * k + epsilon], [x - 0.214 * k - epsilon, y + 0.234 * k - epsilon]])
	        .stream(pointStream);
	
	    hawaiiPoint = hawaii
	        .translate([x - 0.205 * k, y + 0.212 * k])
	        .clipExtent([[x - 0.214 * k + epsilon, y + 0.166 * k + epsilon], [x - 0.115 * k - epsilon, y + 0.234 * k - epsilon]])
	        .stream(pointStream);
	
	    return reset();
	  };
	
	  albersUsa.fitExtent = function(extent, object) {
	    return fitExtent(albersUsa, extent, object);
	  };
	
	  albersUsa.fitSize = function(size, object) {
	    return fitSize(albersUsa, size, object);
	  };
	
	  function reset() {
	    cache = cacheStream = null;
	    return albersUsa;
	  }
	
	  return albersUsa.scale(1070);
	};
	
	function azimuthalRaw(scale) {
	  return function(x, y) {
	    var cx = cos(x),
	        cy = cos(y),
	        k = scale(cx * cy);
	    return [
	      k * cy * sin(x),
	      k * sin(y)
	    ];
	  }
	}
	
	function azimuthalInvert(angle) {
	  return function(x, y) {
	    var z = sqrt(x * x + y * y),
	        c = angle(z),
	        sc = sin(c),
	        cc = cos(c);
	    return [
	      atan2(x * sc, z * cc),
	      asin(z && y * sc / z)
	    ];
	  }
	}
	
	var azimuthalEqualAreaRaw = azimuthalRaw(function(cxcy) {
	  return sqrt(2 / (1 + cxcy));
	});
	
	azimuthalEqualAreaRaw.invert = azimuthalInvert(function(z) {
	  return 2 * asin(z / 2);
	});
	
	var azimuthalEqualArea = function() {
	  return projection(azimuthalEqualAreaRaw)
	      .scale(124.75)
	      .clipAngle(180 - 1e-3);
	};
	
	var azimuthalEquidistantRaw = azimuthalRaw(function(c) {
	  return (c = acos(c)) && c / sin(c);
	});
	
	azimuthalEquidistantRaw.invert = azimuthalInvert(function(z) {
	  return z;
	});
	
	var azimuthalEquidistant = function() {
	  return projection(azimuthalEquidistantRaw)
	      .scale(79.4188)
	      .clipAngle(180 - 1e-3);
	};
	
	function mercatorRaw(lambda, phi) {
	  return [lambda, log(tan((halfPi + phi) / 2))];
	}
	
	mercatorRaw.invert = function(x, y) {
	  return [x, 2 * atan(exp(y)) - halfPi];
	};
	
	var mercator = function() {
	  return mercatorProjection(mercatorRaw)
	      .scale(961 / tau);
	};
	
	function mercatorProjection(project) {
	  var m = projection(project),
	      center = m.center,
	      scale = m.scale,
	      translate = m.translate,
	      clipExtent = m.clipExtent,
	      x0 = null, y0, x1, y1; // clip extent
	
	  m.scale = function(_) {
	    return arguments.length ? (scale(_), reclip()) : scale();
	  };
	
	  m.translate = function(_) {
	    return arguments.length ? (translate(_), reclip()) : translate();
	  };
	
	  m.center = function(_) {
	    return arguments.length ? (center(_), reclip()) : center();
	  };
	
	  m.clipExtent = function(_) {
	    return arguments.length ? ((_ == null ? x0 = y0 = x1 = y1 = null : (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1])), reclip()) : x0 == null ? null : [[x0, y0], [x1, y1]];
	  };
	
	  function reclip() {
	    var k = pi * scale(),
	        t = m(rotation(m.rotate()).invert([0, 0]));
	    return clipExtent(x0 == null
	        ? [[t[0] - k, t[1] - k], [t[0] + k, t[1] + k]] : project === mercatorRaw
	        ? [[Math.max(t[0] - k, x0), y0], [Math.min(t[0] + k, x1), y1]]
	        : [[x0, Math.max(t[1] - k, y0)], [x1, Math.min(t[1] + k, y1)]]);
	  }
	
	  return reclip();
	}
	
	function tany(y) {
	  return tan((halfPi + y) / 2);
	}
	
	function conicConformalRaw(y0, y1) {
	  var cy0 = cos(y0),
	      n = y0 === y1 ? sin(y0) : log(cy0 / cos(y1)) / log(tany(y1) / tany(y0)),
	      f = cy0 * pow(tany(y0), n) / n;
	
	  if (!n) return mercatorRaw;
	
	  function project(x, y) {
	    if (f > 0) { if (y < -halfPi + epsilon) y = -halfPi + epsilon; }
	    else { if (y > halfPi - epsilon) y = halfPi - epsilon; }
	    var r = f / pow(tany(y), n);
	    return [r * sin(n * x), f - r * cos(n * x)];
	  }
	
	  project.invert = function(x, y) {
	    var fy = f - y, r = sign(n) * sqrt(x * x + fy * fy);
	    return [atan2(x, abs(fy)) / n * sign(fy), 2 * atan(pow(f / r, 1 / n)) - halfPi];
	  };
	
	  return project;
	}
	
	var conicConformal = function() {
	  return conicProjection(conicConformalRaw)
	      .scale(109.5)
	      .parallels([30, 30]);
	};
	
	function equirectangularRaw(lambda, phi) {
	  return [lambda, phi];
	}
	
	equirectangularRaw.invert = equirectangularRaw;
	
	var equirectangular = function() {
	  return projection(equirectangularRaw)
	      .scale(152.63);
	};
	
	function conicEquidistantRaw(y0, y1) {
	  var cy0 = cos(y0),
	      n = y0 === y1 ? sin(y0) : (cy0 - cos(y1)) / (y1 - y0),
	      g = cy0 / n + y0;
	
	  if (abs(n) < epsilon) return equirectangularRaw;
	
	  function project(x, y) {
	    var gy = g - y, nx = n * x;
	    return [gy * sin(nx), g - gy * cos(nx)];
	  }
	
	  project.invert = function(x, y) {
	    var gy = g - y;
	    return [atan2(x, abs(gy)) / n * sign(gy), g - sign(n) * sqrt(x * x + gy * gy)];
	  };
	
	  return project;
	}
	
	var conicEquidistant = function() {
	  return conicProjection(conicEquidistantRaw)
	      .scale(131.154)
	      .center([0, 13.9389]);
	};
	
	function gnomonicRaw(x, y) {
	  var cy = cos(y), k = cos(x) * cy;
	  return [cy * sin(x) / k, sin(y) / k];
	}
	
	gnomonicRaw.invert = azimuthalInvert(atan);
	
	var gnomonic = function() {
	  return projection(gnomonicRaw)
	      .scale(144.049)
	      .clipAngle(60);
	};
	
	function scaleTranslate(kx, ky, tx, ty) {
	  return kx === 1 && ky === 1 && tx === 0 && ty === 0 ? identity : transformer({
	    point: function(x, y) {
	      this.stream.point(x * kx + tx, y * ky + ty);
	    }
	  });
	}
	
	var identity$1 = function() {
	  var k = 1, tx = 0, ty = 0, sx = 1, sy = 1, transform = identity, // scale, translate and reflect
	      x0 = null, y0, x1, y1, clip = identity, // clip extent
	      cache,
	      cacheStream,
	      projection;
	
	  function reset() {
	    cache = cacheStream = null;
	    return projection;
	  }
	
	  return projection = {
	    stream: function(stream) {
	      return cache && cacheStream === stream ? cache : cache = transform(clip(cacheStream = stream));
	    },
	    clipExtent: function(_) {
	      return arguments.length ? (clip = _ == null ? (x0 = y0 = x1 = y1 = null, identity) : clipExtent(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [[x0, y0], [x1, y1]];
	    },
	    scale: function(_) {
	      return arguments.length ? (transform = scaleTranslate((k = +_) * sx, k * sy, tx, ty), reset()) : k;
	    },
	    translate: function(_) {
	      return arguments.length ? (transform = scaleTranslate(k * sx, k * sy, tx = +_[0], ty = +_[1]), reset()) : [tx, ty];
	    },
	    reflectX: function(_) {
	      return arguments.length ? (transform = scaleTranslate(k * (sx = _ ? -1 : 1), k * sy, tx, ty), reset()) : sx < 0;
	    },
	    reflectY: function(_) {
	      return arguments.length ? (transform = scaleTranslate(k * sx, k * (sy = _ ? -1 : 1), tx, ty), reset()) : sy < 0;
	    },
	    fitExtent: function(extent, object) {
	      return fitExtent(projection, extent, object);
	    },
	    fitSize: function(size, object) {
	      return fitSize(projection, size, object);
	    }
	  };
	};
	
	function orthographicRaw(x, y) {
	  return [cos(y) * sin(x), sin(y)];
	}
	
	orthographicRaw.invert = azimuthalInvert(asin);
	
	var orthographic = function() {
	  return projection(orthographicRaw)
	      .scale(249.5)
	      .clipAngle(90 + epsilon);
	};
	
	function stereographicRaw(x, y) {
	  var cy = cos(y), k = 1 + cos(x) * cy;
	  return [cy * sin(x) / k, sin(y) / k];
	}
	
	stereographicRaw.invert = azimuthalInvert(function(z) {
	  return 2 * atan(z);
	});
	
	var stereographic = function() {
	  return projection(stereographicRaw)
	      .scale(250)
	      .clipAngle(142);
	};
	
	function transverseMercatorRaw(lambda, phi) {
	  return [log(tan((halfPi + phi) / 2)), -lambda];
	}
	
	transverseMercatorRaw.invert = function(x, y) {
	  return [-y, 2 * atan(exp(x)) - halfPi];
	};
	
	var transverseMercator = function() {
	  var m = mercatorProjection(transverseMercatorRaw),
	      center = m.center,
	      rotate = m.rotate;
	
	  m.center = function(_) {
	    return arguments.length ? center([-_[1], _[0]]) : (_ = center(), [_[1], -_[0]]);
	  };
	
	  m.rotate = function(_) {
	    return arguments.length ? rotate([_[0], _[1], _.length > 2 ? _[2] + 90 : 90]) : (_ = rotate(), [_[0], _[1], _[2] - 90]);
	  };
	
	  return rotate([0, 0, 90])
	      .scale(159.155);
	};
	
	exports.geoArea = area;
	exports.geoBounds = bounds;
	exports.geoCentroid = centroid;
	exports.geoCircle = circle;
	exports.geoClipExtent = extent;
	exports.geoContains = contains;
	exports.geoDistance = distance;
	exports.geoGraticule = graticule;
	exports.geoGraticule10 = graticule10;
	exports.geoInterpolate = interpolate;
	exports.geoLength = length;
	exports.geoPath = index;
	exports.geoAlbers = albers;
	exports.geoAlbersUsa = albersUsa;
	exports.geoAzimuthalEqualArea = azimuthalEqualArea;
	exports.geoAzimuthalEqualAreaRaw = azimuthalEqualAreaRaw;
	exports.geoAzimuthalEquidistant = azimuthalEquidistant;
	exports.geoAzimuthalEquidistantRaw = azimuthalEquidistantRaw;
	exports.geoConicConformal = conicConformal;
	exports.geoConicConformalRaw = conicConformalRaw;
	exports.geoConicEqualArea = conicEqualArea;
	exports.geoConicEqualAreaRaw = conicEqualAreaRaw;
	exports.geoConicEquidistant = conicEquidistant;
	exports.geoConicEquidistantRaw = conicEquidistantRaw;
	exports.geoEquirectangular = equirectangular;
	exports.geoEquirectangularRaw = equirectangularRaw;
	exports.geoGnomonic = gnomonic;
	exports.geoGnomonicRaw = gnomonicRaw;
	exports.geoIdentity = identity$1;
	exports.geoProjection = projection;
	exports.geoProjectionMutator = projectionMutator;
	exports.geoMercator = mercator;
	exports.geoMercatorRaw = mercatorRaw;
	exports.geoOrthographic = orthographic;
	exports.geoOrthographicRaw = orthographicRaw;
	exports.geoStereographic = stereographic;
	exports.geoStereographicRaw = stereographicRaw;
	exports.geoTransverseMercator = transverseMercator;
	exports.geoTransverseMercatorRaw = transverseMercatorRaw;
	exports.geoRotation = rotation;
	exports.geoStream = geoStream;
	exports.geoTransform = transform;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 54 */
/***/ (function(module, exports) {

	
	'use strict';
	
	
	var encodeCache = {};
	
	
	// Create a lookup array where anything but characters in `chars` string
	// and alphanumeric chars is percent-encoded.
	//
	function getEncodeCache(exclude) {
	  var i, ch, cache = encodeCache[exclude];
	  if (cache) { return cache; }
	
	  cache = encodeCache[exclude] = [];
	
	  for (i = 0; i < 128; i++) {
	    ch = String.fromCharCode(i);
	
	    if (/^[0-9a-z]$/i.test(ch)) {
	      // always allow unencoded alphanumeric characters
	      cache.push(ch);
	    } else {
	      cache.push('%' + ('0' + i.toString(16).toUpperCase()).slice(-2));
	    }
	  }
	
	  for (i = 0; i < exclude.length; i++) {
	    cache[exclude.charCodeAt(i)] = exclude[i];
	  }
	
	  return cache;
	}
	
	
	// Encode unsafe characters with percent-encoding, skipping already
	// encoded sequences.
	//
	//  - string       - string to encode
	//  - exclude      - list of characters to ignore (in addition to a-zA-Z0-9)
	//  - keepEscaped  - don't encode '%' in a correct escape sequence (default: true)
	//
	function encode(string, exclude, keepEscaped) {
	  var i, l, code, nextCode, cache,
	      result = '';
	
	  if (typeof exclude !== 'string') {
	    // encode(string, keepEscaped)
	    keepEscaped  = exclude;
	    exclude = encode.defaultChars;
	  }
	
	  if (typeof keepEscaped === 'undefined') {
	    keepEscaped = true;
	  }
	
	  cache = getEncodeCache(exclude);
	
	  for (i = 0, l = string.length; i < l; i++) {
	    code = string.charCodeAt(i);
	
	    if (keepEscaped && code === 0x25 /* % */ && i + 2 < l) {
	      if (/^[0-9a-f]{2}$/i.test(string.slice(i + 1, i + 3))) {
	        result += string.slice(i, i + 3);
	        i += 2;
	        continue;
	      }
	    }
	
	    if (code < 128) {
	      result += cache[code];
	      continue;
	    }
	
	    if (code >= 0xD800 && code <= 0xDFFF) {
	      if (code >= 0xD800 && code <= 0xDBFF && i + 1 < l) {
	        nextCode = string.charCodeAt(i + 1);
	        if (nextCode >= 0xDC00 && nextCode <= 0xDFFF) {
	          result += encodeURIComponent(string[i] + string[i + 1]);
	          i++;
	          continue;
	        }
	      }
	      result += '%EF%BF%BD';
	      continue;
	    }
	
	    result += encodeURIComponent(string[i]);
	  }
	
	  return result;
	}
	
	encode.defaultChars   = ";/?:@&=+$,-_.!~*'()#";
	encode.componentChars = "-_.!~*'()";
	
	
	module.exports = encode;


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var characterEntities = __webpack_require__(302)
	var legacy = __webpack_require__(129)
	var invalid = __webpack_require__(303)
	var decimal = __webpack_require__(40)
	var hexadecimal = __webpack_require__(128)
	var alphanumerical = __webpack_require__(127)
	
	module.exports = parseEntities
	
	var own = {}.hasOwnProperty
	var fromCharCode = String.fromCharCode
	var noop = Function.prototype
	
	/* Default settings. */
	var defaults = {
	  warning: null,
	  reference: null,
	  text: null,
	  warningContext: null,
	  referenceContext: null,
	  textContext: null,
	  position: {},
	  additional: null,
	  attribute: false,
	  nonTerminated: true
	}
	
	/* Reference types. */
	var NAMED = 'named'
	var HEXADECIMAL = 'hexadecimal'
	var DECIMAL = 'decimal'
	
	/* Map of bases. */
	var BASE = {}
	
	BASE[HEXADECIMAL] = 16
	BASE[DECIMAL] = 10
	
	/* Map of types to tests. Each type of character reference
	 * accepts different characters. This test is used to
	 * detect whether a reference has ended (as the semicolon
	 * is not strictly needed). */
	var TESTS = {}
	
	TESTS[NAMED] = alphanumerical
	TESTS[DECIMAL] = decimal
	TESTS[HEXADECIMAL] = hexadecimal
	
	/* Warning messages. */
	var NAMED_NOT_TERMINATED = 1
	var NUMERIC_NOT_TERMINATED = 2
	var NAMED_EMPTY = 3
	var NUMERIC_EMPTY = 4
	var NAMED_UNKNOWN = 5
	var NUMERIC_DISALLOWED = 6
	var NUMERIC_PROHIBITED = 7
	
	var MESSAGES = {}
	
	MESSAGES[NAMED_NOT_TERMINATED] =
	  'Named character references must be terminated by a semicolon'
	MESSAGES[NUMERIC_NOT_TERMINATED] =
	  'Numeric character references must be terminated by a semicolon'
	MESSAGES[NAMED_EMPTY] = 'Named character references cannot be empty'
	MESSAGES[NUMERIC_EMPTY] = 'Numeric character references cannot be empty'
	MESSAGES[NAMED_UNKNOWN] = 'Named character references must be known'
	MESSAGES[NUMERIC_DISALLOWED] =
	  'Numeric character references cannot be disallowed'
	MESSAGES[NUMERIC_PROHIBITED] =
	  'Numeric character references cannot be outside the permissible Unicode range'
	
	/* Wrap to ensure clean parameters are given to `parse`. */
	function parseEntities(value, options) {
	  var settings = {}
	  var option
	  var key
	
	  if (!options) {
	    options = {}
	  }
	
	  for (key in defaults) {
	    option = options[key]
	    settings[key] =
	      option === null || option === undefined ? defaults[key] : option
	  }
	
	  if (settings.position.indent || settings.position.start) {
	    settings.indent = settings.position.indent || []
	    settings.position = settings.position.start
	  }
	
	  return parse(value, settings)
	}
	
	/* Parse entities. */
	function parse(value, settings) {
	  var additional = settings.additional
	  var nonTerminated = settings.nonTerminated
	  var handleText = settings.text
	  var handleReference = settings.reference
	  var handleWarning = settings.warning
	  var textContext = settings.textContext
	  var referenceContext = settings.referenceContext
	  var warningContext = settings.warningContext
	  var pos = settings.position
	  var indent = settings.indent || []
	  var length = value.length
	  var index = 0
	  var lines = -1
	  var column = pos.column || 1
	  var line = pos.line || 1
	  var queue = ''
	  var result = []
	  var entityCharacters
	  var terminated
	  var characters
	  var character
	  var reference
	  var following
	  var warning
	  var reason
	  var output
	  var entity
	  var begin
	  var start
	  var type
	  var test
	  var prev
	  var next
	  var diff
	  var end
	
	  /* Cache the current point. */
	  prev = now()
	
	  /* Wrap `handleWarning`. */
	  warning = handleWarning ? parseError : noop
	
	  /* Ensure the algorithm walks over the first character
	   * and the end (inclusive). */
	  index--
	  length++
	
	  while (++index < length) {
	    /* If the previous character was a newline. */
	    if (character === '\n') {
	      column = indent[lines] || 1
	    }
	
	    character = at(index)
	
	    /* Handle anything other than an ampersand,
	     * including newlines and EOF. */
	    if (character !== '&') {
	      if (character === '\n') {
	        line++
	        lines++
	        column = 0
	      }
	
	      if (character) {
	        queue += character
	        column++
	      } else {
	        flush()
	      }
	    } else {
	      following = at(index + 1)
	
	      /* The behaviour depends on the identity of the next
	       * character. */
	      if (
	        following === '\t' /* Tab */ ||
	        following === '\n' /* Newline */ ||
	        following === '\f' /* Form feed */ ||
	        following === ' ' /* Space */ ||
	        following === '<' /* Less-than */ ||
	        following === '&' /* Ampersand */ ||
	        following === '' ||
	        (additional && following === additional)
	      ) {
	        /* Not a character reference. No characters
	         * are consumed, and nothing is returned.
	         * This is not an error, either. */
	        queue += character
	        column++
	
	        continue
	      }
	
	      start = index + 1
	      begin = start
	      end = start
	
	      /* Numerical entity. */
	      if (following !== '#') {
	        type = NAMED
	      } else {
	        end = ++begin
	
	        /* The behaviour further depends on the
	         * character after the U+0023 NUMBER SIGN. */
	        following = at(end)
	
	        if (following === 'x' || following === 'X') {
	          /* ASCII hex digits. */
	          type = HEXADECIMAL
	          end = ++begin
	        } else {
	          /* ASCII digits. */
	          type = DECIMAL
	        }
	      }
	
	      entityCharacters = ''
	      entity = ''
	      characters = ''
	      test = TESTS[type]
	      end--
	
	      while (++end < length) {
	        following = at(end)
	
	        if (!test(following)) {
	          break
	        }
	
	        characters += following
	
	        /* Check if we can match a legacy named
	         * reference.  If so, we cache that as the
	         * last viable named reference.  This
	         * ensures we do not need to walk backwards
	         * later. */
	        if (type === NAMED && own.call(legacy, characters)) {
	          entityCharacters = characters
	          entity = legacy[characters]
	        }
	      }
	
	      terminated = at(end) === ';'
	
	      if (terminated) {
	        end++
	
	        if (type === NAMED && own.call(characterEntities, characters)) {
	          entityCharacters = characters
	          entity = characterEntities[characters]
	        }
	      }
	
	      diff = 1 + end - start
	
	      if (!terminated && !nonTerminated) {
	        /* Empty. */
	      } else if (!characters) {
	        /* An empty (possible) entity is valid, unless
	         * its numeric (thus an ampersand followed by
	         * an octothorp). */
	        if (type !== NAMED) {
	          warning(NUMERIC_EMPTY, diff)
	        }
	      } else if (type === NAMED) {
	        /* An ampersand followed by anything
	         * unknown, and not terminated, is invalid. */
	        if (terminated && !entity) {
	          warning(NAMED_UNKNOWN, 1)
	        } else {
	          /* If theres something after an entity
	           * name which is not known, cap the
	           * reference. */
	          if (entityCharacters !== characters) {
	            end = begin + entityCharacters.length
	            diff = 1 + end - begin
	            terminated = false
	          }
	
	          /* If the reference is not terminated,
	           * warn. */
	          if (!terminated) {
	            reason = entityCharacters ? NAMED_NOT_TERMINATED : NAMED_EMPTY
	
	            if (!settings.attribute) {
	              warning(reason, diff)
	            } else {
	              following = at(end)
	
	              if (following === '=') {
	                warning(reason, diff)
	                entity = null
	              } else if (alphanumerical(following)) {
	                entity = null
	              } else {
	                warning(reason, diff)
	              }
	            }
	          }
	        }
	
	        reference = entity
	      } else {
	        if (!terminated) {
	          /* All non-terminated numeric entities are
	           * not rendered, and trigger a warning. */
	          warning(NUMERIC_NOT_TERMINATED, diff)
	        }
	
	        /* When terminated and number, parse as
	         * either hexadecimal or decimal. */
	        reference = parseInt(characters, BASE[type])
	
	        /* Trigger a warning when the parsed number
	         * is prohibited, and replace with
	         * replacement character. */
	        if (prohibited(reference)) {
	          warning(NUMERIC_PROHIBITED, diff)
	          reference = '\uFFFD'
	        } else if (reference in invalid) {
	          /* Trigger a warning when the parsed number
	           * is disallowed, and replace by an
	           * alternative. */
	          warning(NUMERIC_DISALLOWED, diff)
	          reference = invalid[reference]
	        } else {
	          /* Parse the number. */
	          output = ''
	
	          /* Trigger a warning when the parsed
	           * number should not be used. */
	          if (disallowed(reference)) {
	            warning(NUMERIC_DISALLOWED, diff)
	          }
	
	          /* Stringify the number. */
	          if (reference > 0xffff) {
	            reference -= 0x10000
	            output += fromCharCode((reference >>> (10 & 0x3ff)) | 0xd800)
	            reference = 0xdc00 | (reference & 0x3ff)
	          }
	
	          reference = output + fromCharCode(reference)
	        }
	      }
	
	      /* If we could not find a reference, queue the
	       * checked characters (as normal characters),
	       * and move the pointer to their end. This is
	       * possible because we can be certain neither
	       * newlines nor ampersands are included. */
	      if (!reference) {
	        characters = value.slice(start - 1, end)
	        queue += characters
	        column += characters.length
	        index = end - 1
	      } else {
	        /* Found it! First eat the queued
	         * characters as normal text, then eat
	         * an entity. */
	        flush()
	
	        prev = now()
	        index = end - 1
	        column += end - start + 1
	        result.push(reference)
	        next = now()
	        next.offset++
	
	        if (handleReference) {
	          handleReference.call(
	            referenceContext,
	            reference,
	            {start: prev, end: next},
	            value.slice(start - 1, end)
	          )
	        }
	
	        prev = next
	      }
	    }
	  }
	
	  /* Return the reduced nodes, and any possible warnings. */
	  return result.join('')
	
	  /* Get current position. */
	  function now() {
	    return {
	      line: line,
	      column: column,
	      offset: index + (pos.offset || 0)
	    }
	  }
	
	  /* “Throw” a parse-error: a warning. */
	  function parseError(code, offset) {
	    var position = now()
	
	    position.column += offset
	    position.offset += offset
	
	    handleWarning.call(warningContext, MESSAGES[code], position, code)
	  }
	
	  /* Get character at position. */
	  function at(position) {
	    return value.charAt(position)
	  }
	
	  /* Flush `queue` (normal text). Macro invoked before
	   * each entity and at the end of `value`.
	   * Does nothing when `queue` is empty. */
	  function flush() {
	    if (queue) {
	      result.push(queue)
	
	      if (handleText) {
	        handleText.call(textContext, queue, {start: prev, end: now()})
	      }
	
	      queue = ''
	    }
	  }
	}
	
	/* Check if `character` is outside the permissible unicode range. */
	function prohibited(code) {
	  return (code >= 0xd800 && code <= 0xdfff) || code > 0x10ffff
	}
	
	/* Check if `character` is disallowed. */
	function disallowed(code) {
	  return (
	    (code >= 0x0001 && code <= 0x0008) ||
	    code === 0x000b ||
	    (code >= 0x000d && code <= 0x001f) ||
	    (code >= 0x007f && code <= 0x009f) ||
	    (code >= 0xfdd0 && code <= 0xfdef) ||
	    (code & 0xffff) === 0xffff ||
	    (code & 0xffff) === 0xfffe
	  )
	}


/***/ }),
/* 56 */
/***/ (function(module, exports) {

	'use strict'
	
	/* eslint-disable max-params */
	
	/* Expose. */
	module.exports = is
	
	/* Assert if `test` passes for `node`.
	 * When a `parent` node is known the `index` of node */
	function is(test, node, index, parent, context) {
	  var hasParent = parent !== null && parent !== undefined
	  var hasIndex = index !== null && index !== undefined
	  var check = convert(test)
	
	  if (
	    hasIndex &&
	    (typeof index !== 'number' || index < 0 || index === Infinity)
	  ) {
	    throw new Error('Expected positive finite index or child node')
	  }
	
	  if (hasParent && (!is(null, parent) || !parent.children)) {
	    throw new Error('Expected parent node')
	  }
	
	  if (!node || !node.type || typeof node.type !== 'string') {
	    return false
	  }
	
	  if (hasParent !== hasIndex) {
	    throw new Error('Expected both parent and index')
	  }
	
	  return Boolean(check.call(context, node, index, parent))
	}
	
	function convert(test) {
	  if (typeof test === 'string') {
	    return typeFactory(test)
	  }
	
	  if (test === null || test === undefined) {
	    return ok
	  }
	
	  if (typeof test === 'object') {
	    return ('length' in test ? anyFactory : matchesFactory)(test)
	  }
	
	  if (typeof test === 'function') {
	    return test
	  }
	
	  throw new Error('Expected function, string, or object as test')
	}
	
	function convertAll(tests) {
	  var results = []
	  var length = tests.length
	  var index = -1
	
	  while (++index < length) {
	    results[index] = convert(tests[index])
	  }
	
	  return results
	}
	
	/* Utility assert each property in `test` is represented
	 * in `node`, and each values are strictly equal. */
	function matchesFactory(test) {
	  return matches
	
	  function matches(node) {
	    var key
	
	    for (key in test) {
	      if (node[key] !== test[key]) {
	        return false
	      }
	    }
	
	    return true
	  }
	}
	
	function anyFactory(tests) {
	  var checks = convertAll(tests)
	  var length = checks.length
	
	  return matches
	
	  function matches() {
	    var index = -1
	
	    while (++index < length) {
	      if (checks[index].apply(this, arguments)) {
	        return true
	      }
	    }
	
	    return false
	  }
	}
	
	/* Utility to convert a string into a function which checks
	 * a given node’s type for said string. */
	function typeFactory(test) {
	  return type
	
	  function type(node) {
	    return Boolean(node && node.type === test)
	  }
	}
	
	/* Utility to return true. */
	function ok() {
	  return true
	}


/***/ }),
/* 57 */,
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _parseToRgb = /*#__PURE__*/__webpack_require__(15);
	
	var _parseToRgb2 = /*#__PURE__*/_interopRequireDefault(_parseToRgb);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Returns a number (float) representing the luminance of a color.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: getLuminance('#CCCD64') >= getLuminance('#0000ff') ? '#CCCD64' : '#0000ff',
	 *   background: getLuminance('rgba(58, 133, 255, 1)') >= getLuminance('rgba(255, 57, 149, 1)') ?
	 *                             'rgba(58, 133, 255, 1)' :
	 *                             'rgba(255, 57, 149, 1)',
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${getLuminance('#CCCD64') >= getLuminance('#0000ff') ? '#CCCD64' : '#0000ff'};
	 *   background: ${getLuminance('rgba(58, 133, 255, 1)') >= getLuminance('rgba(255, 57, 149, 1)') ?
	 *                             'rgba(58, 133, 255, 1)' :
	 *                             'rgba(255, 57, 149, 1)'};
	 *
	 * // CSS in JS Output
	 *
	 * div {
	 *   background: "#CCCD64";
	 *   background: "rgba(58, 133, 255, 1)";
	 * }
	 */
	function getLuminance(color) {
	  var rgbColor = (0, _parseToRgb2.default)(color);
	
	  var _Object$keys$map = Object.keys(rgbColor).map(function (key) {
	    var channel = rgbColor[key] / 255;
	    return channel <= 0.03928 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
	  }),
	      r = _Object$keys$map[0],
	      g = _Object$keys$map[1],
	      b = _Object$keys$map[2];
	
	  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
	}
	exports.default = getLuminance;
	module.exports = exports['default'];

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _hslToHex = /*#__PURE__*/__webpack_require__(62);
	
	var _hslToHex2 = /*#__PURE__*/_interopRequireDefault(_hslToHex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Returns a string value for the color. The returned result is the smallest possible hex notation.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: hsl(359, 0.75, 0.4),
	 *   background: hsl({ hue: 360, saturation: 0.75, lightness: 0.4 }),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${hsl(359, 0.75, 0.4)};
	 *   background: ${hsl({ hue: 360, saturation: 0.75, lightness: 0.4 })};
	 * `
	 *
	 * // CSS in JS Output
	 *
	 * element {
	 *   background: "#b3191c";
	 *   background: "#b3191c";
	 * }
	 */
	function hsl(value, saturation, lightness) {
	  if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number') {
	    return (0, _hslToHex2.default)(value, saturation, lightness);
	  } else if (typeof value === 'object' && saturation === undefined && lightness === undefined) {
	    return (0, _hslToHex2.default)(value.hue, value.saturation, value.lightness);
	  }
	
	  throw new Error('Passed invalid arguments to hsl, please pass multiple numbers e.g. hsl(360, 0.75, 0.4) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75 }).');
	}
	
	exports.default = hsl;
	module.exports = exports['default'];

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _hslToHex = /*#__PURE__*/__webpack_require__(62);
	
	var _hslToHex2 = /*#__PURE__*/_interopRequireDefault(_hslToHex);
	
	var _hslToRgb = /*#__PURE__*/__webpack_require__(44);
	
	var _hslToRgb2 = /*#__PURE__*/_interopRequireDefault(_hslToRgb);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: hsla(359, 0.75, 0.4, 0.7),
	 *   background: hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 }),
	 *   background: hsla(359, 0.75, 0.4, 1),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${hsla(359, 0.75, 0.4, 0.7)};
	 *   background: ${hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 })};
	 *   background: ${hsla(359, 0.75, 0.4, 1)};
	 * `
	 *
	 * // CSS in JS Output
	 *
	 * element {
	 *   background: "rgba(179,25,28,0.7)";
	 *   background: "rgba(179,25,28,0.7)";
	 *   background: "#b3191c";
	 * }
	 */
	function hsla(value, saturation, lightness, alpha) {
	  if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number' && typeof alpha === 'number') {
	    return alpha >= 1 ? (0, _hslToHex2.default)(value, saturation, lightness) : 'rgba(' + (0, _hslToRgb2.default)(value, saturation, lightness) + ',' + alpha + ')';
	  } else if (typeof value === 'object' && saturation === undefined && lightness === undefined && alpha === undefined) {
	    return value.alpha >= 1 ? (0, _hslToHex2.default)(value.hue, value.saturation, value.lightness) : 'rgba(' + (0, _hslToRgb2.default)(value.hue, value.saturation, value.lightness) + ',' + value.alpha + ')';
	  }
	
	  throw new Error('Passed invalid arguments to hsla, please pass multiple numbers e.g. hsl(360, 0.75, 0.4, 0.7) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75, alpha: 0.7 }).');
	}
	
	exports.default = hsla;
	module.exports = exports['default'];

/***/ }),
/* 61 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	// @private
	function capitalizeString(string) {
	  return string.charAt(0).toUpperCase() + string.slice(1);
	}
	
	exports.default = capitalizeString;
	module.exports = exports["default"];

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _hslToRgb = /*#__PURE__*/__webpack_require__(44);
	
	var _hslToRgb2 = /*#__PURE__*/_interopRequireDefault(_hslToRgb);
	
	var _reduceHexValue = /*#__PURE__*/__webpack_require__(65);
	
	var _reduceHexValue2 = /*#__PURE__*/_interopRequireDefault(_reduceHexValue);
	
	var _numberToHex = /*#__PURE__*/__webpack_require__(63);
	
	var _numberToHex2 = /*#__PURE__*/_interopRequireDefault(_numberToHex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function colorToHex(color) {
	  return (0, _numberToHex2.default)(Math.round(color * 255));
	}
	
	
	function convertToHex(red, green, blue) {
	  return (0, _reduceHexValue2.default)('#' + colorToHex(red) + colorToHex(green) + colorToHex(blue));
	}
	
	function hslToHex(hue, saturation, lightness) {
	  return (0, _hslToRgb2.default)(hue, saturation, lightness, convertToHex);
	}
	
	exports.default = hslToHex;
	module.exports = exports['default'];

/***/ }),
/* 63 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function numberToHex(value) {
	  var hex = value.toString(16);
	  return hex.length === 1 ? "0" + hex : hex;
	}
	
	exports.default = numberToHex;
	module.exports = exports["default"];

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _endsWith = /*#__PURE__*/__webpack_require__(152);
	
	var _endsWith2 = /*#__PURE__*/_interopRequireDefault(_endsWith);
	
	var _stripUnit = /*#__PURE__*/__webpack_require__(43);
	
	var _stripUnit2 = /*#__PURE__*/_interopRequireDefault(_stripUnit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Factory function that creates pixel-to-x converters
	 * @private
	 */
	var pxtoFactory = function pxtoFactory(to) {
	  return function (pxval) {
	    var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '16px';
	
	    var newPxval = pxval;
	    var newBase = base;
	    if (typeof pxval === 'string') {
	      if (!(0, _endsWith2.default)(pxval, 'px')) {
	        throw new Error('Expected a string ending in "px" or a number passed as the first argument to ' + to + '(), got "' + pxval + '" instead.');
	      }
	      newPxval = (0, _stripUnit2.default)(pxval);
	    }
	
	    if (typeof base === 'string') {
	      if (!(0, _endsWith2.default)(base, 'px')) {
	        throw new Error('Expected a string ending in "px" or a number passed as the second argument to ' + to + '(), got "' + base + '" instead.');
	      }
	      newBase = (0, _stripUnit2.default)(base);
	    }
	
	    if (typeof newPxval === 'string') {
	      throw new Error('Passed invalid pixel value ("' + pxval + '") to ' + to + '(), please pass a value like "12px" or 12.');
	    }
	
	    if (typeof newBase === 'string') {
	      throw new Error('Passed invalid base value ("' + base + '") to ' + to + '(), please pass a value like "12px" or 12.');
	    }
	
	    return '' + newPxval / newBase + to;
	  };
	};
	
	exports.default = pxtoFactory;
	module.exports = exports['default'];

/***/ }),
/* 65 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	/**
	 * Reduces hex values if possible e.g. #ff8866 to #f86
	 * @private
	 */
	var reduceHexValue = function reduceHexValue(value) {
	  if (value.length === 7 && value[1] === value[2] && value[3] === value[4] && value[5] === value[6]) {
	    return "#" + value[1] + value[3] + value[5];
	  }
	  return value;
	};
	
	exports.default = reduceHexValue;
	module.exports = exports["default"];

/***/ }),
/* 66 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	function generateSelectors(template, state) {
	  var stateSuffix = state ? ':' + state : '';
	  return template(stateSuffix);
	}
	
	/**
	 * Function helper that adds an array of states to a template of selectors. Used in textInputs and buttons.
	 * @private
	 */
	
	function statefulSelectors(states, template, stateMap) {
	  if (!template) throw new Error('You must provide a template to this method.');
	  if (states.length === 0) return generateSelectors(template, null);
	  var selectors = [];
	  for (var i = 0; i < states.length; i += 1) {
	    if (stateMap && stateMap.indexOf(states[i]) < 0) {
	      throw new Error('You passed an unsupported selector state to this method.');
	    }
	    selectors.push(generateSelectors(template, states[i]));
	  }
	  selectors = selectors.join(',');
	  return selectors;
	}
	
	exports.default = statefulSelectors;
	module.exports = exports['default'];

/***/ }),
/* 67 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	/**
	 * Generates a media query to target HiDPI devices.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *  [hiDPI(1.5)]: {
	 *    width: 200px;
	 *  }
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   ${hiDPI(1.5)} {
	 *     width: 200px;
	 *   }
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * '@media only screen and (-webkit-min-device-pixel-ratio: 1.5),
	 *  only screen and (min--moz-device-pixel-ratio: 1.5),
	 *  only screen and (-o-min-device-pixel-ratio: 1.5/1),
	 *  only screen and (min-resolution: 144dpi),
	 *  only screen and (min-resolution: 1.5dppx)': {
	 *   'width': '200px',
	 * }
	 */
	
	function hiDPI() {
	  var ratio = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1.3;
	
	  return "\n    @media only screen and (-webkit-min-device-pixel-ratio: " + ratio + "),\n    only screen and (min--moz-device-pixel-ratio: " + ratio + "),\n    only screen and (-o-min-device-pixel-ratio: " + ratio + "/1),\n    only screen and (min-resolution: " + Math.round(ratio * 96) + "dpi),\n    only screen and (min-resolution: " + ratio + "dppx)\n  ";
	}
	
	exports.default = hiDPI;
	module.exports = exports["default"];

/***/ }),
/* 68 */
/***/ (function(module, exports) {

	'use strict';
	
	var replace = String.prototype.replace;
	var percentTwenties = /%20/g;
	
	module.exports = {
	    'default': 'RFC3986',
	    formatters: {
	        RFC1738: function (value) {
	            return replace.call(value, percentTwenties, '+');
	        },
	        RFC3986: function (value) {
	            return value;
	        }
	    },
	    RFC1738: 'RFC1738',
	    RFC3986: 'RFC3986'
	};


/***/ }),
/* 69 */
/***/ (function(module, exports) {

	'use strict';
	
	var has = Object.prototype.hasOwnProperty;
	
	var hexTable = (function () {
	    var array = [];
	    for (var i = 0; i < 256; ++i) {
	        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
	    }
	
	    return array;
	}());
	
	var compactQueue = function compactQueue(queue) {
	    var obj;
	
	    while (queue.length) {
	        var item = queue.pop();
	        obj = item.obj[item.prop];
	
	        if (Array.isArray(obj)) {
	            var compacted = [];
	
	            for (var j = 0; j < obj.length; ++j) {
	                if (typeof obj[j] !== 'undefined') {
	                    compacted.push(obj[j]);
	                }
	            }
	
	            item.obj[item.prop] = compacted;
	        }
	    }
	
	    return obj;
	};
	
	var arrayToObject = function arrayToObject(source, options) {
	    var obj = options && options.plainObjects ? Object.create(null) : {};
	    for (var i = 0; i < source.length; ++i) {
	        if (typeof source[i] !== 'undefined') {
	            obj[i] = source[i];
	        }
	    }
	
	    return obj;
	};
	
	var merge = function merge(target, source, options) {
	    if (!source) {
	        return target;
	    }
	
	    if (typeof source !== 'object') {
	        if (Array.isArray(target)) {
	            target.push(source);
	        } else if (typeof target === 'object') {
	            if (options.plainObjects || options.allowPrototypes || !has.call(Object.prototype, source)) {
	                target[source] = true;
	            }
	        } else {
	            return [target, source];
	        }
	
	        return target;
	    }
	
	    if (typeof target !== 'object') {
	        return [target].concat(source);
	    }
	
	    var mergeTarget = target;
	    if (Array.isArray(target) && !Array.isArray(source)) {
	        mergeTarget = arrayToObject(target, options);
	    }
	
	    if (Array.isArray(target) && Array.isArray(source)) {
	        source.forEach(function (item, i) {
	            if (has.call(target, i)) {
	                if (target[i] && typeof target[i] === 'object') {
	                    target[i] = merge(target[i], item, options);
	                } else {
	                    target.push(item);
	                }
	            } else {
	                target[i] = item;
	            }
	        });
	        return target;
	    }
	
	    return Object.keys(source).reduce(function (acc, key) {
	        var value = source[key];
	
	        if (has.call(acc, key)) {
	            acc[key] = merge(acc[key], value, options);
	        } else {
	            acc[key] = value;
	        }
	        return acc;
	    }, mergeTarget);
	};
	
	var assign = function assignSingleSource(target, source) {
	    return Object.keys(source).reduce(function (acc, key) {
	        acc[key] = source[key];
	        return acc;
	    }, target);
	};
	
	var decode = function (str) {
	    try {
	        return decodeURIComponent(str.replace(/\+/g, ' '));
	    } catch (e) {
	        return str;
	    }
	};
	
	var encode = function encode(str) {
	    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
	    // It has been adapted here for stricter adherence to RFC 3986
	    if (str.length === 0) {
	        return str;
	    }
	
	    var string = typeof str === 'string' ? str : String(str);
	
	    var out = '';
	    for (var i = 0; i < string.length; ++i) {
	        var c = string.charCodeAt(i);
	
	        if (
	            c === 0x2D // -
	            || c === 0x2E // .
	            || c === 0x5F // _
	            || c === 0x7E // ~
	            || (c >= 0x30 && c <= 0x39) // 0-9
	            || (c >= 0x41 && c <= 0x5A) // a-z
	            || (c >= 0x61 && c <= 0x7A) // A-Z
	        ) {
	            out += string.charAt(i);
	            continue;
	        }
	
	        if (c < 0x80) {
	            out = out + hexTable[c];
	            continue;
	        }
	
	        if (c < 0x800) {
	            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
	            continue;
	        }
	
	        if (c < 0xD800 || c >= 0xE000) {
	            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
	            continue;
	        }
	
	        i += 1;
	        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
	        out += hexTable[0xF0 | (c >> 18)]
	            + hexTable[0x80 | ((c >> 12) & 0x3F)]
	            + hexTable[0x80 | ((c >> 6) & 0x3F)]
	            + hexTable[0x80 | (c & 0x3F)];
	    }
	
	    return out;
	};
	
	var compact = function compact(value) {
	    var queue = [{ obj: { o: value }, prop: 'o' }];
	    var refs = [];
	
	    for (var i = 0; i < queue.length; ++i) {
	        var item = queue[i];
	        var obj = item.obj[item.prop];
	
	        var keys = Object.keys(obj);
	        for (var j = 0; j < keys.length; ++j) {
	            var key = keys[j];
	            var val = obj[key];
	            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
	                queue.push({ obj: obj, prop: key });
	                refs.push(val);
	            }
	        }
	    }
	
	    return compactQueue(queue);
	};
	
	var isRegExp = function isRegExp(obj) {
	    return Object.prototype.toString.call(obj) === '[object RegExp]';
	};
	
	var isBuffer = function isBuffer(obj) {
	    if (obj === null || typeof obj === 'undefined') {
	        return false;
	    }
	
	    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
	};
	
	module.exports = {
	    arrayToObject: arrayToObject,
	    assign: assign,
	    compact: compact,
	    decode: decode,
	    encode: encode,
	    isBuffer: isBuffer,
	    isRegExp: isRegExp,
	    merge: merge
	};


/***/ }),
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var whiteSpace = __webpack_require__(125);
	
	exports.before = siblings(-1);
	exports.after = siblings(1);
	
	/* Factory to check siblings in a direction. */
	function siblings(increment) {
	  return sibling;
	
	  /* Find applicable siblings in a direction.   */
	  function sibling(parent, index, includeWhiteSpace) {
	    var siblings = parent && parent.children;
	    var next;
	
	    index += increment;
	    next = siblings && siblings[index];
	
	    if (!includeWhiteSpace) {
	      while (next && whiteSpace(next)) {
	        index += increment;
	        next = siblings[index];
	      }
	    }
	
	    return next;
	  }
	}


/***/ }),
/* 81 */
/***/ (function(module, exports) {

	'use strict';
	
	/* Expose. */
	module.exports = toString;
	
	/* Get the text content of a node.  If the node itself
	 * does not expose plain-text fields, `toString` will
	 * recursivly try its children. */
	function toString(node) {
	  return valueOf(node) ||
	    (node.children && node.children.map(toString).join('')) ||
	    '';
	}
	
	/* Get the value of `node`.  Checks, `value`,
	 * `alt`, and `title`, in that order. */
	function valueOf(node) {
	  if (!node) {
	    return '';
	  }
	  return node.value ? node.value : (node.alt ? node.alt : node.title) || '';
	}


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var irregularPlurals = __webpack_require__(306);
	
	module.exports = function (str, plural, count) {
		if (typeof plural === 'number') {
			count = plural;
		}
	
		if (str in irregularPlurals) {
			plural = irregularPlurals[str];
		} else if (typeof plural !== 'string') {
			plural = (str.replace(/(?:s|x|z|ch|sh)$/i, '$&e').replace(/([^aeiou])y$/i, '$1ie') + 's')
				.replace(/i?e?s$/i, function (m) {
					var isTailLowerCase = str.slice(-1) === str.slice(-1).toLowerCase();
					return isTailLowerCase ? m.toLowerCase() : m.toUpperCase();
				});
		}
	
		return count === 1 ? str : plural;
	};


/***/ }),
/* 83 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = interrupt;
	
	function interrupt(interruptors, tokenizers, ctx, params) {
	  var bools = ['pedantic', 'commonmark'];
	  var count = bools.length;
	  var length = interruptors.length;
	  var index = -1;
	  var interruptor;
	  var config;
	  var fn;
	  var offset;
	  var bool;
	  var ignore;
	
	  while (++index < length) {
	    interruptor = interruptors[index];
	    config = interruptor[1] || {};
	    fn = interruptor[0];
	    offset = -1;
	    ignore = false;
	
	    while (++offset < count) {
	      bool = bools[offset];
	
	      if (config[bool] !== undefined && config[bool] !== ctx.options[bool]) {
	        ignore = true;
	        break;
	      }
	    }
	
	    if (ignore) {
	      continue;
	    }
	
	    if (tokenizers[fn].apply(ctx, params)) {
	      return true;
	    }
	  }
	
	  return false;
	}


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var collapseWhiteSpace = __webpack_require__(110);
	
	module.exports = normalize;
	
	/* Normalize an identifier.  Collapses multiple white space
	 * characters into a single space, and removes casing. */
	function normalize(value) {
	  return collapseWhiteSpace(value).toLowerCase();
	}


/***/ }),
/* 85 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = enclose;
	
	/* There is currently no way to support nested delimiters
	 * across Markdown.pl, CommonMark, and GitHub (RedCarpet).
	 * The following code supports Markdown.pl and GitHub.
	 * CommonMark is not supported when mixing double- and
	 * single quotes inside a title. */
	function enclose(title) {
	  var delimiter = title.indexOf('"') === -1 ? '"' : '\'';
	  return delimiter + title + delimiter;
	}


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var count = __webpack_require__(109);
	
	module.exports = enclose;
	
	var re = /\s/;
	
	/* Wrap `url` in angle brackets when needed, or when
	 * forced.
	 * In links, images, and definitions, the URL part needs
	 * to be enclosed when it:
	 *
	 * - has a length of `0`;
	 * - contains white-space;
	 * - has more or less opening than closing parentheses.
	 */
	function enclose(uri, always) {
	  if (always || uri.length === 0 || re.test(uri) || count(uri, '(') !== count(uri, ')')) {
	    return '<' + uri + '>';
	  }
	
	  return uri;
	}


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var entities = __webpack_require__(301)
	var legacy = __webpack_require__(129)
	var hexadecimal = __webpack_require__(128)
	var alphanumerical = __webpack_require__(127)
	var dangerous = __webpack_require__(308)
	
	/* Expose. */
	module.exports = encode
	encode.escape = escape
	
	var own = {}.hasOwnProperty
	
	/* List of enforced escapes. */
	var escapes = ['"', "'", '<', '>', '&', '`']
	
	/* Map of characters to names. */
	var characters = construct()
	
	/* Default escapes. */
	var defaultEscapes = toExpression(escapes)
	
	/* Surrogate pairs. */
	var surrogatePair = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g
	
	/* Non-ASCII characters. */
	// eslint-disable-next-line no-control-regex, unicorn/no-hex-escape
	var bmp = /[\x01-\t\x0B\f\x0E-\x1F\x7F\x81\x8D\x8F\x90\x9D\xA0-\uFFFF]/g
	
	/* Encode special characters in `value`. */
	function encode(value, options) {
	  var settings = options || {}
	  var subset = settings.subset
	  var set = subset ? toExpression(subset) : defaultEscapes
	  var escapeOnly = settings.escapeOnly
	  var omit = settings.omitOptionalSemicolons
	
	  value = value.replace(set, function(char, pos, val) {
	    return one(char, val.charAt(pos + 1), settings)
	  })
	
	  if (subset || escapeOnly) {
	    return value
	  }
	
	  return value
	    .replace(surrogatePair, replaceSurrogatePair)
	    .replace(bmp, replaceBmp)
	
	  function replaceSurrogatePair(pair, pos, val) {
	    return toHexReference(
	      (pair.charCodeAt(0) - 0xd800) * 0x400 +
	        pair.charCodeAt(1) -
	        0xdc00 +
	        0x10000,
	      val.charAt(pos + 2),
	      omit
	    )
	  }
	
	  function replaceBmp(char, pos, val) {
	    return one(char, val.charAt(pos + 1), settings)
	  }
	}
	
	/* Shortcut to escape special characters in HTML. */
	function escape(value) {
	  return encode(value, {
	    escapeOnly: true,
	    useNamedReferences: true
	  })
	}
	
	/* Encode `char` according to `options`. */
	function one(char, next, options) {
	  var shortest = options.useShortestReferences
	  var omit = options.omitOptionalSemicolons
	  var named
	  var numeric
	
	  if ((shortest || options.useNamedReferences) && own.call(characters, char)) {
	    named = toNamed(characters[char], next, omit, options.attribute)
	  }
	
	  if (shortest || !named) {
	    numeric = toHexReference(char.charCodeAt(0), next, omit)
	  }
	
	  if (named && (!shortest || named.length < numeric.length)) {
	    return named
	  }
	
	  return numeric
	}
	
	/* Transform `code` into an entity. */
	function toNamed(name, next, omit, attribute) {
	  var value = '&' + name
	
	  if (
	    omit &&
	    own.call(legacy, name) &&
	    dangerous.indexOf(name) === -1 &&
	    (!attribute || (next && next !== '=' && !alphanumerical(next)))
	  ) {
	    return value
	  }
	
	  return value + ';'
	}
	
	/* Transform `code` into a hexadecimal character reference. */
	function toHexReference(code, next, omit) {
	  var value = '&#x' + code.toString(16).toUpperCase()
	  return omit && next && !hexadecimal(next) ? value : value + ';'
	}
	
	/* Create an expression for `characters`. */
	function toExpression(characters) {
	  return new RegExp('[' + characters.join('') + ']', 'g')
	}
	
	/* Construct the map. */
	function construct() {
	  var chars = {}
	  var name
	
	  for (name in entities) {
	    chars[entities[name]] = name
	  }
	
	  return chars
	}


/***/ }),
/* 88 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = trimTrailingLines
	
	var line = '\n'
	
	/* Remove final newline characters from `value`. */
	function trimTrailingLines(value) {
	  var val = String(value)
	  var index = val.length
	
	  while (val.charAt(--index) === line) {
	    /* Empty */
	  }
	
	  return val.slice(0, index + 1)
	}


/***/ }),
/* 89 */
/***/ (function(module, exports) {

	'use strict'
	
	/* Expose. */
	module.exports = factory
	
	/* Factory. */
	function factory(file) {
	  var contents = indices(String(file))
	
	  return {
	    toPosition: offsetToPositionFactory(contents),
	    toOffset: positionToOffsetFactory(contents)
	  }
	}
	
	/* Factory to get the line and column-based `position` for
	 * `offset` in the bound indices. */
	function offsetToPositionFactory(indices) {
	  return offsetToPosition
	
	  /* Get the line and column-based `position` for
	   * `offset` in the bound indices. */
	  function offsetToPosition(offset) {
	    var index = -1
	    var length = indices.length
	
	    if (offset < 0) {
	      return {}
	    }
	
	    while (++index < length) {
	      if (indices[index] > offset) {
	        return {
	          line: index + 1,
	          column: offset - (indices[index - 1] || 0) + 1,
	          offset: offset
	        }
	      }
	    }
	
	    return {}
	  }
	}
	
	/* Factory to get the `offset` for a line and column-based
	 * `position` in the bound indices. */
	function positionToOffsetFactory(indices) {
	  return positionToOffset
	
	  /* Get the `offset` for a line and column-based
	   * `position` in the bound indices. */
	  function positionToOffset(position) {
	    var line = position && position.line
	    var column = position && position.column
	
	    if (!isNaN(line) && !isNaN(column) && line - 1 in indices) {
	      return (indices[line - 2] || 0) + column - 1 || 0
	    }
	
	    return -1
	  }
	}
	
	/* Get indices of line-breaks in `value`. */
	function indices(value) {
	  var result = []
	  var index = value.indexOf('\n')
	
	  while (index !== -1) {
	    result.push(index + 1)
	    index = value.indexOf('\n', index + 1)
	  }
	
	  result.push(value.length + 1)
	
	  return result
	}


/***/ }),
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.wordWrap = exports.triangle = exports.transparentize = exports.transitions = exports.toColorString = exports.tint = exports.timingFunctions = exports.textInputs = exports.stripUnit = exports.size = exports.shade = exports.setSaturation = exports.setLightness = exports.setHue = exports.selection = exports.saturate = exports.rgba = exports.rgb = exports.retinaImage = exports.rem = exports.readableColor = exports.radialGradient = exports.position = exports.placeholder = exports.parseToRgb = exports.parseToHsl = exports.padding = exports.opacify = exports.normalize = exports.modularScale = exports.mix = exports.margin = exports.lighten = exports.hsla = exports.hsl = exports.hiDPI = exports.hideVisually = exports.hideText = exports.invert = exports.grayscale = exports.getLuminance = exports.fontFace = exports.em = exports.ellipsis = exports.directionalProperty = exports.desaturate = exports.darken = exports.complement = exports.clearFix = exports.buttons = exports.borderWidth = exports.borderStyle = exports.borderRadius = exports.borderColor = exports.backgrounds = exports.backgroundImages = exports.animation = exports.adjustHue = undefined;
	
	var _directionalProperty = /*#__PURE__*/__webpack_require__(18);
	
	var _directionalProperty2 = /*#__PURE__*/_interopRequireDefault(_directionalProperty);
	
	var _em = /*#__PURE__*/__webpack_require__(149);
	
	var _em2 = /*#__PURE__*/_interopRequireDefault(_em);
	
	var _modularScale = /*#__PURE__*/__webpack_require__(150);
	
	var _modularScale2 = /*#__PURE__*/_interopRequireDefault(_modularScale);
	
	var _rem = /*#__PURE__*/__webpack_require__(151);
	
	var _rem2 = /*#__PURE__*/_interopRequireDefault(_rem);
	
	var _stripUnit = /*#__PURE__*/__webpack_require__(43);
	
	var _stripUnit2 = /*#__PURE__*/_interopRequireDefault(_stripUnit);
	
	var _clearFix = /*#__PURE__*/__webpack_require__(155);
	
	var _clearFix2 = /*#__PURE__*/_interopRequireDefault(_clearFix);
	
	var _ellipsis = /*#__PURE__*/__webpack_require__(156);
	
	var _ellipsis2 = /*#__PURE__*/_interopRequireDefault(_ellipsis);
	
	var _fontFace = /*#__PURE__*/__webpack_require__(157);
	
	var _fontFace2 = /*#__PURE__*/_interopRequireDefault(_fontFace);
	
	var _hideText = /*#__PURE__*/__webpack_require__(158);
	
	var _hideText2 = /*#__PURE__*/_interopRequireDefault(_hideText);
	
	var _hideVisually = /*#__PURE__*/__webpack_require__(159);
	
	var _hideVisually2 = /*#__PURE__*/_interopRequireDefault(_hideVisually);
	
	var _hiDPI = /*#__PURE__*/__webpack_require__(67);
	
	var _hiDPI2 = /*#__PURE__*/_interopRequireDefault(_hiDPI);
	
	var _normalize = /*#__PURE__*/__webpack_require__(160);
	
	var _normalize2 = /*#__PURE__*/_interopRequireDefault(_normalize);
	
	var _placeholder = /*#__PURE__*/__webpack_require__(161);
	
	var _placeholder2 = /*#__PURE__*/_interopRequireDefault(_placeholder);
	
	var _radialGradient = /*#__PURE__*/__webpack_require__(162);
	
	var _radialGradient2 = /*#__PURE__*/_interopRequireDefault(_radialGradient);
	
	var _retinaImage = /*#__PURE__*/__webpack_require__(163);
	
	var _retinaImage2 = /*#__PURE__*/_interopRequireDefault(_retinaImage);
	
	var _selection = /*#__PURE__*/__webpack_require__(164);
	
	var _selection2 = /*#__PURE__*/_interopRequireDefault(_selection);
	
	var _timingFunctions = /*#__PURE__*/__webpack_require__(165);
	
	var _timingFunctions2 = /*#__PURE__*/_interopRequireDefault(_timingFunctions);
	
	var _triangle = /*#__PURE__*/__webpack_require__(166);
	
	var _triangle2 = /*#__PURE__*/_interopRequireDefault(_triangle);
	
	var _wordWrap = /*#__PURE__*/__webpack_require__(167);
	
	var _wordWrap2 = /*#__PURE__*/_interopRequireDefault(_wordWrap);
	
	var _adjustHue = /*#__PURE__*/__webpack_require__(133);
	
	var _adjustHue2 = /*#__PURE__*/_interopRequireDefault(_adjustHue);
	
	var _complement = /*#__PURE__*/__webpack_require__(134);
	
	var _complement2 = /*#__PURE__*/_interopRequireDefault(_complement);
	
	var _darken = /*#__PURE__*/__webpack_require__(135);
	
	var _darken2 = /*#__PURE__*/_interopRequireDefault(_darken);
	
	var _desaturate = /*#__PURE__*/__webpack_require__(136);
	
	var _desaturate2 = /*#__PURE__*/_interopRequireDefault(_desaturate);
	
	var _getLuminance = /*#__PURE__*/__webpack_require__(58);
	
	var _getLuminance2 = /*#__PURE__*/_interopRequireDefault(_getLuminance);
	
	var _grayscale = /*#__PURE__*/__webpack_require__(137);
	
	var _grayscale2 = /*#__PURE__*/_interopRequireDefault(_grayscale);
	
	var _hsl = /*#__PURE__*/__webpack_require__(59);
	
	var _hsl2 = /*#__PURE__*/_interopRequireDefault(_hsl);
	
	var _hsla = /*#__PURE__*/__webpack_require__(60);
	
	var _hsla2 = /*#__PURE__*/_interopRequireDefault(_hsla);
	
	var _invert = /*#__PURE__*/__webpack_require__(138);
	
	var _invert2 = /*#__PURE__*/_interopRequireDefault(_invert);
	
	var _lighten = /*#__PURE__*/__webpack_require__(139);
	
	var _lighten2 = /*#__PURE__*/_interopRequireDefault(_lighten);
	
	var _mix = /*#__PURE__*/__webpack_require__(41);
	
	var _mix2 = /*#__PURE__*/_interopRequireDefault(_mix);
	
	var _opacify = /*#__PURE__*/__webpack_require__(140);
	
	var _opacify2 = /*#__PURE__*/_interopRequireDefault(_opacify);
	
	var _parseToHsl = /*#__PURE__*/__webpack_require__(8);
	
	var _parseToHsl2 = /*#__PURE__*/_interopRequireDefault(_parseToHsl);
	
	var _parseToRgb = /*#__PURE__*/__webpack_require__(15);
	
	var _parseToRgb2 = /*#__PURE__*/_interopRequireDefault(_parseToRgb);
	
	var _readableColor = /*#__PURE__*/__webpack_require__(141);
	
	var _readableColor2 = /*#__PURE__*/_interopRequireDefault(_readableColor);
	
	var _rgb = /*#__PURE__*/__webpack_require__(42);
	
	var _rgb2 = /*#__PURE__*/_interopRequireDefault(_rgb);
	
	var _rgba = /*#__PURE__*/__webpack_require__(25);
	
	var _rgba2 = /*#__PURE__*/_interopRequireDefault(_rgba);
	
	var _saturate = /*#__PURE__*/__webpack_require__(142);
	
	var _saturate2 = /*#__PURE__*/_interopRequireDefault(_saturate);
	
	var _setHue = /*#__PURE__*/__webpack_require__(143);
	
	var _setHue2 = /*#__PURE__*/_interopRequireDefault(_setHue);
	
	var _setLightness = /*#__PURE__*/__webpack_require__(144);
	
	var _setLightness2 = /*#__PURE__*/_interopRequireDefault(_setLightness);
	
	var _setSaturation = /*#__PURE__*/__webpack_require__(145);
	
	var _setSaturation2 = /*#__PURE__*/_interopRequireDefault(_setSaturation);
	
	var _shade = /*#__PURE__*/__webpack_require__(146);
	
	var _shade2 = /*#__PURE__*/_interopRequireDefault(_shade);
	
	var _tint = /*#__PURE__*/__webpack_require__(147);
	
	var _tint2 = /*#__PURE__*/_interopRequireDefault(_tint);
	
	var _toColorString = /*#__PURE__*/__webpack_require__(7);
	
	var _toColorString2 = /*#__PURE__*/_interopRequireDefault(_toColorString);
	
	var _transparentize = /*#__PURE__*/__webpack_require__(148);
	
	var _transparentize2 = /*#__PURE__*/_interopRequireDefault(_transparentize);
	
	var _animation = /*#__PURE__*/__webpack_require__(168);
	
	var _animation2 = /*#__PURE__*/_interopRequireDefault(_animation);
	
	var _backgroundImages = /*#__PURE__*/__webpack_require__(169);
	
	var _backgroundImages2 = /*#__PURE__*/_interopRequireDefault(_backgroundImages);
	
	var _backgrounds = /*#__PURE__*/__webpack_require__(170);
	
	var _backgrounds2 = /*#__PURE__*/_interopRequireDefault(_backgrounds);
	
	var _borderColor = /*#__PURE__*/__webpack_require__(171);
	
	var _borderColor2 = /*#__PURE__*/_interopRequireDefault(_borderColor);
	
	var _borderRadius = /*#__PURE__*/__webpack_require__(172);
	
	var _borderRadius2 = /*#__PURE__*/_interopRequireDefault(_borderRadius);
	
	var _borderStyle = /*#__PURE__*/__webpack_require__(173);
	
	var _borderStyle2 = /*#__PURE__*/_interopRequireDefault(_borderStyle);
	
	var _borderWidth = /*#__PURE__*/__webpack_require__(174);
	
	var _borderWidth2 = /*#__PURE__*/_interopRequireDefault(_borderWidth);
	
	var _buttons = /*#__PURE__*/__webpack_require__(175);
	
	var _buttons2 = /*#__PURE__*/_interopRequireDefault(_buttons);
	
	var _margin = /*#__PURE__*/__webpack_require__(176);
	
	var _margin2 = /*#__PURE__*/_interopRequireDefault(_margin);
	
	var _padding = /*#__PURE__*/__webpack_require__(177);
	
	var _padding2 = /*#__PURE__*/_interopRequireDefault(_padding);
	
	var _position = /*#__PURE__*/__webpack_require__(178);
	
	var _position2 = /*#__PURE__*/_interopRequireDefault(_position);
	
	var _size = /*#__PURE__*/__webpack_require__(179);
	
	var _size2 = /*#__PURE__*/_interopRequireDefault(_size);
	
	var _textInputs = /*#__PURE__*/__webpack_require__(180);
	
	var _textInputs2 = /*#__PURE__*/_interopRequireDefault(_textInputs);
	
	var _transitions = /*#__PURE__*/__webpack_require__(181);
	
	var _transitions2 = /*#__PURE__*/_interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Shorthands
	
	// Helpers
	exports.adjustHue = _adjustHue2.default;
	exports.animation = _animation2.default;
	exports.backgroundImages = _backgroundImages2.default;
	exports.backgrounds = _backgrounds2.default;
	exports.borderColor = _borderColor2.default;
	exports.borderRadius = _borderRadius2.default;
	exports.borderStyle = _borderStyle2.default;
	exports.borderWidth = _borderWidth2.default;
	exports.buttons = _buttons2.default;
	exports.clearFix = _clearFix2.default;
	exports.complement = _complement2.default;
	exports.darken = _darken2.default;
	exports.desaturate = _desaturate2.default;
	exports.directionalProperty = _directionalProperty2.default;
	exports.ellipsis = _ellipsis2.default;
	exports.em = _em2.default;
	exports.fontFace = _fontFace2.default;
	exports.getLuminance = _getLuminance2.default;
	exports.grayscale = _grayscale2.default;
	exports.invert = _invert2.default;
	exports.hideText = _hideText2.default;
	exports.hideVisually = _hideVisually2.default;
	exports.hiDPI = _hiDPI2.default;
	exports.hsl = _hsl2.default;
	exports.hsla = _hsla2.default;
	exports.lighten = _lighten2.default;
	exports.margin = _margin2.default;
	exports.mix = _mix2.default;
	exports.modularScale = _modularScale2.default;
	exports.normalize = _normalize2.default;
	exports.opacify = _opacify2.default;
	exports.padding = _padding2.default;
	exports.parseToHsl = _parseToHsl2.default;
	exports.parseToRgb = _parseToRgb2.default;
	exports.placeholder = _placeholder2.default;
	exports.position = _position2.default;
	exports.radialGradient = _radialGradient2.default;
	exports.readableColor = _readableColor2.default;
	exports.rem = _rem2.default;
	exports.retinaImage = _retinaImage2.default;
	exports.rgb = _rgb2.default;
	exports.rgba = _rgba2.default;
	exports.saturate = _saturate2.default;
	exports.selection = _selection2.default;
	exports.setHue = _setHue2.default;
	exports.setLightness = _setLightness2.default;
	exports.setSaturation = _setSaturation2.default;
	exports.shade = _shade2.default;
	exports.size = _size2.default;
	exports.stripUnit = _stripUnit2.default;
	exports.textInputs = _textInputs2.default;
	exports.timingFunctions = _timingFunctions2.default;
	exports.tint = _tint2.default;
	exports.toColorString = _toColorString2.default;
	exports.transitions = _transitions2.default;
	exports.transparentize = _transparentize2.default;
	exports.triangle = _triangle2.default;
	exports.wordWrap = _wordWrap2.default;
	
	// Color
	
	
	// Mixins

/***/ }),
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEmotion = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modalContentStyles = /*#__PURE__*/(0, _reactEmotion.css)("font-size:12px;line-height:1.4;p{font-size:12px;}");
	
	exports.default = function (_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement("div", {
	    className: modalContentStyles,
	    dangerouslySetInnerHTML: { __html: children }
	  });
	};
	
	module.exports = exports["default"];

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.getSelectedIndicator = exports.getCurrentDataKey = undefined;
	
	var _ramda = __webpack_require__(70);
	
	var _qs = __webpack_require__(182);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getCurrentDataKey = exports.getCurrentDataKey = function getCurrentDataKey(location) {
	  return (0, _ramda.startsWith)("/map", location.pathname) && _qs2.default.parse(location.search, { ignoreQueryPrefix: true }).key;
	};
	
	var getSelectedIndicator = exports.getSelectedIndicator = function getSelectedIndicator(location, indicators) {
	  return (0, _ramda.find)((0, _ramda.propEq)("dataKey", getCurrentDataKey(location)), indicators);
	};

/***/ }),
/* 109 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = ccount
	
	function ccount(value, character) {
	  var count = 0
	  var index
	
	  value = String(value)
	
	  if (typeof character !== 'string' || character.length !== 1) {
	    throw new Error('Expected character')
	  }
	
	  index = value.indexOf(character)
	
	  while (index !== -1) {
	    count++
	    index = value.indexOf(character, index + 1)
	  }
	
	  return count
	}


/***/ }),
/* 110 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = collapse
	
	/* collapse(' \t\nbar \nbaz\t'); // ' bar baz ' */
	function collapse(value) {
	  return String(value).replace(/\s+/g, ' ')
	}


/***/ }),
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */
/***/ (function(module, exports) {

	/**
	 * @author Titus Wormer
	 * @copyright 2016 Titus Wormer
	 * @license MIT
	 * @module rehype:lint:util:is-element
	 */
	
	'use strict';
	
	/* eslint-env commonjs */
	
	/**
	 * Check if a node is a (certain) element.
	 *
	 * @param {*} node - Thing to check.
	 * @param {string|Array.<string>?} [tagNames] - Name of element.
	 * @return {boolean} - Whether a node is a (certain) element.
	 * @throws {Error} - When `tagNames` is given but invalid.
	 */
	function isElement(node, tagNames) {
	    var name;
	
	    if (
	        !(
	            tagNames === null ||
	            tagNames === undefined ||
	            typeof tagNames === 'string' ||
	            (typeof tagNames === 'object' && tagNames.length)
	        )
	    ) {
	        throw new Error(
	            'Expected `string` or `Array.<string>` for ' +
	            '`tagNames`, not `' + tagNames + '`'
	        );
	    }
	
	    if (
	        !node ||
	        typeof node !== 'object' ||
	        node.type !== 'element' ||
	        typeof node.tagName !== 'string'
	    ) {
	        return false;
	    }
	
	    if (tagNames === null || tagNames === undefined) {
	        return true;
	    }
	
	    name = node.tagName;
	
	    if (typeof tagNames === 'string') {
	        return name === tagNames;
	    }
	
	    return tagNames.indexOf(name) !== -1;
	}
	
	/*
	 * Expose.
	 */
	
	module.exports = isElement;


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var one = __webpack_require__(123);
	
	module.exports = all;
	
	/* Stringify all children of `parent`. */
	function all(ctx, parent) {
	  var children = parent && parent.children;
	  var length = children && children.length;
	  var index = -1;
	  var results = [];
	
	  while (++index < length) {
	    results[index] = one(ctx, children[index], index, parent);
	  }
	
	  return results.join('');
	}


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var is = __webpack_require__(56);
	var element = __webpack_require__(118);
	var whiteSpaceLeft = __webpack_require__(122);
	var after = __webpack_require__(80).after;
	var omission = __webpack_require__(121);
	
	module.exports = omission({
	  html: html,
	  head: headOrColgroupOrCaption,
	  body: body,
	  p: p,
	  li: li,
	  dt: dt,
	  dd: dd,
	  rt: rubyElement,
	  rp: rubyElement,
	  optgroup: optgroup,
	  option: option,
	  menuitem: menuitem,
	  colgroup: headOrColgroupOrCaption,
	  caption: headOrColgroupOrCaption,
	  thead: thead,
	  tbody: tbody,
	  tfoot: tfoot,
	  tr: tr,
	  td: cells,
	  th: cells
	});
	
	/* Macro for `</head>`, `</colgroup>`, and `</caption>`. */
	function headOrColgroupOrCaption(node, index, parent) {
	  var next = after(parent, index, true);
	  return !next || (!is('comment', next) && !whiteSpaceLeft(next));
	}
	
	/* Whether to omit `</html>`. */
	function html(node, index, parent) {
	  var next = after(parent, index);
	  return !next || !is('comment', next);
	}
	
	/* Whether to omit `</body>`. */
	function body(node, index, parent) {
	  var next = after(parent, index);
	  return !next || !is('comment', next);
	}
	
	/* Whether to omit `</p>`. */
	function p(node, index, parent) {
	  var next = after(parent, index);
	
	  if (next) {
	    return element(next, [
	      'address', 'article', 'aside', 'blockquote', 'details',
	      'div', 'dl', 'fieldset', 'figcaption', 'figure', 'footer',
	      'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'header',
	      'hgroup', 'hr', 'main', 'menu', 'nav', 'ol', 'p', 'pre',
	      'section', 'table', 'ul'
	    ]);
	  }
	
	  return !parent || !element(parent, [
	    'a', 'audio', 'del', 'ins', 'map', 'noscript', 'video'
	  ]);
	}
	
	/* Whether to omit `</li>`. */
	function li(node, index, parent) {
	  var next = after(parent, index);
	  return !next || element(next, 'li');
	}
	
	/* Whether to omit `</dt>`. */
	function dt(node, index, parent) {
	  var next = after(parent, index);
	  return next && element(next, ['dt', 'dd']);
	}
	
	/* Whether to omit `</dd>`. */
	function dd(node, index, parent) {
	  var next = after(parent, index);
	  return !next || element(next, ['dt', 'dd']);
	}
	
	/* Whether to omit `</rt>` or `</rp>`. */
	function rubyElement(node, index, parent) {
	  var next = after(parent, index);
	  return !next || element(next, ['rp', 'rt']);
	}
	
	/* Whether to omit `</optgroup>`. */
	function optgroup(node, index, parent) {
	  var next = after(parent, index);
	  return !next || element(next, 'optgroup');
	}
	
	/* Whether to omit `</option>`. */
	function option(node, index, parent) {
	  var next = after(parent, index);
	  return !next || element(next, ['option', 'optgroup']);
	}
	
	/* Whether to omit `</menuitem>`. */
	function menuitem(node, index, parent) {
	  var next = after(parent, index);
	  return !next || element(next, ['menuitem', 'hr', 'menu']);
	}
	
	/* Whether to omit `</thead>`. */
	function thead(node, index, parent) {
	  var next = after(parent, index);
	  return next && element(next, ['tbody', 'tfoot']);
	}
	
	/* Whether to omit `</tbody>`. */
	function tbody(node, index, parent) {
	  var next = after(parent, index);
	  return !next || element(next, ['tbody', 'tfoot']);
	}
	
	/* Whether to omit `</tfoot>`. */
	function tfoot(node, index, parent) {
	  return !after(parent, index);
	}
	
	/* Whether to omit `</tr>`. */
	function tr(node, index, parent) {
	  var next = after(parent, index);
	  return !next || element(next, 'tr');
	}
	
	/* Whether to omit `</td>` or `</th>`. */
	function cells(node, index, parent) {
	  var next = after(parent, index);
	  return !next || element(next, ['td', 'th']);
	}


/***/ }),
/* 121 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = omission;
	
	var own = {}.hasOwnProperty;
	
	/* Factory to check if a given node can have a tag omitted. */
	function omission(handlers) {
	  return omit;
	
	  /* Check if a given node can have a tag omitted.   */
	  function omit(node, index, parent) {
	    var name = node.tagName;
	    var fn = own.call(handlers, name) ? handlers[name] : false;
	
	    return fn ? fn(node, index, parent) : false;
	  }
	}


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var is = __webpack_require__(56);
	var whiteSpace = __webpack_require__(125);
	
	module.exports = whiteSpaceLeft;
	
	/* Check if `node` starts with white-space. */
	function whiteSpaceLeft(node) {
	  return is('text', node) && whiteSpace(node.value.charAt(0));
	}


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = one;
	
	var own = {}.hasOwnProperty;
	
	var handlers = {};
	
	handlers.root = __webpack_require__(119);
	handlers.text = __webpack_require__(124);
	handlers.element = __webpack_require__(285);
	handlers.doctype = __webpack_require__(284);
	handlers.comment = __webpack_require__(283);
	handlers.raw = __webpack_require__(291);
	
	/* Stringify `node`. */
	function one(ctx, node, index, parent) {
	  var type = node && node.type;
	
	  if (!type) {
	    throw new Error('Expected node, not `' + node + '`');
	  }
	
	  if (!own.call(handlers, type)) {
	    throw new Error('Cannot compile unknown node `' + type + '`');
	  }
	
	  return handlers[type](ctx, node, index, parent);
	}


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var xtend = __webpack_require__(12);
	var entities = __webpack_require__(87);
	
	module.exports = text;
	
	/* Stringify `text`. */
	function text(ctx, node, index, parent) {
	  var value = node.value;
	
	  return isLiteral(parent) ? value : entities(value, xtend(ctx.entities, {
	    subset: ['<', '&']
	  }));
	}
	
	/* Check if content of `node` should be escaped. */
	function isLiteral(node) {
	  return node && (node.tagName === 'script' || node.tagName === 'style');
	}


/***/ }),
/* 125 */
/***/ (function(module, exports) {

	/**
	 * @author Titus Wormer
	 * @copyright 2016 Titus Wormer
	 * @license MIT
	 * @module hast:util:whitespace
	 * @fileoverview Check whether a node is inter-element
	 *   whitespace.
	 */
	
	'use strict';
	
	/* eslint-env commonjs */
	
	/*
	 * HTML white-space expression.
	 *
	 * See <https://html.spec.whatwg.org/#space-character>.
	 */
	
	var EXPRESSION = /[\ \t\n\f\r]/g;
	
	/**
	 * Check if `node` is a inter-element white-space.
	 *
	 * @param {Node|string} node - Value to check, or Node
	 *   whose value to check.
	 * @return {boolean} - Whether `node` is inter-element
	 *   white-space.
	 */
	function interElementWhiteSpace(node) {
	    var value;
	
	    if (node && typeof node === 'object' && node.type === 'text') {
	        value = node.value || ''
	    } else if (typeof node === 'string') {
	        value = node;
	    } else {
	        return false;
	    }
	
	    return value.replace(EXPRESSION, '') === '';
	}
	
	/*
	 * Expose.
	 */
	
	module.exports = interElementWhiteSpace;


/***/ }),
/* 126 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = alphabetical
	
	/* Check if the given character code, or the character
	 * code at the first character, is alphabetical. */
	function alphabetical(character) {
	  var code = typeof character === 'string' ? character.charCodeAt(0) : character
	
	  return (
	    (code >= 97 && code <= 122) /* a-z */ ||
	    (code >= 65 && code <= 90) /* A-Z */
	  )
	}


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var alphabetical = __webpack_require__(126)
	var decimal = __webpack_require__(40)
	
	module.exports = alphanumerical
	
	/* Check if the given character code, or the character
	 * code at the first character, is alphanumerical. */
	function alphanumerical(character) {
	  return alphabetical(character) || decimal(character)
	}


/***/ }),
/* 128 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = hexadecimal
	
	/* Check if the given character code, or the character
	 * code at the first character, is hexadecimal. */
	function hexadecimal(character) {
	  var code = typeof character === 'string' ? character.charCodeAt(0) : character
	
	  return (
	    (code >= 97 /* a */ && code <= 102) /* z */ ||
	    (code >= 65 /* A */ && code <= 70) /* Z */ ||
	    (code >= 48 /* A */ && code <= 57) /* Z */
	  )
	}


/***/ }),
/* 129 */
/***/ (function(module, exports) {

	module.exports = {"AElig":"Æ","AMP":"&","Aacute":"Á","Acirc":"Â","Agrave":"À","Aring":"Å","Atilde":"Ã","Auml":"Ä","COPY":"©","Ccedil":"Ç","ETH":"Ð","Eacute":"É","Ecirc":"Ê","Egrave":"È","Euml":"Ë","GT":">","Iacute":"Í","Icirc":"Î","Igrave":"Ì","Iuml":"Ï","LT":"<","Ntilde":"Ñ","Oacute":"Ó","Ocirc":"Ô","Ograve":"Ò","Oslash":"Ø","Otilde":"Õ","Ouml":"Ö","QUOT":"\"","REG":"®","THORN":"Þ","Uacute":"Ú","Ucirc":"Û","Ugrave":"Ù","Uuml":"Ü","Yacute":"Ý","aacute":"á","acirc":"â","acute":"´","aelig":"æ","agrave":"à","amp":"&","aring":"å","atilde":"ã","auml":"ä","brvbar":"¦","ccedil":"ç","cedil":"¸","cent":"¢","copy":"©","curren":"¤","deg":"°","divide":"÷","eacute":"é","ecirc":"ê","egrave":"è","eth":"ð","euml":"ë","frac12":"½","frac14":"¼","frac34":"¾","gt":">","iacute":"í","icirc":"î","iexcl":"¡","igrave":"ì","iquest":"¿","iuml":"ï","laquo":"«","lt":"<","macr":"¯","micro":"µ","middot":"·","nbsp":" ","not":"¬","ntilde":"ñ","oacute":"ó","ocirc":"ô","ograve":"ò","ordf":"ª","ordm":"º","oslash":"ø","otilde":"õ","ouml":"ö","para":"¶","plusmn":"±","pound":"£","quot":"\"","raquo":"»","reg":"®","sect":"§","shy":"­","sup1":"¹","sup2":"²","sup3":"³","szlig":"ß","thorn":"þ","times":"×","uacute":"ú","ucirc":"û","ugrave":"ù","uml":"¨","uuml":"ü","yacute":"ý","yen":"¥","yuml":"ÿ"}

/***/ }),
/* 130 */
/***/ (function(module, exports) {

	'use strict';
	
	/* Expose. */
	module.exports = longestStreak;
	
	/* Get the count of the longest repeating streak of
	 * `character` in `value`. */
	function longestStreak(value, character) {
	  var count = 0;
	  var maximum = 0;
	  var expected;
	  var index;
	
	  if (typeof character !== 'string' || character.length !== 1) {
	    throw new Error('Expected character');
	  }
	
	  value = String(value);
	  index = value.indexOf(character);
	  expected = index;
	
	  while (index !== -1) {
	    count++;
	
	    if (index === expected) {
	      if (count > maximum) {
	        maximum = count;
	      }
	    } else {
	      count = 1;
	    }
	
	    expected = index + 1;
	    index = value.indexOf(character, expected);
	  }
	
	  return maximum;
	}


/***/ }),
/* 131 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = escapes
	
	var defaults = [
	  '\\',
	  '`',
	  '*',
	  '{',
	  '}',
	  '[',
	  ']',
	  '(',
	  ')',
	  '#',
	  '+',
	  '-',
	  '.',
	  '!',
	  '_',
	  '>'
	]
	
	var gfm = defaults.concat(['~', '|'])
	
	var commonmark = gfm.concat([
	  '\n',
	  '"',
	  '$',
	  '%',
	  '&',
	  "'",
	  ',',
	  '/',
	  ':',
	  ';',
	  '<',
	  '=',
	  '?',
	  '@',
	  '^'
	])
	
	escapes.default = defaults
	escapes.gfm = gfm
	escapes.commonmark = commonmark
	
	/* Get markdown escapes. */
	function escapes(options) {
	  var settings = options || {}
	
	  if (settings.commonmark) {
	    return commonmark
	  }
	
	  return settings.gfm ? gfm : defaults
	}


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// resolves . and .. elements in a path array with directory names there
	// must be no slashes, empty elements, or device names (c:\) in the array
	// (so also no leading and trailing slashes - it does not distinguish
	// relative and absolute paths)
	function normalizeArray(parts, allowAboveRoot) {
	  // if the path tries to go above the root, `up` ends up > 0
	  var up = 0;
	  for (var i = parts.length - 1; i >= 0; i--) {
	    var last = parts[i];
	    if (last === '.') {
	      parts.splice(i, 1);
	    } else if (last === '..') {
	      parts.splice(i, 1);
	      up++;
	    } else if (up) {
	      parts.splice(i, 1);
	      up--;
	    }
	  }
	
	  // if the path is allowed to go above the root, restore leading ..s
	  if (allowAboveRoot) {
	    for (; up--; up) {
	      parts.unshift('..');
	    }
	  }
	
	  return parts;
	}
	
	// Split a filename into [root, dir, basename, ext], unix version
	// 'root' is just a slash, or nothing.
	var splitPathRe =
	    /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
	var splitPath = function(filename) {
	  return splitPathRe.exec(filename).slice(1);
	};
	
	// path.resolve([from ...], to)
	// posix version
	exports.resolve = function() {
	  var resolvedPath = '',
	      resolvedAbsolute = false;
	
	  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
	    var path = (i >= 0) ? arguments[i] : process.cwd();
	
	    // Skip empty and invalid entries
	    if (typeof path !== 'string') {
	      throw new TypeError('Arguments to path.resolve must be strings');
	    } else if (!path) {
	      continue;
	    }
	
	    resolvedPath = path + '/' + resolvedPath;
	    resolvedAbsolute = path.charAt(0) === '/';
	  }
	
	  // At this point the path should be resolved to a full absolute path, but
	  // handle relative paths to be safe (might happen when process.cwd() fails)
	
	  // Normalize the path
	  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
	    return !!p;
	  }), !resolvedAbsolute).join('/');
	
	  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
	};
	
	// path.normalize(path)
	// posix version
	exports.normalize = function(path) {
	  var isAbsolute = exports.isAbsolute(path),
	      trailingSlash = substr(path, -1) === '/';
	
	  // Normalize the path
	  path = normalizeArray(filter(path.split('/'), function(p) {
	    return !!p;
	  }), !isAbsolute).join('/');
	
	  if (!path && !isAbsolute) {
	    path = '.';
	  }
	  if (path && trailingSlash) {
	    path += '/';
	  }
	
	  return (isAbsolute ? '/' : '') + path;
	};
	
	// posix version
	exports.isAbsolute = function(path) {
	  return path.charAt(0) === '/';
	};
	
	// posix version
	exports.join = function() {
	  var paths = Array.prototype.slice.call(arguments, 0);
	  return exports.normalize(filter(paths, function(p, index) {
	    if (typeof p !== 'string') {
	      throw new TypeError('Arguments to path.join must be strings');
	    }
	    return p;
	  }).join('/'));
	};
	
	
	// path.relative(from, to)
	// posix version
	exports.relative = function(from, to) {
	  from = exports.resolve(from).substr(1);
	  to = exports.resolve(to).substr(1);
	
	  function trim(arr) {
	    var start = 0;
	    for (; start < arr.length; start++) {
	      if (arr[start] !== '') break;
	    }
	
	    var end = arr.length - 1;
	    for (; end >= 0; end--) {
	      if (arr[end] !== '') break;
	    }
	
	    if (start > end) return [];
	    return arr.slice(start, end - start + 1);
	  }
	
	  var fromParts = trim(from.split('/'));
	  var toParts = trim(to.split('/'));
	
	  var length = Math.min(fromParts.length, toParts.length);
	  var samePartsLength = length;
	  for (var i = 0; i < length; i++) {
	    if (fromParts[i] !== toParts[i]) {
	      samePartsLength = i;
	      break;
	    }
	  }
	
	  var outputParts = [];
	  for (var i = samePartsLength; i < fromParts.length; i++) {
	    outputParts.push('..');
	  }
	
	  outputParts = outputParts.concat(toParts.slice(samePartsLength));
	
	  return outputParts.join('/');
	};
	
	exports.sep = '/';
	exports.delimiter = ':';
	
	exports.dirname = function(path) {
	  var result = splitPath(path),
	      root = result[0],
	      dir = result[1];
	
	  if (!root && !dir) {
	    // No dirname whatsoever
	    return '.';
	  }
	
	  if (dir) {
	    // It has a dirname, strip trailing slash
	    dir = dir.substr(0, dir.length - 1);
	  }
	
	  return root + dir;
	};
	
	
	exports.basename = function(path, ext) {
	  var f = splitPath(path)[2];
	  // TODO: make this comparison case-insensitive on windows?
	  if (ext && f.substr(-1 * ext.length) === ext) {
	    f = f.substr(0, f.length - ext.length);
	  }
	  return f;
	};
	
	
	exports.extname = function(path) {
	  return splitPath(path)[3];
	};
	
	function filter (xs, f) {
	    if (xs.filter) return xs.filter(f);
	    var res = [];
	    for (var i = 0; i < xs.length; i++) {
	        if (f(xs[i], i, xs)) res.push(xs[i]);
	    }
	    return res;
	}
	
	// String.prototype.substr - negative index don't work in IE8
	var substr = 'ab'.substr(-1) === 'b'
	    ? function (str, start, len) { return str.substr(start, len) }
	    : function (str, start, len) {
	        if (start < 0) start = str.length + start;
	        return str.substr(start, len);
	    }
	;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)))

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _parseToHsl = /*#__PURE__*/__webpack_require__(8);
	
	var _parseToHsl2 = /*#__PURE__*/_interopRequireDefault(_parseToHsl);
	
	var _toColorString = /*#__PURE__*/__webpack_require__(7);
	
	var _toColorString2 = /*#__PURE__*/_interopRequireDefault(_toColorString);
	
	var _curry = /*#__PURE__*/__webpack_require__(5);
	
	var _curry2 = /*#__PURE__*/_interopRequireDefault(_curry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Changes the hue of the color. Hue is a number between 0 to 360. The first
	 * argument for adjustHue is the amount of degrees the color is rotated along
	 * the color wheel.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: adjustHue(180, '#448'),
	 *   background: adjustHue(180, 'rgba(101,100,205,0.7)'),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${adjustHue(180, '#448')};
	 *   background: ${adjustHue(180, 'rgba(101,100,205,0.7)')};
	 * `
	 *
	 * // CSS in JS Output
	 * element {
	 *   background: "#888844";
	 *   background: "rgba(136,136,68,0.7)";
	 * }
	 */
	function adjustHue(degree, color) {
	  var hslColor = (0, _parseToHsl2.default)(color);
	  return (0, _toColorString2.default)(_extends({}, hslColor, {
	    hue: (hslColor.hue + degree) % 360
	  }));
	}
	
	var curriedAdjustHue = /*#__PURE__*/(0, _curry2.default)(adjustHue);
	exports.default = curriedAdjustHue;
	module.exports = exports['default'];

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _parseToHsl = /*#__PURE__*/__webpack_require__(8);
	
	var _parseToHsl2 = /*#__PURE__*/_interopRequireDefault(_parseToHsl);
	
	var _toColorString = /*#__PURE__*/__webpack_require__(7);
	
	var _toColorString2 = /*#__PURE__*/_interopRequireDefault(_toColorString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Returns the complement of the provided color. This is identical to adjustHue(180, <color>).
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: complement('#448'),
	 *   background: complement('rgba(204,205,100,0.7)'),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${complement('#448')};
	 *   background: ${complement('rgba(204,205,100,0.7)')};
	 * `
	 *
	 * // CSS in JS Output
	 * element {
	 *   background: "#884";
	 *   background: "rgba(153,153,153,0.7)";
	 * }
	 */
	function complement(color) {
	  var hslColor = (0, _parseToHsl2.default)(color);
	  return (0, _toColorString2.default)(_extends({}, hslColor, {
	    hue: (hslColor.hue + 180) % 360
	  }));
	}
	
	exports.default = complement;
	module.exports = exports['default'];

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _parseToHsl = /*#__PURE__*/__webpack_require__(8);
	
	var _parseToHsl2 = /*#__PURE__*/_interopRequireDefault(_parseToHsl);
	
	var _toColorString = /*#__PURE__*/__webpack_require__(7);
	
	var _toColorString2 = /*#__PURE__*/_interopRequireDefault(_toColorString);
	
	var _guard = /*#__PURE__*/__webpack_require__(23);
	
	var _guard2 = /*#__PURE__*/_interopRequireDefault(_guard);
	
	var _curry = /*#__PURE__*/__webpack_require__(5);
	
	var _curry2 = /*#__PURE__*/_interopRequireDefault(_curry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Returns a string value for the darkened color.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: darken(0.2, '#FFCD64'),
	 *   background: darken(0.2, 'rgba(255,205,100,0.7)'),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${darken(0.2, '#FFCD64')};
	 *   background: ${darken(0.2, 'rgba(255,205,100,0.7)')};
	 * `
	 *
	 * // CSS in JS Output
	 *
	 * element {
	 *   background: "#ffbd31";
	 *   background: "rgba(255,189,49,0.7)";
	 * }
	 */
	function darken(amount, color) {
	  var hslColor = (0, _parseToHsl2.default)(color);
	  return (0, _toColorString2.default)(_extends({}, hslColor, {
	    lightness: (0, _guard2.default)(0, 1, hslColor.lightness - amount)
	  }));
	}
	
	var curriedDarken = /*#__PURE__*/(0, _curry2.default)(darken);
	exports.default = curriedDarken;
	module.exports = exports['default'];

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _parseToHsl = /*#__PURE__*/__webpack_require__(8);
	
	var _parseToHsl2 = /*#__PURE__*/_interopRequireDefault(_parseToHsl);
	
	var _toColorString = /*#__PURE__*/__webpack_require__(7);
	
	var _toColorString2 = /*#__PURE__*/_interopRequireDefault(_toColorString);
	
	var _guard = /*#__PURE__*/__webpack_require__(23);
	
	var _guard2 = /*#__PURE__*/_interopRequireDefault(_guard);
	
	var _curry = /*#__PURE__*/__webpack_require__(5);
	
	var _curry2 = /*#__PURE__*/_interopRequireDefault(_curry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Decreases the intensity of a color. Its range is between 0 to 1. The first
	 * argument of the desaturate function is the amount by how much the color
	 * intensity should be decreased.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: desaturate(0.2, '#CCCD64'),
	 *   background: desaturate(0.2, 'rgba(204,205,100,0.7)'),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${desaturate(0.2, '#CCCD64')};
	 *   background: ${desaturate(0.2, 'rgba(204,205,100,0.7)')};
	 * `
	 *
	 * // CSS in JS Output
	 * element {
	 *   background: "#b8b979";
	 *   background: "rgba(184,185,121,0.7)";
	 * }
	 */
	function desaturate(amount, color) {
	  var hslColor = (0, _parseToHsl2.default)(color);
	  return (0, _toColorString2.default)(_extends({}, hslColor, {
	    saturation: (0, _guard2.default)(0, 1, hslColor.saturation - amount)
	  }));
	}
	
	var curriedDesaturate = /*#__PURE__*/(0, _curry2.default)(desaturate);
	exports.default = curriedDesaturate;
	module.exports = exports['default'];

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _parseToHsl = /*#__PURE__*/__webpack_require__(8);
	
	var _parseToHsl2 = /*#__PURE__*/_interopRequireDefault(_parseToHsl);
	
	var _toColorString = /*#__PURE__*/__webpack_require__(7);
	
	var _toColorString2 = /*#__PURE__*/_interopRequireDefault(_toColorString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Converts the color to a grayscale, by reducing its saturation to 0.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: grayscale('#CCCD64'),
	 *   background: grayscale('rgba(204,205,100,0.7)'),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${grayscale('#CCCD64')};
	 *   background: ${grayscale('rgba(204,205,100,0.7)')};
	 * `
	 *
	 * // CSS in JS Output
	 * element {
	 *   background: "#999";
	 *   background: "rgba(153,153,153,0.7)";
	 * }
	 */
	function grayscale(color) {
	  return (0, _toColorString2.default)(_extends({}, (0, _parseToHsl2.default)(color), {
	    saturation: 0
	  }));
	}
	
	exports.default = grayscale;
	module.exports = exports['default'];

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _parseToRgb = /*#__PURE__*/__webpack_require__(15);
	
	var _parseToRgb2 = /*#__PURE__*/_interopRequireDefault(_parseToRgb);
	
	var _toColorString = /*#__PURE__*/__webpack_require__(7);
	
	var _toColorString2 = /*#__PURE__*/_interopRequireDefault(_toColorString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Inverts the red, green and blue values of a color.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: invert('#CCCD64'),
	 *   background: invert('rgba(101,100,205,0.7)'),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${invert('#CCCD64')};
	 *   background: ${invert('rgba(101,100,205,0.7)')};
	 * `
	 *
	 * // CSS in JS Output
	 *
	 * element {
	 *   background: "#33329b";
	 *   background: "rgba(154,155,50,0.7)";
	 * }
	 */
	function invert(color) {
	  // parse color string to rgb
	  var value = (0, _parseToRgb2.default)(color);
	  return (0, _toColorString2.default)(_extends({}, value, {
	    red: 255 - value.red,
	    green: 255 - value.green,
	    blue: 255 - value.blue
	  }));
	}
	
	exports.default = invert;
	module.exports = exports['default'];

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _parseToHsl = /*#__PURE__*/__webpack_require__(8);
	
	var _parseToHsl2 = /*#__PURE__*/_interopRequireDefault(_parseToHsl);
	
	var _toColorString = /*#__PURE__*/__webpack_require__(7);
	
	var _toColorString2 = /*#__PURE__*/_interopRequireDefault(_toColorString);
	
	var _guard = /*#__PURE__*/__webpack_require__(23);
	
	var _guard2 = /*#__PURE__*/_interopRequireDefault(_guard);
	
	var _curry = /*#__PURE__*/__webpack_require__(5);
	
	var _curry2 = /*#__PURE__*/_interopRequireDefault(_curry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Returns a string value for the lightened color.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: lighten(0.2, '#CCCD64'),
	 *   background: lighten(0.2, 'rgba(204,205,100,0.7)'),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${lighten(0.2, '#FFCD64')};
	 *   background: ${lighten(0.2, 'rgba(204,205,100,0.7)')};
	 * `
	 *
	 * // CSS in JS Output
	 *
	 * element {
	 *   background: "#e5e6b1";
	 *   background: "rgba(229,230,177,0.7)";
	 * }
	 */
	function lighten(amount, color) {
	  var hslColor = (0, _parseToHsl2.default)(color);
	  return (0, _toColorString2.default)(_extends({}, hslColor, {
	    lightness: (0, _guard2.default)(0, 1, hslColor.lightness + amount)
	  }));
	}
	
	var curriedLighten = /*#__PURE__*/(0, _curry2.default)(lighten);
	exports.default = curriedLighten;
	module.exports = exports['default'];

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _rgba = /*#__PURE__*/__webpack_require__(25);
	
	var _rgba2 = /*#__PURE__*/_interopRequireDefault(_rgba);
	
	var _parseToRgb = /*#__PURE__*/__webpack_require__(15);
	
	var _parseToRgb2 = /*#__PURE__*/_interopRequireDefault(_parseToRgb);
	
	var _guard = /*#__PURE__*/__webpack_require__(23);
	
	var _guard2 = /*#__PURE__*/_interopRequireDefault(_guard);
	
	var _curry = /*#__PURE__*/__webpack_require__(5);
	
	var _curry2 = /*#__PURE__*/_interopRequireDefault(_curry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Increases the opacity of a color. Its range for the amount is between 0 to 1.
	 *
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: opacify(0.1, 'rgba(255, 255, 255, 0.9)');
	 *   background: opacify(0.2, 'hsla(0, 0%, 100%, 0.5)'),
	 *   background: opacify(0.5, 'rgba(255, 0, 0, 0.2)'),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${opacify(0.1, 'rgba(255, 255, 255, 0.9)')};
	 *   background: ${opacify(0.2, 'hsla(0, 0%, 100%, 0.5)')},
	 *   background: ${opacify(0.5, 'rgba(255, 0, 0, 0.2)')},
	 * `
	 *
	 * // CSS in JS Output
	 *
	 * element {
	 *   background: "#fff";
	 *   background: "rgba(255,255,255,0.7)";
	 *   background: "rgba(255,0,0,0.7)";
	 * }
	 */
	function opacify(amount, color) {
	  var parsedColor = (0, _parseToRgb2.default)(color);
	  var alpha = typeof parsedColor.alpha === 'number' ? parsedColor.alpha : 1;
	  var colorWithAlpha = _extends({}, parsedColor, {
	    alpha: (0, _guard2.default)(0, 1, (alpha * 100 + amount * 100) / 100)
	  });
	  return (0, _rgba2.default)(colorWithAlpha);
	}
	
	var curriedOpacify = /*#__PURE__*/(0, _curry2.default)(opacify);
	exports.default = curriedOpacify;
	module.exports = exports['default'];

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getLuminance = /*#__PURE__*/__webpack_require__(58);
	
	var _getLuminance2 = /*#__PURE__*/_interopRequireDefault(_getLuminance);
	
	var _curry = /*#__PURE__*/__webpack_require__(5);
	
	var _curry2 = /*#__PURE__*/_interopRequireDefault(_curry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Selects black or white for best contrast depending on the luminosity of the given color.
	 * Follows W3C specs for readability at https://www.w3.org/TR/WCAG20-TECHS/G18.html
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   color: readableColor('#000'),
	 *   color: readableColor('papayawhip'),
	 *   color: readableColor('rgb(255,0,0)'),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   color: ${readableColor('#000')};
	 *   color: ${readableColor('papayawhip')};
	 *   color: ${readableColor('rgb(255,0,0)')};
	 * `
	 *
	 * // CSS in JS Output
	 *
	 * element {
	 *   color: "#fff";
	 *   color: "#fff";
	 *   color: "#000";
	 * }
	 */
	
	function readableColor(color) {
	  return (0, _getLuminance2.default)(color) > 0.179 ? '#000' : '#fff';
	}
	
	var curriedReadableColor = /*#__PURE__*/(0, _curry2.default)(readableColor);
	exports.default = curriedReadableColor;
	module.exports = exports['default'];

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _parseToHsl = /*#__PURE__*/__webpack_require__(8);
	
	var _parseToHsl2 = /*#__PURE__*/_interopRequireDefault(_parseToHsl);
	
	var _toColorString = /*#__PURE__*/__webpack_require__(7);
	
	var _toColorString2 = /*#__PURE__*/_interopRequireDefault(_toColorString);
	
	var _guard = /*#__PURE__*/__webpack_require__(23);
	
	var _guard2 = /*#__PURE__*/_interopRequireDefault(_guard);
	
	var _curry = /*#__PURE__*/__webpack_require__(5);
	
	var _curry2 = /*#__PURE__*/_interopRequireDefault(_curry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Increases the intensity of a color. Its range is between 0 to 1. The first
	 * argument of the saturate function is the amount by how much the color
	 * intensity should be increased.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: saturate(0.2, '#CCCD64'),
	 *   background: saturate(0.2, 'rgba(204,205,100,0.7)'),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${saturate(0.2, '#FFCD64')};
	 *   background: ${saturate(0.2, 'rgba(204,205,100,0.7)')};
	 * `
	 *
	 * // CSS in JS Output
	 *
	 * element {
	 *   background: "#e0e250";
	 *   background: "rgba(224,226,80,0.7)";
	 * }
	 */
	function saturate(amount, color) {
	  var hslColor = (0, _parseToHsl2.default)(color);
	  return (0, _toColorString2.default)(_extends({}, hslColor, {
	    saturation: (0, _guard2.default)(0, 1, hslColor.saturation + amount)
	  }));
	}
	
	var curriedSaturate = /*#__PURE__*/(0, _curry2.default)(saturate);
	exports.default = curriedSaturate;
	module.exports = exports['default'];

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _parseToHsl = /*#__PURE__*/__webpack_require__(8);
	
	var _parseToHsl2 = /*#__PURE__*/_interopRequireDefault(_parseToHsl);
	
	var _toColorString = /*#__PURE__*/__webpack_require__(7);
	
	var _toColorString2 = /*#__PURE__*/_interopRequireDefault(_toColorString);
	
	var _curry = /*#__PURE__*/__webpack_require__(5);
	
	var _curry2 = /*#__PURE__*/_interopRequireDefault(_curry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Sets the hue of a color to the provided value. The hue range can be
	 * from 0 and 359.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: setHue(42, '#CCCD64'),
	 *   background: setHue(244, 'rgba(204,205,100,0.7)'),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${setHue(42, '#CCCD64')};
	 *   background: ${setHue(244, 'rgba(204,205,100,0.7)')};
	 * `
	 *
	 * // CSS in JS Output
	 * element {
	 *   background: "#cdae64";
	 *   background: "rgba(107,100,205,0.7)";
	 * }
	 */
	function setHue(hue, color) {
	  return (0, _toColorString2.default)(_extends({}, (0, _parseToHsl2.default)(color), {
	    hue: hue
	  }));
	}
	
	var curriedSetHue = /*#__PURE__*/(0, _curry2.default)(setHue);
	exports.default = curriedSetHue;
	module.exports = exports['default'];

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _parseToHsl = /*#__PURE__*/__webpack_require__(8);
	
	var _parseToHsl2 = /*#__PURE__*/_interopRequireDefault(_parseToHsl);
	
	var _toColorString = /*#__PURE__*/__webpack_require__(7);
	
	var _toColorString2 = /*#__PURE__*/_interopRequireDefault(_toColorString);
	
	var _curry = /*#__PURE__*/__webpack_require__(5);
	
	var _curry2 = /*#__PURE__*/_interopRequireDefault(_curry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Sets the lightness of a color to the provided value. The lightness range can be
	 * from 0 and 1.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: setLightness(0.2, '#CCCD64'),
	 *   background: setLightness(0.75, 'rgba(204,205,100,0.7)'),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${setLightness(0.2, '#CCCD64')};
	 *   background: ${setLightness(0.75, 'rgba(204,205,100,0.7)')};
	 * `
	 *
	 * // CSS in JS Output
	 * element {
	 *   background: "#4d4d19";
	 *   background: "rgba(223,224,159,0.7)";
	 * }
	 */
	function setLightness(lightness, color) {
	  return (0, _toColorString2.default)(_extends({}, (0, _parseToHsl2.default)(color), {
	    lightness: lightness
	  }));
	}
	
	var curriedSetLightness = /*#__PURE__*/(0, _curry2.default)(setLightness);
	exports.default = curriedSetLightness;
	module.exports = exports['default'];

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _parseToHsl = /*#__PURE__*/__webpack_require__(8);
	
	var _parseToHsl2 = /*#__PURE__*/_interopRequireDefault(_parseToHsl);
	
	var _toColorString = /*#__PURE__*/__webpack_require__(7);
	
	var _toColorString2 = /*#__PURE__*/_interopRequireDefault(_toColorString);
	
	var _curry = /*#__PURE__*/__webpack_require__(5);
	
	var _curry2 = /*#__PURE__*/_interopRequireDefault(_curry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Sets the saturation of a color to the provided value. The lightness range can be
	 * from 0 and 1.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: setSaturation(0.2, '#CCCD64'),
	 *   background: setSaturation(0.75, 'rgba(204,205,100,0.7)'),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${setSaturation(0.2, '#CCCD64')};
	 *   background: ${setSaturation(0.75, 'rgba(204,205,100,0.7)')};
	 * `
	 *
	 * // CSS in JS Output
	 * element {
	 *   background: "#adad84";
	 *   background: "rgba(228,229,76,0.7)";
	 * }
	 */
	function setSaturation(saturation, color) {
	  return (0, _toColorString2.default)(_extends({}, (0, _parseToHsl2.default)(color), {
	    saturation: saturation
	  }));
	}
	
	var curriedSetSaturation = /*#__PURE__*/(0, _curry2.default)(setSaturation);
	exports.default = curriedSetSaturation;
	module.exports = exports['default'];

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mix = /*#__PURE__*/__webpack_require__(41);
	
	var _mix2 = /*#__PURE__*/_interopRequireDefault(_mix);
	
	var _curry = /*#__PURE__*/__webpack_require__(5);
	
	var _curry2 = /*#__PURE__*/_interopRequireDefault(_curry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Shades a color by mixing it with black. `shade` can produce
	 * hue shifts, where as `darken` manipulates the luminance channel and therefore
	 * doesn't produce hue shifts.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: shade(0.25, '#00f')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${shade(0.25, '#00f')};
	 * `
	 *
	 * // CSS in JS Output
	 *
	 * element {
	 *   background: "#00003f";
	 * }
	 */
	
	function shade(percentage, color) {
	  if (typeof percentage !== 'number' || percentage > 1 || percentage < -1) {
	    throw new Error('Passed an incorrect argument to shade, please pass a percentage less than or equal to 1 and larger than or equal to -1.');
	  }
	  if (typeof color !== 'string') {
	    throw new Error('Passed an incorrect argument to a color function, please pass a string representation of a color.');
	  }
	  return (0, _mix2.default)(percentage, color, 'rgb(0, 0, 0)');
	}
	
	var curriedShade = /*#__PURE__*/(0, _curry2.default)(shade);
	exports.default = curriedShade;
	module.exports = exports['default'];

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mix = /*#__PURE__*/__webpack_require__(41);
	
	var _mix2 = /*#__PURE__*/_interopRequireDefault(_mix);
	
	var _curry = /*#__PURE__*/__webpack_require__(5);
	
	var _curry2 = /*#__PURE__*/_interopRequireDefault(_curry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Tints a color by mixing it with white. `tint` can produce
	 * hue shifts, where as `lighten` manipulates the luminance channel and therefore
	 * doesn't produce hue shifts.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: tint(0.25, '#00f')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${tint(0.25, '#00f')};
	 * `
	 *
	 * // CSS in JS Output
	 *
	 * element {
	 *   background: "#bfbfff";
	 * }
	 */
	
	function tint(percentage, color) {
	  if (typeof percentage !== 'number' || percentage > 1 || percentage < -1) {
	    throw new Error('Passed an incorrect argument to tint, please pass a percentage less than or equal to 1 and larger than or equal to -1.');
	  }
	  if (typeof color !== 'string') {
	    throw new Error('Passed an incorrect argument to a color function, please pass a string representation of a color.');
	  }
	  return (0, _mix2.default)(percentage, color, 'rgb(255, 255, 255)');
	}
	
	var curriedTint = /*#__PURE__*/(0, _curry2.default)(tint);
	exports.default = curriedTint;
	module.exports = exports['default'];

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _rgba = /*#__PURE__*/__webpack_require__(25);
	
	var _rgba2 = /*#__PURE__*/_interopRequireDefault(_rgba);
	
	var _parseToRgb = /*#__PURE__*/__webpack_require__(15);
	
	var _parseToRgb2 = /*#__PURE__*/_interopRequireDefault(_parseToRgb);
	
	var _guard = /*#__PURE__*/__webpack_require__(23);
	
	var _guard2 = /*#__PURE__*/_interopRequireDefault(_guard);
	
	var _curry = /*#__PURE__*/__webpack_require__(5);
	
	var _curry2 = /*#__PURE__*/_interopRequireDefault(_curry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Decreases the opacity of a color. Its range for the amount is between 0 to 1.
	 *
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   background: transparentize(0.1, '#fff');
	 *   background: transparentize(0.2, 'hsl(0, 0%, 100%)'),
	 *   background: transparentize(0.5, 'rgba(255, 0, 0, 0.8)'),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   background: ${transparentize(0.1, '#fff')};
	 *   background: ${transparentize(0.2, 'hsl(0, 0%, 100%)')},
	 *   background: ${transparentize(0.5, 'rgba(255, 0, 0, 0.8)')},
	 * `
	 *
	 * // CSS in JS Output
	 *
	 * element {
	 *   background: "rgba(255,255,255,0.9)";
	 *   background: "rgba(255,255,255,0.8)";
	 *   background: "rgba(255,0,0,0.3)";
	 * }
	 */
	function transparentize(amount, color) {
	  var parsedColor = (0, _parseToRgb2.default)(color);
	  var alpha = typeof parsedColor.alpha === 'number' ? parsedColor.alpha : 1;
	  var colorWithAlpha = _extends({}, parsedColor, {
	    alpha: (0, _guard2.default)(0, 1, (alpha * 100 - amount * 100) / 100)
	  });
	  return (0, _rgba2.default)(colorWithAlpha);
	}
	
	var curriedTransparentize = /*#__PURE__*/(0, _curry2.default)(transparentize);
	exports.default = curriedTransparentize;
	module.exports = exports['default'];

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _pxto = /*#__PURE__*/__webpack_require__(64);
	
	var _pxto2 = /*#__PURE__*/_interopRequireDefault(_pxto);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Convert pixel value to ems. The default base value is 16px, but can be changed by passing a
	 * second argument to the function.
	 * @function
	 * @param {string|number} pxval
	 * @param {string|number} [base='16px']
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   'height': em('16px')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   height: ${em('16px')}
	 * `
	 *
	 * // CSS in JS Output
	 *
	 * element {
	 *   'height': '1em'
	 * }
	 */
	
	var em = /*#__PURE__*/(0, _pxto2.default)('em');
	exports.default = em;
	module.exports = exports['default'];

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ratioNames = undefined;
	
	var _stripUnit = /*#__PURE__*/__webpack_require__(43);
	
	var _stripUnit2 = /*#__PURE__*/_interopRequireDefault(_stripUnit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ratioNames = {
	  minorSecond: 1.067,
	  majorSecond: 1.125,
	  minorThird: 1.2,
	  majorThird: 1.25,
	  perfectFourth: 1.333,
	  augFourth: 1.414,
	  perfectFifth: 1.5,
	  minorSixth: 1.6,
	  goldenSection: 1.618,
	  majorSixth: 1.667,
	  minorSeventh: 1.778,
	  majorSeventh: 1.875,
	  octave: 2,
	  majorTenth: 2.5,
	  majorEleventh: 2.667,
	  majorTwelfth: 3,
	  doubleOctave: 4
	
	  /** */
	};
	
	/**
	 * Establish consistent measurements and spacial relationships throughout your projects by incrementing up or down a defined scale. We provide a list of commonly used scales as pre-defined variables, see below.
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *    // Increment two steps up the default scale
	 *   'fontSize': modularScale(2)
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *    // Increment two steps up the default scale
	 *   fontSize: ${modularScale(2)}
	 * `
	 *
	 * // CSS in JS Output
	 *
	 * element {
	 *   'fontSize': '1.77689em'
	 * }
	 */
	function modularScale(steps) {
	  var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '1em';
	  var ratio = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'perfectFourth';
	
	  if (typeof steps !== 'number') {
	    throw new Error('Please provide a number of steps to the modularScale helper.');
	  }
	  if (typeof ratio === 'string' && !ratioNames[ratio]) {
	    throw new Error('Please pass a number or one of the predefined scales to the modularScale helper as the ratio.');
	  }
	
	  var realBase = typeof base === 'string' ? (0, _stripUnit2.default)(base) : base;
	  var realRatio = typeof ratio === 'string' ? ratioNames[ratio] : ratio;
	
	  if (typeof realBase === 'string') {
	    throw new Error('Invalid value passed as base to modularScale, expected number or em string but got "' + base + '"');
	  }
	
	  return realBase * Math.pow(realRatio, steps) + 'em';
	}
	
	exports.ratioNames = ratioNames;
	exports.default = modularScale;

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _pxto = /*#__PURE__*/__webpack_require__(64);
	
	var _pxto2 = /*#__PURE__*/_interopRequireDefault(_pxto);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Convert pixel value to rems. The default base value is 16px, but can be changed by passing a
	 * second argument to the function.
	 * @function
	 * @param {string|number} pxval
	 * @param {string|number} [base='16px']
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   'height': rem('16px')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   height: ${rem('16px')}
	 * `
	 *
	 * // CSS in JS Output
	 *
	 * element {
	 *   'height': '1rem'
	 * }
	 */
	
	var rem = /*#__PURE__*/(0, _pxto2.default)('rem');
	
	exports.default = rem;
	module.exports = exports['default'];

/***/ }),
/* 152 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (string, suffix) {
	  return string.substr(-suffix.length) === suffix;
	};
	
	module.exports = exports["default"];

/***/ }),
/* 153 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var namedColorMap = {
	  aliceblue: 'f0f8ff',
	  antiquewhite: 'faebd7',
	  aqua: '00ffff',
	  aquamarine: '7fffd4',
	  azure: 'f0ffff',
	  beige: 'f5f5dc',
	  bisque: 'ffe4c4',
	  black: '000',
	  blanchedalmond: 'ffebcd',
	  blue: '0000ff',
	  blueviolet: '8a2be2',
	  brown: 'a52a2a',
	  burlywood: 'deb887',
	  cadetblue: '5f9ea0',
	  chartreuse: '7fff00',
	  chocolate: 'd2691e',
	  coral: 'ff7f50',
	  cornflowerblue: '6495ed',
	  cornsilk: 'fff8dc',
	  crimson: 'dc143c',
	  cyan: '00ffff',
	  darkblue: '00008b',
	  darkcyan: '008b8b',
	  darkgoldenrod: 'b8860b',
	  darkgray: 'a9a9a9',
	  darkgreen: '006400',
	  darkgrey: 'a9a9a9',
	  darkkhaki: 'bdb76b',
	  darkmagenta: '8b008b',
	  darkolivegreen: '556b2f',
	  darkorange: 'ff8c00',
	  darkorchid: '9932cc',
	  darkred: '8b0000',
	  darksalmon: 'e9967a',
	  darkseagreen: '8fbc8f',
	  darkslateblue: '483d8b',
	  darkslategray: '2f4f4f',
	  darkslategrey: '2f4f4f',
	  darkturquoise: '00ced1',
	  darkviolet: '9400d3',
	  deeppink: 'ff1493',
	  deepskyblue: '00bfff',
	  dimgray: '696969',
	  dimgrey: '696969',
	  dodgerblue: '1e90ff',
	  firebrick: 'b22222',
	  floralwhite: 'fffaf0',
	  forestgreen: '228b22',
	  fuchsia: 'ff00ff',
	  gainsboro: 'dcdcdc',
	  ghostwhite: 'f8f8ff',
	  gold: 'ffd700',
	  goldenrod: 'daa520',
	  gray: '808080',
	  green: '008000',
	  greenyellow: 'adff2f',
	  grey: '808080',
	  honeydew: 'f0fff0',
	  hotpink: 'ff69b4',
	  indianred: 'cd5c5c',
	  indigo: '4b0082',
	  ivory: 'fffff0',
	  khaki: 'f0e68c',
	  lavender: 'e6e6fa',
	  lavenderblush: 'fff0f5',
	  lawngreen: '7cfc00',
	  lemonchiffon: 'fffacd',
	  lightblue: 'add8e6',
	  lightcoral: 'f08080',
	  lightcyan: 'e0ffff',
	  lightgoldenrodyellow: 'fafad2',
	  lightgray: 'd3d3d3',
	  lightgreen: '90ee90',
	  lightgrey: 'd3d3d3',
	  lightpink: 'ffb6c1',
	  lightsalmon: 'ffa07a',
	  lightseagreen: '20b2aa',
	  lightskyblue: '87cefa',
	  lightslategray: '789',
	  lightslategrey: '789',
	  lightsteelblue: 'b0c4de',
	  lightyellow: 'ffffe0',
	  lime: '0f0',
	  limegreen: '32cd32',
	  linen: 'faf0e6',
	  magenta: 'f0f',
	  maroon: '800000',
	  mediumaquamarine: '66cdaa',
	  mediumblue: '0000cd',
	  mediumorchid: 'ba55d3',
	  mediumpurple: '9370db',
	  mediumseagreen: '3cb371',
	  mediumslateblue: '7b68ee',
	  mediumspringgreen: '00fa9a',
	  mediumturquoise: '48d1cc',
	  mediumvioletred: 'c71585',
	  midnightblue: '191970',
	  mintcream: 'f5fffa',
	  mistyrose: 'ffe4e1',
	  moccasin: 'ffe4b5',
	  navajowhite: 'ffdead',
	  navy: '000080',
	  oldlace: 'fdf5e6',
	  olive: '808000',
	  olivedrab: '6b8e23',
	  orange: 'ffa500',
	  orangered: 'ff4500',
	  orchid: 'da70d6',
	  palegoldenrod: 'eee8aa',
	  palegreen: '98fb98',
	  paleturquoise: 'afeeee',
	  palevioletred: 'db7093',
	  papayawhip: 'ffefd5',
	  peachpuff: 'ffdab9',
	  peru: 'cd853f',
	  pink: 'ffc0cb',
	  plum: 'dda0dd',
	  powderblue: 'b0e0e6',
	  purple: '800080',
	  rebeccapurple: '639',
	  red: 'f00',
	  rosybrown: 'bc8f8f',
	  royalblue: '4169e1',
	  saddlebrown: '8b4513',
	  salmon: 'fa8072',
	  sandybrown: 'f4a460',
	  seagreen: '2e8b57',
	  seashell: 'fff5ee',
	  sienna: 'a0522d',
	  silver: 'c0c0c0',
	  skyblue: '87ceeb',
	  slateblue: '6a5acd',
	  slategray: '708090',
	  slategrey: '708090',
	  snow: 'fffafa',
	  springgreen: '00ff7f',
	  steelblue: '4682b4',
	  tan: 'd2b48c',
	  teal: '008080',
	  thistle: 'd8bfd8',
	  tomato: 'ff6347',
	  turquoise: '40e0d0',
	  violet: 'ee82ee',
	  wheat: 'f5deb3',
	  white: 'fff',
	  whitesmoke: 'f5f5f5',
	  yellow: 'ff0',
	  yellowgreen: '9acd32'
	
	  /**
	   * Checks if a string is a CSS named color and returns its equivalent hex value, otherwise returns the original color.
	   * @private
	   */
	};function nameToHex(color) {
	  if (typeof color !== 'string') return color;
	  var normalizedColorName = color.toLowerCase();
	  return namedColorMap[normalizedColorName] ? '#' + namedColorMap[normalizedColorName] : color;
	}
	
	exports.default = nameToHex;
	module.exports = exports['default'];

/***/ }),
/* 154 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	function rgbToHsl(color) {
	  // make sure rgb are contained in a set of [0, 255]
	  var red = color.red / 255;
	  var green = color.green / 255;
	  var blue = color.blue / 255;
	
	  var max = Math.max(red, green, blue);
	  var min = Math.min(red, green, blue);
	  var lightness = (max + min) / 2;
	
	  if (max === min) {
	    // achromatic
	    if (color.alpha !== undefined) {
	      return {
	        hue: 0,
	        saturation: 0,
	        lightness: lightness,
	        alpha: color.alpha
	      };
	    } else {
	      return { hue: 0, saturation: 0, lightness: lightness };
	    }
	  }
	
	  var hue = void 0;
	  var delta = max - min;
	  var saturation = lightness > 0.5 ? delta / (2 - max - min) : delta / (max + min);
	  switch (max) {
	    case red:
	      hue = (green - blue) / delta + (green < blue ? 6 : 0);
	      break;
	    case green:
	      hue = (blue - red) / delta + 2;
	      break;
	    default:
	      // blue case
	      hue = (red - green) / delta + 4;
	      break;
	  }
	
	  hue *= 60;
	  if (color.alpha !== undefined) {
	    return {
	      hue: hue,
	      saturation: saturation,
	      lightness: lightness,
	      alpha: color.alpha
	    };
	  }
	  return { hue: hue, saturation: saturation, lightness: lightness };
	}
	
	exports.default = rgbToHsl;
	module.exports = exports['default'];

/***/ }),
/* 155 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	/**
	 * CSS to contain a float (credit to CSSMojo).
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *    ...clearFix(),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   ${clearFix()}
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * '&::after': {
	 *   'clear': 'both',
	 *   'content': '""',
	 *   'display': 'table'
	 * }
	 */
	
	function clearFix() {
	  var _ref;
	
	  var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '&';
	
	  var pseudoSelector = parent + '::after';
	  return _ref = {}, _ref[pseudoSelector] = {
	    clear: 'both',
	    content: '""',
	    display: 'table'
	  }, _ref;
	}
	
	exports.default = clearFix;
	module.exports = exports['default'];

/***/ }),
/* 156 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	/**
	 * CSS to represent truncated text with an ellipsis.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   ...ellipsis('250px')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   ${ellipsis('250px')}
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * div: {
	 *   'display': 'inline-block',
	 *   'maxWidth': '250px',
	 *   'overflow': 'hidden',
	 *   'textOverflow': 'ellipsis',
	 *   'whiteSpace': 'nowrap',
	 *   'wordWrap': 'normal'
	 * }
	 */
	
	function ellipsis() {
	  var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '100%';
	
	  return {
	    display: 'inline-block',
	    maxWidth: width,
	    overflow: 'hidden',
	    textOverflow: 'ellipsis',
	    whiteSpace: 'nowrap',
	    wordWrap: 'normal'
	  };
	}
	
	exports.default = ellipsis;
	module.exports = exports['default'];

/***/ }),
/* 157 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	function generateFileReferences(fontFilePath, fileFormats) {
	  var fileFontReferences = fileFormats.map(function (format) {
	    return 'url("' + fontFilePath + '.' + format + '")';
	  });
	  return fileFontReferences.join(', ');
	}
	
	/** */
	
	
	function generateLocalReferences(localFonts) {
	  var localFontReferences = localFonts.map(function (font) {
	    return 'local("' + font + '")';
	  });
	  return localFontReferences.join(', ');
	}
	
	function generateSources(fontFilePath, localFonts, fileFormats) {
	  var fontReferences = [];
	  if (localFonts) fontReferences.push(generateLocalReferences(localFonts));
	  if (fontFilePath) {
	    fontReferences.push(generateFileReferences(fontFilePath, fileFormats));
	  }
	  return fontReferences.join(', ');
	}
	
	/**
	 * CSS for a @font-face declaration.
	 *
	 * @example
	 * // Styles as object basic usage
	 * const styles = {
	 *    ...fontFace({
	 *      'fontFamily': 'Sans-Pro'
	 *      'fontFilePath': 'path/to/file'
	 *    })
	 * }
	 *
	 * // styled-components basic usage
	 * injectGlobal`${
	 *   fontFace({
	 *     'fontFamily': 'Sans-Pro'
	 *     'fontFilePath': 'path/to/file'
	 *   }
	 * )}`
	 *
	 * // CSS as JS Output
	 *
	 * '@font-face': {
	 *   'fontFamily': 'Sans-Pro',
	 *   'src': 'url("path/to/file.eot"), url("path/to/file.woff2"), url("path/to/file.woff"), url("path/to/file.ttf"), url("path/to/file.svg")',
	 * }
	 */
	
	function fontFace(_ref) {
	  var fontFamily = _ref.fontFamily,
	      fontFilePath = _ref.fontFilePath,
	      fontStretch = _ref.fontStretch,
	      fontStyle = _ref.fontStyle,
	      fontVariant = _ref.fontVariant,
	      fontWeight = _ref.fontWeight,
	      _ref$fileFormats = _ref.fileFormats,
	      fileFormats = _ref$fileFormats === undefined ? ['eot', 'woff2', 'woff', 'ttf', 'svg'] : _ref$fileFormats,
	      localFonts = _ref.localFonts,
	      unicodeRange = _ref.unicodeRange;
	
	  // Error Handling
	  if (!fontFamily) throw new Error('fontFace expects a name of a font-family.');
	  if (!fontFilePath && !localFonts) {
	    throw new Error('fontFace expects either the path to the font file(s) or a name of a local copy.');
	  }
	  if (localFonts && !Array.isArray(localFonts)) {
	    throw new Error('fontFace expects localFonts to be an array.');
	  }
	  if (!Array.isArray(fileFormats)) {
	    throw new Error('fontFace expects fileFormats to be an array.');
	  }
	
	  var fontFaceDeclaration = {
	    '@font-face': {
	      fontFamily: fontFamily,
	      src: generateSources(fontFilePath, localFonts, fileFormats),
	      unicodeRange: unicodeRange,
	      fontStretch: fontStretch,
	      fontStyle: fontStyle,
	      fontVariant: fontVariant,
	      fontWeight: fontWeight
	    }
	
	    // Removes undefined fields for cleaner css object.
	  };return JSON.parse(JSON.stringify(fontFaceDeclaration));
	}
	
	exports.default = fontFace;
	module.exports = exports['default'];

/***/ }),
/* 158 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	/**
	 * CSS to hide text to show a background image in a SEO-friendly way.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   'backgroundImage': 'url(logo.png)',
	 *   ...hideText(),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   backgroundImage: url(logo.png);
	 *   ${hideText()};
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * 'div': {
	 *   'backgroundImage': 'url(logo.png)',
	 *   'textIndent': '101%',
	 *   'overflow': 'hidden',
	 *   'whiteSpace': 'nowrap',
	 * }
	 */
	
	function hideText() {
	  return {
	    textIndent: '101%',
	    overflow: 'hidden',
	    whiteSpace: 'nowrap'
	  };
	}
	
	exports.default = hideText;
	module.exports = exports['default'];

/***/ }),
/* 159 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	/**
	 * CSS to hide content visually but remain accessible to screen readers.
	 * from [HTML5 Boilerplate](https://github.com/h5bp/html5-boilerplate/blob/9a176f57af1cfe8ec70300da4621fb9b07e5fa31/src/css/main.css#L121)
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   ...hideVisually(),
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   ${hideVisually()};
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * 'div': {
	 *   'border': '0',
	 *   'clip': 'rect(0 0 0 0)',
	 *   'clipPath': 'inset(50%)',
	 *   'height': '1px',
	 *   'margin': '-1px',
	 *   'overflow': 'hidden',
	 *   'padding': '0',
	 *   'position': 'absolute',
	 *   'whiteSpace': 'nowrap',
	 *   'width': '1px',
	 * }
	 */
	
	function hideVisually() {
	  return {
	    border: '0',
	    clip: 'rect(0 0 0 0)',
	    clipPath: 'inset(50%)',
	    height: '1px',
	    margin: '-1px',
	    overflow: 'hidden',
	    padding: '0',
	    position: 'absolute',
	    whiteSpace: 'nowrap',
	    width: '1px'
	  };
	}
	
	exports.default = hideVisually;
	module.exports = exports['default'];

/***/ }),
/* 160 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _opinionatedRules, _abbrTitle, _unopinionatedRules;
	
	var opinionatedRules = (_opinionatedRules = {
	  html: {
	    fontFamily: 'sans-serif'
	  },
	
	  body: {
	    margin: '0'
	  }
	
	}, _opinionatedRules['a:active,\n  a:hover'] = {
	  outlineWidth: '0'
	}, _opinionatedRules['button,\n  input,\n  optgroup,\n  select,\n  textarea'] = {
	  fontFamily: 'sans-serif',
	  fontSize: '100%',
	  lineHeight: '1.15'
	}, _opinionatedRules);
	
	var unopinionatedRules = (_unopinionatedRules = {
	  html: {
	    lineHeight: '1.15',
	    textSizeAdjust: '100%'
	  }
	
	}, _unopinionatedRules['article,\n  aside,\n  footer,\n  header,\n  nav,\n  section'] = {
	  display: 'block'
	}, _unopinionatedRules.h1 = {
	  fontSize: '2em',
	  margin: '0.67em 0'
	}, _unopinionatedRules['figcaption,\n  figure,\n  main'] = {
	  display: 'block'
	}, _unopinionatedRules.figure = {
	  margin: '1em 40px'
	}, _unopinionatedRules.hr = {
	  boxSizing: 'content-box',
	  height: '0',
	  overflow: 'visible'
	}, _unopinionatedRules.pre = {
	  fontFamily: 'monospace, monospace',
	  fontSize: '1em'
	}, _unopinionatedRules.a = {
	  'background-color': 'transparent',
	  '-webkit-text-decoration-skip': 'objects'
	}, _unopinionatedRules['abbr[title]'] = (_abbrTitle = {
	  borderBottom: 'none',
	  textDecoration: 'underline'
	}, _abbrTitle['textDecoration'] = 'underline dotted', _abbrTitle), _unopinionatedRules['b,\n  strong'] = {
	  fontWeight: 'inherit'
	}, _unopinionatedRules['code,\n  kbd,\n  samp'] = {
	  fontFamily: 'monospace, monospace',
	  fontSize: '1em'
	}, _unopinionatedRules.dfn = {
	  fontStyle: 'italic'
	}, _unopinionatedRules.mark = {
	  backgroundColor: '#ff0',
	  color: '#000'
	}, _unopinionatedRules.small = {
	  fontSize: '80%'
	}, _unopinionatedRules['sub,\n  sup'] = {
	  fontSize: '75%',
	  lineHeight: '0',
	  position: 'relative',
	  verticalAlign: 'baseline'
	}, _unopinionatedRules.sub = {
	  bottom: '-0.25em'
	}, _unopinionatedRules.sup = {
	  top: '-0.5em'
	}, _unopinionatedRules['audio,\n  video'] = {
	  display: 'inline-block'
	}, _unopinionatedRules['audio:not([controls])'] = {
	  display: 'none',
	  height: '0'
	}, _unopinionatedRules.img = {
	  borderStyle: 'none'
	}, _unopinionatedRules['svg:not(:root)'] = {
	  overflow: 'hidden'
	}, _unopinionatedRules['button,\n  input,\n  optgroup,\n  select,\n  textarea'] = {
	  margin: '0'
	}, _unopinionatedRules['button,\n  input'] = {
	  overflow: 'visible'
	}, _unopinionatedRules['button,\n  select'] = {
	  textTransform: 'none'
	}, _unopinionatedRules['button,\n  html [type="button"],\n  [type="reset"],\n  [type="submit"]'] = {
	  '-webkit-appearance': 'button'
	}, _unopinionatedRules['button::-moz-focus-inner,\n  [type="button"]::-moz-focus-inner,\n  [type="reset"]::-moz-focus-inner,\n  [type="submit"]::-moz-focus-inner'] = {
	  borderStyle: 'none',
	  padding: '0'
	}, _unopinionatedRules['button:-moz-focusring,\n  [type="button"]:-moz-focusring,\n  [type="reset"]:-moz-focusring,\n  [type="submit"]:-moz-focusring'] = {
	  outline: '1px dotted ButtonText'
	}, _unopinionatedRules.fieldset = {
	  border: '1px solid #c0c0c0',
	  margin: '0 2px',
	  padding: '0.35em 0.625em 0.75em'
	}, _unopinionatedRules.legend = {
	  boxSizing: 'border-box',
	  color: 'inherit',
	  display: 'table',
	  maxWidth: '100%',
	  padding: '0',
	  whiteSpace: 'normal'
	}, _unopinionatedRules.progress = {
	  display: 'inline-block',
	  verticalAlign: 'baseline'
	}, _unopinionatedRules.textarea = {
	  overflow: 'auto'
	}, _unopinionatedRules['[type="checkbox"],\n  [type="radio"]'] = {
	  boxSizing: 'border-box',
	  padding: '0'
	}, _unopinionatedRules['[type="number"]::-webkit-inner-spin-button,\n  [type="number"]::-webkit-outer-spin-button'] = {
	  height: 'auto'
	}, _unopinionatedRules['[type="search"]'] = {
	  '-webkit-appearance': 'textfield',
	  outlineOffset: '-2px'
	}, _unopinionatedRules['[type="search"]::-webkit-search-cancel-button,\n  [type="search"]::-webkit-search-decoration'] = {
	  '-webkit-appearance': 'none'
	}, _unopinionatedRules['::-webkit-file-upload-button'] = {
	  '-webkit-appearance': 'button',
	  font: 'inherit'
	}, _unopinionatedRules['details,\n  menu'] = {
	  display: 'block'
	}, _unopinionatedRules.summary = {
	  display: 'list-item'
	}, _unopinionatedRules.canvas = {
	  display: 'inline-block'
	}, _unopinionatedRules.template = {
	  display: 'none'
	}, _unopinionatedRules['[hidden]'] = {
	  display: 'none'
	}, _unopinionatedRules);
	
	function mergeRules(baseRules, additionalRules) {
	  var mergedRules = _extends({}, baseRules);
	  Object.keys(additionalRules).forEach(function (key) {
	    if (mergedRules[key]) {
	      mergedRules[key] = _extends({}, mergedRules[key], additionalRules[key]);
	    } else {
	      mergedRules[key] = _extends({}, additionalRules[key]);
	    }
	  });
	  return mergedRules;
	}
	
	/**
	 * CSS to normalize abnormalities across browsers (normalize.css v5.0.0 | MIT License | github.com/necolas/normalize.css)
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *    ...normalize(),
	 * }
	 *
	 * // styled-components usage
	 * injectGlobal`${normalize()}`
	 *
	 * // CSS as JS Output
	 *
	 * html {
	 *   fontFamily: 'sans-serif',
	 *   lineHeight: 1.15,
	 *   textSizeAdjust: 100%,
	 * } ...
	 */
	function normalize(excludeOpinionated) {
	  if (excludeOpinionated) return unopinionatedRules;
	  return mergeRules(unopinionatedRules, opinionatedRules);
	}
	
	exports.default = normalize;
	module.exports = exports['default'];

/***/ }),
/* 161 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	/**
	 * CSS to style the placeholder pseudo-element.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   ...placeholder({'color': 'blue'})
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.input`
	 *    ${placeholder({'color': 'blue'})}
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * 'input': {
	 *   '&:-moz-placeholder': {
	 *     'color': 'blue',
	 *   },
	 *   '&:-ms-input-placeholder': {
	 *     'color': 'blue',
	 *   },
	 *   '&::-moz-placeholder': {
	 *     'color': 'blue',
	 *   },
	 *   '&::-webkit-input-placeholder': {
	 *     'color': 'blue',
	 *   },
	 * },
	 */
	
	function placeholder(styles) {
	  var _ref;
	
	  var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '&';
	
	  return _ref = {}, _ref[parent + '::-webkit-input-placeholder'] = _extends({}, styles), _ref[parent + ':-moz-placeholder'] = _extends({}, styles), _ref[parent + '::-moz-placeholder'] = _extends({}, styles), _ref[parent + ':-ms-input-placeholder'] = _extends({}, styles), _ref;
	}
	
	exports.default = placeholder;
	module.exports = exports['default'];

/***/ }),
/* 162 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = /*#__PURE__*/ _taggedTemplateLiteralLoose(['radial-gradient(', '', '', '', ')'], ['radial-gradient(', '', '', '', ')']);
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function parseFallback(colorStops) {
	  return colorStops[0].split(' ')[0];
	}
	
	/** */
	
	
	function constructGradientValue(literals) {
	  var template = '';
	  for (var i = 0; i < literals.length; i += 1) {
	    template += literals[i];
	    // Adds leading coma if properties preceed color-stops
	    if (i === 3 && (arguments.length <= i + 1 ? undefined : arguments[i + 1]) && ((arguments.length <= 1 ? undefined : arguments[1]) || (arguments.length <= 2 ? undefined : arguments[2]) || (arguments.length <= 3 ? undefined : arguments[3]))) {
	      template = template.slice(0, -1);
	      template += ', ' + (arguments.length <= i + 1 ? undefined : arguments[i + 1]);
	      // No trailing space if color-stops is the only param provided
	    } else if (i === 3 && (arguments.length <= i + 1 ? undefined : arguments[i + 1]) && !(arguments.length <= 1 ? undefined : arguments[1]) && !(arguments.length <= 2 ? undefined : arguments[2]) && !(arguments.length <= 3 ? undefined : arguments[3])) {
	      template += '' + (arguments.length <= i + 1 ? undefined : arguments[i + 1]);
	      // Only adds substitution if it is defined
	    } else if (arguments.length <= i + 1 ? undefined : arguments[i + 1]) {
	      template += (arguments.length <= i + 1 ? undefined : arguments[i + 1]) + ' ';
	    }
	  }
	  return template.trim();
	}
	
	/**
	 * CSS for declaring a radial gradient, including a fallback background-color. The fallback is either the first color-stop or an explicitly passed fallback color.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   ...radialGradient({
	 *     colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
	 *     extent: 'farthest-corner at 45px 45px',
	 *     position: 'center',
	 *     shape: 'ellipse',
	 *   })
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   ${radialGradient({
	 *     colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
	 *     extent: 'farthest-corner at 45px 45px',
	 *     position: 'center',
	 *     shape: 'ellipse',
	 *   })}
	 *`
	 *
	 * // CSS as JS Output
	 *
	 * div: {
	 *   'backgroundColor': '#00FFFF',
	 *   'backgroundImage': 'radial-gradient(center ellipse farthest-corner at 45px 45px, #00FFFF 0%, rgba(0, 0, 255, 0) 50%, #0000FF 95%)',
	 * }
	 */
	
	function radialGradient(_ref) {
	  var colorStops = _ref.colorStops,
	      extent = _ref.extent,
	      fallback = _ref.fallback,
	      position = _ref.position,
	      shape = _ref.shape;
	
	  if (!colorStops || colorStops.length < 2) {
	    throw new Error('radialGradient requries at least 2 color-stops to properly render.');
	  }
	  return {
	    backgroundColor: fallback || parseFallback(colorStops),
	    backgroundImage: constructGradientValue(_templateObject, position, shape, extent, colorStops.join(', '))
	  };
	}
	
	exports.default = radialGradient;
	module.exports = exports['default'];

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _hiDPI = /*#__PURE__*/__webpack_require__(67);
	
	var _hiDPI2 = /*#__PURE__*/_interopRequireDefault(_hiDPI);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A helper to generate a retina background image and non-retina
	 * background image. The retina background image will output to a HiDPI media query. The mixin uses
	 * a _2x.png filename suffix by default.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *  ...retinaImage('my-img')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   ${retinaImage('my-img')}
	 * `
	 *
	 * // CSS as JS Output
	 * div {
	 *   backgroundImage: 'url(my-img.png)',
	 *   '@media only screen and (-webkit-min-device-pixel-ratio: 1.3),
	 *    only screen and (min--moz-device-pixel-ratio: 1.3),
	 *    only screen and (-o-min-device-pixel-ratio: 1.3/1),
	 *    only screen and (min-resolution: 144dpi),
	 *    only screen and (min-resolution: 1.5dppx)': {
	 *     backgroundImage: 'url(my-img_2x.png)',
	 *   }
	 * }
	 */
	function retinaImage(filename, backgroundSize) {
	  var extension = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'png';
	
	  var _ref;
	
	  var retinaFilename = arguments[3];
	  var retinaSuffix = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '_2x';
	
	  if (!filename) {
	    throw new Error('Please supply a filename to retinaImage() as the first argument.');
	  }
	  // Replace the dot at the beginning of the passed extension if one exists
	  var ext = extension.replace(/^\./, '');
	  var rFilename = retinaFilename ? retinaFilename + '.' + ext : '' + filename + retinaSuffix + '.' + ext;
	
	  return _ref = {
	    backgroundImage: 'url(' + filename + '.' + ext + ')'
	  }, _ref[(0, _hiDPI2.default)()] = {
	    backgroundImage: 'url(' + rFilename + ')',
	    backgroundSize: backgroundSize
	  }, _ref;
	}
	
	exports.default = retinaImage;
	module.exports = exports['default'];

/***/ }),
/* 164 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	/**
	 * CSS to style the selection pseudo-element.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   ...selection({
	 *     'backgroundColor': 'blue'
	 *   }, 'section')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   ${selection({'backgroundColor': 'blue'}, 'section')}
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * 'div': {
	 *   'section::-moz-selection': {
	 *     'backgroundColor':'blue',
	 *   },
	 *   'section::selection': {
	 *     'backgroundColor': 'blue',
	 *   }
	 * }
	 */
	
	function selection(styles) {
	  var _ref;
	
	  var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	  return _ref = {}, _ref[parent + '::-moz-selection'] = _extends({}, styles), _ref[parent + '::selection'] = _extends({}, styles), _ref;
	}
	
	exports.default = selection;
	module.exports = exports['default'];

/***/ }),
/* 165 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	/* eslint-disable key-spacing */
	var functionsMap = {
	  easeInBack: 'cubic-bezier(0.600, -0.280, 0.735, 0.045)',
	  easeInCirc: 'cubic-bezier(0.600,  0.040, 0.980, 0.335)',
	  easeInCubic: 'cubic-bezier(0.550,  0.055, 0.675, 0.190)',
	  easeInExpo: 'cubic-bezier(0.950,  0.050, 0.795, 0.035)',
	  easeInQuad: 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
	  easeInQuart: 'cubic-bezier(0.895,  0.030, 0.685, 0.220)',
	  easeInQuint: 'cubic-bezier(0.755,  0.050, 0.855, 0.060)',
	  easeInSine: 'cubic-bezier(0.470,  0.000, 0.745, 0.715)',
	
	  easeOutBack: 'cubic-bezier(0.175,  0.885, 0.320, 1.275)',
	  easeOutCubic: 'cubic-bezier(0.215,  0.610, 0.355, 1.000)',
	  easeOutCirc: 'cubic-bezier(0.075,  0.820, 0.165, 1.000)',
	  easeOutExpo: 'cubic-bezier(0.190,  1.000, 0.220, 1.000)',
	  easeOutQuad: 'cubic-bezier(0.250,  0.460, 0.450, 0.940)',
	  easeOutQuart: 'cubic-bezier(0.165,  0.840, 0.440, 1.000)',
	  easeOutQuint: 'cubic-bezier(0.230,  1.000, 0.320, 1.000)',
	  easeOutSine: 'cubic-bezier(0.390,  0.575, 0.565, 1.000)',
	
	  easeInOutBack: 'cubic-bezier(0.680, -0.550, 0.265, 1.550)',
	  easeInOutCirc: 'cubic-bezier(0.785,  0.135, 0.150, 0.860)',
	  easeInOutCubic: 'cubic-bezier(0.645,  0.045, 0.355, 1.000)',
	  easeInOutExpo: 'cubic-bezier(1.000,  0.000, 0.000, 1.000)',
	  easeInOutQuad: 'cubic-bezier(0.455,  0.030, 0.515, 0.955)',
	  easeInOutQuart: 'cubic-bezier(0.770,  0.000, 0.175, 1.000)',
	  easeInOutQuint: 'cubic-bezier(0.860,  0.000, 0.070, 1.000)',
	  easeInOutSine: 'cubic-bezier(0.445,  0.050, 0.550, 0.950)'
	  /* eslint-enable key-spacing */
	
	  /** */
	};
	
	/**
	 * String to represent common easing functions as demonstrated here: (github.com/jaukia/easie).
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   'transitionTimingFunction': timingFunctions('easeInQuad')
	 * }
	 *
	 * // styled-components usage
	 *  const div = styled.div`
	 *   transitionTimingFunction: ${timingFunctions('easeInQuad')};
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * 'div': {
	 *   'transitionTimingFunction': 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
	 * }
	 */
	
	function timingFunctions(timingFunction) {
	  return functionsMap[timingFunction];
	}
	
	exports.default = timingFunctions;
	module.exports = exports['default'];

/***/ }),
/* 166 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	/** */
	var getBorderWidth = function getBorderWidth(pointingDirection, height, width) {
	  switch (pointingDirection) {
	    case 'top':
	      return '0 ' + width / 2 + 'px ' + height + 'px ' + width / 2 + 'px';
	    case 'left':
	      return height / 2 + 'px ' + width + 'px ' + height / 2 + 'px 0';
	    case 'bottom':
	      return height + 'px ' + width / 2 + 'px 0 ' + width / 2 + 'px';
	    case 'right':
	      return height / 2 + 'px 0 ' + height / 2 + 'px ' + width + 'px';
	
	    default:
	      throw new Error("Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.");
	  }
	};
	
	// needed for border-color
	var reverseDirection = {
	  left: 'Right',
	  right: 'Left',
	  top: 'Bottom',
	  bottom: 'Top'
	
	  /**
	   * CSS to represent triangle with any pointing direction with an optional background color. Accepts number or px values for height and width.
	   *
	   * @example
	   * // Styles as object usage
	   *
	   * const styles = {
	   *   ...triangle({ pointingDirection: 'right', width: '100px', height: '100px', foregroundColor: 'red' })
	   * }
	   *
	   *
	   * // styled-components usage
	   * const div = styled.div`
	   *   ${triangle({ pointingDirection: 'right', width: '100px', height: '100px', foregroundColor: 'red' })}
	   *
	   *
	   * // CSS as JS Output
	   *
	   * div: {
	   *  'borderColor': 'transparent',
	   *  'borderLeftColor': 'red !important',
	   *  'borderStyle': 'solid',
	   *  'borderWidth': '50px 0 50px 100px',
	   *  'height': '0',
	   *  'width': '0',
	   * }
	   */
	
	};function triangle(_ref) {
	  var _ref2;
	
	  var pointingDirection = _ref.pointingDirection,
	      height = _ref.height,
	      width = _ref.width,
	      foregroundColor = _ref.foregroundColor,
	      _ref$backgroundColor = _ref.backgroundColor,
	      backgroundColor = _ref$backgroundColor === undefined ? 'transparent' : _ref$backgroundColor;
	
	  var unitlessHeight = parseFloat(height);
	  var unitlessWidth = parseFloat(width);
	  if (isNaN(unitlessHeight) || isNaN(unitlessWidth)) {
	    throw new Error('Passed an invalid value to `height` or `width`. Please provide a pixel based unit');
	  }
	
	  return _ref2 = {
	    borderColor: backgroundColor,
	    width: '0',
	    height: '0',
	    borderWidth: getBorderWidth(pointingDirection, unitlessHeight, unitlessWidth),
	    borderStyle: 'solid'
	  }, _ref2['border' + reverseDirection[pointingDirection] + 'Color'] = foregroundColor + ' !important', _ref2;
	}
	
	exports.default = triangle;
	module.exports = exports['default'];

/***/ }),
/* 167 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	/**
	 * Provides an easy way to change the `wordWrap` property.
	 *
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   ...wordWrap('break-word')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   ${wordWrap('break-word')}
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * const styles = {
	 *   overflowWrap: 'break-word',
	 *   wordWrap: 'break-word',
	 *   wordBreak: 'break-all',
	 * }
	 */
	
	function wordWrap() {
	  var wrap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'break-word';
	
	  var wordBreak = wrap === 'break-word' ? 'break-all' : wrap;
	  return {
	    overflowWrap: wrap,
	    wordWrap: wrap,
	    wordBreak: wordBreak
	  };
	}
	
	exports.default = wordWrap;
	module.exports = exports['default'];

/***/ }),
/* 168 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	/**
	 * Shorthand for easily setting the animation property. Allows either multiple arrays with animations
	 * or a single animation spread over the arguments.
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   ...animation(['rotate', '1s', 'ease-in-out'], ['colorchange', '2s'])
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   ${animation(['rotate', '1s', 'ease-in-out'], ['colorchange', '2s'])}
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * div {
	 *   'animation': 'rotate 1s ease-in-out, colorchange 2s'
	 * }
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   ...animation('rotate', '1s', 'ease-in-out')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   ${animation('rotate', '1s', 'ease-in-out')}
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * div {
	 *   'animation': 'rotate 1s ease-in-out'
	 * }
	 */
	function animation() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  // Allow single or multiple animations passed
	  var multiMode = Array.isArray(args[0]);
	  if (!multiMode && args.length > 8) {
	    throw new Error('The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation');
	  }
	  var code = args.map(function (arg) {
	    if (multiMode && !Array.isArray(arg) || !multiMode && Array.isArray(arg)) {
	      throw new Error("To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s')");
	    }
	    if (Array.isArray(arg) && arg.length > 8) {
	      throw new Error('The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation');
	    }
	
	    return Array.isArray(arg) ? arg.join(' ') : arg;
	  }).join(', ');
	
	  return {
	    animation: code
	  };
	}
	
	/** */
	exports.default = animation;
	module.exports = exports['default'];

/***/ }),
/* 169 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	/**
	 * Shorthand that accepts any number of backgroundImage values as parameters for creating a single background statement.
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   ...backgroundImages('url("/image/background.jpg")', 'linear-gradient(red, green)')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   ${backgroundImages('url("/image/background.jpg")', 'linear-gradient(red, green)')}
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * div {
	 *   'backgroundImage': 'url("/image/background.jpg"), linear-gradient(red, green)'
	 * }
	 */
	
	function backgroundImages() {
	  for (var _len = arguments.length, properties = Array(_len), _key = 0; _key < _len; _key++) {
	    properties[_key] = arguments[_key];
	  }
	
	  return {
	    backgroundImage: properties.join(', ')
	  };
	}
	
	exports.default = backgroundImages;
	module.exports = exports['default'];

/***/ }),
/* 170 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	/**
	 * Shorthand that accepts any number of background values as parameters for creating a single background statement.
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   ...backgrounds('url("/image/background.jpg")', 'linear-gradient(red, green)', 'center no-repeat')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   ${backgrounds('url("/image/background.jpg")', 'linear-gradient(red, green)', 'center no-repeat')}
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * div {
	 *   'background': 'url("/image/background.jpg"), linear-gradient(red, green), center no-repeat'
	 * }
	 */
	function backgrounds() {
	  for (var _len = arguments.length, properties = Array(_len), _key = 0; _key < _len; _key++) {
	    properties[_key] = arguments[_key];
	  }
	
	  return {
	    background: properties.join(', ')
	  };
	}
	
	exports.default = backgrounds;
	module.exports = exports['default'];

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _directionalProperty = /*#__PURE__*/__webpack_require__(18);
	
	var _directionalProperty2 = /*#__PURE__*/_interopRequireDefault(_directionalProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   ...borderColor('red', 'green', 'blue', 'yellow')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   ${borderColor('red', 'green', 'blue', 'yellow')}
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * div {
	 *   'borderTopColor': 'red',
	 *   'borderRightColor': 'green',
	 *   'borderBottomColor': 'blue',
	 *   'borderLeftColor': 'yellow'
	 * }
	 */
	
	function borderColor() {
	  for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
	    values[_key] = arguments[_key];
	  }
	
	  return _directionalProperty2.default.apply(undefined, ['borderColor'].concat(values));
	}
	exports.default = borderColor;
	module.exports = exports['default'];

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _capitalizeString = /*#__PURE__*/__webpack_require__(61);
	
	var _capitalizeString2 = /*#__PURE__*/_interopRequireDefault(_capitalizeString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Shorthand that accepts a value for side and a value for radius and applies the radius value to both corners of the side.
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   ...borderRadius('top', '5px')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   ${borderRadius('top', '5px')}
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * div {
	 *   'borderTopRightRadius': '5px',
	 *   'borderTopLeftRadius': '5px',
	 * }
	 */
	
	function borderRadius(side, radius) {
	  var uppercaseSide = (0, _capitalizeString2.default)(side);
	  if (!radius && radius !== 0) {
	    throw new Error('borderRadius expects a radius value as a string or number as the second argument.');
	  }
	  if (uppercaseSide === 'Top' || uppercaseSide === 'Bottom') {
	    var _ref;
	
	    return _ref = {}, _ref['border' + uppercaseSide + 'RightRadius'] = radius, _ref['border' + uppercaseSide + 'LeftRadius'] = radius, _ref;
	  }
	
	  if (uppercaseSide === 'Left' || uppercaseSide === 'Right') {
	    var _ref2;
	
	    return _ref2 = {}, _ref2['borderTop' + uppercaseSide + 'Radius'] = radius, _ref2['borderBottom' + uppercaseSide + 'Radius'] = radius, _ref2;
	  }
	
	  throw new Error('borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.');
	}
	exports.default = borderRadius;
	module.exports = exports['default'];

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _directionalProperty = /*#__PURE__*/__webpack_require__(18);
	
	var _directionalProperty2 = /*#__PURE__*/_interopRequireDefault(_directionalProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   ...borderStyle('solid', 'dashed', 'dotted', 'double')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   ${borderStyle('solid', 'dashed', 'dotted', 'double')}
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * div {
	 *   'borderTopStyle': 'solid',
	 *   'borderRightStyle': 'dashed',
	 *   'borderBottomStyle': 'dotted',
	 *   'borderLeftStyle': 'double'
	 * }
	 */
	
	function borderStyle() {
	  for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
	    values[_key] = arguments[_key];
	  }
	
	  return _directionalProperty2.default.apply(undefined, ['borderStyle'].concat(values));
	}
	exports.default = borderStyle;
	module.exports = exports['default'];

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _directionalProperty = /*#__PURE__*/__webpack_require__(18);
	
	var _directionalProperty2 = /*#__PURE__*/_interopRequireDefault(_directionalProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   ...borderWidth('12px', '24px', '36px', '48px')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   ${borderWidth('12px', '24px', '36px', '48px')}
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * div {
	 *   'borderTopWidth': '12px',
	 *   'borderRightWidth': '24px',
	 *   'borderBottomWidth': '36px',
	 *   'borderLeftWidth': '48px'
	 * }
	 */
	function borderWidth() {
	  for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
	    values[_key] = arguments[_key];
	  }
	
	  return _directionalProperty2.default.apply(undefined, ['borderWidth'].concat(values));
	}
	exports.default = borderWidth;
	module.exports = exports['default'];

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _statefulSelectors = /*#__PURE__*/__webpack_require__(66);
	
	var _statefulSelectors2 = /*#__PURE__*/_interopRequireDefault(_statefulSelectors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var stateMap = [undefined, null, 'active', 'focus', 'hover'];
	
	
	function template(state) {
	  return 'button' + state + ',\n  input[type="button"]' + state + ',\n  input[type="reset"]' + state + ',\n  input[type="submit"]' + state;
	}
	
	/**
	 * Populates selectors that target all buttons. You can pass optional states to append to the selectors.
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   [buttons('active')]: {
	 *     'border': 'none'
	 *   }
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   > ${buttons('active')} {
	 *     border: none;
	 *   }
	 * `
	 *
	 * // CSS in JS Output
	 *
	 *  'button:active,
	 *  'input[type="button"]:active,
	 *  'input[type=\"reset\"]:active,
	 *  'input[type=\"submit\"]:active: {
	 *   'border': 'none'
	 * }
	 */
	
	function buttons() {
	  for (var _len = arguments.length, states = Array(_len), _key = 0; _key < _len; _key++) {
	    states[_key] = arguments[_key];
	  }
	
	  return (0, _statefulSelectors2.default)(states, template, stateMap);
	}
	
	exports.default = buttons;
	module.exports = exports['default'];

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _directionalProperty = /*#__PURE__*/__webpack_require__(18);
	
	var _directionalProperty2 = /*#__PURE__*/_interopRequireDefault(_directionalProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   ...margin('12px', '24px', '36px', '48px')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   ${margin('12px', '24px', '36px', '48px')}
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * div {
	 *   'marginTop': '12px',
	 *   'marginRight': '24px',
	 *   'marginBottom': '36px',
	 *   'marginLeft': '48px'
	 * }
	 */
	
	function margin() {
	  for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
	    values[_key] = arguments[_key];
	  }
	
	  return _directionalProperty2.default.apply(undefined, ['margin'].concat(values));
	}
	exports.default = margin;
	module.exports = exports['default'];

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _directionalProperty = /*#__PURE__*/__webpack_require__(18);
	
	var _directionalProperty2 = /*#__PURE__*/_interopRequireDefault(_directionalProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   ...padding('12px', '24px', '36px', '48px')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   ${padding('12px', '24px', '36px', '48px')}
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * div {
	 *   'paddingTop': '12px',
	 *   'paddingRight': '24px',
	 *   'paddingBottom': '36px',
	 *   'paddingLeft': '48px'
	 * }
	 */
	
	function padding() {
	  for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
	    values[_key] = arguments[_key];
	  }
	
	  return _directionalProperty2.default.apply(undefined, ['padding'].concat(values));
	}
	exports.default = padding;
	module.exports = exports['default'];

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _directionalProperty = /*#__PURE__*/__webpack_require__(18);
	
	var _directionalProperty2 = /*#__PURE__*/_interopRequireDefault(_directionalProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var positionMap = ['absolute', 'fixed', 'relative', 'static', 'sticky'];
	
	/**
	 * Shorthand accepts up to five values, including null to skip a value, and maps them to their respective directions. The first value can optionally be a position keyword.
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   ...position('12px', '24px', '36px', '48px')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   ${position('12px', '24px', '36px', '48px')}
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * div {
	 *   'top': '12px',
	 *   'right': '24px',
	 *   'bottom': '36px',
	 *   'left': '48px'
	 * }
	 *
	 * // Styles as object usage
	 * const styles = {
	 *   ...position('absolute', '12px', '24px', '36px', '48px')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   ${position('absolute', '12px', '24px', '36px', '48px')}
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * div {
	 *   'position': 'absolute',
	 *   'top': '12px',
	 *   'right': '24px',
	 *   'bottom': '36px',
	 *   'left': '48px'
	 * }
	 */
	
	function position(positionKeyword) {
	  for (var _len = arguments.length, values = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    values[_key - 1] = arguments[_key];
	  }
	
	  if (positionMap.indexOf(positionKeyword) >= 0) {
	    return _extends({
	      position: positionKeyword
	    }, _directionalProperty2.default.apply(undefined, [''].concat(values)));
	  } else {
	    var firstValue = positionKeyword; // in this case position is actually the first value
	    return _directionalProperty2.default.apply(undefined, ['', firstValue].concat(values));
	  }
	}
	
	exports.default = position;
	module.exports = exports['default'];

/***/ }),
/* 179 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	/**
	 * Shorthand to set the height and width properties in a single statement.
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   ...size('300px', '250px')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   ${size('300px', '250px')}
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * div {
	 *   'height': '300px',
	 *   'width': '250px',
	 * }
	 */
	
	function size(height) {
	  var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : height;
	
	  return {
	    height: height,
	    width: width
	  };
	}
	
	exports.default = size;
	module.exports = exports["default"];

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _statefulSelectors = /*#__PURE__*/__webpack_require__(66);
	
	var _statefulSelectors2 = /*#__PURE__*/_interopRequireDefault(_statefulSelectors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var stateMap = [undefined, null, 'active', 'focus', 'hover'];
	
	
	function template(state) {
	  return 'input[type="color"]' + state + ',\n    input[type="date"]' + state + ',\n    input[type="datetime"]' + state + ',\n    input[type="datetime-local"]' + state + ',\n    input[type="email"]' + state + ',\n    input[type="month"]' + state + ',\n    input[type="number"]' + state + ',\n    input[type="password"]' + state + ',\n    input[type="search"]' + state + ',\n    input[type="tel"]' + state + ',\n    input[type="text"]' + state + ',\n    input[type="time"]' + state + ',\n    input[type="url"]' + state + ',\n    input[type="week"]' + state + ',\n    input:not([type])' + state + ',\n    textarea' + state;
	}
	
	/**
	 * Populates selectors that target all text inputs. You can pass optional states to append to the selectors.
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   [textInputs('active')]: {
	 *     'border': 'none'
	 *   }
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   > ${textInputs('active')} {
	 *     border: none;
	 *   }
	 * `
	 *
	 * // CSS in JS Output
	 *
	 *  'input[type="color"]:active,
	 *  input[type="date"]:active,
	 *  input[type="datetime"]:active,
	 *  input[type="datetime-local"]:active,
	 *  input[type="email"]:active,
	 *  input[type="month"]:active,
	 *  input[type="number"]:active,
	 *  input[type="password"]:active,
	 *  input[type="search"]:active,
	 *  input[type="tel"]:active,
	 *  input[type="text"]:active,
	 *  input[type="time"]:active,
	 *  input[type="url"]:active,
	 *  input[type="week"]:active,
	 *  input:not([type]):active,
	 *  textarea:active': {
	 *   'border': 'none'
	 * }
	 */
	
	function textInputs() {
	  for (var _len = arguments.length, states = Array(_len), _key = 0; _key < _len; _key++) {
	    states[_key] = arguments[_key];
	  }
	
	  return (0, _statefulSelectors2.default)(states, template, stateMap);
	}
	
	exports.default = textInputs;
	module.exports = exports['default'];

/***/ }),
/* 181 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	/**
	 * Shorthand that accepts any number of transition values as parameters for creating a single transition statement.
	 * @example
	 * // Styles as object usage
	 * const styles = {
	 *   ...transitions('opacity 1.0s ease-in 0s', 'width 2.0s ease-in 2s')
	 * }
	 *
	 * // styled-components usage
	 * const div = styled.div`
	 *   ${transitions('opacity 1.0s ease-in 0s', 'width 2.0s ease-in 2s')}
	 * `
	 *
	 * // CSS as JS Output
	 *
	 * div {
	 *   'transition': 'opacity 1.0s ease-in 0s, width 2.0s ease-in 2s'
	 * }
	 */
	
	function transitions() {
	  for (var _len = arguments.length, properties = Array(_len), _key = 0; _key < _len; _key++) {
	    properties[_key] = arguments[_key];
	  }
	
	  return {
	    transition: properties.join(', ')
	  };
	}
	
	exports.default = transitions;
	module.exports = exports['default'];

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var stringify = __webpack_require__(184);
	var parse = __webpack_require__(183);
	var formats = __webpack_require__(68);
	
	module.exports = {
	    formats: formats,
	    parse: parse,
	    stringify: stringify
	};


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(69);
	
	var has = Object.prototype.hasOwnProperty;
	
	var defaults = {
	    allowDots: false,
	    allowPrototypes: false,
	    arrayLimit: 20,
	    decoder: utils.decode,
	    delimiter: '&',
	    depth: 5,
	    parameterLimit: 1000,
	    plainObjects: false,
	    strictNullHandling: false
	};
	
	var parseValues = function parseQueryStringValues(str, options) {
	    var obj = {};
	    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
	    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
	    var parts = cleanStr.split(options.delimiter, limit);
	
	    for (var i = 0; i < parts.length; ++i) {
	        var part = parts[i];
	
	        var bracketEqualsPos = part.indexOf(']=');
	        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;
	
	        var key, val;
	        if (pos === -1) {
	            key = options.decoder(part, defaults.decoder);
	            val = options.strictNullHandling ? null : '';
	        } else {
	            key = options.decoder(part.slice(0, pos), defaults.decoder);
	            val = options.decoder(part.slice(pos + 1), defaults.decoder);
	        }
	        if (has.call(obj, key)) {
	            obj[key] = [].concat(obj[key]).concat(val);
	        } else {
	            obj[key] = val;
	        }
	    }
	
	    return obj;
	};
	
	var parseObject = function (chain, val, options) {
	    var leaf = val;
	
	    for (var i = chain.length - 1; i >= 0; --i) {
	        var obj;
	        var root = chain[i];
	
	        if (root === '[]') {
	            obj = [];
	            obj = obj.concat(leaf);
	        } else {
	            obj = options.plainObjects ? Object.create(null) : {};
	            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
	            var index = parseInt(cleanRoot, 10);
	            if (
	                !isNaN(index)
	                && root !== cleanRoot
	                && String(index) === cleanRoot
	                && index >= 0
	                && (options.parseArrays && index <= options.arrayLimit)
	            ) {
	                obj = [];
	                obj[index] = leaf;
	            } else {
	                obj[cleanRoot] = leaf;
	            }
	        }
	
	        leaf = obj;
	    }
	
	    return leaf;
	};
	
	var parseKeys = function parseQueryStringKeys(givenKey, val, options) {
	    if (!givenKey) {
	        return;
	    }
	
	    // Transform dot notation to bracket notation
	    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;
	
	    // The regex chunks
	
	    var brackets = /(\[[^[\]]*])/;
	    var child = /(\[[^[\]]*])/g;
	
	    // Get the parent
	
	    var segment = brackets.exec(key);
	    var parent = segment ? key.slice(0, segment.index) : key;
	
	    // Stash the parent if it exists
	
	    var keys = [];
	    if (parent) {
	        // If we aren't using plain objects, optionally prefix keys
	        // that would overwrite object prototype properties
	        if (!options.plainObjects && has.call(Object.prototype, parent)) {
	            if (!options.allowPrototypes) {
	                return;
	            }
	        }
	
	        keys.push(parent);
	    }
	
	    // Loop through children appending to the array until we hit depth
	
	    var i = 0;
	    while ((segment = child.exec(key)) !== null && i < options.depth) {
	        i += 1;
	        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
	            if (!options.allowPrototypes) {
	                return;
	            }
	        }
	        keys.push(segment[1]);
	    }
	
	    // If there's a remainder, just add whatever is left
	
	    if (segment) {
	        keys.push('[' + key.slice(segment.index) + ']');
	    }
	
	    return parseObject(keys, val, options);
	};
	
	module.exports = function (str, opts) {
	    var options = opts ? utils.assign({}, opts) : {};
	
	    if (options.decoder !== null && options.decoder !== undefined && typeof options.decoder !== 'function') {
	        throw new TypeError('Decoder has to be a function.');
	    }
	
	    options.ignoreQueryPrefix = options.ignoreQueryPrefix === true;
	    options.delimiter = typeof options.delimiter === 'string' || utils.isRegExp(options.delimiter) ? options.delimiter : defaults.delimiter;
	    options.depth = typeof options.depth === 'number' ? options.depth : defaults.depth;
	    options.arrayLimit = typeof options.arrayLimit === 'number' ? options.arrayLimit : defaults.arrayLimit;
	    options.parseArrays = options.parseArrays !== false;
	    options.decoder = typeof options.decoder === 'function' ? options.decoder : defaults.decoder;
	    options.allowDots = typeof options.allowDots === 'boolean' ? options.allowDots : defaults.allowDots;
	    options.plainObjects = typeof options.plainObjects === 'boolean' ? options.plainObjects : defaults.plainObjects;
	    options.allowPrototypes = typeof options.allowPrototypes === 'boolean' ? options.allowPrototypes : defaults.allowPrototypes;
	    options.parameterLimit = typeof options.parameterLimit === 'number' ? options.parameterLimit : defaults.parameterLimit;
	    options.strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : defaults.strictNullHandling;
	
	    if (str === '' || str === null || typeof str === 'undefined') {
	        return options.plainObjects ? Object.create(null) : {};
	    }
	
	    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
	    var obj = options.plainObjects ? Object.create(null) : {};
	
	    // Iterate over the keys and setup the new object
	
	    var keys = Object.keys(tempObj);
	    for (var i = 0; i < keys.length; ++i) {
	        var key = keys[i];
	        var newObj = parseKeys(key, tempObj[key], options);
	        obj = utils.merge(obj, newObj, options);
	    }
	
	    return utils.compact(obj);
	};


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(69);
	var formats = __webpack_require__(68);
	
	var arrayPrefixGenerators = {
	    brackets: function brackets(prefix) { // eslint-disable-line func-name-matching
	        return prefix + '[]';
	    },
	    indices: function indices(prefix, key) { // eslint-disable-line func-name-matching
	        return prefix + '[' + key + ']';
	    },
	    repeat: function repeat(prefix) { // eslint-disable-line func-name-matching
	        return prefix;
	    }
	};
	
	var toISO = Date.prototype.toISOString;
	
	var defaults = {
	    delimiter: '&',
	    encode: true,
	    encoder: utils.encode,
	    encodeValuesOnly: false,
	    serializeDate: function serializeDate(date) { // eslint-disable-line func-name-matching
	        return toISO.call(date);
	    },
	    skipNulls: false,
	    strictNullHandling: false
	};
	
	var stringify = function stringify( // eslint-disable-line func-name-matching
	    object,
	    prefix,
	    generateArrayPrefix,
	    strictNullHandling,
	    skipNulls,
	    encoder,
	    filter,
	    sort,
	    allowDots,
	    serializeDate,
	    formatter,
	    encodeValuesOnly
	) {
	    var obj = object;
	    if (typeof filter === 'function') {
	        obj = filter(prefix, obj);
	    } else if (obj instanceof Date) {
	        obj = serializeDate(obj);
	    } else if (obj === null) {
	        if (strictNullHandling) {
	            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder) : prefix;
	        }
	
	        obj = '';
	    }
	
	    if (typeof obj === 'string' || typeof obj === 'number' || typeof obj === 'boolean' || utils.isBuffer(obj)) {
	        if (encoder) {
	            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder);
	            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder))];
	        }
	        return [formatter(prefix) + '=' + formatter(String(obj))];
	    }
	
	    var values = [];
	
	    if (typeof obj === 'undefined') {
	        return values;
	    }
	
	    var objKeys;
	    if (Array.isArray(filter)) {
	        objKeys = filter;
	    } else {
	        var keys = Object.keys(obj);
	        objKeys = sort ? keys.sort(sort) : keys;
	    }
	
	    for (var i = 0; i < objKeys.length; ++i) {
	        var key = objKeys[i];
	
	        if (skipNulls && obj[key] === null) {
	            continue;
	        }
	
	        if (Array.isArray(obj)) {
	            values = values.concat(stringify(
	                obj[key],
	                generateArrayPrefix(prefix, key),
	                generateArrayPrefix,
	                strictNullHandling,
	                skipNulls,
	                encoder,
	                filter,
	                sort,
	                allowDots,
	                serializeDate,
	                formatter,
	                encodeValuesOnly
	            ));
	        } else {
	            values = values.concat(stringify(
	                obj[key],
	                prefix + (allowDots ? '.' + key : '[' + key + ']'),
	                generateArrayPrefix,
	                strictNullHandling,
	                skipNulls,
	                encoder,
	                filter,
	                sort,
	                allowDots,
	                serializeDate,
	                formatter,
	                encodeValuesOnly
	            ));
	        }
	    }
	
	    return values;
	};
	
	module.exports = function (object, opts) {
	    var obj = object;
	    var options = opts ? utils.assign({}, opts) : {};
	
	    if (options.encoder !== null && options.encoder !== undefined && typeof options.encoder !== 'function') {
	        throw new TypeError('Encoder has to be a function.');
	    }
	
	    var delimiter = typeof options.delimiter === 'undefined' ? defaults.delimiter : options.delimiter;
	    var strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : defaults.strictNullHandling;
	    var skipNulls = typeof options.skipNulls === 'boolean' ? options.skipNulls : defaults.skipNulls;
	    var encode = typeof options.encode === 'boolean' ? options.encode : defaults.encode;
	    var encoder = typeof options.encoder === 'function' ? options.encoder : defaults.encoder;
	    var sort = typeof options.sort === 'function' ? options.sort : null;
	    var allowDots = typeof options.allowDots === 'undefined' ? false : options.allowDots;
	    var serializeDate = typeof options.serializeDate === 'function' ? options.serializeDate : defaults.serializeDate;
	    var encodeValuesOnly = typeof options.encodeValuesOnly === 'boolean' ? options.encodeValuesOnly : defaults.encodeValuesOnly;
	    if (typeof options.format === 'undefined') {
	        options.format = formats['default'];
	    } else if (!Object.prototype.hasOwnProperty.call(formats.formatters, options.format)) {
	        throw new TypeError('Unknown format option provided.');
	    }
	    var formatter = formats.formatters[options.format];
	    var objKeys;
	    var filter;
	
	    if (typeof options.filter === 'function') {
	        filter = options.filter;
	        obj = filter('', obj);
	    } else if (Array.isArray(options.filter)) {
	        filter = options.filter;
	        objKeys = filter;
	    }
	
	    var keys = [];
	
	    if (typeof obj !== 'object' || obj === null) {
	        return '';
	    }
	
	    var arrayFormat;
	    if (options.arrayFormat in arrayPrefixGenerators) {
	        arrayFormat = options.arrayFormat;
	    } else if ('indices' in options) {
	        arrayFormat = options.indices ? 'indices' : 'repeat';
	    } else {
	        arrayFormat = 'indices';
	    }
	
	    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];
	
	    if (!objKeys) {
	        objKeys = Object.keys(obj);
	    }
	
	    if (sort) {
	        objKeys.sort(sort);
	    }
	
	    for (var i = 0; i < objKeys.length; ++i) {
	        var key = objKeys[i];
	
	        if (skipNulls && obj[key] === null) {
	            continue;
	        }
	
	        keys = keys.concat(stringify(
	            obj[key],
	            key,
	            generateArrayPrefix,
	            strictNullHandling,
	            skipNulls,
	            encode ? encoder : null,
	            filter,
	            sort,
	            allowDots,
	            serializeDate,
	            formatter,
	            encodeValuesOnly
	        ));
	    }
	
	    var joined = keys.join(delimiter);
	    var prefix = options.addQueryPrefix === true ? '?' : '';
	
	    return joined.length > 0 ? prefix + joined : '';
	};


/***/ }),
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.calculateResizeFactor = calculateResizeFactor;
	exports.calculateMousePosition = calculateMousePosition;
	exports.isChildOfType = isChildOfType;
	exports.createNewChildren = createNewChildren;
	exports.roundPath = roundPath;
	exports.createConnectorPath = createConnectorPath;
	exports.createTextAnchor = createTextAnchor;
	exports.computeBackdrop = computeBackdrop;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function calculateResizeFactor(actualDimension, baseDimension) {
	  if (actualDimension === 0) return 1;
	  return 1 / 100 * (100 / actualDimension * baseDimension);
	}
	
	function calculateMousePosition(direction, projection, props, zoom, resizeFactor) {
	  var center = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : props.center;
	  var width = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : props.width;
	  var height = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : props.height;
	
	  var reference = { x: 0, y: 1 };
	  var canRotate = !!projection.rotate;
	  var reverseRotation = !!canRotate ? projection.rotate().map(function (item) {
	    return -item;
	  }) : false;
	  var point = !!reverseRotation ? projection.rotate(reverseRotation)([-center[0], -center[1]]) : projection([center[0], center[1]]);
	  var returner = point ? (point[reference[direction]] - (reference[direction] === 0 ? width : height) / 2) * zoom * (1 / resizeFactor) : 0;
	  if (canRotate) projection.rotate([-reverseRotation[0], -reverseRotation[1], -reverseRotation[2]]);
	  return !!reverseRotation ? returner : -returner;
	}
	
	function isChildOfType(child, expectedTypes) {
	  return expectedTypes.indexOf(child.props.componentIdentifier) !== -1;
	}
	
	function createNewChildren(children, props) {
	  if (!children) return;
	  if (!children.length) {
	    return isChildOfType(children, ["Geographies"]) ? _react2.default.cloneElement(children, {
	      projection: props.projection
	    }) : isChildOfType(children, ["Group", "Markers", "Lines", "Annotations", "Annotation", "Graticule"]) ? _react2.default.cloneElement(children, {
	      projection: props.projection,
	      zoom: props.zoom,
	      width: props.width,
	      height: props.height,
	      groupName: props.groupName,
	      itemName: props.itemName
	    }) : children;
	  } else {
	    return children.map(function (child, i) {
	      if (!child) return;
	      return isChildOfType(child, ["Geographies"]) ? _react2.default.cloneElement(child, {
	        key: "zoomable-child-" + i,
	        projection: props.projection
	      }) : isChildOfType(child, ["Group", "Markers", "Lines", "Annotations", "Annotation", "Graticule"]) ? _react2.default.cloneElement(child, {
	        key: "zoomable-child-" + i,
	        projection: props.projection,
	        zoom: props.zoom,
	        width: props.width,
	        height: props.height,
	        groupName: props.groupName,
	        itemName: props.itemName
	      }) : child;
	    });
	  }
	}
	
	function roundPath(path, precision) {
	  if (!path) return;
	  var query = /[\d\.-][\d\.e-]*/g;
	  return path.replace(query, function (n) {
	    return Math.round(n * (1 / precision)) / (1 / precision);
	  });
	}
	
	function createConnectorPath(connectorType, endPoint, curve) {
	  var e0 = endPoint[0];
	  var e1 = endPoint[1];
	  return "M0,0 Q " + (curve + 1) / 2 * e0 + "," + (e1 - (curve + 1) / 2 * e1) + " " + e0 + "," + e1;
	}
	
	function createTextAnchor(dx) {
	  if (dx > 0) return "start";else if (dx < 0) return "end";else return "middle";
	}
	
	function computeBackdrop(projection, backdrop) {
	  var canRotate = projection.rotate;
	  var originalRotation = canRotate ? projection.rotate() : null;
	
	  var tl = canRotate ? projection.rotate([0, 0, 0])([backdrop.x[0], backdrop.y[0]]) : projection([backdrop.x[0], backdrop.y[0]]);
	
	  var br = canRotate ? projection.rotate([0, 0, 0])([backdrop.x[1], backdrop.y[1]]) : projection([backdrop.x[1], backdrop.y[1]]);
	
	  var x = tl ? tl[0] : 0;
	  var x0 = br ? br[0] : 0;
	
	  var y = tl ? tl[1] : 0;
	  var y0 = br ? br[1] : 0;
	
	  var width = x0 - x;
	  var height = y0 - y;
	
	  if (originalRotation) projection.rotate(originalRotation);
	
	  return { x: x, y: y, width: width, height: height };
	}

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = failsafe;
	
	var u = __webpack_require__(17);
	var all = __webpack_require__(13);
	
	/* Return the content of a reference without definition
	 * as markdown. */
	function failsafe(h, node, definition) {
	  var subtype = node.referenceType;
	
	  if (subtype !== 'collapsed' && subtype !== 'full' && !definition) {
	    if (node.type === 'imageReference') {
	      return u('text', '![' + node.alt + ']');
	    }
	
	    return [u('text', '[')].concat(all(h, node), u('text', ']'));
	  }
	}


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = footnoteReference;
	
	var u = __webpack_require__(17);
	
	/* Transform a reference to a footnote. */
	function footnoteReference(h, node) {
	  var identifier = node.identifier;
	
	  return h(node.position, 'sup', {id: 'fnref-' + identifier}, [
	    h(node, 'a', {
	      href: '#fn-' + identifier,
	      className: ['footnote-ref']
	    }, [u('text', identifier)])
	  ]);
	}


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = list;
	
	var wrap = __webpack_require__(35);
	var all = __webpack_require__(13);
	
	/* Transform a list. */
	function list(h, node) {
	  var props = {};
	  var name = node.ordered ? 'ol' : 'ul';
	
	  if (typeof node.start === 'number' && node.start !== 1) {
	    props.start = node.start;
	  }
	
	  return h(node, name, props, wrap(all(h, node), true));
	}


/***/ }),
/* 195 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = thematicBreak;
	
	/* Transform a thematic break / horizontal rule. */
	function thematicBreak(h, node) {
	  return h(node, 'hr');
	}


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = one;
	
	var u = __webpack_require__(17);
	var all = __webpack_require__(13);
	
	var own = {}.hasOwnProperty;
	
	/* Transform an unknown node. */
	function unknown(h, node) {
	  if (text(node)) {
	    return h.augment(node, u('text', node.value));
	  }
	
	  return h(node, 'div', all(h, node));
	}
	
	/* Visit a node. */
	function one(h, node, parent) {
	  var type = node && node.type;
	  var fn = own.call(h.handlers, type) ? h.handlers[type] : null;
	
	  /* Fail on non-nodes. */
	  if (!type) {
	    throw new Error('Expected node, got `' + node + '`');
	  }
	
	  return (typeof fn === 'function' ? fn : unknown)(h, node, parent);
	}
	
	/* Check if the node should be renderered a text node. */
	function text(node) {
	  var data = node.data || {};
	
	  if (own.call(data, 'hName') || own.call(data, 'hProperties') || own.call(data, 'hChildren')) {
	    return false;
	  }
	
	  return 'value' in node;
	}


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = {
	  position: true,
	  gfm: true,
	  commonmark: false,
	  footnotes: false,
	  pedantic: false,
	  blocks: __webpack_require__(307)
	};


/***/ }),
/* 198 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = locate;
	
	function locate(value, fromIndex) {
	  var link = value.indexOf('[', fromIndex);
	  var image = value.indexOf('![', fromIndex);
	
	  if (image === -1) {
	    return link;
	  }
	
	  /* Link can never be `-1` if an image is found, so we don’t need
	   * to check for that :) */
	  return link < image ? link : image;
	}


/***/ }),
/* 199 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = locate;
	
	function locate(value, fromIndex) {
	  return value.indexOf('<', fromIndex);
	}


/***/ }),
/* 200 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = indentation;
	
	/* Map of characters, and their column length,
	 * which can be used as indentation. */
	var characters = {' ': 1, '\t': 4};
	
	/* Gets indentation information for a line. */
	function indentation(value) {
	  var index = 0;
	  var indent = 0;
	  var character = value.charAt(index);
	  var stops = {};
	  var size;
	
	  while (character in characters) {
	    size = characters[character];
	
	    indent += size;
	
	    if (size > 1) {
	      indent = Math.floor(indent / size) * size;
	    }
	
	    stops[indent] = index;
	
	    character = value.charAt(++index);
	  }
	
	  return {indent: indent, stops: stops};
	}


/***/ }),
/* 201 */
/***/ (function(module, exports) {

	'use strict';
	
	var attributeName = '[a-zA-Z_:][a-zA-Z0-9:._-]*';
	var unquoted = '[^"\'=<>`\\u0000-\\u0020]+';
	var singleQuoted = '\'[^\']*\'';
	var doubleQuoted = '"[^"]*"';
	var attributeValue = '(?:' + unquoted + '|' + singleQuoted + '|' + doubleQuoted + ')';
	var attribute = '(?:\\s+' + attributeName + '(?:\\s*=\\s*' + attributeValue + ')?)';
	var openTag = '<[A-Za-z][A-Za-z0-9\\-]*' + attribute + '*\\s*\\/?>';
	var closeTag = '<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>';
	var comment = '<!---->|<!--(?:-?[^>-])(?:-?[^-])*-->';
	var processing = '<[?].*?[?]>';
	var declaration = '<![A-Za-z]+\\s+[^>]*>';
	var cdata = '<!\\[CDATA\\[[\\s\\S]*?\\]\\]>';
	
	exports.openCloseTag = new RegExp('^(?:' + openTag + '|' + closeTag + ')');
	
	exports.tag = new RegExp('^(?:' +
	  openTag + '|' +
	  closeTag + '|' +
	  comment + '|' +
	  processing + '|' +
	  declaration + '|' +
	  cdata +
	')');


/***/ }),
/* 202 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	  gfm: true,
	  commonmark: false,
	  pedantic: false,
	  entities: 'false',
	  setext: false,
	  closeAtx: false,
	  looseTable: false,
	  spacedTable: true,
	  paddedTable: true,
	  stringLength: stringLength,
	  incrementListMarker: true,
	  fences: false,
	  fence: '`',
	  bullet: '-',
	  listItemIndent: 'tab',
	  rule: '*',
	  ruleSpaces: true,
	  ruleRepetition: 3,
	  strong: '*',
	  emphasis: '_'
	};
	
	function stringLength(value) {
	  return value.length;
	}


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var decode = __webpack_require__(55);
	
	module.exports = length;
	
	/* Returns the length of HTML entity that is a prefix of
	 * the given string (excluding the ampersand), 0 if it
	 * does not start with an entity. */
	function length(value) {
	  var prefix;
	
	  /* istanbul ignore if - Currently also tested for at
	   * implemention, but we keep it here because that’s
	   * proper. */
	  if (value.charAt(0) !== '&') {
	    return 0;
	  }
	
	  prefix = value.split('&', 2).join('&');
	
	  return prefix.length - decode(prefix).length;
	}


/***/ }),
/* 204 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = label;
	
	/* Stringify a reference label.
	 * Because link references are easily, mistakingly,
	 * created (for example, `[foo]`), reference nodes have
	 * an extra property depicting how it looked in the
	 * original document, so stringification can cause minimal
	 * changes. */
	function label(node) {
	  var type = node.referenceType;
	  var value = type === 'full' ? node.identifier : '';
	
	  return type === 'shortcut' ? value : '[' + value + ']';
	}


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var repeat = __webpack_require__(16);
	
	module.exports = pad;
	
	var INDENT = 4;
	
	/* Pad `value` with `level * INDENT` spaces.  Respects
	 * lines. Ignores empty lines. */
	function pad(value, level) {
	  var index;
	  var padding;
	
	  value = value.split('\n');
	
	  index = value.length;
	  padding = repeat(' ', level * INDENT);
	
	  while (index--) {
	    if (value[index].length !== 0) {
	      value[index] = padding + value[index];
	    }
	  }
	
	  return value.join('\n');
	}


/***/ }),
/* 206 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = returner;
	
	function returner(value) {
	  return value;
	}


/***/ }),
/* 207 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = factory
	
	/* Construct a state `toggler`: a function which inverses
	 * `property` in context based on its current value.
	 * The by `toggler` returned function restores that value. */
	function factory(key, state, ctx) {
	  return enter
	
	  function enter() {
	    var context = ctx || this
	    var current = context[key]
	
	    context[key] = !state
	
	    return exit
	
	    function exit() {
	      context[key] = current
	    }
	  }
	}


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var xtend = __webpack_require__(12)
	var inherits = __webpack_require__(295)
	
	module.exports = unherit
	
	/* Create a custom constructor which can be modified
	 * without affecting the original class. */
	function unherit(Super) {
	  var result
	  var key
	  var value
	
	  inherits(Of, Super)
	  inherits(From, Of)
	
	  /* Clone values. */
	  result = Of.prototype
	
	  for (key in result) {
	    value = result[key]
	
	    if (value && typeof value === 'object') {
	      result[key] = 'concat' in value ? value.concat() : xtend(value)
	    }
	  }
	
	  return Of
	
	  /* Constructor accepting a single argument,
	   * which itself is an `arguments` object. */
	  function From(parameters) {
	    return Super.apply(this, parameters)
	  }
	
	  /* Constructor accepting variadic arguments. */
	  function Of() {
	    if (!(this instanceof Of)) {
	      return new From(arguments)
	    }
	
	    return Super.apply(this, arguments)
	  }
	}


/***/ }),
/* 209 */,
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.MarkdownStringContent = exports.HTMLContent = undefined;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _remark = __webpack_require__(383);
	
	var _remark2 = _interopRequireDefault(_remark);
	
	var _remarkPresetLintRecommended = __webpack_require__(382);
	
	var _remarkPresetLintRecommended2 = _interopRequireDefault(_remarkPresetLintRecommended);
	
	var _remarkHtml = __webpack_require__(341);
	
	var _remarkHtml2 = _interopRequireDefault(_remarkHtml);
	
	var _reactEmotion = __webpack_require__(21);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Wrapper = /*#__PURE__*/(0, _reactEmotion2.default)("div", {
	  target: "e1wikig10"
	})();
	
	var HTMLContent = exports.HTMLContent = function HTMLContent(_ref) {
	  var content = _ref.content,
	      className = _ref.className;
	  return _react2.default.createElement(Wrapper, {
	    className: className,
	    dangerouslySetInnerHTML: { __html: content }
	  });
	};
	
	var MarkdownStringContent = exports.MarkdownStringContent = function MarkdownStringContent(_ref2) {
	  var content = _ref2.content,
	      className = _ref2.className;
	  return _react2.default.createElement(Wrapper, {
	    className: className,
	    dangerouslySetInnerHTML: {
	      __html: (0, _remark2.default)().use(_remarkPresetLintRecommended2.default).use(_remarkHtml2.default).processSync(content).toString()
	    }
	  });
	};
	
	var Content = function Content(_ref3) {
	  var content = _ref3.content,
	      className = _ref3.className;
	  return _react2.default.createElement(
	    Wrapper,
	    { className: className },
	    content
	  );
	};
	
	Content.propTypes = {
	  content: _propTypes2.default.string,
	  className: _propTypes2.default.string
	};
	
	HTMLContent.propTypes = Content.propTypes;
	
	exports.default = Content;

/***/ }),
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MapGroup = function (_Component) {
	  _inherits(MapGroup, _Component);
	
	  function MapGroup() {
	    _classCallCheck(this, MapGroup);
	
	    return _possibleConstructorReturn(this, (MapGroup.__proto__ || Object.getPrototypeOf(MapGroup)).apply(this, arguments));
	  }
	
	  _createClass(MapGroup, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          projection = _props.projection,
	          style = _props.style,
	          zoom = _props.zoom,
	          width = _props.width,
	          height = _props.height,
	          groupName = _props.groupName,
	          itemName = _props.itemName;
	
	      return _react2.default.createElement(
	        "g",
	        { className: "rsm-" + groupName, style: style },
	        !children ? null : children.length === undefined ? _react2.default.cloneElement(children, {
	          projection: projection,
	          zoom: zoom,
	          width: width,
	          height: height
	        }) : children.map(function (child, i) {
	          return !child ? null : _react2.default.cloneElement(child, {
	            key: child.key || itemName + "-" + i,
	            projection: projection,
	            zoom: zoom,
	            width: width,
	            height: height
	          });
	        })
	      );
	    }
	  }]);
	
	  return MapGroup;
	}(_react.Component);
	
	MapGroup.defaultProps = {
	  componentIdentifier: "Group",
	  groupName: "group",
	  itemName: "group-item"
	};
	
	exports.default = MapGroup;

/***/ }),
/* 243 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = iterate
	
	var own = {}.hasOwnProperty
	
	function iterate(values, callback, context) {
	  var index = -1
	  var result
	
	  if (!values) {
	    throw new Error('Iterate requires that |this| not be ' + values)
	  }
	
	  if (!own.call(values, 'length')) {
	    throw new Error('Iterate requires that |this| has a `length`')
	  }
	
	  if (typeof callback !== 'function') {
	    throw new Error('`callback` must be a function')
	  }
	
	  /* The length might change, so we do not cache it. */
	  while (++index < values.length) {
	    /* Skip missing values. */
	    if (!(index in values)) {
	      continue
	    }
	
	    result = callback.call(context, values[index], index, values)
	
	    /* If `callback` returns a `number`, move `index` over to
	     * `number`. */
	    if (typeof result === 'number') {
	      /* Make sure that negative numbers do not break the loop. */
	      if (result < 0) {
	        index = 0
	      }
	
	      index = result - 1
	    }
	  }
	}


/***/ }),
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = bail
	
	function bail(err) {
	  if (err) {
	    throw err
	  }
	}


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate) {
	/**
	 * slice() reference.
	 */
	
	var slice = Array.prototype.slice;
	
	/**
	 * Expose `co`.
	 */
	
	module.exports = co;
	
	/**
	 * Wrap the given generator `fn` and
	 * return a thunk.
	 *
	 * @param {Function} fn
	 * @return {Function}
	 * @api public
	 */
	
	function co(fn) {
	  var isGenFun = isGeneratorFunction(fn);
	
	  return function (done) {
	    var ctx = this;
	
	    // in toThunk() below we invoke co()
	    // with a generator, so optimize for
	    // this case
	    var gen = fn;
	
	    // we only need to parse the arguments
	    // if gen is a generator function.
	    if (isGenFun) {
	      var args = slice.call(arguments), len = args.length;
	      var hasCallback = len && 'function' == typeof args[len - 1];
	      done = hasCallback ? args.pop() : error;
	      gen = fn.apply(this, args);
	    } else {
	      done = done || error;
	    }
	
	    next();
	
	    // #92
	    // wrap the callback in a setImmediate
	    // so that any of its errors aren't caught by `co`
	    function exit(err, res) {
	      setImmediate(function(){
	        done.call(ctx, err, res);
	      });
	    }
	
	    function next(err, res) {
	      var ret;
	
	      // multiple args
	      if (arguments.length > 2) res = slice.call(arguments, 1);
	
	      // error
	      if (err) {
	        try {
	          ret = gen.throw(err);
	        } catch (e) {
	          return exit(e);
	        }
	      }
	
	      // ok
	      if (!err) {
	        try {
	          ret = gen.next(res);
	        } catch (e) {
	          return exit(e);
	        }
	      }
	
	      // done
	      if (ret.done) return exit(null, ret.value);
	
	      // normalize
	      ret.value = toThunk(ret.value, ctx);
	
	      // run
	      if ('function' == typeof ret.value) {
	        var called = false;
	        try {
	          ret.value.call(ctx, function(){
	            if (called) return;
	            called = true;
	            next.apply(ctx, arguments);
	          });
	        } catch (e) {
	          setImmediate(function(){
	            if (called) return;
	            called = true;
	            next(e);
	          });
	        }
	        return;
	      }
	
	      // invalid
	      next(new TypeError('You may only yield a function, promise, generator, array, or object, '
	        + 'but the following was passed: "' + String(ret.value) + '"'));
	    }
	  }
	}
	
	/**
	 * Convert `obj` into a normalized thunk.
	 *
	 * @param {Mixed} obj
	 * @param {Mixed} ctx
	 * @return {Function}
	 * @api private
	 */
	
	function toThunk(obj, ctx) {
	
	  if (isGeneratorFunction(obj)) {
	    return co(obj.call(ctx));
	  }
	
	  if (isGenerator(obj)) {
	    return co(obj);
	  }
	
	  if (isPromise(obj)) {
	    return promiseToThunk(obj);
	  }
	
	  if ('function' == typeof obj) {
	    return obj;
	  }
	
	  if (isObject(obj) || Array.isArray(obj)) {
	    return objectToThunk.call(ctx, obj);
	  }
	
	  return obj;
	}
	
	/**
	 * Convert an object of yieldables to a thunk.
	 *
	 * @param {Object} obj
	 * @return {Function}
	 * @api private
	 */
	
	function objectToThunk(obj){
	  var ctx = this;
	  var isArray = Array.isArray(obj);
	
	  return function(done){
	    var keys = Object.keys(obj);
	    var pending = keys.length;
	    var results = isArray
	      ? new Array(pending) // predefine the array length
	      : new obj.constructor();
	    var finished;
	
	    if (!pending) {
	      setImmediate(function(){
	        done(null, results)
	      });
	      return;
	    }
	
	    // prepopulate object keys to preserve key ordering
	    if (!isArray) {
	      for (var i = 0; i < pending; i++) {
	        results[keys[i]] = undefined;
	      }
	    }
	
	    for (var i = 0; i < keys.length; i++) {
	      run(obj[keys[i]], keys[i]);
	    }
	
	    function run(fn, key) {
	      if (finished) return;
	      try {
	        fn = toThunk(fn, ctx);
	
	        if ('function' != typeof fn) {
	          results[key] = fn;
	          return --pending || done(null, results);
	        }
	
	        fn.call(ctx, function(err, res){
	          if (finished) return;
	
	          if (err) {
	            finished = true;
	            return done(err);
	          }
	
	          results[key] = res;
	          --pending || done(null, results);
	        });
	      } catch (err) {
	        finished = true;
	        done(err);
	      }
	    }
	  }
	}
	
	/**
	 * Convert `promise` to a thunk.
	 *
	 * @param {Object} promise
	 * @return {Function}
	 * @api private
	 */
	
	function promiseToThunk(promise) {
	  return function(fn){
	    promise.then(function(res) {
	      fn(null, res);
	    }, fn);
	  }
	}
	
	/**
	 * Check if `obj` is a promise.
	 *
	 * @param {Object} obj
	 * @return {Boolean}
	 * @api private
	 */
	
	function isPromise(obj) {
	  return obj && 'function' == typeof obj.then;
	}
	
	/**
	 * Check if `obj` is a generator.
	 *
	 * @param {Mixed} obj
	 * @return {Boolean}
	 * @api private
	 */
	
	function isGenerator(obj) {
	  return obj && 'function' == typeof obj.next && 'function' == typeof obj.throw;
	}
	
	/**
	 * Check if `obj` is a generator function.
	 *
	 * @param {Mixed} obj
	 * @return {Boolean}
	 * @api private
	 */
	
	function isGeneratorFunction(obj) {
	  return obj && obj.constructor && 'GeneratorFunction' == obj.constructor.name;
	}
	
	/**
	 * Check for plain object.
	 *
	 * @param {Mixed} val
	 * @return {Boolean}
	 * @api private
	 */
	
	function isObject(val) {
	  return val && Object == val.constructor;
	}
	
	/**
	 * Throw `err` in a new stack.
	 *
	 * This is used when co() is invoked
	 * without supplying a callback, which
	 * should only be for demonstrational
	 * purposes.
	 *
	 * @param {Error} err
	 * @api private
	 */
	
	function error(err) {
	  if (!err) return;
	  setImmediate(function(){
	    throw err;
	  });
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(464).setImmediate))

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	exports.parse = parse
	exports.stringify = stringify
	
	var trim = __webpack_require__(22)
	
	var comma = ','
	var space = ' '
	var empty = ''
	
	/* Parse comma-separated tokens to an array. */
	function parse(value) {
	  var values = []
	  var input = String(value || empty)
	  var index = input.indexOf(comma)
	  var lastIndex = 0
	  var end = false
	  var val
	
	  while (!end) {
	    if (index === -1) {
	      index = input.length
	      end = true
	    }
	
	    val = trim(input.slice(lastIndex, index))
	
	    if (val || !end) {
	      values.push(val)
	    }
	
	    lastIndex = index + 1
	    index = input.indexOf(comma, lastIndex)
	  }
	
	  return values
	}
	
	/* Compile an array to comma-separated tokens.
	 * `options.padLeft` (default: `true`) pads a space left of each
	 * token, and `options.padRight` (default: `false`) pads a space
	 * to the right of each token. */
	function stringify(values, options) {
	  var settings = options || {}
	  var left = settings.padLeft === false ? empty : space
	  var right = settings.padRight ? space : empty
	
	  /* Ensure the last empty entry is seen. */
	  if (values[values.length - 1] === empty) {
	    values = values.concat(empty)
	  }
	
	  return trim(values.join(right + comma + left))
	}


/***/ }),
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-array/ Version 1.2.1. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var ascending = function(a, b) {
	  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
	};
	
	var bisector = function(compare) {
	  if (compare.length === 1) compare = ascendingComparator(compare);
	  return {
	    left: function(a, x, lo, hi) {
	      if (lo == null) lo = 0;
	      if (hi == null) hi = a.length;
	      while (lo < hi) {
	        var mid = lo + hi >>> 1;
	        if (compare(a[mid], x) < 0) lo = mid + 1;
	        else hi = mid;
	      }
	      return lo;
	    },
	    right: function(a, x, lo, hi) {
	      if (lo == null) lo = 0;
	      if (hi == null) hi = a.length;
	      while (lo < hi) {
	        var mid = lo + hi >>> 1;
	        if (compare(a[mid], x) > 0) hi = mid;
	        else lo = mid + 1;
	      }
	      return lo;
	    }
	  };
	};
	
	function ascendingComparator(f) {
	  return function(d, x) {
	    return ascending(f(d), x);
	  };
	}
	
	var ascendingBisect = bisector(ascending);
	var bisectRight = ascendingBisect.right;
	var bisectLeft = ascendingBisect.left;
	
	var pairs = function(array, f) {
	  if (f == null) f = pair;
	  var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
	  while (i < n) pairs[i] = f(p, p = array[++i]);
	  return pairs;
	};
	
	function pair(a, b) {
	  return [a, b];
	}
	
	var cross = function(values0, values1, reduce) {
	  var n0 = values0.length,
	      n1 = values1.length,
	      values = new Array(n0 * n1),
	      i0,
	      i1,
	      i,
	      value0;
	
	  if (reduce == null) reduce = pair;
	
	  for (i0 = i = 0; i0 < n0; ++i0) {
	    for (value0 = values0[i0], i1 = 0; i1 < n1; ++i1, ++i) {
	      values[i] = reduce(value0, values1[i1]);
	    }
	  }
	
	  return values;
	};
	
	var descending = function(a, b) {
	  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	};
	
	var number = function(x) {
	  return x === null ? NaN : +x;
	};
	
	var variance = function(values, valueof) {
	  var n = values.length,
	      m = 0,
	      i = -1,
	      mean = 0,
	      value,
	      delta,
	      sum = 0;
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (!isNaN(value = number(values[i]))) {
	        delta = value - mean;
	        mean += delta / ++m;
	        sum += delta * (value - mean);
	      }
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(value = number(valueof(values[i], i, values)))) {
	        delta = value - mean;
	        mean += delta / ++m;
	        sum += delta * (value - mean);
	      }
	    }
	  }
	
	  if (m > 1) return sum / (m - 1);
	};
	
	var deviation = function(array, f) {
	  var v = variance(array, f);
	  return v ? Math.sqrt(v) : v;
	};
	
	var extent = function(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      min,
	      max;
	
	  if (valueof == null) {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = values[i]) != null && value >= value) {
	        min = max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = values[i]) != null) {
	            if (min > value) min = value;
	            if (max < value) max = value;
	          }
	        }
	      }
	    }
	  }
	
	  else {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = valueof(values[i], i, values)) != null && value >= value) {
	        min = max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = valueof(values[i], i, values)) != null) {
	            if (min > value) min = value;
	            if (max < value) max = value;
	          }
	        }
	      }
	    }
	  }
	
	  return [min, max];
	};
	
	var array = Array.prototype;
	
	var slice = array.slice;
	var map = array.map;
	
	var constant = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	var identity = function(x) {
	  return x;
	};
	
	var range = function(start, stop, step) {
	  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
	
	  var i = -1,
	      n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
	      range = new Array(n);
	
	  while (++i < n) {
	    range[i] = start + i * step;
	  }
	
	  return range;
	};
	
	var e10 = Math.sqrt(50);
	var e5 = Math.sqrt(10);
	var e2 = Math.sqrt(2);
	
	var ticks = function(start, stop, count) {
	  var reverse,
	      i = -1,
	      n,
	      ticks,
	      step;
	
	  stop = +stop, start = +start, count = +count;
	  if (start === stop && count > 0) return [start];
	  if (reverse = stop < start) n = start, start = stop, stop = n;
	  if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];
	
	  if (step > 0) {
	    start = Math.ceil(start / step);
	    stop = Math.floor(stop / step);
	    ticks = new Array(n = Math.ceil(stop - start + 1));
	    while (++i < n) ticks[i] = (start + i) * step;
	  } else {
	    start = Math.floor(start * step);
	    stop = Math.ceil(stop * step);
	    ticks = new Array(n = Math.ceil(start - stop + 1));
	    while (++i < n) ticks[i] = (start - i) / step;
	  }
	
	  if (reverse) ticks.reverse();
	
	  return ticks;
	};
	
	function tickIncrement(start, stop, count) {
	  var step = (stop - start) / Math.max(0, count),
	      power = Math.floor(Math.log(step) / Math.LN10),
	      error = step / Math.pow(10, power);
	  return power >= 0
	      ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power)
	      : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
	}
	
	function tickStep(start, stop, count) {
	  var step0 = Math.abs(stop - start) / Math.max(0, count),
	      step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
	      error = step0 / step1;
	  if (error >= e10) step1 *= 10;
	  else if (error >= e5) step1 *= 5;
	  else if (error >= e2) step1 *= 2;
	  return stop < start ? -step1 : step1;
	}
	
	var sturges = function(values) {
	  return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
	};
	
	var histogram = function() {
	  var value = identity,
	      domain = extent,
	      threshold = sturges;
	
	  function histogram(data) {
	    var i,
	        n = data.length,
	        x,
	        values = new Array(n);
	
	    for (i = 0; i < n; ++i) {
	      values[i] = value(data[i], i, data);
	    }
	
	    var xz = domain(values),
	        x0 = xz[0],
	        x1 = xz[1],
	        tz = threshold(values, x0, x1);
	
	    // Convert number of thresholds into uniform thresholds.
	    if (!Array.isArray(tz)) {
	      tz = tickStep(x0, x1, tz);
	      tz = range(Math.ceil(x0 / tz) * tz, Math.floor(x1 / tz) * tz, tz); // exclusive
	    }
	
	    // Remove any thresholds outside the domain.
	    var m = tz.length;
	    while (tz[0] <= x0) tz.shift(), --m;
	    while (tz[m - 1] > x1) tz.pop(), --m;
	
	    var bins = new Array(m + 1),
	        bin;
	
	    // Initialize bins.
	    for (i = 0; i <= m; ++i) {
	      bin = bins[i] = [];
	      bin.x0 = i > 0 ? tz[i - 1] : x0;
	      bin.x1 = i < m ? tz[i] : x1;
	    }
	
	    // Assign data to bins by value, ignoring any outside the domain.
	    for (i = 0; i < n; ++i) {
	      x = values[i];
	      if (x0 <= x && x <= x1) {
	        bins[bisectRight(tz, x, 0, m)].push(data[i]);
	      }
	    }
	
	    return bins;
	  }
	
	  histogram.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant(_), histogram) : value;
	  };
	
	  histogram.domain = function(_) {
	    return arguments.length ? (domain = typeof _ === "function" ? _ : constant([_[0], _[1]]), histogram) : domain;
	  };
	
	  histogram.thresholds = function(_) {
	    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? constant(slice.call(_)) : constant(_), histogram) : threshold;
	  };
	
	  return histogram;
	};
	
	var quantile = function(values, p, valueof) {
	  if (valueof == null) valueof = number;
	  if (!(n = values.length)) return;
	  if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
	  if (p >= 1) return +valueof(values[n - 1], n - 1, values);
	  var n,
	      i = (n - 1) * p,
	      i0 = Math.floor(i),
	      value0 = +valueof(values[i0], i0, values),
	      value1 = +valueof(values[i0 + 1], i0 + 1, values);
	  return value0 + (value1 - value0) * (i - i0);
	};
	
	var freedmanDiaconis = function(values, min, max) {
	  values = map.call(values, number).sort(ascending);
	  return Math.ceil((max - min) / (2 * (quantile(values, 0.75) - quantile(values, 0.25)) * Math.pow(values.length, -1 / 3)));
	};
	
	var scott = function(values, min, max) {
	  return Math.ceil((max - min) / (3.5 * deviation(values) * Math.pow(values.length, -1 / 3)));
	};
	
	var max = function(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      max;
	
	  if (valueof == null) {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = values[i]) != null && value >= value) {
	        max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = values[i]) != null && value > max) {
	            max = value;
	          }
	        }
	      }
	    }
	  }
	
	  else {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = valueof(values[i], i, values)) != null && value >= value) {
	        max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = valueof(values[i], i, values)) != null && value > max) {
	            max = value;
	          }
	        }
	      }
	    }
	  }
	
	  return max;
	};
	
	var mean = function(values, valueof) {
	  var n = values.length,
	      m = n,
	      i = -1,
	      value,
	      sum = 0;
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (!isNaN(value = number(values[i]))) sum += value;
	      else --m;
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(value = number(valueof(values[i], i, values)))) sum += value;
	      else --m;
	    }
	  }
	
	  if (m) return sum / m;
	};
	
	var median = function(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      numbers = [];
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (!isNaN(value = number(values[i]))) {
	        numbers.push(value);
	      }
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(value = number(valueof(values[i], i, values)))) {
	        numbers.push(value);
	      }
	    }
	  }
	
	  return quantile(numbers.sort(ascending), 0.5);
	};
	
	var merge = function(arrays) {
	  var n = arrays.length,
	      m,
	      i = -1,
	      j = 0,
	      merged,
	      array;
	
	  while (++i < n) j += arrays[i].length;
	  merged = new Array(j);
	
	  while (--n >= 0) {
	    array = arrays[n];
	    m = array.length;
	    while (--m >= 0) {
	      merged[--j] = array[m];
	    }
	  }
	
	  return merged;
	};
	
	var min = function(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      min;
	
	  if (valueof == null) {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = values[i]) != null && value >= value) {
	        min = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = values[i]) != null && min > value) {
	            min = value;
	          }
	        }
	      }
	    }
	  }
	
	  else {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = valueof(values[i], i, values)) != null && value >= value) {
	        min = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = valueof(values[i], i, values)) != null && min > value) {
	            min = value;
	          }
	        }
	      }
	    }
	  }
	
	  return min;
	};
	
	var permute = function(array, indexes) {
	  var i = indexes.length, permutes = new Array(i);
	  while (i--) permutes[i] = array[indexes[i]];
	  return permutes;
	};
	
	var scan = function(values, compare) {
	  if (!(n = values.length)) return;
	  var n,
	      i = 0,
	      j = 0,
	      xi,
	      xj = values[j];
	
	  if (compare == null) compare = ascending;
	
	  while (++i < n) {
	    if (compare(xi = values[i], xj) < 0 || compare(xj, xj) !== 0) {
	      xj = xi, j = i;
	    }
	  }
	
	  if (compare(xj, xj) === 0) return j;
	};
	
	var shuffle = function(array, i0, i1) {
	  var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0),
	      t,
	      i;
	
	  while (m) {
	    i = Math.random() * m-- | 0;
	    t = array[m + i0];
	    array[m + i0] = array[i + i0];
	    array[i + i0] = t;
	  }
	
	  return array;
	};
	
	var sum = function(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      sum = 0;
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (value = +values[i]) sum += value; // Note: zero and null are equivalent.
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (value = +valueof(values[i], i, values)) sum += value;
	    }
	  }
	
	  return sum;
	};
	
	var transpose = function(matrix) {
	  if (!(n = matrix.length)) return [];
	  for (var i = -1, m = min(matrix, length), transpose = new Array(m); ++i < m;) {
	    for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n;) {
	      row[j] = matrix[j][i];
	    }
	  }
	  return transpose;
	};
	
	function length(d) {
	  return d.length;
	}
	
	var zip = function() {
	  return transpose(arguments);
	};
	
	exports.bisect = bisectRight;
	exports.bisectRight = bisectRight;
	exports.bisectLeft = bisectLeft;
	exports.ascending = ascending;
	exports.bisector = bisector;
	exports.cross = cross;
	exports.descending = descending;
	exports.deviation = deviation;
	exports.extent = extent;
	exports.histogram = histogram;
	exports.thresholdFreedmanDiaconis = freedmanDiaconis;
	exports.thresholdScott = scott;
	exports.thresholdSturges = sturges;
	exports.max = max;
	exports.mean = mean;
	exports.median = median;
	exports.merge = merge;
	exports.min = min;
	exports.pairs = pairs;
	exports.permute = permute;
	exports.quantile = quantile;
	exports.range = range;
	exports.scan = scan;
	exports.shuffle = shuffle;
	exports.sum = sum;
	exports.ticks = ticks;
	exports.tickIncrement = tickIncrement;
	exports.tickStep = tickStep;
	exports.transpose = transpose;
	exports.variance = variance;
	exports.zip = zip;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = detab;
	
	var repeat = __webpack_require__(16);
	
	var TAB = 0x09;
	var LF = 0x0A;
	var CR = 0x0D;
	
	/* Replace tabs with spaces, being smart about which
	 * column the tab is at and which size should be used. */
	function detab(value, size) {
	  var string = typeof value === 'string';
	  var length = string && value.length;
	  var start = 0;
	  var index = -1;
	  var column = -1;
	  var tabSize = size || 4;
	  var results = [];
	  var code;
	  var add;
	
	  if (!string) {
	    throw new Error('detab expected string');
	  }
	
	  while (++index < length) {
	    code = value.charCodeAt(index);
	
	    if (code === TAB) {
	      add = tabSize - ((column + 1) % tabSize);
	      column += add;
	      results.push(value.slice(start, index) + repeat(' ', add));
	      start = index + 1;
	    } else if (code === LF || code === CR) {
	      column = -1;
	    } else {
	      column++;
	    }
	  }
	
	  results.push(value.slice(start));
	
	  return results.join('');
	}


/***/ }),
/* 278 */,
/* 279 */
/***/ (function(module, exports) {

	'use strict';
	
	var hasOwn = Object.prototype.hasOwnProperty;
	var toStr = Object.prototype.toString;
	
	var isArray = function isArray(arr) {
		if (typeof Array.isArray === 'function') {
			return Array.isArray(arr);
		}
	
		return toStr.call(arr) === '[object Array]';
	};
	
	var isPlainObject = function isPlainObject(obj) {
		if (!obj || toStr.call(obj) !== '[object Object]') {
			return false;
		}
	
		var hasOwnConstructor = hasOwn.call(obj, 'constructor');
		var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');
		// Not own constructor property must be Object
		if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {
			return false;
		}
	
		// Own properties are enumerated firstly, so to speed up,
		// if last one is own, then all properties are own.
		var key;
		for (key in obj) { /**/ }
	
		return typeof key === 'undefined' || hasOwn.call(obj, key);
	};
	
	module.exports = function extend() {
		var options, name, src, copy, copyIsArray, clone;
		var target = arguments[0];
		var i = 1;
		var length = arguments.length;
		var deep = false;
	
		// Handle a deep copy situation
		if (typeof target === 'boolean') {
			deep = target;
			target = arguments[1] || {};
			// skip the boolean and the target
			i = 2;
		}
		if (target == null || (typeof target !== 'object' && typeof target !== 'function')) {
			target = {};
		}
	
		for (; i < length; ++i) {
			options = arguments[i];
			// Only deal with non-null/undefined values
			if (options != null) {
				// Extend the base object
				for (name in options) {
					src = target[name];
					copy = options[name];
	
					// Prevent never-ending loop
					if (target !== copy) {
						// Recurse if we're merging plain objects or arrays
						if (deep && copy && (isPlainObject(copy) || (copyIsArray = isArray(copy)))) {
							if (copyIsArray) {
								copyIsArray = false;
								clone = src && isArray(src) ? src : [];
							} else {
								clone = src && isPlainObject(src) ? src : {};
							}
	
							// Never move original objects, clone them
							target[name] = extend(deep, clone, copy);
	
						// Don't bring in undefined values
						} else if (typeof copy !== 'undefined') {
							target[name] = copy;
						}
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	module.exports = __webpack_require__(281);


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/* Dependencies. */
	var xtend = __webpack_require__(12);
	var defaults = __webpack_require__(304);
	
	/* Expose. */
	module.exports = wrapper;
	
	var own = {}.hasOwnProperty;
	
	/* Schema. */
	var NODES = {
	  root: {children: all},
	  element: {
	    tagName: handleTagName,
	    properties: handleProperties,
	    children: all
	  },
	  text: {value: handleValue},
	  '*': {
	    data: allow,
	    position: allow
	  }
	};
	
	/* Sanitize `node`, according to `schema`. */
	function wrapper(node, schema) {
	  var ctx = {type: 'root', children: []};
	  var replace;
	
	  if (!node || typeof node !== 'object' || !node.type) {
	    return ctx;
	  }
	
	  replace = one(xtend(defaults, schema || {}), node, []);
	
	  if (!replace) {
	    return ctx;
	  }
	
	  if ('length' in replace) {
	    if (replace.length === 1) {
	      return replace[0];
	    }
	
	    ctx.children = replace;
	
	    return ctx;
	  }
	
	  return replace;
	}
	
	/* Sanitize `node`. */
	function one(schema, node, stack) {
	  var type = node && node.type;
	  var replacement = {type: node.type};
	  var replace = true;
	  var allowed;
	  var result;
	  var key;
	
	  if (!own.call(NODES, type)) {
	    replace = false;
	  } else {
	    allowed = xtend(NODES[type], NODES['*']);
	
	    for (key in allowed) {
	      result = allowed[key](schema, node[key], node, stack);
	
	      if (result === false) {
	        replace = false;
	
	        /* Set the non-safe value. */
	        replacement[key] = node[key];
	      } else if (result !== null && result !== undefined) {
	        replacement[key] = result;
	      }
	    }
	  }
	
	  if (!replace) {
	    if (
	      !replacement.children ||
	      replacement.children.length === 0 ||
	      schema.strip.indexOf(replacement.tagName) !== -1
	    ) {
	      return null;
	    }
	
	    return replacement.children;
	  }
	
	  return replacement;
	}
	
	/* Sanitize `children`. */
	function all(schema, children, node, stack) {
	  var nodes = children || [];
	  var length = nodes.length || 0;
	  var results = [];
	  var index = -1;
	  var result;
	
	  stack = stack.concat(node.tagName);
	
	  while (++index < length) {
	    result = one(schema, nodes[index], stack);
	
	    if (result) {
	      if ('length' in result) {
	        results = results.concat(result);
	      } else {
	        results.push(result);
	      }
	    }
	  }
	
	  return results;
	}
	
	/* Sanitize `properties`. */
	function handleProperties(schema, properties, node, stack) {
	  var name = handleTagName(schema, node.tagName, node, stack);
	  var attrs = schema.attributes;
	  var props = properties || {};
	  var result = {};
	  var allowed;
	  var prop;
	  var value;
	
	  allowed = own.call(attrs, name) ? attrs[name] : [];
	  allowed = [].concat(allowed, attrs['*']);
	
	  for (prop in props) {
	    value = props[prop];
	
	    if (
	      allowed.indexOf(prop) === -1 &&
	      !(data(prop) && allowed.indexOf('data*') !== -1)
	    ) {
	      continue;
	    }
	
	    if (value && typeof value === 'object' && 'length' in value) {
	      value = handlePropertyValues(schema, value, prop);
	    } else {
	      value = handlePropertyValue(schema, value, prop);
	    }
	
	    if (value !== null && value !== undefined) {
	      result[prop] = value;
	    }
	  }
	
	  return result;
	}
	
	/* Sanitize a property value which is a list. */
	function handlePropertyValues(schema, values, prop) {
	  var length = values.length;
	  var result = [];
	  var index = -1;
	  var value;
	
	  while (++index < length) {
	    value = handlePropertyValue(schema, values[index], prop);
	
	    if (value !== null && value !== undefined) {
	      result.push(value);
	    }
	  }
	
	  return result;
	}
	
	/* Sanitize a property value. */
	function handlePropertyValue(schema, value, prop) {
	  if (
	    typeof value !== 'boolean' &&
	    typeof value !== 'number' &&
	    typeof value !== 'string'
	  ) {
	    return null;
	  }
	
	  if (!handleProtocol(schema, value, prop)) {
	    return null;
	  }
	
	  if (schema.clobber.indexOf(prop) !== -1) {
	    value = schema.clobberPrefix + value;
	  }
	
	  return value;
	}
	
	/* Check whether `value` is a safe URL. */
	function handleProtocol(schema, value, prop) {
	  var protocols = schema.protocols;
	  var protocol;
	  var first;
	  var colon;
	  var length;
	  var index;
	
	  protocols = own.call(protocols, prop) ? protocols[prop].concat() : [];
	
	  if (protocols.length === 0) {
	    return true;
	  }
	
	  value = String(value);
	  first = value.charAt(0);
	
	  if (first === '#' || first === '/') {
	    return true;
	  }
	
	  colon = value.indexOf(':');
	
	  if (colon === -1) {
	    return true;
	  }
	
	  length = protocols.length;
	  index = -1;
	
	  while (++index < length) {
	    protocol = protocols[index];
	
	    if (
	      colon === protocol.length &&
	      value.slice(0, protocol.length) === protocol
	    ) {
	      return true;
	    }
	  }
	
	  index = value.indexOf('?');
	
	  if (index !== -1 && colon > index) {
	    return true;
	  }
	
	  index = value.indexOf('#');
	
	  if (index !== -1 && colon > index) {
	    return true;
	  }
	
	  return false;
	}
	
	/* Sanitize `tagName`. */
	function handleTagName(schema, tagName, node, stack) {
	  var name = typeof tagName === 'string' ? tagName : null;
	  var ancestors = schema.ancestors;
	  var length;
	  var index;
	
	  if (!name || name === '*' || schema.tagNames.indexOf(name) === -1) {
	    return false;
	  }
	
	  ancestors = own.call(ancestors, name) ? ancestors[name] : [];
	
	  /* Some nodes can break out of their context if they
	   * don’t have a certain ancestor. */
	  if (ancestors.length !== 0) {
	    length = ancestors.length + 1;
	    index = -1;
	
	    while (++index < length) {
	      if (!ancestors[index]) {
	        return false;
	      }
	
	      if (stack.indexOf(ancestors[index]) !== -1) {
	        break;
	      }
	    }
	  }
	
	  return name;
	}
	
	/* Sanitize `value`. */
	function handleValue(schema, value) {
	  return typeof value === 'string' ? value : '';
	}
	
	/* Allow `value`. */
	function allow(schema, value) {
	  return value;
	}
	
	/* Check if `prop` is a data property. */
	function data(prop) {
	  return prop.length > 4 && prop.slice(0, 4).toLowerCase() === 'data';
	}


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	module.exports = __webpack_require__(286);


/***/ }),
/* 283 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = comment;
	
	/* Stringify a comment `node`. */
	function comment(ctx, node) {
	  return '<!--' + node.value + '-->';
	}


/***/ }),
/* 284 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = doctype;
	
	/* Stringify a doctype `node`. */
	function doctype(ctx, node) {
	  var pub = node.public;
	  var sys = node.system;
	  var val = '<!DOCTYPE';
	
	  if (!node.name) {
	    return val + '>';
	  }
	
	  val += ' ' + node.name;
	
	  if (pub != null) {
	    val += ' PUBLIC ' + smart(pub);
	  } else if (sys != null) {
	    val += ' SYSTEM';
	  }
	
	  if (sys != null) {
	    val += ' ' + smart(sys);
	  }
	
	  return val + '>';
	}
	
	function smart(value) {
	  var quote = value.indexOf('"') === -1 ? '"' : '\'';
	  return quote + value + quote;
	}


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var xtend = __webpack_require__(12);
	var spaces = __webpack_require__(463).stringify;
	var commas = __webpack_require__(252).stringify;
	var information = __webpack_require__(316);
	var entities = __webpack_require__(87);
	var kebab = __webpack_require__(309);
	var ccount = __webpack_require__(109);
	var all = __webpack_require__(119);
	
	module.exports = element;
	
	/* Constants. */
	var DATA = 'data';
	var EMPTY = '';
	
	/* Characters. */
	var SPACE = ' ';
	var DQ = '"';
	var SQ = '\'';
	var EQ = '=';
	var LT = '<';
	var GT = '>';
	var SO = '/';
	
	/* Stringify an element `node`. */
	function element(ctx, node, index, parent) {
	  var name = node.tagName;
	  var content = all(ctx, name === 'template' ? node.content : node);
	  var selfClosing = ctx.voids.indexOf(name.toLowerCase()) !== -1;
	  var attrs = attributes(ctx, node.properties);
	  var omit = ctx.omit;
	  var value = '';
	
	  /* If the node is categorised as void, but it has
	   * children, remove the categorisation.  This
	   * enables for example `menuitem`s, which are
	   * void in W3C HTML but not void in WHATWG HTML, to
	   * be stringified properly. */
	  selfClosing = content ? false : selfClosing;
	
	  if (attrs || !omit || !omit.opening(node, index, parent)) {
	    value = LT + name + (attrs ? SPACE + attrs : EMPTY);
	
	    if (selfClosing && ctx.close) {
	      if (!ctx.tightClose || attrs.charAt(attrs.length - 1) === SO) {
	        value += SPACE;
	      }
	
	      value += SO;
	    }
	
	    value += GT;
	  }
	
	  value += content;
	
	  if (!selfClosing && (!omit || !omit.closing(node, index, parent))) {
	    value += LT + SO + name + GT;
	  }
	
	  return value;
	}
	
	/* Stringify all attributes. */
	function attributes(ctx, props) {
	  var values = [];
	  var key;
	  var value;
	  var result;
	  var length;
	  var index;
	  var last;
	
	  for (key in props) {
	    value = props[key];
	
	    if (value == null) {
	      continue;
	    }
	
	    result = attribute(ctx, key, value);
	
	    if (result) {
	      values.push(result);
	    }
	  }
	
	  length = values.length;
	  index = -1;
	
	  while (++index < length) {
	    result = values[index];
	    last = ctx.tight && result.charAt(result.length - 1);
	
	    /* In tight mode, don’t add a space after quoted attributes. */
	    if (index !== length - 1 && last !== DQ && last !== SQ) {
	      values[index] = result + SPACE;
	    }
	  }
	
	  return values.join(EMPTY);
	}
	
	/* Stringify one attribute. */
	function attribute(ctx, key, value) {
	  var info = information(key) || {};
	  var name;
	
	  if (
	    value == null ||
	    (typeof value === 'number' && isNaN(value)) ||
	    (!value && info.boolean) ||
	    (value === false && info.overloadedBoolean)
	  ) {
	    return EMPTY;
	  }
	
	  name = attributeName(ctx, key);
	
	  if ((value && info.boolean) || (value === true && info.overloadedBoolean)) {
	    return name;
	  }
	
	  return name + attributeValue(ctx, key, value);
	}
	
	/* Stringify the attribute name. */
	function attributeName(ctx, key) {
	  var info = information(key) || {};
	  var name = info.name || kebab(key);
	
	  if (
	    name.slice(0, DATA.length) === DATA &&
	    /[0-9]/.test(name.charAt(DATA.length))
	  ) {
	    name = DATA + '-' + name.slice(4);
	  }
	
	  return entities(name, xtend(ctx.entities, {
	    subset: ctx.NAME
	  }));
	}
	
	/* Stringify the attribute value. */
	function attributeValue(ctx, key, value) {
	  var info = information(key) || {};
	  var options = ctx.entities;
	  var quote = ctx.quote;
	  var alternative = ctx.alternative;
	  var unquoted;
	
	  if (typeof value === 'object' && 'length' in value) {
	    /* `spaces` doesn’t accept a second argument, but it’s
	     * given here just to keep the code cleaner. */
	    value = (info.commaSeparated ? commas : spaces)(value, {
	      padLeft: !ctx.tightLists
	    });
	  }
	
	  value = String(value);
	
	  if (value || !ctx.collapseEmpty) {
	    unquoted = value;
	
	    /* Check unquoted value. */
	    if (ctx.unquoted) {
	      unquoted = entities(value, xtend(options, {
	        subset: ctx.UNQUOTED,
	        attribute: true
	      }));
	    }
	
	    /* If `value` contains entities when unquoted... */
	    if (!ctx.unquoted || unquoted !== value) {
	      /* If the alternative is less common than `quote`, switch. */
	      if (
	        alternative &&
	        ccount(value, quote) > ccount(value, alternative)
	      ) {
	        quote = alternative;
	      }
	
	      value = entities(value, xtend(options, {
	        subset: quote === SQ ? ctx.SINGLE_QUOTED : ctx.DOUBLE_QUOTED,
	        attribute: true
	      }));
	
	      value = quote + value + quote;
	    }
	
	    /* Don’t add a `=` for unquoted empties. */
	    value = value ? EQ + value : value;
	  }
	
	  return value;
	}


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var voids = __webpack_require__(305);
	var omission = __webpack_require__(287);
	var one = __webpack_require__(123);
	
	module.exports = toHTML;
	
	/* Characters. */
	var NULL = '\0';
	var AMP = '&';
	var SPACE = ' ';
	var TAB = '\t';
	var GR = '`';
	var DQ = '"';
	var SQ = '\'';
	var EQ = '=';
	var LT = '<';
	var GT = '>';
	var SO = '/';
	var LF = '\n';
	var CR = '\r';
	var FF = '\f';
	
	/* https://html.spec.whatwg.org/#attribute-name-state */
	var NAME = [AMP, SPACE, TAB, LF, CR, FF, SO, GT, EQ];
	var CLEAN_NAME = NAME.concat(NULL, DQ, SQ, LT);
	
	/* In safe mode, all attribute values contain DQ (`"`),
	 * SQ (`'`), and GR (`` ` ``), as those can create XSS
	 * issues in older browsers:
	 * - https://html5sec.org/#59
	 * - https://html5sec.org/#102
	 * - https://html5sec.org/#108 */
	var QUOTES = [DQ, SQ, GR];
	
	/* https://html.spec.whatwg.org/#attribute-value-(unquoted)-state */
	var UQ_VALUE = [AMP, SPACE, TAB, LF, CR, FF, GT];
	var UQ_VALUE_CLEAN = UQ_VALUE.concat(NULL, DQ, SQ, LT, EQ, GR);
	
	/* https://html.spec.whatwg.org/#attribute-value-(single-quoted)-state */
	var SQ_VALUE = [AMP, SQ];
	var SQ_VALUE_CLEAN = SQ_VALUE.concat(NULL);
	
	/* https://html.spec.whatwg.org/#attribute-value-(double-quoted)-state */
	var DQ_VALUE = [AMP, DQ];
	var DQ_VALUE_CLEAN = DQ_VALUE.concat(NULL);
	
	/* Stringify the given HAST node. */
	function toHTML(node, options) {
	  var settings = options || {};
	  var quote = settings.quote || DQ;
	  var smart = settings.quoteSmart;
	  var errors = settings.allowParseErrors;
	  var characters = settings.allowDangerousCharacters;
	  var alternative = quote === DQ ? SQ : DQ;
	  var name = errors ? NAME : CLEAN_NAME;
	  var unquoted = errors ? UQ_VALUE : UQ_VALUE_CLEAN;
	  var singleQuoted = errors ? SQ_VALUE : SQ_VALUE_CLEAN;
	  var doubleQuoted = errors ? DQ_VALUE : DQ_VALUE_CLEAN;
	
	  if (quote !== DQ && quote !== SQ) {
	    throw new Error(
	      'Invalid quote `' + quote + '`, expected `' +
	      SQ + '` or `' + DQ + '`'
	    );
	  }
	
	  return one({
	    NAME: name.concat(characters ? [] : QUOTES),
	    UNQUOTED: unquoted.concat(characters ? [] : QUOTES),
	    DOUBLE_QUOTED: doubleQuoted.concat(characters ? [] : QUOTES),
	    SINGLE_QUOTED: singleQuoted.concat(characters ? [] : QUOTES),
	    omit: settings.omitOptionalTags && omission,
	    quote: quote,
	    alternative: smart ? alternative : null,
	    unquoted: Boolean(settings.preferUnquoted),
	    tight: settings.tightAttributes,
	    tightLists: settings.tightCommaSeparatedLists,
	    tightClose: settings.tightSelfClosing,
	    collapseEmpty: settings.collapseEmptyAttributes,
	    dangerous: settings.allowDangerousHTML,
	    voids: settings.voids || voids.concat(),
	    entities: settings.entities || {},
	    close: settings.closeSelfClosing
	  }, node);
	}


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	exports.opening = __webpack_require__(288);
	exports.closing = __webpack_require__(120);


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var is = __webpack_require__(56);
	var element = __webpack_require__(118);
	var before = __webpack_require__(80).before;
	var first = __webpack_require__(289);
	var place = __webpack_require__(290);
	var whiteSpaceLeft = __webpack_require__(122);
	var closing = __webpack_require__(120);
	var omission = __webpack_require__(121);
	
	var own = {}.hasOwnProperty;
	
	module.exports = omission({
	  html: html,
	  head: head,
	  body: body,
	  colgroup: colgroup,
	  tbody: tbody
	});
	
	/* Whether to omit `<html>`. */
	function html(node) {
	  var head = first(node);
	  return !head || !is('comment', head);
	}
	
	/* Whether to omit `<head>`. */
	function head(node) {
	  var children = node.children;
	  var length = children.length;
	  var map = {};
	  var index = -1;
	  var child;
	  var name;
	
	  while (++index < length) {
	    child = children[index];
	    name = child.tagName;
	
	    if (
	      child.type === 'element' &&
	      (name === 'title' || name === 'base')
	    ) {
	      if (own.call(map, name)) {
	        return false;
	      }
	
	      map[name] = true;
	    }
	  }
	
	  return Boolean(length);
	}
	
	/* Whether to omit `<body>`. */
	function body(node) {
	  var head = first(node, true);
	
	  return !head || (
	    !is('comment', head) &&
	    !whiteSpaceLeft(head) &&
	    !element(head, ['meta', 'link', 'script', 'style', 'template'])
	  );
	}
	
	/* Whether to omit `<colgroup>`.
	 * The spec describes some logic for the opening tag,
	 * but it’s easier to implement in the closing tag, to
	 * the same effect, so we handle it there instead. */
	function colgroup(node, index, parent) {
	  var prev = before(parent, index);
	  var head = first(node, true);
	
	  /* Previous colgroup was already omitted. */
	  if (
	    element(prev, 'colgroup') &&
	    closing(prev, place(parent, prev), parent)
	  ) {
	    return false;
	  }
	
	  return head && element(head, 'col');
	}
	
	/* Whether to omit `<tbody>`. */
	function tbody(node, index, parent) {
	  var prev = before(parent, index);
	  var head = first(node);
	
	  /* Previous table section was already omitted. */
	  if (
	    element(prev, ['thead', 'tbody']) &&
	    closing(prev, place(parent, prev), parent)
	  ) {
	    return false;
	  }
	
	  return head && element(head, 'tr');
	}


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var after = __webpack_require__(80).after;
	
	module.exports = first;
	
	/* Get the first child in `parent`. */
	function first(parent, includeWhiteSpace) {
	  return after(parent, -1, includeWhiteSpace);
	}


/***/ }),
/* 290 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = place;
	
	/* Get the position of `node` in `parent`. */
	function place(parent, child) {
	  return parent && parent.children && parent.children.indexOf(child);
	}


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var text = __webpack_require__(124);
	
	module.exports = raw;
	
	/* Stringify `raw`. */
	function raw(ctx, node) {
	  return ctx.dangerous ? node.value : text(ctx, node);
	}


/***/ }),
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */
/***/ (function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ }),
/* 296 */
/***/ (function(module, exports) {

	'use strict';
	module.exports = function (str) {
		if (typeof str !== 'string') {
			throw new TypeError('Expected a string');
		}
	
		return !/[^0-9a-z\xDF-\xFF]/.test(str.toLowerCase());
	};


/***/ }),
/* 297 */
/***/ (function(module, exports) {

	/*!
	 * Determine if an object is a Buffer
	 *
	 * @author   Feross Aboukhadijeh <https://feross.org>
	 * @license  MIT
	 */
	
	// The _isBuffer check is for Safari 5-7 support, because it's missing
	// Object.prototype.constructor. Remove this eventually
	module.exports = function (obj) {
	  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
	}
	
	function isBuffer (obj) {
	  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
	}
	
	// For Node v0.10 support. Remove this eventually.
	function isSlowBuffer (obj) {
	  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
	}


/***/ }),
/* 298 */
/***/ (function(module, exports) {

	'use strict';
	var toString = Object.prototype.toString;
	
	module.exports = function (x) {
		var prototype;
		return toString.call(x) === '[object Object]' && (prototype = Object.getPrototypeOf(x), prototype === null || prototype === Object.getPrototypeOf({}));
	};


/***/ }),
/* 299 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = wordCharacter
	
	var fromCode = String.fromCharCode
	var re = /\w/
	
	/* Check if the given character code, or the character
	 * code at the first character, is a word character. */
	function wordCharacter(character) {
	  return re.test(
	    typeof character === 'number' ? fromCode(character) : character.charAt(0)
	  )
	}


/***/ }),
/* 300 */,
/* 301 */
/***/ (function(module, exports) {

	module.exports = {"nbsp":" ","iexcl":"¡","cent":"¢","pound":"£","curren":"¤","yen":"¥","brvbar":"¦","sect":"§","uml":"¨","copy":"©","ordf":"ª","laquo":"«","not":"¬","shy":"­","reg":"®","macr":"¯","deg":"°","plusmn":"±","sup2":"²","sup3":"³","acute":"´","micro":"µ","para":"¶","middot":"·","cedil":"¸","sup1":"¹","ordm":"º","raquo":"»","frac14":"¼","frac12":"½","frac34":"¾","iquest":"¿","Agrave":"À","Aacute":"Á","Acirc":"Â","Atilde":"Ã","Auml":"Ä","Aring":"Å","AElig":"Æ","Ccedil":"Ç","Egrave":"È","Eacute":"É","Ecirc":"Ê","Euml":"Ë","Igrave":"Ì","Iacute":"Í","Icirc":"Î","Iuml":"Ï","ETH":"Ð","Ntilde":"Ñ","Ograve":"Ò","Oacute":"Ó","Ocirc":"Ô","Otilde":"Õ","Ouml":"Ö","times":"×","Oslash":"Ø","Ugrave":"Ù","Uacute":"Ú","Ucirc":"Û","Uuml":"Ü","Yacute":"Ý","THORN":"Þ","szlig":"ß","agrave":"à","aacute":"á","acirc":"â","atilde":"ã","auml":"ä","aring":"å","aelig":"æ","ccedil":"ç","egrave":"è","eacute":"é","ecirc":"ê","euml":"ë","igrave":"ì","iacute":"í","icirc":"î","iuml":"ï","eth":"ð","ntilde":"ñ","ograve":"ò","oacute":"ó","ocirc":"ô","otilde":"õ","ouml":"ö","divide":"÷","oslash":"ø","ugrave":"ù","uacute":"ú","ucirc":"û","uuml":"ü","yacute":"ý","thorn":"þ","yuml":"ÿ","fnof":"ƒ","Alpha":"Α","Beta":"Β","Gamma":"Γ","Delta":"Δ","Epsilon":"Ε","Zeta":"Ζ","Eta":"Η","Theta":"Θ","Iota":"Ι","Kappa":"Κ","Lambda":"Λ","Mu":"Μ","Nu":"Ν","Xi":"Ξ","Omicron":"Ο","Pi":"Π","Rho":"Ρ","Sigma":"Σ","Tau":"Τ","Upsilon":"Υ","Phi":"Φ","Chi":"Χ","Psi":"Ψ","Omega":"Ω","alpha":"α","beta":"β","gamma":"γ","delta":"δ","epsilon":"ε","zeta":"ζ","eta":"η","theta":"θ","iota":"ι","kappa":"κ","lambda":"λ","mu":"μ","nu":"ν","xi":"ξ","omicron":"ο","pi":"π","rho":"ρ","sigmaf":"ς","sigma":"σ","tau":"τ","upsilon":"υ","phi":"φ","chi":"χ","psi":"ψ","omega":"ω","thetasym":"ϑ","upsih":"ϒ","piv":"ϖ","bull":"•","hellip":"…","prime":"′","Prime":"″","oline":"‾","frasl":"⁄","weierp":"℘","image":"ℑ","real":"ℜ","trade":"™","alefsym":"ℵ","larr":"←","uarr":"↑","rarr":"→","darr":"↓","harr":"↔","crarr":"↵","lArr":"⇐","uArr":"⇑","rArr":"⇒","dArr":"⇓","hArr":"⇔","forall":"∀","part":"∂","exist":"∃","empty":"∅","nabla":"∇","isin":"∈","notin":"∉","ni":"∋","prod":"∏","sum":"∑","minus":"−","lowast":"∗","radic":"√","prop":"∝","infin":"∞","ang":"∠","and":"∧","or":"∨","cap":"∩","cup":"∪","int":"∫","there4":"∴","sim":"∼","cong":"≅","asymp":"≈","ne":"≠","equiv":"≡","le":"≤","ge":"≥","sub":"⊂","sup":"⊃","nsub":"⊄","sube":"⊆","supe":"⊇","oplus":"⊕","otimes":"⊗","perp":"⊥","sdot":"⋅","lceil":"⌈","rceil":"⌉","lfloor":"⌊","rfloor":"⌋","lang":"〈","rang":"〉","loz":"◊","spades":"♠","clubs":"♣","hearts":"♥","diams":"♦","quot":"\"","amp":"&","lt":"<","gt":">","OElig":"Œ","oelig":"œ","Scaron":"Š","scaron":"š","Yuml":"Ÿ","circ":"ˆ","tilde":"˜","ensp":" ","emsp":" ","thinsp":" ","zwnj":"‌","zwj":"‍","lrm":"‎","rlm":"‏","ndash":"–","mdash":"—","lsquo":"‘","rsquo":"’","sbquo":"‚","ldquo":"“","rdquo":"”","bdquo":"„","dagger":"†","Dagger":"‡","permil":"‰","lsaquo":"‹","rsaquo":"›","euro":"€"}

/***/ }),
/* 302 */
/***/ (function(module, exports) {

	module.exports = {"AEli":"Æ","AElig":"Æ","AM":"&","AMP":"&","Aacut":"Á","Aacute":"Á","Abreve":"Ă","Acir":"Â","Acirc":"Â","Acy":"А","Afr":"𝔄","Agrav":"À","Agrave":"À","Alpha":"Α","Amacr":"Ā","And":"⩓","Aogon":"Ą","Aopf":"𝔸","ApplyFunction":"⁡","Arin":"Å","Aring":"Å","Ascr":"𝒜","Assign":"≔","Atild":"Ã","Atilde":"Ã","Aum":"Ä","Auml":"Ä","Backslash":"∖","Barv":"⫧","Barwed":"⌆","Bcy":"Б","Because":"∵","Bernoullis":"ℬ","Beta":"Β","Bfr":"𝔅","Bopf":"𝔹","Breve":"˘","Bscr":"ℬ","Bumpeq":"≎","CHcy":"Ч","COP":"©","COPY":"©","Cacute":"Ć","Cap":"⋒","CapitalDifferentialD":"ⅅ","Cayleys":"ℭ","Ccaron":"Č","Ccedi":"Ç","Ccedil":"Ç","Ccirc":"Ĉ","Cconint":"∰","Cdot":"Ċ","Cedilla":"¸","CenterDot":"·","Cfr":"ℭ","Chi":"Χ","CircleDot":"⊙","CircleMinus":"⊖","CirclePlus":"⊕","CircleTimes":"⊗","ClockwiseContourIntegral":"∲","CloseCurlyDoubleQuote":"”","CloseCurlyQuote":"’","Colon":"∷","Colone":"⩴","Congruent":"≡","Conint":"∯","ContourIntegral":"∮","Copf":"ℂ","Coproduct":"∐","CounterClockwiseContourIntegral":"∳","Cross":"⨯","Cscr":"𝒞","Cup":"⋓","CupCap":"≍","DD":"ⅅ","DDotrahd":"⤑","DJcy":"Ђ","DScy":"Ѕ","DZcy":"Џ","Dagger":"‡","Darr":"↡","Dashv":"⫤","Dcaron":"Ď","Dcy":"Д","Del":"∇","Delta":"Δ","Dfr":"𝔇","DiacriticalAcute":"´","DiacriticalDot":"˙","DiacriticalDoubleAcute":"˝","DiacriticalGrave":"`","DiacriticalTilde":"˜","Diamond":"⋄","DifferentialD":"ⅆ","Dopf":"𝔻","Dot":"¨","DotDot":"⃜","DotEqual":"≐","DoubleContourIntegral":"∯","DoubleDot":"¨","DoubleDownArrow":"⇓","DoubleLeftArrow":"⇐","DoubleLeftRightArrow":"⇔","DoubleLeftTee":"⫤","DoubleLongLeftArrow":"⟸","DoubleLongLeftRightArrow":"⟺","DoubleLongRightArrow":"⟹","DoubleRightArrow":"⇒","DoubleRightTee":"⊨","DoubleUpArrow":"⇑","DoubleUpDownArrow":"⇕","DoubleVerticalBar":"∥","DownArrow":"↓","DownArrowBar":"⤓","DownArrowUpArrow":"⇵","DownBreve":"̑","DownLeftRightVector":"⥐","DownLeftTeeVector":"⥞","DownLeftVector":"↽","DownLeftVectorBar":"⥖","DownRightTeeVector":"⥟","DownRightVector":"⇁","DownRightVectorBar":"⥗","DownTee":"⊤","DownTeeArrow":"↧","Downarrow":"⇓","Dscr":"𝒟","Dstrok":"Đ","ENG":"Ŋ","ET":"Ð","ETH":"Ð","Eacut":"É","Eacute":"É","Ecaron":"Ě","Ecir":"Ê","Ecirc":"Ê","Ecy":"Э","Edot":"Ė","Efr":"𝔈","Egrav":"È","Egrave":"È","Element":"∈","Emacr":"Ē","EmptySmallSquare":"◻","EmptyVerySmallSquare":"▫","Eogon":"Ę","Eopf":"𝔼","Epsilon":"Ε","Equal":"⩵","EqualTilde":"≂","Equilibrium":"⇌","Escr":"ℰ","Esim":"⩳","Eta":"Η","Eum":"Ë","Euml":"Ë","Exists":"∃","ExponentialE":"ⅇ","Fcy":"Ф","Ffr":"𝔉","FilledSmallSquare":"◼","FilledVerySmallSquare":"▪","Fopf":"𝔽","ForAll":"∀","Fouriertrf":"ℱ","Fscr":"ℱ","GJcy":"Ѓ","G":">","GT":">","Gamma":"Γ","Gammad":"Ϝ","Gbreve":"Ğ","Gcedil":"Ģ","Gcirc":"Ĝ","Gcy":"Г","Gdot":"Ġ","Gfr":"𝔊","Gg":"⋙","Gopf":"𝔾","GreaterEqual":"≥","GreaterEqualLess":"⋛","GreaterFullEqual":"≧","GreaterGreater":"⪢","GreaterLess":"≷","GreaterSlantEqual":"⩾","GreaterTilde":"≳","Gscr":"𝒢","Gt":"≫","HARDcy":"Ъ","Hacek":"ˇ","Hat":"^","Hcirc":"Ĥ","Hfr":"ℌ","HilbertSpace":"ℋ","Hopf":"ℍ","HorizontalLine":"─","Hscr":"ℋ","Hstrok":"Ħ","HumpDownHump":"≎","HumpEqual":"≏","IEcy":"Е","IJlig":"Ĳ","IOcy":"Ё","Iacut":"Í","Iacute":"Í","Icir":"Î","Icirc":"Î","Icy":"И","Idot":"İ","Ifr":"ℑ","Igrav":"Ì","Igrave":"Ì","Im":"ℑ","Imacr":"Ī","ImaginaryI":"ⅈ","Implies":"⇒","Int":"∬","Integral":"∫","Intersection":"⋂","InvisibleComma":"⁣","InvisibleTimes":"⁢","Iogon":"Į","Iopf":"𝕀","Iota":"Ι","Iscr":"ℐ","Itilde":"Ĩ","Iukcy":"І","Ium":"Ï","Iuml":"Ï","Jcirc":"Ĵ","Jcy":"Й","Jfr":"𝔍","Jopf":"𝕁","Jscr":"𝒥","Jsercy":"Ј","Jukcy":"Є","KHcy":"Х","KJcy":"Ќ","Kappa":"Κ","Kcedil":"Ķ","Kcy":"К","Kfr":"𝔎","Kopf":"𝕂","Kscr":"𝒦","LJcy":"Љ","L":"<","LT":"<","Lacute":"Ĺ","Lambda":"Λ","Lang":"⟪","Laplacetrf":"ℒ","Larr":"↞","Lcaron":"Ľ","Lcedil":"Ļ","Lcy":"Л","LeftAngleBracket":"⟨","LeftArrow":"←","LeftArrowBar":"⇤","LeftArrowRightArrow":"⇆","LeftCeiling":"⌈","LeftDoubleBracket":"⟦","LeftDownTeeVector":"⥡","LeftDownVector":"⇃","LeftDownVectorBar":"⥙","LeftFloor":"⌊","LeftRightArrow":"↔","LeftRightVector":"⥎","LeftTee":"⊣","LeftTeeArrow":"↤","LeftTeeVector":"⥚","LeftTriangle":"⊲","LeftTriangleBar":"⧏","LeftTriangleEqual":"⊴","LeftUpDownVector":"⥑","LeftUpTeeVector":"⥠","LeftUpVector":"↿","LeftUpVectorBar":"⥘","LeftVector":"↼","LeftVectorBar":"⥒","Leftarrow":"⇐","Leftrightarrow":"⇔","LessEqualGreater":"⋚","LessFullEqual":"≦","LessGreater":"≶","LessLess":"⪡","LessSlantEqual":"⩽","LessTilde":"≲","Lfr":"𝔏","Ll":"⋘","Lleftarrow":"⇚","Lmidot":"Ŀ","LongLeftArrow":"⟵","LongLeftRightArrow":"⟷","LongRightArrow":"⟶","Longleftarrow":"⟸","Longleftrightarrow":"⟺","Longrightarrow":"⟹","Lopf":"𝕃","LowerLeftArrow":"↙","LowerRightArrow":"↘","Lscr":"ℒ","Lsh":"↰","Lstrok":"Ł","Lt":"≪","Map":"⤅","Mcy":"М","MediumSpace":" ","Mellintrf":"ℳ","Mfr":"𝔐","MinusPlus":"∓","Mopf":"𝕄","Mscr":"ℳ","Mu":"Μ","NJcy":"Њ","Nacute":"Ń","Ncaron":"Ň","Ncedil":"Ņ","Ncy":"Н","NegativeMediumSpace":"​","NegativeThickSpace":"​","NegativeThinSpace":"​","NegativeVeryThinSpace":"​","NestedGreaterGreater":"≫","NestedLessLess":"≪","NewLine":"\n","Nfr":"𝔑","NoBreak":"⁠","NonBreakingSpace":" ","Nopf":"ℕ","Not":"⫬","NotCongruent":"≢","NotCupCap":"≭","NotDoubleVerticalBar":"∦","NotElement":"∉","NotEqual":"≠","NotEqualTilde":"≂̸","NotExists":"∄","NotGreater":"≯","NotGreaterEqual":"≱","NotGreaterFullEqual":"≧̸","NotGreaterGreater":"≫̸","NotGreaterLess":"≹","NotGreaterSlantEqual":"⩾̸","NotGreaterTilde":"≵","NotHumpDownHump":"≎̸","NotHumpEqual":"≏̸","NotLeftTriangle":"⋪","NotLeftTriangleBar":"⧏̸","NotLeftTriangleEqual":"⋬","NotLess":"≮","NotLessEqual":"≰","NotLessGreater":"≸","NotLessLess":"≪̸","NotLessSlantEqual":"⩽̸","NotLessTilde":"≴","NotNestedGreaterGreater":"⪢̸","NotNestedLessLess":"⪡̸","NotPrecedes":"⊀","NotPrecedesEqual":"⪯̸","NotPrecedesSlantEqual":"⋠","NotReverseElement":"∌","NotRightTriangle":"⋫","NotRightTriangleBar":"⧐̸","NotRightTriangleEqual":"⋭","NotSquareSubset":"⊏̸","NotSquareSubsetEqual":"⋢","NotSquareSuperset":"⊐̸","NotSquareSupersetEqual":"⋣","NotSubset":"⊂⃒","NotSubsetEqual":"⊈","NotSucceeds":"⊁","NotSucceedsEqual":"⪰̸","NotSucceedsSlantEqual":"⋡","NotSucceedsTilde":"≿̸","NotSuperset":"⊃⃒","NotSupersetEqual":"⊉","NotTilde":"≁","NotTildeEqual":"≄","NotTildeFullEqual":"≇","NotTildeTilde":"≉","NotVerticalBar":"∤","Nscr":"𝒩","Ntild":"Ñ","Ntilde":"Ñ","Nu":"Ν","OElig":"Œ","Oacut":"Ó","Oacute":"Ó","Ocir":"Ô","Ocirc":"Ô","Ocy":"О","Odblac":"Ő","Ofr":"𝔒","Ograv":"Ò","Ograve":"Ò","Omacr":"Ō","Omega":"Ω","Omicron":"Ο","Oopf":"𝕆","OpenCurlyDoubleQuote":"“","OpenCurlyQuote":"‘","Or":"⩔","Oscr":"𝒪","Oslas":"Ø","Oslash":"Ø","Otild":"Õ","Otilde":"Õ","Otimes":"⨷","Oum":"Ö","Ouml":"Ö","OverBar":"‾","OverBrace":"⏞","OverBracket":"⎴","OverParenthesis":"⏜","PartialD":"∂","Pcy":"П","Pfr":"𝔓","Phi":"Φ","Pi":"Π","PlusMinus":"±","Poincareplane":"ℌ","Popf":"ℙ","Pr":"⪻","Precedes":"≺","PrecedesEqual":"⪯","PrecedesSlantEqual":"≼","PrecedesTilde":"≾","Prime":"″","Product":"∏","Proportion":"∷","Proportional":"∝","Pscr":"𝒫","Psi":"Ψ","QUO":"\"","QUOT":"\"","Qfr":"𝔔","Qopf":"ℚ","Qscr":"𝒬","RBarr":"⤐","RE":"®","REG":"®","Racute":"Ŕ","Rang":"⟫","Rarr":"↠","Rarrtl":"⤖","Rcaron":"Ř","Rcedil":"Ŗ","Rcy":"Р","Re":"ℜ","ReverseElement":"∋","ReverseEquilibrium":"⇋","ReverseUpEquilibrium":"⥯","Rfr":"ℜ","Rho":"Ρ","RightAngleBracket":"⟩","RightArrow":"→","RightArrowBar":"⇥","RightArrowLeftArrow":"⇄","RightCeiling":"⌉","RightDoubleBracket":"⟧","RightDownTeeVector":"⥝","RightDownVector":"⇂","RightDownVectorBar":"⥕","RightFloor":"⌋","RightTee":"⊢","RightTeeArrow":"↦","RightTeeVector":"⥛","RightTriangle":"⊳","RightTriangleBar":"⧐","RightTriangleEqual":"⊵","RightUpDownVector":"⥏","RightUpTeeVector":"⥜","RightUpVector":"↾","RightUpVectorBar":"⥔","RightVector":"⇀","RightVectorBar":"⥓","Rightarrow":"⇒","Ropf":"ℝ","RoundImplies":"⥰","Rrightarrow":"⇛","Rscr":"ℛ","Rsh":"↱","RuleDelayed":"⧴","SHCHcy":"Щ","SHcy":"Ш","SOFTcy":"Ь","Sacute":"Ś","Sc":"⪼","Scaron":"Š","Scedil":"Ş","Scirc":"Ŝ","Scy":"С","Sfr":"𝔖","ShortDownArrow":"↓","ShortLeftArrow":"←","ShortRightArrow":"→","ShortUpArrow":"↑","Sigma":"Σ","SmallCircle":"∘","Sopf":"𝕊","Sqrt":"√","Square":"□","SquareIntersection":"⊓","SquareSubset":"⊏","SquareSubsetEqual":"⊑","SquareSuperset":"⊐","SquareSupersetEqual":"⊒","SquareUnion":"⊔","Sscr":"𝒮","Star":"⋆","Sub":"⋐","Subset":"⋐","SubsetEqual":"⊆","Succeeds":"≻","SucceedsEqual":"⪰","SucceedsSlantEqual":"≽","SucceedsTilde":"≿","SuchThat":"∋","Sum":"∑","Sup":"⋑","Superset":"⊃","SupersetEqual":"⊇","Supset":"⋑","THOR":"Þ","THORN":"Þ","TRADE":"™","TSHcy":"Ћ","TScy":"Ц","Tab":"\t","Tau":"Τ","Tcaron":"Ť","Tcedil":"Ţ","Tcy":"Т","Tfr":"𝔗","Therefore":"∴","Theta":"Θ","ThickSpace":"  ","ThinSpace":" ","Tilde":"∼","TildeEqual":"≃","TildeFullEqual":"≅","TildeTilde":"≈","Topf":"𝕋","TripleDot":"⃛","Tscr":"𝒯","Tstrok":"Ŧ","Uacut":"Ú","Uacute":"Ú","Uarr":"↟","Uarrocir":"⥉","Ubrcy":"Ў","Ubreve":"Ŭ","Ucir":"Û","Ucirc":"Û","Ucy":"У","Udblac":"Ű","Ufr":"𝔘","Ugrav":"Ù","Ugrave":"Ù","Umacr":"Ū","UnderBar":"_","UnderBrace":"⏟","UnderBracket":"⎵","UnderParenthesis":"⏝","Union":"⋃","UnionPlus":"⊎","Uogon":"Ų","Uopf":"𝕌","UpArrow":"↑","UpArrowBar":"⤒","UpArrowDownArrow":"⇅","UpDownArrow":"↕","UpEquilibrium":"⥮","UpTee":"⊥","UpTeeArrow":"↥","Uparrow":"⇑","Updownarrow":"⇕","UpperLeftArrow":"↖","UpperRightArrow":"↗","Upsi":"ϒ","Upsilon":"Υ","Uring":"Ů","Uscr":"𝒰","Utilde":"Ũ","Uum":"Ü","Uuml":"Ü","VDash":"⊫","Vbar":"⫫","Vcy":"В","Vdash":"⊩","Vdashl":"⫦","Vee":"⋁","Verbar":"‖","Vert":"‖","VerticalBar":"∣","VerticalLine":"|","VerticalSeparator":"❘","VerticalTilde":"≀","VeryThinSpace":" ","Vfr":"𝔙","Vopf":"𝕍","Vscr":"𝒱","Vvdash":"⊪","Wcirc":"Ŵ","Wedge":"⋀","Wfr":"𝔚","Wopf":"𝕎","Wscr":"𝒲","Xfr":"𝔛","Xi":"Ξ","Xopf":"𝕏","Xscr":"𝒳","YAcy":"Я","YIcy":"Ї","YUcy":"Ю","Yacut":"Ý","Yacute":"Ý","Ycirc":"Ŷ","Ycy":"Ы","Yfr":"𝔜","Yopf":"𝕐","Yscr":"𝒴","Yuml":"Ÿ","ZHcy":"Ж","Zacute":"Ź","Zcaron":"Ž","Zcy":"З","Zdot":"Ż","ZeroWidthSpace":"​","Zeta":"Ζ","Zfr":"ℨ","Zopf":"ℤ","Zscr":"𝒵","aacut":"á","aacute":"á","abreve":"ă","ac":"∾","acE":"∾̳","acd":"∿","acir":"â","acirc":"â","acut":"´","acute":"´","acy":"а","aeli":"æ","aelig":"æ","af":"⁡","afr":"𝔞","agrav":"à","agrave":"à","alefsym":"ℵ","aleph":"ℵ","alpha":"α","amacr":"ā","amalg":"⨿","am":"&","amp":"&","and":"∧","andand":"⩕","andd":"⩜","andslope":"⩘","andv":"⩚","ang":"∠","ange":"⦤","angle":"∠","angmsd":"∡","angmsdaa":"⦨","angmsdab":"⦩","angmsdac":"⦪","angmsdad":"⦫","angmsdae":"⦬","angmsdaf":"⦭","angmsdag":"⦮","angmsdah":"⦯","angrt":"∟","angrtvb":"⊾","angrtvbd":"⦝","angsph":"∢","angst":"Å","angzarr":"⍼","aogon":"ą","aopf":"𝕒","ap":"≈","apE":"⩰","apacir":"⩯","ape":"≊","apid":"≋","apos":"'","approx":"≈","approxeq":"≊","arin":"å","aring":"å","ascr":"𝒶","ast":"*","asymp":"≈","asympeq":"≍","atild":"ã","atilde":"ã","aum":"ä","auml":"ä","awconint":"∳","awint":"⨑","bNot":"⫭","backcong":"≌","backepsilon":"϶","backprime":"‵","backsim":"∽","backsimeq":"⋍","barvee":"⊽","barwed":"⌅","barwedge":"⌅","bbrk":"⎵","bbrktbrk":"⎶","bcong":"≌","bcy":"б","bdquo":"„","becaus":"∵","because":"∵","bemptyv":"⦰","bepsi":"϶","bernou":"ℬ","beta":"β","beth":"ℶ","between":"≬","bfr":"𝔟","bigcap":"⋂","bigcirc":"◯","bigcup":"⋃","bigodot":"⨀","bigoplus":"⨁","bigotimes":"⨂","bigsqcup":"⨆","bigstar":"★","bigtriangledown":"▽","bigtriangleup":"△","biguplus":"⨄","bigvee":"⋁","bigwedge":"⋀","bkarow":"⤍","blacklozenge":"⧫","blacksquare":"▪","blacktriangle":"▴","blacktriangledown":"▾","blacktriangleleft":"◂","blacktriangleright":"▸","blank":"␣","blk12":"▒","blk14":"░","blk34":"▓","block":"█","bne":"=⃥","bnequiv":"≡⃥","bnot":"⌐","bopf":"𝕓","bot":"⊥","bottom":"⊥","bowtie":"⋈","boxDL":"╗","boxDR":"╔","boxDl":"╖","boxDr":"╓","boxH":"═","boxHD":"╦","boxHU":"╩","boxHd":"╤","boxHu":"╧","boxUL":"╝","boxUR":"╚","boxUl":"╜","boxUr":"╙","boxV":"║","boxVH":"╬","boxVL":"╣","boxVR":"╠","boxVh":"╫","boxVl":"╢","boxVr":"╟","boxbox":"⧉","boxdL":"╕","boxdR":"╒","boxdl":"┐","boxdr":"┌","boxh":"─","boxhD":"╥","boxhU":"╨","boxhd":"┬","boxhu":"┴","boxminus":"⊟","boxplus":"⊞","boxtimes":"⊠","boxuL":"╛","boxuR":"╘","boxul":"┘","boxur":"└","boxv":"│","boxvH":"╪","boxvL":"╡","boxvR":"╞","boxvh":"┼","boxvl":"┤","boxvr":"├","bprime":"‵","breve":"˘","brvba":"¦","brvbar":"¦","bscr":"𝒷","bsemi":"⁏","bsim":"∽","bsime":"⋍","bsol":"\\","bsolb":"⧅","bsolhsub":"⟈","bull":"•","bullet":"•","bump":"≎","bumpE":"⪮","bumpe":"≏","bumpeq":"≏","cacute":"ć","cap":"∩","capand":"⩄","capbrcup":"⩉","capcap":"⩋","capcup":"⩇","capdot":"⩀","caps":"∩︀","caret":"⁁","caron":"ˇ","ccaps":"⩍","ccaron":"č","ccedi":"ç","ccedil":"ç","ccirc":"ĉ","ccups":"⩌","ccupssm":"⩐","cdot":"ċ","cedi":"¸","cedil":"¸","cemptyv":"⦲","cen":"¢","cent":"¢","centerdot":"·","cfr":"𝔠","chcy":"ч","check":"✓","checkmark":"✓","chi":"χ","cir":"○","cirE":"⧃","circ":"ˆ","circeq":"≗","circlearrowleft":"↺","circlearrowright":"↻","circledR":"®","circledS":"Ⓢ","circledast":"⊛","circledcirc":"⊚","circleddash":"⊝","cire":"≗","cirfnint":"⨐","cirmid":"⫯","cirscir":"⧂","clubs":"♣","clubsuit":"♣","colon":":","colone":"≔","coloneq":"≔","comma":",","commat":"@","comp":"∁","compfn":"∘","complement":"∁","complexes":"ℂ","cong":"≅","congdot":"⩭","conint":"∮","copf":"𝕔","coprod":"∐","cop":"©","copy":"©","copysr":"℗","crarr":"↵","cross":"✗","cscr":"𝒸","csub":"⫏","csube":"⫑","csup":"⫐","csupe":"⫒","ctdot":"⋯","cudarrl":"⤸","cudarrr":"⤵","cuepr":"⋞","cuesc":"⋟","cularr":"↶","cularrp":"⤽","cup":"∪","cupbrcap":"⩈","cupcap":"⩆","cupcup":"⩊","cupdot":"⊍","cupor":"⩅","cups":"∪︀","curarr":"↷","curarrm":"⤼","curlyeqprec":"⋞","curlyeqsucc":"⋟","curlyvee":"⋎","curlywedge":"⋏","curre":"¤","curren":"¤","curvearrowleft":"↶","curvearrowright":"↷","cuvee":"⋎","cuwed":"⋏","cwconint":"∲","cwint":"∱","cylcty":"⌭","dArr":"⇓","dHar":"⥥","dagger":"†","daleth":"ℸ","darr":"↓","dash":"‐","dashv":"⊣","dbkarow":"⤏","dblac":"˝","dcaron":"ď","dcy":"д","dd":"ⅆ","ddagger":"‡","ddarr":"⇊","ddotseq":"⩷","de":"°","deg":"°","delta":"δ","demptyv":"⦱","dfisht":"⥿","dfr":"𝔡","dharl":"⇃","dharr":"⇂","diam":"⋄","diamond":"⋄","diamondsuit":"♦","diams":"♦","die":"¨","digamma":"ϝ","disin":"⋲","div":"÷","divid":"÷","divide":"÷","divideontimes":"⋇","divonx":"⋇","djcy":"ђ","dlcorn":"⌞","dlcrop":"⌍","dollar":"$","dopf":"𝕕","dot":"˙","doteq":"≐","doteqdot":"≑","dotminus":"∸","dotplus":"∔","dotsquare":"⊡","doublebarwedge":"⌆","downarrow":"↓","downdownarrows":"⇊","downharpoonleft":"⇃","downharpoonright":"⇂","drbkarow":"⤐","drcorn":"⌟","drcrop":"⌌","dscr":"𝒹","dscy":"ѕ","dsol":"⧶","dstrok":"đ","dtdot":"⋱","dtri":"▿","dtrif":"▾","duarr":"⇵","duhar":"⥯","dwangle":"⦦","dzcy":"џ","dzigrarr":"⟿","eDDot":"⩷","eDot":"≑","eacut":"é","eacute":"é","easter":"⩮","ecaron":"ě","ecir":"ê","ecirc":"ê","ecolon":"≕","ecy":"э","edot":"ė","ee":"ⅇ","efDot":"≒","efr":"𝔢","eg":"⪚","egrav":"è","egrave":"è","egs":"⪖","egsdot":"⪘","el":"⪙","elinters":"⏧","ell":"ℓ","els":"⪕","elsdot":"⪗","emacr":"ē","empty":"∅","emptyset":"∅","emptyv":"∅","emsp13":" ","emsp14":" ","emsp":" ","eng":"ŋ","ensp":" ","eogon":"ę","eopf":"𝕖","epar":"⋕","eparsl":"⧣","eplus":"⩱","epsi":"ε","epsilon":"ε","epsiv":"ϵ","eqcirc":"≖","eqcolon":"≕","eqsim":"≂","eqslantgtr":"⪖","eqslantless":"⪕","equals":"=","equest":"≟","equiv":"≡","equivDD":"⩸","eqvparsl":"⧥","erDot":"≓","erarr":"⥱","escr":"ℯ","esdot":"≐","esim":"≂","eta":"η","et":"ð","eth":"ð","eum":"ë","euml":"ë","euro":"€","excl":"!","exist":"∃","expectation":"ℰ","exponentiale":"ⅇ","fallingdotseq":"≒","fcy":"ф","female":"♀","ffilig":"ﬃ","fflig":"ﬀ","ffllig":"ﬄ","ffr":"𝔣","filig":"ﬁ","fjlig":"fj","flat":"♭","fllig":"ﬂ","fltns":"▱","fnof":"ƒ","fopf":"𝕗","forall":"∀","fork":"⋔","forkv":"⫙","fpartint":"⨍","frac1":"¼","frac12":"½","frac13":"⅓","frac14":"¼","frac15":"⅕","frac16":"⅙","frac18":"⅛","frac23":"⅔","frac25":"⅖","frac3":"¾","frac34":"¾","frac35":"⅗","frac38":"⅜","frac45":"⅘","frac56":"⅚","frac58":"⅝","frac78":"⅞","frasl":"⁄","frown":"⌢","fscr":"𝒻","gE":"≧","gEl":"⪌","gacute":"ǵ","gamma":"γ","gammad":"ϝ","gap":"⪆","gbreve":"ğ","gcirc":"ĝ","gcy":"г","gdot":"ġ","ge":"≥","gel":"⋛","geq":"≥","geqq":"≧","geqslant":"⩾","ges":"⩾","gescc":"⪩","gesdot":"⪀","gesdoto":"⪂","gesdotol":"⪄","gesl":"⋛︀","gesles":"⪔","gfr":"𝔤","gg":"≫","ggg":"⋙","gimel":"ℷ","gjcy":"ѓ","gl":"≷","glE":"⪒","gla":"⪥","glj":"⪤","gnE":"≩","gnap":"⪊","gnapprox":"⪊","gne":"⪈","gneq":"⪈","gneqq":"≩","gnsim":"⋧","gopf":"𝕘","grave":"`","gscr":"ℊ","gsim":"≳","gsime":"⪎","gsiml":"⪐","g":">","gt":">","gtcc":"⪧","gtcir":"⩺","gtdot":"⋗","gtlPar":"⦕","gtquest":"⩼","gtrapprox":"⪆","gtrarr":"⥸","gtrdot":"⋗","gtreqless":"⋛","gtreqqless":"⪌","gtrless":"≷","gtrsim":"≳","gvertneqq":"≩︀","gvnE":"≩︀","hArr":"⇔","hairsp":" ","half":"½","hamilt":"ℋ","hardcy":"ъ","harr":"↔","harrcir":"⥈","harrw":"↭","hbar":"ℏ","hcirc":"ĥ","hearts":"♥","heartsuit":"♥","hellip":"…","hercon":"⊹","hfr":"𝔥","hksearow":"⤥","hkswarow":"⤦","hoarr":"⇿","homtht":"∻","hookleftarrow":"↩","hookrightarrow":"↪","hopf":"𝕙","horbar":"―","hscr":"𝒽","hslash":"ℏ","hstrok":"ħ","hybull":"⁃","hyphen":"‐","iacut":"í","iacute":"í","ic":"⁣","icir":"î","icirc":"î","icy":"и","iecy":"е","iexc":"¡","iexcl":"¡","iff":"⇔","ifr":"𝔦","igrav":"ì","igrave":"ì","ii":"ⅈ","iiiint":"⨌","iiint":"∭","iinfin":"⧜","iiota":"℩","ijlig":"ĳ","imacr":"ī","image":"ℑ","imagline":"ℐ","imagpart":"ℑ","imath":"ı","imof":"⊷","imped":"Ƶ","in":"∈","incare":"℅","infin":"∞","infintie":"⧝","inodot":"ı","int":"∫","intcal":"⊺","integers":"ℤ","intercal":"⊺","intlarhk":"⨗","intprod":"⨼","iocy":"ё","iogon":"į","iopf":"𝕚","iota":"ι","iprod":"⨼","iques":"¿","iquest":"¿","iscr":"𝒾","isin":"∈","isinE":"⋹","isindot":"⋵","isins":"⋴","isinsv":"⋳","isinv":"∈","it":"⁢","itilde":"ĩ","iukcy":"і","ium":"ï","iuml":"ï","jcirc":"ĵ","jcy":"й","jfr":"𝔧","jmath":"ȷ","jopf":"𝕛","jscr":"𝒿","jsercy":"ј","jukcy":"є","kappa":"κ","kappav":"ϰ","kcedil":"ķ","kcy":"к","kfr":"𝔨","kgreen":"ĸ","khcy":"х","kjcy":"ќ","kopf":"𝕜","kscr":"𝓀","lAarr":"⇚","lArr":"⇐","lAtail":"⤛","lBarr":"⤎","lE":"≦","lEg":"⪋","lHar":"⥢","lacute":"ĺ","laemptyv":"⦴","lagran":"ℒ","lambda":"λ","lang":"⟨","langd":"⦑","langle":"⟨","lap":"⪅","laqu":"«","laquo":"«","larr":"←","larrb":"⇤","larrbfs":"⤟","larrfs":"⤝","larrhk":"↩","larrlp":"↫","larrpl":"⤹","larrsim":"⥳","larrtl":"↢","lat":"⪫","latail":"⤙","late":"⪭","lates":"⪭︀","lbarr":"⤌","lbbrk":"❲","lbrace":"{","lbrack":"[","lbrke":"⦋","lbrksld":"⦏","lbrkslu":"⦍","lcaron":"ľ","lcedil":"ļ","lceil":"⌈","lcub":"{","lcy":"л","ldca":"⤶","ldquo":"“","ldquor":"„","ldrdhar":"⥧","ldrushar":"⥋","ldsh":"↲","le":"≤","leftarrow":"←","leftarrowtail":"↢","leftharpoondown":"↽","leftharpoonup":"↼","leftleftarrows":"⇇","leftrightarrow":"↔","leftrightarrows":"⇆","leftrightharpoons":"⇋","leftrightsquigarrow":"↭","leftthreetimes":"⋋","leg":"⋚","leq":"≤","leqq":"≦","leqslant":"⩽","les":"⩽","lescc":"⪨","lesdot":"⩿","lesdoto":"⪁","lesdotor":"⪃","lesg":"⋚︀","lesges":"⪓","lessapprox":"⪅","lessdot":"⋖","lesseqgtr":"⋚","lesseqqgtr":"⪋","lessgtr":"≶","lesssim":"≲","lfisht":"⥼","lfloor":"⌊","lfr":"𝔩","lg":"≶","lgE":"⪑","lhard":"↽","lharu":"↼","lharul":"⥪","lhblk":"▄","ljcy":"љ","ll":"≪","llarr":"⇇","llcorner":"⌞","llhard":"⥫","lltri":"◺","lmidot":"ŀ","lmoust":"⎰","lmoustache":"⎰","lnE":"≨","lnap":"⪉","lnapprox":"⪉","lne":"⪇","lneq":"⪇","lneqq":"≨","lnsim":"⋦","loang":"⟬","loarr":"⇽","lobrk":"⟦","longleftarrow":"⟵","longleftrightarrow":"⟷","longmapsto":"⟼","longrightarrow":"⟶","looparrowleft":"↫","looparrowright":"↬","lopar":"⦅","lopf":"𝕝","loplus":"⨭","lotimes":"⨴","lowast":"∗","lowbar":"_","loz":"◊","lozenge":"◊","lozf":"⧫","lpar":"(","lparlt":"⦓","lrarr":"⇆","lrcorner":"⌟","lrhar":"⇋","lrhard":"⥭","lrm":"‎","lrtri":"⊿","lsaquo":"‹","lscr":"𝓁","lsh":"↰","lsim":"≲","lsime":"⪍","lsimg":"⪏","lsqb":"[","lsquo":"‘","lsquor":"‚","lstrok":"ł","l":"<","lt":"<","ltcc":"⪦","ltcir":"⩹","ltdot":"⋖","lthree":"⋋","ltimes":"⋉","ltlarr":"⥶","ltquest":"⩻","ltrPar":"⦖","ltri":"◃","ltrie":"⊴","ltrif":"◂","lurdshar":"⥊","luruhar":"⥦","lvertneqq":"≨︀","lvnE":"≨︀","mDDot":"∺","mac":"¯","macr":"¯","male":"♂","malt":"✠","maltese":"✠","map":"↦","mapsto":"↦","mapstodown":"↧","mapstoleft":"↤","mapstoup":"↥","marker":"▮","mcomma":"⨩","mcy":"м","mdash":"—","measuredangle":"∡","mfr":"𝔪","mho":"℧","micr":"µ","micro":"µ","mid":"∣","midast":"*","midcir":"⫰","middo":"·","middot":"·","minus":"−","minusb":"⊟","minusd":"∸","minusdu":"⨪","mlcp":"⫛","mldr":"…","mnplus":"∓","models":"⊧","mopf":"𝕞","mp":"∓","mscr":"𝓂","mstpos":"∾","mu":"μ","multimap":"⊸","mumap":"⊸","nGg":"⋙̸","nGt":"≫⃒","nGtv":"≫̸","nLeftarrow":"⇍","nLeftrightarrow":"⇎","nLl":"⋘̸","nLt":"≪⃒","nLtv":"≪̸","nRightarrow":"⇏","nVDash":"⊯","nVdash":"⊮","nabla":"∇","nacute":"ń","nang":"∠⃒","nap":"≉","napE":"⩰̸","napid":"≋̸","napos":"ŉ","napprox":"≉","natur":"♮","natural":"♮","naturals":"ℕ","nbs":" ","nbsp":" ","nbump":"≎̸","nbumpe":"≏̸","ncap":"⩃","ncaron":"ň","ncedil":"ņ","ncong":"≇","ncongdot":"⩭̸","ncup":"⩂","ncy":"н","ndash":"–","ne":"≠","neArr":"⇗","nearhk":"⤤","nearr":"↗","nearrow":"↗","nedot":"≐̸","nequiv":"≢","nesear":"⤨","nesim":"≂̸","nexist":"∄","nexists":"∄","nfr":"𝔫","ngE":"≧̸","nge":"≱","ngeq":"≱","ngeqq":"≧̸","ngeqslant":"⩾̸","nges":"⩾̸","ngsim":"≵","ngt":"≯","ngtr":"≯","nhArr":"⇎","nharr":"↮","nhpar":"⫲","ni":"∋","nis":"⋼","nisd":"⋺","niv":"∋","njcy":"њ","nlArr":"⇍","nlE":"≦̸","nlarr":"↚","nldr":"‥","nle":"≰","nleftarrow":"↚","nleftrightarrow":"↮","nleq":"≰","nleqq":"≦̸","nleqslant":"⩽̸","nles":"⩽̸","nless":"≮","nlsim":"≴","nlt":"≮","nltri":"⋪","nltrie":"⋬","nmid":"∤","nopf":"𝕟","no":"¬","not":"¬","notin":"∉","notinE":"⋹̸","notindot":"⋵̸","notinva":"∉","notinvb":"⋷","notinvc":"⋶","notni":"∌","notniva":"∌","notnivb":"⋾","notnivc":"⋽","npar":"∦","nparallel":"∦","nparsl":"⫽⃥","npart":"∂̸","npolint":"⨔","npr":"⊀","nprcue":"⋠","npre":"⪯̸","nprec":"⊀","npreceq":"⪯̸","nrArr":"⇏","nrarr":"↛","nrarrc":"⤳̸","nrarrw":"↝̸","nrightarrow":"↛","nrtri":"⋫","nrtrie":"⋭","nsc":"⊁","nsccue":"⋡","nsce":"⪰̸","nscr":"𝓃","nshortmid":"∤","nshortparallel":"∦","nsim":"≁","nsime":"≄","nsimeq":"≄","nsmid":"∤","nspar":"∦","nsqsube":"⋢","nsqsupe":"⋣","nsub":"⊄","nsubE":"⫅̸","nsube":"⊈","nsubset":"⊂⃒","nsubseteq":"⊈","nsubseteqq":"⫅̸","nsucc":"⊁","nsucceq":"⪰̸","nsup":"⊅","nsupE":"⫆̸","nsupe":"⊉","nsupset":"⊃⃒","nsupseteq":"⊉","nsupseteqq":"⫆̸","ntgl":"≹","ntild":"ñ","ntilde":"ñ","ntlg":"≸","ntriangleleft":"⋪","ntrianglelefteq":"⋬","ntriangleright":"⋫","ntrianglerighteq":"⋭","nu":"ν","num":"#","numero":"№","numsp":" ","nvDash":"⊭","nvHarr":"⤄","nvap":"≍⃒","nvdash":"⊬","nvge":"≥⃒","nvgt":">⃒","nvinfin":"⧞","nvlArr":"⤂","nvle":"≤⃒","nvlt":"<⃒","nvltrie":"⊴⃒","nvrArr":"⤃","nvrtrie":"⊵⃒","nvsim":"∼⃒","nwArr":"⇖","nwarhk":"⤣","nwarr":"↖","nwarrow":"↖","nwnear":"⤧","oS":"Ⓢ","oacut":"ó","oacute":"ó","oast":"⊛","ocir":"ô","ocirc":"ô","ocy":"о","odash":"⊝","odblac":"ő","odiv":"⨸","odot":"⊙","odsold":"⦼","oelig":"œ","ofcir":"⦿","ofr":"𝔬","ogon":"˛","ograv":"ò","ograve":"ò","ogt":"⧁","ohbar":"⦵","ohm":"Ω","oint":"∮","olarr":"↺","olcir":"⦾","olcross":"⦻","oline":"‾","olt":"⧀","omacr":"ō","omega":"ω","omicron":"ο","omid":"⦶","ominus":"⊖","oopf":"𝕠","opar":"⦷","operp":"⦹","oplus":"⊕","or":"∨","orarr":"↻","ord":"º","order":"ℴ","orderof":"ℴ","ordf":"ª","ordm":"º","origof":"⊶","oror":"⩖","orslope":"⩗","orv":"⩛","oscr":"ℴ","oslas":"ø","oslash":"ø","osol":"⊘","otild":"õ","otilde":"õ","otimes":"⊗","otimesas":"⨶","oum":"ö","ouml":"ö","ovbar":"⌽","par":"¶","para":"¶","parallel":"∥","parsim":"⫳","parsl":"⫽","part":"∂","pcy":"п","percnt":"%","period":".","permil":"‰","perp":"⊥","pertenk":"‱","pfr":"𝔭","phi":"φ","phiv":"ϕ","phmmat":"ℳ","phone":"☎","pi":"π","pitchfork":"⋔","piv":"ϖ","planck":"ℏ","planckh":"ℎ","plankv":"ℏ","plus":"+","plusacir":"⨣","plusb":"⊞","pluscir":"⨢","plusdo":"∔","plusdu":"⨥","pluse":"⩲","plusm":"±","plusmn":"±","plussim":"⨦","plustwo":"⨧","pm":"±","pointint":"⨕","popf":"𝕡","poun":"£","pound":"£","pr":"≺","prE":"⪳","prap":"⪷","prcue":"≼","pre":"⪯","prec":"≺","precapprox":"⪷","preccurlyeq":"≼","preceq":"⪯","precnapprox":"⪹","precneqq":"⪵","precnsim":"⋨","precsim":"≾","prime":"′","primes":"ℙ","prnE":"⪵","prnap":"⪹","prnsim":"⋨","prod":"∏","profalar":"⌮","profline":"⌒","profsurf":"⌓","prop":"∝","propto":"∝","prsim":"≾","prurel":"⊰","pscr":"𝓅","psi":"ψ","puncsp":" ","qfr":"𝔮","qint":"⨌","qopf":"𝕢","qprime":"⁗","qscr":"𝓆","quaternions":"ℍ","quatint":"⨖","quest":"?","questeq":"≟","quo":"\"","quot":"\"","rAarr":"⇛","rArr":"⇒","rAtail":"⤜","rBarr":"⤏","rHar":"⥤","race":"∽̱","racute":"ŕ","radic":"√","raemptyv":"⦳","rang":"⟩","rangd":"⦒","range":"⦥","rangle":"⟩","raqu":"»","raquo":"»","rarr":"→","rarrap":"⥵","rarrb":"⇥","rarrbfs":"⤠","rarrc":"⤳","rarrfs":"⤞","rarrhk":"↪","rarrlp":"↬","rarrpl":"⥅","rarrsim":"⥴","rarrtl":"↣","rarrw":"↝","ratail":"⤚","ratio":"∶","rationals":"ℚ","rbarr":"⤍","rbbrk":"❳","rbrace":"}","rbrack":"]","rbrke":"⦌","rbrksld":"⦎","rbrkslu":"⦐","rcaron":"ř","rcedil":"ŗ","rceil":"⌉","rcub":"}","rcy":"р","rdca":"⤷","rdldhar":"⥩","rdquo":"”","rdquor":"”","rdsh":"↳","real":"ℜ","realine":"ℛ","realpart":"ℜ","reals":"ℝ","rect":"▭","re":"®","reg":"®","rfisht":"⥽","rfloor":"⌋","rfr":"𝔯","rhard":"⇁","rharu":"⇀","rharul":"⥬","rho":"ρ","rhov":"ϱ","rightarrow":"→","rightarrowtail":"↣","rightharpoondown":"⇁","rightharpoonup":"⇀","rightleftarrows":"⇄","rightleftharpoons":"⇌","rightrightarrows":"⇉","rightsquigarrow":"↝","rightthreetimes":"⋌","ring":"˚","risingdotseq":"≓","rlarr":"⇄","rlhar":"⇌","rlm":"‏","rmoust":"⎱","rmoustache":"⎱","rnmid":"⫮","roang":"⟭","roarr":"⇾","robrk":"⟧","ropar":"⦆","ropf":"𝕣","roplus":"⨮","rotimes":"⨵","rpar":")","rpargt":"⦔","rppolint":"⨒","rrarr":"⇉","rsaquo":"›","rscr":"𝓇","rsh":"↱","rsqb":"]","rsquo":"’","rsquor":"’","rthree":"⋌","rtimes":"⋊","rtri":"▹","rtrie":"⊵","rtrif":"▸","rtriltri":"⧎","ruluhar":"⥨","rx":"℞","sacute":"ś","sbquo":"‚","sc":"≻","scE":"⪴","scap":"⪸","scaron":"š","sccue":"≽","sce":"⪰","scedil":"ş","scirc":"ŝ","scnE":"⪶","scnap":"⪺","scnsim":"⋩","scpolint":"⨓","scsim":"≿","scy":"с","sdot":"⋅","sdotb":"⊡","sdote":"⩦","seArr":"⇘","searhk":"⤥","searr":"↘","searrow":"↘","sec":"§","sect":"§","semi":";","seswar":"⤩","setminus":"∖","setmn":"∖","sext":"✶","sfr":"𝔰","sfrown":"⌢","sharp":"♯","shchcy":"щ","shcy":"ш","shortmid":"∣","shortparallel":"∥","sh":"­","shy":"­","sigma":"σ","sigmaf":"ς","sigmav":"ς","sim":"∼","simdot":"⩪","sime":"≃","simeq":"≃","simg":"⪞","simgE":"⪠","siml":"⪝","simlE":"⪟","simne":"≆","simplus":"⨤","simrarr":"⥲","slarr":"←","smallsetminus":"∖","smashp":"⨳","smeparsl":"⧤","smid":"∣","smile":"⌣","smt":"⪪","smte":"⪬","smtes":"⪬︀","softcy":"ь","sol":"/","solb":"⧄","solbar":"⌿","sopf":"𝕤","spades":"♠","spadesuit":"♠","spar":"∥","sqcap":"⊓","sqcaps":"⊓︀","sqcup":"⊔","sqcups":"⊔︀","sqsub":"⊏","sqsube":"⊑","sqsubset":"⊏","sqsubseteq":"⊑","sqsup":"⊐","sqsupe":"⊒","sqsupset":"⊐","sqsupseteq":"⊒","squ":"□","square":"□","squarf":"▪","squf":"▪","srarr":"→","sscr":"𝓈","ssetmn":"∖","ssmile":"⌣","sstarf":"⋆","star":"☆","starf":"★","straightepsilon":"ϵ","straightphi":"ϕ","strns":"¯","sub":"⊂","subE":"⫅","subdot":"⪽","sube":"⊆","subedot":"⫃","submult":"⫁","subnE":"⫋","subne":"⊊","subplus":"⪿","subrarr":"⥹","subset":"⊂","subseteq":"⊆","subseteqq":"⫅","subsetneq":"⊊","subsetneqq":"⫋","subsim":"⫇","subsub":"⫕","subsup":"⫓","succ":"≻","succapprox":"⪸","succcurlyeq":"≽","succeq":"⪰","succnapprox":"⪺","succneqq":"⪶","succnsim":"⋩","succsim":"≿","sum":"∑","sung":"♪","sup":"⊃","sup1":"¹","sup2":"²","sup3":"³","supE":"⫆","supdot":"⪾","supdsub":"⫘","supe":"⊇","supedot":"⫄","suphsol":"⟉","suphsub":"⫗","suplarr":"⥻","supmult":"⫂","supnE":"⫌","supne":"⊋","supplus":"⫀","supset":"⊃","supseteq":"⊇","supseteqq":"⫆","supsetneq":"⊋","supsetneqq":"⫌","supsim":"⫈","supsub":"⫔","supsup":"⫖","swArr":"⇙","swarhk":"⤦","swarr":"↙","swarrow":"↙","swnwar":"⤪","szli":"ß","szlig":"ß","target":"⌖","tau":"τ","tbrk":"⎴","tcaron":"ť","tcedil":"ţ","tcy":"т","tdot":"⃛","telrec":"⌕","tfr":"𝔱","there4":"∴","therefore":"∴","theta":"θ","thetasym":"ϑ","thetav":"ϑ","thickapprox":"≈","thicksim":"∼","thinsp":" ","thkap":"≈","thksim":"∼","thor":"þ","thorn":"þ","tilde":"˜","time":"×","times":"×","timesb":"⊠","timesbar":"⨱","timesd":"⨰","tint":"∭","toea":"⤨","top":"⊤","topbot":"⌶","topcir":"⫱","topf":"𝕥","topfork":"⫚","tosa":"⤩","tprime":"‴","trade":"™","triangle":"▵","triangledown":"▿","triangleleft":"◃","trianglelefteq":"⊴","triangleq":"≜","triangleright":"▹","trianglerighteq":"⊵","tridot":"◬","trie":"≜","triminus":"⨺","triplus":"⨹","trisb":"⧍","tritime":"⨻","trpezium":"⏢","tscr":"𝓉","tscy":"ц","tshcy":"ћ","tstrok":"ŧ","twixt":"≬","twoheadleftarrow":"↞","twoheadrightarrow":"↠","uArr":"⇑","uHar":"⥣","uacut":"ú","uacute":"ú","uarr":"↑","ubrcy":"ў","ubreve":"ŭ","ucir":"û","ucirc":"û","ucy":"у","udarr":"⇅","udblac":"ű","udhar":"⥮","ufisht":"⥾","ufr":"𝔲","ugrav":"ù","ugrave":"ù","uharl":"↿","uharr":"↾","uhblk":"▀","ulcorn":"⌜","ulcorner":"⌜","ulcrop":"⌏","ultri":"◸","umacr":"ū","um":"¨","uml":"¨","uogon":"ų","uopf":"𝕦","uparrow":"↑","updownarrow":"↕","upharpoonleft":"↿","upharpoonright":"↾","uplus":"⊎","upsi":"υ","upsih":"ϒ","upsilon":"υ","upuparrows":"⇈","urcorn":"⌝","urcorner":"⌝","urcrop":"⌎","uring":"ů","urtri":"◹","uscr":"𝓊","utdot":"⋰","utilde":"ũ","utri":"▵","utrif":"▴","uuarr":"⇈","uum":"ü","uuml":"ü","uwangle":"⦧","vArr":"⇕","vBar":"⫨","vBarv":"⫩","vDash":"⊨","vangrt":"⦜","varepsilon":"ϵ","varkappa":"ϰ","varnothing":"∅","varphi":"ϕ","varpi":"ϖ","varpropto":"∝","varr":"↕","varrho":"ϱ","varsigma":"ς","varsubsetneq":"⊊︀","varsubsetneqq":"⫋︀","varsupsetneq":"⊋︀","varsupsetneqq":"⫌︀","vartheta":"ϑ","vartriangleleft":"⊲","vartriangleright":"⊳","vcy":"в","vdash":"⊢","vee":"∨","veebar":"⊻","veeeq":"≚","vellip":"⋮","verbar":"|","vert":"|","vfr":"𝔳","vltri":"⊲","vnsub":"⊂⃒","vnsup":"⊃⃒","vopf":"𝕧","vprop":"∝","vrtri":"⊳","vscr":"𝓋","vsubnE":"⫋︀","vsubne":"⊊︀","vsupnE":"⫌︀","vsupne":"⊋︀","vzigzag":"⦚","wcirc":"ŵ","wedbar":"⩟","wedge":"∧","wedgeq":"≙","weierp":"℘","wfr":"𝔴","wopf":"𝕨","wp":"℘","wr":"≀","wreath":"≀","wscr":"𝓌","xcap":"⋂","xcirc":"◯","xcup":"⋃","xdtri":"▽","xfr":"𝔵","xhArr":"⟺","xharr":"⟷","xi":"ξ","xlArr":"⟸","xlarr":"⟵","xmap":"⟼","xnis":"⋻","xodot":"⨀","xopf":"𝕩","xoplus":"⨁","xotime":"⨂","xrArr":"⟹","xrarr":"⟶","xscr":"𝓍","xsqcup":"⨆","xuplus":"⨄","xutri":"△","xvee":"⋁","xwedge":"⋀","yacut":"ý","yacute":"ý","yacy":"я","ycirc":"ŷ","ycy":"ы","ye":"¥","yen":"¥","yfr":"𝔶","yicy":"ї","yopf":"𝕪","yscr":"𝓎","yucy":"ю","yum":"ÿ","yuml":"ÿ","zacute":"ź","zcaron":"ž","zcy":"з","zdot":"ż","zeetrf":"ℨ","zeta":"ζ","zfr":"𝔷","zhcy":"ж","zigrarr":"⇝","zopf":"𝕫","zscr":"𝓏","zwj":"‍","zwnj":"‌"}

/***/ }),
/* 303 */
/***/ (function(module, exports) {

	module.exports = {"0":"�","128":"€","130":"‚","131":"ƒ","132":"„","133":"…","134":"†","135":"‡","136":"ˆ","137":"‰","138":"Š","139":"‹","140":"Œ","142":"Ž","145":"‘","146":"’","147":"“","148":"”","149":"•","150":"–","151":"—","152":"˜","153":"™","154":"š","155":"›","156":"œ","158":"ž","159":"Ÿ"}

/***/ }),
/* 304 */
/***/ (function(module, exports) {

	module.exports = {"strip":["script"],"clobberPrefix":"user-content-","clobber":["name","id"],"ancestors":{"li":["ol","ul"],"tbody":["table"],"tfoot":["table"],"thead":["table"],"td":["table"],"th":["table"],"tr":["table"]},"protocols":{"href":["http","https","mailto"],"cite":["http","https"],"src":["http","https"],"longDesc":["http","https"]},"tagNames":["h1","h2","h3","h4","h5","h6","h7","h8","br","b","i","strong","em","a","pre","code","img","tt","div","ins","del","sup","sub","p","ol","ul","table","thead","tbody","tfoot","blockquote","dl","dt","dd","kbd","q","samp","var","hr","ruby","rt","rp","li","tr","td","th","s","strike","summary","details"],"attributes":{"a":["href"],"img":["src","longDesc"],"div":["itemScope","itemType"],"blockquote":["cite"],"del":["cite"],"ins":["cite"],"q":["cite"],"*":["abbr","accept","acceptCharset","accessKey","action","align","alt","axis","border","cellPadding","cellSpacing","char","charoff","charSet","checked","clear","cols","colSpan","color","compact","coords","dateTime","dir","disabled","encType","htmlFor","frame","headers","height","hrefLang","hspace","isMap","id","label","lang","maxLength","media","method","multiple","name","nohref","noshade","nowrap","open","prompt","readOnly","rel","rev","rows","rowSpan","rules","scope","selected","shape","size","span","start","summary","tabIndex","target","title","type","useMap","valign","value","vspace","width","itemProp"]}}

/***/ }),
/* 305 */
/***/ (function(module, exports) {

	module.exports = ["area","base","basefont","bgsound","br","col","command","embed","frame","hr","image","img","input","isindex","keygen","link","menuitem","meta","nextid","param","source","track","wbr"]

/***/ }),
/* 306 */
/***/ (function(module, exports) {

	module.exports = {"addendum":"addenda","aircraft":"aircraft","alga":"algae","alumna":"alumnae","alumnus":"alumni","amoeba":"amoebae","analysis":"analyses","antenna":"antennae","antithesis":"antitheses","apex":"apices","appendix":"appendices","automaton":"automata","axis":"axes","bacillus":"bacilli","bacterium":"bacteria","barracks":"barracks","basis":"bases","beau":"beaux","bison":"bison","buffalo":"buffalo","bureau":"bureaus","cactus":"cacti","calf":"calves","carp":"carp","census":"censuses","chassis":"chassis","cherub":"cherubim","child":"children","château":"châteaus","cod":"cod","codex":"codices","concerto":"concerti","corpus":"corpora","crisis":"crises","criterion":"criteria","curriculum":"curricula","datum":"data","deer":"deer","diagnosis":"diagnoses","die":"dice","dwarf":"dwarfs","echo":"echoes","elf":"elves","elk":"elk","ellipsis":"ellipses","embargo":"embargoes","emphasis":"emphases","erratum":"errata","faux pas":"faux pas","fez":"fezes","firmware":"firmware","fish":"fish","focus":"foci","foot":"feet","formula":"formulae","fungus":"fungi","gallows":"gallows","genus":"genera","goose":"geese","graffito":"graffiti","grouse":"grouse","half":"halves","hero":"heroes","hoof":"hooves","hovercraft":"hovercraft","hypothesis":"hypotheses","index":"indices","kakapo":"kakapo","knife":"knives","larva":"larvae","leaf":"leaves","libretto":"libretti","life":"lives","loaf":"loaves","locus":"loci","louse":"lice","man":"men","matrix":"matrices","means":"means","medium":"media","memorandum":"memoranda","millennium":"millennia","minutia":"minutiae","moose":"moose","mouse":"mice","nebula":"nebulae","nemesis":"nemeses","neurosis":"neuroses","news":"news","nucleus":"nuclei","oasis":"oases","offspring":"offspring","opus":"opera","ovum":"ova","ox":"oxen","paralysis":"paralyses","parenthesis":"parentheses","person":"people","phenomenon":"phenomena","phylum":"phyla","pike":"pike","polyhedron":"polyhedra","potato":"potatoes","prognosis":"prognoses","quiz":"quizzes","radius":"radii","referendum":"referenda","salmon":"salmon","scarf":"scarves","self":"selves","series":"series","sheep":"sheep","shelf":"shelves","shrimp":"shrimp","spacecraft":"spacecraft","species":"species","spectrum":"spectra","squid":"squid","stimulus":"stimuli","stratum":"strata","swine":"swine","syllabus":"syllabi","symposium":"symposia","synopsis":"synopses","synthesis":"syntheses","tableau":"tableaus","that":"those","thesis":"theses","thief":"thieves","this":"these","tomato":"tomatoes","tooth":"teeth","trout":"trout","tuna":"tuna","vertebra":"vertebrae","vertex":"vertices","veto":"vetoes","vita":"vitae","vortex":"vortices","watercraft":"watercraft","wharf":"wharves","wife":"wives","wolf":"wolves","woman":"women"}

/***/ }),
/* 307 */
/***/ (function(module, exports) {

	module.exports = ["address","article","aside","base","basefont","blockquote","body","caption","center","col","colgroup","dd","details","dialog","dir","div","dl","dt","fieldset","figcaption","figure","footer","form","frame","frameset","h1","h2","h3","h4","h5","h6","head","header","hgroup","hr","html","iframe","legend","li","link","main","menu","menuitem","meta","nav","noframes","ol","optgroup","option","p","param","pre","section","source","title","summary","table","tbody","td","tfoot","th","thead","title","tr","track","ul"]

/***/ }),
/* 308 */
/***/ (function(module, exports) {

	module.exports = ["cent","copy","divide","gt","lt","not","para","times"]

/***/ }),
/* 309 */
/***/ (function(module, exports) {

	'use strict';
	var KEBAB_REGEX = /[A-Z\u00C0-\u00D6\u00D8-\u00DE]/g;
	var REVERSE_REGEX = /-[a-z\u00E0-\u00F6\u00F8-\u00FE]/g;
	
	module.exports = exports = function kebabCase(str) {
		return str.replace(KEBAB_REGEX, function (match) {
			return '-' + match.toLowerCase();
		});
	};
	
	exports.reverse = function (str) {
		return str.replace(REVERSE_REGEX, function (match) {
			return match.slice(1).toUpperCase();
		});
	};


/***/ }),
/* 310 */
/***/ (function(module, exports) {

	'use strict'
	
	/* Expose. */
	module.exports = markdownTable
	
	/* Expressions. */
	var EXPRESSION_DOT = /\./
	var EXPRESSION_LAST_DOT = /\.[^.]*$/
	
	/* Allowed alignment values. */
	var LEFT = 'l'
	var RIGHT = 'r'
	var CENTER = 'c'
	var DOT = '.'
	var NULL = ''
	
	var ALLIGNMENT = [LEFT, RIGHT, CENTER, DOT, NULL]
	var MIN_CELL_SIZE = 3
	
	/* Characters. */
	var COLON = ':'
	var DASH = '-'
	var PIPE = '|'
	var SPACE = ' '
	var NEW_LINE = '\n'
	
	/* Create a table from a matrix of strings. */
	function markdownTable(table, options) {
	  var settings = options || {}
	  var delimiter = settings.delimiter
	  var start = settings.start
	  var end = settings.end
	  var alignment = settings.align
	  var calculateStringLength = settings.stringLength || lengthNoop
	  var cellCount = 0
	  var rowIndex = -1
	  var rowLength = table.length
	  var sizes = []
	  var align
	  var rule
	  var rows
	  var row
	  var cells
	  var index
	  var position
	  var size
	  var value
	  var spacing
	  var before
	  var after
	
	  alignment = alignment ? alignment.concat() : []
	
	  if (delimiter === null || delimiter === undefined) {
	    delimiter = SPACE + PIPE + SPACE
	  }
	
	  if (start === null || start === undefined) {
	    start = PIPE + SPACE
	  }
	
	  if (end === null || end === undefined) {
	    end = SPACE + PIPE
	  }
	
	  while (++rowIndex < rowLength) {
	    row = table[rowIndex]
	
	    index = -1
	
	    if (row.length > cellCount) {
	      cellCount = row.length
	    }
	
	    while (++index < cellCount) {
	      position = row[index] ? dotindex(row[index]) : null
	
	      if (!sizes[index]) {
	        sizes[index] = MIN_CELL_SIZE
	      }
	
	      if (position > sizes[index]) {
	        sizes[index] = position
	      }
	    }
	  }
	
	  if (typeof alignment === 'string') {
	    alignment = pad(cellCount, alignment).split('')
	  }
	
	  /* Make sure only valid alignments are used. */
	  index = -1
	
	  while (++index < cellCount) {
	    align = alignment[index]
	
	    if (typeof align === 'string') {
	      align = align.charAt(0).toLowerCase()
	    }
	
	    if (ALLIGNMENT.indexOf(align) === -1) {
	      align = NULL
	    }
	
	    alignment[index] = align
	  }
	
	  rowIndex = -1
	  rows = []
	
	  while (++rowIndex < rowLength) {
	    row = table[rowIndex]
	
	    index = -1
	    cells = []
	
	    while (++index < cellCount) {
	      value = row[index]
	
	      value = stringify(value)
	
	      if (alignment[index] === DOT) {
	        position = dotindex(value)
	
	        size =
	          sizes[index] +
	          (EXPRESSION_DOT.test(value) ? 0 : 1) -
	          (calculateStringLength(value) - position)
	
	        cells[index] = value + pad(size - 1)
	      } else {
	        cells[index] = value
	      }
	    }
	
	    rows[rowIndex] = cells
	  }
	
	  sizes = []
	  rowIndex = -1
	
	  while (++rowIndex < rowLength) {
	    cells = rows[rowIndex]
	
	    index = -1
	
	    while (++index < cellCount) {
	      value = cells[index]
	
	      if (!sizes[index]) {
	        sizes[index] = MIN_CELL_SIZE
	      }
	
	      size = calculateStringLength(value)
	
	      if (size > sizes[index]) {
	        sizes[index] = size
	      }
	    }
	  }
	
	  rowIndex = -1
	
	  while (++rowIndex < rowLength) {
	    cells = rows[rowIndex]
	
	    index = -1
	
	    if (settings.pad !== false) {
	      while (++index < cellCount) {
	        value = cells[index]
	
	        position = sizes[index] - (calculateStringLength(value) || 0)
	        spacing = pad(position)
	
	        if (alignment[index] === RIGHT || alignment[index] === DOT) {
	          value = spacing + value
	        } else if (alignment[index] === CENTER) {
	          position /= 2
	
	          if (position % 1 === 0) {
	            before = position
	            after = position
	          } else {
	            before = position + 0.5
	            after = position - 0.5
	          }
	
	          value = pad(before) + value + pad(after)
	        } else {
	          value += spacing
	        }
	
	        cells[index] = value
	      }
	    }
	
	    rows[rowIndex] = cells.join(delimiter)
	  }
	
	  if (settings.rule !== false) {
	    index = -1
	    rule = []
	
	    while (++index < cellCount) {
	      /* When `pad` is false, make the rule the same size as the first row. */
	      if (settings.pad === false) {
	        value = table[0][index]
	        spacing = calculateStringLength(stringify(value))
	        spacing = spacing > MIN_CELL_SIZE ? spacing : MIN_CELL_SIZE
	      } else {
	        spacing = sizes[index]
	      }
	
	      align = alignment[index]
	
	      /* When `align` is left, don't add colons. */
	      value = align === RIGHT || align === NULL ? DASH : COLON
	      value += pad(spacing - 2, DASH)
	      value += align !== LEFT && align !== NULL ? COLON : DASH
	
	      rule[index] = value
	    }
	
	    rows.splice(1, 0, rule.join(delimiter))
	  }
	
	  return start + rows.join(end + NEW_LINE + start) + end
	}
	
	function stringify(value) {
	  return value === null || value === undefined ? '' : String(value)
	}
	
	/* Get the length of `value`. */
	function lengthNoop(value) {
	  return String(value).length
	}
	
	/* Get a string consisting of `length` `character`s. */
	function pad(length, character) {
	  return new Array(length + 1).join(character || SPACE)
	}
	
	/* Get the position of the last dot in `value`. */
	function dotindex(value) {
	  var match = EXPRESSION_LAST_DOT.exec(value)
	
	  return match ? match.index + 1 : value.length
	}


/***/ }),
/* 311 */
/***/ (function(module, exports) {

	'use strict';
	
	/* Expose. */
	module.exports = marker;
	
	/* HTML type. */
	var T_HTML = 'html';
	
	/* Expression for eliminating extra spaces */
	var SPACES = /\s+/g;
	
	/* Expression for parsing parameters. */
	var PARAMETERS = new RegExp(
	  '\\s+' +
	  '(' +
	    '[-a-z0-9_]+' +
	  ')' +
	  '(?:' +
	    '=' +
	    '(?:' +
	      '"' +
	      '(' +
	        '(?:' +
	          '\\\\[\\s\\S]' +
	          '|' +
	          '[^"]' +
	        ')+' +
	      ')' +
	      '"' +
	      '|' +
	      '\'' +
	      '(' +
	        '(?:' +
	          '\\\\[\\s\\S]' +
	          '|' +
	          '[^\']' +
	        ')+' +
	      ')' +
	      '\'' +
	      '|' +
	      '(' +
	        '(?:' +
	          '\\\\[\\s\\S]' +
	          '|' +
	          '[^"\'\\s]' +
	        ')+' +
	      ')' +
	    ')' +
	  ')?',
	  'gi'
	);
	
	var MARKER = new RegExp(
	  '(' +
	    '\\s*' +
	    '<!--' +
	    '\\s*' +
	    '([a-zA-Z0-9-]+)' +
	    '(\\s+([\\s\\S]*?))?' +
	    '\\s*' +
	    '-->' +
	    '\\s*' +
	  ')'
	);
	
	/* Parse a comment marker */
	function marker(node) {
	  var value;
	  var match;
	  var params;
	
	  if (!node || node.type !== T_HTML) {
	    return null;
	  }
	
	  value = node.value;
	  match = value.match(MARKER);
	
	  if (!match || match[1].length !== value.length) {
	    return null;
	  }
	
	  params = parameters(match[3] || '');
	
	  if (!params) {
	    return null;
	  }
	
	  return {
	    name: match[2],
	    attributes: match[4] || '',
	    parameters: params,
	    node: node
	  };
	}
	
	/* eslint-disable max-params */
	
	/* Parse `value` into an object. */
	function parameters(value) {
	  var attributes = {};
	  var rest = value.replace(PARAMETERS, function ($0, $1, $2, $3, $4) {
	    var result = $2 || $3 || $4 || '';
	
	    if (result === 'true' || result === '') {
	      result = true;
	    } else if (result === 'false') {
	      result = false;
	    } else if (!isNaN(result)) {
	      result = Number(result);
	    }
	
	    attributes[$1] = result;
	
	    return '';
	  });
	
	  return rest.replace(SPACES, '') ? null : attributes;
	}


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/* Dependencies. */
	var visit = __webpack_require__(6);
	var modify = __webpack_require__(469);
	
	/* Expose. */
	module.exports = compact;
	
	/* Make an MDAST tree compact by merging adjacent text
	 * nodes. */
	function compact(tree, commonmark) {
	  var modifier = modify(iterator);
	
	  visit(tree, visitor);
	
	  return tree;
	
	  function visitor(node) {
	    if (node.children) {
	      modifier(node);
	    }
	  }
	
	  function iterator(child, index, parent) {
	    var siblings = parent.children;
	    var prev = index && siblings[index - 1];
	
	    if (
	      prev &&
	      child.type === prev.type &&
	      mergeable(prev, commonmark) &&
	      mergeable(child, commonmark)
	    ) {
	      if (child.value) {
	        prev.value += child.value;
	      }
	
	      if (child.children) {
	        prev.children = prev.children.concat(child.children);
	      }
	
	      siblings.splice(index, 1);
	
	      if (prev.position && child.position) {
	        prev.position.end = child.position.end;
	      }
	
	      return index;
	    }
	  }
	}
	
	function mergeable(node, commonmark) {
	  var start;
	  var end;
	
	  if (node.type === 'text') {
	    if (!node.position) {
	      return true;
	    }
	
	    start = node.position.start;
	    end = node.position.end;
	
	    /* Only merge nodes which occupy the same size as their `value`. */
	    return start.line !== end.line ||
	      end.column - start.column === node.value.length;
	  }
	
	  return commonmark && node.type === 'blockquote';
	}


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var visit = __webpack_require__(6);
	
	module.exports = getDefinitionFactory;
	
	var own = {}.hasOwnProperty;
	
	/* Get a definition in `node` by `identifier`. */
	function getDefinitionFactory(node, options) {
	  return getterFactory(gather(node, options));
	}
	
	/* Gather all definitions in `node` */
	function gather(node, options) {
	  var cache = {};
	
	  if (!node || !node.type) {
	    throw new Error('mdast-util-definitions expected node');
	  }
	
	  visit(node, 'definition', options && options.commonmark ? commonmark : normal);
	
	  return cache;
	
	  function commonmark(definition) {
	    var id = normalise(definition.identifier);
	    if (!own.call(cache, id)) {
	      cache[id] = definition;
	    }
	  }
	
	  function normal(definition) {
	    cache[normalise(definition.identifier)] = definition;
	  }
	}
	
	/* Factory to get a node from the given definition-cache. */
	function getterFactory(cache) {
	  return getter;
	
	  /* Get a node from the bound definition-cache. */
	  function getter(identifier) {
	    var id = identifier && normalise(identifier);
	    return id && own.call(cache, id) ? cache[id] : null;
	  }
	}
	
	function normalise(identifier) {
	  return identifier.toUpperCase();
	}


/***/ }),
/* 314 */
/***/ (function(module, exports) {

	'use strict';
	
	/* Expose. */
	module.exports = style;
	
	/* Check the style of a heading. */
	function style(node, relative) {
	  var last = node.children[node.children.length - 1];
	  var depth = node.depth;
	  var pos = node && node.position && node.position.end;
	  var final = last && last.position && last.position.end;
	
	  if (!pos) {
	    return null;
	  }
	
	  /* This can only occur for `'atx'` and `'atx-closed'`
	   * headings.  This might incorrectly match `'atx'`
	   * headings with lots of trailing white space as an
	   * `'atx-closed'` heading. */
	  if (!last) {
	    if (pos.column - 1 <= depth * 2) {
	      return consolidate(depth, relative);
	    }
	
	    return 'atx-closed';
	  }
	
	  if (final.line + 1 === pos.line) {
	    return 'setext';
	  }
	
	  if (final.column + depth < pos.column) {
	    return 'atx-closed';
	  }
	
	  return consolidate(depth, relative);
	}
	
	/* Get the probable style of an atx-heading, depending on
	 * preferred style. */
	function consolidate(depth, relative) {
	  return depth < 3 ? 'atx' : relative === 'atx' || relative === 'setext' ? relative : null;
	}


/***/ }),
/* 315 */,
/* 316 */
/***/ (function(module, exports) {

	'use strict';
	
	/* Expose. */
	module.exports = getPropertyInformation;
	
	/* Constants. */
	var USE_ATTRIBUTE = 0x1;
	var USE_PROPERTY = 0x2;
	var BOOLEAN_VALUE = 0x8;
	var NUMERIC_VALUE = 0x10;
	var POSITIVE_NUMERIC_VALUE = 0x20 | 0x10;
	var OVERLOADED_BOOLEAN_VALUE = 0x40;
	var SPACE_SEPARATED = 0x80;
	var COMMA_SEPARATED = 0x100;
	
	/* Map of properties. Names are camel-cased properties. */
	var propertyConfig = {
	  /* Standard Properties. */
	  abbr: null,
	  accept: COMMA_SEPARATED,
	  acceptCharset: SPACE_SEPARATED,
	  accessKey: SPACE_SEPARATED,
	  action: null,
	  allowFullScreen: USE_ATTRIBUTE | BOOLEAN_VALUE,
	  allowTransparency: USE_ATTRIBUTE,
	  alt: null,
	  /* https://html.spec.whatwg.org/#attr-link-as */
	  as: null,
	  async: BOOLEAN_VALUE,
	  autoComplete: SPACE_SEPARATED,
	  autoFocus: BOOLEAN_VALUE,
	  autoPlay: BOOLEAN_VALUE,
	  capture: USE_ATTRIBUTE | BOOLEAN_VALUE,
	  cellPadding: null,
	  cellSpacing: null,
	  challenge: USE_ATTRIBUTE,
	  charSet: USE_ATTRIBUTE,
	  checked: USE_PROPERTY | BOOLEAN_VALUE,
	  cite: null,
	  /* To set className on SVG elements, it's necessary to
	   * use .setAttribute; this works on HTML elements too
	   * in all browsers except IE8. */
	  className: USE_ATTRIBUTE | SPACE_SEPARATED,
	  cols: USE_ATTRIBUTE | POSITIVE_NUMERIC_VALUE,
	  colSpan: null,
	  command: null,
	  content: null,
	  contentEditable: null,
	  contextMenu: USE_ATTRIBUTE,
	  controls: USE_PROPERTY | BOOLEAN_VALUE,
	  /* https://github.com/WICG/controls-list/blob/gh-pages/explainer.md */
	  controlsList: SPACE_SEPARATED,
	  coords: NUMERIC_VALUE | COMMA_SEPARATED,
	  crossOrigin: null,
	  /* For `<object />` acts as `src`. */
	  data: null,
	  dateTime: USE_ATTRIBUTE,
	  default: BOOLEAN_VALUE,
	  defer: BOOLEAN_VALUE,
	  dir: null,
	  dirName: null,
	  disabled: USE_ATTRIBUTE | BOOLEAN_VALUE,
	  download: OVERLOADED_BOOLEAN_VALUE,
	  draggable: null,
	  dropzone: SPACE_SEPARATED,
	  encType: null,
	  form: USE_ATTRIBUTE,
	  formAction: USE_ATTRIBUTE,
	  formEncType: USE_ATTRIBUTE,
	  formMethod: USE_ATTRIBUTE,
	  formNoValidate: BOOLEAN_VALUE,
	  formTarget: USE_ATTRIBUTE,
	  frameBorder: USE_ATTRIBUTE,
	  headers: SPACE_SEPARATED,
	  height: USE_ATTRIBUTE | POSITIVE_NUMERIC_VALUE,
	  hidden: USE_ATTRIBUTE | BOOLEAN_VALUE,
	  high: NUMERIC_VALUE,
	  href: null,
	  hrefLang: null,
	  htmlFor: SPACE_SEPARATED,
	  httpEquiv: SPACE_SEPARATED,
	  id: USE_PROPERTY,
	  inputMode: USE_ATTRIBUTE,
	  /* Web Components */
	  is: USE_ATTRIBUTE,
	  isMap: BOOLEAN_VALUE,
	  keyParams: USE_ATTRIBUTE,
	  keyType: USE_ATTRIBUTE,
	  kind: null,
	  label: null,
	  lang: null,
	  list: USE_ATTRIBUTE,
	  loop: USE_PROPERTY | BOOLEAN_VALUE,
	  low: NUMERIC_VALUE,
	  manifest: USE_ATTRIBUTE,
	  marginHeight: NUMERIC_VALUE,
	  marginWidth: NUMERIC_VALUE,
	  max: null,
	  maxLength: USE_ATTRIBUTE | POSITIVE_NUMERIC_VALUE,
	  media: USE_ATTRIBUTE,
	  mediaGroup: null,
	  menu: null,
	  method: null,
	  min: null,
	  minLength: USE_ATTRIBUTE | POSITIVE_NUMERIC_VALUE,
	  multiple: USE_PROPERTY | BOOLEAN_VALUE,
	  muted: USE_PROPERTY | BOOLEAN_VALUE,
	  name: null,
	  nonce: null,
	  noValidate: BOOLEAN_VALUE,
	  open: BOOLEAN_VALUE,
	  optimum: NUMERIC_VALUE,
	  pattern: null,
	  ping: SPACE_SEPARATED,
	  placeholder: null,
	  /* https://html.spec.whatwg.org/#attr-video-playsinline */
	  playsInline: BOOLEAN_VALUE,
	  poster: null,
	  preload: null,
	  /* https://html.spec.whatwg.org/#dom-head-profile */
	  profile: null,
	  radioGroup: null,
	  readOnly: USE_PROPERTY | BOOLEAN_VALUE,
	  /* https://html.spec.whatwg.org/#attr-link-referrerpolicy */
	  referrerPolicy: null,
	  /* `rel` is `relList` in DOM */
	  rel: SPACE_SEPARATED | USE_ATTRIBUTE,
	  required: BOOLEAN_VALUE,
	  reversed: BOOLEAN_VALUE,
	  role: USE_ATTRIBUTE,
	  rows: USE_ATTRIBUTE | POSITIVE_NUMERIC_VALUE,
	  rowSpan: POSITIVE_NUMERIC_VALUE,
	  sandbox: SPACE_SEPARATED,
	  scope: null,
	  scoped: BOOLEAN_VALUE,
	  scrolling: null,
	  seamless: USE_ATTRIBUTE | BOOLEAN_VALUE,
	  selected: USE_PROPERTY | BOOLEAN_VALUE,
	  shape: null,
	  size: USE_ATTRIBUTE | POSITIVE_NUMERIC_VALUE,
	  sizes: USE_ATTRIBUTE | SPACE_SEPARATED,
	  /* https://html.spec.whatwg.org/#attr-slot */
	  slot: null,
	  sortable: BOOLEAN_VALUE,
	  sorted: SPACE_SEPARATED,
	  span: POSITIVE_NUMERIC_VALUE,
	  spellCheck: null,
	  src: null,
	  srcDoc: USE_PROPERTY,
	  srcLang: null,
	  srcSet: USE_ATTRIBUTE | COMMA_SEPARATED,
	  start: NUMERIC_VALUE,
	  step: null,
	  style: null,
	  summary: null,
	  tabIndex: NUMERIC_VALUE,
	  target: null,
	  title: null,
	  translate: null,
	  type: null,
	  typeMustMatch: BOOLEAN_VALUE,
	  useMap: null,
	  value: USE_PROPERTY,
	  volume: POSITIVE_NUMERIC_VALUE,
	  width: USE_ATTRIBUTE | NUMERIC_VALUE,
	  wmode: USE_ATTRIBUTE,
	  wrap: null,
	
	  /* Non-standard Properties. */
	
	  /* `autoCapitalize` and `autoCorrect` are supported in
	   * Mobile Safari for keyboard hints. */
	  autoCapitalize: null,
	  autoCorrect: null,
	  /* `autoSave` allows WebKit/Blink to persist values of
	   * input fields on page reloads */
	  autoSave: null,
	  /* `itemProp`, `itemScope`, `itemType` are for Microdata
	   * support. See http://schema.org/docs/gs.html */
	  itemProp: USE_ATTRIBUTE | SPACE_SEPARATED,
	  itemScope: USE_ATTRIBUTE | BOOLEAN_VALUE,
	  itemType: USE_ATTRIBUTE | SPACE_SEPARATED,
	  /* `itemID` and `itemRef` are for Microdata support as well
	   * but only specified in the the WHATWG spec document.
	   * See https://html.spec.whatwg.org/multipage/
	   * microdata.html#microdata-dom-api */
	  itemID: USE_ATTRIBUTE,
	  itemRef: USE_ATTRIBUTE | SPACE_SEPARATED,
	  /* `property` is supported for OpenGraph in meta tags. */
	  property: null,
	  /* `results` show looking glass icon and recent searches
	   * on input search fields in WebKit/Blink */
	  results: null,
	  /* IE-only attribute that specifies security
	   * restrictions on an iframe as an alternative to the
	   * sandbox attribute on IE < 10 */
	  security: USE_ATTRIBUTE,
	  /* IE-only attribute that controls focus behavior */
	  unselectable: USE_ATTRIBUTE,
	
	  /* Ancient. */
	  xmlLang: USE_ATTRIBUTE,
	  xmlBase: USE_ATTRIBUTE
	};
	
	/* Map of properties to attributes.
	 * Names are lower-case properties.
	 * Values are HTML attributes. */
	var propertyToAttributeMapping = {
	  xmlbase: 'xml:base',
	  xmllang: 'xml:lang',
	  classname: 'class',
	  htmlfor: 'for',
	  httpequiv: 'http-equiv',
	  acceptcharset: 'accept-charset'
	};
	
	/* Expand config. */
	var information = {};
	var property;
	var name;
	var config;
	
	getPropertyInformation.all = information;
	
	for (property in propertyConfig) {
	  name = lower(property);
	  name = propertyToAttributeMapping[name] || name;
	  config = propertyConfig[property];
	
	  information[name] = {
	    name: name,
	    propertyName: property,
	    mustUseAttribute: check(config, USE_ATTRIBUTE),
	    mustUseProperty: check(config, USE_PROPERTY),
	    boolean: check(config, BOOLEAN_VALUE),
	    overloadedBoolean: check(config, OVERLOADED_BOOLEAN_VALUE),
	    numeric: check(config, NUMERIC_VALUE),
	    positiveNumeric: check(config, POSITIVE_NUMERIC_VALUE),
	    commaSeparated: check(config, COMMA_SEPARATED),
	    spaceSeparated: check(config, SPACE_SEPARATED)
	  };
	}
	
	/* Get a config for a property. */
	function getPropertyInformation(propertyName) {
	  var insensitive = lower(propertyName);
	
	  return information[propertyToAttributeMapping[insensitive] || insensitive];
	}
	
	/* Check a mask. */
	function check(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	/* Lower-case a string. */
	function lower(value) {
	  return value.toLowerCase();
	}


/***/ }),
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var xtend = __webpack_require__(12);
	var toHAST = __webpack_require__(342);
	var toHTML = __webpack_require__(282);
	var sanitize = __webpack_require__(280);
	
	module.exports = plugin;
	
	function plugin(options) {
	  var settings = options || {};
	  var clean = settings.sanitize;
	  var schema = clean && typeof clean === 'object' ? clean : null;
	  var handlers = settings.handlers || {};
	
	  this.Compiler = compiler;
	
	  function compiler(node, file) {
	    var root = node && node.type && node.type === 'root';
	    var hast = toHAST(node, {allowDangerousHTML: !clean, handlers: handlers});
	    var result;
	
	    if (file.extname) {
	      file.extname = '.html';
	    }
	
	    if (clean) {
	      hast = sanitize(hast, schema);
	    }
	
	    result = toHTML(hast, xtend(settings, {
	      allowDangerousHTML: !clean
	    }));
	
	    /* Add a final newline. */
	    if (root && result.charAt(result.length - 1) !== '\n') {
	      result += '\n';
	    }
	
	    return result;
	  }
	}


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	module.exports = __webpack_require__(364);


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = generateFootnotes;
	
	var thematicBreak = __webpack_require__(195);
	var list = __webpack_require__(194);
	var wrap = __webpack_require__(35);
	
	/* Transform all footnote definitions, if any. */
	function generateFootnotes(h) {
	  var footnotes = h.footnotes;
	  var length = footnotes.length;
	  var index = -1;
	  var listItems = [];
	  var def;
	
	  if (!length) {
	    return null;
	  }
	
	  while (++index < length) {
	    def = footnotes[index];
	
	    listItems[index] = {
	      type: 'listItem',
	      data: {hProperties: {id: 'fn-' + def.identifier}},
	      children: def.children.concat({
	        type: 'link',
	        url: '#fnref-' + def.identifier,
	        data: {hProperties: {className: ['footnote-backref']}},
	        children: [{
	          type: 'text',
	          value: '↩'
	        }]
	      }),
	      position: def.position
	    };
	  }
	
	  return h(null, 'div', {
	    className: ['footnotes']
	  }, wrap([
	    thematicBreak(h),
	    list(h, {
	      type: 'list',
	      ordered: true,
	      children: listItems
	    })
	  ], true));
	}


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = blockquote;
	
	var wrap = __webpack_require__(35);
	var all = __webpack_require__(13);
	
	/* Transform a block quote. */
	function blockquote(h, node) {
	  return h(node, 'blockquote', wrap(all(h, node), true));
	}


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = hardBreak;
	
	var u = __webpack_require__(17);
	
	/* Transform an inline break. */
	function hardBreak(h, node) {
	  return [h(node, 'br'), u('text', '\n')];
	}


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = code;
	
	var detab = __webpack_require__(277);
	var u = __webpack_require__(17);
	
	/* Transform a code block. */
	function code(h, node) {
	  var value = node.value ? detab(node.value + '\n') : '';
	  var lang = node.lang && node.lang.match(/^[^ \t]+(?=[ \t]|$)/);
	  var props = {};
	
	  if (lang) {
	    props.className = ['language-' + lang];
	  }
	
	  return h(node.position, 'pre', [
	    h(node, 'code', props, [u('text', value)])
	  ]);
	}


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = strikethrough;
	
	var all = __webpack_require__(13);
	
	/* Transform deletions. */
	function strikethrough(h, node) {
	  return h(node, 'del', all(h, node));
	}


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = emphasis;
	
	var all = __webpack_require__(13);
	
	/* Transform emphasis. */
	function emphasis(h, node) {
	  return h(node, 'em', all(h, node));
	}


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = footnote;
	
	var footnoteReference = __webpack_require__(193);
	
	/* Transform an inline footnote. */
	function footnote(h, node) {
	  var identifiers = [];
	  var identifier = 1;
	  var footnotes = h.footnotes;
	  var length = footnotes.length;
	  var index = -1;
	
	  while (++index < length) {
	    identifiers[index] = footnotes[index].identifier;
	  }
	
	  while (identifiers.indexOf(String(identifier)) !== -1) {
	    identifier++;
	  }
	
	  identifier = String(identifier);
	
	  footnotes.push({
	    type: 'footnoteDefinition',
	    identifier: identifier,
	    children: [{
	      type: 'paragraph',
	      children: node.children
	    }],
	    position: node.position
	  });
	
	  return footnoteReference(h, {
	    type: 'footnoteReference',
	    identifier: identifier,
	    position: node.position
	  });
	}


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = heading;
	
	var all = __webpack_require__(13);
	
	/* Transform a heading. */
	function heading(h, node) {
	  return h(node, 'h' + node.depth, all(h, node));
	}


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = html;
	
	var u = __webpack_require__(17);
	
	/* Return either a `raw` node, in dangerous mode, or
	 * nothing. */
	function html(h, node) {
	  return h.dangerous ? h.augment(node, u('raw', node.value)) : null;
	}


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = imageReference;
	
	var normalize = __webpack_require__(54);
	var failsafe = __webpack_require__(192);
	
	/* Transform a reference to an image. */
	function imageReference(h, node) {
	  var def = h.definition(node.identifier);
	  var props = {src: normalize((def && def.url) || ''), alt: node.alt};
	
	  if (def && def.title !== null && def.title !== undefined) {
	    props.title = def.title;
	  }
	
	  return failsafe(h, node, def) || h(node, 'img', props);
	}


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var normalize = __webpack_require__(54);
	
	module.exports = image;
	
	/* Transform an image. */
	function image(h, node) {
	  var props = {src: normalize(node.url), alt: node.alt};
	
	  if (node.title !== null && node.title !== undefined) {
	    props.title = node.title;
	  }
	
	  return h(node, 'img', props);
	}


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = {
	  blockquote: __webpack_require__(344),
	  break: __webpack_require__(345),
	  code: __webpack_require__(346),
	  delete: __webpack_require__(347),
	  emphasis: __webpack_require__(348),
	  footnoteReference: __webpack_require__(193),
	  footnote: __webpack_require__(349),
	  heading: __webpack_require__(350),
	  html: __webpack_require__(351),
	  imageReference: __webpack_require__(352),
	  image: __webpack_require__(353),
	  inlineCode: __webpack_require__(355),
	  linkReference: __webpack_require__(356),
	  link: __webpack_require__(357),
	  listItem: __webpack_require__(358),
	  list: __webpack_require__(194),
	  paragraph: __webpack_require__(359),
	  root: __webpack_require__(360),
	  strong: __webpack_require__(361),
	  table: __webpack_require__(362),
	  text: __webpack_require__(363),
	  thematicBreak: __webpack_require__(195),
	  toml: ignore,
	  yaml: ignore,
	  definition: ignore,
	  footnoteDefinition: ignore
	};
	
	/* Return nothing for nodes which are ignored. */
	function ignore() {
	  return null;
	}


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = inlineCode;
	
	var collapse = __webpack_require__(110);
	var u = __webpack_require__(17);
	
	/* Transform inline code. */
	function inlineCode(h, node) {
	  return h(node, 'code', [u('text', collapse(node.value))]);
	}


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = linkReference;
	
	var normalize = __webpack_require__(54);
	var failsafe = __webpack_require__(192);
	var all = __webpack_require__(13);
	
	/* Transform a reference to a link. */
	function linkReference(h, node) {
	  var def = h.definition(node.identifier);
	  var props = {href: normalize((def && def.url) || '')};
	
	  if (def && def.title !== null && def.title !== undefined) {
	    props.title = def.title;
	  }
	
	  return failsafe(h, node, def) || h(node, 'a', props, all(h, node));
	}


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var normalize = __webpack_require__(54);
	var all = __webpack_require__(13);
	
	module.exports = link;
	
	/* Transform a link. */
	function link(h, node) {
	  var props = {href: normalize(node.url)};
	
	  if (node.title !== null && node.title !== undefined) {
	    props.title = node.title;
	  }
	
	  return h(node, 'a', props, all(h, node));
	}


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = listItem;
	
	var u = __webpack_require__(17);
	var wrap = __webpack_require__(35);
	var all = __webpack_require__(13);
	
	/* Transform a list-item. */
	function listItem(h, node, parent) {
	  var children = node.children;
	  var head = children[0];
	  var props = {};
	  var single = false;
	  var result;
	  var container;
	
	  if ((!parent || !parent.loose) && children.length === 1 && head.type === 'paragraph') {
	    single = true;
	  }
	
	  result = all(h, single ? head : node);
	
	  if (typeof node.checked === 'boolean') {
	    if (!single && (!head || head.type !== 'paragraph')) {
	      result.unshift(h(null, 'p', []));
	    }
	
	    container = single ? result : result[0].children;
	
	    if (container.length !== 0) {
	      container.unshift(u('text', ' '));
	    }
	
	    container.unshift(h(null, 'input', {
	      type: 'checkbox',
	      checked: node.checked,
	      disabled: true
	    }));
	
	    /* According to github-markdown-css, this class hides bullet. */
	    props.className = ['task-list-item'];
	  }
	
	  if (!single && result.length !== 0) {
	    result = wrap(result, true);
	  }
	
	  return h(node, 'li', props, result);
	}


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = paragraph;
	
	var all = __webpack_require__(13);
	
	/* Transform a paragraph. */
	function paragraph(h, node) {
	  return h(node, 'p', all(h, node));
	}


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = root;
	
	var u = __webpack_require__(17);
	var wrap = __webpack_require__(35);
	var all = __webpack_require__(13);
	
	/* Transform a `root`. */
	function root(h, node) {
	  return h.augment(node, u('root', wrap(all(h, node))));
	}


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = strong;
	
	var all = __webpack_require__(13);
	
	/* Transform importance. */
	function strong(h, node) {
	  return h(node, 'strong', all(h, node));
	}


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = table;
	
	var position = __webpack_require__(19);
	var wrap = __webpack_require__(35);
	var all = __webpack_require__(13);
	
	/* Transform a table. */
	function table(h, node) {
	  var rows = node.children;
	  var index = rows.length;
	  var align = node.align;
	  var alignLength = align.length;
	  var result = [];
	  var pos;
	  var row;
	  var out;
	  var name;
	  var cell;
	
	  while (index--) {
	    row = rows[index].children;
	    name = index === 0 ? 'th' : 'td';
	    pos = alignLength;
	    out = [];
	
	    while (pos--) {
	      cell = row[pos];
	      out[pos] = h(cell, name, {
	        align: align[pos]
	      }, cell ? wrap(all(h, cell)) : []);
	    }
	
	    result[index] = h(rows[index], 'tr', wrap(out, true));
	  }
	
	  return h(node, 'table', wrap([
	    h(result[0].position, 'thead', wrap([result[0]], true)),
	    h({
	      start: position.start(result[1]),
	      end: position.end(result[result.length - 1])
	    }, 'tbody', wrap(result.slice(1), true))
	  ], true));
	}


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = text;
	
	var u = __webpack_require__(17);
	var trimLines = __webpack_require__(465);
	
	/* Transform text. */
	function text(h, node) {
	  return h.augment(node, u('text', trimLines(node.value)));
	}


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = toHAST;
	
	var xtend = __webpack_require__(12);
	var u = __webpack_require__(17);
	var visit = __webpack_require__(6);
	var position = __webpack_require__(19);
	var generated = __webpack_require__(11);
	var definitions = __webpack_require__(313);
	var one = __webpack_require__(196);
	var footer = __webpack_require__(343);
	var handlers = __webpack_require__(354);
	
	/* Factory to transform. */
	function factory(tree, options) {
	  var settings = options || {};
	  var dangerous = settings.allowDangerousHTML;
	
	  h.dangerous = dangerous;
	  h.definition = definitions(tree, settings);
	  h.footnotes = [];
	  h.augment = augment;
	  h.handlers = xtend(handlers, (settings.handlers || {}));
	
	  visit(tree, 'footnoteDefinition', visitor);
	
	  return h;
	
	  /* Finalise the created `right`, a HAST node, from
	   * `left`, an MDAST node.   */
	  function augment(left, right) {
	    var data;
	    var ctx;
	
	    /* Handle `data.hName`, `data.hProperties, `hChildren`. */
	    if (left && 'data' in left) {
	      data = left.data;
	
	      if (right.type === 'element' && data.hName) {
	        right.tagName = data.hName;
	      }
	
	      if (right.type === 'element' && data.hProperties) {
	        right.properties = xtend(right.properties, data.hProperties);
	      }
	
	      if (right.children && data.hChildren) {
	        right.children = data.hChildren;
	      }
	    }
	
	    ctx = left && left.position ? left : {position: left};
	
	    if (!generated(ctx)) {
	      right.position = {
	        start: position.start(ctx),
	        end: position.end(ctx)
	      };
	    }
	
	    return right;
	  }
	
	  /* Create an element for a `node`. */
	  function h(node, tagName, props, children) {
	    if (
	      (children === undefined || children === null) &&
	      typeof props === 'object' &&
	      'length' in props
	    ) {
	      children = props;
	      props = {};
	    }
	
	    return augment(node, {
	      type: 'element',
	      tagName: tagName,
	      properties: props || {},
	      children: children || []
	    });
	  }
	
	  function visitor(definition) {
	    h.footnotes.push(definition);
	  }
	}
	
	/* Transform `tree`, which is an MDAST node, to a HAST node. */
	function toHAST(tree, options) {
	  var h = factory(tree, options);
	  var node = one(h, tree);
	  var footnotes = footer(h);
	
	  if (node && node.children && footnotes) {
	    node.children = node.children.concat(u('text', '\n'), footnotes);
	  }
	
	  return node;
	}


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module final-newline
	 * @fileoverview
	 *   Warn when a newline at the end of a file is missing. Empty files are allowed.
	 *
	 *   See [StackExchange](http://unix.stackexchange.com/questions/18743) for why.
	 *
	 *   ## Example
	 *
	 *   ##### `valid.md`
	 *
	 *   ###### In
	 *
	 *   Note: `␊` represents LF.
	 *
	 *   ```markdown
	 *   Alpha␊
	 *   ```
	 *
	 *   ###### Out
	 *
	 *   No messages.
	 *
	 *   ##### `invalid.md`
	 *
	 *   ###### In
	 *
	 *   Note: The below file does not have a final newline.
	 *
	 *   ```markdown
	 *   Bravo
	 *   ```
	 *
	 *   ###### Out
	 *
	 *   ```text
	 *   1:1: Missing newline character at end of file
	 *   ```
	 */
	
	'use strict';
	
	var rule = __webpack_require__(10);
	
	module.exports = rule('remark-lint:final-newline', finalNewline);
	
	function finalNewline(ast, file) {
	  var contents = file.toString();
	  var last = contents.length - 1;
	
	  if (last > -1 && contents.charAt(last) !== '\n') {
	    file.message('Missing newline character at end of file');
	  }
	}


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module hard-break-spaces
	 * @fileoverview
	 *   Warn when too many spaces are used to create a hard break.
	 *
	 * @example {"name": "valid.md"}
	 *
	 *   Lorem ipsum··
	 *   dolor sit amet
	 *
	 * @example {"name": "invalid.md", "label": "input"}
	 *
	 *   Lorem ipsum···
	 *   dolor sit amet.
	 *
	 * @example {"name": "invalid.md", "label": "output"}
	 *
	 *   1:12-2:1: Use two spaces for hard line breaks
	 */
	
	'use strict';
	
	var rule = __webpack_require__(10);
	var visit = __webpack_require__(6);
	var position = __webpack_require__(19);
	var generated = __webpack_require__(11);
	
	module.exports = rule('remark-lint:hard-break-spaces', hardBreakSpaces);
	
	function hardBreakSpaces(ast, file) {
	  var contents = file.toString();
	
	  visit(ast, 'break', visitor);
	
	  function visitor(node) {
	    var start = position.start(node).offset;
	    var end = position.end(node).offset;
	    var value;
	
	    if (generated(node)) {
	      return;
	    }
	
	    value = contents.slice(start, end).split('\n', 1)[0].replace(/\r$/, '');
	
	    if (value.length > 2) {
	      file.message('Use two spaces for hard line breaks', node);
	    }
	  }
	}


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module list-item-bullet-indent
	 * @fileoverview
	 *   Warn when list item bullets are indented.
	 *
	 * @example {"name": "valid.md"}
	 *
	 *   Paragraph.
	 *
	 *   * List item
	 *   * List item
	 *
	 * @example {"name": "invalid.md", "label": "input"}
	 *
	 *   Paragraph.
	 *
	 *   ·* List item
	 *   ·* List item
	 *
	 * @example {"name": "invalid.md", "label": "output"}
	 *
	 *   3:3: Incorrect indentation before bullet: remove 1 space
	 *   4:3: Incorrect indentation before bullet: remove 1 space
	 */
	
	'use strict';
	
	var rule = __webpack_require__(10);
	var plural = __webpack_require__(82);
	var visit = __webpack_require__(6);
	var position = __webpack_require__(19);
	var generated = __webpack_require__(11);
	
	module.exports = rule('remark-lint:list-item-bullet-indent', listItemBulletIndent);
	
	var start = position.start;
	
	function listItemBulletIndent(ast, file) {
	  var contents = file.toString();
	
	  visit(ast, 'list', visitor);
	
	  function visitor(node) {
	    var items = node.children;
	
	    items.forEach(visitItems);
	  }
	
	  function visitItems(item) {
	    var head = item.children[0];
	    var initial = start(item).offset;
	    var final = start(head).offset;
	    var indent;
	
	    if (generated(item)) {
	      return;
	    }
	
	    indent = contents.slice(initial, final).match(/^\s*/)[0].length;
	
	    if (indent !== 0) {
	      initial = start(head);
	
	      file.message('Incorrect indentation before bullet: remove ' + indent + ' ' + plural('space', indent), {
	        line: initial.line,
	        column: initial.column - indent
	      });
	    }
	  }
	}


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module list-item-indent
	 * @fileoverview
	 *   Warn when the spacing between a list item’s bullet and its content
	 *   violates a given style.
	 *
	 *   Options: `'tab-size'`, `'mixed'`, or `'space'`, default: `'tab-size'`.
	 *
	 * @example {"name": "valid.md"}
	 *
	 *   *···List
	 *   ····item.
	 *
	 *   Paragraph.
	 *
	 *   11.·List
	 *   ····item.
	 *
	 *   Paragraph.
	 *
	 *   *···List
	 *   ····item.
	 *
	 *   *···List
	 *   ····item.
	 *
	 * @example {"name": "valid.md", "setting": "mixed"}
	 *
	 *   *·List item.
	 *
	 *   Paragraph.
	 *
	 *   11.·List item
	 *
	 *   Paragraph.
	 *
	 *   *···List
	 *   ····item.
	 *
	 *   *···List
	 *   ····item.
	 *
	 * @example {"name": "valid.md", "setting": "space"}
	 *
	 *   *·List item.
	 *
	 *   Paragraph.
	 *
	 *   11.·List item
	 *
	 *   Paragraph.
	 *
	 *   *·List
	 *   ··item.
	 *
	 *   *·List
	 *   ··item.
	 *
	 * @example {"name": "invalid.md", "setting": "space", "label": "input"}
	 *
	 *   *···List
	 *   ····item.
	 *
	 * @example {"name": "invalid.md", "setting": "space", "label": "output"}
	 *
	 *    1:5: Incorrect list-item indent: remove 2 spaces
	 *
	 * @example {"name": "invalid.md", "setting": "tab-size", "label": "input"}
	 *
	 *   *·List
	 *   ··item.
	 *
	 * @example {"name": "invalid.md", "setting": "tab-size", "label": "output"}
	 *
	 *    1:3: Incorrect list-item indent: add 2 spaces
	 *
	 * @example {"name": "invalid.md", "setting": "mixed", "label": "input"}
	 *
	 *   *···List item.
	 *
	 * @example {"name": "invalid.md", "setting": "mixed", "label": "output"}
	 *
	 *    1:5: Incorrect list-item indent: remove 2 spaces
	 *
	 * @example {"name": "invalid.md", "setting": "invalid", "label": "output", "config": {"positionless": true}}
	 *
	 *    1:1: Invalid list-item indent style `invalid`: use either `'tab-size'`, `'space'`, or `'mixed'`
	 */
	
	'use strict';
	
	var rule = __webpack_require__(10);
	var plural = __webpack_require__(82);
	var visit = __webpack_require__(6);
	var position = __webpack_require__(19);
	var generated = __webpack_require__(11);
	
	module.exports = rule('remark-lint:list-item-indent', listItemIndent);
	
	var start = position.start;
	
	var STYLES = {
	  'tab-size': true,
	  mixed: true,
	  space: true
	};
	
	function listItemIndent(ast, file, preferred) {
	  var contents = file.toString();
	
	  preferred = typeof preferred === 'string' ? preferred : 'tab-size';
	
	  if (STYLES[preferred] !== true) {
	    file.fail('Invalid list-item indent style `' + preferred + '`: use either `\'tab-size\'`, `\'space\'`, or `\'mixed\'`');
	  }
	
	  visit(ast, 'list', visitor);
	
	  function visitor(node) {
	    var items = node.children;
	
	    if (generated(node)) {
	      return;
	    }
	
	    items.forEach(visitItem);
	
	    function visitItem(item) {
	      var head = item.children[0];
	      var initial = start(item).offset;
	      var final = start(head).offset;
	      var bulletSize;
	      var tab;
	      var marker;
	      var shouldBe;
	      var diff;
	      var word;
	
	      marker = contents.slice(initial, final);
	
	      /* Support checkboxes. */
	      marker = marker.replace(/\[[x ]?]\s*$/i, '');
	
	      bulletSize = marker.trimRight().length;
	      tab = Math.ceil(bulletSize / 4) * 4;
	
	      if (preferred === 'tab-size') {
	        shouldBe = tab;
	      } else if (preferred === 'space') {
	        shouldBe = bulletSize + 1;
	      } else {
	        shouldBe = node.loose ? tab : bulletSize + 1;
	      }
	
	      if (marker.length !== shouldBe) {
	        diff = shouldBe - marker.length;
	        word = diff > 0 ? 'add' : 'remove';
	
	        diff = Math.abs(diff);
	
	        file.message(
	          'Incorrect list-item indent: ' + word +
	          ' ' + diff + ' ' + plural('space', diff),
	          start(head)
	        );
	      }
	    }
	  }
	}


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module no-auto-link-without-protocol
	 * @fileoverview
	 *   Warn for angle-bracketed links without protocol.
	 *
	 * @example {"name": "valid.md"}
	 *
	 *   <http://www.example.com>
	 *   <mailto:foo@bar.com>
	 *
	 * @example {"name": "invalid.md", "label": "input"}
	 *
	 *   <www.example.com>
	 *   <foo@bar.com>
	 *
	 * @example {"name": "invalid.md", "label": "output"}
	 *
	 *   2:1-2:14: All automatic links must start with a protocol
	 */
	
	'use strict';
	
	var rule = __webpack_require__(10);
	var visit = __webpack_require__(6);
	var position = __webpack_require__(19);
	var generated = __webpack_require__(11);
	var toString = __webpack_require__(81);
	
	module.exports = rule('remark-lint:no-auto-link-without-protocol', noAutoLinkWithoutProtocol);
	
	var start = position.start;
	var end = position.end;
	
	/* Protocol expression. See:
	 * http://en.wikipedia.org/wiki/URI_scheme#Generic_syntax */
	var PROTOCOL = /^[a-z][a-z+.-]+:\/?/i;
	
	function noAutoLinkWithoutProtocol(ast, file) {
	  visit(ast, 'link', visitor);
	
	  function visitor(node) {
	    var head = start(node.children[0]).column;
	    var tail = end(node.children[node.children.length - 1]).column;
	    var initial = start(node).column;
	    var final = end(node).column;
	
	    if (generated(node)) {
	      return;
	    }
	
	    if (initial === head - 1 && final === tail + 1 && !PROTOCOL.test(toString(node))) {
	      file.message('All automatic links must start with a protocol', node);
	    }
	  }
	}


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module no-blockquote-without-marker
	 * @fileoverview
	 *   Warn when blank lines without markers (`>`) are found in a blockquote.
	 *
	 * @example {"name": "valid.md"}
	 *
	 *   > Foo...
	 *   >
	 *   > ...Bar.
	 *
	 * @example {"name": "invalid.md", "label": "input"}
	 *
	 *   > Foo...
	 *
	 *   > ...Bar.
	 *
	 * @example {"name": "invalid.md", "label": "output"}
	 *
	 *   2:1: Missing marker in blockquote
	 */
	
	'use strict';
	
	var rule = __webpack_require__(10);
	var vfileLocation = __webpack_require__(89);
	var visit = __webpack_require__(6);
	var position = __webpack_require__(19);
	var generated = __webpack_require__(11);
	
	module.exports = rule('remark-lint:no-blockquote-without-marker', noBlockquoteWithoutMarker);
	
	function noBlockquoteWithoutMarker(ast, file) {
	  var contents = file.toString();
	  var location = vfileLocation(file);
	  var last = contents.length;
	
	  visit(ast, 'blockquote', visitor);
	
	  function visitor(node) {
	    var start = position.start(node).line;
	    var indent = node.position && node.position.indent;
	
	    if (generated(node) || !indent || indent.length === 0) {
	      return;
	    }
	
	    indent.forEach(eachLine);
	
	    function eachLine(column, n) {
	      var character;
	      var line = start + n + 1;
	      var offset = location.toOffset({
	        line: line,
	        column: column
	      }) - 1;
	
	      while (++offset < last) {
	        character = contents.charAt(offset);
	
	        if (character === '>') {
	          return;
	        }
	
	        /* istanbul ignore else - just for safety */
	        if (character !== ' ' && character !== '\t') {
	          break;
	        }
	      }
	
	      file.message('Missing marker in blockquote', {
	        line: line,
	        column: column
	      });
	    }
	  }
	}


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module no-duplicate-definitions
	 * @fileoverview
	 *   Warn when duplicate definitions are found.
	 *
	 * @example {"name": "valid.md"}
	 *
	 *   [foo]: bar
	 *   [baz]: qux
	 *
	 * @example {"name": "invalid.md", "label": "input"}
	 *
	 *   [foo]: bar
	 *   [foo]: qux
	 *
	 * @example {"name": "invalid.md", "label": "output"}
	 *
	 *   2:1-2:11: Do not use definitions with the same identifier (1:1)
	 */
	
	'use strict';
	
	var rule = __webpack_require__(10);
	var position = __webpack_require__(19);
	var generated = __webpack_require__(11);
	var visit = __webpack_require__(6);
	
	module.exports = rule('remark-lint:no-duplicate-definitions', noDuplicateDefinitions);
	
	function noDuplicateDefinitions(ast, file) {
	  var map = {};
	
	  visit(ast, 'definition', validate);
	  visit(ast, 'footnoteDefinition', validate);
	
	  function validate(node) {
	    var duplicate = map[node.identifier];
	    var pos;
	
	    if (generated(node)) {
	      return;
	    }
	
	    if (duplicate && duplicate.type) {
	      pos = position.start(duplicate);
	
	      file.message(
	        'Do not use definitions with the same identifier (' +
	        pos.line + ':' + pos.column + ')',
	        node
	      );
	    }
	
	    map[node.identifier] = node;
	  }
	}


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module no-heading-content-indent
	 * @fileoverview
	 *   Warn when a heading’s content is indented.
	 *
	 * @example {"name": "valid.md"}
	 *
	 *   #·Foo
	 *
	 *   ## Bar·##
	 *
	 *     ##·Baz
	 *
	 *   Setext headings are not affected.
	 *
	 *   Baz
	 *   ===
	 *
	 * @example {"name": "invalid.md", "label": "input"}
	 *
	 *   #··Foo
	 *
	 *   ## Bar··##
	 *
	 *     ##··Baz
	 *
	 * @example {"name": "invalid.md", "label": "output"}
	 *
	 *   1:4: Remove 1 space before this heading’s content
	 *   3:7: Remove 1 space after this heading’s content
	 *   5:7: Remove 1 space before this heading’s content
	 *
	 * @example {"name": "empty-heading.md"}
	 *
	 *   #··
	 *
	 * @example {"name": "tight.md", "config":{"pedantic":true}, "label": "input"}
	 *
	 *   In pedantic mode, headings without spacing can also be detected:
	 *
	 *   ##No spacing left, too much right··##
	 *
	 * @example {"name": "tight.md", "label": "output"}
	 *
	 *   3:3: Add 1 space before this heading’s content
	 *   3:34: Remove 1 space after this heading’s content
	 */
	
	'use strict';
	
	var rule = __webpack_require__(10);
	var visit = __webpack_require__(6);
	var style = __webpack_require__(314);
	var plural = __webpack_require__(82);
	var position = __webpack_require__(19);
	var generated = __webpack_require__(11);
	
	module.exports = rule('remark-lint:no-heading-content-indent', noHeadingContentIndent);
	
	var start = position.start;
	var end = position.end;
	
	function noHeadingContentIndent(ast, file) {
	  var contents = file.toString();
	
	  visit(ast, 'heading', visitor);
	
	  function visitor(node) {
	    var depth = node.depth;
	    var children = node.children;
	    var type = style(node, 'atx');
	    var head;
	    var initial;
	    var final;
	    var diff;
	    var word;
	    var index;
	    var char;
	
	    if (generated(node)) {
	      return;
	    }
	
	    if (type === 'atx' || type === 'atx-closed') {
	      initial = start(node);
	      index = initial.offset;
	      char = contents.charAt(index);
	
	      while (char && char !== '#') {
	        index++;
	        char = contents.charAt(index);
	      }
	
	      /* istanbul ignore if - CR/LF bug: wooorm/remark#195. */
	      if (!char) {
	        return;
	      }
	
	      index = depth + (index - initial.offset);
	      head = start(children[0]).column;
	
	      /* Ignore empty headings. */
	      if (!head) {
	        return;
	      }
	
	      diff = head - initial.column - 1 - index;
	
	      if (diff) {
	        word = diff > 0 ? 'Remove' : 'Add';
	        diff = Math.abs(diff);
	
	        file.message(
	          word + ' ' + diff + ' ' + plural('space', diff) +
	          ' before this heading’s content',
	          start(children[0])
	        );
	      }
	    }
	
	    /* Closed ATX-heading always must have a space
	     * between their content and the final hashes,
	     * thus, there is no `add x spaces`. */
	    if (type === 'atx-closed') {
	      final = end(children[children.length - 1]);
	      diff = end(node).column - final.column - 1 - depth;
	
	      if (diff) {
	        file.message(
	          'Remove ' + diff + ' ' + plural('space', diff) +
	          ' after this heading’s content',
	          final
	        );
	      }
	    }
	  }
	}


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module no-inline-padding
	 * @fileoverview
	 *   Warn when inline nodes are padded with spaces between their markers and
	 *   content.
	 *
	 *   Warns for emphasis, strong, delete, images, and links.
	 *
	 * @example {"name": "valid.md"}
	 *
	 *   Alpha, *bravo*, _charlie_, [delta](http://echo.fox/trot)
	 *
	 * @example {"name": "invalid.md", "label": "input"}
	 *
	 *   Alpha, * bravo *, _ charlie _, [ delta ](http://echo.fox/trot)
	 *
	 * @example {"name": "invalid.md", "label": "output"}
	 *
	 *   1:8-1:17: Don’t pad `emphasis` with inner spaces
	 *   1:19-1:30: Don’t pad `emphasis` with inner spaces
	 *   1:32-1:63: Don’t pad `link` with inner spaces
	 */
	
	'use strict';
	
	var rule = __webpack_require__(10);
	var visit = __webpack_require__(6);
	var generated = __webpack_require__(11);
	var toString = __webpack_require__(81);
	
	module.exports = rule('remark-lint:no-inline-padding', noInlinePadding);
	
	function noInlinePadding(ast, file) {
	  visit(ast, visitor);
	
	  function visitor(node) {
	    var type = node.type;
	    var contents;
	
	    if (generated(node)) {
	      return;
	    }
	
	    if (
	      type === 'emphasis' ||
	      type === 'strong' ||
	      type === 'delete' ||
	      type === 'image' ||
	      type === 'link'
	    ) {
	      contents = toString(node);
	
	      if (contents.charAt(0) === ' ' || contents.charAt(contents.length - 1) === ' ') {
	        file.message('Don’t pad `' + type + '` with inner spaces', node);
	      }
	    }
	  }
	}


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module no-literal-urls
	 * @fileoverview
	 *   Warn when URLs without angle-brackets are used.
	 *
	 * @example {"name": "valid.md"}
	 *
	 *   <http://foo.bar/baz>
	 *
	 * @example {"name": "invalid.md", "label": "input"}
	 *
	 *   http://foo.bar/baz
	 *
	 * @example {"name": "invalid.md", "label": "output"}
	 *
	 *   1:1-1:19: Don’t use literal URLs without angle brackets
	 */
	
	'use strict';
	
	var rule = __webpack_require__(10);
	var visit = __webpack_require__(6);
	var position = __webpack_require__(19);
	var generated = __webpack_require__(11);
	var toString = __webpack_require__(81);
	
	module.exports = rule('remark-lint:no-literal-urls', noLiteralURLs);
	
	var start = position.start;
	var end = position.end;
	var MAILTO = 'mailto:';
	
	function noLiteralURLs(ast, file) {
	  visit(ast, 'link', visitor);
	
	  function visitor(node) {
	    var head = start(node.children[0]).column;
	    var tail = end(node.children[node.children.length - 1]).column;
	    var initial = start(node).column;
	    var final = end(node).column;
	    var value = toString(node);
	
	    if (generated(node)) {
	      return;
	    }
	
	    if (
	      initial === head &&
	      final === tail &&
	      (node.url === MAILTO + value || node.url === value)
	    ) {
	      file.message('Don’t use literal URLs without angle brackets', node);
	    }
	  }
	}


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module no-shortcut-reference-image
	 * @fileoverview
	 *   Warn when shortcut reference images are used.
	 *
	 *   Shortcut references render as images when a definition is found, and as
	 *   plain text without definition.  Sometimes, you don’t intend to create an
	 *   image from the reference, but this rule still warns anyway.  In that case,
	 *   you can escape the reference like so: `!\[foo]`.
	 *
	 * @example {"name": "valid.md"}
	 *
	 *   ![foo][]
	 *
	 *   [foo]: http://foo.bar/baz.png
	 *
	 * @example {"name": "invalid.md", "label": "input"}
	 *
	 *   ![foo]
	 *
	 *   [foo]: http://foo.bar/baz.png
	 *
	 * @example {"name": "invalid.md", "label": "output"}
	 *
	 *   1:1-1:7: Use the trailing [] on reference images
	 */
	
	'use strict';
	
	var rule = __webpack_require__(10);
	var visit = __webpack_require__(6);
	var generated = __webpack_require__(11);
	
	module.exports = rule('remark-lint:no-shortcut-reference-image', noShortcutReferenceImage);
	
	function noShortcutReferenceImage(ast, file) {
	  visit(ast, 'imageReference', visitor);
	
	  function visitor(node) {
	    if (generated(node)) {
	      return;
	    }
	
	    if (node.referenceType === 'shortcut') {
	      file.message('Use the trailing [] on reference images', node);
	    }
	  }
	}


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module no-shortcut-reference-link
	 * @fileoverview
	 *   Warn when shortcut reference links are used.
	 *
	 *   Shortcut references render as links when a definition is found, and as
	 *   plain text without definition.  Sometimes, you don’t intend to create a
	 *   link from the reference, but this rule still warns anyway.  In that case,
	 *   you can escape the reference like so: `\[foo]`.
	 *
	 * @example {"name": "valid.md"}
	 *
	 *   [foo][]
	 *
	 *   [foo]: http://foo.bar/baz
	 *
	 * @example {"name": "invalid.md", "label": "input"}
	 *
	 *   [foo]
	 *
	 *   [foo]: http://foo.bar/baz
	 *
	 * @example {"name": "invalid.md", "label": "output"}
	 *
	 *   1:1-1:6: Use the trailing [] on reference links
	 */
	
	'use strict';
	
	var rule = __webpack_require__(10);
	var visit = __webpack_require__(6);
	var generated = __webpack_require__(11);
	
	module.exports = rule('remark-lint:no-shortcut-reference-link', noShortcutReferenceLink);
	
	function noShortcutReferenceLink(ast, file) {
	  visit(ast, 'linkReference', visitor);
	
	  function visitor(node) {
	    if (generated(node)) {
	      return;
	    }
	
	    if (node.referenceType === 'shortcut') {
	      file.message('Use the trailing [] on reference links', node);
	    }
	  }
	}


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2016 Titus Wormer
	 * @license MIT
	 * @module no-undefined-references
	 * @fileoverview
	 *   Warn when references to undefined definitions are found.
	 *
	 * @example {"name": "valid.md"}
	 *
	 *   [foo][]
	 *
	 *   [foo]: https://example.com
	 *
	 * @example {"name": "invalid.md", "label": "input"}
	 *
	 *   [bar][]
	 *
	 * @example {"name": "invalid.md", "label": "output"}
	 *
	 *   1:1-1:8: Found reference to undefined definition
	 */
	
	'use strict';
	
	var rule = __webpack_require__(10);
	var generated = __webpack_require__(11);
	var visit = __webpack_require__(6);
	
	module.exports = rule('remark-lint:no-undefined-references', noUndefinedReferences);
	
	function noUndefinedReferences(ast, file) {
	  var map = {};
	
	  visit(ast, 'definition', mark);
	  visit(ast, 'footnoteDefinition', mark);
	
	  visit(ast, 'imageReference', find);
	  visit(ast, 'linkReference', find);
	  visit(ast, 'footnoteReference', find);
	
	  function mark(node) {
	    if (!generated(node)) {
	      map[node.identifier.toUpperCase()] = true;
	    }
	  }
	
	  function find(node) {
	    if (!generated(node) && !map[node.identifier.toUpperCase()]) {
	      file.message('Found reference to undefined definition', node);
	    }
	  }
	}


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2016 Titus Wormer
	 * @license MIT
	 * @module no-unused-definitions
	 * @fileoverview
	 *   Warn when unused definitions are found.
	 *
	 * @example {"name": "valid.md"}
	 *
	 *   [foo][]
	 *
	 *   [foo]: https://example.com
	 *
	 * @example {"name": "invalid.md", "label": "input"}
	 *
	 *   [bar]: https://example.com
	 *
	 * @example {"name": "invalid.md", "label": "output"}
	 *
	 *   1:1-1:27: Found unused definition
	 */
	
	'use strict';
	
	var rule = __webpack_require__(10);
	var generated = __webpack_require__(11);
	var visit = __webpack_require__(6);
	
	module.exports = rule('remark-lint:no-unused-definitions', noUnusedDefinitions);
	
	function noUnusedDefinitions(ast, file) {
	  var map = {};
	  var identifier;
	
	  visit(ast, 'definition', find);
	  visit(ast, 'footnoteDefinition', find);
	
	  visit(ast, 'imageReference', mark);
	  visit(ast, 'linkReference', mark);
	  visit(ast, 'footnoteReference', mark);
	
	  for (identifier in map) {
	    if (!map[identifier].used) {
	      file.message('Found unused definition', map[identifier].node);
	    }
	  }
	
	  function find(node) {
	    if (generated(node)) {
	      return;
	    }
	
	    map[node.identifier.toUpperCase()] = {
	      node: node,
	      used: false
	    };
	  }
	
	  function mark(node) {
	    var info = map[node.identifier.toUpperCase()];
	
	    if (generated(node) || !info) {
	      return;
	    }
	
	    info.used = true;
	  }
	}


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author Titus Wormer
	 * @copyright 2015 Titus Wormer
	 * @license MIT
	 * @module ordered-list-marker-style
	 * @fileoverview
	 *   Warn when the list-item marker style of ordered lists violate a given
	 *   style.
	 *
	 *   Options: `'consistent'`, `'.'`, or `')'`, default: `'consistent'`.
	 *
	 *   `'consistent'` detects the first used list style and warns when subsequent
	 *   lists use different styles.
	 *
	 *   Note: `)` is only supported in CommonMark.
	 *
	 * @example {"name": "valid.md"}
	 *
	 *   1.  Foo
	 *
	 *
	 *   1.  Bar
	 *
	 *   Unordered lists are not affected by this rule.
	 *
	 *   * Foo
	 *
	 * @example {"name": "valid.md", "setting": "."}
	 *
	 *   1.  Foo
	 *
	 *   2.  Bar
	 *
	 * @example {"name": "valid.md", "setting": ")", "config": {"commonmark": true}}
	 *
	 *   <!-- This requires commonmark. -->
	 *
	 *   1)  Foo
	 *
	 *   2)  Bar
	 *
	 * @example {"name": "invalid.md", "label": "input", "config": {"commonmark": true}}
	 *
	 *   1.  Foo
	 *
	 *   2)  Bar
	 *
	 * @example {"name": "invalid.md", "label": "output"}
	 *
	 *   3:1-3:8: Marker style should be `.`
	 *
	 * @example {"name": "invalid.md", "label": "output", "setting": "!", "config": {"positionless": true}}
	 *
	 *   1:1: Invalid ordered list-item marker style `!`: use either `'.'` or `')'`
	 */
	
	'use strict';
	
	var rule = __webpack_require__(10);
	var visit = __webpack_require__(6);
	var position = __webpack_require__(19);
	var generated = __webpack_require__(11);
	
	module.exports = rule('remark-lint:ordered-list-marker-style', orderedListMarkerStyle);
	
	var start = position.start;
	
	var STYLES = {
	  ')': true,
	  '.': true,
	  null: true
	};
	
	function orderedListMarkerStyle(ast, file, preferred) {
	  var contents = file.toString();
	
	  preferred = typeof preferred !== 'string' || preferred === 'consistent' ? null : preferred;
	
	  if (STYLES[preferred] !== true) {
	    file.fail('Invalid ordered list-item marker style `' + preferred + '`: use either `\'.\'` or `\')\'`');
	  }
	
	  visit(ast, 'list', visitor);
	
	  function visitor(node) {
	    var items = node.children;
	
	    if (!node.ordered) {
	      return;
	    }
	
	    items.forEach(each);
	
	    function each(item) {
	      var head = item.children[0];
	      var initial = start(item).offset;
	      var final = start(head).offset;
	      var marker;
	
	      if (generated(item)) {
	        return;
	      }
	
	      marker = contents.slice(initial, final).replace(/\s|\d/g, '');
	
	      /* Support checkboxes. */
	      marker = marker.replace(/\[[x ]?]\s*$/i, '');
	
	      if (!preferred) {
	        preferred = marker;
	      } else if (marker !== preferred) {
	        file.message('Marker style should be `' + preferred + '`', item);
	      }
	    }
	  }
	}


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var control = __webpack_require__(381);
	
	module.exports = lint;
	
	/* `remark-lint`.  This adds support for ignoring stuff from
	 * messages (`<!--lint ignore-->`).
	 * All rules are in their own packages and presets. */
	function lint() {
	  this.use(lintMessageControl);
	}
	
	function lintMessageControl() {
	  return control({name: 'lint', source: 'remark-lint'});
	}


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var control = __webpack_require__(467);
	var marker = __webpack_require__(311);
	var xtend = __webpack_require__(12);
	
	module.exports = messageControl;
	
	function messageControl(options) {
	  var settings = options || {};
	
	  return control(xtend(options, {
	    marker: settings.marker || marker,
	    test: settings.test || 'html'
	  }));
	}


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @fileoverview
	 *   remark preset to configure remark-lint with settings that
	 *   prevent mistakes or syntaxes that do not work correctly
	 *   across vendors.
	 */
	
	'use strict';
	
	module.exports.plugins = [
	  __webpack_require__(380),
	  /* Unix compatibility. */
	  __webpack_require__(365),
	  /* Rendering across vendors differs greatly
	   * if using other styles. */
	  __webpack_require__(367),
	  [__webpack_require__(368), 'tab-size'],
	  /* Differs or unsupported across vendors. */
	  __webpack_require__(369),
	  __webpack_require__(370),
	  __webpack_require__(374),
	  [__webpack_require__(379), '.'],
	  /* Mistakes. */
	  __webpack_require__(366),
	  __webpack_require__(371),
	  __webpack_require__(372),
	  __webpack_require__(373),
	  __webpack_require__(375),
	  __webpack_require__(376),
	  __webpack_require__(377),
	  __webpack_require__(378)
	];


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var unified = __webpack_require__(468);
	var parse = __webpack_require__(384);
	var stringify = __webpack_require__(424);
	
	module.exports = unified().use(parse).use(stringify).freeze();


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var unherit = __webpack_require__(208);
	var xtend = __webpack_require__(12);
	var Parser = __webpack_require__(394);
	
	module.exports = parse;
	parse.Parser = Parser;
	
	function parse(options) {
	  var Local = unherit(Parser);
	  Local.prototype.options = xtend(Local.prototype.options, this.data('settings'), options);
	  this.Parser = Local;
	}


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var xtend = __webpack_require__(12);
	var entities = __webpack_require__(55);
	
	module.exports = factory;
	
	/* Factory to create an entity decoder. */
	function factory(ctx) {
	  decoder.raw = decodeRaw;
	
	  return decoder;
	
	  /* Normalize `position` to add an `indent`. */
	  function normalize(position) {
	    var offsets = ctx.offset;
	    var line = position.line;
	    var result = [];
	
	    while (++line) {
	      if (!(line in offsets)) {
	        break;
	      }
	
	      result.push((offsets[line] || 0) + 1);
	    }
	
	    return {
	      start: position,
	      indent: result
	    };
	  }
	
	  /* Handle a warning.
	   * See https://github.com/wooorm/parse-entities
	   * for the warnings. */
	  function handleWarning(reason, position, code) {
	    if (code === 3) {
	      return;
	    }
	
	    ctx.file.message(reason, position);
	  }
	
	  /* Decode `value` (at `position`) into text-nodes. */
	  function decoder(value, position, handler) {
	    entities(value, {
	      position: normalize(position),
	      warning: handleWarning,
	      text: handler,
	      reference: handler,
	      textContext: ctx,
	      referenceContext: ctx
	    });
	  }
	
	  /* Decode `value` (at `position`) into a string. */
	  function decodeRaw(value, position, options) {
	    return entities(value, xtend(options, {
	      position: normalize(position),
	      warning: handleWarning
	    }));
	  }
	}


/***/ }),
/* 386 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = locate;
	
	function locate(value, fromIndex) {
	  var index = value.indexOf('\n', fromIndex);
	
	  while (index > fromIndex) {
	    if (value.charAt(index - 1) !== ' ') {
	      break;
	    }
	
	    index--;
	  }
	
	  return index;
	}


/***/ }),
/* 387 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = locate;
	
	function locate(value, fromIndex) {
	  return value.indexOf('`', fromIndex);
	}


/***/ }),
/* 388 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = locate;
	
	function locate(value, fromIndex) {
	  return value.indexOf('~~', fromIndex);
	}


/***/ }),
/* 389 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = locate;
	
	function locate(value, fromIndex) {
	  var asterisk = value.indexOf('*', fromIndex);
	  var underscore = value.indexOf('_', fromIndex);
	
	  if (underscore === -1) {
	    return asterisk;
	  }
	
	  if (asterisk === -1) {
	    return underscore;
	  }
	
	  return underscore < asterisk ? underscore : asterisk;
	}


/***/ }),
/* 390 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = locate;
	
	function locate(value, fromIndex) {
	  return value.indexOf('\\', fromIndex);
	}


/***/ }),
/* 391 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = locate;
	
	function locate(value, fromIndex) {
	  var asterisk = value.indexOf('**', fromIndex);
	  var underscore = value.indexOf('__', fromIndex);
	
	  if (underscore === -1) {
	    return asterisk;
	  }
	
	  if (asterisk === -1) {
	    return underscore;
	  }
	
	  return underscore < asterisk ? underscore : asterisk;
	}


/***/ }),
/* 392 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = locate;
	
	var PROTOCOLS = ['https://', 'http://', 'mailto:'];
	
	function locate(value, fromIndex) {
	  var length = PROTOCOLS.length;
	  var index = -1;
	  var min = -1;
	  var position;
	
	  if (!this.options.gfm) {
	    return -1;
	  }
	
	  while (++index < length) {
	    position = value.indexOf(PROTOCOLS[index], fromIndex);
	
	    if (position !== -1 && (position < min || min === -1)) {
	      min = position;
	    }
	  }
	
	  return min;
	}


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var xtend = __webpack_require__(12);
	var removePosition = __webpack_require__(470);
	
	module.exports = parse;
	
	var C_NEWLINE = '\n';
	var EXPRESSION_LINE_BREAKS = /\r\n|\r/g;
	
	/* Parse the bound file. */
	function parse() {
	  var self = this;
	  var value = String(self.file);
	  var start = {line: 1, column: 1, offset: 0};
	  var content = xtend(start);
	  var node;
	
	  /* Clean non-unix newlines: `\r\n` and `\r` are all
	   * changed to `\n`.  This should not affect positional
	   * information. */
	  value = value.replace(EXPRESSION_LINE_BREAKS, C_NEWLINE);
	
	  if (value.charCodeAt(0) === 0xFEFF) {
	    value = value.slice(1);
	
	    content.column++;
	    content.offset++;
	  }
	
	  node = {
	    type: 'root',
	    children: self.tokenizeBlock(value, content),
	    position: {
	      start: start,
	      end: self.eof || xtend(start)
	    }
	  };
	
	  if (!self.options.position) {
	    removePosition(node, true);
	  }
	
	  return node;
	}


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var xtend = __webpack_require__(12);
	var toggle = __webpack_require__(207);
	var vfileLocation = __webpack_require__(89);
	var unescape = __webpack_require__(422);
	var decode = __webpack_require__(385);
	var tokenizer = __webpack_require__(421);
	
	module.exports = Parser;
	
	function Parser(doc, file) {
	  this.file = file;
	  this.offset = {};
	  this.options = xtend(this.options);
	  this.setOptions({});
	
	  this.inList = false;
	  this.inBlock = false;
	  this.inLink = false;
	  this.atStart = true;
	
	  this.toOffset = vfileLocation(file).toOffset;
	  this.unescape = unescape(this, 'escape');
	  this.decode = decode(this);
	}
	
	var proto = Parser.prototype;
	
	/* Expose core. */
	proto.setOptions = __webpack_require__(395);
	proto.parse = __webpack_require__(393);
	
	/* Expose `defaults`. */
	proto.options = __webpack_require__(197);
	
	/* Enter and exit helpers. */
	proto.exitStart = toggle('atStart', true);
	proto.enterList = toggle('inList', false);
	proto.enterLink = toggle('inLink', false);
	proto.enterBlock = toggle('inBlock', false);
	
	/* Nodes that can interupt a paragraph:
	 *
	 * ```markdown
	 * A paragraph, followed by a thematic break.
	 * ___
	 * ```
	 *
	 * In the above example, the thematic break “interupts”
	 * the paragraph. */
	proto.interruptParagraph = [
	  ['thematicBreak'],
	  ['atxHeading'],
	  ['fencedCode'],
	  ['blockquote'],
	  ['html'],
	  ['setextHeading', {commonmark: false}],
	  ['definition', {commonmark: false}],
	  ['footnote', {commonmark: false}]
	];
	
	/* Nodes that can interupt a list:
	 *
	 * ```markdown
	 * - One
	 * ___
	 * ```
	 *
	 * In the above example, the thematic break “interupts”
	 * the list. */
	proto.interruptList = [
	  ['atxHeading', {pedantic: false}],
	  ['fencedCode', {pedantic: false}],
	  ['thematicBreak', {pedantic: false}],
	  ['definition', {commonmark: false}],
	  ['footnote', {commonmark: false}]
	];
	
	/* Nodes that can interupt a blockquote:
	 *
	 * ```markdown
	 * > A paragraph.
	 * ___
	 * ```
	 *
	 * In the above example, the thematic break “interupts”
	 * the blockquote. */
	proto.interruptBlockquote = [
	  ['indentedCode', {commonmark: true}],
	  ['fencedCode', {commonmark: true}],
	  ['atxHeading', {commonmark: true}],
	  ['setextHeading', {commonmark: true}],
	  ['thematicBreak', {commonmark: true}],
	  ['html', {commonmark: true}],
	  ['list', {commonmark: true}],
	  ['definition', {commonmark: false}],
	  ['footnote', {commonmark: false}]
	];
	
	/* Handlers. */
	proto.blockTokenizers = {
	  newline: __webpack_require__(413),
	  indentedCode: __webpack_require__(400),
	  fencedCode: __webpack_require__(399),
	  blockquote: __webpack_require__(397),
	  atxHeading: __webpack_require__(407),
	  thematicBreak: __webpack_require__(419),
	  list: __webpack_require__(412),
	  setextHeading: __webpack_require__(408),
	  html: __webpack_require__(409),
	  footnote: __webpack_require__(406),
	  definition: __webpack_require__(402),
	  table: __webpack_require__(417),
	  paragraph: __webpack_require__(414)
	};
	
	proto.inlineTokenizers = {
	  escape: __webpack_require__(405),
	  autoLink: __webpack_require__(396),
	  url: __webpack_require__(420),
	  html: __webpack_require__(410),
	  link: __webpack_require__(411),
	  reference: __webpack_require__(415),
	  strong: __webpack_require__(416),
	  emphasis: __webpack_require__(404),
	  deletion: __webpack_require__(403),
	  code: __webpack_require__(401),
	  break: __webpack_require__(398),
	  text: __webpack_require__(418)
	};
	
	/* Expose precedence. */
	proto.blockMethods = keys(proto.blockTokenizers);
	proto.inlineMethods = keys(proto.inlineTokenizers);
	
	/* Tokenizers. */
	proto.tokenizeBlock = tokenizer('block');
	proto.tokenizeInline = tokenizer('inline');
	proto.tokenizeFactory = tokenizer;
	
	/* Get all keys in `value`. */
	function keys(value) {
	  var result = [];
	  var key;
	
	  for (key in value) {
	    result.push(key);
	  }
	
	  return result;
	}


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var xtend = __webpack_require__(12);
	var escapes = __webpack_require__(131);
	var defaults = __webpack_require__(197);
	
	module.exports = setOptions;
	
	function setOptions(options) {
	  var self = this;
	  var current = self.options;
	  var key;
	  var value;
	
	  if (options == null) {
	    options = {};
	  } else if (typeof options === 'object') {
	    options = xtend(options);
	  } else {
	    throw new Error(
	      'Invalid value `' + options + '` ' +
	      'for setting `options`'
	    );
	  }
	
	  for (key in defaults) {
	    value = options[key];
	
	    if (value == null) {
	      value = current[key];
	    }
	
	    if (
	      (key !== 'blocks' && typeof value !== 'boolean') ||
	      (key === 'blocks' && typeof value !== 'object')
	    ) {
	      throw new Error('Invalid value `' + value + '` for setting `options.' + key + '`');
	    }
	
	    options[key] = value;
	  }
	
	  self.options = options;
	  self.escape = escapes(options);
	
	  return self;
	}


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var whitespace = __webpack_require__(14);
	var decode = __webpack_require__(55);
	var locate = __webpack_require__(199);
	
	module.exports = autoLink;
	autoLink.locator = locate;
	autoLink.notInLink = true;
	
	var C_LT = '<';
	var C_GT = '>';
	var C_AT_SIGN = '@';
	var C_SLASH = '/';
	var MAILTO = 'mailto:';
	var MAILTO_LENGTH = MAILTO.length;
	
	/* Tokenise a link. */
	function autoLink(eat, value, silent) {
	  var self;
	  var subvalue;
	  var length;
	  var index;
	  var queue;
	  var character;
	  var hasAtCharacter;
	  var link;
	  var now;
	  var content;
	  var tokenizers;
	  var exit;
	
	  if (value.charAt(0) !== C_LT) {
	    return;
	  }
	
	  self = this;
	  subvalue = '';
	  length = value.length;
	  index = 0;
	  queue = '';
	  hasAtCharacter = false;
	  link = '';
	
	  index++;
	  subvalue = C_LT;
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (
	      whitespace(character) ||
	      character === C_GT ||
	      character === C_AT_SIGN ||
	      (character === ':' && value.charAt(index + 1) === C_SLASH)
	    ) {
	      break;
	    }
	
	    queue += character;
	    index++;
	  }
	
	  if (!queue) {
	    return;
	  }
	
	  link += queue;
	  queue = '';
	
	  character = value.charAt(index);
	  link += character;
	  index++;
	
	  if (character === C_AT_SIGN) {
	    hasAtCharacter = true;
	  } else {
	    if (
	      character !== ':' ||
	      value.charAt(index + 1) !== C_SLASH
	    ) {
	      return;
	    }
	
	    link += C_SLASH;
	    index++;
	  }
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (whitespace(character) || character === C_GT) {
	      break;
	    }
	
	    queue += character;
	    index++;
	  }
	
	  character = value.charAt(index);
	
	  if (!queue || character !== C_GT) {
	    return;
	  }
	
	  /* istanbul ignore if - never used (yet) */
	  if (silent) {
	    return true;
	  }
	
	  link += queue;
	  content = link;
	  subvalue += link + character;
	  now = eat.now();
	  now.column++;
	  now.offset++;
	
	  if (hasAtCharacter) {
	    if (link.slice(0, MAILTO_LENGTH).toLowerCase() === MAILTO) {
	      content = content.substr(MAILTO_LENGTH);
	      now.column += MAILTO_LENGTH;
	      now.offset += MAILTO_LENGTH;
	    } else {
	      link = MAILTO + link;
	    }
	  }
	
	  /* Temporarily remove all tokenizers except text in autolinks. */
	  tokenizers = self.inlineTokenizers;
	  self.inlineTokenizers = {text: tokenizers.text};
	
	  exit = self.enterLink();
	
	  content = self.tokenizeInline(content, now);
	
	  self.inlineTokenizers = tokenizers;
	  exit();
	
	  return eat(subvalue)({
	    type: 'link',
	    title: null,
	    url: decode(link, {nonTerminated: false}),
	    children: content
	  });
	}


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var trim = __webpack_require__(22);
	var interrupt = __webpack_require__(83);
	
	module.exports = blockquote;
	
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	var C_SPACE = ' ';
	var C_GT = '>';
	
	/* Tokenise a blockquote. */
	function blockquote(eat, value, silent) {
	  var self = this;
	  var offsets = self.offset;
	  var tokenizers = self.blockTokenizers;
	  var interruptors = self.interruptBlockquote;
	  var now = eat.now();
	  var currentLine = now.line;
	  var length = value.length;
	  var values = [];
	  var contents = [];
	  var indents = [];
	  var add;
	  var index = 0;
	  var character;
	  var rest;
	  var nextIndex;
	  var content;
	  var line;
	  var startIndex;
	  var prefixed;
	  var exit;
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character !== C_SPACE && character !== C_TAB) {
	      break;
	    }
	
	    index++;
	  }
	
	  if (value.charAt(index) !== C_GT) {
	    return;
	  }
	
	  if (silent) {
	    return true;
	  }
	
	  index = 0;
	
	  while (index < length) {
	    nextIndex = value.indexOf(C_NEWLINE, index);
	    startIndex = index;
	    prefixed = false;
	
	    if (nextIndex === -1) {
	      nextIndex = length;
	    }
	
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (character !== C_SPACE && character !== C_TAB) {
	        break;
	      }
	
	      index++;
	    }
	
	    if (value.charAt(index) === C_GT) {
	      index++;
	      prefixed = true;
	
	      if (value.charAt(index) === C_SPACE) {
	        index++;
	      }
	    } else {
	      index = startIndex;
	    }
	
	    content = value.slice(index, nextIndex);
	
	    if (!prefixed && !trim(content)) {
	      index = startIndex;
	      break;
	    }
	
	    if (!prefixed) {
	      rest = value.slice(index);
	
	      /* Check if the following code contains a possible
	       * block. */
	      if (interrupt(interruptors, tokenizers, self, [eat, rest, true])) {
	        break;
	      }
	    }
	
	    line = startIndex === index ? content : value.slice(startIndex, nextIndex);
	
	    indents.push(index - startIndex);
	    values.push(line);
	    contents.push(content);
	
	    index = nextIndex + 1;
	  }
	
	  index = -1;
	  length = indents.length;
	  add = eat(values.join(C_NEWLINE));
	
	  while (++index < length) {
	    offsets[currentLine] = (offsets[currentLine] || 0) + indents[index];
	    currentLine++;
	  }
	
	  exit = self.enterBlock();
	  contents = self.tokenizeBlock(contents.join(C_NEWLINE), now);
	  exit();
	
	  return add({
	    type: 'blockquote',
	    children: contents
	  });
	}


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var locate = __webpack_require__(386);
	
	module.exports = hardBreak;
	hardBreak.locator = locate;
	
	var MIN_BREAK_LENGTH = 2;
	
	function hardBreak(eat, value, silent) {
	  var length = value.length;
	  var index = -1;
	  var queue = '';
	  var character;
	
	  while (++index < length) {
	    character = value.charAt(index);
	
	    if (character === '\n') {
	      if (index < MIN_BREAK_LENGTH) {
	        return;
	      }
	
	      /* istanbul ignore if - never used (yet) */
	      if (silent) {
	        return true;
	      }
	
	      queue += character;
	
	      return eat(queue)({type: 'break'});
	    }
	
	    if (character !== ' ') {
	      return;
	    }
	
	    queue += character;
	  }
	}


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var trim = __webpack_require__(88);
	
	module.exports = fencedCode;
	
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	var C_SPACE = ' ';
	var C_TILDE = '~';
	var C_TICK = '`';
	
	var MIN_FENCE_COUNT = 3;
	var CODE_INDENT_COUNT = 4;
	
	function fencedCode(eat, value, silent) {
	  var self = this;
	  var settings = self.options;
	  var length = value.length + 1;
	  var index = 0;
	  var subvalue = '';
	  var fenceCount;
	  var marker;
	  var character;
	  var flag;
	  var queue;
	  var content;
	  var exdentedContent;
	  var closing;
	  var exdentedClosing;
	  var indent;
	  var now;
	
	  if (!settings.gfm) {
	    return;
	  }
	
	  /* Eat initial spacing. */
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character !== C_SPACE && character !== C_TAB) {
	      break;
	    }
	
	    subvalue += character;
	    index++;
	  }
	
	  indent = index;
	
	  /* Eat the fence. */
	  character = value.charAt(index);
	
	  if (character !== C_TILDE && character !== C_TICK) {
	    return;
	  }
	
	  index++;
	  marker = character;
	  fenceCount = 1;
	  subvalue += character;
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character !== marker) {
	      break;
	    }
	
	    subvalue += character;
	    fenceCount++;
	    index++;
	  }
	
	  if (fenceCount < MIN_FENCE_COUNT) {
	    return;
	  }
	
	  /* Eat spacing before flag. */
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character !== C_SPACE && character !== C_TAB) {
	      break;
	    }
	
	    subvalue += character;
	    index++;
	  }
	
	  /* Eat flag. */
	  flag = '';
	  queue = '';
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (
	      character === C_NEWLINE ||
	      character === C_TILDE ||
	      character === C_TICK
	    ) {
	      break;
	    }
	
	    if (character === C_SPACE || character === C_TAB) {
	      queue += character;
	    } else {
	      flag += queue + character;
	      queue = '';
	    }
	
	    index++;
	  }
	
	  character = value.charAt(index);
	
	  if (character && character !== C_NEWLINE) {
	    return;
	  }
	
	  if (silent) {
	    return true;
	  }
	
	  now = eat.now();
	  now.column += subvalue.length;
	  now.offset += subvalue.length;
	
	  subvalue += flag;
	  flag = self.decode.raw(self.unescape(flag), now);
	
	  if (queue) {
	    subvalue += queue;
	  }
	
	  queue = '';
	  closing = '';
	  exdentedClosing = '';
	  content = '';
	  exdentedContent = '';
	
	  /* Eat content. */
	  while (index < length) {
	    character = value.charAt(index);
	    content += closing;
	    exdentedContent += exdentedClosing;
	    closing = '';
	    exdentedClosing = '';
	
	    if (character !== C_NEWLINE) {
	      content += character;
	      exdentedClosing += character;
	      index++;
	      continue;
	    }
	
	    /* Add the newline to `subvalue` if its the first
	     * character.  Otherwise, add it to the `closing`
	     * queue. */
	    if (content) {
	      closing += character;
	      exdentedClosing += character;
	    } else {
	      subvalue += character;
	    }
	
	    queue = '';
	    index++;
	
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (character !== C_SPACE) {
	        break;
	      }
	
	      queue += character;
	      index++;
	    }
	
	    closing += queue;
	    exdentedClosing += queue.slice(indent);
	
	    if (queue.length >= CODE_INDENT_COUNT) {
	      continue;
	    }
	
	    queue = '';
	
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (character !== marker) {
	        break;
	      }
	
	      queue += character;
	      index++;
	    }
	
	    closing += queue;
	    exdentedClosing += queue;
	
	    if (queue.length < fenceCount) {
	      continue;
	    }
	
	    queue = '';
	
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (character !== C_SPACE && character !== C_TAB) {
	        break;
	      }
	
	      closing += character;
	      exdentedClosing += character;
	      index++;
	    }
	
	    if (!character || character === C_NEWLINE) {
	      break;
	    }
	  }
	
	  subvalue += content + closing;
	
	  return eat(subvalue)({
	    type: 'code',
	    lang: flag || null,
	    value: trim(exdentedContent)
	  });
	}


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var repeat = __webpack_require__(16);
	var trim = __webpack_require__(88);
	
	module.exports = indentedCode;
	
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	var C_SPACE = ' ';
	
	var CODE_INDENT_COUNT = 4;
	var CODE_INDENT = repeat(C_SPACE, CODE_INDENT_COUNT);
	
	/* Tokenise indented code. */
	function indentedCode(eat, value, silent) {
	  var index = -1;
	  var length = value.length;
	  var subvalue = '';
	  var content = '';
	  var subvalueQueue = '';
	  var contentQueue = '';
	  var character;
	  var blankQueue;
	  var indent;
	
	  while (++index < length) {
	    character = value.charAt(index);
	
	    if (indent) {
	      indent = false;
	
	      subvalue += subvalueQueue;
	      content += contentQueue;
	      subvalueQueue = '';
	      contentQueue = '';
	
	      if (character === C_NEWLINE) {
	        subvalueQueue = character;
	        contentQueue = character;
	      } else {
	        subvalue += character;
	        content += character;
	
	        while (++index < length) {
	          character = value.charAt(index);
	
	          if (!character || character === C_NEWLINE) {
	            contentQueue = character;
	            subvalueQueue = character;
	            break;
	          }
	
	          subvalue += character;
	          content += character;
	        }
	      }
	    } else if (
	      character === C_SPACE &&
	      value.charAt(index + 1) === character &&
	      value.charAt(index + 2) === character &&
	      value.charAt(index + 3) === character
	    ) {
	      subvalueQueue += CODE_INDENT;
	      index += 3;
	      indent = true;
	    } else if (character === C_TAB) {
	      subvalueQueue += character;
	      indent = true;
	    } else {
	      blankQueue = '';
	
	      while (character === C_TAB || character === C_SPACE) {
	        blankQueue += character;
	        character = value.charAt(++index);
	      }
	
	      if (character !== C_NEWLINE) {
	        break;
	      }
	
	      subvalueQueue += blankQueue + character;
	      contentQueue += character;
	    }
	  }
	
	  if (content) {
	    if (silent) {
	      return true;
	    }
	
	    return eat(subvalue)({
	      type: 'code',
	      lang: null,
	      value: trim(content)
	    });
	  }
	}


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var whitespace = __webpack_require__(14);
	var locate = __webpack_require__(387);
	
	module.exports = inlineCode;
	inlineCode.locator = locate;
	
	var C_TICK = '`';
	
	/* Tokenise inline code. */
	function inlineCode(eat, value, silent) {
	  var length = value.length;
	  var index = 0;
	  var queue = '';
	  var tickQueue = '';
	  var contentQueue;
	  var subqueue;
	  var count;
	  var openingCount;
	  var subvalue;
	  var character;
	  var found;
	  var next;
	
	  while (index < length) {
	    if (value.charAt(index) !== C_TICK) {
	      break;
	    }
	
	    queue += C_TICK;
	    index++;
	  }
	
	  if (!queue) {
	    return;
	  }
	
	  subvalue = queue;
	  openingCount = index;
	  queue = '';
	  next = value.charAt(index);
	  count = 0;
	
	  while (index < length) {
	    character = next;
	    next = value.charAt(index + 1);
	
	    if (character === C_TICK) {
	      count++;
	      tickQueue += character;
	    } else {
	      count = 0;
	      queue += character;
	    }
	
	    if (count && next !== C_TICK) {
	      if (count === openingCount) {
	        subvalue += queue + tickQueue;
	        found = true;
	        break;
	      }
	
	      queue += tickQueue;
	      tickQueue = '';
	    }
	
	    index++;
	  }
	
	  if (!found) {
	    if (openingCount % 2 !== 0) {
	      return;
	    }
	
	    queue = '';
	  }
	
	  /* istanbul ignore if - never used (yet) */
	  if (silent) {
	    return true;
	  }
	
	  contentQueue = '';
	  subqueue = '';
	  length = queue.length;
	  index = -1;
	
	  while (++index < length) {
	    character = queue.charAt(index);
	
	    if (whitespace(character)) {
	      subqueue += character;
	      continue;
	    }
	
	    if (subqueue) {
	      if (contentQueue) {
	        contentQueue += subqueue;
	      }
	
	      subqueue = '';
	    }
	
	    contentQueue += character;
	  }
	
	  return eat(subvalue)({
	    type: 'inlineCode',
	    value: contentQueue
	  });
	}


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var whitespace = __webpack_require__(14);
	var normalize = __webpack_require__(84);
	
	module.exports = definition;
	definition.notInList = true;
	definition.notInBlock = true;
	
	var C_DOUBLE_QUOTE = '"';
	var C_SINGLE_QUOTE = '\'';
	var C_BACKSLASH = '\\';
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	var C_SPACE = ' ';
	var C_BRACKET_OPEN = '[';
	var C_BRACKET_CLOSE = ']';
	var C_PAREN_OPEN = '(';
	var C_PAREN_CLOSE = ')';
	var C_COLON = ':';
	var C_LT = '<';
	var C_GT = '>';
	
	function definition(eat, value, silent) {
	  var self = this;
	  var commonmark = self.options.commonmark;
	  var index = 0;
	  var length = value.length;
	  var subvalue = '';
	  var beforeURL;
	  var beforeTitle;
	  var queue;
	  var character;
	  var test;
	  var identifier;
	  var url;
	  var title;
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character !== C_SPACE && character !== C_TAB) {
	      break;
	    }
	
	    subvalue += character;
	    index++;
	  }
	
	  character = value.charAt(index);
	
	  if (character !== C_BRACKET_OPEN) {
	    return;
	  }
	
	  index++;
	  subvalue += character;
	  queue = '';
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character === C_BRACKET_CLOSE) {
	      break;
	    } else if (character === C_BACKSLASH) {
	      queue += character;
	      index++;
	      character = value.charAt(index);
	    }
	
	    queue += character;
	    index++;
	  }
	
	  if (
	    !queue ||
	    value.charAt(index) !== C_BRACKET_CLOSE ||
	    value.charAt(index + 1) !== C_COLON
	  ) {
	    return;
	  }
	
	  identifier = queue;
	  subvalue += queue + C_BRACKET_CLOSE + C_COLON;
	  index = subvalue.length;
	  queue = '';
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (
	      character !== C_TAB &&
	      character !== C_SPACE &&
	      character !== C_NEWLINE
	    ) {
	      break;
	    }
	
	    subvalue += character;
	    index++;
	  }
	
	  character = value.charAt(index);
	  queue = '';
	  beforeURL = subvalue;
	
	  if (character === C_LT) {
	    index++;
	
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (!isEnclosedURLCharacter(character)) {
	        break;
	      }
	
	      queue += character;
	      index++;
	    }
	
	    character = value.charAt(index);
	
	    if (character === isEnclosedURLCharacter.delimiter) {
	      subvalue += C_LT + queue + character;
	      index++;
	    } else {
	      if (commonmark) {
	        return;
	      }
	
	      index -= queue.length + 1;
	      queue = '';
	    }
	  }
	
	  if (!queue) {
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (!isUnclosedURLCharacter(character)) {
	        break;
	      }
	
	      queue += character;
	      index++;
	    }
	
	    subvalue += queue;
	  }
	
	  if (!queue) {
	    return;
	  }
	
	  url = queue;
	  queue = '';
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (
	      character !== C_TAB &&
	      character !== C_SPACE &&
	      character !== C_NEWLINE
	    ) {
	      break;
	    }
	
	    queue += character;
	    index++;
	  }
	
	  character = value.charAt(index);
	  test = null;
	
	  if (character === C_DOUBLE_QUOTE) {
	    test = C_DOUBLE_QUOTE;
	  } else if (character === C_SINGLE_QUOTE) {
	    test = C_SINGLE_QUOTE;
	  } else if (character === C_PAREN_OPEN) {
	    test = C_PAREN_CLOSE;
	  }
	
	  if (!test) {
	    queue = '';
	    index = subvalue.length;
	  } else if (queue) {
	    subvalue += queue + character;
	    index = subvalue.length;
	    queue = '';
	
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (character === test) {
	        break;
	      }
	
	      if (character === C_NEWLINE) {
	        index++;
	        character = value.charAt(index);
	
	        if (character === C_NEWLINE || character === test) {
	          return;
	        }
	
	        queue += C_NEWLINE;
	      }
	
	      queue += character;
	      index++;
	    }
	
	    character = value.charAt(index);
	
	    if (character !== test) {
	      return;
	    }
	
	    beforeTitle = subvalue;
	    subvalue += queue + character;
	    index++;
	    title = queue;
	    queue = '';
	  } else {
	    return;
	  }
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character !== C_TAB && character !== C_SPACE) {
	      break;
	    }
	
	    subvalue += character;
	    index++;
	  }
	
	  character = value.charAt(index);
	
	  if (!character || character === C_NEWLINE) {
	    if (silent) {
	      return true;
	    }
	
	    beforeURL = eat(beforeURL).test().end;
	    url = self.decode.raw(self.unescape(url), beforeURL, {nonTerminated: false});
	
	    if (title) {
	      beforeTitle = eat(beforeTitle).test().end;
	      title = self.decode.raw(self.unescape(title), beforeTitle);
	    }
	
	    return eat(subvalue)({
	      type: 'definition',
	      identifier: normalize(identifier),
	      title: title || null,
	      url: url
	    });
	  }
	}
	
	/* Check if `character` can be inside an enclosed URI. */
	function isEnclosedURLCharacter(character) {
	  return character !== C_GT &&
	    character !== C_BRACKET_OPEN &&
	    character !== C_BRACKET_CLOSE;
	}
	
	isEnclosedURLCharacter.delimiter = C_GT;
	
	/* Check if `character` can be inside an unclosed URI. */
	function isUnclosedURLCharacter(character) {
	  return character !== C_BRACKET_OPEN &&
	    character !== C_BRACKET_CLOSE &&
	    !whitespace(character);
	}


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var whitespace = __webpack_require__(14);
	var locate = __webpack_require__(388);
	
	module.exports = strikethrough;
	strikethrough.locator = locate;
	
	var C_TILDE = '~';
	var DOUBLE = '~~';
	
	function strikethrough(eat, value, silent) {
	  var self = this;
	  var character = '';
	  var previous = '';
	  var preceding = '';
	  var subvalue = '';
	  var index;
	  var length;
	  var now;
	
	  if (
	    !self.options.gfm ||
	    value.charAt(0) !== C_TILDE ||
	    value.charAt(1) !== C_TILDE ||
	    whitespace(value.charAt(2))
	  ) {
	    return;
	  }
	
	  index = 1;
	  length = value.length;
	  now = eat.now();
	  now.column += 2;
	  now.offset += 2;
	
	  while (++index < length) {
	    character = value.charAt(index);
	
	    if (
	      character === C_TILDE &&
	      previous === C_TILDE &&
	      (!preceding || !whitespace(preceding))
	    ) {
	      /* istanbul ignore if - never used (yet) */
	      if (silent) {
	        return true;
	      }
	
	      return eat(DOUBLE + subvalue + DOUBLE)({
	        type: 'delete',
	        children: self.tokenizeInline(subvalue, now)
	      });
	    }
	
	    subvalue += previous;
	    preceding = previous;
	    previous = character;
	  }
	}


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var trim = __webpack_require__(22);
	var word = __webpack_require__(299);
	var whitespace = __webpack_require__(14);
	var locate = __webpack_require__(389);
	
	module.exports = emphasis;
	emphasis.locator = locate;
	
	var C_ASTERISK = '*';
	var C_UNDERSCORE = '_';
	
	function emphasis(eat, value, silent) {
	  var self = this;
	  var index = 0;
	  var character = value.charAt(index);
	  var now;
	  var pedantic;
	  var marker;
	  var queue;
	  var subvalue;
	  var length;
	  var prev;
	
	  if (character !== C_ASTERISK && character !== C_UNDERSCORE) {
	    return;
	  }
	
	  pedantic = self.options.pedantic;
	  subvalue = character;
	  marker = character;
	  length = value.length;
	  index++;
	  queue = '';
	  character = '';
	
	  if (pedantic && whitespace(value.charAt(index))) {
	    return;
	  }
	
	  while (index < length) {
	    prev = character;
	    character = value.charAt(index);
	
	    if (character === marker && (!pedantic || !whitespace(prev))) {
	      character = value.charAt(++index);
	
	      if (character !== marker) {
	        if (!trim(queue) || prev === marker) {
	          return;
	        }
	
	        if (!pedantic && marker === C_UNDERSCORE && word(character)) {
	          queue += marker;
	          continue;
	        }
	
	        /* istanbul ignore if - never used (yet) */
	        if (silent) {
	          return true;
	        }
	
	        now = eat.now();
	        now.column++;
	        now.offset++;
	
	        return eat(subvalue + queue + marker)({
	          type: 'emphasis',
	          children: self.tokenizeInline(queue, now)
	        });
	      }
	
	      queue += marker;
	    }
	
	    if (!pedantic && character === '\\') {
	      queue += character;
	      character = value.charAt(++index);
	    }
	
	    queue += character;
	    index++;
	  }
	}


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var locate = __webpack_require__(390);
	
	module.exports = escape;
	escape.locator = locate;
	
	function escape(eat, value, silent) {
	  var self = this;
	  var character;
	  var node;
	
	  if (value.charAt(0) === '\\') {
	    character = value.charAt(1);
	
	    if (self.escape.indexOf(character) !== -1) {
	      /* istanbul ignore if - never used (yet) */
	      if (silent) {
	        return true;
	      }
	
	      if (character === '\n') {
	        node = {type: 'break'};
	      } else {
	        node = {
	          type: 'text',
	          value: character
	        };
	      }
	
	      return eat('\\' + character)(node);
	    }
	  }
	}


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var whitespace = __webpack_require__(14);
	var normalize = __webpack_require__(84);
	
	module.exports = footnoteDefinition;
	footnoteDefinition.notInList = true;
	footnoteDefinition.notInBlock = true;
	
	var C_BACKSLASH = '\\';
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	var C_SPACE = ' ';
	var C_BRACKET_OPEN = '[';
	var C_BRACKET_CLOSE = ']';
	var C_CARET = '^';
	var C_COLON = ':';
	
	var EXPRESSION_INITIAL_TAB = /^( {4}|\t)?/gm;
	
	function footnoteDefinition(eat, value, silent) {
	  var self = this;
	  var offsets = self.offset;
	  var index;
	  var length;
	  var subvalue;
	  var now;
	  var currentLine;
	  var content;
	  var queue;
	  var subqueue;
	  var character;
	  var identifier;
	  var add;
	  var exit;
	
	  if (!self.options.footnotes) {
	    return;
	  }
	
	  index = 0;
	  length = value.length;
	  subvalue = '';
	  now = eat.now();
	  currentLine = now.line;
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (!whitespace(character)) {
	      break;
	    }
	
	    subvalue += character;
	    index++;
	  }
	
	  if (
	    value.charAt(index) !== C_BRACKET_OPEN ||
	    value.charAt(index + 1) !== C_CARET
	  ) {
	    return;
	  }
	
	  subvalue += C_BRACKET_OPEN + C_CARET;
	  index = subvalue.length;
	  queue = '';
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character === C_BRACKET_CLOSE) {
	      break;
	    } else if (character === C_BACKSLASH) {
	      queue += character;
	      index++;
	      character = value.charAt(index);
	    }
	
	    queue += character;
	    index++;
	  }
	
	  if (
	    !queue ||
	    value.charAt(index) !== C_BRACKET_CLOSE ||
	    value.charAt(index + 1) !== C_COLON
	  ) {
	    return;
	  }
	
	  if (silent) {
	    return true;
	  }
	
	  identifier = normalize(queue);
	  subvalue += queue + C_BRACKET_CLOSE + C_COLON;
	  index = subvalue.length;
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character !== C_TAB && character !== C_SPACE) {
	      break;
	    }
	
	    subvalue += character;
	    index++;
	  }
	
	  now.column += subvalue.length;
	  now.offset += subvalue.length;
	  queue = '';
	  content = '';
	  subqueue = '';
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character === C_NEWLINE) {
	      subqueue = character;
	      index++;
	
	      while (index < length) {
	        character = value.charAt(index);
	
	        if (character !== C_NEWLINE) {
	          break;
	        }
	
	        subqueue += character;
	        index++;
	      }
	
	      queue += subqueue;
	      subqueue = '';
	
	      while (index < length) {
	        character = value.charAt(index);
	
	        if (character !== C_SPACE) {
	          break;
	        }
	
	        subqueue += character;
	        index++;
	      }
	
	      if (subqueue.length === 0) {
	        break;
	      }
	
	      queue += subqueue;
	    }
	
	    if (queue) {
	      content += queue;
	      queue = '';
	    }
	
	    content += character;
	    index++;
	  }
	
	  subvalue += content;
	
	  content = content.replace(EXPRESSION_INITIAL_TAB, function (line) {
	    offsets[currentLine] = (offsets[currentLine] || 0) + line.length;
	    currentLine++;
	
	    return '';
	  });
	
	  add = eat(subvalue);
	
	  exit = self.enterBlock();
	  content = self.tokenizeBlock(content, now);
	  exit();
	
	  return add({
	    type: 'footnoteDefinition',
	    identifier: identifier,
	    children: content
	  });
	}


/***/ }),
/* 407 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = atxHeading;
	
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	var C_SPACE = ' ';
	var C_HASH = '#';
	
	var MAX_ATX_COUNT = 6;
	
	function atxHeading(eat, value, silent) {
	  var self = this;
	  var settings = self.options;
	  var length = value.length + 1;
	  var index = -1;
	  var now = eat.now();
	  var subvalue = '';
	  var content = '';
	  var character;
	  var queue;
	  var depth;
	
	  /* Eat initial spacing. */
	  while (++index < length) {
	    character = value.charAt(index);
	
	    if (character !== C_SPACE && character !== C_TAB) {
	      index--;
	      break;
	    }
	
	    subvalue += character;
	  }
	
	  /* Eat hashes. */
	  depth = 0;
	
	  while (++index <= length) {
	    character = value.charAt(index);
	
	    if (character !== C_HASH) {
	      index--;
	      break;
	    }
	
	    subvalue += character;
	    depth++;
	  }
	
	  if (depth > MAX_ATX_COUNT) {
	    return;
	  }
	
	  if (
	    !depth ||
	    (!settings.pedantic && value.charAt(index + 1) === C_HASH)
	  ) {
	    return;
	  }
	
	  length = value.length + 1;
	
	  /* Eat intermediate white-space. */
	  queue = '';
	
	  while (++index < length) {
	    character = value.charAt(index);
	
	    if (character !== C_SPACE && character !== C_TAB) {
	      index--;
	      break;
	    }
	
	    queue += character;
	  }
	
	  /* Exit when not in pedantic mode without spacing. */
	  if (
	    !settings.pedantic &&
	    queue.length === 0 &&
	    character &&
	    character !== C_NEWLINE
	  ) {
	    return;
	  }
	
	  if (silent) {
	    return true;
	  }
	
	  /* Eat content. */
	  subvalue += queue;
	  queue = '';
	  content = '';
	
	  while (++index < length) {
	    character = value.charAt(index);
	
	    if (!character || character === C_NEWLINE) {
	      break;
	    }
	
	    if (
	      character !== C_SPACE &&
	      character !== C_TAB &&
	      character !== C_HASH
	    ) {
	      content += queue + character;
	      queue = '';
	      continue;
	    }
	
	    while (character === C_SPACE || character === C_TAB) {
	      queue += character;
	      character = value.charAt(++index);
	    }
	
	    while (character === C_HASH) {
	      queue += character;
	      character = value.charAt(++index);
	    }
	
	    while (character === C_SPACE || character === C_TAB) {
	      queue += character;
	      character = value.charAt(++index);
	    }
	
	    index--;
	  }
	
	  now.column += subvalue.length;
	  now.offset += subvalue.length;
	  subvalue += content + queue;
	
	  return eat(subvalue)({
	    type: 'heading',
	    depth: depth,
	    children: self.tokenizeInline(content, now)
	  });
	}


/***/ }),
/* 408 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = setextHeading;
	
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	var C_SPACE = ' ';
	var C_EQUALS = '=';
	var C_DASH = '-';
	
	var MAX_HEADING_INDENT = 3;
	
	/* Map of characters which can be used to mark setext
	 * headers, mapping to their corresponding depth. */
	var SETEXT_MARKERS = {};
	
	SETEXT_MARKERS[C_EQUALS] = 1;
	SETEXT_MARKERS[C_DASH] = 2;
	
	function setextHeading(eat, value, silent) {
	  var self = this;
	  var now = eat.now();
	  var length = value.length;
	  var index = -1;
	  var subvalue = '';
	  var content;
	  var queue;
	  var character;
	  var marker;
	  var depth;
	
	  /* Eat initial indentation. */
	  while (++index < length) {
	    character = value.charAt(index);
	
	    if (character !== C_SPACE || index >= MAX_HEADING_INDENT) {
	      index--;
	      break;
	    }
	
	    subvalue += character;
	  }
	
	  /* Eat content. */
	  content = '';
	  queue = '';
	
	  while (++index < length) {
	    character = value.charAt(index);
	
	    if (character === C_NEWLINE) {
	      index--;
	      break;
	    }
	
	    if (character === C_SPACE || character === C_TAB) {
	      queue += character;
	    } else {
	      content += queue + character;
	      queue = '';
	    }
	  }
	
	  now.column += subvalue.length;
	  now.offset += subvalue.length;
	  subvalue += content + queue;
	
	  /* Ensure the content is followed by a newline and a
	   * valid marker. */
	  character = value.charAt(++index);
	  marker = value.charAt(++index);
	
	  if (character !== C_NEWLINE || !SETEXT_MARKERS[marker]) {
	    return;
	  }
	
	  subvalue += character;
	
	  /* Eat Setext-line. */
	  queue = marker;
	  depth = SETEXT_MARKERS[marker];
	
	  while (++index < length) {
	    character = value.charAt(index);
	
	    if (character !== marker) {
	      if (character !== C_NEWLINE) {
	        return;
	      }
	
	      index--;
	      break;
	    }
	
	    queue += character;
	  }
	
	  if (silent) {
	    return true;
	  }
	
	  return eat(subvalue + queue)({
	    type: 'heading',
	    depth: depth,
	    children: self.tokenizeInline(content, now)
	  });
	}


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var openCloseTag = __webpack_require__(201).openCloseTag;
	
	module.exports = blockHTML;
	
	var C_TAB = '\t';
	var C_SPACE = ' ';
	var C_NEWLINE = '\n';
	var C_LT = '<';
	
	function blockHTML(eat, value, silent) {
	  var self = this;
	  var blocks = self.options.blocks;
	  var length = value.length;
	  var index = 0;
	  var next;
	  var line;
	  var offset;
	  var character;
	  var count;
	  var sequence;
	  var subvalue;
	
	  var sequences = [
	    [/^<(script|pre|style)(?=(\s|>|$))/i, /<\/(script|pre|style)>/i, true],
	    [/^<!--/, /-->/, true],
	    [/^<\?/, /\?>/, true],
	    [/^<![A-Za-z]/, />/, true],
	    [/^<!\[CDATA\[/, /\]\]>/, true],
	    [new RegExp('^</?(' + blocks.join('|') + ')(?=(\\s|/?>|$))', 'i'), /^$/, true],
	    [new RegExp(openCloseTag.source + '\\s*$'), /^$/, false]
	  ];
	
	  /* Eat initial spacing. */
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character !== C_TAB && character !== C_SPACE) {
	      break;
	    }
	
	    index++;
	  }
	
	  if (value.charAt(index) !== C_LT) {
	    return;
	  }
	
	  next = value.indexOf(C_NEWLINE, index + 1);
	  next = next === -1 ? length : next;
	  line = value.slice(index, next);
	  offset = -1;
	  count = sequences.length;
	
	  while (++offset < count) {
	    if (sequences[offset][0].test(line)) {
	      sequence = sequences[offset];
	      break;
	    }
	  }
	
	  if (!sequence) {
	    return;
	  }
	
	  if (silent) {
	    return sequence[2];
	  }
	
	  index = next;
	
	  if (!sequence[1].test(line)) {
	    while (index < length) {
	      next = value.indexOf(C_NEWLINE, index + 1);
	      next = next === -1 ? length : next;
	      line = value.slice(index + 1, next);
	
	      if (sequence[1].test(line)) {
	        if (line) {
	          index = next;
	        }
	
	        break;
	      }
	
	      index = next;
	    }
	  }
	
	  subvalue = value.slice(0, index);
	
	  return eat(subvalue)({type: 'html', value: subvalue});
	}


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var alphabetical = __webpack_require__(126);
	var locate = __webpack_require__(199);
	var tag = __webpack_require__(201).tag;
	
	module.exports = inlineHTML;
	inlineHTML.locator = locate;
	
	var EXPRESSION_HTML_LINK_OPEN = /^<a /i;
	var EXPRESSION_HTML_LINK_CLOSE = /^<\/a>/i;
	
	function inlineHTML(eat, value, silent) {
	  var self = this;
	  var length = value.length;
	  var character;
	  var subvalue;
	
	  if (value.charAt(0) !== '<' || length < 3) {
	    return;
	  }
	
	  character = value.charAt(1);
	
	  if (
	    !alphabetical(character) &&
	    character !== '?' &&
	    character !== '!' &&
	    character !== '/'
	  ) {
	    return;
	  }
	
	  subvalue = value.match(tag);
	
	  if (!subvalue) {
	    return;
	  }
	
	  /* istanbul ignore if - not used yet. */
	  if (silent) {
	    return true;
	  }
	
	  subvalue = subvalue[0];
	
	  if (!self.inLink && EXPRESSION_HTML_LINK_OPEN.test(subvalue)) {
	    self.inLink = true;
	  } else if (self.inLink && EXPRESSION_HTML_LINK_CLOSE.test(subvalue)) {
	    self.inLink = false;
	  }
	
	  return eat(subvalue)({type: 'html', value: subvalue});
	}


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var whitespace = __webpack_require__(14);
	var locate = __webpack_require__(198);
	
	module.exports = link;
	link.locator = locate;
	
	var own = {}.hasOwnProperty;
	
	var C_BACKSLASH = '\\';
	var C_BRACKET_OPEN = '[';
	var C_BRACKET_CLOSE = ']';
	var C_PAREN_OPEN = '(';
	var C_PAREN_CLOSE = ')';
	var C_LT = '<';
	var C_GT = '>';
	var C_TICK = '`';
	var C_DOUBLE_QUOTE = '"';
	var C_SINGLE_QUOTE = '\'';
	
	/* Map of characters, which can be used to mark link
	 * and image titles. */
	var LINK_MARKERS = {};
	
	LINK_MARKERS[C_DOUBLE_QUOTE] = C_DOUBLE_QUOTE;
	LINK_MARKERS[C_SINGLE_QUOTE] = C_SINGLE_QUOTE;
	
	/* Map of characters, which can be used to mark link
	 * and image titles in commonmark-mode. */
	var COMMONMARK_LINK_MARKERS = {};
	
	COMMONMARK_LINK_MARKERS[C_DOUBLE_QUOTE] = C_DOUBLE_QUOTE;
	COMMONMARK_LINK_MARKERS[C_SINGLE_QUOTE] = C_SINGLE_QUOTE;
	COMMONMARK_LINK_MARKERS[C_PAREN_OPEN] = C_PAREN_CLOSE;
	
	function link(eat, value, silent) {
	  var self = this;
	  var subvalue = '';
	  var index = 0;
	  var character = value.charAt(0);
	  var pedantic = self.options.pedantic;
	  var commonmark = self.options.commonmark;
	  var gfm = self.options.gfm;
	  var closed;
	  var count;
	  var opening;
	  var beforeURL;
	  var beforeTitle;
	  var subqueue;
	  var hasMarker;
	  var markers;
	  var isImage;
	  var content;
	  var marker;
	  var length;
	  var title;
	  var depth;
	  var queue;
	  var url;
	  var now;
	  var exit;
	  var node;
	
	  /* Detect whether this is an image. */
	  if (character === '!') {
	    isImage = true;
	    subvalue = character;
	    character = value.charAt(++index);
	  }
	
	  /* Eat the opening. */
	  if (character !== C_BRACKET_OPEN) {
	    return;
	  }
	
	  /* Exit when this is a link and we’re already inside
	   * a link. */
	  if (!isImage && self.inLink) {
	    return;
	  }
	
	  subvalue += character;
	  queue = '';
	  index++;
	
	  /* Eat the content. */
	  length = value.length;
	  now = eat.now();
	  depth = 0;
	
	  now.column += index;
	  now.offset += index;
	
	  while (index < length) {
	    character = value.charAt(index);
	    subqueue = character;
	
	    if (character === C_TICK) {
	      /* Inline-code in link content. */
	      count = 1;
	
	      while (value.charAt(index + 1) === C_TICK) {
	        subqueue += character;
	        index++;
	        count++;
	      }
	
	      if (!opening) {
	        opening = count;
	      } else if (count >= opening) {
	        opening = 0;
	      }
	    } else if (character === C_BACKSLASH) {
	      /* Allow brackets to be escaped. */
	      index++;
	      subqueue += value.charAt(index);
	    /* In GFM mode, brackets in code still count.
	     * In all other modes, they don’t.  This empty
	     * block prevents the next statements are
	     * entered. */
	    } else if ((!opening || gfm) && character === C_BRACKET_OPEN) {
	      depth++;
	    } else if ((!opening || gfm) && character === C_BRACKET_CLOSE) {
	      if (depth) {
	        depth--;
	      } else {
	        /* Allow white-space between content and
	         * url in GFM mode. */
	        if (!pedantic) {
	          while (index < length) {
	            character = value.charAt(index + 1);
	
	            if (!whitespace(character)) {
	              break;
	            }
	
	            subqueue += character;
	            index++;
	          }
	        }
	
	        if (value.charAt(index + 1) !== C_PAREN_OPEN) {
	          return;
	        }
	
	        subqueue += C_PAREN_OPEN;
	        closed = true;
	        index++;
	
	        break;
	      }
	    }
	
	    queue += subqueue;
	    subqueue = '';
	    index++;
	  }
	
	  /* Eat the content closing. */
	  if (!closed) {
	    return;
	  }
	
	  content = queue;
	  subvalue += queue + subqueue;
	  index++;
	
	  /* Eat white-space. */
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (!whitespace(character)) {
	      break;
	    }
	
	    subvalue += character;
	    index++;
	  }
	
	  /* Eat the URL. */
	  character = value.charAt(index);
	  markers = commonmark ? COMMONMARK_LINK_MARKERS : LINK_MARKERS;
	  queue = '';
	  beforeURL = subvalue;
	
	  if (character === C_LT) {
	    index++;
	    beforeURL += C_LT;
	
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (character === C_GT) {
	        break;
	      }
	
	      if (commonmark && character === '\n') {
	        return;
	      }
	
	      queue += character;
	      index++;
	    }
	
	    if (value.charAt(index) !== C_GT) {
	      return;
	    }
	
	    subvalue += C_LT + queue + C_GT;
	    url = queue;
	    index++;
	  } else {
	    character = null;
	    subqueue = '';
	
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (subqueue && own.call(markers, character)) {
	        break;
	      }
	
	      if (whitespace(character)) {
	        if (!pedantic) {
	          break;
	        }
	
	        subqueue += character;
	      } else {
	        if (character === C_PAREN_OPEN) {
	          depth++;
	        } else if (character === C_PAREN_CLOSE) {
	          if (depth === 0) {
	            break;
	          }
	
	          depth--;
	        }
	
	        queue += subqueue;
	        subqueue = '';
	
	        if (character === C_BACKSLASH) {
	          queue += C_BACKSLASH;
	          character = value.charAt(++index);
	        }
	
	        queue += character;
	      }
	
	      index++;
	    }
	
	    subvalue += queue;
	    url = queue;
	    index = subvalue.length;
	  }
	
	  /* Eat white-space. */
	  queue = '';
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (!whitespace(character)) {
	      break;
	    }
	
	    queue += character;
	    index++;
	  }
	
	  character = value.charAt(index);
	  subvalue += queue;
	
	  /* Eat the title. */
	  if (queue && own.call(markers, character)) {
	    index++;
	    subvalue += character;
	    queue = '';
	    marker = markers[character];
	    beforeTitle = subvalue;
	
	    /* In commonmark-mode, things are pretty easy: the
	     * marker cannot occur inside the title.
	     *
	     * Non-commonmark does, however, support nested
	     * delimiters. */
	    if (commonmark) {
	      while (index < length) {
	        character = value.charAt(index);
	
	        if (character === marker) {
	          break;
	        }
	
	        if (character === C_BACKSLASH) {
	          queue += C_BACKSLASH;
	          character = value.charAt(++index);
	        }
	
	        index++;
	        queue += character;
	      }
	
	      character = value.charAt(index);
	
	      if (character !== marker) {
	        return;
	      }
	
	      title = queue;
	      subvalue += queue + character;
	      index++;
	
	      while (index < length) {
	        character = value.charAt(index);
	
	        if (!whitespace(character)) {
	          break;
	        }
	
	        subvalue += character;
	        index++;
	      }
	    } else {
	      subqueue = '';
	
	      while (index < length) {
	        character = value.charAt(index);
	
	        if (character === marker) {
	          if (hasMarker) {
	            queue += marker + subqueue;
	            subqueue = '';
	          }
	
	          hasMarker = true;
	        } else if (!hasMarker) {
	          queue += character;
	        } else if (character === C_PAREN_CLOSE) {
	          subvalue += queue + marker + subqueue;
	          title = queue;
	          break;
	        } else if (whitespace(character)) {
	          subqueue += character;
	        } else {
	          queue += marker + subqueue + character;
	          subqueue = '';
	          hasMarker = false;
	        }
	
	        index++;
	      }
	    }
	  }
	
	  if (value.charAt(index) !== C_PAREN_CLOSE) {
	    return;
	  }
	
	  /* istanbul ignore if - never used (yet) */
	  if (silent) {
	    return true;
	  }
	
	  subvalue += C_PAREN_CLOSE;
	
	  url = self.decode.raw(self.unescape(url), eat(beforeURL).test().end, {nonTerminated: false});
	
	  if (title) {
	    beforeTitle = eat(beforeTitle).test().end;
	    title = self.decode.raw(self.unescape(title), beforeTitle);
	  }
	
	  node = {
	    type: isImage ? 'image' : 'link',
	    title: title || null,
	    url: url
	  };
	
	  if (isImage) {
	    node.alt = self.decode.raw(self.unescape(content), now) || null;
	  } else {
	    exit = self.enterLink();
	    node.children = self.tokenizeInline(content, now);
	    exit();
	  }
	
	  return eat(subvalue)(node);
	}


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/* eslint-disable max-params */
	
	var trim = __webpack_require__(22);
	var repeat = __webpack_require__(16);
	var decimal = __webpack_require__(40);
	var getIndent = __webpack_require__(200);
	var removeIndent = __webpack_require__(423);
	var interrupt = __webpack_require__(83);
	
	module.exports = list;
	
	var C_ASTERISK = '*';
	var C_UNDERSCORE = '_';
	var C_PLUS = '+';
	var C_DASH = '-';
	var C_DOT = '.';
	var C_SPACE = ' ';
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	var C_PAREN_CLOSE = ')';
	var C_X_LOWER = 'x';
	
	var TAB_SIZE = 4;
	var EXPRESSION_LOOSE_LIST_ITEM = /\n\n(?!\s*$)/;
	var EXPRESSION_TASK_ITEM = /^\[([ \t]|x|X)][ \t]/;
	var EXPRESSION_BULLET = /^([ \t]*)([*+-]|\d+[.)])( {1,4}(?! )| |\t|$|(?=\n))([^\n]*)/;
	var EXPRESSION_PEDANTIC_BULLET = /^([ \t]*)([*+-]|\d+[.)])([ \t]+)/;
	var EXPRESSION_INITIAL_INDENT = /^( {1,4}|\t)?/gm;
	
	/* Map of characters which can be used to mark
	 * list-items. */
	var LIST_UNORDERED_MARKERS = {};
	
	LIST_UNORDERED_MARKERS[C_ASTERISK] = true;
	LIST_UNORDERED_MARKERS[C_PLUS] = true;
	LIST_UNORDERED_MARKERS[C_DASH] = true;
	
	/* Map of characters which can be used to mark
	 * list-items after a digit. */
	var LIST_ORDERED_MARKERS = {};
	
	LIST_ORDERED_MARKERS[C_DOT] = true;
	
	/* Map of characters which can be used to mark
	 * list-items after a digit. */
	var LIST_ORDERED_COMMONMARK_MARKERS = {};
	
	LIST_ORDERED_COMMONMARK_MARKERS[C_DOT] = true;
	LIST_ORDERED_COMMONMARK_MARKERS[C_PAREN_CLOSE] = true;
	
	function list(eat, value, silent) {
	  var self = this;
	  var commonmark = self.options.commonmark;
	  var pedantic = self.options.pedantic;
	  var tokenizers = self.blockTokenizers;
	  var interuptors = self.interruptList;
	  var markers;
	  var index = 0;
	  var length = value.length;
	  var start = null;
	  var size = 0;
	  var queue;
	  var ordered;
	  var character;
	  var marker;
	  var nextIndex;
	  var startIndex;
	  var prefixed;
	  var currentMarker;
	  var content;
	  var line;
	  var prevEmpty;
	  var empty;
	  var items;
	  var allLines;
	  var emptyLines;
	  var item;
	  var enterTop;
	  var exitBlockquote;
	  var isLoose;
	  var node;
	  var now;
	  var end;
	  var indented;
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character === C_TAB) {
	      size += TAB_SIZE - (size % TAB_SIZE);
	    } else if (character === C_SPACE) {
	      size++;
	    } else {
	      break;
	    }
	
	    index++;
	  }
	
	  if (size >= TAB_SIZE) {
	    return;
	  }
	
	  character = value.charAt(index);
	
	  markers = commonmark ?
	    LIST_ORDERED_COMMONMARK_MARKERS :
	    LIST_ORDERED_MARKERS;
	
	  if (LIST_UNORDERED_MARKERS[character] === true) {
	    marker = character;
	    ordered = false;
	  } else {
	    ordered = true;
	    queue = '';
	
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (!decimal(character)) {
	        break;
	      }
	
	      queue += character;
	      index++;
	    }
	
	    character = value.charAt(index);
	
	    if (!queue || markers[character] !== true) {
	      return;
	    }
	
	    start = parseInt(queue, 10);
	    marker = character;
	  }
	
	  character = value.charAt(++index);
	
	  if (character !== C_SPACE && character !== C_TAB) {
	    return;
	  }
	
	  if (silent) {
	    return true;
	  }
	
	  index = 0;
	  items = [];
	  allLines = [];
	  emptyLines = [];
	
	  while (index < length) {
	    nextIndex = value.indexOf(C_NEWLINE, index);
	    startIndex = index;
	    prefixed = false;
	    indented = false;
	
	    if (nextIndex === -1) {
	      nextIndex = length;
	    }
	
	    end = index + TAB_SIZE;
	    size = 0;
	
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (character === C_TAB) {
	        size += TAB_SIZE - (size % TAB_SIZE);
	      } else if (character === C_SPACE) {
	        size++;
	      } else {
	        break;
	      }
	
	      index++;
	    }
	
	    if (size >= TAB_SIZE) {
	      indented = true;
	    }
	
	    if (item && size >= item.indent) {
	      indented = true;
	    }
	
	    character = value.charAt(index);
	    currentMarker = null;
	
	    if (!indented) {
	      if (LIST_UNORDERED_MARKERS[character] === true) {
	        currentMarker = character;
	        index++;
	        size++;
	      } else {
	        queue = '';
	
	        while (index < length) {
	          character = value.charAt(index);
	
	          if (!decimal(character)) {
	            break;
	          }
	
	          queue += character;
	          index++;
	        }
	
	        character = value.charAt(index);
	        index++;
	
	        if (queue && markers[character] === true) {
	          currentMarker = character;
	          size += queue.length + 1;
	        }
	      }
	
	      if (currentMarker) {
	        character = value.charAt(index);
	
	        if (character === C_TAB) {
	          size += TAB_SIZE - (size % TAB_SIZE);
	          index++;
	        } else if (character === C_SPACE) {
	          end = index + TAB_SIZE;
	
	          while (index < end) {
	            if (value.charAt(index) !== C_SPACE) {
	              break;
	            }
	
	            index++;
	            size++;
	          }
	
	          if (index === end && value.charAt(index) === C_SPACE) {
	            index -= TAB_SIZE - 1;
	            size -= TAB_SIZE - 1;
	          }
	        } else if (character !== C_NEWLINE && character !== '') {
	          currentMarker = null;
	        }
	      }
	    }
	
	    if (currentMarker) {
	      if (!pedantic && marker !== currentMarker) {
	        break;
	      }
	
	      prefixed = true;
	    } else {
	      if (!commonmark && !indented && value.charAt(startIndex) === C_SPACE) {
	        indented = true;
	      } else if (commonmark && item) {
	        indented = size >= item.indent || size > TAB_SIZE;
	      }
	
	      prefixed = false;
	      index = startIndex;
	    }
	
	    line = value.slice(startIndex, nextIndex);
	    content = startIndex === index ? line : value.slice(index, nextIndex);
	
	    if (
	      currentMarker === C_ASTERISK ||
	      currentMarker === C_UNDERSCORE ||
	      currentMarker === C_DASH
	    ) {
	      if (tokenizers.thematicBreak.call(self, eat, line, true)) {
	        break;
	      }
	    }
	
	    prevEmpty = empty;
	    empty = !trim(content).length;
	
	    if (indented && item) {
	      item.value = item.value.concat(emptyLines, line);
	      allLines = allLines.concat(emptyLines, line);
	      emptyLines = [];
	    } else if (prefixed) {
	      if (emptyLines.length !== 0) {
	        item.value.push('');
	        item.trail = emptyLines.concat();
	      }
	
	      item = {
	        value: [line],
	        indent: size,
	        trail: []
	      };
	
	      items.push(item);
	      allLines = allLines.concat(emptyLines, line);
	      emptyLines = [];
	    } else if (empty) {
	      if (prevEmpty) {
	        break;
	      }
	
	      emptyLines.push(line);
	    } else {
	      if (prevEmpty) {
	        break;
	      }
	
	      if (interrupt(interuptors, tokenizers, self, [eat, line, true])) {
	        break;
	      }
	
	      item.value = item.value.concat(emptyLines, line);
	      allLines = allLines.concat(emptyLines, line);
	      emptyLines = [];
	    }
	
	    index = nextIndex + 1;
	  }
	
	  node = eat(allLines.join(C_NEWLINE)).reset({
	    type: 'list',
	    ordered: ordered,
	    start: start,
	    loose: null,
	    children: []
	  });
	
	  enterTop = self.enterList();
	  exitBlockquote = self.enterBlock();
	  isLoose = false;
	  index = -1;
	  length = items.length;
	
	  while (++index < length) {
	    item = items[index].value.join(C_NEWLINE);
	    now = eat.now();
	
	    item = eat(item)(listItem(self, item, now), node);
	
	    if (item.loose) {
	      isLoose = true;
	    }
	
	    item = items[index].trail.join(C_NEWLINE);
	
	    if (index !== length - 1) {
	      item += C_NEWLINE;
	    }
	
	    eat(item);
	  }
	
	  enterTop();
	  exitBlockquote();
	
	  node.loose = isLoose;
	
	  return node;
	}
	
	function listItem(ctx, value, position) {
	  var offsets = ctx.offset;
	  var fn = ctx.options.pedantic ? pedanticListItem : normalListItem;
	  var checked = null;
	  var task;
	  var indent;
	
	  value = fn.apply(null, arguments);
	
	  if (ctx.options.gfm) {
	    task = value.match(EXPRESSION_TASK_ITEM);
	
	    if (task) {
	      indent = task[0].length;
	      checked = task[1].toLowerCase() === C_X_LOWER;
	      offsets[position.line] += indent;
	      value = value.slice(indent);
	    }
	  }
	
	  return {
	    type: 'listItem',
	    loose: EXPRESSION_LOOSE_LIST_ITEM.test(value) ||
	      value.charAt(value.length - 1) === C_NEWLINE,
	    checked: checked,
	    children: ctx.tokenizeBlock(value, position)
	  };
	}
	
	/* Create a list-item using overly simple mechanics. */
	function pedanticListItem(ctx, value, position) {
	  var offsets = ctx.offset;
	  var line = position.line;
	
	  /* Remove the list-item’s bullet. */
	  value = value.replace(EXPRESSION_PEDANTIC_BULLET, replacer);
	
	  /* The initial line was also matched by the below, so
	   * we reset the `line`. */
	  line = position.line;
	
	  return value.replace(EXPRESSION_INITIAL_INDENT, replacer);
	
	  /* A simple replacer which removed all matches,
	   * and adds their length to `offset`. */
	  function replacer($0) {
	    offsets[line] = (offsets[line] || 0) + $0.length;
	    line++;
	
	    return '';
	  }
	}
	
	/* Create a list-item using sane mechanics. */
	function normalListItem(ctx, value, position) {
	  var offsets = ctx.offset;
	  var line = position.line;
	  var max;
	  var bullet;
	  var rest;
	  var lines;
	  var trimmedLines;
	  var index;
	  var length;
	
	  /* Remove the list-item’s bullet. */
	  value = value.replace(EXPRESSION_BULLET, replacer);
	
	  lines = value.split(C_NEWLINE);
	
	  trimmedLines = removeIndent(value, getIndent(max).indent).split(C_NEWLINE);
	
	  /* We replaced the initial bullet with something
	   * else above, which was used to trick
	   * `removeIndentation` into removing some more
	   * characters when possible.  However, that could
	   * result in the initial line to be stripped more
	   * than it should be. */
	  trimmedLines[0] = rest;
	
	  offsets[line] = (offsets[line] || 0) + bullet.length;
	  line++;
	
	  index = 0;
	  length = lines.length;
	
	  while (++index < length) {
	    offsets[line] = (offsets[line] || 0) +
	      lines[index].length - trimmedLines[index].length;
	    line++;
	  }
	
	  return trimmedLines.join(C_NEWLINE);
	
	  function replacer($0, $1, $2, $3, $4) {
	    bullet = $1 + $2 + $3;
	    rest = $4;
	
	    /* Make sure that the first nine numbered list items
	     * can indent with an extra space.  That is, when
	     * the bullet did not receive an extra final space. */
	    if (Number($2) < 10 && bullet.length % 2 === 1) {
	      $2 = C_SPACE + $2;
	    }
	
	    max = $1 + repeat(C_SPACE, $2.length) + $3;
	
	    return max + rest;
	  }
	}


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var whitespace = __webpack_require__(14);
	
	module.exports = newline;
	
	/* Tokenise newline. */
	function newline(eat, value, silent) {
	  var character = value.charAt(0);
	  var length;
	  var subvalue;
	  var queue;
	  var index;
	
	  if (character !== '\n') {
	    return;
	  }
	
	  /* istanbul ignore if - never used (yet) */
	  if (silent) {
	    return true;
	  }
	
	  index = 1;
	  length = value.length;
	  subvalue = character;
	  queue = '';
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (!whitespace(character)) {
	      break;
	    }
	
	    queue += character;
	
	    if (character === '\n') {
	      subvalue += queue;
	      queue = '';
	    }
	
	    index++;
	  }
	
	  eat(subvalue);
	}


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var trim = __webpack_require__(22);
	var decimal = __webpack_require__(40);
	var trimTrailingLines = __webpack_require__(88);
	var interrupt = __webpack_require__(83);
	
	module.exports = paragraph;
	
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	var C_SPACE = ' ';
	
	var TAB_SIZE = 4;
	
	/* Tokenise paragraph. */
	function paragraph(eat, value, silent) {
	  var self = this;
	  var settings = self.options;
	  var commonmark = settings.commonmark;
	  var gfm = settings.gfm;
	  var tokenizers = self.blockTokenizers;
	  var interruptors = self.interruptParagraph;
	  var index = value.indexOf(C_NEWLINE);
	  var length = value.length;
	  var position;
	  var subvalue;
	  var character;
	  var size;
	  var now;
	
	  while (index < length) {
	    /* Eat everything if there’s no following newline. */
	    if (index === -1) {
	      index = length;
	      break;
	    }
	
	    /* Stop if the next character is NEWLINE. */
	    if (value.charAt(index + 1) === C_NEWLINE) {
	      break;
	    }
	
	    /* In commonmark-mode, following indented lines
	     * are part of the paragraph. */
	    if (commonmark) {
	      size = 0;
	      position = index + 1;
	
	      while (position < length) {
	        character = value.charAt(position);
	
	        if (character === C_TAB) {
	          size = TAB_SIZE;
	          break;
	        } else if (character === C_SPACE) {
	          size++;
	        } else {
	          break;
	        }
	
	        position++;
	      }
	
	      if (size >= TAB_SIZE) {
	        index = value.indexOf(C_NEWLINE, index + 1);
	        continue;
	      }
	    }
	
	    subvalue = value.slice(index + 1);
	
	    /* Check if the following code contains a possible
	     * block. */
	    if (interrupt(interruptors, tokenizers, self, [eat, subvalue, true])) {
	      break;
	    }
	
	    /* Break if the following line starts a list, when
	     * already in a list, or when in commonmark, or when
	     * in gfm mode and the bullet is *not* numeric. */
	    if (
	      tokenizers.list.call(self, eat, subvalue, true) &&
	      (
	        self.inList ||
	        commonmark ||
	        (gfm && !decimal(trim.left(subvalue).charAt(0)))
	      )
	    ) {
	      break;
	    }
	
	    position = index;
	    index = value.indexOf(C_NEWLINE, index + 1);
	
	    if (index !== -1 && trim(value.slice(position, index)) === '') {
	      index = position;
	      break;
	    }
	  }
	
	  subvalue = value.slice(0, index);
	
	  if (trim(subvalue) === '') {
	    eat(subvalue);
	
	    return null;
	  }
	
	  /* istanbul ignore if - never used (yet) */
	  if (silent) {
	    return true;
	  }
	
	  now = eat.now();
	  subvalue = trimTrailingLines(subvalue);
	
	  return eat(subvalue)({
	    type: 'paragraph',
	    children: self.tokenizeInline(subvalue, now)
	  });
	}


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var whitespace = __webpack_require__(14);
	var locate = __webpack_require__(198);
	var normalize = __webpack_require__(84);
	
	module.exports = reference;
	reference.locator = locate;
	
	var T_LINK = 'link';
	var T_IMAGE = 'image';
	var T_FOOTNOTE = 'footnote';
	var REFERENCE_TYPE_SHORTCUT = 'shortcut';
	var REFERENCE_TYPE_COLLAPSED = 'collapsed';
	var REFERENCE_TYPE_FULL = 'full';
	var C_CARET = '^';
	var C_BACKSLASH = '\\';
	var C_BRACKET_OPEN = '[';
	var C_BRACKET_CLOSE = ']';
	
	function reference(eat, value, silent) {
	  var self = this;
	  var character = value.charAt(0);
	  var index = 0;
	  var length = value.length;
	  var subvalue = '';
	  var intro = '';
	  var type = T_LINK;
	  var referenceType = REFERENCE_TYPE_SHORTCUT;
	  var content;
	  var identifier;
	  var now;
	  var node;
	  var exit;
	  var queue;
	  var bracketed;
	  var depth;
	
	  /* Check whether we’re eating an image. */
	  if (character === '!') {
	    type = T_IMAGE;
	    intro = character;
	    character = value.charAt(++index);
	  }
	
	  if (character !== C_BRACKET_OPEN) {
	    return;
	  }
	
	  index++;
	  intro += character;
	  queue = '';
	
	  /* Check whether we’re eating a footnote. */
	  if (self.options.footnotes && value.charAt(index) === C_CARET) {
	    /* Exit if `![^` is found, so the `!` will be seen as text after this,
	     * and we’ll enter this function again when `[^` is found. */
	    if (type === T_IMAGE) {
	      return;
	    }
	
	    intro += C_CARET;
	    index++;
	    type = T_FOOTNOTE;
	  }
	
	  /* Eat the text. */
	  depth = 0;
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character === C_BRACKET_OPEN) {
	      bracketed = true;
	      depth++;
	    } else if (character === C_BRACKET_CLOSE) {
	      if (!depth) {
	        break;
	      }
	
	      depth--;
	    }
	
	    if (character === C_BACKSLASH) {
	      queue += C_BACKSLASH;
	      character = value.charAt(++index);
	    }
	
	    queue += character;
	    index++;
	  }
	
	  subvalue = queue;
	  content = queue;
	  character = value.charAt(index);
	
	  if (character !== C_BRACKET_CLOSE) {
	    return;
	  }
	
	  index++;
	  subvalue += character;
	  queue = '';
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (!whitespace(character)) {
	      break;
	    }
	
	    queue += character;
	    index++;
	  }
	
	  character = value.charAt(index);
	
	  /* Inline footnotes cannot have an identifier. */
	  if (type !== T_FOOTNOTE && character === C_BRACKET_OPEN) {
	    identifier = '';
	    queue += character;
	    index++;
	
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (character === C_BRACKET_OPEN || character === C_BRACKET_CLOSE) {
	        break;
	      }
	
	      if (character === C_BACKSLASH) {
	        identifier += C_BACKSLASH;
	        character = value.charAt(++index);
	      }
	
	      identifier += character;
	      index++;
	    }
	
	    character = value.charAt(index);
	
	    if (character === C_BRACKET_CLOSE) {
	      referenceType = identifier ? REFERENCE_TYPE_FULL : REFERENCE_TYPE_COLLAPSED;
	      queue += identifier + character;
	      index++;
	    } else {
	      identifier = '';
	    }
	
	    subvalue += queue;
	    queue = '';
	  } else {
	    if (!content) {
	      return;
	    }
	
	    identifier = content;
	  }
	
	  /* Brackets cannot be inside the identifier. */
	  if (referenceType !== REFERENCE_TYPE_FULL && bracketed) {
	    return;
	  }
	
	  subvalue = intro + subvalue;
	
	  if (type === T_LINK && self.inLink) {
	    return null;
	  }
	
	  /* istanbul ignore if - never used (yet) */
	  if (silent) {
	    return true;
	  }
	
	  if (type === T_FOOTNOTE && content.indexOf(' ') !== -1) {
	    return eat(subvalue)({
	      type: 'footnote',
	      children: this.tokenizeInline(content, eat.now())
	    });
	  }
	
	  now = eat.now();
	  now.column += intro.length;
	  now.offset += intro.length;
	  identifier = referenceType === REFERENCE_TYPE_FULL ? identifier : content;
	
	  node = {
	    type: type + 'Reference',
	    identifier: normalize(identifier)
	  };
	
	  if (type === T_LINK || type === T_IMAGE) {
	    node.referenceType = referenceType;
	  }
	
	  if (type === T_LINK) {
	    exit = self.enterLink();
	    node.children = self.tokenizeInline(content, now);
	    exit();
	  } else if (type === T_IMAGE) {
	    node.alt = self.decode.raw(self.unescape(content), now) || null;
	  }
	
	  return eat(subvalue)(node);
	}


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var trim = __webpack_require__(22);
	var whitespace = __webpack_require__(14);
	var locate = __webpack_require__(391);
	
	module.exports = strong;
	strong.locator = locate;
	
	var C_ASTERISK = '*';
	var C_UNDERSCORE = '_';
	
	function strong(eat, value, silent) {
	  var self = this;
	  var index = 0;
	  var character = value.charAt(index);
	  var now;
	  var pedantic;
	  var marker;
	  var queue;
	  var subvalue;
	  var length;
	  var prev;
	
	  if (
	    (character !== C_ASTERISK && character !== C_UNDERSCORE) ||
	    value.charAt(++index) !== character
	  ) {
	    return;
	  }
	
	  pedantic = self.options.pedantic;
	  marker = character;
	  subvalue = marker + marker;
	  length = value.length;
	  index++;
	  queue = '';
	  character = '';
	
	  if (pedantic && whitespace(value.charAt(index))) {
	    return;
	  }
	
	  while (index < length) {
	    prev = character;
	    character = value.charAt(index);
	
	    if (
	      character === marker &&
	      value.charAt(index + 1) === marker &&
	      (!pedantic || !whitespace(prev))
	    ) {
	      character = value.charAt(index + 2);
	
	      if (character !== marker) {
	        if (!trim(queue)) {
	          return;
	        }
	
	        /* istanbul ignore if - never used (yet) */
	        if (silent) {
	          return true;
	        }
	
	        now = eat.now();
	        now.column += 2;
	        now.offset += 2;
	
	        return eat(subvalue + queue + subvalue)({
	          type: 'strong',
	          children: self.tokenizeInline(queue, now)
	        });
	      }
	    }
	
	    if (!pedantic && character === '\\') {
	      queue += character;
	      character = value.charAt(++index);
	    }
	
	    queue += character;
	    index++;
	  }
	}


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var whitespace = __webpack_require__(14);
	
	module.exports = table;
	
	var C_BACKSLASH = '\\';
	var C_TICK = '`';
	var C_DASH = '-';
	var C_PIPE = '|';
	var C_COLON = ':';
	var C_SPACE = ' ';
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	
	var MIN_TABLE_COLUMNS = 1;
	var MIN_TABLE_ROWS = 2;
	
	var TABLE_ALIGN_LEFT = 'left';
	var TABLE_ALIGN_CENTER = 'center';
	var TABLE_ALIGN_RIGHT = 'right';
	var TABLE_ALIGN_NONE = null;
	
	function table(eat, value, silent) {
	  var self = this;
	  var index;
	  var alignments;
	  var alignment;
	  var subvalue;
	  var row;
	  var length;
	  var lines;
	  var queue;
	  var character;
	  var hasDash;
	  var align;
	  var cell;
	  var preamble;
	  var count;
	  var opening;
	  var now;
	  var position;
	  var lineCount;
	  var line;
	  var rows;
	  var table;
	  var lineIndex;
	  var pipeIndex;
	  var first;
	
	  /* Exit when not in gfm-mode. */
	  if (!self.options.gfm) {
	    return;
	  }
	
	  /* Get the rows.
	   * Detecting tables soon is hard, so there are some
	   * checks for performance here, such as the minimum
	   * number of rows, and allowed characters in the
	   * alignment row. */
	  index = 0;
	  lineCount = 0;
	  length = value.length + 1;
	  lines = [];
	
	  while (index < length) {
	    lineIndex = value.indexOf(C_NEWLINE, index);
	    pipeIndex = value.indexOf(C_PIPE, index + 1);
	
	    if (lineIndex === -1) {
	      lineIndex = value.length;
	    }
	
	    if (pipeIndex === -1 || pipeIndex > lineIndex) {
	      if (lineCount < MIN_TABLE_ROWS) {
	        return;
	      }
	
	      break;
	    }
	
	    lines.push(value.slice(index, lineIndex));
	    lineCount++;
	    index = lineIndex + 1;
	  }
	
	  /* Parse the alignment row. */
	  subvalue = lines.join(C_NEWLINE);
	  alignments = lines.splice(1, 1)[0] || [];
	  index = 0;
	  length = alignments.length;
	  lineCount--;
	  alignment = false;
	  align = [];
	
	  while (index < length) {
	    character = alignments.charAt(index);
	
	    if (character === C_PIPE) {
	      hasDash = null;
	
	      if (alignment === false) {
	        if (first === false) {
	          return;
	        }
	      } else {
	        align.push(alignment);
	        alignment = false;
	      }
	
	      first = false;
	    } else if (character === C_DASH) {
	      hasDash = true;
	      alignment = alignment || TABLE_ALIGN_NONE;
	    } else if (character === C_COLON) {
	      if (alignment === TABLE_ALIGN_LEFT) {
	        alignment = TABLE_ALIGN_CENTER;
	      } else if (hasDash && alignment === TABLE_ALIGN_NONE) {
	        alignment = TABLE_ALIGN_RIGHT;
	      } else {
	        alignment = TABLE_ALIGN_LEFT;
	      }
	    } else if (!whitespace(character)) {
	      return;
	    }
	
	    index++;
	  }
	
	  if (alignment !== false) {
	    align.push(alignment);
	  }
	
	  /* Exit when without enough columns. */
	  if (align.length < MIN_TABLE_COLUMNS) {
	    return;
	  }
	
	  /* istanbul ignore if - never used (yet) */
	  if (silent) {
	    return true;
	  }
	
	  /* Parse the rows. */
	  position = -1;
	  rows = [];
	
	  table = eat(subvalue).reset({
	    type: 'table',
	    align: align,
	    children: rows
	  });
	
	  while (++position < lineCount) {
	    line = lines[position];
	    row = {type: 'tableRow', children: []};
	
	    /* Eat a newline character when this is not the
	     * first row. */
	    if (position) {
	      eat(C_NEWLINE);
	    }
	
	    /* Eat the row. */
	    eat(line).reset(row, table);
	
	    length = line.length + 1;
	    index = 0;
	    queue = '';
	    cell = '';
	    preamble = true;
	    count = null;
	    opening = null;
	
	    while (index < length) {
	      character = line.charAt(index);
	
	      if (character === C_TAB || character === C_SPACE) {
	        if (cell) {
	          queue += character;
	        } else {
	          eat(character);
	        }
	
	        index++;
	        continue;
	      }
	
	      if (character === '' || character === C_PIPE) {
	        if (preamble) {
	          eat(character);
	        } else {
	          if (character && opening) {
	            queue += character;
	            index++;
	            continue;
	          }
	
	          if ((cell || character) && !preamble) {
	            subvalue = cell;
	
	            if (queue.length > 1) {
	              if (character) {
	                subvalue += queue.slice(0, queue.length - 1);
	                queue = queue.charAt(queue.length - 1);
	              } else {
	                subvalue += queue;
	                queue = '';
	              }
	            }
	
	            now = eat.now();
	
	            eat(subvalue)({
	              type: 'tableCell',
	              children: self.tokenizeInline(cell, now)
	            }, row);
	          }
	
	          eat(queue + character);
	
	          queue = '';
	          cell = '';
	        }
	      } else {
	        if (queue) {
	          cell += queue;
	          queue = '';
	        }
	
	        cell += character;
	
	        if (character === C_BACKSLASH && index !== length - 2) {
	          cell += line.charAt(index + 1);
	          index++;
	        }
	
	        if (character === C_TICK) {
	          count = 1;
	
	          while (line.charAt(index + 1) === character) {
	            cell += character;
	            index++;
	            count++;
	          }
	
	          if (!opening) {
	            opening = count;
	          } else if (count >= opening) {
	            opening = 0;
	          }
	        }
	      }
	
	      preamble = false;
	      index++;
	    }
	
	    /* Eat the alignment row. */
	    if (!position) {
	      eat(C_NEWLINE + alignments);
	    }
	  }
	
	  return table;
	}


/***/ }),
/* 418 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = text;
	
	function text(eat, value, silent) {
	  var self = this;
	  var methods;
	  var tokenizers;
	  var index;
	  var length;
	  var subvalue;
	  var position;
	  var tokenizer;
	  var name;
	  var min;
	  var now;
	
	  /* istanbul ignore if - never used (yet) */
	  if (silent) {
	    return true;
	  }
	
	  methods = self.inlineMethods;
	  length = methods.length;
	  tokenizers = self.inlineTokenizers;
	  index = -1;
	  min = value.length;
	
	  while (++index < length) {
	    name = methods[index];
	
	    if (name === 'text' || !tokenizers[name]) {
	      continue;
	    }
	
	    tokenizer = tokenizers[name].locator;
	
	    if (!tokenizer) {
	      eat.file.fail('Missing locator: `' + name + '`');
	    }
	
	    position = tokenizer.call(self, value, 1);
	
	    if (position !== -1 && position < min) {
	      min = position;
	    }
	  }
	
	  subvalue = value.slice(0, min);
	  now = eat.now();
	
	  self.decode(subvalue, now, function (content, position, source) {
	    eat(source || content)({
	      type: 'text',
	      value: content
	    });
	  });
	}


/***/ }),
/* 419 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = thematicBreak;
	
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	var C_SPACE = ' ';
	var C_ASTERISK = '*';
	var C_UNDERSCORE = '_';
	var C_DASH = '-';
	
	var THEMATIC_BREAK_MARKER_COUNT = 3;
	
	function thematicBreak(eat, value, silent) {
	  var index = -1;
	  var length = value.length + 1;
	  var subvalue = '';
	  var character;
	  var marker;
	  var markerCount;
	  var queue;
	
	  while (++index < length) {
	    character = value.charAt(index);
	
	    if (character !== C_TAB && character !== C_SPACE) {
	      break;
	    }
	
	    subvalue += character;
	  }
	
	  if (
	    character !== C_ASTERISK &&
	    character !== C_DASH &&
	    character !== C_UNDERSCORE
	  ) {
	    return;
	  }
	
	  marker = character;
	  subvalue += character;
	  markerCount = 1;
	  queue = '';
	
	  while (++index < length) {
	    character = value.charAt(index);
	
	    if (character === marker) {
	      markerCount++;
	      subvalue += queue + marker;
	      queue = '';
	    } else if (character === C_SPACE) {
	      queue += character;
	    } else if (
	      markerCount >= THEMATIC_BREAK_MARKER_COUNT &&
	      (!character || character === C_NEWLINE)
	    ) {
	      subvalue += queue;
	
	      if (silent) {
	        return true;
	      }
	
	      return eat(subvalue)({type: 'thematicBreak'});
	    } else {
	      return;
	    }
	  }
	}


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var decode = __webpack_require__(55);
	var whitespace = __webpack_require__(14);
	var locate = __webpack_require__(392);
	
	module.exports = url;
	url.locator = locate;
	url.notInLink = true;
	
	var C_BRACKET_OPEN = '[';
	var C_BRACKET_CLOSE = ']';
	var C_PAREN_OPEN = '(';
	var C_PAREN_CLOSE = ')';
	var C_LT = '<';
	var C_AT_SIGN = '@';
	
	var HTTP_PROTOCOL = 'http://';
	var HTTPS_PROTOCOL = 'https://';
	var MAILTO_PROTOCOL = 'mailto:';
	
	var PROTOCOLS = [
	  HTTP_PROTOCOL,
	  HTTPS_PROTOCOL,
	  MAILTO_PROTOCOL
	];
	
	var PROTOCOLS_LENGTH = PROTOCOLS.length;
	
	function url(eat, value, silent) {
	  var self = this;
	  var subvalue;
	  var content;
	  var character;
	  var index;
	  var position;
	  var protocol;
	  var match;
	  var length;
	  var queue;
	  var parenCount;
	  var nextCharacter;
	  var exit;
	
	  if (!self.options.gfm) {
	    return;
	  }
	
	  subvalue = '';
	  index = -1;
	  length = PROTOCOLS_LENGTH;
	
	  while (++index < length) {
	    protocol = PROTOCOLS[index];
	    match = value.slice(0, protocol.length);
	
	    if (match.toLowerCase() === protocol) {
	      subvalue = match;
	      break;
	    }
	  }
	
	  if (!subvalue) {
	    return;
	  }
	
	  index = subvalue.length;
	  length = value.length;
	  queue = '';
	  parenCount = 0;
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (whitespace(character) || character === C_LT) {
	      break;
	    }
	
	    if (
	      character === '.' ||
	      character === ',' ||
	      character === ':' ||
	      character === ';' ||
	      character === '"' ||
	      character === '\'' ||
	      character === ')' ||
	      character === ']'
	    ) {
	      nextCharacter = value.charAt(index + 1);
	
	      if (!nextCharacter || whitespace(nextCharacter)) {
	        break;
	      }
	    }
	
	    if (character === C_PAREN_OPEN || character === C_BRACKET_OPEN) {
	      parenCount++;
	    }
	
	    if (character === C_PAREN_CLOSE || character === C_BRACKET_CLOSE) {
	      parenCount--;
	
	      if (parenCount < 0) {
	        break;
	      }
	    }
	
	    queue += character;
	    index++;
	  }
	
	  if (!queue) {
	    return;
	  }
	
	  subvalue += queue;
	  content = subvalue;
	
	  if (protocol === MAILTO_PROTOCOL) {
	    position = queue.indexOf(C_AT_SIGN);
	
	    if (position === -1 || position === length - 1) {
	      return;
	    }
	
	    content = content.substr(MAILTO_PROTOCOL.length);
	  }
	
	  /* istanbul ignore if - never used (yet) */
	  if (silent) {
	    return true;
	  }
	
	  exit = self.enterLink();
	  content = self.tokenizeInline(content, eat.now());
	  exit();
	
	  return eat(subvalue)({
	    type: 'link',
	    title: null,
	    url: decode(subvalue, {nonTerminated: false}),
	    children: content
	  });
	}


/***/ }),
/* 421 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = factory;
	
	var MERGEABLE_NODES = {
	  text: mergeText,
	  blockquote: mergeBlockquote
	};
	
	/* Check whether a node is mergeable with adjacent nodes. */
	function mergeable(node) {
	  var start;
	  var end;
	
	  if (node.type !== 'text' || !node.position) {
	    return true;
	  }
	
	  start = node.position.start;
	  end = node.position.end;
	
	  /* Only merge nodes which occupy the same size as their
	   * `value`. */
	  return start.line !== end.line ||
	      end.column - start.column === node.value.length;
	}
	
	/* Merge two text nodes: `node` into `prev`. */
	function mergeText(prev, node) {
	  prev.value += node.value;
	
	  return prev;
	}
	
	/* Merge two blockquotes: `node` into `prev`, unless in
	 * CommonMark mode. */
	function mergeBlockquote(prev, node) {
	  if (this.options.commonmark) {
	    return node;
	  }
	
	  prev.children = prev.children.concat(node.children);
	
	  return prev;
	}
	
	/* Construct a tokenizer.  This creates both
	 * `tokenizeInline` and `tokenizeBlock`. */
	function factory(type) {
	  return tokenize;
	
	  /* Tokenizer for a bound `type`. */
	  function tokenize(value, location) {
	    var self = this;
	    var offset = self.offset;
	    var tokens = [];
	    var methods = self[type + 'Methods'];
	    var tokenizers = self[type + 'Tokenizers'];
	    var line = location.line;
	    var column = location.column;
	    var index;
	    var length;
	    var method;
	    var name;
	    var matched;
	    var valueLength;
	
	    /* Trim white space only lines. */
	    if (!value) {
	      return tokens;
	    }
	
	    /* Expose on `eat`. */
	    eat.now = now;
	    eat.file = self.file;
	
	    /* Sync initial offset. */
	    updatePosition('');
	
	    /* Iterate over `value`, and iterate over all
	     * tokenizers.  When one eats something, re-iterate
	     * with the remaining value.  If no tokenizer eats,
	     * something failed (should not happen) and an
	     * exception is thrown. */
	    while (value) {
	      index = -1;
	      length = methods.length;
	      matched = false;
	
	      while (++index < length) {
	        name = methods[index];
	        method = tokenizers[name];
	
	        if (
	          method &&
	          /* istanbul ignore next */ (!method.onlyAtStart || self.atStart) &&
	          (!method.notInList || !self.inList) &&
	          (!method.notInBlock || !self.inBlock) &&
	          (!method.notInLink || !self.inLink)
	        ) {
	          valueLength = value.length;
	
	          method.apply(self, [eat, value]);
	
	          matched = valueLength !== value.length;
	
	          if (matched) {
	            break;
	          }
	        }
	      }
	
	      /* istanbul ignore if */
	      if (!matched) {
	        self.file.fail(new Error('Infinite loop'), eat.now());
	      }
	    }
	
	    self.eof = now();
	
	    return tokens;
	
	    /* Update line, column, and offset based on
	     * `value`. */
	    function updatePosition(subvalue) {
	      var lastIndex = -1;
	      var index = subvalue.indexOf('\n');
	
	      while (index !== -1) {
	        line++;
	        lastIndex = index;
	        index = subvalue.indexOf('\n', index + 1);
	      }
	
	      if (lastIndex === -1) {
	        column += subvalue.length;
	      } else {
	        column = subvalue.length - lastIndex;
	      }
	
	      if (line in offset) {
	        if (lastIndex !== -1) {
	          column += offset[line];
	        } else if (column <= offset[line]) {
	          column = offset[line] + 1;
	        }
	      }
	    }
	
	    /* Get offset.  Called before the first character is
	     * eaten to retrieve the range's offsets. */
	    function getOffset() {
	      var indentation = [];
	      var pos = line + 1;
	
	      /* Done.  Called when the last character is
	       * eaten to retrieve the range’s offsets. */
	      return function () {
	        var last = line + 1;
	
	        while (pos < last) {
	          indentation.push((offset[pos] || 0) + 1);
	
	          pos++;
	        }
	
	        return indentation;
	      };
	    }
	
	    /* Get the current position. */
	    function now() {
	      var pos = {line: line, column: column};
	
	      pos.offset = self.toOffset(pos);
	
	      return pos;
	    }
	
	    /* Store position information for a node. */
	    function Position(start) {
	      this.start = start;
	      this.end = now();
	    }
	
	    /* Throw when a value is incorrectly eaten.
	     * This shouldn’t happen but will throw on new,
	     * incorrect rules. */
	    function validateEat(subvalue) {
	      /* istanbul ignore if */
	      if (value.substring(0, subvalue.length) !== subvalue) {
	        /* Capture stack-trace. */
	        self.file.fail(
	          new Error(
	            'Incorrectly eaten value: please report this ' +
	            'warning on http://git.io/vg5Ft'
	          ),
	          now()
	        );
	      }
	    }
	
	    /* Mark position and patch `node.position`. */
	    function position() {
	      var before = now();
	
	      return update;
	
	      /* Add the position to a node. */
	      function update(node, indent) {
	        var prev = node.position;
	        var start = prev ? prev.start : before;
	        var combined = [];
	        var n = prev && prev.end.line;
	        var l = before.line;
	
	        node.position = new Position(start);
	
	        /* If there was already a `position`, this
	         * node was merged.  Fixing `start` wasn’t
	         * hard, but the indent is different.
	         * Especially because some information, the
	         * indent between `n` and `l` wasn’t
	         * tracked.  Luckily, that space is
	         * (should be?) empty, so we can safely
	         * check for it now. */
	        if (prev && indent && prev.indent) {
	          combined = prev.indent;
	
	          if (n < l) {
	            while (++n < l) {
	              combined.push((offset[n] || 0) + 1);
	            }
	
	            combined.push(before.column);
	          }
	
	          indent = combined.concat(indent);
	        }
	
	        node.position.indent = indent || [];
	
	        return node;
	      }
	    }
	
	    /* Add `node` to `parent`s children or to `tokens`.
	     * Performs merges where possible. */
	    function add(node, parent) {
	      var children = parent ? parent.children : tokens;
	      var prev = children[children.length - 1];
	
	      if (
	        prev &&
	        node.type === prev.type &&
	        node.type in MERGEABLE_NODES &&
	        mergeable(prev) &&
	        mergeable(node)
	      ) {
	        node = MERGEABLE_NODES[node.type].call(self, prev, node);
	      }
	
	      if (node !== prev) {
	        children.push(node);
	      }
	
	      if (self.atStart && tokens.length !== 0) {
	        self.exitStart();
	      }
	
	      return node;
	    }
	
	    /* Remove `subvalue` from `value`.
	     * `subvalue` must be at the start of `value`. */
	    function eat(subvalue) {
	      var indent = getOffset();
	      var pos = position();
	      var current = now();
	
	      validateEat(subvalue);
	
	      apply.reset = reset;
	      reset.test = test;
	      apply.test = test;
	
	      value = value.substring(subvalue.length);
	
	      updatePosition(subvalue);
	
	      indent = indent();
	
	      return apply;
	
	      /* Add the given arguments, add `position` to
	       * the returned node, and return the node. */
	      function apply(node, parent) {
	        return pos(add(pos(node), parent), indent);
	      }
	
	      /* Functions just like apply, but resets the
	       * content:  the line and column are reversed,
	       * and the eaten value is re-added.
	       * This is useful for nodes with a single
	       * type of content, such as lists and tables.
	       * See `apply` above for what parameters are
	       * expected. */
	      function reset() {
	        var node = apply.apply(null, arguments);
	
	        line = current.line;
	        column = current.column;
	        value = subvalue + value;
	
	        return node;
	      }
	
	      /* Test the position, after eating, and reverse
	       * to a not-eaten state. */
	      function test() {
	        var result = pos({});
	
	        line = current.line;
	        column = current.column;
	        value = subvalue + value;
	
	        return result.position;
	      }
	    }
	  }
	}


/***/ }),
/* 422 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = factory;
	
	/* Factory to de-escape a value, based on a list at `key`
	 * in `ctx`. */
	function factory(ctx, key) {
	  return unescape;
	
	  /* De-escape a string using the expression at `key`
	   * in `ctx`. */
	  function unescape(value) {
	    var prev = 0;
	    var index = value.indexOf('\\');
	    var escape = ctx[key];
	    var queue = [];
	    var character;
	
	    while (index !== -1) {
	      queue.push(value.slice(prev, index));
	      prev = index + 1;
	      character = value.charAt(prev);
	
	      /* If the following character is not a valid escape,
	       * add the slash. */
	      if (!character || escape.indexOf(character) === -1) {
	        queue.push('\\');
	      }
	
	      index = value.indexOf('\\', prev);
	    }
	
	    queue.push(value.slice(prev));
	
	    return queue.join('');
	  }
	}


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var trim = __webpack_require__(22);
	var repeat = __webpack_require__(16);
	var getIndent = __webpack_require__(200);
	
	module.exports = indentation;
	
	var C_SPACE = ' ';
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	
	/* Remove the minimum indent from every line in `value`.
	 * Supports both tab, spaced, and mixed indentation (as
	 * well as possible). */
	function indentation(value, maximum) {
	  var values = value.split(C_NEWLINE);
	  var position = values.length + 1;
	  var minIndent = Infinity;
	  var matrix = [];
	  var index;
	  var indentation;
	  var stops;
	  var padding;
	
	  values.unshift(repeat(C_SPACE, maximum) + '!');
	
	  while (position--) {
	    indentation = getIndent(values[position]);
	
	    matrix[position] = indentation.stops;
	
	    if (trim(values[position]).length === 0) {
	      continue;
	    }
	
	    if (indentation.indent) {
	      if (indentation.indent > 0 && indentation.indent < minIndent) {
	        minIndent = indentation.indent;
	      }
	    } else {
	      minIndent = Infinity;
	
	      break;
	    }
	  }
	
	  if (minIndent !== Infinity) {
	    position = values.length;
	
	    while (position--) {
	      stops = matrix[position];
	      index = minIndent;
	
	      while (index && !(index in stops)) {
	        index--;
	      }
	
	      if (
	        trim(values[position]).length !== 0 &&
	        minIndent &&
	        index !== minIndent
	      ) {
	        padding = C_TAB;
	      } else {
	        padding = '';
	      }
	
	      values[position] = padding + values[position].slice(
	        index in stops ? stops[index] + 1 : 0
	      );
	    }
	  }
	
	  values.shift();
	
	  return values.join(C_NEWLINE);
	}


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var unherit = __webpack_require__(208);
	var xtend = __webpack_require__(12);
	var Compiler = __webpack_require__(425);
	
	module.exports = stringify;
	stringify.Compiler = Compiler;
	
	function stringify(options) {
	  var Local = unherit(Compiler);
	  Local.prototype.options = xtend(Local.prototype.options, this.data('settings'), options);
	  this.Compiler = Local;
	}


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var xtend = __webpack_require__(12);
	var toggle = __webpack_require__(207);
	
	module.exports = Compiler;
	
	/* Construct a new compiler. */
	function Compiler(tree, file) {
	  this.inLink = false;
	  this.inTable = false;
	  this.tree = tree;
	  this.file = file;
	  this.options = xtend(this.options);
	  this.setOptions({});
	}
	
	var proto = Compiler.prototype;
	
	/* Enter and exit helpers. */
	proto.enterLink = toggle('inLink', false);
	proto.enterTable = toggle('inTable', false);
	proto.enterLinkReference = __webpack_require__(435);
	
	/* Configuration. */
	proto.options = __webpack_require__(202);
	proto.setOptions = __webpack_require__(433);
	
	proto.compile = __webpack_require__(429);
	proto.visit = __webpack_require__(430);
	proto.all = __webpack_require__(427);
	proto.block = __webpack_require__(428);
	proto.visitOrderedItems = __webpack_require__(431);
	proto.visitUnorderedItems = __webpack_require__(432);
	
	/* Expose visitors. */
	proto.visitors = {
	  root: __webpack_require__(455),
	  text: __webpack_require__(459),
	  heading: __webpack_require__(445),
	  paragraph: __webpack_require__(454),
	  blockquote: __webpack_require__(436),
	  list: __webpack_require__(453),
	  listItem: __webpack_require__(452),
	  inlineCode: __webpack_require__(449),
	  code: __webpack_require__(438),
	  html: __webpack_require__(446),
	  thematicBreak: __webpack_require__(460),
	  strong: __webpack_require__(456),
	  emphasis: __webpack_require__(441),
	  break: __webpack_require__(437),
	  delete: __webpack_require__(440),
	  link: __webpack_require__(451),
	  linkReference: __webpack_require__(450),
	  imageReference: __webpack_require__(447),
	  definition: __webpack_require__(439),
	  image: __webpack_require__(448),
	  footnote: __webpack_require__(444),
	  footnoteReference: __webpack_require__(443),
	  footnoteDefinition: __webpack_require__(442),
	  table: __webpack_require__(458),
	  tableCell: __webpack_require__(457)
	};


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var decimal = __webpack_require__(40);
	var alphanumeric = __webpack_require__(296);
	var whitespace = __webpack_require__(14);
	var escapes = __webpack_require__(131);
	var prefix = __webpack_require__(203);
	
	module.exports = factory;
	
	var BACKSLASH = '\\';
	var BULLETS = ['*', '-', '+'];
	var ALLIGNMENT = [':', '-', ' ', '|'];
	var entities = {'<': '&lt;', ':': '&#x3A;', '&': '&amp;', '|': '&#x7C;', '~': '&#x7E;'};
	
	/* Factory to escape characters. */
	function factory(options) {
	  return escape;
	
	  /* Escape punctuation characters in a node's value. */
	  function escape(value, node, parent) {
	    var self = this;
	    var gfm = options.gfm;
	    var commonmark = options.commonmark;
	    var pedantic = options.pedantic;
	    var markers = commonmark ? ['.', ')'] : ['.'];
	    var siblings = parent && parent.children;
	    var index = siblings && siblings.indexOf(node);
	    var prev = siblings && siblings[index - 1];
	    var next = siblings && siblings[index + 1];
	    var length = value.length;
	    var escapable = escapes(options);
	    var position = -1;
	    var queue = [];
	    var escaped = queue;
	    var afterNewLine;
	    var character;
	    var wordCharBefore;
	    var wordCharAfter;
	    var offset;
	    var replace;
	
	    if (prev) {
	      afterNewLine = text(prev) && /\n\s*$/.test(prev.value);
	    } else {
	      afterNewLine = !parent || parent.type === 'root' || parent.type === 'paragraph';
	    }
	
	    function one(character) {
	      return escapable.indexOf(character) === -1 ?
	        entities[character] : BACKSLASH + character;
	    }
	
	    while (++position < length) {
	      character = value.charAt(position);
	      replace = false;
	
	      if (character === '\n') {
	        afterNewLine = true;
	      } else if (
	        character === BACKSLASH ||
	        character === '`' ||
	        character === '*' ||
	        character === '[' ||
	        character === '<' ||
	        (character === '&' && prefix(value.slice(position)) > 0) ||
	        (character === ']' && self.inLink) ||
	        (gfm && character === '~' && value.charAt(position + 1) === '~') ||
	        (gfm && character === '|' && (self.inTable || alignment(value, position))) ||
	        (
	          character === '_' &&
	          /* Delegate leading/trailing underscores
	           * to the multinode version below. */
	          position > 0 &&
	          position < length - 1 &&
	          (
	              pedantic ||
	              !alphanumeric(value.charAt(position - 1)) ||
	              !alphanumeric(value.charAt(position + 1))
	          )
	        ) ||
	        (gfm && !self.inLink && character === ':' && protocol(queue.join('')))
	      ) {
	        replace = true;
	      } else if (afterNewLine) {
	        if (
	          character === '>' ||
	          character === '#' ||
	          BULLETS.indexOf(character) !== -1
	        ) {
	          replace = true;
	        } else if (decimal(character)) {
	          offset = position + 1;
	
	          while (offset < length) {
	            if (!decimal(value.charAt(offset))) {
	              break;
	            }
	
	            offset++;
	          }
	
	          if (markers.indexOf(value.charAt(offset)) !== -1) {
	            next = value.charAt(offset + 1);
	
	            if (!next || next === ' ' || next === '\t' || next === '\n') {
	              queue.push(value.slice(position, offset));
	              position = offset;
	              character = value.charAt(position);
	              replace = true;
	            }
	          }
	        }
	      }
	
	      if (afterNewLine && !whitespace(character)) {
	        afterNewLine = false;
	      }
	
	      queue.push(replace ? one(character) : character);
	    }
	
	    /* Multi-node versions. */
	    if (siblings && text(node)) {
	      /* Check for an opening parentheses after a
	       * link-reference (which can be joined by
	       * white-space). */
	      if (prev && prev.referenceType === 'shortcut') {
	        position = -1;
	        length = escaped.length;
	
	        while (++position < length) {
	          character = escaped[position];
	
	          if (character === ' ' || character === '\t') {
	            continue;
	          }
	
	          if (character === '(' || character === ':') {
	            escaped[position] = one(character);
	          }
	
	          break;
	        }
	
	        /* If the current node is all spaces / tabs,
	         * preceded by a shortcut, and followed by
	         * a text starting with `(`, escape it. */
	        if (
	          text(next) &&
	          position === length &&
	          next.value.charAt(0) === '('
	        ) {
	          escaped.push(BACKSLASH);
	        }
	      }
	
	      /* Ensure non-auto-links are not seen as links.
	       * This pattern needs to check the preceding
	       * nodes too. */
	      if (
	        gfm &&
	        !self.inLink &&
	        text(prev) &&
	        value.charAt(0) === ':' &&
	        protocol(prev.value.slice(-6))
	      ) {
	        escaped[0] = one(':');
	      }
	
	      /* Escape ampersand if it would otherwise
	       * start an entity. */
	      if (
	        text(next) &&
	        value.charAt(length - 1) === '&' &&
	        prefix('&' + next.value) !== 0
	      ) {
	        escaped[escaped.length - 1] = one('&');
	      }
	
	      /* Escape double tildes in GFM. */
	      if (
	        gfm &&
	        text(next) &&
	        value.charAt(length - 1) === '~' &&
	        next.value.charAt(0) === '~'
	      ) {
	        escaped.splice(escaped.length - 1, 0, BACKSLASH);
	      }
	
	      /* Escape underscores, but not mid-word (unless
	       * in pedantic mode). */
	      wordCharBefore = text(prev) && alphanumeric(prev.value.slice(-1));
	      wordCharAfter = text(next) && alphanumeric(next.value.charAt(0));
	
	      if (length === 1) {
	        if (value === '_' && (pedantic || !wordCharBefore || !wordCharAfter)) {
	          escaped.unshift(BACKSLASH);
	        }
	      } else {
	        if (
	          value.charAt(0) === '_' &&
	          (pedantic || !wordCharBefore || !alphanumeric(value.charAt(1)))
	        ) {
	          escaped.unshift(BACKSLASH);
	        }
	
	        if (
	          value.charAt(length - 1) === '_' &&
	          (pedantic || !wordCharAfter || !alphanumeric(value.charAt(length - 2)))
	        ) {
	          escaped.splice(escaped.length - 1, 0, BACKSLASH);
	        }
	      }
	    }
	
	    return escaped.join('');
	  }
	}
	
	/* Check if `index` in `value` is inside an alignment row. */
	function alignment(value, index) {
	  var start = value.lastIndexOf('\n', index);
	  var end = value.indexOf('\n', index);
	
	  start = start === -1 ? -1 : start;
	  end = end === -1 ? value.length : end;
	
	  while (++start < end) {
	    if (ALLIGNMENT.indexOf(value.charAt(start)) === -1) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	/* Check if `node` is a text node. */
	function text(node) {
	  return node && node.type === 'text';
	}
	
	/* Check if `value` ends in a protocol. */
	function protocol(value) {
	  var val = value.slice(-6).toLowerCase();
	  return val === 'mailto' || val.slice(-5) === 'https' || val.slice(-4) === 'http';
	}


/***/ }),
/* 427 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = all;
	
	/* Visit all children of `parent`. */
	function all(parent) {
	  var self = this;
	  var children = parent.children;
	  var length = children.length;
	  var results = [];
	  var index = -1;
	
	  while (++index < length) {
	    results[index] = self.visit(children[index], parent);
	  }
	
	  return results;
	}


/***/ }),
/* 428 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = block;
	
	/* Stringify a block node with block children (e.g., `root`
	 * or `blockquote`).
	 * Knows about code following a list, or adjacent lists
	 * with similar bullets, and places an extra newline
	 * between them. */
	function block(node) {
	  var self = this;
	  var values = [];
	  var children = node.children;
	  var length = children.length;
	  var index = -1;
	  var child;
	  var prev;
	
	  while (++index < length) {
	    child = children[index];
	
	    if (prev) {
	      /* Duplicate nodes, such as a list
	       * directly following another list,
	       * often need multiple new lines.
	       *
	       * Additionally, code blocks following a list
	       * might easily be mistaken for a paragraph
	       * in the list itself. */
	      if (child.type === prev.type && prev.type === 'list') {
	        values.push(prev.ordered === child.ordered ? '\n\n\n' : '\n\n');
	      } else if (prev.type === 'list' && child.type === 'code' && !child.lang) {
	        values.push('\n\n\n');
	      } else {
	        values.push('\n\n');
	      }
	    }
	
	    values.push(self.visit(child, node));
	
	    prev = child;
	  }
	
	  return values.join('');
	}


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var compact = __webpack_require__(312);
	
	module.exports = compile;
	
	/* Stringify the given tree. */
	function compile() {
	  return this.visit(compact(this.tree, this.options.commonmark));
	}


/***/ }),
/* 430 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = one;
	
	function one(node, parent) {
	  var self = this;
	  var visitors = self.visitors;
	
	  /* Fail on unknown nodes. */
	  if (typeof visitors[node.type] !== 'function') {
	    self.file.fail(
	      new Error(
	        'Missing compiler for node of type `' +
	        node.type + '`: `' + node + '`'
	      ),
	      node
	    );
	  }
	
	  return visitors[node.type].call(self, node, parent);
	}


/***/ }),
/* 431 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = orderedItems;
	
	/* Visit ordered list items.
	 *
	 * Starts the list with
	 * `node.start` and increments each following list item
	 * bullet by one:
	 *
	 *     2. foo
	 *     3. bar
	 *
	 * In `incrementListMarker: false` mode, does not increment
	 * each marker and stays on `node.start`:
	 *
	 *     1. foo
	 *     1. bar
	 */
	function orderedItems(node) {
	  var self = this;
	  var fn = self.visitors.listItem;
	  var increment = self.options.incrementListMarker;
	  var values = [];
	  var start = node.start;
	  var children = node.children;
	  var length = children.length;
	  var index = -1;
	  var bullet;
	
	  while (++index < length) {
	    bullet = (increment ? start + index : start) + '.';
	    values[index] = fn.call(self, children[index], node, index, bullet);
	  }
	
	  return values.join('\n');
	}


/***/ }),
/* 432 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = unorderedItems;
	
	/* Visit unordered list items.
	 * Uses `options.bullet` as each item's bullet.
	 */
	function unorderedItems(node) {
	  var self = this;
	  var bullet = self.options.bullet;
	  var fn = self.visitors.listItem;
	  var children = node.children;
	  var length = children.length;
	  var index = -1;
	  var values = [];
	
	  while (++index < length) {
	    values[index] = fn.call(self, children[index], node, index, bullet);
	  }
	
	  return values.join('\n');
	}


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var xtend = __webpack_require__(12);
	var encode = __webpack_require__(87);
	var defaults = __webpack_require__(202);
	var escapeFactory = __webpack_require__(426);
	var returner = __webpack_require__(206);
	
	module.exports = setOptions;
	
	/* Map of applicable enum's. */
	var maps = {
	  entities: {true: true, false: true, numbers: true, escape: true},
	  bullet: {'*': true, '-': true, '+': true},
	  rule: {'-': true, _: true, '*': true},
	  listItemIndent: {tab: true, mixed: true, 1: true},
	  emphasis: {_: true, '*': true},
	  strong: {_: true, '*': true},
	  fence: {'`': true, '~': true}
	};
	
	/* Expose `validate`. */
	var validate = {
	  boolean: validateBoolean,
	  string: validateString,
	  number: validateNumber,
	  function: validateFunction
	};
	
	/* Set options.  Does not overwrite previously set
	 * options. */
	function setOptions(options) {
	  var self = this;
	  var current = self.options;
	  var ruleRepetition;
	  var key;
	
	  if (options == null) {
	    options = {};
	  } else if (typeof options === 'object') {
	    options = xtend(options);
	  } else {
	    throw new Error('Invalid value `' + options + '` for setting `options`');
	  }
	
	  for (key in defaults) {
	    validate[typeof defaults[key]](options, key, current[key], maps[key]);
	  }
	
	  ruleRepetition = options.ruleRepetition;
	
	  if (ruleRepetition && ruleRepetition < 3) {
	    raise(ruleRepetition, 'options.ruleRepetition');
	  }
	
	  self.encode = encodeFactory(String(options.entities));
	  self.escape = escapeFactory(options);
	
	  self.options = options;
	
	  return self;
	}
	
	/* Throw an exception with in its `message` `value`
	 * and `name`. */
	function raise(value, name) {
	  throw new Error('Invalid value `' + value + '` for setting `' + name + '`');
	}
	
	/* Validate a value to be boolean. Defaults to `def`.
	 * Raises an exception with `context[name]` when not
	 * a boolean. */
	function validateBoolean(context, name, def) {
	  var value = context[name];
	
	  if (value == null) {
	    value = def;
	  }
	
	  if (typeof value !== 'boolean') {
	    raise(value, 'options.' + name);
	  }
	
	  context[name] = value;
	}
	
	/* Validate a value to be boolean. Defaults to `def`.
	 * Raises an exception with `context[name]` when not
	 * a boolean. */
	function validateNumber(context, name, def) {
	  var value = context[name];
	
	  if (value == null) {
	    value = def;
	  }
	
	  if (isNaN(value)) {
	    raise(value, 'options.' + name);
	  }
	
	  context[name] = value;
	}
	
	/* Validate a value to be in `map`. Defaults to `def`.
	 * Raises an exception with `context[name]` when not
	 * in `map`. */
	function validateString(context, name, def, map) {
	  var value = context[name];
	
	  if (value == null) {
	    value = def;
	  }
	
	  value = String(value);
	
	  if (!(value in map)) {
	    raise(value, 'options.' + name);
	  }
	
	  context[name] = value;
	}
	
	/* Validate a value to be function. Defaults to `def`.
	 * Raises an exception with `context[name]` when not
	 * a function. */
	function validateFunction(context, name, def) {
	  var value = context[name];
	
	  if (value == null) {
	    value = def;
	  }
	
	  if (typeof value !== 'function') {
	    raise(value, 'options.' + name);
	  }
	
	  context[name] = value;
	}
	
	/* Factory to encode HTML entities.
	 * Creates a no-operation function when `type` is
	 * `'false'`, a function which encodes using named
	 * references when `type` is `'true'`, and a function
	 * which encodes using numbered references when `type` is
	 * `'numbers'`. */
	function encodeFactory(type) {
	  var options = {};
	
	  if (type === 'false') {
	    return returner;
	  }
	
	  if (type === 'true') {
	    options.useNamedReferences = true;
	  }
	
	  if (type === 'escape') {
	    options.escapeOnly = true;
	    options.useNamedReferences = true;
	  }
	
	  return wrapped;
	
	  /* Encode HTML entities using the bound options. */
	  function wrapped(value) {
	    return encode(value, options);
	  }
	}


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var entityPrefixLength = __webpack_require__(203);
	
	module.exports = copy;
	
	var PUNCTUATION = /[-!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~_]/;
	
	/* For shortcut and collapsed reference links, the contents
	 * is also an identifier, so we need to restore the original
	 * encoding and escaping that were present in the source
	 * string.
	 *
	 * This function takes the unescaped & unencoded value from
	 * shortcut's child nodes and the identifier and encodes
	 * the former according to the latter. */
	function copy(value, identifier) {
	  var length = value.length;
	  var count = identifier.length;
	  var result = [];
	  var position = 0;
	  var index = 0;
	  var start;
	
	  while (index < length) {
	    /* Take next non-punctuation characters from `value`. */
	    start = index;
	
	    while (index < length && !PUNCTUATION.test(value.charAt(index))) {
	      index += 1;
	    }
	
	    result.push(value.slice(start, index));
	
	    /* Advance `position` to the next punctuation character. */
	    while (position < count && !PUNCTUATION.test(identifier.charAt(position))) {
	      position += 1;
	    }
	
	    /* Take next punctuation characters from `identifier`. */
	    start = position;
	
	    while (position < count && PUNCTUATION.test(identifier.charAt(position))) {
	      if (identifier.charAt(position) === '&') {
	        position += entityPrefixLength(identifier.slice(position));
	      }
	
	      position += 1;
	    }
	
	    result.push(identifier.slice(start, position));
	
	    /* Advance `index` to the next non-punctuation character. */
	    while (index < length && PUNCTUATION.test(value.charAt(index))) {
	      index += 1;
	    }
	  }
	
	  return result.join('');
	}


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var returner = __webpack_require__(206);
	
	module.exports = enter;
	
	/* Shortcut and collapsed link references need no escaping
	 * and encoding during the processing of child nodes (it
	 * must be implied from identifier).
	 *
	 * This toggler turns encoding and escaping off for shortcut
	 * and collapsed references.
	 *
	 * Implies `enterLink`.
	 */
	function enter(compiler, node) {
	  var encode = compiler.encode;
	  var escape = compiler.escape;
	  var exit = compiler.enterLink();
	
	  if (
	    node.referenceType !== 'shortcut' &&
	    node.referenceType !== 'collapsed'
	  ) {
	    return exit;
	  }
	
	  compiler.escape = returner;
	  compiler.encode = returner;
	
	  return function () {
	    compiler.encode = encode;
	    compiler.escape = escape;
	    exit();
	  };
	}


/***/ }),
/* 436 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = blockquote;
	
	function blockquote(node) {
	  var values = this.block(node).split('\n');
	  var result = [];
	  var length = values.length;
	  var index = -1;
	  var value;
	
	  while (++index < length) {
	    value = values[index];
	    result[index] = (value ? ' ' : '') + value;
	  }
	
	  return '>' + result.join('\n>');
	}


/***/ }),
/* 437 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = lineBreak;
	
	var map = {true: '\\\n', false: '  \n'};
	
	function lineBreak() {
	  return map[this.options.commonmark];
	}


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var streak = __webpack_require__(130);
	var repeat = __webpack_require__(16);
	var pad = __webpack_require__(205);
	
	module.exports = code;
	
	/* Stringify code.
	 * Creates indented code when:
	 *
	 * - No language tag exists;
	 * - Not in `fences: true` mode;
	 * - A non-empty value exists.
	 *
	 * Otherwise, GFM fenced code is created:
	 *
	 *     ```js
	 *     foo();
	 *     ```
	 *
	 * When in ``fence: `~` `` mode, uses tildes as fences:
	 *
	 *     ~~~js
	 *     foo();
	 *     ~~~
	 *
	 * Knows about internal fences:
	 *
	 *     ````markdown
	 *     ```javascript
	 *     foo();
	 *     ```
	 *     ````
	 */
	function code(node, parent) {
	  var self = this;
	  var value = node.value;
	  var options = self.options;
	  var marker = options.fence;
	  var language = self.encode(node.lang || '', node);
	  var fence;
	
	  /* Without (needed) fences. */
	  if (!language && !options.fences && value) {
	    /* Throw when pedantic, in a list item which
	     * isn’t compiled using a tab. */
	    if (
	      parent &&
	      parent.type === 'listItem' &&
	      options.listItemIndent !== 'tab' &&
	      options.pedantic
	    ) {
	      self.file.fail('Cannot indent code properly. See http://git.io/vgFvT', node.position);
	    }
	
	    return pad(value, 1);
	  }
	
	  fence = repeat(marker, Math.max(streak(value, marker) + 1, 3));
	
	  return fence + language + '\n' + value + '\n' + fence;
	}


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var uri = __webpack_require__(86);
	var title = __webpack_require__(85);
	
	module.exports = definition;
	
	/* Stringify an URL definition.
	 *
	 * Is smart about enclosing `url` (see `encloseURI()`) and
	 * `title` (see `encloseTitle()`).
	 *
	 *    [foo]: <foo at bar dot com> 'An "example" e-mail'
	 */
	function definition(node) {
	  var content = uri(node.url);
	
	  if (node.title) {
	    content += ' ' + title(node.title);
	  }
	
	  return '[' + node.identifier + ']: ' + content;
	}


/***/ }),
/* 440 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = strikethrough;
	
	function strikethrough(node) {
	  return '~~' + this.all(node).join('') + '~~';
	}


/***/ }),
/* 441 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = emphasis;
	
	/* Stringify an `emphasis`.
	 *
	 * The marker used is configurable through `emphasis`, which
	 * defaults to an underscore (`'_'`) but also accepts an
	 * asterisk (`'*'`):
	 *
	 *     *foo*
	 */
	function emphasis(node) {
	  var marker = this.options.emphasis;
	  return marker + this.all(node).join('') + marker;
	}


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var repeat = __webpack_require__(16);
	
	module.exports = footnoteDefinition;
	
	function footnoteDefinition(node) {
	  var id = node.identifier.toLowerCase();
	  var content = this.all(node).join('\n\n' + repeat(' ', 4));
	
	  return '[^' + id + ']: ' + content;
	}


/***/ }),
/* 443 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = footnoteReference;
	
	function footnoteReference(node) {
	  return '[^' + node.identifier + ']';
	}


/***/ }),
/* 444 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = footnote;
	
	function footnote(node) {
	  return '[^' + this.all(node).join('') + ']';
	}


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var repeat = __webpack_require__(16);
	
	module.exports = heading;
	
	/* Stringify a heading.
	 *
	 * In `setext: true` mode and when `depth` is smaller than
	 * three, creates a setext header:
	 *
	 *     Foo
	 *     ===
	 *
	 * Otherwise, an ATX header is generated:
	 *
	 *     ### Foo
	 *
	 * In `closeAtx: true` mode, the header is closed with
	 * hashes:
	 *
	 *     ### Foo ###
	 */
	function heading(node) {
	  var self = this;
	  var depth = node.depth;
	  var setext = self.options.setext;
	  var closeAtx = self.options.closeAtx;
	  var content = self.all(node).join('');
	  var prefix;
	
	  if (setext && depth < 3) {
	    return content + '\n' + repeat(depth === 1 ? '=' : '-', content.length);
	  }
	
	  prefix = repeat('#', node.depth);
	
	  return prefix + ' ' + content + (closeAtx ? ' ' + prefix : '');
	}


/***/ }),
/* 446 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = html;
	
	function html(node) {
	  return node.value;
	}


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var label = __webpack_require__(204);
	
	module.exports = imageReference;
	
	function imageReference(node) {
	  return '![' + (this.encode(node.alt, node) || '') + ']' + label(node);
	}


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var uri = __webpack_require__(86);
	var title = __webpack_require__(85);
	
	module.exports = image;
	
	/* Stringify an image.
	 *
	 * Is smart about enclosing `url` (see `encloseURI()`) and
	 * `title` (see `encloseTitle()`).
	 *
	 *    ![foo](</fav icon.png> 'My "favourite" icon')
	 *
	 * Supports named entities in `url`, `alt`, and `title`
	 * when in `settings.encode` mode.
	 */
	function image(node) {
	  var self = this;
	  var content = uri(self.encode(node.url || '', node));
	  var exit = self.enterLink();
	  var alt = self.encode(self.escape(node.alt || '', node));
	
	  exit();
	
	  if (node.title) {
	    content += ' ' + title(self.encode(node.title, node));
	  }
	
	  return '![' + alt + '](' + content + ')';
	}


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var streak = __webpack_require__(130);
	var repeat = __webpack_require__(16);
	
	module.exports = inlineCode;
	
	/* Stringify inline code.
	 *
	 * Knows about internal ticks (`\``), and ensures one more
	 * tick is used to enclose the inline code:
	 *
	 *     ```foo ``bar`` baz```
	 *
	 * Even knows about inital and final ticks:
	 *
	 *     `` `foo ``
	 *     `` foo` ``
	 */
	function inlineCode(node) {
	  var value = node.value;
	  var ticks = repeat('`', streak(value, '`') + 1);
	  var start = ticks;
	  var end = ticks;
	
	  if (value.charAt(0) === '`') {
	    start += ' ';
	  }
	
	  if (value.charAt(value.length - 1) === '`') {
	    end = ' ' + end;
	  }
	
	  return start + value + end;
	}


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var copy = __webpack_require__(434);
	var label = __webpack_require__(204);
	
	module.exports = linkReference;
	
	function linkReference(node) {
	  var self = this;
	  var type = node.referenceType;
	  var exit = self.enterLinkReference(self, node);
	  var value = self.all(node).join('');
	
	  exit();
	
	  if (type === 'shortcut' || type === 'collapsed') {
	    value = copy(value, node.identifier);
	  }
	
	  return '[' + value + ']' + label(node);
	}


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var uri = __webpack_require__(86);
	var title = __webpack_require__(85);
	
	module.exports = link;
	
	/* Expression for a protocol:
	 * http://en.wikipedia.org/wiki/URI_scheme#Generic_syntax */
	var PROTOCOL = /^[a-z][a-z+.-]+:\/?/i;
	
	/* Stringify a link.
	 *
	 * When no title exists, the compiled `children` equal
	 * `url`, and `url` starts with a protocol, an auto
	 * link is created:
	 *
	 *     <http://example.com>
	 *
	 * Otherwise, is smart about enclosing `url` (see
	 * `encloseURI()`) and `title` (see `encloseTitle()`).
	 *
	 *    [foo](<foo at bar dot com> 'An "example" e-mail')
	 *
	 * Supports named entities in the `url` and `title` when
	 * in `settings.encode` mode. */
	function link(node) {
	  var self = this;
	  var content = self.encode(node.url || '', node);
	  var exit = self.enterLink();
	  var escaped = self.encode(self.escape(node.url || '', node));
	  var value = self.all(node).join('');
	
	  exit();
	
	  if (
	    node.title == null &&
	    PROTOCOL.test(content) &&
	    (escaped === value || escaped === 'mailto:' + value)
	  ) {
	    /* Backslash escapes do not work in autolinks,
	     * so we do not escape. */
	    return uri(self.encode(node.url), true);
	  }
	
	  content = uri(content);
	
	  if (node.title) {
	    content += ' ' + title(self.encode(self.escape(node.title, node), node));
	  }
	
	  return '[' + value + '](' + content + ')';
	}


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var repeat = __webpack_require__(16);
	var pad = __webpack_require__(205);
	
	module.exports = listItem;
	
	/* Which checkbox to use. */
	var CHECKBOX_MAP = {
	  undefined: '',
	  null: '',
	  true: '[x] ',
	  false: '[ ] '
	};
	
	/* Stringify a list item.
	 *
	 * Prefixes the content with a checked checkbox when
	 * `checked: true`:
	 *
	 *     [x] foo
	 *
	 * Prefixes the content with an unchecked checkbox when
	 * `checked: false`:
	 *
	 *     [ ] foo
	 */
	function listItem(node, parent, position, bullet) {
	  var self = this;
	  var style = self.options.listItemIndent;
	  var loose = node.loose;
	  var children = node.children;
	  var length = children.length;
	  var values = [];
	  var index = -1;
	  var value;
	  var indent;
	  var spacing;
	
	  while (++index < length) {
	    values[index] = self.visit(children[index], node);
	  }
	
	  value = CHECKBOX_MAP[node.checked] + values.join(loose ? '\n\n' : '\n');
	
	  if (style === '1' || (style === 'mixed' && value.indexOf('\n') === -1)) {
	    indent = bullet.length + 1;
	    spacing = ' ';
	  } else {
	    indent = Math.ceil((bullet.length + 1) / 4) * 4;
	    spacing = repeat(' ', indent - bullet.length);
	  }
	
	  value = bullet + spacing + pad(value, indent / 4).slice(indent);
	
	  if (loose && parent.children.length - 1 !== position) {
	    value += '\n';
	  }
	
	  return value;
	}


/***/ }),
/* 453 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = list;
	
	/* Which method to use based on `list.ordered`. */
	var ORDERED_MAP = {
	  true: 'visitOrderedItems',
	  false: 'visitUnorderedItems'
	};
	
	function list(node) {
	  return this[ORDERED_MAP[node.ordered]](node);
	}


/***/ }),
/* 454 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = paragraph;
	
	function paragraph(node) {
	  return this.all(node).join('');
	}


/***/ }),
/* 455 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = root;
	
	/* Stringify a root.
	 * Adds a final newline to ensure valid POSIX files. */
	function root(node) {
	  return this.block(node) + '\n';
	}


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var repeat = __webpack_require__(16);
	
	module.exports = strong;
	
	/* Stringify a `strong`.
	 *
	 * The marker used is configurable by `strong`, which
	 * defaults to an asterisk (`'*'`) but also accepts an
	 * underscore (`'_'`):
	 *
	 *     __foo__
	 */
	function strong(node) {
	  var marker = repeat(this.options.strong, 2);
	  return marker + this.all(node).join('') + marker;
	}


/***/ }),
/* 457 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = tableCell;
	
	function tableCell(node) {
	  return this.all(node).join('');
	}


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var markdownTable = __webpack_require__(310);
	
	module.exports = table;
	
	/* Stringify table.
	 *
	 * Creates a fenced table by default, but not in
	 * `looseTable: true` mode:
	 *
	 *     Foo | Bar
	 *     :-: | ---
	 *     Baz | Qux
	 *
	 * NOTE: Be careful with `looseTable: true` mode, as a
	 * loose table inside an indented code block on GitHub
	 * renders as an actual table!
	 *
	 * Creates a spaced table by default, but not in
	 * `spacedTable: false`:
	 *
	 *     |Foo|Bar|
	 *     |:-:|---|
	 *     |Baz|Qux|
	 */
	function table(node) {
	  var self = this;
	  var options = self.options;
	  var loose = options.looseTable;
	  var spaced = options.spacedTable;
	  var pad = options.paddedTable;
	  var stringLength = options.stringLength;
	  var rows = node.children;
	  var index = rows.length;
	  var exit = self.enterTable();
	  var result = [];
	  var start;
	  var end;
	
	  while (index--) {
	    result[index] = self.all(rows[index]);
	  }
	
	  exit();
	
	  if (loose) {
	    start = '';
	    end = '';
	  } else if (spaced) {
	    start = '| ';
	    end = ' |';
	  } else {
	    start = '|';
	    end = '|';
	  }
	
	  return markdownTable(result, {
	    align: node.align,
	    pad: pad,
	    start: start,
	    end: end,
	    stringLength: stringLength,
	    delimiter: spaced ? ' | ' : '|'
	  });
	}


/***/ }),
/* 459 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = text;
	
	/* Stringify text.
	 * Supports named entities in `settings.encode: true` mode:
	 *
	 *     AT&amp;T
	 *
	 * Supports numbered entities in `settings.encode: numbers`
	 * mode:
	 *
	 *     AT&#x26;T
	 */
	function text(node, parent) {
	  return this.encode(this.escape(node.value, node, parent), node);
	}


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var repeat = __webpack_require__(16);
	
	module.exports = thematic;
	
	/* Stringify a `thematic-break`.
	 * The character used is configurable through `rule`: (`'_'`)
	 *
	 *     ___
	 *
	 * The number of repititions is defined through
	 * `ruleRepetition`: (`6`)
	 *
	 *     ******
	 *
	 * Whether spaces delimit each character, is configured
	 * through `ruleSpaces`: (`true`)
	 *
	 *     * * *
	 */
	function thematic() {
	  var options = this.options;
	  var rule = repeat(options.rule, options.ruleRepetition);
	  return options.ruleSpaces ? rule.split('').join(' ') : rule;
	}


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(37)))

/***/ }),
/* 462 */
/***/ (function(module, exports) {

	
	/**
	 * An Array.prototype.slice.call(arguments) alternative
	 *
	 * @param {Object} args something with a length
	 * @param {Number} slice
	 * @param {Number} sliceEnd
	 * @api public
	 */
	
	module.exports = function (args, slice, sliceEnd) {
	  var ret = [];
	  var len = args.length;
	
	  if (0 === len) return ret;
	
	  var start = slice < 0
	    ? Math.max(0, slice + len)
	    : slice || 0;
	
	  if (sliceEnd !== undefined) {
	    len = sliceEnd < 0
	      ? sliceEnd + len
	      : sliceEnd
	  }
	
	  while (len-- > start) {
	    ret[len - start] = args[len];
	  }
	
	  return ret;
	}
	


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var trim = __webpack_require__(22)
	
	exports.parse = parse
	exports.stringify = stringify
	
	var empty = ''
	var space = ' '
	var whiteSpace = /[ \t\n\r\f]+/g
	
	function parse(value) {
	  var input = trim(String(value || empty))
	  return input === empty ? [] : input.split(whiteSpace)
	}
	
	function stringify(values) {
	  return trim(values.join(space))
	}


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
	            (typeof self !== "undefined" && self) ||
	            window;
	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(scope, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(461);
	// On some exotic environments, it's not clear which object `setimmediate` was
	// able to install onto.  Search each possibility in the same order as the
	// `setimmediate` library.
	exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
	                       (typeof global !== "undefined" && global.setImmediate) ||
	                       (this && this.setImmediate);
	exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
	                         (typeof global !== "undefined" && global.clearImmediate) ||
	                         (this && this.clearImmediate);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 465 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = trimLines
	
	var ws = /[ \t]*\n+[ \t]*/g
	var newline = '\n'
	
	function trimLines(value) {
	  return String(value).replace(ws, newline)
	}


/***/ }),
/* 466 */
/***/ (function(module, exports) {

	'use strict'
	
	/* Expose. */
	module.exports = trough
	
	/* Methods. */
	var slice = [].slice
	
	/* Create new middleware. */
	function trough() {
	  var fns = []
	  var middleware = {}
	
	  middleware.run = run
	  middleware.use = use
	
	  return middleware
	
	  /* Run `fns`.  Last argument must be
	   * a completion handler. */
	  function run() {
	    var index = -1
	    var input = slice.call(arguments, 0, -1)
	    var done = arguments[arguments.length - 1]
	
	    if (typeof done !== 'function') {
	      throw new Error('Expected function as last argument, not ' + done)
	    }
	
	    next.apply(null, [null].concat(input))
	
	    /* Run the next `fn`, if any. */
	    function next(err) {
	      var fn = fns[++index]
	      var params = slice.call(arguments, 0)
	      var values = params.slice(1)
	      var length = input.length
	      var pos = -1
	
	      if (err) {
	        done(err)
	        return
	      }
	
	      /* Copy non-nully input into values. */
	      while (++pos < length) {
	        if (values[pos] === null || values[pos] === undefined) {
	          values[pos] = input[pos]
	        }
	      }
	
	      input = values
	
	      /* Next or done. */
	      if (fn) {
	        wrap(fn, next).apply(null, input)
	      } else {
	        done.apply(null, [null].concat(input))
	      }
	    }
	  }
	
	  /* Add `fn` to the list. */
	  function use(fn) {
	    if (typeof fn !== 'function') {
	      throw new Error('Expected `fn` to be a function, not ' + fn)
	    }
	
	    fns.push(fn)
	
	    return middleware
	  }
	}
	
	/* Wrap `fn`.  Can be sync or async; return a promise,
	 * receive a completion handler, return new values and
	 * errors. */
	function wrap(fn, next) {
	  var invoked
	
	  return wrapped
	
	  function wrapped() {
	    var params = slice.call(arguments, 0)
	    var callback = fn.length > params.length
	    var result
	
	    if (callback) {
	      params.push(done)
	    }
	
	    try {
	      result = fn.apply(null, params)
	    } catch (err) {
	      /* Well, this is quite the pickle.  `fn` received
	       * a callback and invoked it (thus continuing the
	       * pipeline), but later also threw an error.
	       * We’re not about to restart the pipeline again,
	       * so the only thing left to do is to throw the
	       * thing instea. */
	      if (callback && invoked) {
	        throw err
	      }
	
	      return done(err)
	    }
	
	    if (!callback) {
	      if (result && typeof result.then === 'function') {
	        result.then(then, done)
	      } else if (result instanceof Error) {
	        done(result)
	      } else {
	        then(result)
	      }
	    }
	  }
	
	  /* Invoke `next`, only once. */
	  function done() {
	    if (!invoked) {
	      invoked = true
	
	      next.apply(null, arguments)
	    }
	  }
	
	  /* Invoke `done` with one value.
	   * Tracks if an error is passed, too. */
	  function then(value) {
	    done(null, value)
	  }
	}


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var trim = __webpack_require__(22)
	var location = __webpack_require__(89)
	var visit = __webpack_require__(6)
	
	/* Map of allowed verbs. */
	var ALLOWED_VERBS = {
	  enable: true,
	  disable: true,
	  ignore: true
	}
	
	module.exports = messageControl
	
	function messageControl(options) {
	  var name = options && options.name
	  var marker = options && options.marker
	  var test = options && options.test
	  var sources
	  var known
	  var reset
	  var enable
	  var disable
	
	  if (!name) {
	    throw new Error('Expected `name` in `options`, got `' + name + '`')
	  }
	
	  if (!marker) {
	    throw new Error('Expected `name` in `options`, got `' + name + '`')
	  }
	
	  if (!test) {
	    throw new Error('Expected `test` in `options`, got `' + test + '`')
	  }
	
	  known = options.known
	  reset = options.reset
	  enable = options.enable || []
	  disable = options.disable || []
	  sources = options.source
	
	  if (!sources) {
	    sources = [name]
	  } else if (typeof sources === 'string') {
	    sources = [sources]
	  }
	
	  return transformer
	
	  function transformer(tree, file) {
	    var toOffset = location(file).toOffset
	    var initial = !reset
	    var gaps = detectGaps(tree, file)
	    var scope = {}
	    var globals = []
	
	    visit(tree, test, visitor)
	
	    file.messages = file.messages.filter(filter)
	
	    function visitor(node, position, parent) {
	      var mark = marker(node)
	      var ruleIds
	      var ruleId
	      var verb
	      var index
	      var length
	      var next
	      var pos
	      var tail
	
	      if (!mark || mark.name !== options.name) {
	        return
	      }
	
	      ruleIds = mark.attributes.split(/\s/g)
	      verb = ruleIds.shift()
	      next = parent.children[position + 1]
	      pos = mark.node.position && mark.node.position.start
	      tail = next && next.position && next.position.end
	
	      if (!verb || !ALLOWED_VERBS[verb] === true) {
	        file.fail(
	          'Unknown keyword `' +
	            verb +
	            '`: expected ' +
	            "`'enable'`, `'disable'`, or `'ignore'`",
	          mark.node
	        )
	      }
	
	      length = ruleIds.length
	      index = -1
	
	      while (++index < length) {
	        ruleId = ruleIds[index]
	
	        if (isKnown(ruleId, verb, mark.node)) {
	          toggle(pos, verb === 'enable', ruleId)
	
	          if (verb === 'ignore') {
	            toggle(tail, true, ruleId)
	          }
	        }
	      }
	
	      /* Apply to all rules. */
	      if (!length) {
	        if (verb === 'ignore') {
	          toggle(pos, false)
	          toggle(tail, true)
	        } else {
	          toggle(pos, verb === 'enable')
	          reset = verb !== 'enable'
	        }
	      }
	    }
	
	    function filter(message) {
	      var gapIndex = gaps.length
	      var ruleId = message.ruleId
	      var ranges = scope[ruleId]
	      var pos
	
	      /* Keep messages from a different source. */
	      if (!message.source || sources.indexOf(message.source) === -1) {
	        return true
	      }
	
	      /* We only ignore messages if they‘re disabled,
	       * *not* when they’re not in the document. */
	      if (!message.line) {
	        message.line = 1
	      }
	
	      if (!message.column) {
	        message.column = 1
	      }
	
	      /* Check whether the warning is inside a gap. */
	      pos = toOffset(message)
	
	      while (gapIndex--) {
	        if (gaps[gapIndex].start <= pos && gaps[gapIndex].end > pos) {
	          return false
	        }
	      }
	
	      /* Check whether allowed by specific and global states. */
	      return check(message, ranges, ruleId) && check(message, globals)
	    }
	
	    /* Helper to check (and possibly warn) if a ruleId is unknown. */
	    function isKnown(ruleId, verb, pos) {
	      var result = known ? known.indexOf(ruleId) !== -1 : true
	
	      if (!result) {
	        file.warn('Unknown rule: cannot ' + verb + " `'" + ruleId + "'`", pos)
	      }
	
	      return result
	    }
	
	    /* Get the latest state of a rule. When without `ruleId`, gets global state. */
	    function getState(ruleId) {
	      var ranges = ruleId ? scope[ruleId] : globals
	
	      if (ranges && ranges.length !== 0) {
	        return ranges[ranges.length - 1].state
	      }
	
	      if (!ruleId) {
	        return !reset
	      }
	
	      if (reset) {
	        return enable.indexOf(ruleId) !== -1
	      }
	
	      return disable.indexOf(ruleId) === -1
	    }
	
	    /* Handle a rule. */
	    function toggle(pos, state, ruleId) {
	      var markers = ruleId ? scope[ruleId] : globals
	      var currentState
	      var previousState
	
	      if (!markers) {
	        markers = []
	        scope[ruleId] = markers
	      }
	
	      previousState = getState(ruleId)
	      currentState = state
	
	      if (currentState !== previousState) {
	        markers.push({state: currentState, position: pos})
	      }
	
	      /* Toggle all known rules. */
	      if (!ruleId) {
	        for (ruleId in scope) {
	          toggle(pos, state, ruleId)
	        }
	      }
	    }
	
	    /* Check all `ranges` for `message`. */
	    function check(message, ranges, id) {
	      /* Check the state at the message's position. */
	      var index = ranges && ranges.length
	      var length = -1
	      var range
	
	      while (--index > length) {
	        range = ranges[index]
	
	        /* istanbul ignore if - generated marker. */
	        if (!range.position || !range.position.line || !range.position.column) {
	          continue
	        }
	
	        if (
	          range.position.line < message.line ||
	          (range.position.line === message.line &&
	            range.position.column < message.column)
	        ) {
	          return range.state === true
	        }
	      }
	
	      /* The first marker ocurred after the first
	       * message, so we check the initial state. */
	      if (!id) {
	        return initial || reset
	      }
	
	      return reset ? enable.indexOf(id) !== -1 : disable.indexOf(id) === -1
	    }
	  }
	}
	
	/* Detect gaps in `ast`. */
	function detectGaps(tree, file) {
	  var lastNode = tree.children[tree.children.length - 1]
	  var offset = 0
	  var isGap = false
	  var gaps = []
	
	  /* Find all gaps. */
	  visit(tree, one)
	
	  /* Get the end of the document.
	   * This detects if the last node was the last node.
	   * If not, there’s an extra gap between the last node
	   * and the end of the document. */
	  if (
	    lastNode &&
	    lastNode.position &&
	    lastNode.position.end &&
	    offset === lastNode.position.end.offset &&
	    trim(file.toString().slice(offset)) !== ''
	  ) {
	    update()
	
	    update(
	      tree && tree.position && tree.position.end && tree.position.end.offset - 1
	    )
	  }
	
	  return gaps
	
	  function one(node) {
	    var pos = node.position
	
	    update(pos && pos.start && pos.start.offset)
	
	    if (!node.children) {
	      update(pos && pos.end && pos.end.offset)
	    }
	  }
	
	  /* Detect a new position. */
	  function update(latest) {
	    if (latest === null || latest === undefined) {
	      isGap = true
	      return
	    }
	
	    if (offset >= latest) {
	      return
	    }
	
	    if (isGap) {
	      gaps.push({start: offset, end: latest})
	      isGap = false
	    }
	
	    offset = latest
	  }
	}


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict'
	
	/* Dependencies. */
	var extend = __webpack_require__(279)
	var bail = __webpack_require__(250)
	var vfile = __webpack_require__(474)
	var trough = __webpack_require__(466)
	var string = __webpack_require__(477)
	var plain = __webpack_require__(298)
	
	/* Expose a frozen processor. */
	module.exports = unified().freeze()
	
	var slice = [].slice
	var own = {}.hasOwnProperty
	
	/* Process pipeline. */
	var pipeline = trough()
	  .use(pipelineParse)
	  .use(pipelineRun)
	  .use(pipelineStringify)
	
	function pipelineParse(p, ctx) {
	  ctx.tree = p.parse(ctx.file)
	}
	
	function pipelineRun(p, ctx, next) {
	  p.run(ctx.tree, ctx.file, done)
	
	  function done(err, tree, file) {
	    if (err) {
	      next(err)
	    } else {
	      ctx.tree = tree
	      ctx.file = file
	      next()
	    }
	  }
	}
	
	function pipelineStringify(p, ctx) {
	  ctx.file.contents = p.stringify(ctx.tree, ctx.file)
	}
	
	/* Function to create the first processor. */
	function unified() {
	  var attachers = []
	  var transformers = trough()
	  var namespace = {}
	  var frozen = false
	  var freezeIndex = -1
	
	  /* Data management. */
	  processor.data = data
	
	  /* Lock. */
	  processor.freeze = freeze
	
	  /* Plug-ins. */
	  processor.attachers = attachers
	  processor.use = use
	
	  /* API. */
	  processor.parse = parse
	  processor.stringify = stringify
	  processor.run = run
	  processor.runSync = runSync
	  processor.process = process
	  processor.processSync = processSync
	
	  /* Expose. */
	  return processor
	
	  /* Create a new processor based on the processor
	   * in the current scope. */
	  function processor() {
	    var destination = unified()
	    var length = attachers.length
	    var index = -1
	
	    while (++index < length) {
	      destination.use.apply(null, attachers[index])
	    }
	
	    destination.data(extend(true, {}, namespace))
	
	    return destination
	  }
	
	  /* Freeze: used to signal a processor that has finished
	   * configuration.
	   *
	   * For example, take unified itself.  It’s frozen.
	   * Plug-ins should not be added to it.  Rather, it should
	   * be extended, by invoking it, before modifying it.
	   *
	   * In essence, always invoke this when exporting a
	   * processor. */
	  function freeze() {
	    var values
	    var plugin
	    var options
	    var transformer
	
	    if (frozen) {
	      return processor
	    }
	
	    while (++freezeIndex < attachers.length) {
	      values = attachers[freezeIndex]
	      plugin = values[0]
	      options = values[1]
	      transformer = null
	
	      if (options === false) {
	        continue
	      }
	
	      if (options === true) {
	        values[1] = undefined
	      }
	
	      transformer = plugin.apply(processor, values.slice(1))
	
	      if (typeof transformer === 'function') {
	        transformers.use(transformer)
	      }
	    }
	
	    frozen = true
	    freezeIndex = Infinity
	
	    return processor
	  }
	
	  /* Data management.
	   * Getter / setter for processor-specific informtion. */
	  function data(key, value) {
	    if (string(key)) {
	      /* Set `key`. */
	      if (arguments.length === 2) {
	        assertUnfrozen('data', frozen)
	
	        namespace[key] = value
	
	        return processor
	      }
	
	      /* Get `key`. */
	      return (own.call(namespace, key) && namespace[key]) || null
	    }
	
	    /* Set space. */
	    if (key) {
	      assertUnfrozen('data', frozen)
	      namespace = key
	      return processor
	    }
	
	    /* Get space. */
	    return namespace
	  }
	
	  /* Plug-in management.
	   *
	   * Pass it:
	   * *   an attacher and options,
	   * *   a preset,
	   * *   a list of presets, attachers, and arguments (list
	   *     of attachers and options). */
	  function use(value) {
	    var settings
	
	    assertUnfrozen('use', frozen)
	
	    if (value === null || value === undefined) {
	      /* Empty */
	    } else if (typeof value === 'function') {
	      addPlugin.apply(null, arguments)
	    } else if (typeof value === 'object') {
	      if ('length' in value) {
	        addList(value)
	      } else {
	        addPreset(value)
	      }
	    } else {
	      throw new Error('Expected usable value, not `' + value + '`')
	    }
	
	    if (settings) {
	      namespace.settings = extend(namespace.settings || {}, settings)
	    }
	
	    return processor
	
	    function addPreset(result) {
	      addList(result.plugins)
	
	      if (result.settings) {
	        settings = extend(settings || {}, result.settings)
	      }
	    }
	
	    function add(value) {
	      if (typeof value === 'function') {
	        addPlugin(value)
	      } else if (typeof value === 'object') {
	        if ('length' in value) {
	          addPlugin.apply(null, value)
	        } else {
	          addPreset(value)
	        }
	      } else {
	        throw new Error('Expected usable value, not `' + value + '`')
	      }
	    }
	
	    function addList(plugins) {
	      var length
	      var index
	
	      if (plugins === null || plugins === undefined) {
	        /* Empty */
	      } else if (typeof plugins === 'object' && 'length' in plugins) {
	        length = plugins.length
	        index = -1
	
	        while (++index < length) {
	          add(plugins[index])
	        }
	      } else {
	        throw new Error('Expected a list of plugins, not `' + plugins + '`')
	      }
	    }
	
	    function addPlugin(plugin, value) {
	      var entry = find(plugin)
	
	      if (entry) {
	        if (plain(entry[1]) && plain(value)) {
	          value = extend(entry[1], value)
	        }
	
	        entry[1] = value
	      } else {
	        attachers.push(slice.call(arguments))
	      }
	    }
	  }
	
	  function find(plugin) {
	    var length = attachers.length
	    var index = -1
	    var entry
	
	    while (++index < length) {
	      entry = attachers[index]
	
	      if (entry[0] === plugin) {
	        return entry
	      }
	    }
	  }
	
	  /* Parse a file (in string or VFile representation)
	   * into a Unist node using the `Parser` on the
	   * processor. */
	  function parse(doc) {
	    var file = vfile(doc)
	    var Parser
	
	    freeze()
	    Parser = processor.Parser
	    assertParser('parse', Parser)
	
	    if (newable(Parser)) {
	      return new Parser(String(file), file).parse()
	    }
	
	    return Parser(String(file), file) // eslint-disable-line new-cap
	  }
	
	  /* Run transforms on a Unist node representation of a file
	   * (in string or VFile representation), async. */
	  function run(node, file, cb) {
	    assertNode(node)
	    freeze()
	
	    if (!cb && typeof file === 'function') {
	      cb = file
	      file = null
	    }
	
	    if (!cb) {
	      return new Promise(executor)
	    }
	
	    executor(null, cb)
	
	    function executor(resolve, reject) {
	      transformers.run(node, vfile(file), done)
	
	      function done(err, tree, file) {
	        tree = tree || node
	        if (err) {
	          reject(err)
	        } else if (resolve) {
	          resolve(tree)
	        } else {
	          cb(null, tree, file)
	        }
	      }
	    }
	  }
	
	  /* Run transforms on a Unist node representation of a file
	   * (in string or VFile representation), sync. */
	  function runSync(node, file) {
	    var complete = false
	    var result
	
	    run(node, file, done)
	
	    assertDone('runSync', 'run', complete)
	
	    return result
	
	    function done(err, tree) {
	      complete = true
	      bail(err)
	      result = tree
	    }
	  }
	
	  /* Stringify a Unist node representation of a file
	   * (in string or VFile representation) into a string
	   * using the `Compiler` on the processor. */
	  function stringify(node, doc) {
	    var file = vfile(doc)
	    var Compiler
	
	    freeze()
	    Compiler = processor.Compiler
	    assertCompiler('stringify', Compiler)
	    assertNode(node)
	
	    if (newable(Compiler)) {
	      return new Compiler(node, file).compile()
	    }
	
	    return Compiler(node, file) // eslint-disable-line new-cap
	  }
	
	  /* Parse a file (in string or VFile representation)
	   * into a Unist node using the `Parser` on the processor,
	   * then run transforms on that node, and compile the
	   * resulting node using the `Compiler` on the processor,
	   * and store that result on the VFile. */
	  function process(doc, cb) {
	    freeze()
	    assertParser('process', processor.Parser)
	    assertCompiler('process', processor.Compiler)
	
	    if (!cb) {
	      return new Promise(executor)
	    }
	
	    executor(null, cb)
	
	    function executor(resolve, reject) {
	      var file = vfile(doc)
	
	      pipeline.run(processor, {file: file}, done)
	
	      function done(err) {
	        if (err) {
	          reject(err)
	        } else if (resolve) {
	          resolve(file)
	        } else {
	          cb(null, file)
	        }
	      }
	    }
	  }
	
	  /* Process the given document (in string or VFile
	   * representation), sync. */
	  function processSync(doc) {
	    var complete = false
	    var file
	
	    freeze()
	    assertParser('processSync', processor.Parser)
	    assertCompiler('processSync', processor.Compiler)
	    file = vfile(doc)
	
	    process(file, done)
	
	    assertDone('processSync', 'process', complete)
	
	    return file
	
	    function done(err) {
	      complete = true
	      bail(err)
	    }
	  }
	}
	
	/* Check if `func` is a constructor. */
	function newable(value) {
	  return typeof value === 'function' && keys(value.prototype)
	}
	
	/* Check if `value` is an object with keys. */
	function keys(value) {
	  var key
	  for (key in value) {
	    return true
	  }
	  return false
	}
	
	/* Assert a parser is available. */
	function assertParser(name, Parser) {
	  if (typeof Parser !== 'function') {
	    throw new Error('Cannot `' + name + '` without `Parser`')
	  }
	}
	
	/* Assert a compiler is available. */
	function assertCompiler(name, Compiler) {
	  if (typeof Compiler !== 'function') {
	    throw new Error('Cannot `' + name + '` without `Compiler`')
	  }
	}
	
	/* Assert the processor is not frozen. */
	function assertUnfrozen(name, frozen) {
	  if (frozen) {
	    throw new Error(
	      [
	        'Cannot invoke `' + name + '` on a frozen processor.\nCreate a new ',
	        'processor first, by invoking it: use `processor()` instead of ',
	        '`processor`.'
	      ].join('')
	    )
	  }
	}
	
	/* Assert `node` is a Unist node. */
	function assertNode(node) {
	  if (!node || !string(node.type)) {
	    throw new Error('Expected node, got `' + node + '`')
	  }
	}
	
	/* Assert that `complete` is `true`. */
	function assertDone(name, asyncName, complete) {
	  if (!complete) {
	    throw new Error(
	      '`' + name + '` finished async. Use `' + asyncName + '` instead'
	    )
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)))

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var iterate = __webpack_require__(243)
	
	module.exports = modifierFactory
	
	/* Turn `callback` into a child-modifier accepting a parent.
	 * See `array-iterate` for more info. */
	function modifierFactory(callback) {
	  return iteratorFactory(wrapperFactory(callback))
	}
	
	/* Turn `callback` into a `iterator' accepting a parent. */
	function iteratorFactory(callback) {
	  return iterator
	
	  function iterator(parent) {
	    var children = parent && parent.children
	
	    if (!children) {
	      throw new Error('Missing children in `parent` for `modifier`')
	    }
	
	    return iterate(children, callback, parent)
	  }
	}
	
	/* Pass the context as the third argument to `callback`. */
	function wrapperFactory(callback) {
	  return wrapper
	
	  function wrapper(value, index) {
	    return callback(value, index, this)
	  }
	}


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var visit = __webpack_require__(6)
	
	module.exports = removePosition
	
	/* Remove `position`s from `tree`. */
	function removePosition(node, force) {
	  visit(node, force ? hard : soft)
	  return node
	}
	
	function hard(node) {
	  delete node.position
	}
	
	function soft(node) {
	  node.position = undefined
	}


/***/ }),
/* 471 */
/***/ (function(module, exports) {

	'use strict'
	
	var own = {}.hasOwnProperty
	
	module.exports = stringify
	
	function stringify(value) {
	  /* Nothing. */
	  if (!value || typeof value !== 'object') {
	    return null
	  }
	
	  /* Node. */
	  if (own.call(value, 'position') || own.call(value, 'type')) {
	    return position(value.position)
	  }
	
	  /* Position. */
	  if (own.call(value, 'start') || own.call(value, 'end')) {
	    return position(value)
	  }
	
	  /* Point. */
	  if (own.call(value, 'line') || own.call(value, 'column')) {
	    return point(value)
	  }
	
	  /* ? */
	  return null
	}
	
	function point(point) {
	  if (!point || typeof point !== 'object') {
	    point = {}
	  }
	
	  return index(point.line) + ':' + index(point.column)
	}
	
	function position(pos) {
	  if (!pos || typeof pos !== 'object') {
	    pos = {}
	  }
	
	  return point(pos.start) + '-' + point(pos.end)
	}
	
	function index(value) {
	  return value && typeof value === 'number' ? value : 1
	}


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var stringify = __webpack_require__(471)
	
	module.exports = VMessage
	
	/* Inherit from `Error#`. */
	function VMessagePrototype() {}
	VMessagePrototype.prototype = Error.prototype
	VMessage.prototype = new VMessagePrototype()
	
	/* Message properties. */
	var proto = VMessage.prototype
	
	proto.file = ''
	proto.name = ''
	proto.reason = ''
	proto.message = ''
	proto.stack = ''
	proto.fatal = null
	proto.column = null
	proto.line = null
	
	/* Construct a new VMessage.
	 *
	 * Note: We cannot invoke `Error` on the created context,
	 * as that adds readonly `line` and `column` attributes on
	 * Safari 9, thus throwing and failing the data. */
	function VMessage(reason, position, origin) {
	  var parts
	  var range
	  var location
	
	  if (typeof position === 'string') {
	    origin = position
	    position = null
	  }
	
	  parts = parseOrigin(origin)
	  range = stringify(position) || '1:1'
	
	  location = {
	    start: {line: null, column: null},
	    end: {line: null, column: null}
	  }
	
	  /* Node. */
	  if (position && position.position) {
	    position = position.position
	  }
	
	  if (position) {
	    /* Position. */
	    if (position.start) {
	      location = position
	      position = position.start
	    } else {
	      /* Point. */
	      location.start = position
	    }
	  }
	
	  if (reason.stack) {
	    this.stack = reason.stack
	    reason = reason.message
	  }
	
	  this.message = reason
	  this.name = range
	  this.reason = reason
	  this.line = position ? position.line : null
	  this.column = position ? position.column : null
	  this.location = location
	  this.source = parts[0]
	  this.ruleId = parts[1]
	}
	
	function parseOrigin(origin) {
	  var result = [null, null]
	  var index
	
	  if (typeof origin === 'string') {
	    index = origin.indexOf(':')
	
	    if (index === -1) {
	      result[1] = origin
	    } else {
	      result[0] = origin.slice(0, index)
	      result[1] = origin.slice(index + 1)
	    }
	  }
	
	  return result
	}


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var path = __webpack_require__(132);
	var replace = __webpack_require__(475);
	var buffer = __webpack_require__(297);
	
	module.exports = VFile;
	
	var own = {}.hasOwnProperty;
	var proto = VFile.prototype;
	
	proto.toString = toString;
	
	/* Order of setting (least specific to most), we need this because
	 * otherwise `{stem: 'a', path: '~/b.js'}` would throw, as a path
	 * is needed before a stem can be set. */
	var order = [
	  'history',
	  'path',
	  'basename',
	  'stem',
	  'extname',
	  'dirname'
	];
	
	/* Construct a new file. */
	function VFile(options) {
	  var prop;
	  var index;
	  var length;
	
	  if (!options) {
	    options = {};
	  } else if (typeof options === 'string' || buffer(options)) {
	    options = {contents: options};
	  } else if ('message' in options && 'messages' in options) {
	    return options;
	  }
	
	  if (!(this instanceof VFile)) {
	    return new VFile(options);
	  }
	
	  this.data = {};
	  this.messages = [];
	  this.history = [];
	  this.cwd = process.cwd();
	
	  /* Set path related properties in the correct order. */
	  index = -1;
	  length = order.length;
	
	  while (++index < length) {
	    prop = order[index];
	
	    if (own.call(options, prop)) {
	      this[prop] = options[prop];
	    }
	  }
	
	  /* Set non-path related properties. */
	  for (prop in options) {
	    if (order.indexOf(prop) === -1) {
	      this[prop] = options[prop];
	    }
	  }
	}
	
	/* Access full path (`~/index.min.js`). */
	Object.defineProperty(proto, 'path', {
	  get: function () {
	    return this.history[this.history.length - 1];
	  },
	  set: function (path) {
	    assertNonEmpty(path, 'path');
	
	    if (path !== this.path) {
	      this.history.push(path);
	    }
	  }
	});
	
	/* Access parent path (`~`). */
	Object.defineProperty(proto, 'dirname', {
	  get: function () {
	    return typeof this.path === 'string' ? path.dirname(this.path) : undefined;
	  },
	  set: function (dirname) {
	    assertPath(this.path, 'dirname');
	    this.path = path.join(dirname || '', this.basename);
	  }
	});
	
	/* Access basename (`index.min.js`). */
	Object.defineProperty(proto, 'basename', {
	  get: function () {
	    return typeof this.path === 'string' ? path.basename(this.path) : undefined;
	  },
	  set: function (basename) {
	    assertNonEmpty(basename, 'basename');
	    assertPart(basename, 'basename');
	    this.path = path.join(this.dirname || '', basename);
	  }
	});
	
	/* Access extname (`.js`). */
	Object.defineProperty(proto, 'extname', {
	  get: function () {
	    return typeof this.path === 'string' ? path.extname(this.path) : undefined;
	  },
	  set: function (extname) {
	    var ext = extname || '';
	
	    assertPart(ext, 'extname');
	    assertPath(this.path, 'extname');
	
	    if (ext) {
	      if (ext.charAt(0) !== '.') {
	        throw new Error('`extname` must start with `.`');
	      }
	
	      if (ext.indexOf('.', 1) !== -1) {
	        throw new Error('`extname` cannot contain multiple dots');
	      }
	    }
	
	    this.path = replace(this.path, ext);
	  }
	});
	
	/* Access stem (`index.min`). */
	Object.defineProperty(proto, 'stem', {
	  get: function () {
	    return typeof this.path === 'string' ? path.basename(this.path, this.extname) : undefined;
	  },
	  set: function (stem) {
	    assertNonEmpty(stem, 'stem');
	    assertPart(stem, 'stem');
	    this.path = path.join(this.dirname || '', stem + (this.extname || ''));
	  }
	});
	
	/* Get the value of the file. */
	function toString(encoding) {
	  var value = this.contents || '';
	  return buffer(value) ? value.toString(encoding) : String(value);
	}
	
	/* Assert that `part` is not a path (i.e., does
	 * not contain `path.sep`). */
	function assertPart(part, name) {
	  if (part.indexOf(path.sep) !== -1) {
	    throw new Error('`' + name + '` cannot be a path: did not expect `' + path.sep + '`');
	  }
	}
	
	/* Assert that `part` is not empty. */
	function assertNonEmpty(part, name) {
	  if (!part) {
	    throw new Error('`' + name + '` cannot be empty');
	  }
	}
	
	/* Assert `path` exists. */
	function assertPath(path, name) {
	  if (!path) {
	    throw new Error('Setting `' + name + '` requires `path` to be set too');
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)))

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var VMessage = __webpack_require__(472);
	var VFile = __webpack_require__(473);
	
	module.exports = VFile;
	
	var proto = VFile.prototype;
	
	proto.message = message;
	proto.info = info;
	proto.fail = fail;
	
	/* Slight backwards compatibility.  Remove in the future. */
	proto.warn = message;
	
	/* Create a message with `reason` at `position`.
	 * When an error is passed in as `reason`, copies the stack. */
	function message(reason, position, origin) {
	  var filePath = this.path;
	  var message = new VMessage(reason, position, origin);
	
	  if (filePath) {
	    message.name = filePath + ':' + message.name;
	    message.file = filePath;
	  }
	
	  message.fatal = false;
	
	  this.messages.push(message);
	
	  return message;
	}
	
	/* Fail. Creates a vmessage, associates it with the file,
	 * and throws it. */
	function fail() {
	  var message = this.message.apply(this, arguments);
	
	  message.fatal = true;
	
	  throw message;
	}
	
	/* Info. Creates a vmessage, associates it with the file,
	 * and marks the fatality as null. */
	function info() {
	  var message = this.message.apply(this, arguments);
	
	  message.fatal = null;
	
	  return message;
	}


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var path = __webpack_require__(132);
	
	function replaceExt(npath, ext) {
	  if (typeof npath !== 'string') {
	    return npath;
	  }
	
	  if (npath.length === 0) {
	    return npath;
	  }
	
	  var nFileName = path.basename(npath, path.extname(npath)) + ext;
	  return path.join(path.dirname(npath), nFileName);
	}
	
	module.exports = replaceExt;


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Module Dependencies
	 */
	
	var sliced = __webpack_require__(462);
	var noop = function(){};
	var co = __webpack_require__(251);
	
	/**
	 * Export `wrapped`
	 */
	
	module.exports = wrapped;
	
	/**
	 * Wrap a function to support
	 * sync, async, and gen functions.
	 *
	 * @param {Function} fn
	 * @return {Function}
	 * @api public
	 */
	
	function wrapped(fn) {
	  function wrap() {
	    var args = sliced(arguments);
	    var last = args[args.length - 1];
	    var ctx = this;
	
	    // done
	    var done = typeof last == 'function' ? args.pop() : noop;
	
	    // nothing
	    if (!fn) {
	      return done.apply(ctx, [null].concat(args));
	    }
	
	    // generator
	    if (generator(fn)) {
	      return co(fn).apply(ctx, args.concat(done));
	    }
	
	    // async
	    if (fn.length > args.length) {
	      // NOTE: this only handles uncaught synchronous errors
	      try {
	        return fn.apply(ctx, args.concat(done));
	      } catch (e) {
	        return done(e);
	      }
	    }
	
	    // sync
	    return sync(fn, done).apply(ctx, args);
	  }
	
	  return wrap;
	}
	
	/**
	 * Wrap a synchronous function execution.
	 *
	 * @param {Function} fn
	 * @param {Function} done
	 * @return {Function}
	 * @api private
	 */
	
	function sync(fn, done) {
	  return function () {
	    var ret;
	
	    try {
	      ret = fn.apply(this, arguments);
	    } catch (err) {
	      return done(err);
	    }
	
	    if (promise(ret)) {
	      ret.then(function (value) { done(null, value); }, done);
	    } else {
	      ret instanceof Error ? done(ret) : done(null, ret);
	    }
	  }
	}
	
	/**
	 * Is `value` a generator?
	 *
	 * @param {Mixed} value
	 * @return {Boolean}
	 * @api private
	 */
	
	function generator(value) {
	  return value
	    && value.constructor
	    && 'GeneratorFunction' == value.constructor.name;
	}
	
	
	/**
	 * Is `value` a promise?
	 *
	 * @param {Mixed} value
	 * @return {Boolean}
	 * @api private
	 */
	
	function promise(value) {
	  return value && 'function' == typeof value.then;
	}


/***/ }),
/* 477 */
/***/ (function(module, exports) {

	var toString = Object.prototype.toString
	
	module.exports = isString
	
	function isString(obj) {
	    return toString.call(obj) === "[object String]"
	}


/***/ }),
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTooltip = __webpack_require__(1027);
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	var _reactEmotion = __webpack_require__(21);
	
	var _consts = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var tooltipStyles = /*#__PURE__*/(0, _reactEmotion.css)("box-shadow:0 0 25px 0 rgba(0,0,0,0.15);.tooltip-wrapper{display:flex;justify-content:center;}.tooltip-name{margin-right:10px;margin-bottom:0;color:", _consts.colors.primary, ";}.tooltip-value{margin-bottom:0;font-weight:600;color:", _consts.colors.primaryDark, ";}.tooltip-download{text-align:center;font-size:12px;color:", _consts.colors.primary, ";margin:0;&.mt{margin-top:4px;}}");
	
	exports.default = function (props) {
	  return _react2.default.createElement(_reactTooltip2.default, _extends({ type: "light", className: tooltipStyles, html: true }, props));
	};
	
	module.exports = exports["default"];

/***/ }),
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-time/ Version 1.0.8. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var t0 = new Date;
	var t1 = new Date;
	
	function newInterval(floori, offseti, count, field) {
	
	  function interval(date) {
	    return floori(date = new Date(+date)), date;
	  }
	
	  interval.floor = interval;
	
	  interval.ceil = function(date) {
	    return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
	  };
	
	  interval.round = function(date) {
	    var d0 = interval(date),
	        d1 = interval.ceil(date);
	    return date - d0 < d1 - date ? d0 : d1;
	  };
	
	  interval.offset = function(date, step) {
	    return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
	  };
	
	  interval.range = function(start, stop, step) {
	    var range = [], previous;
	    start = interval.ceil(start);
	    step = step == null ? 1 : Math.floor(step);
	    if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
	    do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
	    while (previous < start && start < stop);
	    return range;
	  };
	
	  interval.filter = function(test) {
	    return newInterval(function(date) {
	      if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
	    }, function(date, step) {
	      if (date >= date) {
	        if (step < 0) while (++step <= 0) {
	          while (offseti(date, -1), !test(date)) {} // eslint-disable-line no-empty
	        } else while (--step >= 0) {
	          while (offseti(date, +1), !test(date)) {} // eslint-disable-line no-empty
	        }
	      }
	    });
	  };
	
	  if (count) {
	    interval.count = function(start, end) {
	      t0.setTime(+start), t1.setTime(+end);
	      floori(t0), floori(t1);
	      return Math.floor(count(t0, t1));
	    };
	
	    interval.every = function(step) {
	      step = Math.floor(step);
	      return !isFinite(step) || !(step > 0) ? null
	          : !(step > 1) ? interval
	          : interval.filter(field
	              ? function(d) { return field(d) % step === 0; }
	              : function(d) { return interval.count(0, d) % step === 0; });
	    };
	  }
	
	  return interval;
	}
	
	var millisecond = newInterval(function() {
	  // noop
	}, function(date, step) {
	  date.setTime(+date + step);
	}, function(start, end) {
	  return end - start;
	});
	
	// An optimized implementation for this simple case.
	millisecond.every = function(k) {
	  k = Math.floor(k);
	  if (!isFinite(k) || !(k > 0)) return null;
	  if (!(k > 1)) return millisecond;
	  return newInterval(function(date) {
	    date.setTime(Math.floor(date / k) * k);
	  }, function(date, step) {
	    date.setTime(+date + step * k);
	  }, function(start, end) {
	    return (end - start) / k;
	  });
	};
	
	var milliseconds = millisecond.range;
	
	var durationSecond = 1e3;
	var durationMinute = 6e4;
	var durationHour = 36e5;
	var durationDay = 864e5;
	var durationWeek = 6048e5;
	
	var second = newInterval(function(date) {
	  date.setTime(Math.floor(date / durationSecond) * durationSecond);
	}, function(date, step) {
	  date.setTime(+date + step * durationSecond);
	}, function(start, end) {
	  return (end - start) / durationSecond;
	}, function(date) {
	  return date.getUTCSeconds();
	});
	
	var seconds = second.range;
	
	var minute = newInterval(function(date) {
	  date.setTime(Math.floor(date / durationMinute) * durationMinute);
	}, function(date, step) {
	  date.setTime(+date + step * durationMinute);
	}, function(start, end) {
	  return (end - start) / durationMinute;
	}, function(date) {
	  return date.getMinutes();
	});
	
	var minutes = minute.range;
	
	var hour = newInterval(function(date) {
	  var offset = date.getTimezoneOffset() * durationMinute % durationHour;
	  if (offset < 0) offset += durationHour;
	  date.setTime(Math.floor((+date - offset) / durationHour) * durationHour + offset);
	}, function(date, step) {
	  date.setTime(+date + step * durationHour);
	}, function(start, end) {
	  return (end - start) / durationHour;
	}, function(date) {
	  return date.getHours();
	});
	
	var hours = hour.range;
	
	var day = newInterval(function(date) {
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setDate(date.getDate() + step);
	}, function(start, end) {
	  return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationDay;
	}, function(date) {
	  return date.getDate() - 1;
	});
	
	var days = day.range;
	
	function weekday(i) {
	  return newInterval(function(date) {
	    date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
	    date.setHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setDate(date.getDate() + step * 7);
	  }, function(start, end) {
	    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationWeek;
	  });
	}
	
	var sunday = weekday(0);
	var monday = weekday(1);
	var tuesday = weekday(2);
	var wednesday = weekday(3);
	var thursday = weekday(4);
	var friday = weekday(5);
	var saturday = weekday(6);
	
	var sundays = sunday.range;
	var mondays = monday.range;
	var tuesdays = tuesday.range;
	var wednesdays = wednesday.range;
	var thursdays = thursday.range;
	var fridays = friday.range;
	var saturdays = saturday.range;
	
	var month = newInterval(function(date) {
	  date.setDate(1);
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setMonth(date.getMonth() + step);
	}, function(start, end) {
	  return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
	}, function(date) {
	  return date.getMonth();
	});
	
	var months = month.range;
	
	var year = newInterval(function(date) {
	  date.setMonth(0, 1);
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setFullYear(date.getFullYear() + step);
	}, function(start, end) {
	  return end.getFullYear() - start.getFullYear();
	}, function(date) {
	  return date.getFullYear();
	});
	
	// An optimized implementation for this simple case.
	year.every = function(k) {
	  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
	    date.setFullYear(Math.floor(date.getFullYear() / k) * k);
	    date.setMonth(0, 1);
	    date.setHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setFullYear(date.getFullYear() + step * k);
	  });
	};
	
	var years = year.range;
	
	var utcMinute = newInterval(function(date) {
	  date.setUTCSeconds(0, 0);
	}, function(date, step) {
	  date.setTime(+date + step * durationMinute);
	}, function(start, end) {
	  return (end - start) / durationMinute;
	}, function(date) {
	  return date.getUTCMinutes();
	});
	
	var utcMinutes = utcMinute.range;
	
	var utcHour = newInterval(function(date) {
	  date.setUTCMinutes(0, 0, 0);
	}, function(date, step) {
	  date.setTime(+date + step * durationHour);
	}, function(start, end) {
	  return (end - start) / durationHour;
	}, function(date) {
	  return date.getUTCHours();
	});
	
	var utcHours = utcHour.range;
	
	var utcDay = newInterval(function(date) {
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCDate(date.getUTCDate() + step);
	}, function(start, end) {
	  return (end - start) / durationDay;
	}, function(date) {
	  return date.getUTCDate() - 1;
	});
	
	var utcDays = utcDay.range;
	
	function utcWeekday(i) {
	  return newInterval(function(date) {
	    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
	    date.setUTCHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setUTCDate(date.getUTCDate() + step * 7);
	  }, function(start, end) {
	    return (end - start) / durationWeek;
	  });
	}
	
	var utcSunday = utcWeekday(0);
	var utcMonday = utcWeekday(1);
	var utcTuesday = utcWeekday(2);
	var utcWednesday = utcWeekday(3);
	var utcThursday = utcWeekday(4);
	var utcFriday = utcWeekday(5);
	var utcSaturday = utcWeekday(6);
	
	var utcSundays = utcSunday.range;
	var utcMondays = utcMonday.range;
	var utcTuesdays = utcTuesday.range;
	var utcWednesdays = utcWednesday.range;
	var utcThursdays = utcThursday.range;
	var utcFridays = utcFriday.range;
	var utcSaturdays = utcSaturday.range;
	
	var utcMonth = newInterval(function(date) {
	  date.setUTCDate(1);
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCMonth(date.getUTCMonth() + step);
	}, function(start, end) {
	  return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
	}, function(date) {
	  return date.getUTCMonth();
	});
	
	var utcMonths = utcMonth.range;
	
	var utcYear = newInterval(function(date) {
	  date.setUTCMonth(0, 1);
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCFullYear(date.getUTCFullYear() + step);
	}, function(start, end) {
	  return end.getUTCFullYear() - start.getUTCFullYear();
	}, function(date) {
	  return date.getUTCFullYear();
	});
	
	// An optimized implementation for this simple case.
	utcYear.every = function(k) {
	  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
	    date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
	    date.setUTCMonth(0, 1);
	    date.setUTCHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setUTCFullYear(date.getUTCFullYear() + step * k);
	  });
	};
	
	var utcYears = utcYear.range;
	
	exports.timeInterval = newInterval;
	exports.timeMillisecond = millisecond;
	exports.timeMilliseconds = milliseconds;
	exports.utcMillisecond = millisecond;
	exports.utcMilliseconds = milliseconds;
	exports.timeSecond = second;
	exports.timeSeconds = seconds;
	exports.utcSecond = second;
	exports.utcSeconds = seconds;
	exports.timeMinute = minute;
	exports.timeMinutes = minutes;
	exports.timeHour = hour;
	exports.timeHours = hours;
	exports.timeDay = day;
	exports.timeDays = days;
	exports.timeWeek = sunday;
	exports.timeWeeks = sundays;
	exports.timeSunday = sunday;
	exports.timeSundays = sundays;
	exports.timeMonday = monday;
	exports.timeMondays = mondays;
	exports.timeTuesday = tuesday;
	exports.timeTuesdays = tuesdays;
	exports.timeWednesday = wednesday;
	exports.timeWednesdays = wednesdays;
	exports.timeThursday = thursday;
	exports.timeThursdays = thursdays;
	exports.timeFriday = friday;
	exports.timeFridays = fridays;
	exports.timeSaturday = saturday;
	exports.timeSaturdays = saturdays;
	exports.timeMonth = month;
	exports.timeMonths = months;
	exports.timeYear = year;
	exports.timeYears = years;
	exports.utcMinute = utcMinute;
	exports.utcMinutes = utcMinutes;
	exports.utcHour = utcHour;
	exports.utcHours = utcHours;
	exports.utcDay = utcDay;
	exports.utcDays = utcDays;
	exports.utcWeek = utcSunday;
	exports.utcWeeks = utcSundays;
	exports.utcSunday = utcSunday;
	exports.utcSundays = utcSundays;
	exports.utcMonday = utcMonday;
	exports.utcMondays = utcMondays;
	exports.utcTuesday = utcTuesday;
	exports.utcTuesdays = utcTuesdays;
	exports.utcWednesday = utcWednesday;
	exports.utcWednesdays = utcWednesdays;
	exports.utcThursday = utcThursday;
	exports.utcThursdays = utcThursdays;
	exports.utcFriday = utcFriday;
	exports.utcFridays = utcFridays;
	exports.utcSaturday = utcSaturday;
	exports.utcSaturdays = utcSaturdays;
	exports.utcMonth = utcMonth;
	exports.utcMonths = utcMonths;
	exports.utcYear = utcYear;
	exports.utcYears = utcYears;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */
/***/ (function(module, exports) {

	module.exports = {"type":"Topology","transform":{"scale":[0.0017672725050734866,0.0012459536210745025],"translate":[-116.0495518555481,44.37975008675692]},"arcs":[[[3269,1871],[171,34],[85,-48],[42,0]],[[3567,1857],[202,0]],[[3769,1857],[-9,-163],[1,-217],[-142,-1]],[[3619,1476],[-355,1]],[[3264,1477],[5,394]],[[6219,3708],[103,-1],[188,1],[281,0],[-1,-122],[1,-172],[0,-112],[1,-84]],[[6792,3218],[-329,0],[0,70],[-74,0],[0,69],[-122,0]],[[6267,3357],[0,70],[-37,0],[0,209],[-11,72]],[[5578,1130],[684,-1]],[[6262,1129],[-3,-348],[-29,0],[0,-283]],[[6230,498],[-21,0],[-436,0],[-100,-2],[-136,-3],[0,0]],[[5537,493],[0,139],[-9,10]],[[5528,642],[0,139],[25,0],[1,349],[24,0]],[[1528,3154],[438,0],[-1,139],[221,-4]],[[2186,3289],[110,-32],[0,-35],[111,-1],[0,-35],[73,0],[0,-105],[146,0]],[[2626,3081],[0,-70]],[[2626,3011],[0,-116]],[[2626,2895],[-326,-2],[0,47],[-36,0],[0,35],[-74,0],[0,35],[-473,0]],[[1717,3010],[-122,32],[-3,62],[-64,50]],[[6476,1991],[109,35],[60,111],[-6,111],[-59,140]],[[6580,2388],[164,-1],[49,35]],[[6793,2422],[0,-52],[0,-2],[0,-163],[-1,-155],[0,-177],[0,-58]],[[6792,1815],[-175,0],[-36,35],[-106,0]],[[6475,1850],[0,118],[1,23]],[[4607,2465],[25,51],[58,27],[38,66],[46,14],[97,-18],[14,54]],[[4885,2659],[94,-25],[135,2],[67,9],[18,50],[72,-2],[12,30],[62,10],[53,75],[5,64],[47,-1]],[[5450,2871],[34,0],[0,-71],[55,0],[-21,-272],[0,-140],[72,0],[0,-140],[48,0]],[[5638,2248],[0,-257]],[[5638,1991],[0,-12]],[[5638,1979],[-353,0],[-429,11],[-240,-6]],[[4616,1984],[-26,20],[31,98],[-21,20],[-27,182],[3,83],[30,39],[1,39]],[[3003,3707],[120,0],[53,1],[150,0],[379,1],[7,0]],[[3712,3709],[-9,-70],[0,-278],[23,-34],[0,-58],[-18,-1],[-13,-127],[-18,0],[9,-128]],[[3686,3013],[-109,-1],[0,71],[-67,-2],[0,70],[-440,0],[-1,-69],[-73,0]],[[2996,3082],[3,557],[4,68]],[[1121,3708],[91,-1],[121,-1],[180,1],[147,0],[522,0]],[[2182,3707],[4,-418]],[[1528,3154],[-21,25],[30,38],[-13,29],[-69,23],[6,76],[-43,31],[-31,-9],[-86,32],[27,84],[-50,101],[-121,-10],[-30,45],[21,58],[-27,31]],[[3264,1448],[0,29]],[[3619,1476],[0,-70],[28,0],[-1,-70],[107,0]],[[3753,1336],[-4,-68],[-47,-1],[0,-71],[-24,0],[-8,-70],[1,-140],[-70,0],[0,-35],[-70,1],[0,-34],[-70,0],[0,-140],[-74,0],[0,-142]],[[3387,636],[-93,0],[5,142],[0,349],[-41,1],[0,280],[6,40]],[[3061,2438],[242,0]],[[3303,2438],[0,-47],[48,0],[0,-70],[71,1],[1,-35],[72,0],[0,-35],[65,0],[1,-232],[-45,-70],[44,-23],[7,-70]],[[3269,1871],[-31,-30],[-79,4],[-105,117]],[[3054,1962],[9,10],[-5,208],[-71,1],[-10,169],[12,42],[73,-1],[-1,47]],[[1677,1188],[92,60],[-9,47],[49,44],[43,0],[0,70],[54,0],[59,35]],[[1965,1444],[41,4],[-8,-38],[64,-200],[-5,-41],[126,-71]],[[2183,1098],[-152,-5],[-21,14],[-29,-60],[-78,-48]],[[1903,999],[-41,99],[-130,48],[-55,42]],[[2411,1757],[89,1],[-5,135],[21,32],[59,-13]],[[2575,1912],[24,-16],[26,-82],[45,-5],[-8,-70],[50,-39],[6,-48],[69,1],[38,-29],[-39,-105],[29,-17],[7,-47]],[[2822,1455],[-161,-4],[-1,-52],[-43,-49],[3,-53],[-95,-72],[-41,-59]],[[2484,1166],[-1,174],[-70,0],[-2,417]],[[5638,1991],[143,0],[122,-23],[0,-70],[24,-69],[47,0],[0,-47],[25,-23],[118,-1],[-1,-23],[145,-1],[0,23],[71,0],[0,35],[71,0]],[[6403,1792],[0,-105],[-98,0],[12,-277]],[[6317,1410],[-31,0],[-24,-281]],[[5578,1130],[0,280],[21,278],[19,280],[20,11]],[[4421,3708],[301,0],[149,0],[44,0],[104,0]],[[5019,3708],[-15,-70],[0,-277],[7,-47],[-37,5],[-24,-28],[0,-69],[23,0],[0,-72],[-62,0],[0,-69],[-20,0],[0,-280],[-6,-142]],[[4607,2465],[-11,94],[-78,25],[-140,-12]],[[4378,2572],[-13,-13],[-108,43],[-139,20],[-67,71]],[[4051,2693],[1,150],[149,-2],[10,57],[98,-12],[0,195],[14,184],[36,-21],[0,118],[15,139],[34,0],[0,138],[13,69]],[[3303,2438],[30,-1],[72,51],[102,48],[8,139],[65,-8],[18,21],[86,8]],[[3684,2696],[64,-15],[86,59],[80,-10],[87,18],[50,-55]],[[4378,2572],[-2,-216],[-155,-7],[-1,-29],[-72,0],[-10,-138],[72,0],[-1,-210],[-11,-70]],[[4198,1902],[-215,1]],[[3983,1903],[-215,0],[0,-28],[0,-1],[0,-5],[0,-3],[0,-1],[1,-5],[0,-3],[0,0]],[[0,3079],[53,-54],[11,28],[77,31],[32,32],[41,-45],[-14,-23],[29,-35],[34,-90],[23,-18],[-8,-46],[19,-27],[111,7],[29,-22],[52,26],[18,76],[81,0]],[[588,2919],[12,-116],[217,2],[0,-68]],[[817,2737],[12,-35],[0,-116],[149,-5],[-36,-90],[47,11],[-29,-86],[36,-27],[49,0],[0,-140],[9,-35]],[[1054,2214],[-38,-14],[-52,45],[-116,60],[-140,14]],[[708,2319],[-96,35],[-8,68],[-151,67],[-218,1]],[[235,2490],[-47,41],[-2,35],[15,38],[-24,25],[7,34],[-63,51],[-5,44],[-32,22],[-33,43],[-40,61],[-5,9],[-6,12],[0,100],[0,74]],[[4616,1984],[17,-13],[20,-64]],[[4653,1907],[-455,-5]],[[1257,1831],[91,-2],[-1,46],[107,23],[0,47],[100,23]],[[1554,1968],[106,-95],[44,18],[1,-377]],[[1705,1514],[0,-35],[-140,0],[3,-143],[-56,-21],[-79,-63]],[[1433,1252],[-74,20],[-23,57],[-65,1],[28,61],[-38,80],[40,48],[-20,12],[2,58],[-38,65],[-14,54],[35,65],[-9,58]],[[5638,2248],[71,0],[0,-70],[72,0],[0,71],[242,0]],[[6023,2249],[46,0],[0,-164],[72,0],[-1,-47],[73,0],[23,-46],[240,-1]],[[6475,1850],[-72,-23],[0,-35]],[[2832,499],[4,281],[68,0],[-1,140],[35,0],[0,51],[36,0],[2,443],[4,41]],[[2980,1455],[212,-1],[72,-6]],[[3387,636],[142,0],[8,-4]],[[3537,632],[0,-132]],[[3537,500],[-112,1],[-185,-4],[-216,-5],[-45,8],[-147,-1],[0,0]],[[5775,2913],[111,54],[82,17],[174,-25]],[[6142,2959],[-1,-160],[-22,-61]],[[6119,2738],[-72,0],[0,-210],[-24,-279]],[[5450,2871],[10,84],[97,-29],[126,6],[92,-19]],[[2182,3707],[28,0],[164,0],[200,-1],[131,0]],[[2705,3706],[-4,-625],[-75,0]],[[6119,2738],[0,-70],[145,0],[0,-70],[218,0],[0,-70],[46,0],[0,-140],[52,0]],[[6317,1410],[209,-1],[0,-65],[71,0],[0,-68],[145,-1],[0,-70],[51,0]],[[6793,1205],[0,-14],[1,-92],[0,-154],[1,-53],[0,-124],[0,-99],[1,-71],[0,-101],[-10,-1],[-548,2],[-8,0]],[[2485,2034],[67,0],[0,70],[144,0],[72,9],[0,61],[44,0],[-14,-48],[109,-38],[32,-48],[58,-25],[1,-37],[56,-16]],[[2980,1455],[-158,0]],[[2575,1912],[-80,56],[-10,66]],[[708,2319],[48,-35],[0,-35],[71,-46],[12,-46],[47,0],[36,-35],[-60,-11],[-23,-37],[10,-174],[-73,-12]],[[776,1888],[-12,7],[-39,-2],[-13,32],[-50,27],[-36,45],[9,37],[-19,15],[-40,31],[-22,41],[-28,31],[-39,56],[-38,35],[-20,29],[-20,37],[-25,7],[-56,16],[-35,23],[-26,43],[-75,41],[10,31],[33,20]],[[748,3709],[28,0],[171,0],[111,-1],[63,0]],[[1717,3010],[78,-124],[-61,-18]],[[1734,2868],[-57,-29],[3,-134],[-48,-24],[12,-100]],[[1644,2581],[-103,0],[-79,4]],[[1462,2585],[-95,0]],[[1367,2585],[17,97],[-21,-1],[-23,69],[8,68],[-45,49],[-54,21],[-24,59],[-82,0],[-28,-23],[23,-49],[-257,0],[8,-138],[-72,0]],[[588,2919],[-5,168],[97,0],[-1,279],[-22,68],[141,0],[-30,21],[45,54],[-68,46],[23,26],[-15,78],[19,28],[-24,22]],[[2832,499],[-7,-108],[1,-113],[0,-48],[0,-33],[4,-121],[-42,15],[-12,34],[-33,32],[-13,39],[-25,36],[-31,45],[-30,21]],[[2644,298],[2,482],[12,233],[-104,0],[-70,81],[-83,44]],[[2401,1138],[57,-2],[26,30]],[[969,1826],[11,5],[277,0]],[[1433,1252],[1,-1]],[[1434,1251],[-7,-46],[-96,-31],[-75,-74],[-23,25],[-44,-80]],[[1189,1045],[-13,15],[-25,-4],[0,-34],[-39,-40],[-58,-47],[-37,-6],[-16,-45],[-50,10],[-50,40],[-28,12],[-10,21],[-8,17],[1,36],[21,14],[-3,43],[-33,46],[26,45],[53,16],[20,22],[-14,23],[6,40],[-22,22],[-22,33],[11,54],[-35,23],[4,34],[39,5],[-2,51],[5,29],[5,30],[5,61],[22,20],[-11,70],[29,7],[12,56],[6,56],[-9,6]],[[2183,1098],[60,82],[89,4],[69,-46]],[[2644,298],[-5,3],[-30,-27],[-10,-20]],[[2599,254],[-11,10],[-173,0],[0,58],[-161,2],[0,34],[-58,1],[-13,139],[-81,0],[0,71],[-69,0],[0,210],[-27,75],[-70,-2],[-35,34],[2,113]],[[4653,1907],[19,-61],[-25,-67],[32,-81]],[[4679,1698],[0,-81],[-83,1],[-48,-47],[-9,-59],[-166,0],[-47,-22],[0,-83],[-212,-1]],[[4114,1406],[0,117],[-47,70],[1,70],[-25,100],[-48,1],[-12,139]],[[5797,3358],[470,-1]],[[6792,3218],[0,-119],[1,-197]],[[6793,2902],[-31,3],[-24,44],[-59,-19],[-169,77],[-78,-19],[-80,13],[-39,25],[-31,-45],[-62,-13],[-69,20],[-9,-29]],[[5775,2913],[22,168],[0,277]],[[3537,632],[62,0],[0,76],[45,0],[0,35],[50,70],[93,58],[93,0],[0,47],[36,0],[1,51],[33,-4],[54,27],[74,-4]],[[4078,988],[34,22],[-11,-70],[58,-22],[31,-47]],[[4190,871],[-21,-25],[-10,-68],[0,-105],[341,2],[-68,-101],[-23,-69],[5,-6]],[[4414,499],[-142,-1],[-69,0],[-249,0],[-24,5],[-266,-3],[-127,0]],[[2626,2895],[0,-231]],[[2626,2664],[-146,-1],[0,-69],[-145,0],[-3,-89],[-68,13]],[[2264,2518],[-130,-9],[-23,29],[-49,9],[-14,41],[-67,39],[-131,-43],[-43,25],[-33,52],[1,106],[-41,101]],[[1644,2581],[12,-64],[36,-21],[0,-249],[149,-2],[1,-277],[147,2],[0,-108],[69,0],[1,-35],[50,0],[13,-24],[-10,-42],[3,-123]],[[2115,1638],[-77,-70],[-69,-23],[7,-31]],[[1976,1514],[-271,0]],[[1554,1968],[0,279],[-92,0],[0,338]],[[0,3709],[311,0],[166,-1],[271,1]],[[0,3079],[0,75],[0,138],[0,16],[0,401]],[[4114,1406],[-82,0]],[[4032,1406],[-279,0],[0,-70]],[[4190,871],[186,-3],[0,23],[70,0],[0,23],[70,0],[12,212],[0,93],[94,23],[47,23],[0,24],[70,0],[0,46],[92,0]],[[4831,1335],[49,0],[0,-70],[141,0],[0,-34],[70,0],[0,-35],[64,0]],[[5155,1196],[0,-31],[35,0],[-20,-35],[0,-84],[105,-6],[-24,-259],[1,-139],[276,0]],[[5537,493],[-354,2],[-262,4],[-316,0],[-48,0],[-143,0]],[[6793,2902],[0,-20],[1,-134],[-1,-160],[0,-166]],[[2705,3706],[150,0],[148,1]],[[2996,3082],[-41,0],[0,-70],[-329,-1]],[[6792,1815],[1,-81],[0,-25],[-1,-148],[0,-36],[0,-269],[1,-51]],[[5623,3708],[35,0],[156,0],[237,0],[52,0],[116,0]],[[5797,3358],[-122,-1],[0,210],[-74,0],[22,141]],[[3712,3709],[135,-1],[141,0],[260,0],[173,0]],[[3684,2696],[2,317]],[[1976,1514],[-22,-24],[11,-46]],[[1677,1188],[-53,20],[-112,-101],[-78,144]],[[2599,254],[-7,-13],[-29,-78],[-24,-22],[-31,1],[-49,3],[-59,-39],[-36,42],[-92,-21],[-52,-8],[-54,13],[-37,20],[-41,-32],[-16,-65],[-48,26],[-73,8],[-60,10],[-15,-3],[-53,-46],[4,-28],[-3,-2],[-31,-20],[-39,30],[-32,44],[0,37],[-31,48],[7,41],[-29,64],[-18,45],[-65,47],[-31,-19],[-43,28],[-25,7],[-30,54],[15,35],[6,43],[-8,42],[-33,32],[-37,23],[-42,86],[-49,72],[2,48],[-17,35],[1,42],[-24,34],[-2,63],[-31,17],[-21,16],[-28,31]],[[4679,1698],[24,-11]],[[4703,1687],[71,-105],[82,-139],[-25,-108]],[[4078,988],[-35,57],[2,223],[-13,138]],[[2264,2518],[2,-260],[38,-7],[20,-33],[86,-11],[0,-173],[75,0]],[[2411,1757],[-136,0],[-31,-42],[-69,-14],[16,-34],[-76,-29]],[[5019,3708],[318,0],[217,0],[69,0]],[[3061,2438],[0,23],[-73,0],[0,64],[-54,0],[-105,59],[42,80],[-245,0]],[[1367,2585],[-178,0],[10,-1],[12,-68],[-24,-31],[46,-67],[0,-83],[28,-16],[0,-70],[-64,0],[0,-35],[-143,0]],[[4703,1687],[319,1],[12,-70],[70,0],[12,-72],[0,-138],[39,2],[0,-214]],[[969,1826],[-14,11],[-52,-16],[-53,-3],[-25,6],[-17,5],[-3,44],[-29,15]]],"objects":{"cb_2015_montana_county_20m":{"type":"GeometryCollection","geometries":[{"arcs":[[0,1,2,3,4]],"type":"Polygon","properties":{"STATEFP":"30","COUNTYFP":"107","COUNTYNS":"01719560","AFFGEOID":"0500000US30107","GEOID":"30107","NAME":"Wheatland","LSAD":"06","ALAND":3684213378,"AWATER":13010925}},{"arcs":[[5,6,7]],"type":"Polygon","properties":{"STATEFP":"30","COUNTYFP":"091","COUNTYNS":"01677577","AFFGEOID":"0500000US30091","GEOID":"30091","NAME":"Sheridan","LSAD":"06","ALAND":4340270472,"AWATER":75077762}},{"arcs":[[8,9,10,11,12]],"type":"Polygon","properties":{"STATEFP":"30","COUNTYFP":"075","COUNTYNS":"01719584","AFFGEOID":"0500000US30075","GEOID":"30075","NAME":"Powder River","LSAD":"06","ALAND":8542358767,"AWATER":1565958}},{"arcs":[[13,14,15,16,17,18]],"type":"Polygon","properties":{"STATEFP":"30","COUNTYFP":"073","COUNTYNS":"01719587","AFFGEOID":"0500000US30073","GEOID":"30073","NAME":"Pondera","LSAD":"06","ALAND":4207497555,"AWATER":43979774}},{"arcs":[[19,20,21,22,23]],"type":"Polygon","properties":{"STATEFP":"30","COUNTYFP":"109","COUNTYNS":"01696629","AFFGEOID":"0500000US30109","GEOID":"30109","NAME":"Wibaux","LSAD":"06","ALAND":2301427764,"AWATER":1756850}},{"arcs":[[24,25,26,27,28,29,30]],"type":"Polygon","properties":{"STATEFP":"30","COUNTYFP":"033","COUNTYNS":"01716058","AFFGEOID":"0500000US30033","GEOID":"30033","NAME":"Garfield","LSAD":"06","ALAND":12112207601,"AWATER":446716183}},{"arcs":[[31,32,33,34]],"type":"Polygon","properties":{"STATEFP":"30","COUNTYFP":"041","COUNTYNS":"01720048","AFFGEOID":"0500000US30041","GEOID":"30041","NAME":"Hill","LSAD":"06","ALAND":7509065661,"AWATER":44201872}},{"arcs":[[35,36,-14,37]],"type":"Polygon","properties":{"STATEFP":"30","COUNTYFP":"035","COUNTYNS":"01719607","AFFGEOID":"0500000US30035","GEOID":"30035","NAME":"Glacier","LSAD":"06","ALAND":7756722585,"AWATER":106140211}},{"arcs":[[38,-4,39,40,41]],"type":"Polygon","properties":{"STATEFP":"30","COUNTYFP":"097","COUNTYNS":"01719569","AFFGEOID":"0500000US30097","GEOID":"30097","NAME":"Sweet Grass","LSAD":"06","ALAND":4805558677,"AWATER":17639847}},{"arcs":[[42,43,-1,44,45]],"type":"Polygon","properties":{"STATEFP":"30","COUNTYFP":"045","COUNTYNS":"01719602","AFFGEOID":"0500000US30045","GEOID":"30045","NAME":"Judith Basin","LSAD":"06","ALAND":4842662499,"AWATER":2066731}},{"arcs":[[46,47,48,49]],"type":"Polygon","properties":{"STATEFP":"30","COUNTYFP":"093","COUNTYNS":"01719575","AFFGEOID":"0500000US30093","GEOID":"30093","NAME":"Silver Bow","LSAD":"06","ALAND":1859598425,"AWATER":1522160}},{"arcs":[[50,51,52,53]],"type":"Polygon","properties":{"STATEFP":"30","COUNTYFP":"007","COUNTYNS":"01719625","AFFGEOID":"0500000US30007","GEOID":"30007","NAME":"Broadwater","LSAD":"06","ALAND":3087316637,"AWATER":119289206}},{"arcs":[[-29,54,55,56,-9,57]],"type":"Polygon","properties":{"STATEFP":"30","COUNTYFP":"017","COUNTYNS":"01720109","AFFGEOID":"0500000US30017","GEOID":"30017","NAME":"Custer","LSAD":"06","ALAND":9798804902,"AWATER":25523467}},{"arcs":[[58,59,-25,60,61,62]],"type":"Polygon","properties":{"STATEFP":"30","COUNTYFP":"071","COUNTYNS":"01720023","AFFGEOID":"0500000US30071","GEOID":"30071","NAME":"Phillips","LSAD":"06","ALAND":13313557752,"AWATER":185538524}},{"arcs":[[63,64,-62,65,66,67,-2,-44]],"type":"Polygon","properties":{"STATEFP":"30","COUNTYFP":"027","COUNTYNS":"01719614","AFFGEOID":"0500000US30027","GEOID":"30027","NAME":"Fergus","LSAD":"06","ALAND":11238872754,"AWATER":27700322}},{"arcs":[[68,69,70,71,72,73]],"type":"Polygon","properties":{"STATEFP":"30","COUNTYFP":"089","COUNTYNS":"01719578","AFFGEOID":"0500000US30089","GEOID":"30089","NAME":"Sanders","LSAD":"06","ALAND":7149653471,"AWATER":76377031}},{"arcs":[[-61,-31,74,75,-66]],"type":"Polygon","properties":{"STATEFP":"30","COUNTYFP":"069","COUNTYNS":"01719590","AFFGEOID":"0500000US30069","GEOID":"30069","NAME":"Petroleum","LSAD":"06","ALAND":4288041275,"AWATER":48927318}},{"arcs":[[76,77,78,79]],"type":"Polygon","properties":{"STATEFP":"30","COUNTYFP":"039","COUNTYNS":"01719605","AFFGEOID":"0500000US30039","GEOID":"30039","NAME":"Granite","LSAD":"06","ALAND":4473268340,"AWATER":14547083}},{"arcs":[[80,81,-24,82,-55,-28]],"type":"Polygon","properties":{"STATEFP":"30","COUNTYFP":"079","COUNTYNS":"01715847","AFFGEOID":"0500000US30079","GEOID":"30079","NAME":"Prairie","LSAD":"06","ALAND":4497958392,"AWATER":15092932}},{"arcs":[[83,84,-42,85,86,87]],"type":"Polygon","properties":{"STATEFP":"30","COUNTYFP":"067","COUNTYNS":"01720027","AFFGEOID":"0500000US30067","GEOID":"30067","NAME":"Park","LSAD":"06","ALAND":7259490989,"AWATER":27015343}},{"arcs":[[88,89,90,-81,-27,91]],"type":"Polygon","properties":{"STATEFP":"30","COUNTYFP":"055","COUNTYNS":"01716270","AFFGEOID":"0500000US30055","GEOID":"30055","NAME":"McCone","LSAD":"06","ALAND":6843602621,"AWATER":103093129}},{"arcs":[[92,93,-15,-37]],"type":"Polygon","properties":{"STATEFP":"30","COUNTYFP":"101","COUNTYNS":"01719566","AFFGEOID":"0500000US30101","GEOID":"30101","NAME":"Toole","LSAD":"06","ALAND":4959694374,"AWATER":78009540}},{"arcs":[[94,-20,-82,-91]],"type":"Polygon","properties":{"STATEFP":"30","COUNTYFP":"021","COUNTYNS":"01715632","AFFGEOID":"0500000US30021","GEOID":"30021","NAME":"Dawson","LSAD":"06","ALAND":6143899768,"AWATER":29279964}},{"arcs":[[-57,95,96,-10]],"type":"Polygon","properties":{"STATEFP":"30","COUNTYFP":"011","COUNTYNS":"01688746","AFFGEOID":"0500000US30011","GEOID":"30011","NAME":"Carter","LSAD":"06","ALAND":8651779114,"AWATER":19499108}},{"arcs":[[97,-45,-5,-39,-85,98,-52,99]],"type":"Polygon","properties":{"STATEFP":"30","COUNTYFP":"059","COUNTYNS":"01719600","AFFGEOID":"0500000US30059","GEOID":"30059","NAME":"Meagher","LSAD":"06","ALAND":6194857385,"AWATER":7404298}},{"arcs":[[-73,100,101]],"type":"Polygon","properties":{"STATEFP":"30","COUNTYFP":"061","COUNTYNS":"01720030","AFFGEOID":"0500000US30061","GEOID":"30061","NAME":"Mineral","LSAD":"06","ALAND":3158843928,"AWATER":9897206}},{"arcs":[[102,-38,-19,103,104,105,106,107,-70,108]],"type":"Polygon","properties":{"STATEFP":"30","COUNTYFP":"029","COUNTYNS":"01719611","AFFGEOID":"0500000US30029","GEOID":"30029","NAME":"Flathead","LSAD":"06","ALAND":13175882902,"AWATER":437082640}},{"arcs":[[-53,-99,-84,109,110,111]],"type":"Polygon","properties":{"STATEFP":"30","COUNTYFP":"031","COUNTYNS":"01720053","AFFGEOID":"0500000US30031","GEOID":"30031","NAME":"Gallatin","LSAD":"06","ALAND":6746197554,"AWATER":75237084}},{"arcs":[[112,-80,113,114,115]],"type":"Polygon","properties":{"STATEFP":"30","COUNTYFP":"081","COUNTYNS":"01719582","AFFGEOID":"0500000US30081","GEOID":"30081","NAME":"Ravalli","LSAD":"06","ALAND":6192590028,"AWATER":24247021}},{"arcs":[[-49,116,-111,117,118]],"type":"Polygon","properties":{"STATEFP":"30","COUNTYFP":"057","COUNTYNS":"01720033","AFFGEOID":"0500000US30057","GEOID":"30057","NAME":"Madison","LSAD":"06","ALAND":9293431729,"AWATER":39686248}},{"arcs":[[-67,-76,119,120,121]],"type":"Polygon","properties":{"STATEFP":"30","COUNTYFP":"065","COUNTYNS":"01719593","AFFGEOID":"0500000US30065","GEOID":"30065","NAME":"Musselshell","LSAD":"06","ALAND":4840652081,"AWATER":7123215}},{"arcs":[[122,-7,123,124,-89,125]],"type":"Polygon","properties":{"STATEFP":"30","COUNTYFP":"085","COUNTYNS":"01669428","AFFGEOID":"0500000US30085","GEOID":"30085","NAME":"Roosevelt","LSAD":"06","ALAND":6097957344,"AWATER":37820803}},{"arcs":[[126,127,128,129,-87]],"type":"Polygon","properties":{"STATEFP":"30","COUNTYFP":"009","COUNTYNS":"01720111","AFFGEOID":"0500000US30009","GEOID":"30009","NAME":"Carbon","LSAD":"06","ALAND":5304126731,"AWATER":34674674}},{"arcs":[[-18,130,131,132,-104]],"type":"Polygon","properties":{"STATEFP":"30","COUNTYFP":"099","COUNTYNS":"01720018","AFFGEOID":"0500000US30099","GEOID":"30099","NAME":"Teton","LSAD":"06","ALAND":5883404830,"AWATER":52657911}},{"arcs":[[-106,133,134,135,-78,136]],"type":"Polygon","properties":{"STATEFP":"30","COUNTYFP":"077","COUNTYNS":"01720021","AFFGEOID":"0500000US30077","GEOID":"30077","NAME":"Powell","LSAD":"06","ALAND":6024437069,"AWATER":16220808}},{"arcs":[[137,-109,-69,138]],"type":"Polygon","properties":{"STATEFP":"30","COUNTYFP":"053","COUNTYNS":"01720038","AFFGEOID":"0500000US30053","GEOID":"30053","NAME":"Lincoln","LSAD":"06","ALAND":9356922529,"AWATER":161078666}},{"arcs":[[-3,-68,-122,139,140,-40]],"type":"Polygon","properties":{"STATEFP":"30","COUNTYFP":"037","COUNTYNS":"01723078","AFFGEOID":"0500000US30037","GEOID":"30037","NAME":"Golden Valley","LSAD":"06","ALAND":3041743931,"AWATER":2621792}},{"arcs":[[141,142,143,-12,144,-129]],"type":"Polygon","properties":{"STATEFP":"30","COUNTYFP":"003","COUNTYNS":"01716521","AFFGEOID":"0500000US30003","GEOID":"30003","NAME":"Big Horn","LSAD":"06","ALAND":12942492843,"AWATER":49185856}},{"arcs":[[-90,-125,145,-21,-95]],"type":"Polygon","properties":{"STATEFP":"30","COUNTYFP":"083","COUNTYNS":"01715338","AFFGEOID":"0500000US30083","GEOID":"30083","NAME":"Richland","LSAD":"06","ALAND":5398471136,"AWATER":49588405}},{"arcs":[[-94,146,-35,147,-16]],"type":"Polygon","properties":{"STATEFP":"30","COUNTYFP":"051","COUNTYNS":"01720036","AFFGEOID":"0500000US30051","GEOID":"30051","NAME":"Liberty","LSAD":"06","ALAND":3704088496,"AWATER":44389510}},{"arcs":[[-83,-23,148,-96,-56]],"type":"Polygon","properties":{"STATEFP":"30","COUNTYFP":"025","COUNTYNS":"01688745","AFFGEOID":"0500000US30025","GEOID":"30025","NAME":"Fallon","LSAD":"06","ALAND":4196968853,"AWATER":5915331}},{"arcs":[[149,-8,-123,150]],"type":"Polygon","properties":{"STATEFP":"30","COUNTYFP":"019","COUNTYNS":"01637566","AFFGEOID":"0500000US30019","GEOID":"30019","NAME":"Daniels","LSAD":"06","ALAND":3693585018,"AWATER":1021697}},{"arcs":[[151,-63,-65,152,-33]],"type":"Polygon","properties":{"STATEFP":"30","COUNTYFP":"005","COUNTYNS":"01722470","AFFGEOID":"0500000US30005","GEOID":"30005","NAME":"Blaine","LSAD":"06","ALAND":10948213994,"AWATER":29079150}},{"arcs":[[-79,-136,153,-47,154,-114]],"type":"Polygon","properties":{"STATEFP":"30","COUNTYFP":"023","COUNTYNS":"01719617","AFFGEOID":"0500000US30023","GEOID":"30023","NAME":"Deer Lodge","LSAD":"06","ALAND":1908004250,"AWATER":12199241}},{"arcs":[[-115,-155,-50,-119,155]],"type":"Polygon","properties":{"STATEFP":"30","COUNTYFP":"001","COUNTYNS":"01719627","AFFGEOID":"0500000US30001","GEOID":"30001","NAME":"Beaverhead","LSAD":"06","ALAND":14355471225,"AWATER":78345572}},{"arcs":[[-140,-121,156,157,-142,-128,158]],"type":"Polygon","properties":{"STATEFP":"30","COUNTYFP":"111","COUNTYNS":"01719558","AFFGEOID":"0500000US30111","GEOID":"30111","NAME":"Yellowstone","LSAD":"06","ALAND":6819683757,"AWATER":40851911}},{"arcs":[[-133,159,-100,-51,160,-134,-105]],"type":"Polygon","properties":{"STATEFP":"30","COUNTYFP":"049","COUNTYNS":"00793926","AFFGEOID":"0500000US30049","GEOID":"30049","NAME":"Lewis and Clark","LSAD":"06","ALAND":8957621068,"AWATER":101077021}},{"arcs":[[161,-151,-126,-92,-26,-60]],"type":"Polygon","properties":{"STATEFP":"30","COUNTYFP":"105","COUNTYNS":"01678923","AFFGEOID":"0500000US30105","GEOID":"30105","NAME":"Valley","LSAD":"06","ALAND":12758875092,"AWATER":351462598}},{"arcs":[[-148,-34,-153,-64,-43,162,-131,-17]],"type":"Polygon","properties":{"STATEFP":"30","COUNTYFP":"015","COUNTYNS":"01719619","AFFGEOID":"0500000US30015","GEOID":"30015","NAME":"Chouteau","LSAD":"06","ALAND":10288581590,"AWATER":62618447}},{"arcs":[[-108,163,-71]],"type":"Polygon","properties":{"STATEFP":"30","COUNTYFP":"047","COUNTYNS":"01796943","AFFGEOID":"0500000US30047","GEOID":"30047","NAME":"Lake","LSAD":"06","ALAND":3860279421,"AWATER":423557170}},{"arcs":[[-132,-163,-46,-98,-160]],"type":"Polygon","properties":{"STATEFP":"30","COUNTYFP":"013","COUNTYNS":"01719622","AFFGEOID":"0500000US30013","GEOID":"30013","NAME":"Cascade","LSAD":"06","ALAND":6988361955,"AWATER":34331733}},{"arcs":[[164,-143,-158]],"type":"Polygon","properties":{"STATEFP":"30","COUNTYFP":"103","COUNTYNS":"01719563","AFFGEOID":"0500000US30103","GEOID":"30103","NAME":"Treasure","LSAD":"06","ALAND":2532085947,"AWATER":17149961}},{"arcs":[[-30,-58,-13,-144,-165,-157,-120,-75]],"type":"Polygon","properties":{"STATEFP":"30","COUNTYFP":"087","COUNTYNS":"01716795","AFFGEOID":"0500000US30087","GEOID":"30087","NAME":"Rosebud","LSAD":"06","ALAND":12972748900,"AWATER":43034238}},{"arcs":[[-72,-164,-107,-137,-77,-113,165,-101]],"type":"Polygon","properties":{"STATEFP":"30","COUNTYFP":"063","COUNTYNS":"01719596","AFFGEOID":"0500000US30063","GEOID":"30063","NAME":"Missoula","LSAD":"06","ALAND":6715988454,"AWATER":64467912}},{"arcs":[[-135,-161,-54,-112,-117,-48,-154]],"type":"Polygon","properties":{"STATEFP":"30","COUNTYFP":"043","COUNTYNS":"01720045","AFFGEOID":"0500000US30043","GEOID":"30043","NAME":"Jefferson","LSAD":"06","ALAND":4291406516,"AWATER":6605901}},{"arcs":[[-141,-159,-127,-86,-41]],"type":"Polygon","properties":{"STATEFP":"30","COUNTYFP":"095","COUNTYNS":"01719572","AFFGEOID":"0500000US30095","GEOID":"30095","NAME":"Stillwater","LSAD":"06","ALAND":4653276351,"AWATER":23988007}}]}}}

/***/ }),
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  scale: 160,
	  xOffset: 0,
	  yOffset: 0,
	  rotation: [0, 0, 0],
	  precision: 0.1
	};

/***/ }),
/* 586 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	
	  GLOBAL: {
	    HIDE: '__react_tooltip_hide_event',
	    REBUILD: '__react_tooltip_rebuild_event',
	    SHOW: '__react_tooltip_show_event'
	  }
	};

/***/ }),
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactEmotion = __webpack_require__(21);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _ramda = __webpack_require__(70);
	
	var _consts = __webpack_require__(28);
	
	var _Tooltip = __webpack_require__(481);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var width = 180;
	var dotted = "2px dotted #ababab";
	
	var Wrapper = /*#__PURE__*/(0, _reactEmotion2.default)("div", {
	  target: "ezpxb3t0"
	})("position:relative;height:100%;min-height:700px;display:flex;flex-direction:column;");
	var AverageText = /*#__PURE__*/(0, _reactEmotion2.default)("h5", {
	  target: "ezpxb3t1"
	})("color:#7c7c7c;margin:8px 0 0 6px;font-size:12px;border-bottom:", dotted, ";padding-bottom:3px;transform:translateY(3px);width:calc(", function (_ref) {
	  var width = _ref.width;
	  return width;
	}, " - 4px);min-width:95px;");
	var Container = /*#__PURE__*/(0, _reactEmotion2.default)("div", {
	  target: "ezpxb3t2"
	})("position:relative;width:", width, "px;display:flex;flex:1;flex-direction:column;justify-content:center;align-items:flex-start;padding:15px 0 5px 0;overflow:hidden;");
	var AverageLine = /*#__PURE__*/(0, _reactEmotion2.default)("div", {
	  target: "ezpxb3t3"
	})("position:absolute;left:", function (_ref2) {
	  var left = _ref2.left;
	  return left;
	}, ";height:100%;width:0;border-left:", dotted, ";pointer-events:none;box-shadow:0 0 3px 1px rgba(255,255,255,0.3);");
	var CountyBlock = /*#__PURE__*/(0, _reactEmotion2.default)("a", {
	  target: "ezpxb3t4"
	})("display:block;flex:1;width:100%;position:relative;transition:opacity 0.2s;opacity:", function (_ref3) {
	  var hovered = _ref3.hovered;
	  return hovered ? 1 : 0.7;
	}, ";cursor:pointer;&:hover{opacity:1;z-index:1;}");
	var Bar = /*#__PURE__*/(0, _reactEmotion2.default)("span", {
	  target: "ezpxb3t5"
	})("position:absolute;top:0;left:0;bottom:0;");
	var Text = /*#__PURE__*/(0, _reactEmotion2.default)("span", {
	  target: "ezpxb3t6"
	})("position:absolute;top:50%;left:6px;color:black;font-size:11px;line-height:10px;font-weight:400;transition:transform 0.2s;transform:translate(", function (_ref4) {
	  var hovered = _ref4.hovered;
	  return hovered ? 6 : 0;
	}, "px,-50%);span{font-weight:600;}&::after{content:\"\";position:absolute;left:-12px;width:0;height:0;border-style:solid;border-width:5px 0 5px 6px;border-color:transparent transparent transparent ", _consts.colors.primaryDark, ";}");
	
	var CountyList = function (_React$Component) {
	  _inherits(CountyList, _React$Component);
	
	  function CountyList() {
	    _classCallCheck(this, CountyList);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  CountyList.prototype.render = function render() {
	    var _props = this.props,
	        indicatorData = _props.indicatorData,
	        hoveredCounty = _props.hoveredCounty,
	        setHoveredCounty = _props.setHoveredCounty,
	        dataSheetUrl = _props.dataSheetUrl;
	
	
	    return _react2.default.createElement(
	      Wrapper,
	      null,
	      _react2.default.createElement(
	        AverageText,
	        { width: indicatorData.averageRatio + "%" },
	        "Montana: ",
	        indicatorData.averageString
	      ),
	      _react2.default.createElement(
	        Container,
	        null,
	        indicatorData.countyList.map(function (county) {
	          var hovered = hoveredCounty + " County" === county.name;
	          return _react2.default.createElement(
	            CountyBlock,
	            {
	              key: county.name,
	              hovered: hovered,
	              onMouseEnter: function onMouseEnter() {
	                // give onMouseLeave event's setState time to finish
	                setTimeout(function () {
	                  setHoveredCounty((0, _ramda.replace)(" County", "", county.name));
	                }, 10);
	              },
	              onMouseLeave: function onMouseLeave() {
	                setHoveredCounty(null);
	              },
	              href: dataSheetUrl,
	              target: "_blank",
	              "data-tip": "\n                <div>\n                  <h5 class=\"tooltip-download\">Click to download Data Sheet (PDF)</h5>\n                </div>\n              ",
	              "data-place": "right",
	              "data-delay-show": 500
	            },
	            _react2.default.createElement(Bar, {
	              style: {
	                width: county.width,
	                backgroundColor: county.backgroundColor
	              }
	            }),
	            _react2.default.createElement(
	              Text,
	              { hovered: hovered },
	              county.name,
	              ": ",
	              _react2.default.createElement(
	                "span",
	                null,
	                county.valueString
	              )
	            )
	          );
	        }),
	        _react2.default.createElement(AverageLine, { left: indicatorData.averageRatio + "%" })
	      ),
	      _react2.default.createElement(_Tooltip2.default, null)
	    );
	  };
	
	  return CountyList;
	}(_react2.default.Component);
	
	CountyList.propTypes = {
	  indicatorData: _propTypes2.default.object.isRequired,
	  hoveredCounty: _propTypes2.default.string,
	  setHoveredCounty: _propTypes2.default.func.isRequired
	};
	exports.default = CountyList;
	module.exports = exports["default"];

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactEmotion = __webpack_require__(21);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _reactShow = __webpack_require__(1005);
	
	var _reactShow2 = _interopRequireDefault(_reactShow);
	
	var _consts = __webpack_require__(28);
	
	var _Content = __webpack_require__(210);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Wrapper = /*#__PURE__*/(0, _reactEmotion2.default)("div", {
	  target: "egcsa8u0"
	})("display:flex;justify-content:center;width:100%;");
	var Content = /*#__PURE__*/(0, _reactEmotion2.default)("div", {
	  target: "egcsa8u1"
	})("width:320px;padding-left:30px;border-left:1px solid #dbdcde;");
	var LegendBar = /*#__PURE__*/(0, _reactEmotion2.default)("div", {
	  target: "egcsa8u2"
	})("width:100%;height:24px;background-image:", function (_ref) {
	  var reverse = _ref.reverse;
	  return _consts.dataGradient[reverse ? "reverse" : "normal"];
	}, ";");
	var LegendFlex = /*#__PURE__*/(0, _reactEmotion2.default)("div", {
	  target: "egcsa8u3"
	})("display:flex;justify-content:space-between;margin-top:4px;");
	var LegendText = /*#__PURE__*/(0, _reactEmotion2.default)("div", {
	  target: "egcsa8u4"
	})("color:", _consts.colors.primaryDark, ";font-size:12px;");
	var InfoContainer = /*#__PURE__*/(0, _reactEmotion2.default)("div", {
	  target: "egcsa8u5"
	})("display:flex;flex-direction:column;align-items:flex-start;margin-top:15px;");
	var InfoButton = /*#__PURE__*/(0, _reactEmotion2.default)("button", {
	  target: "egcsa8u6"
	})("margin-top:6px;font-size:14px;color:", _consts.colors.active, ";background:none;border:none;padding:3px 0;transition-duration:0.2s;cursor:pointer;&:hover{color:", _consts.colors.primaryDark, ";}");
	var Icon = /*#__PURE__*/(0, _reactEmotion2.default)("i", {
	  target: "egcsa8u7"
	})("display:inline-block;margin-left:6px;font-size:12px;transition:transform 0.2s;");
	var InfoContent = /*#__PURE__*/(0, _reactEmotion2.default)(_Content.MarkdownStringContent, {
	  target: "egcsa8u8"
	})("margin:6px 0 18px 0;p,ol,ul{font-size:12px;}");
	
	var flipStyle = function flipStyle(flipped) {
	  return flipped ? { transform: "rotateX(180deg)" } : { transform: "rotateX(0)" };
	};
	
	var IndicatorInfo = function (_React$Component) {
	  _inherits(IndicatorInfo, _React$Component);
	
	  function IndicatorInfo() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, IndicatorInfo);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = { show: null }, _this.toggleNotes = function (e) {
	      _this.setState(function (prevState) {
	        return prevState.show === "notes" ? { show: null } : { show: "notes" };
	      });
	    }, _this.toggleSource = function (e) {
	      _this.setState(function (prevState) {
	        return prevState.show === "source" ? { show: null } : { show: "source" };
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  IndicatorInfo.prototype.render = function render() {
	    var _props = this.props,
	        toggleSourceModal = _props.toggleSourceModal,
	        toggleNotesModal = _props.toggleNotesModal,
	        indicator = _props.indicator,
	        indicatorData = _props.indicatorData;
	    var title = indicator.title,
	        dataKey = indicator.dataKey,
	        description = indicator.description,
	        notes = indicator.notes,
	        source = indicator.source;
	    var lowerIsBetter = indicatorData.lowerIsBetter,
	        minString = indicatorData.minString,
	        maxString = indicatorData.maxString;
	
	    var showSource = this.state.show === "source";
	    var showNotes = this.state.show === "notes";
	    return _react2.default.createElement(
	      Wrapper,
	      null,
	      _react2.default.createElement(
	        Content,
	        null,
	        _react2.default.createElement(
	          "h6",
	          null,
	          title
	        ),
	        _react2.default.createElement(
	          "h3",
	          null,
	          description
	        ),
	        _react2.default.createElement(LegendBar, { reverse: lowerIsBetter }),
	        _react2.default.createElement(
	          LegendFlex,
	          null,
	          _react2.default.createElement(
	            LegendText,
	            null,
	            minString
	          ),
	          _react2.default.createElement(
	            LegendText,
	            null,
	            maxString
	          )
	        ),
	        _react2.default.createElement(
	          InfoContainer,
	          null,
	          _react2.default.createElement(
	            InfoButton,
	            { onClick: this.toggleSource },
	            "Source",
	            " ",
	            _react2.default.createElement(Icon, {
	              className: "icon-arrow-down icons",
	              style: flipStyle(showSource)
	            })
	          ),
	          _react2.default.createElement(
	            _reactShow2.default,
	            { show: showSource },
	            _react2.default.createElement(InfoContent, { content: source })
	          ),
	          _react2.default.createElement(
	            InfoButton,
	            { onClick: this.toggleNotes },
	            "Notes",
	            " ",
	            _react2.default.createElement(Icon, {
	              className: "icon-arrow-down icons",
	              style: flipStyle(showNotes)
	            })
	          ),
	          _react2.default.createElement(
	            _reactShow2.default,
	            { show: showNotes },
	            _react2.default.createElement(InfoContent, { content: notes })
	          )
	        )
	      )
	    );
	  };
	
	  return IndicatorInfo;
	}(_react2.default.Component);
	
	IndicatorInfo.propTypes = {
	  indicator: _propTypes2.default.object.isRequired,
	  indicatorData: _propTypes2.default.object.isRequired
	};
	exports.default = IndicatorInfo;
	module.exports = exports["default"];

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSimpleMaps = __webpack_require__(1019);
	
	var _reactEmotion = __webpack_require__(21);
	
	var _polished = __webpack_require__(100);
	
	var _Tooltip = __webpack_require__(481);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _montanaCounties = __webpack_require__(512);
	
	var _montanaCounties2 = _interopRequireDefault(_montanaCounties);
	
	var _consts = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var transitionDuration = 0.3;
	var rsmStyles = /*#__PURE__*/(0, _reactEmotion.css)(".rsm-geography{transition:fill ", transitionDuration, "s;}");
	
	var MTMap = function (_React$Component) {
	  _inherits(MTMap, _React$Component);
	
	  function MTMap() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MTMap);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.openDataSheet = function () {
	      window.open(_this.props.dataSheetUrl, "_blank");
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  MTMap.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        indicatorData = _props.indicatorData,
	        setHoveredCounty = _props.setHoveredCounty,
	        hoveredCounty = _props.hoveredCounty;
	
	    return _react2.default.createElement(
	      _react2.default.Fragment,
	      null,
	      _react2.default.createElement(
	        _reactSimpleMaps.ComposableMap,
	        {
	          className: rsmStyles,
	          projection: "mercator",
	          projectionConfig: {
	            scale: 3400
	          },
	          width: 980,
	          height: 551,
	          style: {
	            width: "100%",
	            height: "auto"
	          }
	        },
	        _react2.default.createElement(
	          _reactSimpleMaps.ZoomableGroup,
	          { center: [-108, 47], zoom: 1, disablePanning: true },
	          _react2.default.createElement(
	            _reactSimpleMaps.Geographies,
	            { geography: _montanaCounties2.default, disableOptimization: true },
	            function (geographies, projection) {
	              return geographies.map(function (geography, i) {
	                // NOTE: I can use this to match it up to the data JSON and
	                // control style.
	                //
	                // Should be able to use chroma-js and d3-scale to control color
	                // See https://github.com/zcreativelabs/react-simple-maps/blob/master/examples/switching-between-datasets/pages/index.js
	                //
	                // Can use onMouseEnter, onMouseLeave, and onClick on Geography
	                // to control state for tooltips, highlights, etc.
	                var name = geography.properties.NAME;
	                var hovered = name === hoveredCounty;
	                // console.log(name);
	                var countyData = indicatorData.counties[name + " County"];
	                var fillColor = countyData.value ? indicatorData.colorScale(countyData.value) : _consts.colors.empty;
	                var hoveredFillColor = (0, _polished.saturate)(0.2, (0, _polished.darken)(0.2, fillColor));
	                return geography.id !== "ATA" && _react2.default.createElement(_reactSimpleMaps.Geography, {
	                  key: name,
	                  "data-tip": "\n                          <div>\n                            <div class=\"tooltip-wrapper\">\n                              <h4 class=\"tooltip-name\">" + name + " County</h4>\n                              <h4 class=\"tooltip-value\">" + countyData.valueString + "</h4>\n\n                            </div>\n                            <h5 class=\"tooltip-download mt\">Click to download Data Sheet (PDF)</h5>\n                          </div>\n                        ",
	                  onMouseEnter: function onMouseEnter(_ref, e) {
	                    var properties = _ref.properties;
	
	                    // give onMouseLeave event's setState time to finish
	                    setTimeout(function () {
	                      setHoveredCounty(properties.NAME);
	                    }, 10);
	                  },
	                  onMouseLeave: function onMouseLeave(_ref2, e) {
	                    var properties = _ref2.properties;
	
	                    setHoveredCounty(null);
	                  },
	                  onClick: _this2.openDataSheet,
	                  geography: geography,
	                  projection: projection,
	                  style: {
	                    default: {
	                      fill: hovered ? hoveredFillColor : fillColor,
	                      stroke: "#ffffff",
	                      strokeWidth: hovered ? 3 : 0.75,
	                      outline: "none",
	                      cursor: "pointer"
	                    },
	                    hover: {
	                      fill: hoveredFillColor,
	                      stroke: "#ffffff",
	                      strokeWidth: 3,
	                      outline: "none",
	                      cursor: "pointer"
	                    },
	                    pressed: {
	                      fill: hoveredFillColor,
	                      stroke: "#ffffff",
	                      strokeWidth: 0.75,
	                      outline: "none",
	                      cursor: "pointer"
	                    }
	                  }
	                });
	              });
	            }
	          )
	        )
	      ),
	      _react2.default.createElement(_Tooltip2.default, null)
	    );
	  };
	
	  return MTMap;
	}(_react2.default.Component);
	
	MTMap.propTypes = {
	  indicatorData: _propTypes2.default.object.isRequired,
	  hoveredCounty: _propTypes2.default.string,
	  setHoveredCounty: _propTypes2.default.func.isRequired
	};
	exports.default = MTMap;
	module.exports = exports["default"];

/***/ }),
/* 602 */,
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // percentage
	// currency
	// currency, lowerIsBetter
	// percentage, lowerIsBetter
	// percentage, lowerIsBetter
	// percentage, lowerIsBetter
	
	
	var _ramda = __webpack_require__(70);
	
	var _d3Scale = __webpack_require__(696);
	
	var _numeral = __webpack_require__(755);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	var _consts = __webpack_require__(28);
	
	var _affordableHousingSupply = __webpack_require__(746);
	
	var _affordableHousingSupply2 = _interopRequireDefault(_affordableHousingSupply);
	
	var _affordableRent = __webpack_require__(747);
	
	var _affordableRent2 = _interopRequireDefault(_affordableRent);
	
	var _fairMarketRent = __webpack_require__(748);
	
	var _fairMarketRent2 = _interopRequireDefault(_fairMarketRent);
	
	var _housingCostBurden = __webpack_require__(749);
	
	var _housingCostBurden2 = _interopRequireDefault(_housingCostBurden);
	
	var _povertyRate = __webpack_require__(750);
	
	var _povertyRate2 = _interopRequireDefault(_povertyRate);
	
	var _renterHouseholds = __webpack_require__(751);
	
	var _renterHouseholds2 = _interopRequireDefault(_renterHouseholds);
	
	var _workHoursNeeded = __webpack_require__(752);
	
	var _workHoursNeeded2 = _interopRequireDefault(_workHoursNeeded);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// number, lowerIsBetter
	
	var formats = {
	  percentage: "0.0%",
	  currency: "$0,0",
	  number: "0,0"
	};
	
	var colorRange = [_consts.colors.grad1, _consts.colors.grad2, _consts.colors.grad3, _consts.colors.grad4, _consts.colors.grad5];
	
	// this function returns:
	// {
	//   [dataKey]: {
	//     counties: {
	//       [county name]: {
	//         name: string,
	//         value: number,
	//         valueString: string,
	//         lci: number,
	//         uci: number
	//       }
	//     },
	//     average: number,
	//     averageRatio: number, // 0-1
	//     averageString: string,
	//     min: number,
	//     max: number
	//   },
	//   colorScale: function, // func that accepts value and returns color
	//   lowerIsBetter: boolean
	// }
	function processData(data, formatType) {
	  var lowerIsBetter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	  var baseWidth = arguments[3];
	
	  var nAverage = (0, _numeral2.default)(data[0].value);
	  var counties = (0, _ramda.tail)(data);
	  var result = counties.reduce(function (accum, county) {
	    var nValue = (0, _numeral2.default)(county.value);
	    var value = nValue.value();
	    accum.counties[county.county] = {
	      name: county.county,
	      value: value,
	      valueString: (0, _ramda.isEmpty)(county.value) ? "n/a" : nValue.format(formats[formatType]),
	      lci: county.lci ? (0, _numeral2.default)(county.lci).value() : undefined,
	      uci: county.uci ? (0, _numeral2.default)(county.uci).value() : undefined
	    };
	    if (value) {
	      accum.min = (0, _ramda.min)(accum.min, value);
	      accum.max = (0, _ramda.max)(accum.max, value);
	    }
	    return accum;
	  }, {
	    counties: {},
	    average: nAverage.value(),
	    averageString: nAverage.format(formats[formatType]),
	    min: 99999,
	    max: -99999
	  });
	
	  var relativeMax = result.max - result.min;
	  result.averageRatio = baseWidth + (result.average - result.min) / relativeMax * (100 - baseWidth);
	
	  result.minString = (0, _numeral2.default)(result.min).format(formats[formatType]);
	  result.maxString = (0, _numeral2.default)(result.max).format(formats[formatType]);
	
	  var numSteps = colorRange.length - 1;
	  var step = (result.max - result.min) / numSteps;
	  result.colorScale = (0, _d3Scale.scaleLinear)().domain([result.min].concat((0, _ramda.range)(1, numSteps).map(function (n) {
	    return result.min + step * n;
	  }))).range(lowerIsBetter ? (0, _ramda.reverse)(colorRange) : colorRange);
	
	  result.lowerIsBetter = !!lowerIsBetter;
	
	  result.countyList = (0, _ramda.pipe)(_ramda.values, (0, _ramda.sortWith)([lowerIsBetter ? (0, _ramda.ascend)((0, _ramda.prop)("value")) : (0, _ramda.descend)((0, _ramda.prop)("value")), (0, _ramda.ascend)((0, _ramda.prop)("name"))]), (0, _ramda.map)(function (county) {
	    var width = 0;
	    if (!(0, _ramda.isEmpty)(county.value)) {
	      var relativeValue = county.value - result.min;
	      width = relativeValue / relativeMax;
	    }
	    width = baseWidth + width * (100 - baseWidth) + "%";
	
	    var backgroundColor = county.value ? result.colorScale(county.value) : _consts.colors.empty;
	
	    return _extends({}, county, {
	      width: width,
	      backgroundColor: backgroundColor
	    });
	  }))(result.counties);
	
	  return result;
	}
	
	exports.default = {
	  "affordable-housing-supply": processData(_affordableHousingSupply2.default, "percentage", false, 10),
	  "affordable-rent": processData(_affordableRent2.default, "currency", false, 10),
	  "fair-market-rent": processData(_fairMarketRent2.default, "currency", true, 60),
	  "housing-cost-burden": processData(_housingCostBurden2.default, "percentage", true, 40),
	  "poverty-rate": processData(_povertyRate2.default, "percentage", true, 10),
	  "renter-households": processData(_renterHouseholds2.default, "percentage", true, 10),
	  "work-hours-needed": processData(_workHoursNeeded2.default, "number", true, 60)
	};
	module.exports = exports["default"];

/***/ }),
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(79);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactEmotion = __webpack_require__(21);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _reactRouterDom = __webpack_require__(52);
	
	var _ramda = __webpack_require__(70);
	
	var _polished = __webpack_require__(100);
	
	var _utils = __webpack_require__(108);
	
	var _consts = __webpack_require__(28);
	
	var _mapData = __webpack_require__(603);
	
	var _mapData2 = _interopRequireDefault(_mapData);
	
	var _MTMap = __webpack_require__(601);
	
	var _MTMap2 = _interopRequireDefault(_MTMap);
	
	var _CountyList = __webpack_require__(599);
	
	var _CountyList2 = _interopRequireDefault(_CountyList);
	
	var _IndicatorInfo = __webpack_require__(600);
	
	var _IndicatorInfo2 = _interopRequireDefault(_IndicatorInfo);
	
	var _MarkdownContent = __webpack_require__(107);
	
	var _MarkdownContent2 = _interopRequireDefault(_MarkdownContent);
	
	var _Content = __webpack_require__(210);
	
	var _montanaCounties = __webpack_require__(512);
	
	var _montanaCounties2 = _interopRequireDefault(_montanaCounties);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var countiesSorted = (0, _ramda.sort)((0, _ramda.ascend)(_ramda.identity), _montanaCounties2.default.objects.cb_2015_montana_county_20m.geometries.map(function (g) {
	  return g.properties.NAME;
	}));
	var getDataSheetUrl = function getDataSheetUrl(countyName) {
	  if (!countyName) return null;
	  var index = (0, _ramda.findIndex)(function (c) {
	    return c === countyName;
	  }, countiesSorted);
	  return "/datasheets/MBPC_CountyData_8.5x11_County" + (index + 1) + ".pdf";
	};
	
	var Wrapper = /*#__PURE__*/(0, _reactEmotion2.default)("div", {
	  target: "e1aec7h10"
	})("display:flex;flex:1;position:relative;");
	var DataContainer = /*#__PURE__*/(0, _reactEmotion2.default)("div", {
	  target: "e1aec7h11"
	})("display:flex;flex:1;align-items:center;");
	var MapContainer = /*#__PURE__*/(0, _reactEmotion2.default)("div", {
	  target: "e1aec7h12"
	})("display:flex;flex:1;align-items:center;");
	var FooterLinks = /*#__PURE__*/(0, _reactEmotion2.default)("div", {
	  target: "e1aec7h13"
	})("position:absolute;bottom:10px;width:50%;left:50%;transform:translateX(-50%);display:flex;justify-content:center;& > div{padding-right:10px;margin-right:10px;border-right:1px solid ", _consts.colors.primary, ";&:last-child{padding-right:0;margin-right:0;border-right:none;}}");
	var FooterLink = /*#__PURE__*/(0, _reactEmotion2.default)(_gatsbyLink2.default, {
	  target: "e1aec7h14"
	})("color:", _consts.colors.primary, ";text-decoration:none;transition-duration:0.2s;&:hover{color:", (0, _polished.darken)(0.1, _consts.colors.primary), ";}");
	
	var MapPage = function (_React$Component) {
	  _inherits(MapPage, _React$Component);
	
	  function MapPage() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MapPage);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = { hoveredCounty: null }, _this.setHoveredCounty = function (hoveredCounty) {
	      _this.setState({ hoveredCounty: hoveredCounty });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  MapPage.prototype.render = function render() {
	    var _props$data = this.props.data,
	        indicators = _props$data.map.frontmatter.indicators,
	        acknowledgments = _props$data.acknowledgments.html,
	        methodology = _props$data.methodology.html;
	    var hoveredCounty = this.state.hoveredCounty;
	
	    var selectedIndicator = (0, _utils.getSelectedIndicator)(this.props.location, indicators);
	
	    if (!this.props.location.search) {
	      return _react2.default.createElement(_reactRouterDom.Redirect, { to: "/map?key=" + indicators[0].dataKey });
	    }
	
	    var indicatorData = _mapData2.default[selectedIndicator.dataKey];
	    var dataSheetUrl = getDataSheetUrl(hoveredCounty);
	
	    return _react2.default.createElement(
	      Wrapper,
	      null,
	      _react2.default.createElement(
	        DataContainer,
	        null,
	        _react2.default.createElement(_CountyList2.default, {
	          indicatorData: indicatorData,
	          hoveredCounty: hoveredCounty,
	          setHoveredCounty: this.setHoveredCounty,
	          dataSheetUrl: dataSheetUrl
	        }),
	        _react2.default.createElement(_IndicatorInfo2.default, {
	          indicator: selectedIndicator,
	          indicatorData: indicatorData
	        })
	      ),
	      _react2.default.createElement(
	        MapContainer,
	        null,
	        _react2.default.createElement(_MTMap2.default, {
	          indicatorData: indicatorData,
	          hoveredCounty: hoveredCounty,
	          setHoveredCounty: this.setHoveredCounty,
	          dataSheetUrl: dataSheetUrl
	        })
	      ),
	      _react2.default.createElement(
	        FooterLinks,
	        null,
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            FooterLink,
	            { to: "/acknowledgments" },
	            "Acknowledgments"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            FooterLink,
	            { to: "/methodology" },
	            "Methodology"
	          )
	        )
	      )
	    );
	  };
	
	  return MapPage;
	}(_react2.default.Component);
	
	exports.default = MapPage;
	
	
	MapPage.propTypes = {
	  data: _propTypes2.default.shape({
	    markdownRemark: _propTypes2.default.object
	  })
	};
	
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ }),
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-collection/ Version 1.0.4. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var prefix = "$";
	
	function Map() {}
	
	Map.prototype = map.prototype = {
	  constructor: Map,
	  has: function(key) {
	    return (prefix + key) in this;
	  },
	  get: function(key) {
	    return this[prefix + key];
	  },
	  set: function(key, value) {
	    this[prefix + key] = value;
	    return this;
	  },
	  remove: function(key) {
	    var property = prefix + key;
	    return property in this && delete this[property];
	  },
	  clear: function() {
	    for (var property in this) if (property[0] === prefix) delete this[property];
	  },
	  keys: function() {
	    var keys = [];
	    for (var property in this) if (property[0] === prefix) keys.push(property.slice(1));
	    return keys;
	  },
	  values: function() {
	    var values = [];
	    for (var property in this) if (property[0] === prefix) values.push(this[property]);
	    return values;
	  },
	  entries: function() {
	    var entries = [];
	    for (var property in this) if (property[0] === prefix) entries.push({key: property.slice(1), value: this[property]});
	    return entries;
	  },
	  size: function() {
	    var size = 0;
	    for (var property in this) if (property[0] === prefix) ++size;
	    return size;
	  },
	  empty: function() {
	    for (var property in this) if (property[0] === prefix) return false;
	    return true;
	  },
	  each: function(f) {
	    for (var property in this) if (property[0] === prefix) f(this[property], property.slice(1), this);
	  }
	};
	
	function map(object, f) {
	  var map = new Map;
	
	  // Copy constructor.
	  if (object instanceof Map) object.each(function(value, key) { map.set(key, value); });
	
	  // Index array by numeric index or specified key function.
	  else if (Array.isArray(object)) {
	    var i = -1,
	        n = object.length,
	        o;
	
	    if (f == null) while (++i < n) map.set(i, object[i]);
	    else while (++i < n) map.set(f(o = object[i], i, object), o);
	  }
	
	  // Convert object to map.
	  else if (object) for (var key in object) map.set(key, object[key]);
	
	  return map;
	}
	
	var nest = function() {
	  var keys = [],
	      sortKeys = [],
	      sortValues,
	      rollup,
	      nest;
	
	  function apply(array, depth, createResult, setResult) {
	    if (depth >= keys.length) {
	      if (sortValues != null) array.sort(sortValues);
	      return rollup != null ? rollup(array) : array;
	    }
	
	    var i = -1,
	        n = array.length,
	        key = keys[depth++],
	        keyValue,
	        value,
	        valuesByKey = map(),
	        values,
	        result = createResult();
	
	    while (++i < n) {
	      if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) {
	        values.push(value);
	      } else {
	        valuesByKey.set(keyValue, [value]);
	      }
	    }
	
	    valuesByKey.each(function(values, key) {
	      setResult(result, key, apply(values, depth, createResult, setResult));
	    });
	
	    return result;
	  }
	
	  function entries(map$$1, depth) {
	    if (++depth > keys.length) return map$$1;
	    var array, sortKey = sortKeys[depth - 1];
	    if (rollup != null && depth >= keys.length) array = map$$1.entries();
	    else array = [], map$$1.each(function(v, k) { array.push({key: k, values: entries(v, depth)}); });
	    return sortKey != null ? array.sort(function(a, b) { return sortKey(a.key, b.key); }) : array;
	  }
	
	  return nest = {
	    object: function(array) { return apply(array, 0, createObject, setObject); },
	    map: function(array) { return apply(array, 0, createMap, setMap); },
	    entries: function(array) { return entries(apply(array, 0, createMap, setMap), 0); },
	    key: function(d) { keys.push(d); return nest; },
	    sortKeys: function(order) { sortKeys[keys.length - 1] = order; return nest; },
	    sortValues: function(order) { sortValues = order; return nest; },
	    rollup: function(f) { rollup = f; return nest; }
	  };
	};
	
	function createObject() {
	  return {};
	}
	
	function setObject(object, key, value) {
	  object[key] = value;
	}
	
	function createMap() {
	  return map();
	}
	
	function setMap(map$$1, key, value) {
	  map$$1.set(key, value);
	}
	
	function Set() {}
	
	var proto = map.prototype;
	
	Set.prototype = set.prototype = {
	  constructor: Set,
	  has: proto.has,
	  add: function(value) {
	    value += "";
	    this[prefix + value] = value;
	    return this;
	  },
	  remove: proto.remove,
	  clear: proto.clear,
	  values: proto.keys,
	  size: proto.size,
	  empty: proto.empty,
	  each: proto.each
	};
	
	function set(object, f) {
	  var set = new Set;
	
	  // Copy constructor.
	  if (object instanceof Set) object.each(function(value) { set.add(value); });
	
	  // Otherwise, assume it’s an array.
	  else if (object) {
	    var i = -1, n = object.length;
	    if (f == null) while (++i < n) set.add(object[i]);
	    else while (++i < n) set.add(f(object[i], i, object));
	  }
	
	  return set;
	}
	
	var keys = function(map) {
	  var keys = [];
	  for (var key in map) keys.push(key);
	  return keys;
	};
	
	var values = function(map) {
	  var values = [];
	  for (var key in map) values.push(map[key]);
	  return values;
	};
	
	var entries = function(map) {
	  var entries = [];
	  for (var key in map) entries.push({key: key, value: map[key]});
	  return entries;
	};
	
	exports.nest = nest;
	exports.set = set;
	exports.map = map;
	exports.keys = keys;
	exports.values = values;
	exports.entries = entries;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-color/ Version 1.2.0. Copyright 2018 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var define = function(constructor, factory, prototype) {
	  constructor.prototype = factory.prototype = prototype;
	  prototype.constructor = constructor;
	};
	
	function extend(parent, definition) {
	  var prototype = Object.create(parent.prototype);
	  for (var key in definition) prototype[key] = definition[key];
	  return prototype;
	}
	
	function Color() {}
	
	var darker = 0.7;
	var brighter = 1 / darker;
	
	var reI = "\\s*([+-]?\\d+)\\s*";
	var reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*";
	var reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*";
	var reHex3 = /^#([0-9a-f]{3})$/;
	var reHex6 = /^#([0-9a-f]{6})$/;
	var reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$");
	var reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$");
	var reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$");
	var reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$");
	var reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$");
	var reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");
	
	var named = {
	  aliceblue: 0xf0f8ff,
	  antiquewhite: 0xfaebd7,
	  aqua: 0x00ffff,
	  aquamarine: 0x7fffd4,
	  azure: 0xf0ffff,
	  beige: 0xf5f5dc,
	  bisque: 0xffe4c4,
	  black: 0x000000,
	  blanchedalmond: 0xffebcd,
	  blue: 0x0000ff,
	  blueviolet: 0x8a2be2,
	  brown: 0xa52a2a,
	  burlywood: 0xdeb887,
	  cadetblue: 0x5f9ea0,
	  chartreuse: 0x7fff00,
	  chocolate: 0xd2691e,
	  coral: 0xff7f50,
	  cornflowerblue: 0x6495ed,
	  cornsilk: 0xfff8dc,
	  crimson: 0xdc143c,
	  cyan: 0x00ffff,
	  darkblue: 0x00008b,
	  darkcyan: 0x008b8b,
	  darkgoldenrod: 0xb8860b,
	  darkgray: 0xa9a9a9,
	  darkgreen: 0x006400,
	  darkgrey: 0xa9a9a9,
	  darkkhaki: 0xbdb76b,
	  darkmagenta: 0x8b008b,
	  darkolivegreen: 0x556b2f,
	  darkorange: 0xff8c00,
	  darkorchid: 0x9932cc,
	  darkred: 0x8b0000,
	  darksalmon: 0xe9967a,
	  darkseagreen: 0x8fbc8f,
	  darkslateblue: 0x483d8b,
	  darkslategray: 0x2f4f4f,
	  darkslategrey: 0x2f4f4f,
	  darkturquoise: 0x00ced1,
	  darkviolet: 0x9400d3,
	  deeppink: 0xff1493,
	  deepskyblue: 0x00bfff,
	  dimgray: 0x696969,
	  dimgrey: 0x696969,
	  dodgerblue: 0x1e90ff,
	  firebrick: 0xb22222,
	  floralwhite: 0xfffaf0,
	  forestgreen: 0x228b22,
	  fuchsia: 0xff00ff,
	  gainsboro: 0xdcdcdc,
	  ghostwhite: 0xf8f8ff,
	  gold: 0xffd700,
	  goldenrod: 0xdaa520,
	  gray: 0x808080,
	  green: 0x008000,
	  greenyellow: 0xadff2f,
	  grey: 0x808080,
	  honeydew: 0xf0fff0,
	  hotpink: 0xff69b4,
	  indianred: 0xcd5c5c,
	  indigo: 0x4b0082,
	  ivory: 0xfffff0,
	  khaki: 0xf0e68c,
	  lavender: 0xe6e6fa,
	  lavenderblush: 0xfff0f5,
	  lawngreen: 0x7cfc00,
	  lemonchiffon: 0xfffacd,
	  lightblue: 0xadd8e6,
	  lightcoral: 0xf08080,
	  lightcyan: 0xe0ffff,
	  lightgoldenrodyellow: 0xfafad2,
	  lightgray: 0xd3d3d3,
	  lightgreen: 0x90ee90,
	  lightgrey: 0xd3d3d3,
	  lightpink: 0xffb6c1,
	  lightsalmon: 0xffa07a,
	  lightseagreen: 0x20b2aa,
	  lightskyblue: 0x87cefa,
	  lightslategray: 0x778899,
	  lightslategrey: 0x778899,
	  lightsteelblue: 0xb0c4de,
	  lightyellow: 0xffffe0,
	  lime: 0x00ff00,
	  limegreen: 0x32cd32,
	  linen: 0xfaf0e6,
	  magenta: 0xff00ff,
	  maroon: 0x800000,
	  mediumaquamarine: 0x66cdaa,
	  mediumblue: 0x0000cd,
	  mediumorchid: 0xba55d3,
	  mediumpurple: 0x9370db,
	  mediumseagreen: 0x3cb371,
	  mediumslateblue: 0x7b68ee,
	  mediumspringgreen: 0x00fa9a,
	  mediumturquoise: 0x48d1cc,
	  mediumvioletred: 0xc71585,
	  midnightblue: 0x191970,
	  mintcream: 0xf5fffa,
	  mistyrose: 0xffe4e1,
	  moccasin: 0xffe4b5,
	  navajowhite: 0xffdead,
	  navy: 0x000080,
	  oldlace: 0xfdf5e6,
	  olive: 0x808000,
	  olivedrab: 0x6b8e23,
	  orange: 0xffa500,
	  orangered: 0xff4500,
	  orchid: 0xda70d6,
	  palegoldenrod: 0xeee8aa,
	  palegreen: 0x98fb98,
	  paleturquoise: 0xafeeee,
	  palevioletred: 0xdb7093,
	  papayawhip: 0xffefd5,
	  peachpuff: 0xffdab9,
	  peru: 0xcd853f,
	  pink: 0xffc0cb,
	  plum: 0xdda0dd,
	  powderblue: 0xb0e0e6,
	  purple: 0x800080,
	  rebeccapurple: 0x663399,
	  red: 0xff0000,
	  rosybrown: 0xbc8f8f,
	  royalblue: 0x4169e1,
	  saddlebrown: 0x8b4513,
	  salmon: 0xfa8072,
	  sandybrown: 0xf4a460,
	  seagreen: 0x2e8b57,
	  seashell: 0xfff5ee,
	  sienna: 0xa0522d,
	  silver: 0xc0c0c0,
	  skyblue: 0x87ceeb,
	  slateblue: 0x6a5acd,
	  slategray: 0x708090,
	  slategrey: 0x708090,
	  snow: 0xfffafa,
	  springgreen: 0x00ff7f,
	  steelblue: 0x4682b4,
	  tan: 0xd2b48c,
	  teal: 0x008080,
	  thistle: 0xd8bfd8,
	  tomato: 0xff6347,
	  turquoise: 0x40e0d0,
	  violet: 0xee82ee,
	  wheat: 0xf5deb3,
	  white: 0xffffff,
	  whitesmoke: 0xf5f5f5,
	  yellow: 0xffff00,
	  yellowgreen: 0x9acd32
	};
	
	define(Color, color, {
	  displayable: function() {
	    return this.rgb().displayable();
	  },
	  hex: function() {
	    return this.rgb().hex();
	  },
	  toString: function() {
	    return this.rgb() + "";
	  }
	});
	
	function color(format) {
	  var m;
	  format = (format + "").trim().toLowerCase();
	  return (m = reHex3.exec(format)) ? (m = parseInt(m[1], 16), new Rgb((m >> 8 & 0xf) | (m >> 4 & 0x0f0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1)) // #f00
	      : (m = reHex6.exec(format)) ? rgbn(parseInt(m[1], 16)) // #ff0000
	      : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
	      : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
	      : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
	      : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
	      : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
	      : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
	      : named.hasOwnProperty(format) ? rgbn(named[format])
	      : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
	      : null;
	}
	
	function rgbn(n) {
	  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
	}
	
	function rgba(r, g, b, a) {
	  if (a <= 0) r = g = b = NaN;
	  return new Rgb(r, g, b, a);
	}
	
	function rgbConvert(o) {
	  if (!(o instanceof Color)) o = color(o);
	  if (!o) return new Rgb;
	  o = o.rgb();
	  return new Rgb(o.r, o.g, o.b, o.opacity);
	}
	
	function rgb(r, g, b, opacity) {
	  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
	}
	
	function Rgb(r, g, b, opacity) {
	  this.r = +r;
	  this.g = +g;
	  this.b = +b;
	  this.opacity = +opacity;
	}
	
	define(Rgb, rgb, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
	  },
	  rgb: function() {
	    return this;
	  },
	  displayable: function() {
	    return (0 <= this.r && this.r <= 255)
	        && (0 <= this.g && this.g <= 255)
	        && (0 <= this.b && this.b <= 255)
	        && (0 <= this.opacity && this.opacity <= 1);
	  },
	  hex: function() {
	    return "#" + hex(this.r) + hex(this.g) + hex(this.b);
	  },
	  toString: function() {
	    var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
	    return (a === 1 ? "rgb(" : "rgba(")
	        + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
	        + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
	        + Math.max(0, Math.min(255, Math.round(this.b) || 0))
	        + (a === 1 ? ")" : ", " + a + ")");
	  }
	}));
	
	function hex(value) {
	  value = Math.max(0, Math.min(255, Math.round(value) || 0));
	  return (value < 16 ? "0" : "") + value.toString(16);
	}
	
	function hsla(h, s, l, a) {
	  if (a <= 0) h = s = l = NaN;
	  else if (l <= 0 || l >= 1) h = s = NaN;
	  else if (s <= 0) h = NaN;
	  return new Hsl(h, s, l, a);
	}
	
	function hslConvert(o) {
	  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
	  if (!(o instanceof Color)) o = color(o);
	  if (!o) return new Hsl;
	  if (o instanceof Hsl) return o;
	  o = o.rgb();
	  var r = o.r / 255,
	      g = o.g / 255,
	      b = o.b / 255,
	      min = Math.min(r, g, b),
	      max = Math.max(r, g, b),
	      h = NaN,
	      s = max - min,
	      l = (max + min) / 2;
	  if (s) {
	    if (r === max) h = (g - b) / s + (g < b) * 6;
	    else if (g === max) h = (b - r) / s + 2;
	    else h = (r - g) / s + 4;
	    s /= l < 0.5 ? max + min : 2 - max - min;
	    h *= 60;
	  } else {
	    s = l > 0 && l < 1 ? 0 : h;
	  }
	  return new Hsl(h, s, l, o.opacity);
	}
	
	function hsl(h, s, l, opacity) {
	  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
	}
	
	function Hsl(h, s, l, opacity) {
	  this.h = +h;
	  this.s = +s;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Hsl, hsl, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Hsl(this.h, this.s, this.l * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Hsl(this.h, this.s, this.l * k, this.opacity);
	  },
	  rgb: function() {
	    var h = this.h % 360 + (this.h < 0) * 360,
	        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
	        l = this.l,
	        m2 = l + (l < 0.5 ? l : 1 - l) * s,
	        m1 = 2 * l - m2;
	    return new Rgb(
	      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
	      hsl2rgb(h, m1, m2),
	      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
	      this.opacity
	    );
	  },
	  displayable: function() {
	    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
	        && (0 <= this.l && this.l <= 1)
	        && (0 <= this.opacity && this.opacity <= 1);
	  }
	}));
	
	/* From FvD 13.37, CSS Color Module Level 3 */
	function hsl2rgb(h, m1, m2) {
	  return (h < 60 ? m1 + (m2 - m1) * h / 60
	      : h < 180 ? m2
	      : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
	      : m1) * 255;
	}
	
	var deg2rad = Math.PI / 180;
	var rad2deg = 180 / Math.PI;
	
	// https://beta.observablehq.com/@mbostock/lab-and-rgb
	var K = 18;
	var Xn = 0.96422;
	var Yn = 1;
	var Zn = 0.82521;
	var t0 = 4 / 29;
	var t1 = 6 / 29;
	var t2 = 3 * t1 * t1;
	var t3 = t1 * t1 * t1;
	
	function labConvert(o) {
	  if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
	  if (o instanceof Hcl) {
	    if (isNaN(o.h)) return new Lab(o.l, 0, 0, o.opacity);
	    var h = o.h * deg2rad;
	    return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
	  }
	  if (!(o instanceof Rgb)) o = rgbConvert(o);
	  var r = rgb2lrgb(o.r),
	      g = rgb2lrgb(o.g),
	      b = rgb2lrgb(o.b),
	      y = xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / Yn), x, z;
	  if (r === g && g === b) x = z = y; else {
	    x = xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / Xn);
	    z = xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / Zn);
	  }
	  return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
	}
	
	function gray(l, opacity) {
	  return new Lab(l, 0, 0, opacity == null ? 1 : opacity);
	}
	
	function lab(l, a, b, opacity) {
	  return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
	}
	
	function Lab(l, a, b, opacity) {
	  this.l = +l;
	  this.a = +a;
	  this.b = +b;
	  this.opacity = +opacity;
	}
	
	define(Lab, lab, extend(Color, {
	  brighter: function(k) {
	    return new Lab(this.l + K * (k == null ? 1 : k), this.a, this.b, this.opacity);
	  },
	  darker: function(k) {
	    return new Lab(this.l - K * (k == null ? 1 : k), this.a, this.b, this.opacity);
	  },
	  rgb: function() {
	    var y = (this.l + 16) / 116,
	        x = isNaN(this.a) ? y : y + this.a / 500,
	        z = isNaN(this.b) ? y : y - this.b / 200;
	    x = Xn * lab2xyz(x);
	    y = Yn * lab2xyz(y);
	    z = Zn * lab2xyz(z);
	    return new Rgb(
	      lrgb2rgb( 3.1338561 * x - 1.6168667 * y - 0.4906146 * z),
	      lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z),
	      lrgb2rgb( 0.0719453 * x - 0.2289914 * y + 1.4052427 * z),
	      this.opacity
	    );
	  }
	}));
	
	function xyz2lab(t) {
	  return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
	}
	
	function lab2xyz(t) {
	  return t > t1 ? t * t * t : t2 * (t - t0);
	}
	
	function lrgb2rgb(x) {
	  return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
	}
	
	function rgb2lrgb(x) {
	  return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
	}
	
	function hclConvert(o) {
	  if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
	  if (!(o instanceof Lab)) o = labConvert(o);
	  if (o.a === 0 && o.b === 0) return new Hcl(NaN, 0, o.l, o.opacity);
	  var h = Math.atan2(o.b, o.a) * rad2deg;
	  return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
	}
	
	function lch(l, c, h, opacity) {
	  return arguments.length === 1 ? hclConvert(l) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
	}
	
	function hcl(h, c, l, opacity) {
	  return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
	}
	
	function Hcl(h, c, l, opacity) {
	  this.h = +h;
	  this.c = +c;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Hcl, hcl, extend(Color, {
	  brighter: function(k) {
	    return new Hcl(this.h, this.c, this.l + K * (k == null ? 1 : k), this.opacity);
	  },
	  darker: function(k) {
	    return new Hcl(this.h, this.c, this.l - K * (k == null ? 1 : k), this.opacity);
	  },
	  rgb: function() {
	    return labConvert(this).rgb();
	  }
	}));
	
	var A = -0.14861;
	var B = +1.78277;
	var C = -0.29227;
	var D = -0.90649;
	var E = +1.97294;
	var ED = E * D;
	var EB = E * B;
	var BC_DA = B * C - D * A;
	
	function cubehelixConvert(o) {
	  if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
	  if (!(o instanceof Rgb)) o = rgbConvert(o);
	  var r = o.r / 255,
	      g = o.g / 255,
	      b = o.b / 255,
	      l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
	      bl = b - l,
	      k = (E * (g - l) - C * bl) / D,
	      s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), // NaN if l=0 or l=1
	      h = s ? Math.atan2(k, bl) * rad2deg - 120 : NaN;
	  return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
	}
	
	function cubehelix(h, s, l, opacity) {
	  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
	}
	
	function Cubehelix(h, s, l, opacity) {
	  this.h = +h;
	  this.s = +s;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Cubehelix, cubehelix, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
	  },
	  rgb: function() {
	    var h = isNaN(this.h) ? 0 : (this.h + 120) * deg2rad,
	        l = +this.l,
	        a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
	        cosh = Math.cos(h),
	        sinh = Math.sin(h);
	    return new Rgb(
	      255 * (l + a * (A * cosh + B * sinh)),
	      255 * (l + a * (C * cosh + D * sinh)),
	      255 * (l + a * (E * cosh)),
	      this.opacity
	    );
	  }
	}));
	
	exports.color = color;
	exports.rgb = rgb;
	exports.hsl = hsl;
	exports.lab = lab;
	exports.hcl = hcl;
	exports.lch = lch;
	exports.gray = gray;
	exports.cubehelix = cubehelix;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-format/ Version 1.3.0. Copyright 2018 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	// Computes the decimal coefficient and exponent of the specified number x with
	// significant digits p, where x is positive and p is in [1, 21] or undefined.
	// For example, formatDecimal(1.23) returns ["123", 0].
	var formatDecimal = function(x, p) {
	  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
	  var i, coefficient = x.slice(0, i);
	
	  // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
	  // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
	  return [
	    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
	    +x.slice(i + 1)
	  ];
	};
	
	var exponent = function(x) {
	  return x = formatDecimal(Math.abs(x)), x ? x[1] : NaN;
	};
	
	var formatGroup = function(grouping, thousands) {
	  return function(value, width) {
	    var i = value.length,
	        t = [],
	        j = 0,
	        g = grouping[0],
	        length = 0;
	
	    while (i > 0 && g > 0) {
	      if (length + g + 1 > width) g = Math.max(1, width - length);
	      t.push(value.substring(i -= g, i + g));
	      if ((length += g + 1) > width) break;
	      g = grouping[j = (j + 1) % grouping.length];
	    }
	
	    return t.reverse().join(thousands);
	  };
	};
	
	var formatNumerals = function(numerals) {
	  return function(value) {
	    return value.replace(/[0-9]/g, function(i) {
	      return numerals[+i];
	    });
	  };
	};
	
	// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
	var re = /^(?:(.)?([<>=^]))?([+\-\( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
	
	function formatSpecifier(specifier) {
	  return new FormatSpecifier(specifier);
	}
	
	formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof
	
	function FormatSpecifier(specifier) {
	  if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
	  var match;
	  this.fill = match[1] || " ";
	  this.align = match[2] || ">";
	  this.sign = match[3] || "-";
	  this.symbol = match[4] || "";
	  this.zero = !!match[5];
	  this.width = match[6] && +match[6];
	  this.comma = !!match[7];
	  this.precision = match[8] && +match[8].slice(1);
	  this.trim = !!match[9];
	  this.type = match[10] || "";
	}
	
	FormatSpecifier.prototype.toString = function() {
	  return this.fill
	      + this.align
	      + this.sign
	      + this.symbol
	      + (this.zero ? "0" : "")
	      + (this.width == null ? "" : Math.max(1, this.width | 0))
	      + (this.comma ? "," : "")
	      + (this.precision == null ? "" : "." + Math.max(0, this.precision | 0))
	      + (this.trim ? "~" : "")
	      + this.type;
	};
	
	// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
	var formatTrim = function(s) {
	  out: for (var n = s.length, i = 1, i0 = -1, i1; i < n; ++i) {
	    switch (s[i]) {
	      case ".": i0 = i1 = i; break;
	      case "0": if (i0 === 0) i0 = i; i1 = i; break;
	      default: if (i0 > 0) { if (!+s[i]) break out; i0 = 0; } break;
	    }
	  }
	  return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
	};
	
	var prefixExponent;
	
	var formatPrefixAuto = function(x, p) {
	  var d = formatDecimal(x, p);
	  if (!d) return x + "";
	  var coefficient = d[0],
	      exponent = d[1],
	      i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
	      n = coefficient.length;
	  return i === n ? coefficient
	      : i > n ? coefficient + new Array(i - n + 1).join("0")
	      : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i)
	      : "0." + new Array(1 - i).join("0") + formatDecimal(x, Math.max(0, p + i - 1))[0]; // less than 1y!
	};
	
	var formatRounded = function(x, p) {
	  var d = formatDecimal(x, p);
	  if (!d) return x + "";
	  var coefficient = d[0],
	      exponent = d[1];
	  return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient
	      : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1)
	      : coefficient + new Array(exponent - coefficient.length + 2).join("0");
	};
	
	var formatTypes = {
	  "%": function(x, p) { return (x * 100).toFixed(p); },
	  "b": function(x) { return Math.round(x).toString(2); },
	  "c": function(x) { return x + ""; },
	  "d": function(x) { return Math.round(x).toString(10); },
	  "e": function(x, p) { return x.toExponential(p); },
	  "f": function(x, p) { return x.toFixed(p); },
	  "g": function(x, p) { return x.toPrecision(p); },
	  "o": function(x) { return Math.round(x).toString(8); },
	  "p": function(x, p) { return formatRounded(x * 100, p); },
	  "r": formatRounded,
	  "s": formatPrefixAuto,
	  "X": function(x) { return Math.round(x).toString(16).toUpperCase(); },
	  "x": function(x) { return Math.round(x).toString(16); }
	};
	
	var identity = function(x) {
	  return x;
	};
	
	var prefixes = ["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];
	
	var formatLocale = function(locale) {
	  var group = locale.grouping && locale.thousands ? formatGroup(locale.grouping, locale.thousands) : identity,
	      currency = locale.currency,
	      decimal = locale.decimal,
	      numerals = locale.numerals ? formatNumerals(locale.numerals) : identity,
	      percent = locale.percent || "%";
	
	  function newFormat(specifier) {
	    specifier = formatSpecifier(specifier);
	
	    var fill = specifier.fill,
	        align = specifier.align,
	        sign = specifier.sign,
	        symbol = specifier.symbol,
	        zero = specifier.zero,
	        width = specifier.width,
	        comma = specifier.comma,
	        precision = specifier.precision,
	        trim = specifier.trim,
	        type = specifier.type;
	
	    // The "n" type is an alias for ",g".
	    if (type === "n") comma = true, type = "g";
	
	    // The "" type, and any invalid type, is an alias for ".12~g".
	    else if (!formatTypes[type]) precision == null && (precision = 12), trim = true, type = "g";
	
	    // If zero fill is specified, padding goes after sign and before digits.
	    if (zero || (fill === "0" && align === "=")) zero = true, fill = "0", align = "=";
	
	    // Compute the prefix and suffix.
	    // For SI-prefix, the suffix is lazily computed.
	    var prefix = symbol === "$" ? currency[0] : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
	        suffix = symbol === "$" ? currency[1] : /[%p]/.test(type) ? percent : "";
	
	    // What format function should we use?
	    // Is this an integer type?
	    // Can this type generate exponential notation?
	    var formatType = formatTypes[type],
	        maybeSuffix = /[defgprs%]/.test(type);
	
	    // Set the default precision if not specified,
	    // or clamp the specified precision to the supported range.
	    // For significant precision, it must be in [1, 21].
	    // For fixed precision, it must be in [0, 20].
	    precision = precision == null ? 6
	        : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision))
	        : Math.max(0, Math.min(20, precision));
	
	    function format(value) {
	      var valuePrefix = prefix,
	          valueSuffix = suffix,
	          i, n, c;
	
	      if (type === "c") {
	        valueSuffix = formatType(value) + valueSuffix;
	        value = "";
	      } else {
	        value = +value;
	
	        // Perform the initial formatting.
	        var valueNegative = value < 0;
	        value = formatType(Math.abs(value), precision);
	
	        // Trim insignificant zeros.
	        if (trim) value = formatTrim(value);
	
	        // If a negative value rounds to zero during formatting, treat as positive.
	        if (valueNegative && +value === 0) valueNegative = false;
	
	        // Compute the prefix and suffix.
	        valuePrefix = (valueNegative ? (sign === "(" ? sign : "-") : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
	        valueSuffix = (type === "s" ? prefixes[8 + prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
	
	        // Break the formatted value into the integer “value” part that can be
	        // grouped, and fractional or exponential “suffix” part that is not.
	        if (maybeSuffix) {
	          i = -1, n = value.length;
	          while (++i < n) {
	            if (c = value.charCodeAt(i), 48 > c || c > 57) {
	              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
	              value = value.slice(0, i);
	              break;
	            }
	          }
	        }
	      }
	
	      // If the fill character is not "0", grouping is applied before padding.
	      if (comma && !zero) value = group(value, Infinity);
	
	      // Compute the padding.
	      var length = valuePrefix.length + value.length + valueSuffix.length,
	          padding = length < width ? new Array(width - length + 1).join(fill) : "";
	
	      // If the fill character is "0", grouping is applied after padding.
	      if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
	
	      // Reconstruct the final output based on the desired alignment.
	      switch (align) {
	        case "<": value = valuePrefix + value + valueSuffix + padding; break;
	        case "=": value = valuePrefix + padding + value + valueSuffix; break;
	        case "^": value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length); break;
	        default: value = padding + valuePrefix + value + valueSuffix; break;
	      }
	
	      return numerals(value);
	    }
	
	    format.toString = function() {
	      return specifier + "";
	    };
	
	    return format;
	  }
	
	  function formatPrefix(specifier, value) {
	    var f = newFormat((specifier = formatSpecifier(specifier), specifier.type = "f", specifier)),
	        e = Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3,
	        k = Math.pow(10, -e),
	        prefix = prefixes[8 + e / 3];
	    return function(value) {
	      return f(k * value) + prefix;
	    };
	  }
	
	  return {
	    format: newFormat,
	    formatPrefix: formatPrefix
	  };
	};
	
	var locale;
	
	
	
	defaultLocale({
	  decimal: ".",
	  thousands: ",",
	  grouping: [3],
	  currency: ["$", ""]
	});
	
	function defaultLocale(definition) {
	  locale = formatLocale(definition);
	  exports.format = locale.format;
	  exports.formatPrefix = locale.formatPrefix;
	  return locale;
	}
	
	var precisionFixed = function(step) {
	  return Math.max(0, -exponent(Math.abs(step)));
	};
	
	var precisionPrefix = function(step, value) {
	  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3 - exponent(Math.abs(step)));
	};
	
	var precisionRound = function(step, max) {
	  step = Math.abs(step), max = Math.abs(max) - step;
	  return Math.max(0, exponent(max) - exponent(step)) + 1;
	};
	
	exports.formatDefaultLocale = defaultLocale;
	exports.formatLocale = formatLocale;
	exports.formatSpecifier = formatSpecifier;
	exports.precisionFixed = precisionFixed;
	exports.precisionPrefix = precisionPrefix;
	exports.precisionRound = precisionRound;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-geo-projection/ Version 1.2.2. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(53), __webpack_require__(276)) :
		typeof define === 'function' && define.amd ? define(['exports', 'd3-geo', 'd3-array'], factory) :
		(factory((global.d3 = global.d3 || {}),global.d3,global.d3));
	}(this, (function (exports,d3Geo,d3Array) { 'use strict';
	
	var abs = Math.abs;
	var atan = Math.atan;
	var atan2 = Math.atan2;
	
	var cos = Math.cos;
	var exp = Math.exp;
	var floor = Math.floor;
	var log = Math.log;
	var max = Math.max;
	var min = Math.min;
	var pow = Math.pow;
	var round = Math.round;
	var sign = Math.sign || function(x) { return x > 0 ? 1 : x < 0 ? -1 : 0; };
	var sin = Math.sin;
	var tan = Math.tan;
	
	var epsilon = 1e-6;
	var epsilon2 = 1e-12;
	var pi = Math.PI;
	var halfPi = pi / 2;
	var quarterPi = pi / 4;
	var sqrt1_2 = Math.SQRT1_2;
	var sqrt2 = sqrt(2);
	var sqrtPi = sqrt(pi);
	var tau = pi * 2;
	var degrees = 180 / pi;
	var radians = pi / 180;
	
	function sinci(x) {
	  return x ? x / Math.sin(x) : 1;
	}
	
	function asin(x) {
	  return x > 1 ? halfPi : x < -1 ? -halfPi : Math.asin(x);
	}
	
	function acos(x) {
	  return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
	}
	
	function sqrt(x) {
	  return x > 0 ? Math.sqrt(x) : 0;
	}
	
	function tanh(x) {
	  x = exp(2 * x);
	  return (x - 1) / (x + 1);
	}
	
	function sinh(x) {
	  return (exp(x) - exp(-x)) / 2;
	}
	
	function cosh(x) {
	  return (exp(x) + exp(-x)) / 2;
	}
	
	function arsinh(x) {
	  return log(x + sqrt(x * x + 1));
	}
	
	function arcosh(x) {
	  return log(x + sqrt(x * x - 1));
	}
	
	function airyRaw(beta) {
	  var tanBeta_2 = tan(beta / 2),
	      b = 2 * log(cos(beta / 2)) / (tanBeta_2 * tanBeta_2);
	
	  function forward(x, y) {
	    var cosx = cos(x),
	        cosy = cos(y),
	        siny = sin(y),
	        cosz = cosy * cosx,
	        k = -((1 - cosz ? log((1 + cosz) / 2) / (1 - cosz) : -0.5) + b / (1 + cosz));
	    return [k * cosy * sin(x), k * siny];
	  }
	
	  forward.invert = function(x, y) {
	    var r = sqrt(x * x + y * y),
	        z = -beta / 2,
	        i = 50, delta;
	    if (!r) return [0, 0];
	    do {
	      var z_2 = z / 2,
	          cosz_2 = cos(z_2),
	          sinz_2 = sin(z_2),
	          tanz_2 = tan(z_2),
	          lnsecz_2 = log(1 / cosz_2);
	      z -= delta = (2 / tanz_2 * lnsecz_2 - b * tanz_2 - r) / (-lnsecz_2 / (sinz_2 * sinz_2) + 1 - b / (2 * cosz_2 * cosz_2));
	    } while (abs(delta) > epsilon && --i > 0);
	    var sinz = sin(z);
	    return [atan2(x * sinz, r * cos(z)), asin(y * sinz / r)];
	  };
	
	  return forward;
	}
	
	var airy = function() {
	  var beta = halfPi,
	      m = d3Geo.geoProjectionMutator(airyRaw),
	      p = m(beta);
	
	  p.radius = function(_) {
	    return arguments.length ? m(beta = _ * radians) : beta * degrees;
	  };
	
	  return p
	      .scale(179.976)
	      .clipAngle(147);
	};
	
	function aitoffRaw(x, y) {
	  var cosy = cos(y), sincia = sinci(acos(cosy * cos(x /= 2)));
	  return [2 * cosy * sin(x) * sincia, sin(y) * sincia];
	}
	
	// Abort if [x, y] is not within an ellipse centered at [0, 0] with
	// semi-major axis pi and semi-minor axis pi/2.
	aitoffRaw.invert = function(x, y) {
	  if (x * x + 4 * y * y > pi * pi + epsilon) return;
	  var x1 = x, y1 = y, i = 25;
	  do {
	    var sinx = sin(x1),
	        sinx_2 = sin(x1 / 2),
	        cosx_2 = cos(x1 / 2),
	        siny = sin(y1),
	        cosy = cos(y1),
	        sin_2y = sin(2 * y1),
	        sin2y = siny * siny,
	        cos2y = cosy * cosy,
	        sin2x_2 = sinx_2 * sinx_2,
	        c = 1 - cos2y * cosx_2 * cosx_2,
	        e = c ? acos(cosy * cosx_2) * sqrt(f = 1 / c) : f = 0,
	        f,
	        fx = 2 * e * cosy * sinx_2 - x,
	        fy = e * siny - y,
	        dxdx = f * (cos2y * sin2x_2 + e * cosy * cosx_2 * sin2y),
	        dxdy = f * (0.5 * sinx * sin_2y - e * 2 * siny * sinx_2),
	        dydx = f * 0.25 * (sin_2y * sinx_2 - e * siny * cos2y * sinx),
	        dydy = f * (sin2y * cosx_2 + e * sin2x_2 * cosy),
	        z = dxdy * dydx - dydy * dxdx;
	    if (!z) break;
	    var dx = (fy * dxdy - fx * dydy) / z,
	        dy = (fx * dydx - fy * dxdx) / z;
	    x1 -= dx, y1 -= dy;
	  } while ((abs(dx) > epsilon || abs(dy) > epsilon) && --i > 0);
	  return [x1, y1];
	};
	
	var aitoff = function() {
	  return d3Geo.geoProjection(aitoffRaw)
	      .scale(152.63);
	};
	
	function armadilloRaw(phi0) {
	  var sinPhi0 = sin(phi0),
	      cosPhi0 = cos(phi0),
	      sPhi0 = phi0 >= 0 ? 1 : -1,
	      tanPhi0 = tan(sPhi0 * phi0),
	      k = (1 + sinPhi0 - cosPhi0) / 2;
	
	  function forward(lambda, phi) {
	    var cosPhi = cos(phi),
	        cosLambda = cos(lambda /= 2);
	    return [
	      (1 + cosPhi) * sin(lambda),
	      (sPhi0 * phi > -atan2(cosLambda, tanPhi0) - 1e-3 ? 0 : -sPhi0 * 10) + k + sin(phi) * cosPhi0 - (1 + cosPhi) * sinPhi0 * cosLambda // TODO D3 core should allow null or [NaN, NaN] to be returned.
	    ];
	  }
	
	  forward.invert = function(x, y) {
	    var lambda = 0,
	        phi = 0,
	        i = 50;
	    do {
	      var cosLambda = cos(lambda),
	          sinLambda = sin(lambda),
	          cosPhi = cos(phi),
	          sinPhi = sin(phi),
	          A = 1 + cosPhi,
	          fx = A * sinLambda - x,
	          fy = k + sinPhi * cosPhi0 - A * sinPhi0 * cosLambda - y,
	          dxdLambda = A * cosLambda / 2,
	          dxdPhi = -sinLambda * sinPhi,
	          dydLambda = sinPhi0 * A * sinLambda / 2,
	          dydPhi = cosPhi0 * cosPhi + sinPhi0 * cosLambda * sinPhi,
	          denominator = dxdPhi * dydLambda - dydPhi * dxdLambda,
	          dLambda = (fy * dxdPhi - fx * dydPhi) / denominator / 2,
	          dPhi = (fx * dydLambda - fy * dxdLambda) / denominator;
	      lambda -= dLambda, phi -= dPhi;
	    } while ((abs(dLambda) > epsilon || abs(dPhi) > epsilon) && --i > 0);
	    return sPhi0 * phi > -atan2(cos(lambda), tanPhi0) - 1e-3 ? [lambda * 2, phi] : null;
	  };
	
	  return forward;
	}
	
	var armadillo = function() {
	  var phi0 = 20 * radians,
	      sPhi0 = phi0 >= 0 ? 1 : -1,
	      tanPhi0 = tan(sPhi0 * phi0),
	      m = d3Geo.geoProjectionMutator(armadilloRaw),
	      p = m(phi0),
	      stream_ = p.stream;
	
	  p.parallel = function(_) {
	    if (!arguments.length) return phi0 * degrees;
	    tanPhi0 = tan((sPhi0 = (phi0 = _ * radians) >= 0 ? 1 : -1) * phi0);
	    return m(phi0);
	  };
	
	  p.stream = function(stream) {
	    var rotate = p.rotate(),
	        rotateStream = stream_(stream),
	        sphereStream = (p.rotate([0, 0]), stream_(stream));
	    p.rotate(rotate);
	    rotateStream.sphere = function() {
	      sphereStream.polygonStart(), sphereStream.lineStart();
	      for (var lambda = sPhi0 * -180; sPhi0 * lambda < 180; lambda += sPhi0 * 90) sphereStream.point(lambda, sPhi0 * 90);
	      while (sPhi0 * (lambda -= phi0) >= -180) { // TODO precision?
	        sphereStream.point(lambda, sPhi0 * -atan2(cos(lambda * radians / 2), tanPhi0) * degrees);
	      }
	      sphereStream.lineEnd(), sphereStream.polygonEnd();
	    };
	    return rotateStream;
	  };
	
	  return p
	      .scale(218.695)
	      .center([0, 28.0974]);
	};
	
	function augustRaw(lambda, phi) {
	  var tanPhi = tan(phi / 2),
	      k = sqrt(1 - tanPhi * tanPhi),
	      c = 1 + k * cos(lambda /= 2),
	      x = sin(lambda) * k / c,
	      y = tanPhi / c,
	      x2 = x * x,
	      y2 = y * y;
	  return [
	    4 / 3 * x * (3 + x2 - 3 * y2),
	    4 / 3 * y * (3 + 3 * x2 - y2)
	  ];
	}
	
	augustRaw.invert = function(x, y) {
	  x *= 3 / 8, y *= 3 / 8;
	  if (!x && abs(y) > 1) return null;
	  var x2 = x * x,
	      y2 = y * y,
	      s = 1 + x2 + y2,
	      sin3Eta = sqrt((s - sqrt(s * s - 4 * y * y)) / 2),
	      eta = asin(sin3Eta) / 3,
	      xi = sin3Eta ? arcosh(abs(y / sin3Eta)) / 3 : arsinh(abs(x)) / 3,
	      cosEta = cos(eta),
	      coshXi = cosh(xi),
	      d = coshXi * coshXi - cosEta * cosEta;
	  return [
	    sign(x) * 2 * atan2(sinh(xi) * cosEta, 0.25 - d),
	    sign(y) * 2 * atan2(coshXi * sin(eta), 0.25 + d)
	  ];
	};
	
	var august = function() {
	  return d3Geo.geoProjection(augustRaw)
	      .scale(66.1603);
	};
	
	var sqrt8 = sqrt(8);
	var phi0 = log(1 + sqrt2);
	
	function bakerRaw(lambda, phi) {
	  var phi0 = abs(phi);
	  return phi0 < quarterPi
	      ? [lambda, log(tan(quarterPi + phi / 2))]
	      : [lambda * cos(phi0) * (2 * sqrt2 - 1 / sin(phi0)), sign(phi) * (2 * sqrt2 * (phi0 - quarterPi) - log(tan(phi0 / 2)))];
	}
	
	bakerRaw.invert = function(x, y) {
	  if ((y0 = abs(y)) < phi0) return [x, 2 * atan(exp(y)) - halfPi];
	  var phi = quarterPi, i = 25, delta, y0;
	  do {
	    var cosPhi_2 = cos(phi / 2), tanPhi_2 = tan(phi / 2);
	    phi -= delta = (sqrt8 * (phi - quarterPi) - log(tanPhi_2) - y0) / (sqrt8 - cosPhi_2 * cosPhi_2 / (2 * tanPhi_2));
	  } while (abs(delta) > epsilon2 && --i > 0);
	  return [x / (cos(phi) * (sqrt8 - 1 / sin(phi))), sign(y) * phi];
	};
	
	var baker = function() {
	  return d3Geo.geoProjection(bakerRaw)
	      .scale(112.314);
	};
	
	function berghausRaw(lobes) {
	  var k = 2 * pi / lobes;
	
	  function forward(lambda, phi) {
	    var p = d3Geo.geoAzimuthalEquidistantRaw(lambda, phi);
	    if (abs(lambda) > halfPi) { // back hemisphere
	      var theta = atan2(p[1], p[0]),
	          r = sqrt(p[0] * p[0] + p[1] * p[1]),
	          theta0 = k * round((theta - halfPi) / k) + halfPi,
	          α = atan2(sin(theta -= theta0), 2 - cos(theta)); // angle relative to lobe end
	      theta = theta0 + asin(pi / r * sin(α)) - α;
	      p[0] = r * cos(theta);
	      p[1] = r * sin(theta);
	    }
	    return p;
	  }
	
	  forward.invert = function(x, y) {
	    var r = sqrt(x * x + y * y);
	    if (r > halfPi) {
	      var theta = atan2(y, x),
	          theta0 = k * round((theta - halfPi) / k) + halfPi,
	          s = theta > theta0 ? -1 : 1,
	          A = r * cos(theta0 - theta),
	          cotα = 1 / tan(s * acos((A - pi) / sqrt(pi * (pi - 2 * A) + r * r)));
	      theta = theta0 + 2 * atan((cotα + s * sqrt(cotα * cotα - 3)) / 3);
	      x = r * cos(theta), y = r * sin(theta);
	    }
	    return d3Geo.geoAzimuthalEquidistantRaw.invert(x, y);
	  };
	
	  return forward;
	}
	
	var berghaus = function() {
	  var lobes = 5,
	      m = d3Geo.geoProjectionMutator(berghausRaw),
	      p = m(lobes),
	      projectionStream = p.stream,
	      epsilon$$1 = 1e-2,
	      cr = -cos(epsilon$$1 * radians),
	      sr = sin(epsilon$$1 * radians);
	
	  p.lobes = function(_) {
	    return arguments.length ? m(lobes = +_) : lobes;
	  };
	
	  p.stream = function(stream) {
	    var rotate = p.rotate(),
	        rotateStream = projectionStream(stream),
	        sphereStream = (p.rotate([0, 0]), projectionStream(stream));
	    p.rotate(rotate);
	    rotateStream.sphere = function() {
	      sphereStream.polygonStart(), sphereStream.lineStart();
	      for (var i = 0, delta = 360 / lobes, delta0 = 2 * pi / lobes, phi = 90 - 180 / lobes, phi0 = halfPi; i < lobes; ++i, phi -= delta, phi0 -= delta0) {
	        sphereStream.point(atan2(sr * cos(phi0), cr) * degrees, asin(sr * sin(phi0)) * degrees);
	        if (phi < -90) {
	          sphereStream.point(-90, -180 - phi - epsilon$$1);
	          sphereStream.point(-90, -180 - phi + epsilon$$1);
	        } else {
	          sphereStream.point(90, phi + epsilon$$1);
	          sphereStream.point(90, phi - epsilon$$1);
	        }
	      }
	      sphereStream.lineEnd(), sphereStream.polygonEnd();
	    };
	    return rotateStream;
	  };
	
	  return p
	      .scale(87.8076)
	      .center([0, 17.1875])
	      .clipAngle(180 - 1e-3);
	};
	
	function mollweideBromleyTheta(cp, phi) {
	  var cpsinPhi = cp * sin(phi), i = 30, delta;
	  do phi -= delta = (phi + sin(phi) - cpsinPhi) / (1 + cos(phi));
	  while (abs(delta) > epsilon && --i > 0);
	  return phi / 2;
	}
	
	function mollweideBromleyRaw(cx, cy, cp) {
	
	  function forward(lambda, phi) {
	    return [cx * lambda * cos(phi = mollweideBromleyTheta(cp, phi)), cy * sin(phi)];
	  }
	
	  forward.invert = function(x, y) {
	    return y = asin(y / cy), [x / (cx * cos(y)), asin((2 * y + sin(2 * y)) / cp)];
	  };
	
	  return forward;
	}
	
	var mollweideRaw = mollweideBromleyRaw(sqrt2 / halfPi, sqrt2, pi);
	
	var mollweide = function() {
	  return d3Geo.geoProjection(mollweideRaw)
	      .scale(169.529);
	};
	
	var k = 2.00276;
	var w = 1.11072;
	
	function boggsRaw(lambda, phi) {
	  var theta = mollweideBromleyTheta(pi, phi);
	  return [k * lambda / (1 / cos(phi) + w / cos(theta)), (phi + sqrt2 * sin(theta)) / k];
	}
	
	boggsRaw.invert = function(x, y) {
	  var ky = k * y, theta = y < 0 ? -quarterPi : quarterPi, i = 25, delta, phi;
	  do {
	    phi = ky - sqrt2 * sin(theta);
	    theta -= delta = (sin(2 * theta) + 2 * theta - pi * sin(phi)) / (2 * cos(2 * theta) + 2 + pi * cos(phi) * sqrt2 * cos(theta));
	  } while (abs(delta) > epsilon && --i > 0);
	  phi = ky - sqrt2 * sin(theta);
	  return [x * (1 / cos(phi) + w / cos(theta)) / k, phi];
	};
	
	var boggs = function() {
	  return d3Geo.geoProjection(boggsRaw)
	      .scale(160.857);
	};
	
	var parallel1 = function(projectAt) {
	  var phi0 = 0,
	      m = d3Geo.geoProjectionMutator(projectAt),
	      p = m(phi0);
	
	  p.parallel = function(_) {
	    return arguments.length ? m(phi0 = _ * radians) : phi0 * degrees;
	  };
	
	  return p;
	};
	
	function sinusoidalRaw(lambda, phi) {
	  return [lambda * cos(phi), phi];
	}
	
	sinusoidalRaw.invert = function(x, y) {
	  return [x / cos(y), y];
	};
	
	var sinusoidal = function() {
	  return d3Geo.geoProjection(sinusoidalRaw)
	      .scale(152.63);
	};
	
	function bonneRaw(phi0) {
	  if (!phi0) return sinusoidalRaw;
	  var cotPhi0 = 1 / tan(phi0);
	
	  function forward(lambda, phi) {
	    var rho = cotPhi0 + phi0 - phi,
	        e = rho ? lambda * cos(phi) / rho : rho;
	    return [rho * sin(e), cotPhi0 - rho * cos(e)];
	  }
	
	  forward.invert = function(x, y) {
	    var rho = sqrt(x * x + (y = cotPhi0 - y) * y),
	        phi = cotPhi0 + phi0 - rho;
	    return [rho / cos(phi) * atan2(x, y), phi];
	  };
	
	  return forward;
	}
	
	var bonne = function() {
	  return parallel1(bonneRaw)
	      .scale(123.082)
	      .center([0, 26.1441])
	      .parallel(45);
	};
	
	function bottomleyRaw(sinPsi) {
	
	  function forward(lambda, phi) {
	    var rho = halfPi - phi,
	        eta = rho ? lambda * sinPsi * sin(rho) / rho : rho;
	    return [rho * sin(eta) / sinPsi, halfPi - rho * cos(eta)];
	  }
	
	  forward.invert = function(x, y) {
	    var x1 = x * sinPsi,
	        y1 = halfPi - y,
	        rho = sqrt(x1 * x1 + y1 * y1),
	        eta = atan2(x1, y1);
	    return [(rho ? rho / sin(rho) : 1) * eta / sinPsi, halfPi - rho];
	  };
	
	  return forward;
	}
	
	var bottomley = function() {
	  var sinPsi = 0.5,
	      m = d3Geo.geoProjectionMutator(bottomleyRaw),
	      p = m(sinPsi);
	
	  p.fraction = function(_) {
	    return arguments.length ? m(sinPsi = +_) : sinPsi;
	  };
	
	  return p
	      .scale(158.837);
	};
	
	var bromleyRaw = mollweideBromleyRaw(1, 4 / pi, pi);
	
	var bromley = function() {
	  return d3Geo.geoProjection(bromleyRaw)
	      .scale(152.63);
	};
	
	// Azimuthal distance.
	function distance(dPhi, c1, s1, c2, s2, dLambda) {
	  var cosdLambda = cos(dLambda), r;
	  if (abs(dPhi) > 1 || abs(dLambda) > 1) {
	    r = acos(s1 * s2 + c1 * c2 * cosdLambda);
	  } else {
	    var sindPhi = sin(dPhi / 2), sindLambda = sin(dLambda / 2);
	    r = 2 * asin(sqrt(sindPhi * sindPhi + c1 * c2 * sindLambda * sindLambda));
	  }
	  return abs(r) > epsilon ? [r, atan2(c2 * sin(dLambda), c1 * s2 - s1 * c2 * cosdLambda)] : [0, 0];
	}
	
	// Angle opposite a, and contained between sides of lengths b and c.
	function angle(b, c, a) {
	  return acos((b * b + c * c - a * a) / (2 * b * c));
	}
	
	// Normalize longitude.
	function longitude(lambda) {
	  return lambda - 2 * pi * floor((lambda + pi) / (2 * pi));
	}
	
	function chamberlinRaw(p0, p1, p2) {
	  var points = [
	    [p0[0], p0[1], sin(p0[1]), cos(p0[1])],
	    [p1[0], p1[1], sin(p1[1]), cos(p1[1])],
	    [p2[0], p2[1], sin(p2[1]), cos(p2[1])]
	  ];
	
	  for (var a = points[2], b, i = 0; i < 3; ++i, a = b) {
	    b = points[i];
	    a.v = distance(b[1] - a[1], a[3], a[2], b[3], b[2], b[0] - a[0]);
	    a.point = [0, 0];
	  }
	
	  var beta0 = angle(points[0].v[0], points[2].v[0], points[1].v[0]),
	      beta1 = angle(points[0].v[0], points[1].v[0], points[2].v[0]),
	      beta2 = pi - beta0;
	
	  points[2].point[1] = 0;
	  points[0].point[0] = -(points[1].point[0] = points[0].v[0] / 2);
	
	  var mean = [
	    points[2].point[0] = points[0].point[0] + points[2].v[0] * cos(beta0),
	    2 * (points[0].point[1] = points[1].point[1] = points[2].v[0] * sin(beta0))
	  ];
	
	  function forward(lambda, phi) {
	    var sinPhi = sin(phi),
	        cosPhi = cos(phi),
	        v = new Array(3), i;
	
	    // Compute distance and azimuth from control points.
	    for (i = 0; i < 3; ++i) {
	      var p = points[i];
	      v[i] = distance(phi - p[1], p[3], p[2], cosPhi, sinPhi, lambda - p[0]);
	      if (!v[i][0]) return p.point;
	      v[i][1] = longitude(v[i][1] - p.v[1]);
	    }
	
	    // Arithmetic mean of interception points.
	    var point = mean.slice();
	    for (i = 0; i < 3; ++i) {
	      var j = i == 2 ? 0 : i + 1;
	      var a = angle(points[i].v[0], v[i][0], v[j][0]);
	      if (v[i][1] < 0) a = -a;
	
	      if (!i) {
	        point[0] += v[i][0] * cos(a);
	        point[1] -= v[i][0] * sin(a);
	      } else if (i == 1) {
	        a = beta1 - a;
	        point[0] -= v[i][0] * cos(a);
	        point[1] -= v[i][0] * sin(a);
	      } else {
	        a = beta2 - a;
	        point[0] += v[i][0] * cos(a);
	        point[1] += v[i][0] * sin(a);
	      }
	    }
	
	    point[0] /= 3, point[1] /= 3;
	    return point;
	  }
	
	  return forward;
	}
	
	function pointRadians(p) {
	  return p[0] *= radians, p[1] *= radians, p;
	}
	
	function chamberlinAfrica() {
	  return chamberlin([0, 22], [45, 22], [22.5, -22])
	      .scale(380)
	      .center([22.5, 2]);
	}
	
	function chamberlin(p0, p1, p2) { // TODO order matters!
	  var c = d3Geo.geoCentroid({type: "MultiPoint", coordinates: [p0, p1, p2]}),
	      R = [-c[0], -c[1]],
	      r = d3Geo.geoRotation(R),
	      p = d3Geo.geoProjection(chamberlinRaw(pointRadians(r(p0)), pointRadians(r(p1)), pointRadians(r(p2)))).rotate(R),
	      center = p.center;
	
	  delete p.rotate;
	
	  p.center = function(_) {
	    return arguments.length ? center(r(_)) : r.invert(center());
	  };
	
	  return p
	      .clipAngle(90);
	}
	
	function collignonRaw(lambda, phi) {
	  var alpha = sqrt(1 - sin(phi));
	  return [(2 / sqrtPi) * lambda * alpha, sqrtPi * (1 - alpha)];
	}
	
	collignonRaw.invert = function(x, y) {
	  var lambda = (lambda = y / sqrtPi - 1) * lambda;
	  return [lambda > 0 ? x * sqrt(pi / lambda) / 2 : 0, asin(1 - lambda)];
	};
	
	var collignon = function() {
	  return d3Geo.geoProjection(collignonRaw)
	      .scale(95.6464)
	      .center([0, 30]);
	};
	
	function craigRaw(phi0) {
	  var tanPhi0 = tan(phi0);
	
	  function forward(lambda, phi) {
	    return [lambda, (lambda ? lambda / sin(lambda) : 1) * (sin(phi) * cos(lambda) - tanPhi0 * cos(phi))];
	  }
	
	  forward.invert = tanPhi0 ? function(x, y) {
	    if (x) y *= sin(x) / x;
	    var cosλ = cos(x);
	    return [x, 2 * atan2(sqrt(cosλ * cosλ + tanPhi0 * tanPhi0 - y * y) - cosλ, tanPhi0 - y)];
	  } : function(x, y) {
	    return [x, asin(x ? y * tan(x) / x : y)];
	  };
	
	  return forward;
	}
	
	var craig = function() {
	  return parallel1(craigRaw)
	      .scale(249.828)
	      .clipAngle(90);
	};
	
	var sqrt3 = sqrt(3);
	
	function crasterRaw(lambda, phi) {
	  return [sqrt3 * lambda * (2 * cos(2 * phi / 3) - 1) / sqrtPi, sqrt3 * sqrtPi * sin(phi / 3)];
	}
	
	crasterRaw.invert = function(x, y) {
	  var phi = 3 * asin(y / (sqrt3 * sqrtPi));
	  return [sqrtPi * x / (sqrt3 * (2 * cos(2 * phi / 3) - 1)), phi];
	};
	
	var craster = function() {
	  return d3Geo.geoProjection(crasterRaw)
	      .scale(156.19);
	};
	
	function cylindricalEqualAreaRaw(phi0) {
	  var cosPhi0 = cos(phi0);
	
	  function forward(lambda, phi) {
	    return [lambda * cosPhi0, sin(phi) / cosPhi0];
	  }
	
	  forward.invert = function(x, y) {
	    return [x / cosPhi0, asin(y * cosPhi0)];
	  };
	
	  return forward;
	}
	
	var cylindricalEqualArea = function() {
	  return parallel1(cylindricalEqualAreaRaw)
	      .parallel(38.58) // acos(sqrt(width / height / pi)) * radians
	      .scale(195.044); // width / (sqrt(width / height / pi) * 2 * pi)
	};
	
	function cylindricalStereographicRaw(phi0) {
	  var cosPhi0 = cos(phi0);
	
	  function forward(lambda, phi) {
	    return [lambda * cosPhi0, (1 + cosPhi0) * tan(phi / 2)];
	  }
	
	  forward.invert = function(x, y) {
	    return [x / cosPhi0, atan(y / (1 + cosPhi0)) * 2];
	  };
	
	  return forward;
	}
	
	var cylindricalStereographic = function() {
	  return parallel1(cylindricalStereographicRaw)
	      .scale(124.75);
	};
	
	function eckert1Raw(lambda, phi) {
	  var alpha = sqrt(8 / (3 * pi));
	  return [
	    alpha * lambda * (1 - abs(phi) / pi),
	    alpha * phi
	  ];
	}
	
	eckert1Raw.invert = function(x, y) {
	  var alpha = sqrt(8 / (3 * pi)),
	      phi = y / alpha;
	  return [
	    x / (alpha * (1 - abs(phi) / pi)),
	    phi
	  ];
	};
	
	var eckert1 = function() {
	  return d3Geo.geoProjection(eckert1Raw)
	      .scale(165.664);
	};
	
	function eckert2Raw(lambda, phi) {
	  var alpha = sqrt(4 - 3 * sin(abs(phi)));
	  return [
	    2 / sqrt(6 * pi) * lambda * alpha,
	    sign(phi) * sqrt(2 * pi / 3) * (2 - alpha)
	  ];
	}
	
	eckert2Raw.invert = function(x, y) {
	  var alpha = 2 - abs(y) / sqrt(2 * pi / 3);
	  return [
	    x * sqrt(6 * pi) / (2 * alpha),
	    sign(y) * asin((4 - alpha * alpha) / 3)
	  ];
	};
	
	var eckert2 = function() {
	  return d3Geo.geoProjection(eckert2Raw)
	      .scale(165.664);
	};
	
	function eckert3Raw(lambda, phi) {
	  var k = sqrt(pi * (4 + pi));
	  return [
	    2 / k * lambda * (1 + sqrt(1 - 4 * phi * phi / (pi * pi))),
	    4 / k * phi
	  ];
	}
	
	eckert3Raw.invert = function(x, y) {
	  var k = sqrt(pi * (4 + pi)) / 2;
	  return [
	    x * k / (1 + sqrt(1 - y * y * (4 + pi) / (4 * pi))),
	    y * k / 2
	  ];
	};
	
	var eckert3 = function() {
	  return d3Geo.geoProjection(eckert3Raw)
	      .scale(180.739);
	};
	
	function eckert4Raw(lambda, phi) {
	  var k = (2 + halfPi) * sin(phi);
	  phi /= 2;
	  for (var i = 0, delta = Infinity; i < 10 && abs(delta) > epsilon; i++) {
	    var cosPhi = cos(phi);
	    phi -= delta = (phi + sin(phi) * (cosPhi + 2) - k) / (2 * cosPhi * (1 + cosPhi));
	  }
	  return [
	    2 / sqrt(pi * (4 + pi)) * lambda * (1 + cos(phi)),
	    2 * sqrt(pi / (4 + pi)) * sin(phi)
	  ];
	}
	
	eckert4Raw.invert = function(x, y) {
	  var A = y * sqrt((4 + pi) / pi) / 2,
	      k = asin(A),
	      c = cos(k);
	  return [
	    x / (2 / sqrt(pi * (4 + pi)) * (1 + c)),
	    asin((k + A * (c + 2)) / (2 + halfPi))
	  ];
	};
	
	var eckert4 = function() {
	  return d3Geo.geoProjection(eckert4Raw)
	      .scale(180.739);
	};
	
	function eckert5Raw(lambda, phi) {
	  return [
	    lambda * (1 + cos(phi)) / sqrt(2 + pi),
	    2 * phi / sqrt(2 + pi)
	  ];
	}
	
	eckert5Raw.invert = function(x, y) {
	  var k = sqrt(2 + pi),
	      phi = y * k / 2;
	  return [
	    k * x / (1 + cos(phi)),
	    phi
	  ];
	};
	
	var eckert5 = function() {
	  return d3Geo.geoProjection(eckert5Raw)
	      .scale(173.044);
	};
	
	function eckert6Raw(lambda, phi) {
	  var k = (1 + halfPi) * sin(phi);
	  for (var i = 0, delta = Infinity; i < 10 && abs(delta) > epsilon; i++) {
	    phi -= delta = (phi + sin(phi) - k) / (1 + cos(phi));
	  }
	  k = sqrt(2 + pi);
	  return [
	    lambda * (1 + cos(phi)) / k,
	    2 * phi / k
	  ];
	}
	
	eckert6Raw.invert = function(x, y) {
	  var j = 1 + halfPi,
	      k = sqrt(j / 2);
	  return [
	    x * 2 * k / (1 + cos(y *= k)),
	    asin((y + sin(y)) / j)
	  ];
	};
	
	var eckert6 = function() {
	  return d3Geo.geoProjection(eckert6Raw)
	      .scale(173.044);
	};
	
	var eisenlohrK = 3 + 2 * sqrt2;
	
	function eisenlohrRaw(lambda, phi) {
	  var s0 = sin(lambda /= 2),
	      c0 = cos(lambda),
	      k = sqrt(cos(phi)),
	      c1 = cos(phi /= 2),
	      t = sin(phi) / (c1 + sqrt2 * c0 * k),
	      c = sqrt(2 / (1 + t * t)),
	      v = sqrt((sqrt2 * c1 + (c0 + s0) * k) / (sqrt2 * c1 + (c0 - s0) * k));
	  return [
	    eisenlohrK * (c * (v - 1 / v) - 2 * log(v)),
	    eisenlohrK * (c * t * (v + 1 / v) - 2 * atan(t))
	  ];
	}
	
	eisenlohrRaw.invert = function(x, y) {
	  if (!(p = augustRaw.invert(x / 1.2, y * 1.065))) return null;
	  var lambda = p[0], phi = p[1], i = 20, p;
	  x /= eisenlohrK, y /= eisenlohrK;
	  do {
	    var _0 = lambda / 2,
	        _1 = phi / 2,
	        s0 = sin(_0),
	        c0 = cos(_0),
	        s1 = sin(_1),
	        c1 = cos(_1),
	        cos1 = cos(phi),
	        k = sqrt(cos1),
	        t = s1 / (c1 + sqrt2 * c0 * k),
	        t2 = t * t,
	        c = sqrt(2 / (1 + t2)),
	        v0 = (sqrt2 * c1 + (c0 + s0) * k),
	        v1 = (sqrt2 * c1 + (c0 - s0) * k),
	        v2 = v0 / v1,
	        v = sqrt(v2),
	        vm1v = v - 1 / v,
	        vp1v = v + 1 / v,
	        fx = c * vm1v - 2 * log(v) - x,
	        fy = c * t * vp1v - 2 * atan(t) - y,
	        deltatDeltaLambda = s1 && sqrt1_2 * k * s0 * t2 / s1,
	        deltatDeltaPhi = (sqrt2 * c0 * c1 + k) / (2 * (c1 + sqrt2 * c0 * k) * (c1 + sqrt2 * c0 * k) * k),
	        deltacDeltat = -0.5 * t * c * c * c,
	        deltacDeltaLambda = deltacDeltat * deltatDeltaLambda,
	        deltacDeltaPhi = deltacDeltat * deltatDeltaPhi,
	        A = (A = 2 * c1 + sqrt2 * k * (c0 - s0)) * A * v,
	        deltavDeltaLambda = (sqrt2 * c0 * c1 * k + cos1) / A,
	        deltavDeltaPhi = -(sqrt2 * s0 * s1) / (k * A),
	        deltaxDeltaLambda = vm1v * deltacDeltaLambda - 2 * deltavDeltaLambda / v + c * (deltavDeltaLambda + deltavDeltaLambda / v2),
	        deltaxDeltaPhi = vm1v * deltacDeltaPhi - 2 * deltavDeltaPhi / v + c * (deltavDeltaPhi + deltavDeltaPhi / v2),
	        deltayDeltaLambda = t * vp1v * deltacDeltaLambda - 2 * deltatDeltaLambda / (1 + t2) + c * vp1v * deltatDeltaLambda + c * t * (deltavDeltaLambda - deltavDeltaLambda / v2),
	        deltayDeltaPhi = t * vp1v * deltacDeltaPhi - 2 * deltatDeltaPhi / (1 + t2) + c * vp1v * deltatDeltaPhi + c * t * (deltavDeltaPhi - deltavDeltaPhi / v2),
	        denominator = deltaxDeltaPhi * deltayDeltaLambda - deltayDeltaPhi * deltaxDeltaLambda;
	    if (!denominator) break;
	    var deltaLambda = (fy * deltaxDeltaPhi - fx * deltayDeltaPhi) / denominator,
	        deltaPhi = (fx * deltayDeltaLambda - fy * deltaxDeltaLambda) / denominator;
	    lambda -= deltaLambda;
	    phi = max(-halfPi, min(halfPi, phi - deltaPhi));
	  } while ((abs(deltaLambda) > epsilon || abs(deltaPhi) > epsilon) && --i > 0);
	  return abs(abs(phi) - halfPi) < epsilon ? [0, phi] : i && [lambda, phi];
	};
	
	var eisenlohr = function() {
	  return d3Geo.geoProjection(eisenlohrRaw)
	      .scale(62.5271);
	};
	
	var faheyK = cos(35 * radians);
	
	function faheyRaw(lambda, phi) {
	  var t = tan(phi / 2);
	  return [lambda * faheyK * sqrt(1 - t * t), (1 + faheyK) * t];
	}
	
	faheyRaw.invert = function(x, y) {
	  var t = y / (1 + faheyK);
	  return [x && x / (faheyK * sqrt(1 - t * t)), 2 * atan(t)];
	};
	
	var fahey = function() {
	  return d3Geo.geoProjection(faheyRaw)
	      .scale(137.152);
	};
	
	function foucautRaw(lambda, phi) {
	  var k = phi / 2, cosk = cos(k);
	  return [ 2 * lambda / sqrtPi * cos(phi) * cosk * cosk, sqrtPi * tan(k)];
	}
	
	foucautRaw.invert = function(x, y) {
	  var k = atan(y / sqrtPi), cosk = cos(k), phi = 2 * k;
	  return [x * sqrtPi / 2 / (cos(phi) * cosk * cosk), phi];
	};
	
	var foucaut = function() {
	  return d3Geo.geoProjection(foucautRaw)
	      .scale(135.264);
	};
	
	function gilbertForward(point) {
	  return [point[0] / 2, asin(tan(point[1] / 2 * radians)) * degrees];
	}
	
	function gilbertInvert(point) {
	  return [point[0] * 2, 2 * atan(sin(point[1] * radians)) * degrees];
	}
	
	var gilbert = function(projectionType) {
	  if (projectionType == null) projectionType = d3Geo.geoOrthographic;
	  var projection = projectionType(),
	      equirectangular = d3Geo.geoEquirectangular().scale(degrees).precision(0).clipAngle(null).translate([0, 0]); // antimeridian cutting
	
	  function gilbert(point) {
	    return projection(gilbertForward(point));
	  }
	
	  if (projection.invert) gilbert.invert = function(point) {
	    return gilbertInvert(projection.invert(point));
	  };
	
	  gilbert.stream = function(stream) {
	    var s1 = projection.stream(stream), s0 = equirectangular.stream({
	      point: function(lambda, phi) { s1.point(lambda / 2, asin(tan(-phi / 2 * radians)) * degrees); },
	      lineStart: function() { s1.lineStart(); },
	      lineEnd: function() { s1.lineEnd(); },
	      polygonStart: function() { s1.polygonStart(); },
	      polygonEnd: function() { s1.polygonEnd(); }
	    });
	    s0.sphere = s1.sphere;
	    return s0;
	  };
	
	  function property(name) {
	    gilbert[name] = function(_) {
	      return arguments.length ? (projection[name](_), gilbert) : projection[name]();
	    };
	  }
	
	  gilbert.rotate = function(_) {
	    return arguments.length ? (equirectangular.rotate(_), gilbert) : equirectangular.rotate();
	  };
	
	  gilbert.center = function(_) {
	    return arguments.length ? (projection.center(gilbertForward(_)), gilbert) : gilbertInvert(projection.center());
	  };
	
	  property("clipAngle");
	  property("clipExtent");
	  property("scale");
	  property("translate");
	  property("precision");
	
	  return gilbert
	      .scale(249.5);
	};
	
	function gingeryRaw(rho, n) {
	  var k = 2 * pi / n,
	      rho2 = rho * rho;
	
	  function forward(lambda, phi) {
	    var p = d3Geo.geoAzimuthalEquidistantRaw(lambda, phi),
	        x = p[0],
	        y = p[1],
	        r2 = x * x + y * y;
	
	    if (r2 > rho2) {
	      var r = sqrt(r2),
	          theta = atan2(y, x),
	          theta0 = k * round(theta / k),
	          alpha = theta - theta0,
	          rhoCosAlpha = rho * cos(alpha),
	          k_ = (rho * sin(alpha) - alpha * sin(rhoCosAlpha)) / (halfPi - rhoCosAlpha),
	          s_ = gingeryLength(alpha, k_),
	          e = (pi - rho) / gingeryIntegrate(s_, rhoCosAlpha, pi);
	
	      x = r;
	      var i = 50, delta;
	      do {
	        x -= delta = (rho + gingeryIntegrate(s_, rhoCosAlpha, x) * e - r) / (s_(x) * e);
	      } while (abs(delta) > epsilon && --i > 0);
	
	      y = alpha * sin(x);
	      if (x < halfPi) y -= k_ * (x - halfPi);
	
	      var s = sin(theta0),
	          c = cos(theta0);
	      p[0] = x * c - y * s;
	      p[1] = x * s + y * c;
	    }
	    return p;
	  }
	
	  forward.invert = function(x, y) {
	    var r2 = x * x + y * y;
	    if (r2 > rho2) {
	      var r = sqrt(r2),
	          theta = atan2(y, x),
	          theta0 = k * round(theta / k),
	          dTheta = theta - theta0;
	
	      x = r * cos(dTheta);
	      y = r * sin(dTheta);
	
	      var x_halfPi = x - halfPi,
	          sinx = sin(x),
	          alpha = y / sinx,
	          delta = x < halfPi ? Infinity : 0,
	          i = 10;
	
	      while (true) {
	        var rhosinAlpha = rho * sin(alpha),
	            rhoCosAlpha = rho * cos(alpha),
	            sinRhoCosAlpha = sin(rhoCosAlpha),
	            halfPi_RhoCosAlpha = halfPi - rhoCosAlpha,
	            k_ = (rhosinAlpha - alpha * sinRhoCosAlpha) / halfPi_RhoCosAlpha,
	            s_ = gingeryLength(alpha, k_);
	
	        if (abs(delta) < epsilon2 || !--i) break;
	
	        alpha -= delta = (alpha * sinx - k_ * x_halfPi - y) / (
	          sinx - x_halfPi * 2 * (
	            halfPi_RhoCosAlpha * (rhoCosAlpha + alpha * rhosinAlpha * cos(rhoCosAlpha) - sinRhoCosAlpha) -
	            rhosinAlpha * (rhosinAlpha - alpha * sinRhoCosAlpha)
	          ) / (halfPi_RhoCosAlpha * halfPi_RhoCosAlpha));
	      }
	      r = rho + gingeryIntegrate(s_, rhoCosAlpha, x) * (pi - rho) / gingeryIntegrate(s_, rhoCosAlpha, pi);
	      theta = theta0 + alpha;
	      x = r * cos(theta);
	      y = r * sin(theta);
	    }
	    return d3Geo.geoAzimuthalEquidistantRaw.invert(x, y);
	  };
	
	  return forward;
	}
	
	function gingeryLength(alpha, k) {
	  return function(x) {
	    var y_ = alpha * cos(x);
	    if (x < halfPi) y_ -= k;
	    return sqrt(1 + y_ * y_);
	  };
	}
	
	// Numerical integration: trapezoidal rule.
	function gingeryIntegrate(f, a, b) {
	  var n = 50,
	      h = (b - a) / n,
	      s = f(a) + f(b);
	  for (var i = 1, x = a; i < n; ++i) s += 2 * f(x += h);
	  return s * 0.5 * h;
	}
	
	var gingery = function() {
	  var n = 6,
	      rho = 30 * radians,
	      cRho = cos(rho),
	      sRho = sin(rho),
	      m = d3Geo.geoProjectionMutator(gingeryRaw),
	      p = m(rho, n),
	      stream_ = p.stream,
	      epsilon$$1 = 1e-2,
	      cr = -cos(epsilon$$1 * radians),
	      sr = sin(epsilon$$1 * radians);
	
	  p.radius = function(_) {
	    if (!arguments.length) return rho * degrees;
	    cRho = cos(rho = _ * radians);
	    sRho = sin(rho);
	    return m(rho, n);
	  };
	
	  p.lobes = function(_) {
	    if (!arguments.length) return n;
	    return m(rho, n = +_);
	  };
	
	  p.stream = function(stream) {
	    var rotate = p.rotate(),
	        rotateStream = stream_(stream),
	        sphereStream = (p.rotate([0, 0]), stream_(stream));
	    p.rotate(rotate);
	    rotateStream.sphere = function() {
	      sphereStream.polygonStart(), sphereStream.lineStart();
	      for (var i = 0, delta = 2 * pi / n, phi = 0; i < n; ++i, phi -= delta) {
	        sphereStream.point(atan2(sr * cos(phi), cr) * degrees, asin(sr * sin(phi)) * degrees);
	        sphereStream.point(atan2(sRho * cos(phi - delta / 2), cRho) * degrees, asin(sRho * sin(phi - delta / 2)) * degrees);
	      }
	      sphereStream.lineEnd(), sphereStream.polygonEnd();
	    };
	    return rotateStream;
	  };
	
	  return p
	      .rotate([90, -40])
	      .scale(91.7095)
	      .clipAngle(180 - 1e-3);
	};
	
	var ginzburgPolyconicRaw = function(a, b, c, d, e, f, g, h) {
	  if (arguments.length < 8) h = 0;
	
	  function forward(lambda, phi) {
	    if (!phi) return [a * lambda / pi, 0];
	    var phi2 = phi * phi,
	        xB = a + phi2 * (b + phi2 * (c + phi2 * d)),
	        yB = phi * (e - 1 + phi2 * (f - h + phi2 * g)),
	        m = (xB * xB + yB * yB) / (2 * yB),
	        alpha = lambda * asin(xB / m) / pi;
	    return [m * sin(alpha), phi * (1 + phi2 * h) + m * (1 - cos(alpha))];
	  }
	
	  forward.invert = function(x, y) {
	    var lambda = pi * x / a,
	        phi = y,
	        deltaLambda, deltaPhi, i = 50;
	    do {
	      var phi2 = phi * phi,
	          xB = a + phi2 * (b + phi2 * (c + phi2 * d)),
	          yB = phi * (e - 1 + phi2 * (f - h + phi2 * g)),
	          p = xB * xB + yB * yB,
	          q = 2 * yB,
	          m = p / q,
	          m2 = m * m,
	          dAlphadLambda = asin(xB / m) / pi,
	          alpha = lambda * dAlphadLambda,
	          xB2 = xB * xB,
	          dxBdPhi = (2 * b + phi2 * (4 * c + phi2 * 6 * d)) * phi,
	          dyBdPhi = e + phi2 * (3 * f + phi2 * 5 * g),
	          dpdPhi = 2 * (xB * dxBdPhi + yB * (dyBdPhi - 1)),
	          dqdPhi = 2 * (dyBdPhi - 1),
	          dmdPhi = (dpdPhi * q - p * dqdPhi) / (q * q),
	          cosAlpha = cos(alpha),
	          sinAlpha = sin(alpha),
	          mcosAlpha = m * cosAlpha,
	          msinAlpha = m * sinAlpha,
	          dAlphadPhi = ((lambda / pi) * (1 / sqrt(1 - xB2 / m2)) * (dxBdPhi * m - xB * dmdPhi)) / m2,
	          fx = msinAlpha - x,
	          fy = phi * (1 + phi2 * h) + m - mcosAlpha - y,
	          deltaxDeltaPhi = dmdPhi * sinAlpha + mcosAlpha * dAlphadPhi,
	          deltaxDeltaLambda = mcosAlpha * dAlphadLambda,
	          deltayDeltaPhi = 1 + dmdPhi - (dmdPhi * cosAlpha - msinAlpha * dAlphadPhi),
	          deltayDeltaLambda = msinAlpha * dAlphadLambda,
	          denominator = deltaxDeltaPhi * deltayDeltaLambda - deltayDeltaPhi * deltaxDeltaLambda;
	      if (!denominator) break;
	      lambda -= deltaLambda = (fy * deltaxDeltaPhi - fx * deltayDeltaPhi) / denominator;
	      phi -= deltaPhi = (fx * deltayDeltaLambda - fy * deltaxDeltaLambda) / denominator;
	    } while ((abs(deltaLambda) > epsilon || abs(deltaPhi) > epsilon) && --i > 0);
	    return [lambda, phi];
	  };
	
	  return forward;
	};
	
	var ginzburg4Raw = ginzburgPolyconicRaw(2.8284, -1.6988, 0.75432, -0.18071, 1.76003, -0.38914, 0.042555);
	
	var ginzburg4 = function() {
	  return d3Geo.geoProjection(ginzburg4Raw)
	      .scale(149.995);
	};
	
	var ginzburg5Raw = ginzburgPolyconicRaw(2.583819, -0.835827, 0.170354, -0.038094, 1.543313, -0.411435,0.082742);
	
	var ginzburg5 = function() {
	  return d3Geo.geoProjection(ginzburg5Raw)
	      .scale(153.93);
	};
	
	var ginzburg6Raw = ginzburgPolyconicRaw(5 / 6 * pi, -0.62636, -0.0344, 0, 1.3493, -0.05524, 0, 0.045);
	
	var ginzburg6 = function() {
	  return d3Geo.geoProjection(ginzburg6Raw)
	      .scale(130.945);
	};
	
	function ginzburg8Raw(lambda, phi) {
	  var lambda2 = lambda * lambda,
	      phi2 = phi * phi;
	  return [
	    lambda * (1 - 0.162388 * phi2) * (0.87 - 0.000952426 * lambda2 * lambda2),
	    phi * (1 + phi2 / 12)
	  ];
	}
	
	ginzburg8Raw.invert = function(x, y) {
	  var lambda = x,
	      phi = y,
	      i = 50, delta;
	  do {
	    var phi2 = phi * phi;
	    phi -= delta = (phi * (1 + phi2 / 12) - y) / (1 + phi2 / 4);
	  } while (abs(delta) > epsilon && --i > 0);
	  i = 50;
	  x /= 1 -0.162388 * phi2;
	  do {
	    var lambda4 = (lambda4 = lambda * lambda) * lambda4;
	    lambda -= delta = (lambda * (0.87 - 0.000952426 * lambda4) - x) / (0.87 - 0.00476213 * lambda4);
	  } while (abs(delta) > epsilon && --i > 0);
	  return [lambda, phi];
	};
	
	var ginzburg8 = function() {
	  return d3Geo.geoProjection(ginzburg8Raw)
	      .scale(131.747);
	};
	
	var ginzburg9Raw = ginzburgPolyconicRaw(2.6516, -0.76534, 0.19123, -0.047094, 1.36289, -0.13965,0.031762);
	
	var ginzburg9 = function() {
	  return d3Geo.geoProjection(ginzburg9Raw)
	      .scale(131.087);
	};
	
	var squareRaw = function(project) {
	  var dx = project(halfPi, 0)[0] - project(-halfPi, 0)[0];
	
	  function projectSquare(lambda, phi) {
	    var s = lambda > 0 ? -0.5 : 0.5,
	        point = project(lambda + s * pi, phi);
	    point[0] -= s * dx;
	    return point;
	  }
	
	  if (project.invert) projectSquare.invert = function(x, y) {
	    var s = x > 0 ? -0.5 : 0.5,
	        location = project.invert(x + s * dx, y),
	        lambda = location[0] - s * pi;
	    if (lambda < -pi) lambda += 2 * pi;
	    else if (lambda > pi) lambda -= 2 * pi;
	    location[0] = lambda;
	    return location;
	  };
	
	  return projectSquare;
	};
	
	function gringortenRaw(lambda, phi) {
	  var sLambda = sign(lambda),
	      sPhi = sign(phi),
	      cosPhi = cos(phi),
	      x = cos(lambda) * cosPhi,
	      y = sin(lambda) * cosPhi,
	      z = sin(sPhi * phi);
	  lambda = abs(atan2(y, z));
	  phi = asin(x);
	  if (abs(lambda - halfPi) > epsilon) lambda %= halfPi;
	  var point = gringortenHexadecant(lambda > pi / 4 ? halfPi - lambda : lambda, phi);
	  if (lambda > pi / 4) z = point[0], point[0] = -point[1], point[1] = -z;
	  return (point[0] *= sLambda, point[1] *= -sPhi, point);
	}
	
	gringortenRaw.invert = function(x, y) {
	  var sx = sign(x),
	      sy = sign(y),
	      x0 = -sx * x,
	      y0 = -sy * y,
	      t = y0 / x0 < 1,
	      p = gringortenHexadecantInvert(t ? y0 : x0, t ? x0 : y0),
	      lambda = p[0],
	      phi = p[1],
	      cosPhi = cos(phi);
	  if (t) lambda = -halfPi - lambda;
	  return [sx * (atan2(sin(lambda) * cosPhi, -sin(phi)) + pi), sy * asin(cos(lambda) * cosPhi)];
	};
	
	function gringortenHexadecant(lambda, phi) {
	  if (phi === halfPi) return [0, 0];
	
	  var sinPhi = sin(phi),
	      r = sinPhi * sinPhi,
	      r2 = r * r,
	      j = 1 + r2,
	      k = 1 + 3 * r2,
	      q = 1 - r2,
	      z = asin(1 / sqrt(j)),
	      v = q + r * j * z,
	      p2 = (1 - sinPhi) / v,
	      p = sqrt(p2),
	      a2 = p2 * j,
	      a = sqrt(a2),
	      h = p * q,
	      x,
	      i;
	
	  if (lambda === 0) return [0, -(h + r * a)];
	
	  var cosPhi = cos(phi),
	      secPhi = 1 / cosPhi,
	      drdPhi = 2 * sinPhi * cosPhi,
	      dvdPhi = (-3 * r + z * k) * drdPhi,
	      dp2dPhi = (-v * cosPhi - (1 - sinPhi) * dvdPhi) / (v * v),
	      dpdPhi = (0.5 * dp2dPhi) / p,
	      dhdPhi = q * dpdPhi - 2 * r * p * drdPhi,
	      dra2dPhi = r * j * dp2dPhi + p2 * k * drdPhi,
	      mu = -secPhi * drdPhi,
	      nu = -secPhi * dra2dPhi,
	      zeta = -2 * secPhi * dhdPhi,
	      lambda1 = 4 * lambda / pi,
	      delta;
	
	  // Slower but accurate bisection method.
	  if (lambda > 0.222 * pi || phi < pi / 4 && lambda > 0.175 * pi) {
	    x = (h + r * sqrt(a2 * (1 + r2) - h * h)) / (1 + r2);
	    if (lambda > pi / 4) return [x, x];
	    var x1 = x, x0 = 0.5 * x;
	    x = 0.5 * (x0 + x1), i = 50;
	    do {
	      var g = sqrt(a2 - x * x),
	          f = (x * (zeta + mu * g) + nu * asin(x / a)) - lambda1;
	      if (!f) break;
	      if (f < 0) x0 = x;
	      else x1 = x;
	      x = 0.5 * (x0 + x1);
	    } while (abs(x1 - x0) > epsilon && --i > 0);
	  }
	
	  // Newton-Raphson.
	  else {
	    x = epsilon, i = 25;
	    do {
	      var x2 = x * x,
	          g2 = sqrt(a2 - x2),
	          zetaMug = zeta + mu * g2,
	          f2 = x * zetaMug + nu * asin(x / a) - lambda1,
	          df = zetaMug + (nu - mu * x2) / g2;
	      x -= delta = g2 ? f2 / df : 0;
	    } while (abs(delta) > epsilon && --i > 0);
	  }
	
	  return [x, -h - r * sqrt(a2 - x * x)];
	}
	
	function gringortenHexadecantInvert(x, y) {
	  var x0 = 0,
	      x1 = 1,
	      r = 0.5,
	      i = 50;
	
	  while (true) {
	    var r2 = r * r,
	        sinPhi = sqrt(r),
	        z = asin(1 / sqrt(1 + r2)),
	        v = (1 - r2) + r * (1 + r2) * z,
	        p2 = (1 - sinPhi) / v,
	        p = sqrt(p2),
	        a2 = p2 * (1 + r2),
	        h = p * (1 - r2),
	        g2 = a2 - x * x,
	        g = sqrt(g2),
	        y0 = y + h + r * g;
	    if (abs(x1 - x0) < epsilon2 || --i === 0 || y0 === 0) break;
	    if (y0 > 0) x0 = r;
	    else x1 = r;
	    r = 0.5 * (x0 + x1);
	  }
	
	  if (!i) return null;
	
	  var phi = asin(sinPhi),
	      cosPhi = cos(phi),
	      secPhi = 1 / cosPhi,
	      drdPhi = 2 * sinPhi * cosPhi,
	      dvdPhi = (-3 * r + z * (1 + 3 * r2)) * drdPhi,
	      dp2dPhi = (-v * cosPhi - (1 - sinPhi) * dvdPhi) / (v * v),
	      dpdPhi = 0.5 * dp2dPhi / p,
	      dhdPhi = (1 - r2) * dpdPhi - 2 * r * p * drdPhi,
	      zeta = -2 * secPhi * dhdPhi,
	      mu = -secPhi * drdPhi,
	      nu = -secPhi * (r * (1 + r2) * dp2dPhi + p2 * (1 + 3 * r2) * drdPhi);
	
	  return [pi / 4 * (x * (zeta + mu * g) + nu * asin(x / sqrt(a2))), phi];
	}
	
	var gringorten = function() {
	  return d3Geo.geoProjection(squareRaw(gringortenRaw))
	      .scale(239.75);
	};
	
	// Returns [sn, cn, dn](u + iv|m).
	function ellipticJi(u, v, m) {
	  var a, b, c;
	  if (!u) {
	    b = ellipticJ(v, 1 - m);
	    return [
	      [0, b[0] / b[1]],
	      [1 / b[1], 0],
	      [b[2] / b[1], 0]
	    ];
	  }
	  a = ellipticJ(u, m);
	  if (!v) return [[a[0], 0], [a[1], 0], [a[2], 0]];
	  b = ellipticJ(v, 1 - m);
	  c = b[1] * b[1] + m * a[0] * a[0] * b[0] * b[0];
	  return [
	    [a[0] * b[2] / c, a[1] * a[2] * b[0] * b[1] / c],
	    [a[1] * b[1] / c, -a[0] * a[2] * b[0] * b[2] / c],
	    [a[2] * b[1] * b[2] / c, -m * a[0] * a[1] * b[0] / c]
	  ];
	}
	
	// Returns [sn, cn, dn, ph](u|m).
	function ellipticJ(u, m) {
	  var ai, b, phi, t, twon;
	  if (m < epsilon) {
	    t = sin(u);
	    b = cos(u);
	    ai = m * (u - t * b) / 4;
	    return [
	      t - ai * b,
	      b + ai * t,
	      1 - m * t * t / 2,
	      u - ai
	    ];
	  }
	  if (m >= 1 - epsilon) {
	    ai = (1 - m) / 4;
	    b = cosh(u);
	    t = tanh(u);
	    phi = 1 / b;
	    twon = b * sinh(u);
	    return [
	      t + ai * (twon - u) / (b * b),
	      phi - ai * t * phi * (twon - u),
	      phi + ai * t * phi * (twon + u),
	      2 * atan(exp(u)) - halfPi + ai * (twon - u) / b
	    ];
	  }
	
	  var a = [1, 0, 0, 0, 0, 0, 0, 0, 0],
	      c = [sqrt(m), 0, 0, 0, 0, 0, 0, 0, 0],
	      i = 0;
	  b = sqrt(1 - m);
	  twon = 1;
	
	  while (abs(c[i] / a[i]) > epsilon && i < 8) {
	    ai = a[i++];
	    c[i] = (ai - b) / 2;
	    a[i] = (ai + b) / 2;
	    b = sqrt(ai * b);
	    twon *= 2;
	  }
	
	  phi = twon * a[i] * u;
	  do {
	    t = c[i] * sin(b = phi) / a[i];
	    phi = (asin(t) + phi) / 2;
	  } while (--i);
	
	  return [sin(phi), t = cos(phi), t / cos(phi - b), phi];
	}
	
	// Calculate F(phi+iPsi|m).
	// See Abramowitz and Stegun, 17.4.11.
	function ellipticFi(phi, psi, m) {
	  var r = abs(phi),
	      i = abs(psi),
	      sinhPsi = sinh(i);
	  if (r) {
	    var cscPhi = 1 / sin(r),
	        cotPhi2 = 1 / (tan(r) * tan(r)),
	        b = -(cotPhi2 + m * (sinhPsi * sinhPsi * cscPhi * cscPhi) - 1 + m),
	        c = (m - 1) * cotPhi2,
	        cotLambda2 = (-b + sqrt(b * b - 4 * c)) / 2;
	    return [
	      ellipticF(atan(1 / sqrt(cotLambda2)), m) * sign(phi),
	      ellipticF(atan(sqrt((cotLambda2 / cotPhi2 - 1) / m)), 1 - m) * sign(psi)
	    ];
	  }
	  return [
	    0,
	    ellipticF(atan(sinhPsi), 1 - m) * sign(psi)
	  ];
	}
	
	// Calculate F(phi|m) where m = k² = sin²α.
	// See Abramowitz and Stegun, 17.6.7.
	function ellipticF(phi, m) {
	  if (!m) return phi;
	  if (m === 1) return log(tan(phi / 2 + quarterPi));
	  var a = 1,
	      b = sqrt(1 - m),
	      c = sqrt(m);
	  for (var i = 0; abs(c) > epsilon; i++) {
	    if (phi % pi) {
	      var dPhi = atan(b * tan(phi) / a);
	      if (dPhi < 0) dPhi += pi;
	      phi += dPhi + ~~(phi / pi) * pi;
	    } else phi += phi;
	    c = (a + b) / 2;
	    b = sqrt(a * b);
	    c = ((a = c) - b) / 2;
	  }
	  return phi / (pow(2, i) * a);
	}
	
	function guyouRaw(lambda, phi) {
	  var k_ = (sqrt2 - 1) / (sqrt2 + 1),
	      k = sqrt(1 - k_ * k_),
	      K = ellipticF(halfPi, k * k),
	      f = -1,
	      psi = log(tan(pi / 4 + abs(phi) / 2)),
	      r = exp(f * psi) / sqrt(k_),
	      at = guyouComplexAtan(r * cos(f * lambda), r * sin(f * lambda)),
	      t = ellipticFi(at[0], at[1], k * k);
	  return [-t[1], (phi >= 0 ? 1 : -1) * (0.5 * K - t[0])];
	}
	
	function guyouComplexAtan(x, y) {
	  var x2 = x * x,
	      y_1 = y + 1,
	      t = 1 - x2 - y * y;
	  return [
	   0.5 * ((x >= 0 ? halfPi : -halfPi) - atan2(t, 2 * x)),
	    -0.25 * log(t * t + 4 * x2) +0.5 * log(y_1 * y_1 + x2)
	  ];
	}
	
	function guyouComplexDivide(a, b) {
	  var denominator = b[0] * b[0] + b[1] * b[1];
	  return [
	    (a[0] * b[0] + a[1] * b[1]) / denominator,
	    (a[1] * b[0] - a[0] * b[1]) / denominator
	  ];
	}
	
	guyouRaw.invert = function(x, y) {
	  var k_ = (sqrt2 - 1) / (sqrt2 + 1),
	      k = sqrt(1 - k_ * k_),
	      K = ellipticF(halfPi, k * k),
	      f = -1,
	      j = ellipticJi(0.5 * K - y, -x, k * k),
	      tn = guyouComplexDivide(j[0], j[1]),
	      lambda = atan2(tn[1], tn[0]) / f;
	  return [
	    lambda,
	    2 * atan(exp(0.5 / f * log(k_ * tn[0] * tn[0] + k_ * tn[1] * tn[1]))) - halfPi
	  ];
	};
	
	var guyou = function() {
	  return d3Geo.geoProjection(squareRaw(guyouRaw))
	      .scale(151.496);
	};
	
	function hammerRaw(A, B) {
	  if (arguments.length < 2) B = A;
	  if (B === 1) return d3Geo.geoAzimuthalEqualAreaRaw;
	  if (B === Infinity) return hammerQuarticAuthalicRaw;
	
	  function forward(lambda, phi) {
	    var coordinates = d3Geo.geoAzimuthalEqualAreaRaw(lambda / B, phi);
	    coordinates[0] *= A;
	    return coordinates;
	  }
	
	  forward.invert = function(x, y) {
	    var coordinates = d3Geo.geoAzimuthalEqualAreaRaw.invert(x / A, y);
	    coordinates[0] *= B;
	    return coordinates;
	  };
	
	  return forward;
	}
	
	function hammerQuarticAuthalicRaw(lambda, phi) {
	  return [
	    lambda * cos(phi) / cos(phi /= 2),
	    2 * sin(phi)
	  ];
	}
	
	hammerQuarticAuthalicRaw.invert = function(x, y) {
	  var phi = 2 * asin(y / 2);
	  return [
	    x * cos(phi / 2) / cos(phi),
	    phi
	  ];
	};
	
	var hammer = function() {
	  var B = 2,
	      m = d3Geo.geoProjectionMutator(hammerRaw),
	      p = m(B);
	
	  p.coefficient = function(_) {
	    if (!arguments.length) return B;
	    return m(B = +_);
	  };
	
	  return p
	    .scale(169.529);
	};
	
	function hammerRetroazimuthalRaw(phi0) {
	  var sinPhi0 = sin(phi0),
	      cosPhi0 = cos(phi0),
	      rotate = hammerRetroazimuthalRotation(phi0);
	
	  rotate.invert = hammerRetroazimuthalRotation(-phi0);
	
	  function forward(lambda, phi) {
	    var p = rotate(lambda, phi);
	    lambda = p[0], phi = p[1];
	    var sinPhi = sin(phi),
	        cosPhi = cos(phi),
	        cosLambda = cos(lambda),
	        z = acos(sinPhi0 * sinPhi + cosPhi0 * cosPhi * cosLambda),
	        sinz = sin(z),
	        K = abs(sinz) > epsilon ? z / sinz : 1;
	    return [
	      K * cosPhi0 * sin(lambda),
	      (abs(lambda) > halfPi ? K : -K) // rotate for back hemisphere
	        * (sinPhi0 * cosPhi - cosPhi0 * sinPhi * cosLambda)
	    ];
	  }
	
	  forward.invert = function(x, y) {
	    var rho = sqrt(x * x + y * y),
	        sinz = -sin(rho),
	        cosz = cos(rho),
	        a = rho * cosz,
	        b = -y * sinz,
	        c = rho * sinPhi0,
	        d = sqrt(a * a + b * b - c * c),
	        phi = atan2(a * c + b * d, b * c - a * d),
	        lambda = (rho > halfPi ? -1 : 1) * atan2(x * sinz, rho * cos(phi) * cosz + y * sin(phi) * sinz);
	    return rotate.invert(lambda, phi);
	  };
	
	  return forward;
	}
	
	// Latitudinal rotation by phi0.
	// Temporary hack until D3 supports arbitrary small-circle clipping origins.
	function hammerRetroazimuthalRotation(phi0) {
	  var sinPhi0 = sin(phi0),
	      cosPhi0 = cos(phi0);
	
	  return function(lambda, phi) {
	    var cosPhi = cos(phi),
	        x = cos(lambda) * cosPhi,
	        y = sin(lambda) * cosPhi,
	        z = sin(phi);
	    return [
	      atan2(y, x * cosPhi0 - z * sinPhi0),
	      asin(z * cosPhi0 + x * sinPhi0)
	    ];
	  };
	}
	
	var hammerRetroazimuthal = function() {
	  var phi0 = 0,
	      m = d3Geo.geoProjectionMutator(hammerRetroazimuthalRaw),
	      p = m(phi0),
	      rotate_ = p.rotate,
	      stream_ = p.stream,
	      circle = d3Geo.geoCircle();
	
	  p.parallel = function(_) {
	    if (!arguments.length) return phi0 * degrees;
	    var r = p.rotate();
	    return m(phi0 = _ * radians).rotate(r);
	  };
	
	  // Temporary hack; see hammerRetroazimuthalRotation.
	  p.rotate = function(_) {
	    if (!arguments.length) return (_ = rotate_.call(p), _[1] += phi0 * degrees, _);
	    rotate_.call(p, [_[0], _[1] - phi0 * degrees]);
	    circle.center([-_[0], -_[1]]);
	    return p;
	  };
	
	  p.stream = function(stream) {
	    stream = stream_(stream);
	    stream.sphere = function() {
	      stream.polygonStart();
	      var epsilon$$1 = 1e-2,
	          ring = circle.radius(90 - epsilon$$1)().coordinates[0],
	          n = ring.length - 1,
	          i = -1,
	          p;
	      stream.lineStart();
	      while (++i < n) stream.point((p = ring[i])[0], p[1]);
	      stream.lineEnd();
	      ring = circle.radius(90 + epsilon$$1)().coordinates[0];
	      n = ring.length - 1;
	      stream.lineStart();
	      while (--i >= 0) stream.point((p = ring[i])[0], p[1]);
	      stream.lineEnd();
	      stream.polygonEnd();
	    };
	    return stream;
	  };
	
	  return p
	      .scale(79.4187)
	      .parallel(45)
	      .clipAngle(180 - 1e-3);
	};
	
	var healpixParallel = 41 + 48 / 36 + 37 / 3600;
	var healpixLambert = cylindricalEqualAreaRaw(0);
	
	function healpixRaw(H) {
	  var phi0 = healpixParallel * radians,
	      dx = collignonRaw(pi, phi0)[0] - collignonRaw(-pi, phi0)[0],
	      y0 = healpixLambert(0, phi0)[1],
	      y1 = collignonRaw(0, phi0)[1],
	      dy1 = sqrtPi - y1,
	      k = tau / H,
	      w = 4 / tau,
	      h = y0 + (dy1 * dy1 * 4) / tau;
	
	  function forward(lambda, phi) {
	    var point,
	        phi2 = abs(phi);
	    if (phi2 > phi0) {
	      var i = min(H - 1, max(0, floor((lambda + pi) / k)));
	      lambda += pi * (H - 1) / H - i * k;
	      point = collignonRaw(lambda, phi2);
	      point[0] = point[0] * tau / dx - tau * (H - 1) / (2 * H) + i * tau / H;
	      point[1] = y0 + (point[1] - y1) * 4 * dy1 / tau;
	      if (phi < 0) point[1] = -point[1];
	    } else {
	      point = healpixLambert(lambda, phi);
	    }
	    point[0] *= w, point[1] /= h;
	    return point;
	  }
	
	  forward.invert = function(x, y) {
	    x /= w, y *= h;
	    var y2 = abs(y);
	    if (y2 > y0) {
	      var i = min(H - 1, max(0, floor((x + pi) / k)));
	      x = (x + pi * (H - 1) / H - i * k) * dx / tau;
	      var point = collignonRaw.invert(x, 0.25 * (y2 - y0) * tau / dy1 + y1);
	      point[0] -= pi * (H - 1) / H - i * k;
	      if (y < 0) point[1] = -point[1];
	      return point;
	    }
	    return healpixLambert.invert(x, y);
	  };
	
	  return forward;
	}
	
	function sphere(step) {
	  return {
	    type: "Polygon",
	    coordinates: [
	      d3Array.range(-180, 180 + step / 2, step).map(function(x, i) { return [x, i & 1 ? 90 - 1e-6 : healpixParallel]; })
	      .concat(d3Array.range(180, -180 - step / 2, -step).map(function(x, i) { return [x, i & 1 ? -90 + 1e-6 : -healpixParallel]; }))
	    ]
	  };
	}
	
	var healpix = function() {
	  var H = 4,
	      m = d3Geo.geoProjectionMutator(healpixRaw),
	      p = m(H),
	      stream_ = p.stream;
	
	  p.lobes = function(_) {
	    return arguments.length ? m(H = +_) : H;
	  };
	
	  p.stream = function(stream) {
	    var rotate = p.rotate(),
	        rotateStream = stream_(stream),
	        sphereStream = (p.rotate([0, 0]), stream_(stream));
	    p.rotate(rotate);
	    rotateStream.sphere = function() { d3Geo.geoStream(sphere(180 / H), sphereStream); };
	    return rotateStream;
	  };
	
	  return p
	      .scale(239.75);
	};
	
	function hillRaw(K) {
	  var L = 1 + K,
	      sinBt = sin(1 / L),
	      Bt = asin(sinBt),
	      A = 2 * sqrt(pi / (B = pi + 4 * Bt * L)),
	      B,
	      rho0 = 0.5 * A * (L + sqrt(K * (2 + K))),
	      K2 = K * K,
	      L2 = L * L;
	
	  function forward(lambda, phi) {
	    var t = 1 - sin(phi),
	        rho,
	        omega;
	    if (t && t < 2) {
	      var theta = halfPi - phi, i = 25, delta;
	      do {
	        var sinTheta = sin(theta),
	            cosTheta = cos(theta),
	            Bt_Bt1 = Bt + atan2(sinTheta, L - cosTheta),
	            C = 1 + L2 - 2 * L * cosTheta;
	        theta -= delta = (theta - K2 * Bt - L * sinTheta + C * Bt_Bt1 -0.5 * t * B) / (2 * L * sinTheta * Bt_Bt1);
	      } while (abs(delta) > epsilon2 && --i > 0);
	      rho = A * sqrt(C);
	      omega = lambda * Bt_Bt1 / pi;
	    } else {
	      rho = A * (K + t);
	      omega = lambda * Bt / pi;
	    }
	    return [
	      rho * sin(omega),
	      rho0 - rho * cos(omega)
	    ];
	  }
	
	  forward.invert = function(x, y) {
	    var rho2 = x * x + (y -= rho0) * y,
	        cosTheta = (1 + L2 - rho2 / (A * A)) / (2 * L),
	        theta = acos(cosTheta),
	        sinTheta = sin(theta),
	        Bt_Bt1 = Bt + atan2(sinTheta, L - cosTheta);
	    return [
	      asin(x / sqrt(rho2)) * pi / Bt_Bt1,
	      asin(1 - 2 * (theta - K2 * Bt - L * sinTheta + (1 + L2 - 2 * L * cosTheta) * Bt_Bt1) / B)
	    ];
	  };
	
	  return forward;
	}
	
	var hill = function() {
	  var K = 1,
	      m = d3Geo.geoProjectionMutator(hillRaw),
	      p = m(K);
	
	  p.ratio = function(_) {
	    return arguments.length ? m(K = +_) : K;
	  };
	
	  return p
	      .scale(167.774)
	      .center([0, 18.67]);
	};
	
	var sinuMollweidePhi = 0.7109889596207567;
	
	var sinuMollweideY = 0.0528035274542;
	
	function sinuMollweideRaw(lambda, phi) {
	  return phi > -sinuMollweidePhi
	      ? (lambda = mollweideRaw(lambda, phi), lambda[1] += sinuMollweideY, lambda)
	      : sinusoidalRaw(lambda, phi);
	}
	
	sinuMollweideRaw.invert = function(x, y) {
	  return y > -sinuMollweidePhi
	      ? mollweideRaw.invert(x, y - sinuMollweideY)
	      : sinusoidalRaw.invert(x, y);
	};
	
	var sinuMollweide = function() {
	  return d3Geo.geoProjection(sinuMollweideRaw)
	      .rotate([-20, -55])
	      .scale(164.263)
	      .center([0, -5.4036]);
	};
	
	function homolosineRaw(lambda, phi) {
	  return abs(phi) > sinuMollweidePhi
	      ? (lambda = mollweideRaw(lambda, phi), lambda[1] -= phi > 0 ? sinuMollweideY : -sinuMollweideY, lambda)
	      : sinusoidalRaw(lambda, phi);
	}
	
	homolosineRaw.invert = function(x, y) {
	  return abs(y) > sinuMollweidePhi
	      ? mollweideRaw.invert(x, y + (y > 0 ? sinuMollweideY : -sinuMollweideY))
	      : sinusoidalRaw.invert(x, y);
	};
	
	var homolosine = function() {
	  return d3Geo.geoProjection(homolosineRaw)
	      .scale(152.63);
	};
	
	function pointEqual(a, b) {
	  return abs(a[0] - b[0]) < epsilon && abs(a[1] - b[1]) < epsilon;
	}
	
	function interpolateLine(coordinates, m) {
	  var i = -1,
	      n = coordinates.length,
	      p0 = coordinates[0],
	      p1,
	      dx,
	      dy,
	      resampled = [];
	  while (++i < n) {
	    p1 = coordinates[i];
	    dx = (p1[0] - p0[0]) / m;
	    dy = (p1[1] - p0[1]) / m;
	    for (var j = 0; j < m; ++j) resampled.push([p0[0] + j * dx, p0[1] + j * dy]);
	    p0 = p1;
	  }
	  resampled.push(p1);
	  return resampled;
	}
	
	function interpolateSphere(lobes) {
	  var coordinates = [],
	      lobe,
	      lambda0, phi0, phi1,
	      lambda2, phi2,
	      i, n = lobes[0].length;
	
	  // Northern Hemisphere
	  for (i = 0; i < n; ++i) {
	    lobe = lobes[0][i];
	    lambda0 = lobe[0][0], phi0 = lobe[0][1], phi1 = lobe[1][1];
	    lambda2 = lobe[2][0], phi2 = lobe[2][1];
	    coordinates.push(interpolateLine([
	      [lambda0 + epsilon, phi0 + epsilon],
	      [lambda0 + epsilon, phi1 - epsilon],
	      [lambda2 - epsilon, phi1 - epsilon],
	      [lambda2 - epsilon, phi2 + epsilon]
	    ], 30));
	  }
	
	  // Southern Hemisphere
	  for (i = lobes[1].length - 1; i >= 0; --i) {
	    lobe = lobes[1][i];
	    lambda0 = lobe[0][0], phi0 = lobe[0][1], phi1 = lobe[1][1];
	    lambda2 = lobe[2][0], phi2 = lobe[2][1];
	    coordinates.push(interpolateLine([
	      [lambda2 - epsilon, phi2 - epsilon],
	      [lambda2 - epsilon, phi1 + epsilon],
	      [lambda0 + epsilon, phi1 + epsilon],
	      [lambda0 + epsilon, phi0 - epsilon]
	    ], 30));
	  }
	
	  return {
	    type: "Polygon",
	    coordinates: [d3Array.merge(coordinates)]
	  };
	}
	
	var interrupt = function(project, lobes) {
	  var sphere = interpolateSphere(lobes);
	
	  lobes = lobes.map(function(lobe) {
	    return lobe.map(function(l) {
	      return [
	        [l[0][0] * radians, l[0][1] * radians],
	        [l[1][0] * radians, l[1][1] * radians],
	        [l[2][0] * radians, l[2][1] * radians]
	      ];
	    });
	  });
	
	  var bounds = lobes.map(function(lobe) {
	    return lobe.map(function(l) {
	      var x0 = project(l[0][0], l[0][1])[0],
	          x1 = project(l[2][0], l[2][1])[0],
	          y0 = project(l[1][0], l[0][1])[1],
	          y1 = project(l[1][0], l[1][1])[1],
	          t;
	      if (y0 > y1) t = y0, y0 = y1, y1 = t;
	      return [[x0, y0], [x1, y1]];
	    });
	  });
	
	  function forward(lambda, phi) {
	    var sign$$1 = phi < 0 ? -1 : +1, lobe = lobes[+(phi < 0)];
	    for (var i = 0, n = lobe.length - 1; i < n && lambda > lobe[i][2][0]; ++i);
	    var p = project(lambda - lobe[i][1][0], phi);
	    p[0] += project(lobe[i][1][0], sign$$1 * phi > sign$$1 * lobe[i][0][1] ? lobe[i][0][1] : phi)[0];
	    return p;
	  }
	
	  // Assumes mutually exclusive bounding boxes for lobes.
	  if (project.invert) forward.invert = function(x, y) {
	    var bound = bounds[+(y < 0)], lobe = lobes[+(y < 0)];
	    for (var i = 0, n = bound.length; i < n; ++i) {
	      var b = bound[i];
	      if (b[0][0] <= x && x < b[1][0] && b[0][1] <= y && y < b[1][1]) {
	        var p = project.invert(x - project(lobe[i][1][0], 0)[0], y);
	        p[0] += lobe[i][1][0];
	        return pointEqual(forward(p[0], p[1]), [x, y]) ? p : null;
	      }
	    }
	  };
	
	  var p = d3Geo.geoProjection(forward),
	      stream_ = p.stream;
	
	  p.stream = function(stream) {
	    var rotate = p.rotate(),
	        rotateStream = stream_(stream),
	        sphereStream = (p.rotate([0, 0]), stream_(stream));
	    p.rotate(rotate);
	    rotateStream.sphere = function() { d3Geo.geoStream(sphere, sphereStream); };
	    return rotateStream;
	  };
	
	  return p;
	};
	
	var lobes = [[ // northern hemisphere
	  [[-180,   0], [-100,  90], [ -40,   0]],
	  [[ -40,   0], [  30,  90], [ 180,   0]]
	], [ // southern hemisphere
	  [[-180,   0], [-160, -90], [-100,   0]],
	  [[-100,   0], [ -60, -90], [ -20,   0]],
	  [[ -20,   0], [  20, -90], [  80,   0]],
	  [[  80,   0], [ 140, -90], [ 180,   0]]
	]];
	
	var boggs$1 = function() {
	  return interrupt(boggsRaw, lobes)
	      .scale(160.857);
	};
	
	var lobes$1 = [[ // northern hemisphere
	  [[-180,   0], [-100,  90], [ -40,   0]],
	  [[ -40,   0], [  30,  90], [ 180,   0]]
	], [ // southern hemisphere
	  [[-180,   0], [-160, -90], [-100,   0]],
	  [[-100,   0], [ -60, -90], [ -20,   0]],
	  [[ -20,   0], [  20, -90], [  80,   0]],
	  [[  80,   0], [ 140, -90], [ 180,   0]]
	]];
	
	var homolosine$1 = function() {
	  return interrupt(homolosineRaw, lobes$1)
	      .scale(152.63);
	};
	
	var lobes$2 = [[ // northern hemisphere
	  [[-180,   0], [-100,  90], [ -40,   0]],
	  [[ -40,   0], [  30,  90], [ 180,   0]]
	], [ // southern hemisphere
	  [[-180,   0], [-160, -90], [-100,   0]],
	  [[-100,   0], [ -60, -90], [ -20,   0]],
	  [[ -20,   0], [  20, -90], [  80,   0]],
	  [[  80,   0], [ 140, -90], [ 180,   0]]
	]];
	
	var mollweide$1 = function() {
	  return interrupt(mollweideRaw, lobes$2)
	      .scale(169.529);
	};
	
	var lobes$3 = [[ // northern hemisphere
	  [[-180,   0], [ -90,  90], [   0,   0]],
	  [[   0,   0], [  90,  90], [ 180,   0]]
	], [ // southern hemisphere
	  [[-180,   0], [ -90, -90], [   0,   0]],
	  [[   0,   0], [  90, -90], [ 180,   0]]
	]];
	
	var mollweideHemispheres = function() {
	  return interrupt(mollweideRaw, lobes$3)
	      .scale(169.529)
	      .rotate([20, 0]);
	};
	
	var lobes$4 = [[ // northern hemisphere
	  [[-180,  35], [ -30,  90], [   0,  35]],
	  [[   0,  35], [  30,  90], [ 180,  35]]
	], [ // southern hemisphere
	  [[-180, -10], [-102, -90], [ -65, -10]],
	  [[ -65, -10], [   5, -90], [  77, -10]],
	  [[  77, -10], [ 103, -90], [ 180, -10]]
	]];
	
	var sinuMollweide$1 = function() {
	  return interrupt(sinuMollweideRaw, lobes$4)
	      .rotate([-20, -55])
	      .scale(164.263)
	      .center([0, -5.4036]);
	};
	
	var lobes$5 = [[ // northern hemisphere
	  [[-180,   0], [-110,  90], [ -40,   0]],
	  [[ -40,   0], [   0,  90], [  40,   0]],
	  [[  40,   0], [ 110,  90], [ 180,   0]]
	], [ // southern hemisphere
	  [[-180,   0], [-110, -90], [ -40,   0]],
	  [[ -40,   0], [   0, -90], [  40,   0]],
	  [[  40,   0], [ 110, -90], [ 180,   0]]
	]];
	
	var sinusoidal$1 = function() {
	  return interrupt(sinusoidalRaw, lobes$5)
	      .scale(152.63)
	      .rotate([-20, 0]);
	};
	
	function kavrayskiy7Raw(lambda, phi) {
	  return [3 / tau * lambda * sqrt(pi * pi / 3 - phi * phi), phi];
	}
	
	kavrayskiy7Raw.invert = function(x, y) {
	  return [tau / 3 * x / sqrt(pi * pi / 3 - y * y), y];
	};
	
	var kavrayskiy7 = function() {
	  return d3Geo.geoProjection(kavrayskiy7Raw)
	      .scale(158.837);
	};
	
	function lagrangeRaw(n) {
	
	  function forward(lambda, phi) {
	    if (abs(abs(phi) - halfPi) < epsilon) return [0, phi < 0 ? -2 : 2];
	    var sinPhi = sin(phi),
	        v = pow((1 + sinPhi) / (1 - sinPhi), n / 2),
	        c = 0.5 * (v + 1 / v) + cos(lambda *= n);
	    return [
	      2 * sin(lambda) / c,
	      (v - 1 / v) / c
	    ];
	  }
	
	  forward.invert = function(x, y) {
	    var y0 = abs(y);
	    if (abs(y0 - 2) < epsilon) return x ? null : [0, sign(y) * halfPi];
	    if (y0 > 2) return null;
	
	    x /= 2, y /= 2;
	    var x2 = x * x,
	        y2 = y * y,
	        t = 2 * y / (1 + x2 + y2); // tanh(nPhi)
	    t = pow((1 + t) / (1 - t), 1 / n);
	    return [
	      atan2(2 * x, 1 - x2 - y2) / n,
	      asin((t - 1) / (t + 1))
	    ];
	  };
	
	  return forward;
	}
	
	var lagrange = function() {
	  var n = 0.5,
	      m = d3Geo.geoProjectionMutator(lagrangeRaw),
	      p = m(n);
	
	  p.spacing = function(_) {
	    return arguments.length ? m(n = +_) : n;
	  };
	
	  return p
	      .scale(124.75);
	};
	
	var pi_sqrt2 = pi / sqrt2;
	
	function larriveeRaw(lambda, phi) {
	  return [
	    lambda * (1 + sqrt(cos(phi))) / 2,
	    phi / (cos(phi / 2) * cos(lambda / 6))
	  ];
	}
	
	larriveeRaw.invert = function(x, y) {
	  var x0 = abs(x),
	      y0 = abs(y),
	      lambda = epsilon,
	      phi = halfPi;
	  if (y0 < pi_sqrt2) phi *= y0 / pi_sqrt2;
	  else lambda += 6 * acos(pi_sqrt2 / y0);
	  for (var i = 0; i < 25; i++) {
	    var sinPhi = sin(phi),
	        sqrtcosPhi = sqrt(cos(phi)),
	        sinPhi_2 = sin(phi / 2),
	        cosPhi_2 = cos(phi / 2),
	        sinLambda_6 = sin(lambda / 6),
	        cosLambda_6 = cos(lambda / 6),
	        f0 = 0.5 * lambda * (1 + sqrtcosPhi) - x0,
	        f1 = phi / (cosPhi_2 * cosLambda_6) - y0,
	        df0dPhi = sqrtcosPhi ? -0.25 * lambda * sinPhi / sqrtcosPhi : 0,
	        df0dLambda = 0.5 * (1 + sqrtcosPhi),
	        df1dPhi = (1 +0.5 * phi * sinPhi_2 / cosPhi_2) / (cosPhi_2 * cosLambda_6),
	        df1dLambda = (phi / cosPhi_2) * (sinLambda_6 / 6) / (cosLambda_6 * cosLambda_6),
	        denom = df0dPhi * df1dLambda - df1dPhi * df0dLambda,
	        dPhi = (f0 * df1dLambda - f1 * df0dLambda) / denom,
	        dLambda = (f1 * df0dPhi - f0 * df1dPhi) / denom;
	    phi -= dPhi;
	    lambda -= dLambda;
	    if (abs(dPhi) < epsilon && abs(dLambda) < epsilon) break;
	  }
	  return [x < 0 ? -lambda : lambda, y < 0 ? -phi : phi];
	};
	
	var larrivee = function() {
	  return d3Geo.geoProjection(larriveeRaw)
	      .scale(97.2672);
	};
	
	function laskowskiRaw(lambda, phi) {
	  var lambda2 = lambda * lambda, phi2 = phi * phi;
	  return [
	    lambda * (0.975534 + phi2 * (-0.119161 + lambda2 * -0.0143059 + phi2 * -0.0547009)),
	    phi * (1.00384 + lambda2 * (0.0802894 + phi2 * -0.02855 + lambda2 * 0.000199025) + phi2 * (0.0998909 + phi2 * -0.0491032))
	  ];
	}
	
	laskowskiRaw.invert = function(x, y) {
	  var lambda = sign(x) * pi,
	      phi = y / 2,
	      i = 50;
	  do {
	    var lambda2 = lambda * lambda,
	        phi2 = phi * phi,
	        lambdaPhi = lambda * phi,
	        fx = lambda * (0.975534 + phi2 * (-0.119161 + lambda2 * -0.0143059 + phi2 * -0.0547009)) - x,
	        fy = phi * (1.00384 + lambda2 * (0.0802894 + phi2 * -0.02855 + lambda2 * 0.000199025) + phi2 * (0.0998909 + phi2 * -0.0491032)) - y,
	        deltaxDeltaLambda = 0.975534 - phi2 * (0.119161 + 3 * lambda2 * 0.0143059 + phi2 * 0.0547009),
	        deltaxDeltaPhi = -lambdaPhi * (2 * 0.119161 + 4 * 0.0547009 * phi2 + 2 * 0.0143059 * lambda2),
	        deltayDeltaLambda = lambdaPhi * (2 * 0.0802894 + 4 * 0.000199025 * lambda2 + 2 * -0.02855 * phi2),
	        deltayDeltaPhi = 1.00384 + lambda2 * (0.0802894 + 0.000199025 * lambda2) + phi2 * (3 * (0.0998909 - 0.02855 * lambda2) - 5 * 0.0491032 * phi2),
	        denominator = deltaxDeltaPhi * deltayDeltaLambda - deltayDeltaPhi * deltaxDeltaLambda,
	        deltaLambda = (fy * deltaxDeltaPhi - fx * deltayDeltaPhi) / denominator,
	        deltaPhi = (fx * deltayDeltaLambda - fy * deltaxDeltaLambda) / denominator;
	    lambda -= deltaLambda, phi -= deltaPhi;
	  } while ((abs(deltaLambda) > epsilon || abs(deltaPhi) > epsilon) && --i > 0);
	  return i && [lambda, phi];
	};
	
	var laskowski = function() {
	  return d3Geo.geoProjection(laskowskiRaw)
	      .scale(139.98);
	};
	
	function littrowRaw(lambda, phi) {
	  return [
	    sin(lambda) / cos(phi),
	    tan(phi) * cos(lambda)
	  ];
	}
	
	littrowRaw.invert = function(x, y) {
	  var x2 = x * x,
	      y2 = y * y,
	      y2_1 = y2 + 1,
	      cosPhi = x
	          ? sqrt1_2 * sqrt((y2_1 - sqrt(x2 * x2 + 2 * x2 * (y2 - 1) + y2_1 * y2_1)) / x2 + 1)
	          : 1 / sqrt(y2_1);
	  return [
	    asin(x * cosPhi),
	    sign(y) * acos(cosPhi)
	  ];
	};
	
	var littrow = function() {
	  return d3Geo.geoProjection(littrowRaw)
	      .scale(144.049)
	      .clipAngle(90 - 1e-3);
	};
	
	function loximuthalRaw(phi0) {
	  var cosPhi0 = cos(phi0),
	      tanPhi0 = tan(quarterPi + phi0 / 2);
	
	  function forward(lambda, phi) {
	    var y = phi - phi0,
	        x = abs(y) < epsilon ? lambda * cosPhi0
	            : abs(x = quarterPi + phi / 2) < epsilon || abs(abs(x) - halfPi) < epsilon
	            ? 0 : lambda * y / log(tan(x) / tanPhi0);
	    return [x, y];
	  }
	
	  forward.invert = function(x, y) {
	    var lambda,
	        phi = y + phi0;
	    return [
	      abs(y) < epsilon ? x / cosPhi0
	          : (abs(lambda = quarterPi + phi / 2) < epsilon || abs(abs(lambda) - halfPi) < epsilon) ? 0
	          : x * log(tan(lambda) / tanPhi0) / y,
	      phi
	    ];
	  };
	
	  return forward;
	}
	
	var loximuthal = function() {
	  return parallel1(loximuthalRaw)
	      .parallel(40)
	      .scale(158.837);
	};
	
	function millerRaw(lambda, phi) {
	  return [lambda, 1.25 * log(tan(quarterPi + 0.4 * phi))];
	}
	
	millerRaw.invert = function(x, y) {
	  return [x, 2.5 * atan(exp(0.8 * y)) - 0.625 * pi];
	};
	
	var miller = function() {
	  return d3Geo.geoProjection(millerRaw)
	      .scale(108.318);
	};
	
	function modifiedStereographicRaw(C) {
	  var m = C.length - 1;
	
	  function forward(lambda, phi) {
	    var cosPhi = cos(phi),
	        k = 2 / (1 + cosPhi * cos(lambda)),
	        zr = k * cosPhi * sin(lambda),
	        zi = k * sin(phi),
	        i = m,
	        w = C[i],
	        ar = w[0],
	        ai = w[1],
	        t;
	    while (--i >= 0) {
	      w = C[i];
	      ar = w[0] + zr * (t = ar) - zi * ai;
	      ai = w[1] + zr * ai + zi * t;
	    }
	    ar = zr * (t = ar) - zi * ai;
	    ai = zr * ai + zi * t;
	    return [ar, ai];
	  }
	
	  forward.invert = function(x, y) {
	    var i = 20,
	        zr = x,
	        zi = y;
	    do {
	      var j = m,
	          w = C[j],
	          ar = w[0],
	          ai = w[1],
	          br = 0,
	          bi = 0,
	          t;
	
	      while (--j >= 0) {
	        w = C[j];
	        br = ar + zr * (t = br) - zi * bi;
	        bi = ai + zr * bi + zi * t;
	        ar = w[0] + zr * (t = ar) - zi * ai;
	        ai = w[1] + zr * ai + zi * t;
	      }
	      br = ar + zr * (t = br) - zi * bi;
	      bi = ai + zr * bi + zi * t;
	      ar = zr * (t = ar) - zi * ai - x;
	      ai = zr * ai + zi * t - y;
	
	      var denominator = br * br + bi * bi, deltar, deltai;
	      zr -= deltar = (ar * br + ai * bi) / denominator;
	      zi -= deltai = (ai * br - ar * bi) / denominator;
	    } while (abs(deltar) + abs(deltai) > epsilon * epsilon && --i > 0);
	
	    if (i) {
	      var rho = sqrt(zr * zr + zi * zi),
	          c = 2 * atan(rho * 0.5),
	          sinc = sin(c);
	      return [atan2(zr * sinc, rho * cos(c)), rho ? asin(zi * sinc / rho) : 0];
	    }
	  };
	
	  return forward;
	}
	
	var alaska = [[0.9972523, 0], [0.0052513, -0.0041175], [0.0074606, 0.0048125], [-0.0153783, -0.1968253], [0.0636871, -0.1408027], [0.3660976, -0.2937382]];
	var gs48 = [[0.98879, 0], [0, 0], [-0.050909, 0], [0, 0], [0.075528, 0]];
	var gs50 = [[0.9842990, 0], [0.0211642, 0.0037608], [-0.1036018, -0.0575102], [-0.0329095, -0.0320119], [0.0499471, 0.1223335], [0.0260460, 0.0899805], [0.0007388, -0.1435792], [0.0075848, -0.1334108], [-0.0216473, 0.0776645], [-0.0225161, 0.0853673]];
	var miller$1 = [[0.9245, 0], [0, 0], [0.01943, 0]];
	var lee = [[0.721316, 0], [0, 0], [-0.00881625, -0.00617325]];
	
	function modifiedStereographicAlaska() {
	  return modifiedStereographic(alaska, [152, -64])
	      .scale(1500)
	      .center([-160.908, 62.4864])
	      .clipAngle(25);
	}
	
	function modifiedStereographicGs48() {
	  return modifiedStereographic(gs48, [95, -38])
	      .scale(1000)
	      .clipAngle(55)
	      .center([-96.5563, 38.8675]);
	}
	
	function modifiedStereographicGs50() {
	  return modifiedStereographic(gs50, [120, -45])
	      .scale(359.513)
	      .clipAngle(55)
	      .center([-117.474, 53.0628]);
	}
	
	function modifiedStereographicMiller() {
	  return modifiedStereographic(miller$1, [-20, -18])
	      .scale(209.091)
	      .center([20, 16.7214])
	      .clipAngle(82);
	}
	
	function modifiedStereographicLee() {
	  return modifiedStereographic(lee, [165, 10])
	      .scale(250)
	      .clipAngle(130)
	      .center([-165, -10]);
	}
	
	function modifiedStereographic(coefficients, rotate) {
	  var p = d3Geo.geoProjection(modifiedStereographicRaw(coefficients)).rotate(rotate).clipAngle(90),
	      r = d3Geo.geoRotation(rotate),
	      center = p.center;
	
	  delete p.rotate;
	
	  p.center = function(_) {
	    return arguments.length ? center(r(_)) : r.invert(center());
	  };
	
	  return p;
	}
	
	var sqrt6 = sqrt(6);
	var sqrt7 = sqrt(7);
	
	function mtFlatPolarParabolicRaw(lambda, phi) {
	  var theta = asin(7 * sin(phi) / (3 * sqrt6));
	  return [
	    sqrt6 * lambda * (2 * cos(2 * theta / 3) - 1) / sqrt7,
	    9 * sin(theta / 3) / sqrt7
	  ];
	}
	
	mtFlatPolarParabolicRaw.invert = function(x, y) {
	  var theta = 3 * asin(y * sqrt7 / 9);
	  return [
	    x * sqrt7 / (sqrt6 * (2 * cos(2 * theta / 3) - 1)),
	    asin(sin(theta) * 3 * sqrt6 / 7)
	  ];
	};
	
	var mtFlatPolarParabolic = function() {
	  return d3Geo.geoProjection(mtFlatPolarParabolicRaw)
	      .scale(164.859);
	};
	
	function mtFlatPolarQuarticRaw(lambda, phi) {
	  var k = (1 + sqrt1_2) * sin(phi),
	      theta = phi;
	  for (var i = 0, delta; i < 25; i++) {
	    theta -= delta = (sin(theta / 2) + sin(theta) - k) / (0.5 * cos(theta / 2) + cos(theta));
	    if (abs(delta) < epsilon) break;
	  }
	  return [
	    lambda * (1 + 2 * cos(theta) / cos(theta / 2)) / (3 * sqrt2),
	    2 * sqrt(3) * sin(theta / 2) / sqrt(2 + sqrt2)
	  ];
	}
	
	mtFlatPolarQuarticRaw.invert = function(x, y) {
	  var sinTheta_2 = y * sqrt(2 + sqrt2) / (2 * sqrt(3)),
	      theta = 2 * asin(sinTheta_2);
	  return [
	    3 * sqrt2 * x / (1 + 2 * cos(theta) / cos(theta / 2)),
	    asin((sinTheta_2 + sin(theta)) / (1 + sqrt1_2))
	  ];
	};
	
	var mtFlatPolarQuartic = function() {
	  return d3Geo.geoProjection(mtFlatPolarQuarticRaw)
	      .scale(188.209);
	};
	
	function mtFlatPolarSinusoidalRaw(lambda, phi) {
	  var A = sqrt(6 / (4 + pi)),
	      k = (1 + pi / 4) * sin(phi),
	      theta = phi / 2;
	  for (var i = 0, delta; i < 25; i++) {
	    theta -= delta = (theta / 2 + sin(theta) - k) / (0.5 + cos(theta));
	    if (abs(delta) < epsilon) break;
	  }
	  return [
	    A * (0.5 + cos(theta)) * lambda / 1.5,
	    A * theta
	  ];
	}
	
	mtFlatPolarSinusoidalRaw.invert = function(x, y) {
	  var A = sqrt(6 / (4 + pi)),
	      theta = y / A;
	  if (abs(abs(theta) - halfPi) < epsilon) theta = theta < 0 ? -halfPi : halfPi;
	  return [
	    1.5 * x / (A * (0.5 + cos(theta))),
	    asin((theta / 2 + sin(theta)) / (1 + pi / 4))
	  ];
	};
	
	var mtFlatPolarSinusoidal = function() {
	  return d3Geo.geoProjection(mtFlatPolarSinusoidalRaw)
	      .scale(166.518);
	};
	
	function naturalEarthRaw(lambda, phi) {
	  var phi2 = phi * phi, phi4 = phi2 * phi2;
	  return [
	    lambda * (0.8707 - 0.131979 * phi2 + phi4 * (-0.013791 + phi4 * (0.003971 * phi2 - 0.001529 * phi4))),
	    phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4)))
	  ];
	}
	
	naturalEarthRaw.invert = function(x, y) {
	  var phi = y, i = 25, delta;
	  do {
	    var phi2 = phi * phi, phi4 = phi2 * phi2;
	    phi -= delta = (phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4))) - y) /
	        (1.007226 + phi2 * (0.015085 * 3 + phi4 * (-0.044475 * 7 + 0.028874 * 9 * phi2 - 0.005916 * 11 * phi4)));
	  } while (abs(delta) > epsilon && --i > 0);
	  return [
	    x / (0.8707 + (phi2 = phi * phi) * (-0.131979 + phi2 * (-0.013791 + phi2 * phi2 * phi2 * (0.003971 - 0.001529 * phi2)))),
	    phi
	  ];
	};
	
	var naturalEarth = function() {
	  return d3Geo.geoProjection(naturalEarthRaw)
	      .scale(175.295);
	};
	
	function nellHammerRaw(lambda, phi) {
	  return [
	    lambda * (1 + cos(phi)) / 2,
	    2 * (phi - tan(phi / 2))
	  ];
	}
	
	nellHammerRaw.invert = function(x, y) {
	  var p = y / 2;
	  for (var i = 0, delta = Infinity; i < 10 && abs(delta) > epsilon; ++i) {
	    var c = cos(y / 2);
	    y -= delta = (y - tan(y / 2) - p) / (1 - 0.5 / (c * c));
	  }
	  return [
	    2 * x / (1 + cos(y)),
	    y
	  ];
	};
	
	var nellHammer = function() {
	  return d3Geo.geoProjection(nellHammerRaw)
	      .scale(152.63);
	};
	
	// Based on Java implementation by Bojan Savric.
	// https://github.com/OSUCartography/JMapProjLib/blob/master/src/com/jhlabs/map/proj/PattersonProjection.java
	
	var pattersonK1 = 1.0148;
	var pattersonK2 = 0.23185;
	var pattersonK3 = -0.14499;
	var pattersonK4 = 0.02406;
	var pattersonC1 = pattersonK1;
	var pattersonC2 = 5 * pattersonK2;
	var pattersonC3 = 7 * pattersonK3;
	var pattersonC4 = 9 * pattersonK4;
	var pattersonYmax = 1.790857183;
	
	function pattersonRaw(lambda, phi) {
	  var phi2 = phi * phi;
	  return [
	    lambda,
	    phi * (pattersonK1 + phi2 * phi2 * (pattersonK2 + phi2 * (pattersonK3 + pattersonK4 * phi2)))
	  ];
	}
	
	pattersonRaw.invert = function(x, y) {
	  if (y > pattersonYmax) y = pattersonYmax;
	  else if (y < -pattersonYmax) y = -pattersonYmax;
	  var yc = y, delta;
	
	  do { // Newton-Raphson
	    var y2 = yc * yc;
	    yc -= delta = ((yc * (pattersonK1 + y2 * y2 * (pattersonK2 + y2 * (pattersonK3 + pattersonK4 * y2)))) - y) / (pattersonC1 + y2 * y2 * (pattersonC2 + y2 * (pattersonC3 + pattersonC4 * y2)));
	  } while (abs(delta) > epsilon);
	
	  return [x, yc];
	};
	
	var patterson = function() {
	  return d3Geo.geoProjection(pattersonRaw)
	      .scale(139.319);
	};
	
	function polyconicRaw(lambda, phi) {
	  if (abs(phi) < epsilon) return [lambda, 0];
	  var tanPhi = tan(phi),
	      k = lambda * sin(phi);
	  return [
	    sin(k) / tanPhi,
	    phi + (1 - cos(k)) / tanPhi
	  ];
	}
	
	polyconicRaw.invert = function(x, y) {
	  if (abs(y) < epsilon) return [x, 0];
	  var k = x * x + y * y,
	      phi = y * 0.5,
	      i = 10, delta;
	  do {
	    var tanPhi = tan(phi),
	        secPhi = 1 / cos(phi),
	        j = k - 2 * y * phi + phi * phi;
	    phi -= delta = (tanPhi * j + 2 * (phi - y)) / (2 + j * secPhi * secPhi + 2 * (phi - y) * tanPhi);
	  } while (abs(delta) > epsilon && --i > 0);
	  tanPhi = tan(phi);
	  return [
	    (abs(y) < abs(phi + 1 / tanPhi) ? asin(x * tanPhi) : sign(x) * (acos(abs(x * tanPhi)) + halfPi)) / sin(phi),
	    phi
	  ];
	};
	
	var polyconic = function() {
	  return d3Geo.geoProjection(polyconicRaw)
	      .scale(103.74);
	};
	
	// Note: 6-element arrays are used to denote the 3x3 affine transform matrix:
	// [a, b, c,
	//  d, e, f,
	//  0, 0, 1] - this redundant row is left out.
	
	// Transform matrix for [a0, a1] -> [b0, b1].
	var matrix = function(a, b) {
	  var u = subtract(a[1], a[0]),
	      v = subtract(b[1], b[0]),
	      phi = angle$1(u, v),
	      s = length(u) / length(v);
	
	  return multiply([
	    1, 0, a[0][0],
	    0, 1, a[0][1]
	  ], multiply([
	    s, 0, 0,
	    0, s, 0
	  ], multiply([
	    cos(phi), sin(phi), 0,
	    -sin(phi), cos(phi), 0
	  ], [
	    1, 0, -b[0][0],
	    0, 1, -b[0][1]
	  ])));
	};
	
	// Inverts a transform matrix.
	function inverse(m) {
	  var k = 1 / (m[0] * m[4] - m[1] * m[3]);
	  return [
	    k * m[4], -k * m[1], k * (m[1] * m[5] - m[2] * m[4]),
	    -k * m[3], k * m[0], k * (m[2] * m[3] - m[0] * m[5])
	  ];
	}
	
	// Multiplies two 3x2 matrices.
	function multiply(a, b) {
	  return [
	    a[0] * b[0] + a[1] * b[3],
	    a[0] * b[1] + a[1] * b[4],
	    a[0] * b[2] + a[1] * b[5] + a[2],
	    a[3] * b[0] + a[4] * b[3],
	    a[3] * b[1] + a[4] * b[4],
	    a[3] * b[2] + a[4] * b[5] + a[5]
	  ];
	}
	
	// Subtracts 2D vectors.
	function subtract(a, b) {
	  return [a[0] - b[0], a[1] - b[1]];
	}
	
	// Magnitude of a 2D vector.
	function length(v) {
	  return sqrt(v[0] * v[0] + v[1] * v[1]);
	}
	
	// Angle between two 2D vectors.
	function angle$1(a, b) {
	  return atan2(a[0] * b[1] - a[1] * b[0], a[0] * b[0] + a[1] * b[1]);
	}
	
	// Creates a polyhedral projection.
	//  * root: a spanning tree of polygon faces.  Nodes are automatically
	//    augmented with a transform matrix.
	//  * face: a function that returns the appropriate node for a given {lambda, phi}
	//    point (radians).
	//  * r: rotation angle for final polyhedral net.  Defaults to -pi / 6 (for
	//    butterflies).
	var polyhedral = function(root, face, r) {
	
	  r = r == null ? -pi / 6 : r; // TODO automate
	
	  recurse(root, {transform: [
	    cos(r), sin(r), 0,
	    -sin(r), cos(r), 0
	  ]});
	
	  function recurse(node, parent) {
	    node.edges = faceEdges(node.face);
	    // Find shared edge.
	    if (parent.face) {
	      var shared = node.shared = sharedEdge(node.face, parent.face),
	          m = matrix(shared.map(parent.project), shared.map(node.project));
	      node.transform = parent.transform ? multiply(parent.transform, m) : m;
	      // Replace shared edge in parent edges array.
	      var edges = parent.edges;
	      for (var i = 0, n = edges.length; i < n; ++i) {
	        if (pointEqual$1(shared[0], edges[i][1]) && pointEqual$1(shared[1], edges[i][0])) edges[i] = node;
	        if (pointEqual$1(shared[0], edges[i][0]) && pointEqual$1(shared[1], edges[i][1])) edges[i] = node;
	      }
	      edges = node.edges;
	      for (i = 0, n = edges.length; i < n; ++i) {
	        if (pointEqual$1(shared[0], edges[i][0]) && pointEqual$1(shared[1], edges[i][1])) edges[i] = parent;
	        if (pointEqual$1(shared[0], edges[i][1]) && pointEqual$1(shared[1], edges[i][0])) edges[i] = parent;
	      }
	    } else {
	      node.transform = parent.transform;
	    }
	    if (node.children) {
	      node.children.forEach(function(child) {
	        recurse(child, node);
	      });
	    }
	    return node;
	  }
	
	  function forward(lambda, phi) {
	    var node = face(lambda, phi),
	        point = node.project([lambda * degrees, phi * degrees]),
	        t;
	    if (t = node.transform) {
	      return [
	        t[0] * point[0] + t[1] * point[1] + t[2],
	        -(t[3] * point[0] + t[4] * point[1] + t[5])
	      ];
	    }
	    point[1] = -point[1];
	    return point;
	  }
	
	  // Naive inverse!  A faster solution would use bounding boxes, or even a
	  // polygonal quadtree.
	  if (hasInverse(root)) forward.invert = function(x, y) {
	    var coordinates = faceInvert(root, [x, -y]);
	    return coordinates && (coordinates[0] *= radians, coordinates[1] *= radians, coordinates);
	  };
	
	  function faceInvert(node, coordinates) {
	    var invert = node.project.invert,
	        t = node.transform,
	        point = coordinates;
	    if (t) {
	      t = inverse(t);
	      point = [
	        t[0] * point[0] + t[1] * point[1] + t[2],
	        (t[3] * point[0] + t[4] * point[1] + t[5])
	      ];
	    }
	    if (invert && node === faceDegrees(p = invert(point))) return p;
	    var p,
	        children = node.children;
	    for (var i = 0, n = children && children.length; i < n; ++i) {
	      if (p = faceInvert(children[i], coordinates)) return p;
	    }
	  }
	
	  function faceDegrees(coordinates) {
	    return face(coordinates[0] * radians, coordinates[1] * radians);
	  }
	
	  var proj = d3Geo.geoProjection(forward),
	      stream_ = proj.stream;
	
	  proj.stream = function(stream) {
	    var rotate = proj.rotate(),
	        rotateStream = stream_(stream),
	        sphereStream = (proj.rotate([0, 0]), stream_(stream));
	    proj.rotate(rotate);
	    rotateStream.sphere = function() {
	      sphereStream.polygonStart();
	      sphereStream.lineStart();
	      outline(sphereStream, root);
	      sphereStream.lineEnd();
	      sphereStream.polygonEnd();
	    };
	    return rotateStream;
	  };
	
	  return proj;
	};
	
	function outline(stream, node, parent) {
	  var point,
	      edges = node.edges,
	      n = edges.length,
	      edge,
	      multiPoint = {type: "MultiPoint", coordinates: node.face},
	      notPoles = node.face.filter(function(d) { return abs(d[1]) !== 90; }),
	      b = d3Geo.geoBounds({type: "MultiPoint", coordinates: notPoles}),
	      inside = false,
	      j = -1,
	      dx = b[1][0] - b[0][0];
	  // TODO
	  var c = dx === 180 || dx === 360
	      ? [(b[0][0] + b[1][0]) / 2, (b[0][1] + b[1][1]) / 2]
	      : d3Geo.geoCentroid(multiPoint);
	  // First find the shared edge…
	  if (parent) while (++j < n) {
	    if (edges[j] === parent) break;
	  }
	  ++j;
	  for (var i = 0; i < n; ++i) {
	    edge = edges[(i + j) % n];
	    if (Array.isArray(edge)) {
	      if (!inside) {
	        stream.point((point = d3Geo.geoInterpolate(edge[0], c)(epsilon))[0], point[1]);
	        inside = true;
	      }
	      stream.point((point = d3Geo.geoInterpolate(edge[1], c)(epsilon))[0], point[1]);
	    } else {
	      inside = false;
	      if (edge !== parent) outline(stream, edge, node);
	    }
	  }
	}
	
	// Tests equality of two spherical points.
	function pointEqual$1(a, b) {
	  return a && b && a[0] === b[0] && a[1] === b[1];
	}
	
	// Finds a shared edge given two clockwise polygons.
	function sharedEdge(a, b) {
	  var x, y, n = a.length, found = null;
	  for (var i = 0; i < n; ++i) {
	    x = a[i];
	    for (var j = b.length; --j >= 0;) {
	      y = b[j];
	      if (x[0] === y[0] && x[1] === y[1]) {
	        if (found) return [found, x];
	        found = x;
	      }
	    }
	  }
	}
	
	// Converts an array of n face vertices to an array of n + 1 edges.
	function faceEdges(face) {
	  var n = face.length,
	      edges = [];
	  for (var a = face[n - 1], i = 0; i < n; ++i) edges.push([a, a = face[i]]);
	  return edges;
	}
	
	function hasInverse(node) {
	  return node.project.invert || node.children && node.children.some(hasInverse);
	}
	
	// TODO generate on-the-fly to avoid external modification.
	var octahedron = [
	  [0, 90],
	  [-90, 0], [0, 0], [90, 0], [180, 0],
	  [0, -90]
	];
	
	var octahedron$1 = [
	  [0, 2, 1],
	  [0, 3, 2],
	  [5, 1, 2],
	  [5, 2, 3],
	  [0, 1, 4],
	  [0, 4, 3],
	  [5, 4, 1],
	  [5, 3, 4]
	].map(function(face) {
	  return face.map(function(i) {
	    return octahedron[i];
	  });
	});
	
	var butterfly = function(faceProjection) {
	
	  faceProjection = faceProjection || function(face) {
	    var c = d3Geo.geoCentroid({type: "MultiPoint", coordinates: face});
	    return d3Geo.geoGnomonic().scale(1).translate([0, 0]).rotate([-c[0], -c[1]]);
	  };
	
	  var faces = octahedron$1.map(function(face) {
	    return {face: face, project: faceProjection(face)};
	  });
	
	  [-1, 0, 0, 1, 0, 1, 4, 5].forEach(function(d, i) {
	    var node = faces[d];
	    node && (node.children || (node.children = [])).push(faces[i]);
	  });
	
	  return polyhedral(faces[0], function(lambda, phi) {
	        return faces[lambda < -pi / 2 ? phi < 0 ? 6 : 4
	            : lambda < 0 ? phi < 0 ? 2 : 0
	            : lambda < pi / 2 ? phi < 0 ? 3 : 1
	            : phi < 0 ? 7 : 5];
	      })
	      .scale(101.858)
	      .center([0, 45]);
	};
	
	var kx = 2 / sqrt(3);
	
	function collignonK(a, b) {
	  var p = collignonRaw(a, b);
	  return [p[0] * kx, p[1]];
	}
	
	collignonK.invert = function(x,y) {
	  return collignonRaw.invert(x / kx, y);
	};
	
	var collignon$1 = function(faceProjection) {
	
	  faceProjection = faceProjection || function(face) {
	    var c = d3Geo.geoCentroid({type: "MultiPoint", coordinates: face});
	    return d3Geo.geoProjection(collignonK).translate([0, 0]).scale(1).rotate(c[1] > 0 ? [-c[0], 0] : [180 - c[0], 180]);
	  };
	
	  var faces = octahedron$1.map(function(face) {
	    return {face: face, project: faceProjection(face)};
	  });
	
	  [-1, 0, 0, 1, 0, 1, 4, 5].forEach(function(d, i) {
	    var node = faces[d];
	    node && (node.children || (node.children = [])).push(faces[i]);
	  });
	
	  return polyhedral(faces[0], function(lambda, phi) {
	        return faces[lambda < -pi / 2 ? phi < 0 ? 6 : 4
	            : lambda < 0 ? phi < 0 ? 2 : 0
	            : lambda < pi / 2 ? phi < 0 ? 3 : 1
	            : phi < 0 ? 7 : 5];
	      })
	      .scale(121.906)
	      .center([0, 48.5904]);
	};
	
	var waterman = function(faceProjection) {
	
	  faceProjection = faceProjection || function(face) {
	    var c = face.length === 6 ? d3Geo.geoCentroid({type: "MultiPoint", coordinates: face}) : face[0];
	    return d3Geo.geoGnomonic().scale(1).translate([0, 0]).rotate([-c[0], -c[1]]);
	  };
	
	  var w5 = octahedron$1.map(function(face) {
	    var xyz = face.map(cartesian),
	        n = xyz.length,
	        a = xyz[n - 1],
	        b,
	        hexagon = [];
	    for (var i = 0; i < n; ++i) {
	      b = xyz[i];
	      hexagon.push(spherical([
	        a[0] * 0.9486832980505138 + b[0] * 0.31622776601683794,
	        a[1] * 0.9486832980505138 + b[1] * 0.31622776601683794,
	        a[2] * 0.9486832980505138 + b[2] * 0.31622776601683794
	      ]), spherical([
	        b[0] * 0.9486832980505138 + a[0] * 0.31622776601683794,
	        b[1] * 0.9486832980505138 + a[1] * 0.31622776601683794,
	        b[2] * 0.9486832980505138 + a[2] * 0.31622776601683794
	      ]));
	      a = b;
	    }
	    return hexagon;
	  });
	
	  var cornerNormals = [];
	
	  var parents = [-1, 0, 0, 1, 0, 1, 4, 5];
	
	  w5.forEach(function(hexagon, j) {
	    var face = octahedron$1[j],
	        n = face.length,
	        normals = cornerNormals[j] = [];
	    for (var i = 0; i < n; ++i) {
	      w5.push([
	        face[i],
	        hexagon[(i * 2 + 2) % (2 * n)],
	        hexagon[(i * 2 + 1) % (2 * n)]
	      ]);
	      parents.push(j);
	      normals.push(cross(
	        cartesian(hexagon[(i * 2 + 2) % (2 * n)]),
	        cartesian(hexagon[(i * 2 + 1) % (2 * n)])
	      ));
	    }
	  });
	
	  var faces = w5.map(function(face) {
	    return {
	      project: faceProjection(face),
	      face: face
	    };
	  });
	
	  parents.forEach(function(d, i) {
	    var parent = faces[d];
	    parent && (parent.children || (parent.children = [])).push(faces[i]);
	  });
	
	  function face(lambda, phi) {
	    var cosphi = cos(phi),
	        p = [cosphi * cos(lambda), cosphi * sin(lambda), sin(phi)];
	
	    var hexagon = lambda < -pi / 2 ? phi < 0 ? 6 : 4
	        : lambda < 0 ? phi < 0 ? 2 : 0
	        : lambda < pi / 2 ? phi < 0 ? 3 : 1
	        : phi < 0 ? 7 : 5;
	
	    var n = cornerNormals[hexagon];
	
	    return faces[dot(n[0], p) < 0 ? 8 + 3 * hexagon
	        : dot(n[1], p) < 0 ? 8 + 3 * hexagon + 1
	        : dot(n[2], p) < 0 ? 8 + 3 * hexagon + 2
	        : hexagon];
	  }
	
	  return polyhedral(faces[0], face)
	      .scale(110.625)
	      .center([0,45]);
	};
	
	function dot(a, b) {
	  for (var i = 0, n = a.length, s = 0; i < n; ++i) s += a[i] * b[i];
	  return s;
	}
	
	function cross(a, b) {
	  return [
	    a[1] * b[2] - a[2] * b[1],
	    a[2] * b[0] - a[0] * b[2],
	    a[0] * b[1] - a[1] * b[0]
	  ];
	}
	
	// Converts 3D Cartesian to spherical coordinates (degrees).
	function spherical(cartesian) {
	  return [
	    atan2(cartesian[1], cartesian[0]) * degrees,
	    asin(max(-1, min(1, cartesian[2]))) * degrees
	  ];
	}
	
	// Converts spherical coordinates (degrees) to 3D Cartesian.
	function cartesian(coordinates) {
	  var lambda = coordinates[0] * radians,
	      phi = coordinates[1] * radians,
	      cosphi = cos(phi);
	  return [
	    cosphi * cos(lambda),
	    cosphi * sin(lambda),
	    sin(phi)
	  ];
	}
	
	var noop = function() {};
	
	var clockwise = function(ring) {
	  if ((n = ring.length) < 4) return false;
	  var i = 0,
	      n,
	      area = ring[n - 1][1] * ring[0][0] - ring[n - 1][0] * ring[0][1];
	  while (++i < n) area += ring[i - 1][1] * ring[i][0] - ring[i - 1][0] * ring[i][1];
	  return area <= 0;
	};
	
	var contains = function(ring, point) {
	  var x = point[0],
	      y = point[1],
	      contains = false;
	  for (var i = 0, n = ring.length, j = n - 1; i < n; j = i++) {
	    var pi = ring[i], xi = pi[0], yi = pi[1],
	        pj = ring[j], xj = pj[0], yj = pj[1];
	    if (((yi > y) ^ (yj > y)) && (x < (xj - xi) * (y - yi) / (yj - yi) + xi)) contains = !contains;
	  }
	  return contains;
	};
	
	var index = function(object, projection) {
	  var stream = projection.stream, project;
	  if (!stream) throw new Error("invalid projection");
	  switch (object && object.type) {
	    case "Feature": project = projectFeature; break;
	    case "FeatureCollection": project = projectFeatureCollection; break;
	    default: project = projectGeometry; break;
	  }
	  return project(object, stream);
	};
	
	function projectFeatureCollection(o, stream) {
	  return {
	    type: "FeatureCollection",
	    features: o.features.map(function(f) {
	      return projectFeature(f, stream);
	    })
	  };
	}
	
	function projectFeature(o, stream) {
	  return {
	    type: "Feature",
	    id: o.id,
	    properties: o.properties,
	    geometry: projectGeometry(o.geometry, stream)
	  };
	}
	
	function projectGeometryCollection(o, stream) {
	  return {
	    type: "GeometryCollection",
	    geometries: o.geometries.map(function(o) {
	      return projectGeometry(o, stream);
	    })
	  };
	}
	
	function projectGeometry(o, stream) {
	  if (!o) return null;
	  if (o.type === "GeometryCollection") return projectGeometryCollection(o, stream);
	  var sink;
	  switch (o.type) {
	    case "Point": sink = sinkPoint; break;
	    case "MultiPoint": sink = sinkPoint; break;
	    case "LineString": sink = sinkLine; break;
	    case "MultiLineString": sink = sinkLine; break;
	    case "Polygon": sink = sinkPolygon; break;
	    case "MultiPolygon": sink = sinkPolygon; break;
	    case "Sphere": sink = sinkPolygon; break;
	    default: return null;
	  }
	  d3Geo.geoStream(o, stream(sink));
	  return sink.result();
	}
	
	var points = [];
	var lines = [];
	
	var sinkPoint = {
	  point: function(x, y) {
	    points.push([x, y]);
	  },
	  result: function() {
	    var result = !points.length ? null
	        : points.length < 2 ? {type: "Point", coordinates: points[0]}
	        : {type: "MultiPoint", coordinates: points};
	    points = [];
	    return result;
	  }
	};
	
	var sinkLine = {
	  lineStart: noop,
	  point: function(x, y) {
	    points.push([x, y]);
	  },
	  lineEnd: function() {
	    if (points.length) lines.push(points), points = [];
	  },
	  result: function() {
	    var result = !lines.length ? null
	        : lines.length < 2 ? {type: "LineString", coordinates: lines[0]}
	        : {type: "MultiLineString", coordinates: lines};
	    lines = [];
	    return result;
	  }
	};
	
	var sinkPolygon = {
	  polygonStart: noop,
	  lineStart: noop,
	  point: function(x, y) {
	    points.push([x, y]);
	  },
	  lineEnd: function() {
	    var n = points.length;
	    if (n) {
	      do points.push(points[0].slice()); while (++n < 4);
	      lines.push(points), points = [];
	    }
	  },
	  polygonEnd: noop,
	  result: function() {
	    if (!lines.length) return null;
	    var polygons = [],
	        holes = [];
	
	    // https://github.com/d3/d3/issues/1558
	    lines.forEach(function(ring) {
	      if (clockwise(ring)) polygons.push([ring]);
	      else holes.push(ring);
	    });
	
	    holes.forEach(function(hole) {
	      var point = hole[0];
	      polygons.some(function(polygon) {
	        if (contains(polygon[0], point)) {
	          polygon.push(hole);
	          return true;
	        }
	      }) || polygons.push([hole]);
	    });
	
	    lines = [];
	
	    return !polygons.length ? null
	        : polygons.length > 1 ? {type: "MultiPolygon", coordinates: polygons}
	        : {type: "Polygon", coordinates: polygons[0]};
	  }
	};
	
	var quincuncial = function(project) {
	  var dx = project(halfPi, 0)[0] - project(-halfPi, 0)[0];
	
	  function projectQuincuncial(lambda, phi) {
	    var t = abs(lambda) < halfPi,
	        p = project(t ? lambda : lambda > 0 ? lambda - pi : lambda + pi, phi),
	        x = (p[0] - p[1]) * sqrt1_2,
	        y = (p[0] + p[1]) * sqrt1_2;
	    if (t) return [x, y];
	    var d = dx * sqrt1_2,
	        s = x > 0 ^ y > 0 ? -1 : 1;
	    return [s * x - sign(y) * d, s * y - sign(x) * d];
	  }
	
	  if (project.invert) projectQuincuncial.invert = function(x0, y0) {
	    var x = (x0 + y0) * sqrt1_2,
	        y = (y0 - x0) * sqrt1_2,
	        t = abs(x) < 0.5 * dx && abs(y) < 0.5 * dx;
	
	    if (!t) {
	      var d = dx * sqrt1_2,
	          s = x > 0 ^ y > 0 ? -1 : 1,
	          x1 = -s * (x0 + (y > 0 ? 1 : -1) * d),
	          y1 = -s * (y0 + (x > 0 ? 1 : -1) * d);
	      x = (-x1 - y1) * sqrt1_2;
	      y = (x1 - y1) * sqrt1_2;
	    }
	
	    var p = project.invert(x, y);
	    if (!t) p[0] += x > 0 ? pi : -pi;
	    return p;
	  };
	
	  return d3Geo.geoProjection(projectQuincuncial)
	      .rotate([-90, -90, 45])
	      .clipAngle(180 - 1e-3);
	};
	
	var gringorten$1 = function() {
	  return quincuncial(gringortenRaw)
	      .scale(176.423);
	};
	
	var peirce = function() {
	  return quincuncial(guyouRaw)
	      .scale(111.48);
	};
	
	var quantize = function(o, digits) {
	  if (!(0 <= (digits = +digits) && digits <= 20)) throw new Error("invalid digits");
	
	  function quantizePoint(coordinates) {
	    coordinates[0] = +coordinates[0].toFixed(digits);
	    coordinates[1] = +coordinates[1].toFixed(digits);
	  }
	
	  function quantizePoints(coordinates) {
	    coordinates.forEach(quantizePoint);
	  }
	
	  function quantizePolygon(coordinates) {
	    coordinates.forEach(quantizePoints);
	  }
	
	  function quantizeGeometry(o) {
	    if (o) switch (o.type) {
	      case "GeometryCollection": o.geometries.forEach(quantizeGeometry); break;
	      case "Point": quantizePoint(o.coordinates); break;
	      case "MultiPoint": case "LineString": quantizePoints(o.coordinates); break;
	      case "MultiLineString": case "Polygon": quantizePolygon(o.coordinates); break;
	      case "MultiPolygon": o.coordinates.forEach(quantizePolygon); break;
	      default: return;
	    }
	  }
	
	  function quantizeFeature(o) {
	    quantizeGeometry(o.geometry);
	  }
	
	  if (o) switch (o.type) {
	    case "Feature": quantizeFeature(o); break;
	    case "FeatureCollection": o.features.forEach(quantizeFeature); break;
	    default: quantizeGeometry(o); break;
	  }
	
	  return o;
	};
	
	function rectangularPolyconicRaw(phi0) {
	  var sinPhi0 = sin(phi0);
	
	  function forward(lambda, phi) {
	    var A = sinPhi0 ? tan(lambda * sinPhi0 / 2) / sinPhi0 : lambda / 2;
	    if (!phi) return [2 * A, -phi0];
	    var E = 2 * atan(A * sin(phi)),
	        cotPhi = 1 / tan(phi);
	    return [
	      sin(E) * cotPhi,
	      phi + (1 - cos(E)) * cotPhi - phi0
	    ];
	  }
	
	  // TODO return null for points outside outline.
	  forward.invert = function(x, y) {
	    if (abs(y += phi0) < epsilon) return [sinPhi0 ? 2 * atan(sinPhi0 * x / 2) / sinPhi0 : x, 0];
	    var k = x * x + y * y,
	        phi = 0,
	        i = 10, delta;
	    do {
	      var tanPhi = tan(phi),
	          secPhi = 1 / cos(phi),
	          j = k - 2 * y * phi + phi * phi;
	      phi -= delta = (tanPhi * j + 2 * (phi - y)) / (2 + j * secPhi * secPhi + 2 * (phi - y) * tanPhi);
	    } while (abs(delta) > epsilon && --i > 0);
	    var E = x * (tanPhi = tan(phi)),
	        A = tan(abs(y) < abs(phi + 1 / tanPhi) ? asin(E) * 0.5 : acos(E) * 0.5 + pi / 4) / sin(phi);
	    return [
	      sinPhi0 ? 2 * atan(sinPhi0 * A) / sinPhi0 : 2 * A,
	      phi
	    ];
	  };
	
	  return forward;
	}
	
	var rectangularPolyconic = function() {
	  return parallel1(rectangularPolyconicRaw)
	      .scale(131.215);
	};
	
	var K = [
	  [0.9986, -0.062],
	  [1.0000, 0.0000],
	  [0.9986, 0.0620],
	  [0.9954, 0.1240],
	  [0.9900, 0.1860],
	  [0.9822, 0.2480],
	  [0.9730, 0.3100],
	  [0.9600, 0.3720],
	  [0.9427, 0.4340],
	  [0.9216, 0.4958],
	  [0.8962, 0.5571],
	  [0.8679, 0.6176],
	  [0.8350, 0.6769],
	  [0.7986, 0.7346],
	  [0.7597, 0.7903],
	  [0.7186, 0.8435],
	  [0.6732, 0.8936],
	  [0.6213, 0.9394],
	  [0.5722, 0.9761],
	  [0.5322, 1.0000]
	];
	
	K.forEach(function(d) {
	  d[1] *= 1.0144;
	});
	
	function robinsonRaw(lambda, phi) {
	  var i = min(18, abs(phi) * 36 / pi),
	      i0 = floor(i),
	      di = i - i0,
	      ax = (k = K[i0])[0],
	      ay = k[1],
	      bx = (k = K[++i0])[0],
	      by = k[1],
	      cx = (k = K[min(19, ++i0)])[0],
	      cy = k[1],
	      k;
	  return [
	    lambda * (bx + di * (cx - ax) / 2 + di * di * (cx - 2 * bx + ax) / 2),
	    (phi > 0 ? halfPi : -halfPi) * (by + di * (cy - ay) / 2 + di * di * (cy - 2 * by + ay) / 2)
	  ];
	}
	
	robinsonRaw.invert = function(x, y) {
	  var yy = y / halfPi,
	      phi = yy * 90,
	      i = min(18, abs(phi / 5)),
	      i0 = max(0, floor(i));
	  do {
	    var ay = K[i0][1],
	        by = K[i0 + 1][1],
	        cy = K[min(19, i0 + 2)][1],
	        u = cy - ay,
	        v = cy - 2 * by + ay,
	        t = 2 * (abs(yy) - by) / u,
	        c = v / u,
	        di = t * (1 - c * t * (1 - 2 * c * t));
	    if (di >= 0 || i0 === 1) {
	      phi = (y >= 0 ? 5 : -5) * (di + i);
	      var j = 50, delta;
	      do {
	        i = min(18, abs(phi) / 5);
	        i0 = floor(i);
	        di = i - i0;
	        ay = K[i0][1];
	        by = K[i0 + 1][1];
	        cy = K[min(19, i0 + 2)][1];
	        phi -= (delta = (y >= 0 ? halfPi : -halfPi) * (by + di * (cy - ay) / 2 + di * di * (cy - 2 * by + ay) / 2) - y) * degrees;
	      } while (abs(delta) > epsilon2 && --j > 0);
	      break;
	    }
	  } while (--i0 >= 0);
	  var ax = K[i0][0],
	      bx = K[i0 + 1][0],
	      cx = K[min(19, i0 + 2)][0];
	  return [
	    x / (bx + di * (cx - ax) / 2 + di * di * (cx - 2 * bx + ax) / 2),
	    phi * radians
	  ];
	};
	
	var robinson = function() {
	  return d3Geo.geoProjection(robinsonRaw)
	      .scale(152.63);
	};
	
	function satelliteVerticalRaw(P) {
	  function forward(lambda, phi) {
	    var cosPhi = cos(phi),
	        k = (P - 1) / (P - cosPhi * cos(lambda));
	    return [
	      k * cosPhi * sin(lambda),
	      k * sin(phi)
	    ];
	  }
	
	  forward.invert = function(x, y) {
	    var rho2 = x * x + y * y,
	        rho = sqrt(rho2),
	        sinc = (P - sqrt(1 - rho2 * (P + 1) / (P - 1))) / ((P - 1) / rho + rho / (P - 1));
	    return [
	      atan2(x * sinc, rho * sqrt(1 - sinc * sinc)),
	      rho ? asin(y * sinc / rho) : 0
	    ];
	  };
	
	  return forward;
	}
	
	function satelliteRaw(P, omega) {
	  var vertical = satelliteVerticalRaw(P);
	  if (!omega) return vertical;
	  var cosOmega = cos(omega),
	      sinOmega = sin(omega);
	
	  function forward(lambda, phi) {
	    var coordinates = vertical(lambda, phi),
	        y = coordinates[1],
	        A = y * sinOmega / (P - 1) + cosOmega;
	    return [
	      coordinates[0] * cosOmega / A,
	      y / A
	    ];
	  }
	
	  forward.invert = function(x, y) {
	    var k = (P - 1) / (P - 1 - y * sinOmega);
	    return vertical.invert(k * x, k * y * cosOmega);
	  };
	
	  return forward;
	}
	
	var satellite = function() {
	  var distance = 2,
	      omega = 0,
	      m = d3Geo.geoProjectionMutator(satelliteRaw),
	      p = m(distance, omega);
	
	  // As a multiple of radius.
	  p.distance = function(_) {
	    if (!arguments.length) return distance;
	    return m(distance = +_, omega);
	  };
	
	  p.tilt = function(_) {
	    if (!arguments.length) return omega * degrees;
	    return m(distance, omega = _ * radians);
	  };
	
	  return p
	      .scale(432.147)
	      .clipAngle(acos(1 / distance) * degrees - 1e-6);
	};
	
	var epsilon$1 = 1e-4;
	var epsilonInverse = 1e4;
	var x0 = -180;
	var x0e = x0 + epsilon$1;
	var x1 = 180;
	var x1e = x1 - epsilon$1;
	var y0 = -90;
	var y0e = y0 + epsilon$1;
	var y1 = 90;
	var y1e = y1 - epsilon$1;
	
	function quantize$1(x) {
	  return Math.floor(x * epsilonInverse) / epsilonInverse;
	}
	
	function normalizePoint(y) {
	  return y === y0 || y === y1
	      ? [0, y] // pole
	      : [x0, quantize$1(y)]; // antimeridian
	}
	
	function clampPoint(p) {
	  if (p[0] <= x0e) p[0] = x0;
	  else if (p[0] >= x1e) p[0] = x1;
	  if (p[1] <= y0e) p[1] = y0;
	  else if (p[1] >= y1e) p[1] = y1;
	}
	
	function clampPoints(points) {
	  points.forEach(clampPoint);
	}
	
	// For each ring, detect where it crosses the antimeridian or pole.
	function extractFragments(polygon, fragments) {
	  for (var j = 0, m = polygon.length; j < m; ++j) {
	    var ring = polygon[j];
	    ring.polygon = polygon;
	
	    // By default, assume that this ring doesn’t need any stitching.
	    fragments.push(ring);
	
	    for (var i = 0, n = ring.length; i < n; ++i) {
	      var point = ring[i],
	          x = point[0],
	          y = point[1];
	
	      // If this is an antimeridian or polar point…
	      if (x <= x0e || x >= x1e || y <= y0e || y >= y1e) {
	        clampPoint(point);
	
	        // Advance through any antimeridian or polar points…
	        for (var k = i + 1; k < n; ++k) {
	          var pointk = ring[k],
	              xk = pointk[0],
	              yk = pointk[1];
	          if (xk > x0e && xk < x1e && yk > y0e && yk < y1e) break;
	        }
	
	        // If this was just a single antimeridian or polar point,
	        // we don’t need to cut this ring into a fragment;
	        // we can just leave it as-is.
	        if (k === i + 1) continue;
	
	        // Otherwise, if this is not the first point in the ring,
	        // cut the current fragment so that it ends at the current point.
	        // The current point is also normalized for later joining.
	        if (i) {
	          var fragmentBefore = ring.slice(0, i + 1);
	          fragmentBefore.polygon = polygon;
	          fragmentBefore[fragmentBefore.length - 1] = normalizePoint(y);
	          fragments[fragments.length - 1] = fragmentBefore;
	        }
	
	        // If the ring started with an antimeridian fragment,
	        // we can ignore that fragment entirely.
	        else fragments.pop();
	
	        // If the remainder of the ring is an antimeridian fragment,
	        // move on to the next ring.
	        if (k >= n) break;
	
	        // Otherwise, add the remaining ring fragment and continue.
	        fragments.push(ring = ring.slice(k - 1));
	        ring[0] = normalizePoint(ring[0][1]);
	        ring.polygon = polygon;
	        i = -1;
	        n = ring.length;
	      }
	    }
	  }
	  polygon.length = 0;
	}
	
	// Now stitch the fragments back together into rings.
	// TODO remove empty polygons.
	function stitchFragments(fragments) {
	  var i, n = fragments.length;
	
	  // To connect the fragments start-to-end, create a simple index by end.
	  var fragmentByStart = {},
	      fragmentByEnd = {},
	      fragment,
	      start,
	      startFragment,
	      end,
	      endFragment;
	
	  // For each fragment…
	  for (i = 0; i < n; ++i) {
	    fragment = fragments[i];
	    start = fragment[0];
	    end = fragment[fragment.length - 1];
	
	    // If this fragment is closed, add it as a standalone ring.
	    if (start[0] === end[0] && start[1] === end[1]) {
	      fragment.polygon.push(fragment);
	      fragments[i] = null;
	      continue;
	    }
	
	    fragment.index = i;
	    fragmentByStart[start] = fragmentByEnd[end] = fragment;
	  }
	
	  // For each open fragment…
	  for (i = 0; i < n; ++i) {
	    fragment = fragments[i];
	    if (fragment) {
	      start = fragment[0];
	      end = fragment[fragment.length - 1];
	      startFragment = fragmentByEnd[start];
	      endFragment = fragmentByStart[end];
	
	      delete fragmentByStart[start];
	      delete fragmentByEnd[end];
	
	      // If this fragment is closed, add it as a standalone ring.
	      if (start[0] === end[0] && start[1] === end[1]) {
	        fragment.polygon.push(fragment);
	        continue;
	      }
	
	      if (startFragment) {
	        delete fragmentByEnd[start];
	        delete fragmentByStart[startFragment[0]];
	        startFragment.pop(); // drop the shared coordinate
	        fragments[startFragment.index] = null;
	        fragment = startFragment.concat(fragment);
	        fragment.polygon = startFragment.polygon;
	
	        if (startFragment === endFragment) {
	          // Connect both ends to this single fragment to create a ring.
	          fragment.polygon.push(fragment);
	        } else {
	          fragment.index = n++;
	          fragments.push(fragmentByStart[fragment[0]] = fragmentByEnd[fragment[fragment.length - 1]] = fragment);
	        }
	      } else if (endFragment) {
	        delete fragmentByStart[end];
	        delete fragmentByEnd[endFragment[endFragment.length - 1]];
	        fragment.pop(); // drop the shared coordinate
	        fragment = fragment.concat(endFragment);
	        fragment.polygon = endFragment.polygon;
	        fragment.index = n++;
	        fragments[endFragment.index] = null;
	        fragments.push(fragmentByStart[fragment[0]] = fragmentByEnd[fragment[fragment.length - 1]] = fragment);
	      } else {
	        fragment.push(fragment[0]); // close ring
	        fragment.polygon.push(fragment);
	      }
	    }
	  }
	}
	
	function stitchFeature(o) {
	  stitchGeometry(o.geometry);
	}
	
	function stitchGeometry(o) {
	  if (!o) return;
	  var fragments, i, n;
	
	  switch (o.type) {
	    case "GeometryCollection": {
	      o.geometries.forEach(stitchGeometry);
	      return;
	    }
	    case "Point": {
	      clampPoint(o.coordinates);
	      break;
	    }
	    case "MultiPoint":
	    case "LineString": {
	      clampPoints(o.coordinates);
	      break;
	    }
	    case "MultiLineString": {
	      o.coordinates.forEach(clampPoints);
	      break;
	    }
	    case "Polygon": {
	      extractFragments(o.coordinates, fragments = []);
	      break;
	    }
	    case "MultiPolygon": {
	      fragments = [], i = -1, n = o.coordinates.length;
	      while (++i < n) extractFragments(o.coordinates[i], fragments);
	      break;
	    }
	    default: return;
	  }
	
	  stitchFragments(fragments);
	}
	
	var stitch = function(o) {
	  if (o) switch (o.type) {
	    case "Feature": stitchFeature(o); break;
	    case "FeatureCollection": o.features.forEach(stitchFeature); break;
	    default: stitchGeometry(o); break;
	  }
	  return o;
	};
	
	function timesRaw(lambda, phi) {
	  var t = tan(phi / 2),
	      s = sin(quarterPi * t);
	  return [
	    lambda * (0.74482 - 0.34588 * s * s),
	    1.70711 * t
	  ];
	}
	
	timesRaw.invert = function(x, y) {
	  var t = y / 1.70711,
	      s = sin(quarterPi * t);
	  return [
	    x / (0.74482 - 0.34588 * s * s),
	    2 * atan(t)
	  ];
	};
	
	var times = function() {
	  return d3Geo.geoProjection(timesRaw)
	      .scale(146.153);
	};
	
	// Compute the origin as the midpoint of the two reference points.
	// Rotate one of the reference points by the origin.
	// Apply the spherical law of sines to compute gamma rotation.
	var twoPoint = function(raw, p0, p1) {
	  var i = d3Geo.geoInterpolate(p0, p1),
	      o = i(0.5),
	      a = d3Geo.geoRotation([-o[0], -o[1]])(p0),
	      b = i.distance / 2,
	      y = -asin(sin(a[1] * radians) / sin(b)),
	      R = [-o[0], -o[1], -(a[0] > 0 ? pi - y : y) * degrees],
	      p = d3Geo.geoProjection(raw(b)).rotate(R),
	      r = d3Geo.geoRotation(R),
	      center = p.center;
	
	  delete p.rotate;
	
	  p.center = function(_) {
	    return arguments.length ? center(r(_)) : r.invert(center());
	  };
	
	  return p
	      .clipAngle(90);
	};
	
	function twoPointAzimuthalRaw(d) {
	  var cosd = cos(d);
	
	  function forward(lambda, phi) {
	    var coordinates = d3Geo.geoGnomonicRaw(lambda, phi);
	    coordinates[0] *= cosd;
	    return coordinates;
	  }
	
	  forward.invert = function(x, y) {
	    return d3Geo.geoGnomonicRaw.invert(x / cosd, y);
	  };
	
	  return forward;
	}
	
	function twoPointAzimuthalUsa() {
	  return twoPointAzimuthal([-158, 21.5], [-77, 39])
	      .clipAngle(60)
	      .scale(400);
	}
	
	function twoPointAzimuthal(p0, p1) {
	  return twoPoint(twoPointAzimuthalRaw, p0, p1);
	}
	
	// TODO clip to ellipse
	function twoPointEquidistantRaw(z0) {
	  if (!(z0 *= 2)) return d3Geo.geoAzimuthalEquidistantRaw;
	  var lambdaa = -z0 / 2,
	      lambdab = -lambdaa,
	      z02 = z0 * z0,
	      tanLambda0 = tan(lambdab),
	      S = 0.5 / sin(lambdab);
	
	  function forward(lambda, phi) {
	    var za = acos(cos(phi) * cos(lambda - lambdaa)),
	        zb = acos(cos(phi) * cos(lambda - lambdab)),
	        ys = phi < 0 ? -1 : 1;
	    za *= za, zb *= zb;
	    return [
	      (za - zb) / (2 * z0),
	      ys * sqrt(4 * z02 * zb - (z02 - za + zb) * (z02 - za + zb)) / (2 * z0)
	    ];
	  }
	
	  forward.invert = function(x, y) {
	    var y2 = y * y,
	        cosza = cos(sqrt(y2 + (t = x + lambdaa) * t)),
	        coszb = cos(sqrt(y2 + (t = x + lambdab) * t)),
	        t,
	        d;
	    return [
	      atan2(d = cosza - coszb, t = (cosza + coszb) * tanLambda0),
	      (y < 0 ? -1 : 1) * acos(sqrt(t * t + d * d) * S)
	    ];
	  };
	
	  return forward;
	}
	
	function twoPointEquidistantUsa() {
	  return twoPointEquidistant([-158, 21.5], [-77, 39])
	      .clipAngle(130)
	      .scale(122.571);
	}
	
	function twoPointEquidistant(p0, p1) {
	  return twoPoint(twoPointEquidistantRaw, p0, p1);
	}
	
	function vanDerGrintenRaw(lambda, phi) {
	  if (abs(phi) < epsilon) return [lambda, 0];
	  var sinTheta = abs(phi / halfPi),
	      theta = asin(sinTheta);
	  if (abs(lambda) < epsilon || abs(abs(phi) - halfPi) < epsilon) return [0, sign(phi) * pi * tan(theta / 2)];
	  var cosTheta = cos(theta),
	      A = abs(pi / lambda - lambda / pi) / 2,
	      A2 = A * A,
	      G = cosTheta / (sinTheta + cosTheta - 1),
	      P = G * (2 / sinTheta - 1),
	      P2 = P * P,
	      P2_A2 = P2 + A2,
	      G_P2 = G - P2,
	      Q = A2 + G;
	  return [
	    sign(lambda) * pi * (A * G_P2 + sqrt(A2 * G_P2 * G_P2 - P2_A2 * (G * G - P2))) / P2_A2,
	    sign(phi) * pi * (P * Q - A * sqrt((A2 + 1) * P2_A2 - Q * Q)) / P2_A2
	  ];
	}
	
	vanDerGrintenRaw.invert = function(x, y) {
	  if (abs(y) < epsilon) return [x, 0];
	  if (abs(x) < epsilon) return [0, halfPi * sin(2 * atan(y / pi))];
	  var x2 = (x /= pi) * x,
	      y2 = (y /= pi) * y,
	      x2_y2 = x2 + y2,
	      z = x2_y2 * x2_y2,
	      c1 = -abs(y) * (1 + x2_y2),
	      c2 = c1 - 2 * y2 + x2,
	      c3 = -2 * c1 + 1 + 2 * y2 + z,
	      d = y2 / c3 + (2 * c2 * c2 * c2 / (c3 * c3 * c3) - 9 * c1 * c2 / (c3 * c3)) / 27,
	      a1 = (c1 - c2 * c2 / (3 * c3)) / c3,
	      m1 = 2 * sqrt(-a1 / 3),
	      theta1 = acos(3 * d / (a1 * m1)) / 3;
	  return [
	    pi * (x2_y2 - 1 + sqrt(1 + 2 * (x2 - y2) + z)) / (2 * x),
	    sign(y) * pi * (-m1 * cos(theta1 + pi / 3) - c2 / (3 * c3))
	  ];
	};
	
	var vanDerGrinten = function() {
	  return d3Geo.geoProjection(vanDerGrintenRaw)
	      .scale(79.4183);
	};
	
	function vanDerGrinten2Raw(lambda, phi) {
	  if (abs(phi) < epsilon) return [lambda, 0];
	  var sinTheta = abs(phi / halfPi),
	      theta = asin(sinTheta);
	  if (abs(lambda) < epsilon || abs(abs(phi) - halfPi) < epsilon) return [0, sign(phi) * pi * tan(theta / 2)];
	  var cosTheta = cos(theta),
	      A = abs(pi / lambda - lambda / pi) / 2,
	      A2 = A * A,
	      x1 = cosTheta * (sqrt(1 + A2) - A * cosTheta) / (1 + A2 * sinTheta * sinTheta);
	  return [
	    sign(lambda) * pi * x1,
	    sign(phi) * pi * sqrt(1 - x1 * (2 * A + x1))
	  ];
	}
	
	vanDerGrinten2Raw.invert = function(x, y) {
	  if (!x) return [0, halfPi * sin(2 * atan(y / pi))];
	  var x1 = abs(x / pi),
	      A = (1 - x1 * x1 - (y /= pi) * y) / (2 * x1),
	      A2 = A * A,
	      B = sqrt(A2 + 1);
	  return [
	    sign(x) * pi * (B - A),
	    sign(y) * halfPi * sin(2 * atan2(sqrt((1 - 2 * A * x1) * (A + B) - x1), sqrt(B + A + x1)))
	  ];
	};
	
	var vanDerGrinten2 = function() {
	  return d3Geo.geoProjection(vanDerGrinten2Raw)
	      .scale(79.4183);
	};
	
	function vanDerGrinten3Raw(lambda, phi) {
	  if (abs(phi) < epsilon) return [lambda, 0];
	  var sinTheta = phi / halfPi,
	      theta = asin(sinTheta);
	  if (abs(lambda) < epsilon || abs(abs(phi) - halfPi) < epsilon) return [0, pi * tan(theta / 2)];
	  var A = (pi / lambda - lambda / pi) / 2,
	      y1 = sinTheta / (1 + cos(theta));
	  return [
	    pi * (sign(lambda) * sqrt(A * A + 1 - y1 * y1) - A),
	    pi * y1
	  ];
	}
	
	vanDerGrinten3Raw.invert = function(x, y) {
	  if (!y) return [x, 0];
	  var y1 = y / pi,
	      A = (pi * pi * (1 - y1 * y1) - x * x) / (2 * pi * x);
	  return [
	    x ? pi * (sign(x) * sqrt(A * A + 1) - A) : 0,
	    halfPi * sin(2 * atan(y1))
	  ];
	};
	
	var vanDerGrinten3 = function() {
	  return d3Geo.geoProjection(vanDerGrinten3Raw)
	        .scale(79.4183);
	};
	
	function vanDerGrinten4Raw(lambda, phi) {
	  if (!phi) return [lambda, 0];
	  var phi0 = abs(phi);
	  if (!lambda || phi0 === halfPi) return [0, phi];
	  var B = phi0 / halfPi,
	      B2 = B * B,
	      C = (8 * B - B2 * (B2 + 2) - 5) / (2 * B2 * (B - 1)),
	      C2 = C * C,
	      BC = B * C,
	      B_C2 = B2 + C2 + 2 * BC,
	      B_3C = B + 3 * C,
	      lambda0 = lambda / halfPi,
	      lambda1 = lambda0 + 1 / lambda0,
	      D = sign(abs(lambda) - halfPi) * sqrt(lambda1 * lambda1 - 4),
	      D2 = D * D,
	      F = B_C2 * (B2 + C2 * D2 - 1) + (1 - B2) * (B2 * (B_3C * B_3C + 4 * C2) + 12 * BC * C2 + 4 * C2 * C2),
	      x1 = (D * (B_C2 + C2 - 1) + 2 * sqrt(F)) / (4 * B_C2 + D2);
	  return [
	    sign(lambda) * halfPi * x1,
	    sign(phi) * halfPi * sqrt(1 + D * abs(x1) - x1 * x1)
	  ];
	}
	
	vanDerGrinten4Raw.invert = function(x, y) {
	  var delta;
	  if (!x || !y) return [x, y];
	  y /= pi;
	  var x1 = sign(x) * x / halfPi,
	      D = (x1 * x1 - 1 + 4 * y * y) / abs(x1),
	      D2 = D * D,
	      B = 2 * y,
	      i = 50;
	  do {
	    var B2 = B * B,
	        C = (8 * B - B2 * (B2 + 2) - 5) / (2 * B2 * (B - 1)),
	        C_ = (3 * B - B2 * B - 10) / (2 * B2 * B),
	        C2 = C * C,
	        BC = B * C,
	        B_C = B + C,
	        B_C2 = B_C * B_C,
	        B_3C = B + 3 * C,
	        F = B_C2 * (B2 + C2 * D2 - 1) + (1 - B2) * (B2 * (B_3C * B_3C + 4 * C2) + C2 * (12 * BC + 4 * C2)),
	        F_ = -2 * B_C * (4 * BC * C2 + (1 - 4 * B2 + 3 * B2 * B2) * (1 + C_) + C2 * (-6 + 14 * B2 - D2 + (-8 + 8 * B2 - 2 * D2) * C_) + BC * (-8 + 12 * B2 + (-10 + 10 * B2 - D2) * C_)),
	        sqrtF = sqrt(F),
	        f = D * (B_C2 + C2 - 1) + 2 * sqrtF - x1 * (4 * B_C2 + D2),
	        f_ = D * (2 * C * C_ + 2 * B_C * (1 + C_)) + F_ / sqrtF - 8 * B_C * (D * (-1 + C2 + B_C2) + 2 * sqrtF) * (1 + C_) / (D2 + 4 * B_C2);
	    B -= delta = f / f_;
	  } while (delta > epsilon && --i > 0);
	  return [
	    sign(x) * (sqrt(D * D + 4) + D) * pi / 4,
	    halfPi * B
	  ];
	};
	
	var vanDerGrinten4 = function() {
	  return d3Geo.geoProjection(vanDerGrinten4Raw)
	      .scale(127.16);
	};
	
	var A = 4 * pi + 3 * sqrt(3);
	var B = 2 * sqrt(2 * pi * sqrt(3) / A);
	
	var wagner4Raw = mollweideBromleyRaw(B * sqrt(3) / pi, B, A / 6);
	
	var wagner4 = function() {
	  return d3Geo.geoProjection(wagner4Raw)
	      .scale(176.84);
	};
	
	function wagner6Raw(lambda, phi) {
	  return [lambda * sqrt(1 - 3 * phi * phi / (pi * pi)), phi];
	}
	
	wagner6Raw.invert = function(x, y) {
	  return [x / sqrt(1 - 3 * y * y / (pi * pi)), y];
	};
	
	var wagner6 = function() {
	  return d3Geo.geoProjection(wagner6Raw)
	      .scale(152.63);
	};
	
	function wagner7Raw(lambda, phi) {
	  var s = 0.90631 * sin(phi),
	      c0 = sqrt(1 - s * s),
	      c1 = sqrt(2 / (1 + c0 * cos(lambda /= 3)));
	  return [
	    2.66723 * c0 * c1 * sin(lambda),
	    1.24104 * s * c1
	  ];
	}
	
	wagner7Raw.invert = function(x, y) {
	  var t1 = x / 2.66723,
	      t2 = y / 1.24104,
	      p = sqrt(t1 * t1 + t2 * t2),
	      c = 2 * asin(p / 2);
	  return [
	    3 * atan2(x * tan(c), 2.66723 * p),
	    p && asin(y * sin(c) / (1.24104 * 0.90631 * p))
	  ];
	};
	
	var wagner7 = function() {
	  return d3Geo.geoProjection(wagner7Raw)
	      .scale(172.632);
	};
	
	function wiechelRaw(lambda, phi) {
	  var cosPhi = cos(phi),
	      sinPhi = cos(lambda) * cosPhi,
	      sin1_Phi = 1 - sinPhi,
	      cosLambda = cos(lambda = atan2(sin(lambda) * cosPhi, -sin(phi))),
	      sinLambda = sin(lambda);
	  cosPhi = sqrt(1 - sinPhi * sinPhi);
	  return [
	    sinLambda * cosPhi - cosLambda * sin1_Phi,
	    -cosLambda * cosPhi - sinLambda * sin1_Phi
	  ];
	}
	
	wiechelRaw.invert = function(x, y) {
	  var w = (x * x + y * y) / -2,
	      k = sqrt(-w * (2 + w)),
	      b = y * w + x * k,
	      a = x * w - y * k,
	      D = sqrt(a * a + b * b);
	  return [
	    atan2(k * b, D * (1 + w)),
	    D ? -asin(k * a / D) : 0
	  ];
	};
	
	var wiechel = function() {
	  return d3Geo.geoProjection(wiechelRaw)
	      .rotate([0, -90, 45])
	      .scale(124.75)
	      .clipAngle(180 - 1e-3);
	};
	
	function winkel3Raw(lambda, phi) {
	  var coordinates = aitoffRaw(lambda, phi);
	  return [
	    (coordinates[0] + lambda / halfPi) / 2,
	    (coordinates[1] + phi) / 2
	  ];
	}
	
	winkel3Raw.invert = function(x, y) {
	  var lambda = x, phi = y, i = 25;
	  do {
	    var cosphi = cos(phi),
	        sinphi = sin(phi),
	        sin_2phi = sin(2 * phi),
	        sin2phi = sinphi * sinphi,
	        cos2phi = cosphi * cosphi,
	        sinlambda = sin(lambda),
	        coslambda_2 = cos(lambda / 2),
	        sinlambda_2 = sin(lambda / 2),
	        sin2lambda_2 = sinlambda_2 * sinlambda_2,
	        C = 1 - cos2phi * coslambda_2 * coslambda_2,
	        E = C ? acos(cosphi * coslambda_2) * sqrt(F = 1 / C) : F = 0,
	        F,
	        fx = 0.5 * (2 * E * cosphi * sinlambda_2 + lambda / halfPi) - x,
	        fy = 0.5 * (E * sinphi + phi) - y,
	        dxdlambda = 0.5 * F * (cos2phi * sin2lambda_2 + E * cosphi * coslambda_2 * sin2phi) + 0.5 / halfPi,
	        dxdphi = F * (sinlambda * sin_2phi / 4 - E * sinphi * sinlambda_2),
	        dydlambda = 0.125 * F * (sin_2phi * sinlambda_2 - E * sinphi * cos2phi * sinlambda),
	        dydphi = 0.5 * F * (sin2phi * coslambda_2 + E * sin2lambda_2 * cosphi) + 0.5,
	        denominator = dxdphi * dydlambda - dydphi * dxdlambda,
	        dlambda = (fy * dxdphi - fx * dydphi) / denominator,
	        dphi = (fx * dydlambda - fy * dxdlambda) / denominator;
	    lambda -= dlambda, phi -= dphi;
	  } while ((abs(dlambda) > epsilon || abs(dphi) > epsilon) && --i > 0);
	  return [lambda, phi];
	};
	
	var winkel3 = function() {
	  return d3Geo.geoProjection(winkel3Raw)
	      .scale(158.837);
	};
	
	exports.geoAiry = airy;
	exports.geoAiryRaw = airyRaw;
	exports.geoAitoff = aitoff;
	exports.geoAitoffRaw = aitoffRaw;
	exports.geoArmadillo = armadillo;
	exports.geoArmadilloRaw = armadilloRaw;
	exports.geoAugust = august;
	exports.geoAugustRaw = augustRaw;
	exports.geoBaker = baker;
	exports.geoBakerRaw = bakerRaw;
	exports.geoBerghaus = berghaus;
	exports.geoBerghausRaw = berghausRaw;
	exports.geoBoggs = boggs;
	exports.geoBoggsRaw = boggsRaw;
	exports.geoBonne = bonne;
	exports.geoBonneRaw = bonneRaw;
	exports.geoBottomley = bottomley;
	exports.geoBottomleyRaw = bottomleyRaw;
	exports.geoBromley = bromley;
	exports.geoBromleyRaw = bromleyRaw;
	exports.geoChamberlin = chamberlin;
	exports.geoChamberlinRaw = chamberlinRaw;
	exports.geoChamberlinAfrica = chamberlinAfrica;
	exports.geoCollignon = collignon;
	exports.geoCollignonRaw = collignonRaw;
	exports.geoCraig = craig;
	exports.geoCraigRaw = craigRaw;
	exports.geoCraster = craster;
	exports.geoCrasterRaw = crasterRaw;
	exports.geoCylindricalEqualArea = cylindricalEqualArea;
	exports.geoCylindricalEqualAreaRaw = cylindricalEqualAreaRaw;
	exports.geoCylindricalStereographic = cylindricalStereographic;
	exports.geoCylindricalStereographicRaw = cylindricalStereographicRaw;
	exports.geoEckert1 = eckert1;
	exports.geoEckert1Raw = eckert1Raw;
	exports.geoEckert2 = eckert2;
	exports.geoEckert2Raw = eckert2Raw;
	exports.geoEckert3 = eckert3;
	exports.geoEckert3Raw = eckert3Raw;
	exports.geoEckert4 = eckert4;
	exports.geoEckert4Raw = eckert4Raw;
	exports.geoEckert5 = eckert5;
	exports.geoEckert5Raw = eckert5Raw;
	exports.geoEckert6 = eckert6;
	exports.geoEckert6Raw = eckert6Raw;
	exports.geoEisenlohr = eisenlohr;
	exports.geoEisenlohrRaw = eisenlohrRaw;
	exports.geoFahey = fahey;
	exports.geoFaheyRaw = faheyRaw;
	exports.geoFoucaut = foucaut;
	exports.geoFoucautRaw = foucautRaw;
	exports.geoGilbert = gilbert;
	exports.geoGingery = gingery;
	exports.geoGingeryRaw = gingeryRaw;
	exports.geoGinzburg4 = ginzburg4;
	exports.geoGinzburg4Raw = ginzburg4Raw;
	exports.geoGinzburg5 = ginzburg5;
	exports.geoGinzburg5Raw = ginzburg5Raw;
	exports.geoGinzburg6 = ginzburg6;
	exports.geoGinzburg6Raw = ginzburg6Raw;
	exports.geoGinzburg8 = ginzburg8;
	exports.geoGinzburg8Raw = ginzburg8Raw;
	exports.geoGinzburg9 = ginzburg9;
	exports.geoGinzburg9Raw = ginzburg9Raw;
	exports.geoGringorten = gringorten;
	exports.geoGringortenRaw = gringortenRaw;
	exports.geoGuyou = guyou;
	exports.geoGuyouRaw = guyouRaw;
	exports.geoHammer = hammer;
	exports.geoHammerRaw = hammerRaw;
	exports.geoHammerRetroazimuthal = hammerRetroazimuthal;
	exports.geoHammerRetroazimuthalRaw = hammerRetroazimuthalRaw;
	exports.geoHealpix = healpix;
	exports.geoHealpixRaw = healpixRaw;
	exports.geoHill = hill;
	exports.geoHillRaw = hillRaw;
	exports.geoHomolosine = homolosine;
	exports.geoHomolosineRaw = homolosineRaw;
	exports.geoInterrupt = interrupt;
	exports.geoInterruptedBoggs = boggs$1;
	exports.geoInterruptedHomolosine = homolosine$1;
	exports.geoInterruptedMollweide = mollweide$1;
	exports.geoInterruptedMollweideHemispheres = mollweideHemispheres;
	exports.geoInterruptedSinuMollweide = sinuMollweide$1;
	exports.geoInterruptedSinusoidal = sinusoidal$1;
	exports.geoKavrayskiy7 = kavrayskiy7;
	exports.geoKavrayskiy7Raw = kavrayskiy7Raw;
	exports.geoLagrange = lagrange;
	exports.geoLagrangeRaw = lagrangeRaw;
	exports.geoLarrivee = larrivee;
	exports.geoLarriveeRaw = larriveeRaw;
	exports.geoLaskowski = laskowski;
	exports.geoLaskowskiRaw = laskowskiRaw;
	exports.geoLittrow = littrow;
	exports.geoLittrowRaw = littrowRaw;
	exports.geoLoximuthal = loximuthal;
	exports.geoLoximuthalRaw = loximuthalRaw;
	exports.geoMiller = miller;
	exports.geoMillerRaw = millerRaw;
	exports.geoModifiedStereographic = modifiedStereographic;
	exports.geoModifiedStereographicRaw = modifiedStereographicRaw;
	exports.geoModifiedStereographicAlaska = modifiedStereographicAlaska;
	exports.geoModifiedStereographicGs48 = modifiedStereographicGs48;
	exports.geoModifiedStereographicGs50 = modifiedStereographicGs50;
	exports.geoModifiedStereographicMiller = modifiedStereographicMiller;
	exports.geoModifiedStereographicLee = modifiedStereographicLee;
	exports.geoMollweide = mollweide;
	exports.geoMollweideRaw = mollweideRaw;
	exports.geoMtFlatPolarParabolic = mtFlatPolarParabolic;
	exports.geoMtFlatPolarParabolicRaw = mtFlatPolarParabolicRaw;
	exports.geoMtFlatPolarQuartic = mtFlatPolarQuartic;
	exports.geoMtFlatPolarQuarticRaw = mtFlatPolarQuarticRaw;
	exports.geoMtFlatPolarSinusoidal = mtFlatPolarSinusoidal;
	exports.geoMtFlatPolarSinusoidalRaw = mtFlatPolarSinusoidalRaw;
	exports.geoNaturalEarth = naturalEarth;
	exports.geoNaturalEarthRaw = naturalEarthRaw;
	exports.geoNellHammer = nellHammer;
	exports.geoNellHammerRaw = nellHammerRaw;
	exports.geoPatterson = patterson;
	exports.geoPattersonRaw = pattersonRaw;
	exports.geoPolyconic = polyconic;
	exports.geoPolyconicRaw = polyconicRaw;
	exports.geoPolyhedral = polyhedral;
	exports.geoPolyhedralButterfly = butterfly;
	exports.geoPolyhedralCollignon = collignon$1;
	exports.geoPolyhedralWaterman = waterman;
	exports.geoProject = index;
	exports.geoGringortenQuincuncial = gringorten$1;
	exports.geoPeirceQuincuncial = peirce;
	exports.geoPierceQuincuncial = peirce;
	exports.geoQuantize = quantize;
	exports.geoQuincuncial = quincuncial;
	exports.geoRectangularPolyconic = rectangularPolyconic;
	exports.geoRectangularPolyconicRaw = rectangularPolyconicRaw;
	exports.geoRobinson = robinson;
	exports.geoRobinsonRaw = robinsonRaw;
	exports.geoSatellite = satellite;
	exports.geoSatelliteRaw = satelliteRaw;
	exports.geoSinuMollweide = sinuMollweide;
	exports.geoSinuMollweideRaw = sinuMollweideRaw;
	exports.geoSinusoidal = sinusoidal;
	exports.geoSinusoidalRaw = sinusoidalRaw;
	exports.geoStitch = stitch;
	exports.geoTimes = times;
	exports.geoTimesRaw = timesRaw;
	exports.geoTwoPointAzimuthal = twoPointAzimuthal;
	exports.geoTwoPointAzimuthalRaw = twoPointAzimuthalRaw;
	exports.geoTwoPointAzimuthalUsa = twoPointAzimuthalUsa;
	exports.geoTwoPointEquidistant = twoPointEquidistant;
	exports.geoTwoPointEquidistantRaw = twoPointEquidistantRaw;
	exports.geoTwoPointEquidistantUsa = twoPointEquidistantUsa;
	exports.geoVanDerGrinten = vanDerGrinten;
	exports.geoVanDerGrintenRaw = vanDerGrintenRaw;
	exports.geoVanDerGrinten2 = vanDerGrinten2;
	exports.geoVanDerGrinten2Raw = vanDerGrinten2Raw;
	exports.geoVanDerGrinten3 = vanDerGrinten3;
	exports.geoVanDerGrinten3Raw = vanDerGrinten3Raw;
	exports.geoVanDerGrinten4 = vanDerGrinten4;
	exports.geoVanDerGrinten4Raw = vanDerGrinten4Raw;
	exports.geoWagner4 = wagner4;
	exports.geoWagner4Raw = wagner4Raw;
	exports.geoWagner6 = wagner6;
	exports.geoWagner6Raw = wagner6Raw;
	exports.geoWagner7 = wagner7;
	exports.geoWagner7Raw = wagner7Raw;
	exports.geoWiechel = wiechel;
	exports.geoWiechelRaw = wiechelRaw;
	exports.geoWinkel3 = winkel3;
	exports.geoWinkel3Raw = winkel3Raw;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-interpolate/ Version 1.2.0. Copyright 2018 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(692)) :
		typeof define === 'function' && define.amd ? define(['exports', 'd3-color'], factory) :
		(factory((global.d3 = global.d3 || {}),global.d3));
	}(this, (function (exports,d3Color) { 'use strict';
	
	function basis(t1, v0, v1, v2, v3) {
	  var t2 = t1 * t1, t3 = t2 * t1;
	  return ((1 - 3 * t1 + 3 * t2 - t3) * v0
	      + (4 - 6 * t2 + 3 * t3) * v1
	      + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2
	      + t3 * v3) / 6;
	}
	
	var basis$1 = function(values) {
	  var n = values.length - 1;
	  return function(t) {
	    var i = t <= 0 ? (t = 0) : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
	        v1 = values[i],
	        v2 = values[i + 1],
	        v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
	        v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
	    return basis((t - i / n) * n, v0, v1, v2, v3);
	  };
	};
	
	var basisClosed = function(values) {
	  var n = values.length;
	  return function(t) {
	    var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
	        v0 = values[(i + n - 1) % n],
	        v1 = values[i % n],
	        v2 = values[(i + 1) % n],
	        v3 = values[(i + 2) % n];
	    return basis((t - i / n) * n, v0, v1, v2, v3);
	  };
	};
	
	var constant = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	function linear(a, d) {
	  return function(t) {
	    return a + t * d;
	  };
	}
	
	function exponential(a, b, y) {
	  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
	    return Math.pow(a + t * b, y);
	  };
	}
	
	function hue(a, b) {
	  var d = b - a;
	  return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : constant(isNaN(a) ? b : a);
	}
	
	function gamma(y) {
	  return (y = +y) === 1 ? nogamma : function(a, b) {
	    return b - a ? exponential(a, b, y) : constant(isNaN(a) ? b : a);
	  };
	}
	
	function nogamma(a, b) {
	  var d = b - a;
	  return d ? linear(a, d) : constant(isNaN(a) ? b : a);
	}
	
	var rgb$1 = ((function rgbGamma(y) {
	  var color$$1 = gamma(y);
	
	  function rgb$$1(start, end) {
	    var r = color$$1((start = d3Color.rgb(start)).r, (end = d3Color.rgb(end)).r),
	        g = color$$1(start.g, end.g),
	        b = color$$1(start.b, end.b),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.r = r(t);
	      start.g = g(t);
	      start.b = b(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	
	  rgb$$1.gamma = rgbGamma;
	
	  return rgb$$1;
	}))(1);
	
	function rgbSpline(spline) {
	  return function(colors) {
	    var n = colors.length,
	        r = new Array(n),
	        g = new Array(n),
	        b = new Array(n),
	        i, color$$1;
	    for (i = 0; i < n; ++i) {
	      color$$1 = d3Color.rgb(colors[i]);
	      r[i] = color$$1.r || 0;
	      g[i] = color$$1.g || 0;
	      b[i] = color$$1.b || 0;
	    }
	    r = spline(r);
	    g = spline(g);
	    b = spline(b);
	    color$$1.opacity = 1;
	    return function(t) {
	      color$$1.r = r(t);
	      color$$1.g = g(t);
	      color$$1.b = b(t);
	      return color$$1 + "";
	    };
	  };
	}
	
	var rgbBasis = rgbSpline(basis$1);
	var rgbBasisClosed = rgbSpline(basisClosed);
	
	var array = function(a, b) {
	  var nb = b ? b.length : 0,
	      na = a ? Math.min(nb, a.length) : 0,
	      x = new Array(na),
	      c = new Array(nb),
	      i;
	
	  for (i = 0; i < na; ++i) x[i] = value(a[i], b[i]);
	  for (; i < nb; ++i) c[i] = b[i];
	
	  return function(t) {
	    for (i = 0; i < na; ++i) c[i] = x[i](t);
	    return c;
	  };
	};
	
	var date = function(a, b) {
	  var d = new Date;
	  return a = +a, b -= a, function(t) {
	    return d.setTime(a + b * t), d;
	  };
	};
	
	var number = function(a, b) {
	  return a = +a, b -= a, function(t) {
	    return a + b * t;
	  };
	};
	
	var object = function(a, b) {
	  var i = {},
	      c = {},
	      k;
	
	  if (a === null || typeof a !== "object") a = {};
	  if (b === null || typeof b !== "object") b = {};
	
	  for (k in b) {
	    if (k in a) {
	      i[k] = value(a[k], b[k]);
	    } else {
	      c[k] = b[k];
	    }
	  }
	
	  return function(t) {
	    for (k in i) c[k] = i[k](t);
	    return c;
	  };
	};
	
	var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g;
	var reB = new RegExp(reA.source, "g");
	
	function zero(b) {
	  return function() {
	    return b;
	  };
	}
	
	function one(b) {
	  return function(t) {
	    return b(t) + "";
	  };
	}
	
	var string = function(a, b) {
	  var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
	      am, // current match in a
	      bm, // current match in b
	      bs, // string preceding current number in b, if any
	      i = -1, // index in s
	      s = [], // string constants and placeholders
	      q = []; // number interpolators
	
	  // Coerce inputs to strings.
	  a = a + "", b = b + "";
	
	  // Interpolate pairs of numbers in a & b.
	  while ((am = reA.exec(a))
	      && (bm = reB.exec(b))) {
	    if ((bs = bm.index) > bi) { // a string precedes the next number in b
	      bs = b.slice(bi, bs);
	      if (s[i]) s[i] += bs; // coalesce with previous string
	      else s[++i] = bs;
	    }
	    if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
	      if (s[i]) s[i] += bm; // coalesce with previous string
	      else s[++i] = bm;
	    } else { // interpolate non-matching numbers
	      s[++i] = null;
	      q.push({i: i, x: number(am, bm)});
	    }
	    bi = reB.lastIndex;
	  }
	
	  // Add remains of b.
	  if (bi < b.length) {
	    bs = b.slice(bi);
	    if (s[i]) s[i] += bs; // coalesce with previous string
	    else s[++i] = bs;
	  }
	
	  // Special optimization for only a single match.
	  // Otherwise, interpolate each of the numbers and rejoin the string.
	  return s.length < 2 ? (q[0]
	      ? one(q[0].x)
	      : zero(b))
	      : (b = q.length, function(t) {
	          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
	          return s.join("");
	        });
	};
	
	var value = function(a, b) {
	  var t = typeof b, c;
	  return b == null || t === "boolean" ? constant(b)
	      : (t === "number" ? number
	      : t === "string" ? ((c = d3Color.color(b)) ? (b = c, rgb$1) : string)
	      : b instanceof d3Color.color ? rgb$1
	      : b instanceof Date ? date
	      : Array.isArray(b) ? array
	      : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? object
	      : number)(a, b);
	};
	
	var round = function(a, b) {
	  return a = +a, b -= a, function(t) {
	    return Math.round(a + b * t);
	  };
	};
	
	var degrees = 180 / Math.PI;
	
	var identity = {
	  translateX: 0,
	  translateY: 0,
	  rotate: 0,
	  skewX: 0,
	  scaleX: 1,
	  scaleY: 1
	};
	
	var decompose = function(a, b, c, d, e, f) {
	  var scaleX, scaleY, skewX;
	  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
	  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
	  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
	  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
	  return {
	    translateX: e,
	    translateY: f,
	    rotate: Math.atan2(b, a) * degrees,
	    skewX: Math.atan(skewX) * degrees,
	    scaleX: scaleX,
	    scaleY: scaleY
	  };
	};
	
	var cssNode;
	var cssRoot;
	var cssView;
	var svgNode;
	
	function parseCss(value) {
	  if (value === "none") return identity;
	  if (!cssNode) cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView;
	  cssNode.style.transform = value;
	  value = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform");
	  cssRoot.removeChild(cssNode);
	  value = value.slice(7, -1).split(",");
	  return decompose(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
	}
	
	function parseSvg(value) {
	  if (value == null) return identity;
	  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
	  svgNode.setAttribute("transform", value);
	  if (!(value = svgNode.transform.baseVal.consolidate())) return identity;
	  value = value.matrix;
	  return decompose(value.a, value.b, value.c, value.d, value.e, value.f);
	}
	
	function interpolateTransform(parse, pxComma, pxParen, degParen) {
	
	  function pop(s) {
	    return s.length ? s.pop() + " " : "";
	  }
	
	  function translate(xa, ya, xb, yb, s, q) {
	    if (xa !== xb || ya !== yb) {
	      var i = s.push("translate(", null, pxComma, null, pxParen);
	      q.push({i: i - 4, x: number(xa, xb)}, {i: i - 2, x: number(ya, yb)});
	    } else if (xb || yb) {
	      s.push("translate(" + xb + pxComma + yb + pxParen);
	    }
	  }
	
	  function rotate(a, b, s, q) {
	    if (a !== b) {
	      if (a - b > 180) b += 360; else if (b - a > 180) a += 360; // shortest path
	      q.push({i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: number(a, b)});
	    } else if (b) {
	      s.push(pop(s) + "rotate(" + b + degParen);
	    }
	  }
	
	  function skewX(a, b, s, q) {
	    if (a !== b) {
	      q.push({i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: number(a, b)});
	    } else if (b) {
	      s.push(pop(s) + "skewX(" + b + degParen);
	    }
	  }
	
	  function scale(xa, ya, xb, yb, s, q) {
	    if (xa !== xb || ya !== yb) {
	      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
	      q.push({i: i - 4, x: number(xa, xb)}, {i: i - 2, x: number(ya, yb)});
	    } else if (xb !== 1 || yb !== 1) {
	      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
	    }
	  }
	
	  return function(a, b) {
	    var s = [], // string constants and placeholders
	        q = []; // number interpolators
	    a = parse(a), b = parse(b);
	    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
	    rotate(a.rotate, b.rotate, s, q);
	    skewX(a.skewX, b.skewX, s, q);
	    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
	    a = b = null; // gc
	    return function(t) {
	      var i = -1, n = q.length, o;
	      while (++i < n) s[(o = q[i]).i] = o.x(t);
	      return s.join("");
	    };
	  };
	}
	
	var interpolateTransformCss = interpolateTransform(parseCss, "px, ", "px)", "deg)");
	var interpolateTransformSvg = interpolateTransform(parseSvg, ", ", ")", ")");
	
	var rho = Math.SQRT2;
	var rho2 = 2;
	var rho4 = 4;
	var epsilon2 = 1e-12;
	
	function cosh(x) {
	  return ((x = Math.exp(x)) + 1 / x) / 2;
	}
	
	function sinh(x) {
	  return ((x = Math.exp(x)) - 1 / x) / 2;
	}
	
	function tanh(x) {
	  return ((x = Math.exp(2 * x)) - 1) / (x + 1);
	}
	
	// p0 = [ux0, uy0, w0]
	// p1 = [ux1, uy1, w1]
	var zoom = function(p0, p1) {
	  var ux0 = p0[0], uy0 = p0[1], w0 = p0[2],
	      ux1 = p1[0], uy1 = p1[1], w1 = p1[2],
	      dx = ux1 - ux0,
	      dy = uy1 - uy0,
	      d2 = dx * dx + dy * dy,
	      i,
	      S;
	
	  // Special case for u0 ≅ u1.
	  if (d2 < epsilon2) {
	    S = Math.log(w1 / w0) / rho;
	    i = function(t) {
	      return [
	        ux0 + t * dx,
	        uy0 + t * dy,
	        w0 * Math.exp(rho * t * S)
	      ];
	    };
	  }
	
	  // General case.
	  else {
	    var d1 = Math.sqrt(d2),
	        b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
	        b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
	        r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
	        r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
	    S = (r1 - r0) / rho;
	    i = function(t) {
	      var s = t * S,
	          coshr0 = cosh(r0),
	          u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
	      return [
	        ux0 + u * dx,
	        uy0 + u * dy,
	        w0 * coshr0 / cosh(rho * s + r0)
	      ];
	    };
	  }
	
	  i.duration = S * 1000;
	
	  return i;
	};
	
	function hsl$1(hue$$1) {
	  return function(start, end) {
	    var h = hue$$1((start = d3Color.hsl(start)).h, (end = d3Color.hsl(end)).h),
	        s = nogamma(start.s, end.s),
	        l = nogamma(start.l, end.l),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.h = h(t);
	      start.s = s(t);
	      start.l = l(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	}
	
	var hsl$2 = hsl$1(hue);
	var hslLong = hsl$1(nogamma);
	
	function lab$1(start, end) {
	  var l = nogamma((start = d3Color.lab(start)).l, (end = d3Color.lab(end)).l),
	      a = nogamma(start.a, end.a),
	      b = nogamma(start.b, end.b),
	      opacity = nogamma(start.opacity, end.opacity);
	  return function(t) {
	    start.l = l(t);
	    start.a = a(t);
	    start.b = b(t);
	    start.opacity = opacity(t);
	    return start + "";
	  };
	}
	
	function hcl$1(hue$$1) {
	  return function(start, end) {
	    var h = hue$$1((start = d3Color.hcl(start)).h, (end = d3Color.hcl(end)).h),
	        c = nogamma(start.c, end.c),
	        l = nogamma(start.l, end.l),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.h = h(t);
	      start.c = c(t);
	      start.l = l(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	}
	
	var hcl$2 = hcl$1(hue);
	var hclLong = hcl$1(nogamma);
	
	function cubehelix$1(hue$$1) {
	  return (function cubehelixGamma(y) {
	    y = +y;
	
	    function cubehelix$$1(start, end) {
	      var h = hue$$1((start = d3Color.cubehelix(start)).h, (end = d3Color.cubehelix(end)).h),
	          s = nogamma(start.s, end.s),
	          l = nogamma(start.l, end.l),
	          opacity = nogamma(start.opacity, end.opacity);
	      return function(t) {
	        start.h = h(t);
	        start.s = s(t);
	        start.l = l(Math.pow(t, y));
	        start.opacity = opacity(t);
	        return start + "";
	      };
	    }
	
	    cubehelix$$1.gamma = cubehelixGamma;
	
	    return cubehelix$$1;
	  })(1);
	}
	
	var cubehelix$2 = cubehelix$1(hue);
	var cubehelixLong = cubehelix$1(nogamma);
	
	function piecewise(interpolate, values) {
	  var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
	  while (i < n) I[i] = interpolate(v, v = values[++i]);
	  return function(t) {
	    var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
	    return I[i](t - i);
	  };
	}
	
	var quantize = function(interpolator, n) {
	  var samples = new Array(n);
	  for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));
	  return samples;
	};
	
	exports.interpolate = value;
	exports.interpolateArray = array;
	exports.interpolateBasis = basis$1;
	exports.interpolateBasisClosed = basisClosed;
	exports.interpolateDate = date;
	exports.interpolateNumber = number;
	exports.interpolateObject = object;
	exports.interpolateRound = round;
	exports.interpolateString = string;
	exports.interpolateTransformCss = interpolateTransformCss;
	exports.interpolateTransformSvg = interpolateTransformSvg;
	exports.interpolateZoom = zoom;
	exports.interpolateRgb = rgb$1;
	exports.interpolateRgbBasis = rgbBasis;
	exports.interpolateRgbBasisClosed = rgbBasisClosed;
	exports.interpolateHsl = hsl$2;
	exports.interpolateHslLong = hslLong;
	exports.interpolateLab = lab$1;
	exports.interpolateHcl = hcl$2;
	exports.interpolateHclLong = hclLong;
	exports.interpolateCubehelix = cubehelix$2;
	exports.interpolateCubehelixLong = cubehelixLong;
	exports.piecewise = piecewise;
	exports.quantize = quantize;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-scale/ Version 2.0.0. Copyright 2018 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(276), __webpack_require__(691), __webpack_require__(695), __webpack_require__(693), __webpack_require__(506), __webpack_require__(697)) :
		typeof define === 'function' && define.amd ? define(['exports', 'd3-array', 'd3-collection', 'd3-interpolate', 'd3-format', 'd3-time', 'd3-time-format'], factory) :
		(factory((global.d3 = global.d3 || {}),global.d3,global.d3,global.d3,global.d3,global.d3,global.d3));
	}(this, (function (exports,d3Array,d3Collection,d3Interpolate,d3Format,d3Time,d3TimeFormat) { 'use strict';
	
	var array = Array.prototype;
	
	var map$1 = array.map;
	var slice = array.slice;
	
	var implicit = {name: "implicit"};
	
	function ordinal(range$$1) {
	  var index = d3Collection.map(),
	      domain = [],
	      unknown = implicit;
	
	  range$$1 = range$$1 == null ? [] : slice.call(range$$1);
	
	  function scale(d) {
	    var key = d + "", i = index.get(key);
	    if (!i) {
	      if (unknown !== implicit) return unknown;
	      index.set(key, i = domain.push(d));
	    }
	    return range$$1[(i - 1) % range$$1.length];
	  }
	
	  scale.domain = function(_) {
	    if (!arguments.length) return domain.slice();
	    domain = [], index = d3Collection.map();
	    var i = -1, n = _.length, d, key;
	    while (++i < n) if (!index.has(key = (d = _[i]) + "")) index.set(key, domain.push(d));
	    return scale;
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice.call(_), scale) : range$$1.slice();
	  };
	
	  scale.unknown = function(_) {
	    return arguments.length ? (unknown = _, scale) : unknown;
	  };
	
	  scale.copy = function() {
	    return ordinal()
	        .domain(domain)
	        .range(range$$1)
	        .unknown(unknown);
	  };
	
	  return scale;
	}
	
	function band() {
	  var scale = ordinal().unknown(undefined),
	      domain = scale.domain,
	      ordinalRange = scale.range,
	      range$$1 = [0, 1],
	      step,
	      bandwidth,
	      round = false,
	      paddingInner = 0,
	      paddingOuter = 0,
	      align = 0.5;
	
	  delete scale.unknown;
	
	  function rescale() {
	    var n = domain().length,
	        reverse = range$$1[1] < range$$1[0],
	        start = range$$1[reverse - 0],
	        stop = range$$1[1 - reverse];
	    step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
	    if (round) step = Math.floor(step);
	    start += (stop - start - step * (n - paddingInner)) * align;
	    bandwidth = step * (1 - paddingInner);
	    if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
	    var values = d3Array.range(n).map(function(i) { return start + step * i; });
	    return ordinalRange(reverse ? values.reverse() : values);
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain(_), rescale()) : domain();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = [+_[0], +_[1]], rescale()) : range$$1.slice();
	  };
	
	  scale.rangeRound = function(_) {
	    return range$$1 = [+_[0], +_[1]], round = true, rescale();
	  };
	
	  scale.bandwidth = function() {
	    return bandwidth;
	  };
	
	  scale.step = function() {
	    return step;
	  };
	
	  scale.round = function(_) {
	    return arguments.length ? (round = !!_, rescale()) : round;
	  };
	
	  scale.padding = function(_) {
	    return arguments.length ? (paddingInner = paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
	  };
	
	  scale.paddingInner = function(_) {
	    return arguments.length ? (paddingInner = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
	  };
	
	  scale.paddingOuter = function(_) {
	    return arguments.length ? (paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingOuter;
	  };
	
	  scale.align = function(_) {
	    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
	  };
	
	  scale.copy = function() {
	    return band()
	        .domain(domain())
	        .range(range$$1)
	        .round(round)
	        .paddingInner(paddingInner)
	        .paddingOuter(paddingOuter)
	        .align(align);
	  };
	
	  return rescale();
	}
	
	function pointish(scale) {
	  var copy = scale.copy;
	
	  scale.padding = scale.paddingOuter;
	  delete scale.paddingInner;
	  delete scale.paddingOuter;
	
	  scale.copy = function() {
	    return pointish(copy());
	  };
	
	  return scale;
	}
	
	function point() {
	  return pointish(band().paddingInner(1));
	}
	
	function constant(x) {
	  return function() {
	    return x;
	  };
	}
	
	function number(x) {
	  return +x;
	}
	
	var unit = [0, 1];
	
	function deinterpolateLinear(a, b) {
	  return (b -= (a = +a))
	      ? function(x) { return (x - a) / b; }
	      : constant(b);
	}
	
	function deinterpolateClamp(deinterpolate) {
	  return function(a, b) {
	    var d = deinterpolate(a = +a, b = +b);
	    return function(x) { return x <= a ? 0 : x >= b ? 1 : d(x); };
	  };
	}
	
	function reinterpolateClamp(reinterpolate) {
	  return function(a, b) {
	    var r = reinterpolate(a = +a, b = +b);
	    return function(t) { return t <= 0 ? a : t >= 1 ? b : r(t); };
	  };
	}
	
	function bimap(domain, range$$1, deinterpolate, reinterpolate) {
	  var d0 = domain[0], d1 = domain[1], r0 = range$$1[0], r1 = range$$1[1];
	  if (d1 < d0) d0 = deinterpolate(d1, d0), r0 = reinterpolate(r1, r0);
	  else d0 = deinterpolate(d0, d1), r0 = reinterpolate(r0, r1);
	  return function(x) { return r0(d0(x)); };
	}
	
	function polymap(domain, range$$1, deinterpolate, reinterpolate) {
	  var j = Math.min(domain.length, range$$1.length) - 1,
	      d = new Array(j),
	      r = new Array(j),
	      i = -1;
	
	  // Reverse descending domains.
	  if (domain[j] < domain[0]) {
	    domain = domain.slice().reverse();
	    range$$1 = range$$1.slice().reverse();
	  }
	
	  while (++i < j) {
	    d[i] = deinterpolate(domain[i], domain[i + 1]);
	    r[i] = reinterpolate(range$$1[i], range$$1[i + 1]);
	  }
	
	  return function(x) {
	    var i = d3Array.bisect(domain, x, 1, j) - 1;
	    return r[i](d[i](x));
	  };
	}
	
	function copy(source, target) {
	  return target
	      .domain(source.domain())
	      .range(source.range())
	      .interpolate(source.interpolate())
	      .clamp(source.clamp());
	}
	
	// deinterpolate(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
	// reinterpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding domain value x in [a,b].
	function continuous(deinterpolate, reinterpolate) {
	  var domain = unit,
	      range$$1 = unit,
	      interpolate$$1 = d3Interpolate.interpolate,
	      clamp = false,
	      piecewise,
	      output,
	      input;
	
	  function rescale() {
	    piecewise = Math.min(domain.length, range$$1.length) > 2 ? polymap : bimap;
	    output = input = null;
	    return scale;
	  }
	
	  function scale(x) {
	    return (output || (output = piecewise(domain, range$$1, clamp ? deinterpolateClamp(deinterpolate) : deinterpolate, interpolate$$1)))(+x);
	  }
	
	  scale.invert = function(y) {
	    return (input || (input = piecewise(range$$1, domain, deinterpolateLinear, clamp ? reinterpolateClamp(reinterpolate) : reinterpolate)))(+y);
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain = map$1.call(_, number), rescale()) : domain.slice();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice.call(_), rescale()) : range$$1.slice();
	  };
	
	  scale.rangeRound = function(_) {
	    return range$$1 = slice.call(_), interpolate$$1 = d3Interpolate.interpolateRound, rescale();
	  };
	
	  scale.clamp = function(_) {
	    return arguments.length ? (clamp = !!_, rescale()) : clamp;
	  };
	
	  scale.interpolate = function(_) {
	    return arguments.length ? (interpolate$$1 = _, rescale()) : interpolate$$1;
	  };
	
	  return rescale();
	}
	
	function tickFormat(domain, count, specifier) {
	  var start = domain[0],
	      stop = domain[domain.length - 1],
	      step = d3Array.tickStep(start, stop, count == null ? 10 : count),
	      precision;
	  specifier = d3Format.formatSpecifier(specifier == null ? ",f" : specifier);
	  switch (specifier.type) {
	    case "s": {
	      var value = Math.max(Math.abs(start), Math.abs(stop));
	      if (specifier.precision == null && !isNaN(precision = d3Format.precisionPrefix(step, value))) specifier.precision = precision;
	      return d3Format.formatPrefix(specifier, value);
	    }
	    case "":
	    case "e":
	    case "g":
	    case "p":
	    case "r": {
	      if (specifier.precision == null && !isNaN(precision = d3Format.precisionRound(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
	      break;
	    }
	    case "f":
	    case "%": {
	      if (specifier.precision == null && !isNaN(precision = d3Format.precisionFixed(step))) specifier.precision = precision - (specifier.type === "%") * 2;
	      break;
	    }
	  }
	  return d3Format.format(specifier);
	}
	
	function linearish(scale) {
	  var domain = scale.domain;
	
	  scale.ticks = function(count) {
	    var d = domain();
	    return d3Array.ticks(d[0], d[d.length - 1], count == null ? 10 : count);
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    return tickFormat(domain(), count, specifier);
	  };
	
	  scale.nice = function(count) {
	    if (count == null) count = 10;
	
	    var d = domain(),
	        i0 = 0,
	        i1 = d.length - 1,
	        start = d[i0],
	        stop = d[i1],
	        step;
	
	    if (stop < start) {
	      step = start, start = stop, stop = step;
	      step = i0, i0 = i1, i1 = step;
	    }
	
	    step = d3Array.tickIncrement(start, stop, count);
	
	    if (step > 0) {
	      start = Math.floor(start / step) * step;
	      stop = Math.ceil(stop / step) * step;
	      step = d3Array.tickIncrement(start, stop, count);
	    } else if (step < 0) {
	      start = Math.ceil(start * step) / step;
	      stop = Math.floor(stop * step) / step;
	      step = d3Array.tickIncrement(start, stop, count);
	    }
	
	    if (step > 0) {
	      d[i0] = Math.floor(start / step) * step;
	      d[i1] = Math.ceil(stop / step) * step;
	      domain(d);
	    } else if (step < 0) {
	      d[i0] = Math.ceil(start * step) / step;
	      d[i1] = Math.floor(stop * step) / step;
	      domain(d);
	    }
	
	    return scale;
	  };
	
	  return scale;
	}
	
	function linear() {
	  var scale = continuous(deinterpolateLinear, d3Interpolate.interpolateNumber);
	
	  scale.copy = function() {
	    return copy(scale, linear());
	  };
	
	  return linearish(scale);
	}
	
	function identity() {
	  var domain = [0, 1];
	
	  function scale(x) {
	    return +x;
	  }
	
	  scale.invert = scale;
	
	  scale.domain = scale.range = function(_) {
	    return arguments.length ? (domain = map$1.call(_, number), scale) : domain.slice();
	  };
	
	  scale.copy = function() {
	    return identity().domain(domain);
	  };
	
	  return linearish(scale);
	}
	
	function nice(domain, interval) {
	  domain = domain.slice();
	
	  var i0 = 0,
	      i1 = domain.length - 1,
	      x0 = domain[i0],
	      x1 = domain[i1],
	      t;
	
	  if (x1 < x0) {
	    t = i0, i0 = i1, i1 = t;
	    t = x0, x0 = x1, x1 = t;
	  }
	
	  domain[i0] = interval.floor(x0);
	  domain[i1] = interval.ceil(x1);
	  return domain;
	}
	
	function deinterpolate(a, b) {
	  return (b = Math.log(b / a))
	      ? function(x) { return Math.log(x / a) / b; }
	      : constant(b);
	}
	
	function reinterpolate(a, b) {
	  return a < 0
	      ? function(t) { return -Math.pow(-b, t) * Math.pow(-a, 1 - t); }
	      : function(t) { return Math.pow(b, t) * Math.pow(a, 1 - t); };
	}
	
	function pow10(x) {
	  return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
	}
	
	function powp(base) {
	  return base === 10 ? pow10
	      : base === Math.E ? Math.exp
	      : function(x) { return Math.pow(base, x); };
	}
	
	function logp(base) {
	  return base === Math.E ? Math.log
	      : base === 10 && Math.log10
	      || base === 2 && Math.log2
	      || (base = Math.log(base), function(x) { return Math.log(x) / base; });
	}
	
	function reflect(f) {
	  return function(x) {
	    return -f(-x);
	  };
	}
	
	function log() {
	  var scale = continuous(deinterpolate, reinterpolate).domain([1, 10]),
	      domain = scale.domain,
	      base = 10,
	      logs = logp(10),
	      pows = powp(10);
	
	  function rescale() {
	    logs = logp(base), pows = powp(base);
	    if (domain()[0] < 0) logs = reflect(logs), pows = reflect(pows);
	    return scale;
	  }
	
	  scale.base = function(_) {
	    return arguments.length ? (base = +_, rescale()) : base;
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain(_), rescale()) : domain();
	  };
	
	  scale.ticks = function(count) {
	    var d = domain(),
	        u = d[0],
	        v = d[d.length - 1],
	        r;
	
	    if (r = v < u) i = u, u = v, v = i;
	
	    var i = logs(u),
	        j = logs(v),
	        p,
	        k,
	        t,
	        n = count == null ? 10 : +count,
	        z = [];
	
	    if (!(base % 1) && j - i < n) {
	      i = Math.round(i) - 1, j = Math.round(j) + 1;
	      if (u > 0) for (; i < j; ++i) {
	        for (k = 1, p = pows(i); k < base; ++k) {
	          t = p * k;
	          if (t < u) continue;
	          if (t > v) break;
	          z.push(t);
	        }
	      } else for (; i < j; ++i) {
	        for (k = base - 1, p = pows(i); k >= 1; --k) {
	          t = p * k;
	          if (t < u) continue;
	          if (t > v) break;
	          z.push(t);
	        }
	      }
	    } else {
	      z = d3Array.ticks(i, j, Math.min(j - i, n)).map(pows);
	    }
	
	    return r ? z.reverse() : z;
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    if (specifier == null) specifier = base === 10 ? ".0e" : ",";
	    if (typeof specifier !== "function") specifier = d3Format.format(specifier);
	    if (count === Infinity) return specifier;
	    if (count == null) count = 10;
	    var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
	    return function(d) {
	      var i = d / pows(Math.round(logs(d)));
	      if (i * base < base - 0.5) i *= base;
	      return i <= k ? specifier(d) : "";
	    };
	  };
	
	  scale.nice = function() {
	    return domain(nice(domain(), {
	      floor: function(x) { return pows(Math.floor(logs(x))); },
	      ceil: function(x) { return pows(Math.ceil(logs(x))); }
	    }));
	  };
	
	  scale.copy = function() {
	    return copy(scale, log().base(base));
	  };
	
	  return scale;
	}
	
	function raise(x, exponent) {
	  return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
	}
	
	function pow() {
	  var exponent = 1,
	      scale = continuous(deinterpolate, reinterpolate),
	      domain = scale.domain;
	
	  function deinterpolate(a, b) {
	    return (b = raise(b, exponent) - (a = raise(a, exponent)))
	        ? function(x) { return (raise(x, exponent) - a) / b; }
	        : constant(b);
	  }
	
	  function reinterpolate(a, b) {
	    b = raise(b, exponent) - (a = raise(a, exponent));
	    return function(t) { return raise(a + b * t, 1 / exponent); };
	  }
	
	  scale.exponent = function(_) {
	    return arguments.length ? (exponent = +_, domain(domain())) : exponent;
	  };
	
	  scale.copy = function() {
	    return copy(scale, pow().exponent(exponent));
	  };
	
	  return linearish(scale);
	}
	
	function sqrt() {
	  return pow().exponent(0.5);
	}
	
	function quantile$1() {
	  var domain = [],
	      range$$1 = [],
	      thresholds = [];
	
	  function rescale() {
	    var i = 0, n = Math.max(1, range$$1.length);
	    thresholds = new Array(n - 1);
	    while (++i < n) thresholds[i - 1] = d3Array.quantile(domain, i / n);
	    return scale;
	  }
	
	  function scale(x) {
	    if (!isNaN(x = +x)) return range$$1[d3Array.bisect(thresholds, x)];
	  }
	
	  scale.invertExtent = function(y) {
	    var i = range$$1.indexOf(y);
	    return i < 0 ? [NaN, NaN] : [
	      i > 0 ? thresholds[i - 1] : domain[0],
	      i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
	    ];
	  };
	
	  scale.domain = function(_) {
	    if (!arguments.length) return domain.slice();
	    domain = [];
	    for (var i = 0, n = _.length, d; i < n; ++i) if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
	    domain.sort(d3Array.ascending);
	    return rescale();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice.call(_), rescale()) : range$$1.slice();
	  };
	
	  scale.quantiles = function() {
	    return thresholds.slice();
	  };
	
	  scale.copy = function() {
	    return quantile$1()
	        .domain(domain)
	        .range(range$$1);
	  };
	
	  return scale;
	}
	
	function quantize() {
	  var x0 = 0,
	      x1 = 1,
	      n = 1,
	      domain = [0.5],
	      range$$1 = [0, 1];
	
	  function scale(x) {
	    if (x <= x) return range$$1[d3Array.bisect(domain, x, 0, n)];
	  }
	
	  function rescale() {
	    var i = -1;
	    domain = new Array(n);
	    while (++i < n) domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
	    return scale;
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (x0 = +_[0], x1 = +_[1], rescale()) : [x0, x1];
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (n = (range$$1 = slice.call(_)).length - 1, rescale()) : range$$1.slice();
	  };
	
	  scale.invertExtent = function(y) {
	    var i = range$$1.indexOf(y);
	    return i < 0 ? [NaN, NaN]
	        : i < 1 ? [x0, domain[0]]
	        : i >= n ? [domain[n - 1], x1]
	        : [domain[i - 1], domain[i]];
	  };
	
	  scale.copy = function() {
	    return quantize()
	        .domain([x0, x1])
	        .range(range$$1);
	  };
	
	  return linearish(scale);
	}
	
	function threshold() {
	  var domain = [0.5],
	      range$$1 = [0, 1],
	      n = 1;
	
	  function scale(x) {
	    if (x <= x) return range$$1[d3Array.bisect(domain, x, 0, n)];
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain = slice.call(_), n = Math.min(domain.length, range$$1.length - 1), scale) : domain.slice();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice.call(_), n = Math.min(domain.length, range$$1.length - 1), scale) : range$$1.slice();
	  };
	
	  scale.invertExtent = function(y) {
	    var i = range$$1.indexOf(y);
	    return [domain[i - 1], domain[i]];
	  };
	
	  scale.copy = function() {
	    return threshold()
	        .domain(domain)
	        .range(range$$1);
	  };
	
	  return scale;
	}
	
	var durationSecond = 1000;
	var durationMinute = durationSecond * 60;
	var durationHour = durationMinute * 60;
	var durationDay = durationHour * 24;
	var durationWeek = durationDay * 7;
	var durationMonth = durationDay * 30;
	var durationYear = durationDay * 365;
	
	function date(t) {
	  return new Date(t);
	}
	
	function number$1(t) {
	  return t instanceof Date ? +t : +new Date(+t);
	}
	
	function calendar(year, month, week, day, hour, minute, second, millisecond, format$$1) {
	  var scale = continuous(deinterpolateLinear, d3Interpolate.interpolateNumber),
	      invert = scale.invert,
	      domain = scale.domain;
	
	  var formatMillisecond = format$$1(".%L"),
	      formatSecond = format$$1(":%S"),
	      formatMinute = format$$1("%I:%M"),
	      formatHour = format$$1("%I %p"),
	      formatDay = format$$1("%a %d"),
	      formatWeek = format$$1("%b %d"),
	      formatMonth = format$$1("%B"),
	      formatYear = format$$1("%Y");
	
	  var tickIntervals = [
	    [second,  1,      durationSecond],
	    [second,  5,  5 * durationSecond],
	    [second, 15, 15 * durationSecond],
	    [second, 30, 30 * durationSecond],
	    [minute,  1,      durationMinute],
	    [minute,  5,  5 * durationMinute],
	    [minute, 15, 15 * durationMinute],
	    [minute, 30, 30 * durationMinute],
	    [  hour,  1,      durationHour  ],
	    [  hour,  3,  3 * durationHour  ],
	    [  hour,  6,  6 * durationHour  ],
	    [  hour, 12, 12 * durationHour  ],
	    [   day,  1,      durationDay   ],
	    [   day,  2,  2 * durationDay   ],
	    [  week,  1,      durationWeek  ],
	    [ month,  1,      durationMonth ],
	    [ month,  3,  3 * durationMonth ],
	    [  year,  1,      durationYear  ]
	  ];
	
	  function tickFormat(date) {
	    return (second(date) < date ? formatMillisecond
	        : minute(date) < date ? formatSecond
	        : hour(date) < date ? formatMinute
	        : day(date) < date ? formatHour
	        : month(date) < date ? (week(date) < date ? formatDay : formatWeek)
	        : year(date) < date ? formatMonth
	        : formatYear)(date);
	  }
	
	  function tickInterval(interval, start, stop, step) {
	    if (interval == null) interval = 10;
	
	    // If a desired tick count is specified, pick a reasonable tick interval
	    // based on the extent of the domain and a rough estimate of tick size.
	    // Otherwise, assume interval is already a time interval and use it.
	    if (typeof interval === "number") {
	      var target = Math.abs(stop - start) / interval,
	          i = d3Array.bisector(function(i) { return i[2]; }).right(tickIntervals, target);
	      if (i === tickIntervals.length) {
	        step = d3Array.tickStep(start / durationYear, stop / durationYear, interval);
	        interval = year;
	      } else if (i) {
	        i = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
	        step = i[1];
	        interval = i[0];
	      } else {
	        step = Math.max(d3Array.tickStep(start, stop, interval), 1);
	        interval = millisecond;
	      }
	    }
	
	    return step == null ? interval : interval.every(step);
	  }
	
	  scale.invert = function(y) {
	    return new Date(invert(y));
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? domain(map$1.call(_, number$1)) : domain().map(date);
	  };
	
	  scale.ticks = function(interval, step) {
	    var d = domain(),
	        t0 = d[0],
	        t1 = d[d.length - 1],
	        r = t1 < t0,
	        t;
	    if (r) t = t0, t0 = t1, t1 = t;
	    t = tickInterval(interval, t0, t1, step);
	    t = t ? t.range(t0, t1 + 1) : []; // inclusive stop
	    return r ? t.reverse() : t;
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    return specifier == null ? tickFormat : format$$1(specifier);
	  };
	
	  scale.nice = function(interval, step) {
	    var d = domain();
	    return (interval = tickInterval(interval, d[0], d[d.length - 1], step))
	        ? domain(nice(d, interval))
	        : scale;
	  };
	
	  scale.copy = function() {
	    return copy(scale, calendar(year, month, week, day, hour, minute, second, millisecond, format$$1));
	  };
	
	  return scale;
	}
	
	function time() {
	  return calendar(d3Time.timeYear, d3Time.timeMonth, d3Time.timeWeek, d3Time.timeDay, d3Time.timeHour, d3Time.timeMinute, d3Time.timeSecond, d3Time.timeMillisecond, d3TimeFormat.timeFormat).domain([new Date(2000, 0, 1), new Date(2000, 0, 2)]);
	}
	
	function utcTime() {
	  return calendar(d3Time.utcYear, d3Time.utcMonth, d3Time.utcWeek, d3Time.utcDay, d3Time.utcHour, d3Time.utcMinute, d3Time.utcSecond, d3Time.utcMillisecond, d3TimeFormat.utcFormat).domain([Date.UTC(2000, 0, 1), Date.UTC(2000, 0, 2)]);
	}
	
	function sequential(interpolator) {
	  var x0 = 0,
	      x1 = 1,
	      clamp = false;
	
	  function scale(x) {
	    var t = (x - x0) / (x1 - x0);
	    return interpolator(clamp ? Math.max(0, Math.min(1, t)) : t);
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (x0 = +_[0], x1 = +_[1], scale) : [x0, x1];
	  };
	
	  scale.clamp = function(_) {
	    return arguments.length ? (clamp = !!_, scale) : clamp;
	  };
	
	  scale.interpolator = function(_) {
	    return arguments.length ? (interpolator = _, scale) : interpolator;
	  };
	
	  scale.copy = function() {
	    return sequential(interpolator).domain([x0, x1]).clamp(clamp);
	  };
	
	  return linearish(scale);
	}
	
	exports.scaleBand = band;
	exports.scalePoint = point;
	exports.scaleIdentity = identity;
	exports.scaleLinear = linear;
	exports.scaleLog = log;
	exports.scaleOrdinal = ordinal;
	exports.scaleImplicit = implicit;
	exports.scalePow = pow;
	exports.scaleSqrt = sqrt;
	exports.scaleQuantile = quantile$1;
	exports.scaleQuantize = quantize;
	exports.scaleThreshold = threshold;
	exports.scaleTime = time;
	exports.scaleUtc = utcTime;
	exports.scaleSequential = sequential;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-time-format/ Version 2.1.1. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(506)) :
		typeof define === 'function' && define.amd ? define(['exports', 'd3-time'], factory) :
		(factory((global.d3 = global.d3 || {}),global.d3));
	}(this, (function (exports,d3Time) { 'use strict';
	
	function localDate(d) {
	  if (0 <= d.y && d.y < 100) {
	    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
	    date.setFullYear(d.y);
	    return date;
	  }
	  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
	}
	
	function utcDate(d) {
	  if (0 <= d.y && d.y < 100) {
	    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
	    date.setUTCFullYear(d.y);
	    return date;
	  }
	  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
	}
	
	function newYear(y) {
	  return {y: y, m: 0, d: 1, H: 0, M: 0, S: 0, L: 0};
	}
	
	function formatLocale(locale) {
	  var locale_dateTime = locale.dateTime,
	      locale_date = locale.date,
	      locale_time = locale.time,
	      locale_periods = locale.periods,
	      locale_weekdays = locale.days,
	      locale_shortWeekdays = locale.shortDays,
	      locale_months = locale.months,
	      locale_shortMonths = locale.shortMonths;
	
	  var periodRe = formatRe(locale_periods),
	      periodLookup = formatLookup(locale_periods),
	      weekdayRe = formatRe(locale_weekdays),
	      weekdayLookup = formatLookup(locale_weekdays),
	      shortWeekdayRe = formatRe(locale_shortWeekdays),
	      shortWeekdayLookup = formatLookup(locale_shortWeekdays),
	      monthRe = formatRe(locale_months),
	      monthLookup = formatLookup(locale_months),
	      shortMonthRe = formatRe(locale_shortMonths),
	      shortMonthLookup = formatLookup(locale_shortMonths);
	
	  var formats = {
	    "a": formatShortWeekday,
	    "A": formatWeekday,
	    "b": formatShortMonth,
	    "B": formatMonth,
	    "c": null,
	    "d": formatDayOfMonth,
	    "e": formatDayOfMonth,
	    "f": formatMicroseconds,
	    "H": formatHour24,
	    "I": formatHour12,
	    "j": formatDayOfYear,
	    "L": formatMilliseconds,
	    "m": formatMonthNumber,
	    "M": formatMinutes,
	    "p": formatPeriod,
	    "Q": formatUnixTimestamp,
	    "s": formatUnixTimestampSeconds,
	    "S": formatSeconds,
	    "u": formatWeekdayNumberMonday,
	    "U": formatWeekNumberSunday,
	    "V": formatWeekNumberISO,
	    "w": formatWeekdayNumberSunday,
	    "W": formatWeekNumberMonday,
	    "x": null,
	    "X": null,
	    "y": formatYear,
	    "Y": formatFullYear,
	    "Z": formatZone,
	    "%": formatLiteralPercent
	  };
	
	  var utcFormats = {
	    "a": formatUTCShortWeekday,
	    "A": formatUTCWeekday,
	    "b": formatUTCShortMonth,
	    "B": formatUTCMonth,
	    "c": null,
	    "d": formatUTCDayOfMonth,
	    "e": formatUTCDayOfMonth,
	    "f": formatUTCMicroseconds,
	    "H": formatUTCHour24,
	    "I": formatUTCHour12,
	    "j": formatUTCDayOfYear,
	    "L": formatUTCMilliseconds,
	    "m": formatUTCMonthNumber,
	    "M": formatUTCMinutes,
	    "p": formatUTCPeriod,
	    "Q": formatUnixTimestamp,
	    "s": formatUnixTimestampSeconds,
	    "S": formatUTCSeconds,
	    "u": formatUTCWeekdayNumberMonday,
	    "U": formatUTCWeekNumberSunday,
	    "V": formatUTCWeekNumberISO,
	    "w": formatUTCWeekdayNumberSunday,
	    "W": formatUTCWeekNumberMonday,
	    "x": null,
	    "X": null,
	    "y": formatUTCYear,
	    "Y": formatUTCFullYear,
	    "Z": formatUTCZone,
	    "%": formatLiteralPercent
	  };
	
	  var parses = {
	    "a": parseShortWeekday,
	    "A": parseWeekday,
	    "b": parseShortMonth,
	    "B": parseMonth,
	    "c": parseLocaleDateTime,
	    "d": parseDayOfMonth,
	    "e": parseDayOfMonth,
	    "f": parseMicroseconds,
	    "H": parseHour24,
	    "I": parseHour24,
	    "j": parseDayOfYear,
	    "L": parseMilliseconds,
	    "m": parseMonthNumber,
	    "M": parseMinutes,
	    "p": parsePeriod,
	    "Q": parseUnixTimestamp,
	    "s": parseUnixTimestampSeconds,
	    "S": parseSeconds,
	    "u": parseWeekdayNumberMonday,
	    "U": parseWeekNumberSunday,
	    "V": parseWeekNumberISO,
	    "w": parseWeekdayNumberSunday,
	    "W": parseWeekNumberMonday,
	    "x": parseLocaleDate,
	    "X": parseLocaleTime,
	    "y": parseYear,
	    "Y": parseFullYear,
	    "Z": parseZone,
	    "%": parseLiteralPercent
	  };
	
	  // These recursive directive definitions must be deferred.
	  formats.x = newFormat(locale_date, formats);
	  formats.X = newFormat(locale_time, formats);
	  formats.c = newFormat(locale_dateTime, formats);
	  utcFormats.x = newFormat(locale_date, utcFormats);
	  utcFormats.X = newFormat(locale_time, utcFormats);
	  utcFormats.c = newFormat(locale_dateTime, utcFormats);
	
	  function newFormat(specifier, formats) {
	    return function(date) {
	      var string = [],
	          i = -1,
	          j = 0,
	          n = specifier.length,
	          c,
	          pad,
	          format;
	
	      if (!(date instanceof Date)) date = new Date(+date);
	
	      while (++i < n) {
	        if (specifier.charCodeAt(i) === 37) {
	          string.push(specifier.slice(j, i));
	          if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
	          else pad = c === "e" ? " " : "0";
	          if (format = formats[c]) c = format(date, pad);
	          string.push(c);
	          j = i + 1;
	        }
	      }
	
	      string.push(specifier.slice(j, i));
	      return string.join("");
	    };
	  }
	
	  function newParse(specifier, newDate) {
	    return function(string) {
	      var d = newYear(1900),
	          i = parseSpecifier(d, specifier, string += "", 0),
	          week, day;
	      if (i != string.length) return null;
	
	      // If a UNIX timestamp is specified, return it.
	      if ("Q" in d) return new Date(d.Q);
	
	      // The am-pm flag is 0 for AM, and 1 for PM.
	      if ("p" in d) d.H = d.H % 12 + d.p * 12;
	
	      // Convert day-of-week and week-of-year to day-of-year.
	      if ("V" in d) {
	        if (d.V < 1 || d.V > 53) return null;
	        if (!("w" in d)) d.w = 1;
	        if ("Z" in d) {
	          week = utcDate(newYear(d.y)), day = week.getUTCDay();
	          week = day > 4 || day === 0 ? d3Time.utcMonday.ceil(week) : d3Time.utcMonday(week);
	          week = d3Time.utcDay.offset(week, (d.V - 1) * 7);
	          d.y = week.getUTCFullYear();
	          d.m = week.getUTCMonth();
	          d.d = week.getUTCDate() + (d.w + 6) % 7;
	        } else {
	          week = newDate(newYear(d.y)), day = week.getDay();
	          week = day > 4 || day === 0 ? d3Time.timeMonday.ceil(week) : d3Time.timeMonday(week);
	          week = d3Time.timeDay.offset(week, (d.V - 1) * 7);
	          d.y = week.getFullYear();
	          d.m = week.getMonth();
	          d.d = week.getDate() + (d.w + 6) % 7;
	        }
	      } else if ("W" in d || "U" in d) {
	        if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
	        day = "Z" in d ? utcDate(newYear(d.y)).getUTCDay() : newDate(newYear(d.y)).getDay();
	        d.m = 0;
	        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
	      }
	
	      // If a time zone is specified, all fields are interpreted as UTC and then
	      // offset according to the specified time zone.
	      if ("Z" in d) {
	        d.H += d.Z / 100 | 0;
	        d.M += d.Z % 100;
	        return utcDate(d);
	      }
	
	      // Otherwise, all fields are in local time.
	      return newDate(d);
	    };
	  }
	
	  function parseSpecifier(d, specifier, string, j) {
	    var i = 0,
	        n = specifier.length,
	        m = string.length,
	        c,
	        parse;
	
	    while (i < n) {
	      if (j >= m) return -1;
	      c = specifier.charCodeAt(i++);
	      if (c === 37) {
	        c = specifier.charAt(i++);
	        parse = parses[c in pads ? specifier.charAt(i++) : c];
	        if (!parse || ((j = parse(d, string, j)) < 0)) return -1;
	      } else if (c != string.charCodeAt(j++)) {
	        return -1;
	      }
	    }
	
	    return j;
	  }
	
	  function parsePeriod(d, string, i) {
	    var n = periodRe.exec(string.slice(i));
	    return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseShortWeekday(d, string, i) {
	    var n = shortWeekdayRe.exec(string.slice(i));
	    return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseWeekday(d, string, i) {
	    var n = weekdayRe.exec(string.slice(i));
	    return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseShortMonth(d, string, i) {
	    var n = shortMonthRe.exec(string.slice(i));
	    return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseMonth(d, string, i) {
	    var n = monthRe.exec(string.slice(i));
	    return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseLocaleDateTime(d, string, i) {
	    return parseSpecifier(d, locale_dateTime, string, i);
	  }
	
	  function parseLocaleDate(d, string, i) {
	    return parseSpecifier(d, locale_date, string, i);
	  }
	
	  function parseLocaleTime(d, string, i) {
	    return parseSpecifier(d, locale_time, string, i);
	  }
	
	  function formatShortWeekday(d) {
	    return locale_shortWeekdays[d.getDay()];
	  }
	
	  function formatWeekday(d) {
	    return locale_weekdays[d.getDay()];
	  }
	
	  function formatShortMonth(d) {
	    return locale_shortMonths[d.getMonth()];
	  }
	
	  function formatMonth(d) {
	    return locale_months[d.getMonth()];
	  }
	
	  function formatPeriod(d) {
	    return locale_periods[+(d.getHours() >= 12)];
	  }
	
	  function formatUTCShortWeekday(d) {
	    return locale_shortWeekdays[d.getUTCDay()];
	  }
	
	  function formatUTCWeekday(d) {
	    return locale_weekdays[d.getUTCDay()];
	  }
	
	  function formatUTCShortMonth(d) {
	    return locale_shortMonths[d.getUTCMonth()];
	  }
	
	  function formatUTCMonth(d) {
	    return locale_months[d.getUTCMonth()];
	  }
	
	  function formatUTCPeriod(d) {
	    return locale_periods[+(d.getUTCHours() >= 12)];
	  }
	
	  return {
	    format: function(specifier) {
	      var f = newFormat(specifier += "", formats);
	      f.toString = function() { return specifier; };
	      return f;
	    },
	    parse: function(specifier) {
	      var p = newParse(specifier += "", localDate);
	      p.toString = function() { return specifier; };
	      return p;
	    },
	    utcFormat: function(specifier) {
	      var f = newFormat(specifier += "", utcFormats);
	      f.toString = function() { return specifier; };
	      return f;
	    },
	    utcParse: function(specifier) {
	      var p = newParse(specifier, utcDate);
	      p.toString = function() { return specifier; };
	      return p;
	    }
	  };
	}
	
	var pads = {"-": "", "_": " ", "0": "0"};
	var numberRe = /^\s*\d+/;
	var percentRe = /^%/;
	var requoteRe = /[\\^$*+?|[\]().{}]/g;
	
	function pad(value, fill, width) {
	  var sign = value < 0 ? "-" : "",
	      string = (sign ? -value : value) + "",
	      length = string.length;
	  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
	}
	
	function requote(s) {
	  return s.replace(requoteRe, "\\$&");
	}
	
	function formatRe(names) {
	  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
	}
	
	function formatLookup(names) {
	  var map = {}, i = -1, n = names.length;
	  while (++i < n) map[names[i].toLowerCase()] = i;
	  return map;
	}
	
	function parseWeekdayNumberSunday(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 1));
	  return n ? (d.w = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekdayNumberMonday(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 1));
	  return n ? (d.u = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberSunday(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.U = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberISO(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.V = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberMonday(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.W = +n[0], i + n[0].length) : -1;
	}
	
	function parseFullYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 4));
	  return n ? (d.y = +n[0], i + n[0].length) : -1;
	}
	
	function parseYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
	}
	
	function parseZone(d, string, i) {
	  var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
	  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
	}
	
	function parseMonthNumber(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
	}
	
	function parseDayOfMonth(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.d = +n[0], i + n[0].length) : -1;
	}
	
	function parseDayOfYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 3));
	  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
	}
	
	function parseHour24(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.H = +n[0], i + n[0].length) : -1;
	}
	
	function parseMinutes(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.M = +n[0], i + n[0].length) : -1;
	}
	
	function parseSeconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.S = +n[0], i + n[0].length) : -1;
	}
	
	function parseMilliseconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 3));
	  return n ? (d.L = +n[0], i + n[0].length) : -1;
	}
	
	function parseMicroseconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 6));
	  return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
	}
	
	function parseLiteralPercent(d, string, i) {
	  var n = percentRe.exec(string.slice(i, i + 1));
	  return n ? i + n[0].length : -1;
	}
	
	function parseUnixTimestamp(d, string, i) {
	  var n = numberRe.exec(string.slice(i));
	  return n ? (d.Q = +n[0], i + n[0].length) : -1;
	}
	
	function parseUnixTimestampSeconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i));
	  return n ? (d.Q = (+n[0]) * 1000, i + n[0].length) : -1;
	}
	
	function formatDayOfMonth(d, p) {
	  return pad(d.getDate(), p, 2);
	}
	
	function formatHour24(d, p) {
	  return pad(d.getHours(), p, 2);
	}
	
	function formatHour12(d, p) {
	  return pad(d.getHours() % 12 || 12, p, 2);
	}
	
	function formatDayOfYear(d, p) {
	  return pad(1 + d3Time.timeDay.count(d3Time.timeYear(d), d), p, 3);
	}
	
	function formatMilliseconds(d, p) {
	  return pad(d.getMilliseconds(), p, 3);
	}
	
	function formatMicroseconds(d, p) {
	  return formatMilliseconds(d, p) + "000";
	}
	
	function formatMonthNumber(d, p) {
	  return pad(d.getMonth() + 1, p, 2);
	}
	
	function formatMinutes(d, p) {
	  return pad(d.getMinutes(), p, 2);
	}
	
	function formatSeconds(d, p) {
	  return pad(d.getSeconds(), p, 2);
	}
	
	function formatWeekdayNumberMonday(d) {
	  var day = d.getDay();
	  return day === 0 ? 7 : day;
	}
	
	function formatWeekNumberSunday(d, p) {
	  return pad(d3Time.timeSunday.count(d3Time.timeYear(d), d), p, 2);
	}
	
	function formatWeekNumberISO(d, p) {
	  var day = d.getDay();
	  d = (day >= 4 || day === 0) ? d3Time.timeThursday(d) : d3Time.timeThursday.ceil(d);
	  return pad(d3Time.timeThursday.count(d3Time.timeYear(d), d) + (d3Time.timeYear(d).getDay() === 4), p, 2);
	}
	
	function formatWeekdayNumberSunday(d) {
	  return d.getDay();
	}
	
	function formatWeekNumberMonday(d, p) {
	  return pad(d3Time.timeMonday.count(d3Time.timeYear(d), d), p, 2);
	}
	
	function formatYear(d, p) {
	  return pad(d.getFullYear() % 100, p, 2);
	}
	
	function formatFullYear(d, p) {
	  return pad(d.getFullYear() % 10000, p, 4);
	}
	
	function formatZone(d) {
	  var z = d.getTimezoneOffset();
	  return (z > 0 ? "-" : (z *= -1, "+"))
	      + pad(z / 60 | 0, "0", 2)
	      + pad(z % 60, "0", 2);
	}
	
	function formatUTCDayOfMonth(d, p) {
	  return pad(d.getUTCDate(), p, 2);
	}
	
	function formatUTCHour24(d, p) {
	  return pad(d.getUTCHours(), p, 2);
	}
	
	function formatUTCHour12(d, p) {
	  return pad(d.getUTCHours() % 12 || 12, p, 2);
	}
	
	function formatUTCDayOfYear(d, p) {
	  return pad(1 + d3Time.utcDay.count(d3Time.utcYear(d), d), p, 3);
	}
	
	function formatUTCMilliseconds(d, p) {
	  return pad(d.getUTCMilliseconds(), p, 3);
	}
	
	function formatUTCMicroseconds(d, p) {
	  return formatUTCMilliseconds(d, p) + "000";
	}
	
	function formatUTCMonthNumber(d, p) {
	  return pad(d.getUTCMonth() + 1, p, 2);
	}
	
	function formatUTCMinutes(d, p) {
	  return pad(d.getUTCMinutes(), p, 2);
	}
	
	function formatUTCSeconds(d, p) {
	  return pad(d.getUTCSeconds(), p, 2);
	}
	
	function formatUTCWeekdayNumberMonday(d) {
	  var dow = d.getUTCDay();
	  return dow === 0 ? 7 : dow;
	}
	
	function formatUTCWeekNumberSunday(d, p) {
	  return pad(d3Time.utcSunday.count(d3Time.utcYear(d), d), p, 2);
	}
	
	function formatUTCWeekNumberISO(d, p) {
	  var day = d.getUTCDay();
	  d = (day >= 4 || day === 0) ? d3Time.utcThursday(d) : d3Time.utcThursday.ceil(d);
	  return pad(d3Time.utcThursday.count(d3Time.utcYear(d), d) + (d3Time.utcYear(d).getUTCDay() === 4), p, 2);
	}
	
	function formatUTCWeekdayNumberSunday(d) {
	  return d.getUTCDay();
	}
	
	function formatUTCWeekNumberMonday(d, p) {
	  return pad(d3Time.utcMonday.count(d3Time.utcYear(d), d), p, 2);
	}
	
	function formatUTCYear(d, p) {
	  return pad(d.getUTCFullYear() % 100, p, 2);
	}
	
	function formatUTCFullYear(d, p) {
	  return pad(d.getUTCFullYear() % 10000, p, 4);
	}
	
	function formatUTCZone() {
	  return "+0000";
	}
	
	function formatLiteralPercent() {
	  return "%";
	}
	
	function formatUnixTimestamp(d) {
	  return +d;
	}
	
	function formatUnixTimestampSeconds(d) {
	  return Math.floor(+d / 1000);
	}
	
	var locale;
	
	
	
	
	
	defaultLocale({
	  dateTime: "%x, %X",
	  date: "%-m/%-d/%Y",
	  time: "%-I:%M:%S %p",
	  periods: ["AM", "PM"],
	  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
	  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
	  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
	  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
	});
	
	function defaultLocale(definition) {
	  locale = formatLocale(definition);
	  exports.timeFormat = locale.format;
	  exports.timeParse = locale.parse;
	  exports.utcFormat = locale.utcFormat;
	  exports.utcParse = locale.utcParse;
	  return locale;
	}
	
	var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";
	
	function formatIsoNative(date) {
	  return date.toISOString();
	}
	
	var formatIso = Date.prototype.toISOString
	    ? formatIsoNative
	    : exports.utcFormat(isoSpecifier);
	
	function parseIsoNative(string) {
	  var date = new Date(string);
	  return isNaN(date) ? null : date;
	}
	
	var parseIso = +new Date("2000-01-01T00:00:00.000Z")
	    ? parseIsoNative
	    : exports.utcParse(isoSpecifier);
	
	exports.timeFormatDefaultLocale = defaultLocale;
	exports.timeFormatLocale = formatLocale;
	exports.isoFormat = formatIso;
	exports.isoParse = parseIso;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */
/***/ (function(module, exports) {

	module.exports = [{"county":"Montana","value":"17%","lci":"","uci":""},{"county":"Beaverhead County","value":"20%","lci":"","uci":""},{"county":"Big Horn County","value":"15%","lci":"","uci":""},{"county":"Blaine County","value":"48%","lci":"","uci":""},{"county":"Broadwater County","value":"21%","lci":"","uci":""},{"county":"Carbon County","value":"16%","lci":"","uci":""},{"county":"Carter County","value":"","lci":"","uci":""},{"county":"Cascade County","value":"20%","lci":"","uci":""},{"county":"Chouteau County","value":"53%","lci":"","uci":""},{"county":"Custer County","value":"34%","lci":"","uci":""},{"county":"Daniels County","value":"41%","lci":"","uci":""},{"county":"Dawson County","value":"36%","lci":"","uci":""},{"county":"Deer Lodge County","value":"43%","lci":"","uci":""},{"county":"Fallon County","value":"34%","lci":"","uci":""},{"county":"Fergus County","value":"16%","lci":"","uci":""},{"county":"Flathead County","value":"14%","lci":"","uci":""},{"county":"Gallatin County","value":"6%","lci":"","uci":""},{"county":"Garfield County","value":"53%","lci":"","uci":""},{"county":"Glacier County","value":"49%","lci":"","uci":""},{"county":"Golden Valley County","value":"38%","lci":"","uci":""},{"county":"Granite County","value":"30%","lci":"","uci":""},{"county":"Hill County","value":"44%","lci":"","uci":""},{"county":"Jefferson County","value":"26%","lci":"","uci":""},{"county":"Judith Basin County","value":"59%","lci":"","uci":""},{"county":"Lake County","value":"28%","lci":"","uci":""},{"county":"Lewis and Clark County","value":"14%","lci":"","uci":""},{"county":"Liberty County","value":"28%","lci":"","uci":""},{"county":"Lincoln County","value":"25%","lci":"","uci":""},{"county":"McCone County","value":"37%","lci":"","uci":""},{"county":"Madison County","value":"21%","lci":"","uci":""},{"county":"Meagher County","value":"20%","lci":"","uci":""},{"county":"Mineral County","value":"43%","lci":"","uci":""},{"county":"Missoula County","value":"6%","lci":"","uci":""},{"county":"Musselshell County","value":"7%","lci":"","uci":""},{"county":"Park County","value":"7%","lci":"","uci":""},{"county":"Petroleum County","value":"","lci":"","uci":""},{"county":"Phillips County","value":"59%","lci":"","uci":""},{"county":"Pondera County","value":"46%","lci":"","uci":""},{"county":"Powder River County","value":"43%","lci":"","uci":""},{"county":"Powell County","value":"39%","lci":"","uci":""},{"county":"Prairie County","value":"44%","lci":"","uci":""},{"county":"Ravalli County","value":"15%","lci":"","uci":""},{"county":"Richland County","value":"14%","lci":"","uci":""},{"county":"Roosevelt County","value":"63%","lci":"","uci":""},{"county":"Rosebud County","value":"41%","lci":"","uci":""},{"county":"Sanders County","value":"33%","lci":"","uci":""},{"county":"Sheridan County","value":"35%","lci":"","uci":""},{"county":"Silver Bow County","value":"19%","lci":"","uci":""},{"county":"Stillwater County","value":"26%","lci":"","uci":""},{"county":"Sweet Grass County","value":"23%","lci":"","uci":""},{"county":"Teton County","value":"28%","lci":"","uci":""},{"county":"Toole County","value":"36%","lci":"","uci":""},{"county":"Treasure County","value":"35%","lci":"","uci":""},{"county":"Valley County","value":"49%","lci":"","uci":""},{"county":"Wheatland County","value":"7%","lci":"","uci":""},{"county":"Wibaux County","value":"40%","lci":"","uci":""},{"county":"Yellowstone County","value":"11%","lci":"","uci":""}]

/***/ }),
/* 747 */
/***/ (function(module, exports) {

	module.exports = [{"county":"Montana","value":"469","lci":"","uci":""},{"county":"Beaverhead County","value":"420.75","lci":"","uci":""},{"county":"Big Horn County","value":"377.25","lci":"","uci":""},{"county":"Blaine County","value":"322.5","lci":"","uci":""},{"county":"Broadwater County","value":"386.25","lci":"","uci":""},{"county":"Carbon County","value":"507.75","lci":"","uci":""},{"county":"Carter County","value":"475.5","lci":"","uci":""},{"county":"Cascade County","value":"432","lci":"","uci":""},{"county":"Chouteau County","value":"401.25","lci":"","uci":""},{"county":"Custer County","value":"494.25","lci":"","uci":""},{"county":"Daniels County","value":"492","lci":"","uci":""},{"county":"Dawson County","value":"502.5","lci":"","uci":""},{"county":"Deer Lodge County","value":"425.25","lci":"","uci":""},{"county":"Fallon County","value":"521.25","lci":"","uci":""},{"county":"Fergus County","value":"434.25","lci":"","uci":""},{"county":"Flathead County","value":"445.5","lci":"","uci":""},{"county":"Gallatin County","value":"532.5","lci":"","uci":""},{"county":"Garfield County","value":"486.75","lci":"","uci":""},{"county":"Glacier County","value":"303","lci":"","uci":""},{"county":"Golden Valley County","value":"385.5","lci":"","uci":""},{"county":"Granite County","value":"448.5","lci":"","uci":""},{"county":"Hill County","value":"425.25","lci":"","uci":""},{"county":"Jefferson County","value":"579","lci":"","uci":""},{"county":"Judith Basin County","value":"450","lci":"","uci":""},{"county":"Lake County","value":"390","lci":"","uci":""},{"county":"Lewis and Clark County","value":"525.75","lci":"","uci":""},{"county":"Liberty County","value":"447","lci":"","uci":""},{"county":"Lincoln County","value":"359.25","lci":"","uci":""},{"county":"McCone County","value":"507.75","lci":"","uci":""},{"county":"Madison County","value":"465.75","lci":"","uci":""},{"county":"Meagher County","value":"348","lci":"","uci":""},{"county":"Mineral County","value":"386.25","lci":"","uci":""},{"county":"Missoula County","value":"534","lci":"","uci":""},{"county":"Musselshell County","value":"457.5","lci":"","uci":""},{"county":"Park County","value":"450","lci":"","uci":""},{"county":"Petroleum County","value":"380.25","lci":"","uci":""},{"county":"Phillips County","value":"411","lci":"","uci":""},{"county":"Pondera County","value":"424.5","lci":"","uci":""},{"county":"Powder River County","value":"424.5","lci":"","uci":""},{"county":"Powell County","value":"395.25","lci":"","uci":""},{"county":"Prairie County","value":"356.25","lci":"","uci":""},{"county":"Ravalli County","value":"406.5","lci":"","uci":""},{"county":"Richland County","value":"544.5","lci":"","uci":""},{"county":"Roosevelt County","value":"375.75","lci":"","uci":""},{"county":"Rosebud County","value":"475.5","lci":"","uci":""},{"county":"Sanders County","value":"283.5","lci":"","uci":""},{"county":"Sheridan County","value":"530.25","lci":"","uci":""},{"county":"Silver Bow County","value":"402.75","lci":"","uci":""},{"county":"Stillwater County","value":"558","lci":"","uci":""},{"county":"Sweet Grass County","value":"494.25","lci":"","uci":""},{"county":"Teton County","value":"451.5","lci":"","uci":""},{"county":"Toole County","value":"441","lci":"","uci":""},{"county":"Treasure County","value":"361.5","lci":"","uci":""},{"county":"Valley County","value":"449.25","lci":"","uci":""},{"county":"Wheatland County","value":"316.5","lci":"","uci":""},{"county":"Wibaux County","value":"441.75","lci":"","uci":""},{"county":"Yellowstone County","value":"507.75","lci":"","uci":""}]

/***/ }),
/* 748 */
/***/ (function(module, exports) {

	module.exports = [{"county":"Montana","value":"775","lci":"","uci":""},{"county":"Beaverhead County","value":"681","lci":"","uci":""},{"county":"Big Horn County","value":"694","lci":"","uci":""},{"county":"Blaine County","value":"681","lci":"","uci":""},{"county":"Broadwater County","value":"750","lci":"","uci":""},{"county":"Carbon County","value":"859","lci":"","uci":""},{"county":"Carter County","value":"681","lci":"","uci":""},{"county":"Cascade County","value":"720","lci":"","uci":""},{"county":"Chouteau County","value":"681","lci":"","uci":""},{"county":"Custer County","value":"681","lci":"","uci":""},{"county":"Daniels County","value":"681","lci":"","uci":""},{"county":"Dawson County","value":"681","lci":"","uci":""},{"county":"Deer Lodge County","value":"681","lci":"","uci":""},{"county":"Fallon County","value":"681","lci":"","uci":""},{"county":"Fergus County","value":"744","lci":"","uci":""},{"county":"Flathead County","value":"747","lci":"","uci":""},{"county":"Gallatin County","value":"848","lci":"","uci":""},{"county":"Garfield County","value":"681","lci":"","uci":""},{"county":"Glacier County","value":"681","lci":"","uci":""},{"county":"Golden Valley County","value":"681","lci":"","uci":""},{"county":"Granite County","value":"691","lci":"","uci":""},{"county":"Hill County","value":"681","lci":"","uci":""},{"county":"Jefferson County","value":"843","lci":"","uci":""},{"county":"Judith Basin County","value":"681","lci":"","uci":""},{"county":"Lake County","value":"695","lci":"","uci":""},{"county":"Lewis and Clark County","value":"763","lci":"","uci":""},{"county":"Liberty County","value":"681","lci":"","uci":""},{"county":"Lincoln County","value":"681","lci":"","uci":""},{"county":"McCone County","value":"681","lci":"","uci":""},{"county":"Madison County","value":"750","lci":"","uci":""},{"county":"Meagher County","value":"701","lci":"","uci":""},{"county":"Mineral County","value":"681","lci":"","uci":""},{"county":"Missoula County","value":"855","lci":"","uci":""},{"county":"Musselshell County","value":"681","lci":"","uci":""},{"county":"Park County","value":"853","lci":"","uci":""},{"county":"Petroleum County","value":"734","lci":"","uci":""},{"county":"Phillips County","value":"681","lci":"","uci":""},{"county":"Pondera County","value":"681","lci":"","uci":""},{"county":"Powder River County","value":"681","lci":"","uci":""},{"county":"Powell County","value":"681","lci":"","uci":""},{"county":"Prairie County","value":"681","lci":"","uci":""},{"county":"Ravalli County","value":"721","lci":"","uci":""},{"county":"Richland County","value":"766","lci":"","uci":""},{"county":"Roosevelt County","value":"681","lci":"","uci":""},{"county":"Rosebud County","value":"681","lci":"","uci":""},{"county":"Sanders County","value":"681","lci":"","uci":""},{"county":"Sheridan County","value":"681","lci":"","uci":""},{"county":"Silver Bow County","value":"715","lci":"","uci":""},{"county":"Stillwater County","value":"681","lci":"","uci":""},{"county":"Sweet Grass County","value":"725","lci":"","uci":""},{"county":"Teton County","value":"684","lci":"","uci":""},{"county":"Toole County","value":"681","lci":"","uci":""},{"county":"Treasure County","value":"734","lci":"","uci":""},{"county":"Valley County","value":"681","lci":"","uci":""},{"county":"Wheatland County","value":"681","lci":"","uci":""},{"county":"Wibaux County","value":"747","lci":"","uci":""},{"county":"Yellowstone County","value":"859","lci":"","uci":""}]

/***/ }),
/* 749 */
/***/ (function(module, exports) {

	module.exports = [{"county":"Montana","value":"73.90%","lci":"72.90%","uci":"74.80%"},{"county":"Beaverhead County","value":"91.89%","lci":"85.42%","uci":"98.35%"},{"county":"Big Horn County","value":"86.75%","lci":"71.77%","uci":"100.00%"},{"county":"Blaine County","value":"65.77%","lci":"53.93%","uci":"77.61%"},{"county":"Broadwater County","value":"80.60%","lci":"75.30%","uci":"85.80%"},{"county":"Carbon County","value":"95.13%","lci":"83.14%","uci":"100.00%"},{"county":"Carter County","value":"78.60%","lci":"69.80%","uci":"87.40%"},{"county":"Cascade County","value":"82.92%","lci":"80.53%","uci":"85.31%"},{"county":"Chouteau County","value":"62.43%","lci":"50.12%","uci":"74.74%"},{"county":"Custer County","value":"86.01%","lci":"77.08%","uci":"94.93%"},{"county":"Daniels County","value":"77.00%","lci":"67.50%","uci":"86.40%"},{"county":"Dawson County","value":"89.34%","lci":"71.73%","uci":"100.00%"},{"county":"Deer Lodge County","value":"71.10%","lci":"60.40%","uci":"81.90%"},{"county":"Fallon County","value":"78.60%","lci":"69.80%","uci":"87.40%"},{"county":"Fergus County","value":"80.60%","lci":"75.30%","uci":"85.80%"},{"county":"Flathead County","value":"85.51%","lci":"82.04%","uci":"88.99%"},{"county":"Gallatin County","value":"88.14%","lci":"84.09%","uci":"92.19%"},{"county":"Garfield County","value":"78.60%","lci":"69.80%","uci":"87.40%"},{"county":"Glacier County","value":"75.78%","lci":"66.85%","uci":"84.71%"},{"county":"Golden Valley County","value":"78.60%","lci":"69.80%","uci":"87.40%"},{"county":"Granite County","value":"71.10%","lci":"60.40%","uci":"81.90%"},{"county":"Hill County","value":"87.81%","lci":"75.36%","uci":"100.00%"},{"county":"Jefferson County","value":"80.60%","lci":"75.30%","uci":"85.80%"},{"county":"Judith Basin County","value":"80.60%","lci":"75.30%","uci":"85.80%"},{"county":"Lake County","value":"72.89%","lci":"64.09%","uci":"81.68%"},{"county":"Lewis and Clark County","value":"82.51%","lci":"75.65%","uci":"89.37%"},{"county":"Liberty County","value":"77.70%","lci":"67.20%","uci":"88.30%"},{"county":"Lincoln County","value":"75.67%","lci":"69.20%","uci":"82.14%"},{"county":"McCone County","value":"77.00%","lci":"67.50%","uci":"86.40%"},{"county":"Madison County","value":"80.60%","lci":"75.30%","uci":"85.80%"},{"county":"Meagher County","value":"80.60%","lci":"75.30%","uci":"85.80%"},{"county":"Mineral County","value":"90.50%","lci":"79.85%","uci":"100.00%"},{"county":"Missoula County","value":"92.82%","lci":"89.37%","uci":"96.27%"},{"county":"Musselshell County","value":"81.97%","lci":"65.48%","uci":"98.45%"},{"county":"Park County","value":"90.02%","lci":"77.13%","uci":"100.00%"},{"county":"Petroleum County","value":"78.60%","lci":"69.80%","uci":"87.40%"},{"county":"Phillips County","value":"77.00%","lci":"67.50%","uci":"86.40%"},{"county":"Pondera County","value":"77.70%","lci":"67.20%","uci":"88.30%"},{"county":"Powder River County","value":"78.60%","lci":"69.80%","uci":"87.40%"},{"county":"Powell County","value":"71.10%","lci":"60.40%","uci":"81.90%"},{"county":"Prairie County","value":"77.00%","lci":"67.50%","uci":"86.40%"},{"county":"Ravalli County","value":"83.23%","lci":"74.00%","uci":"92.45%"},{"county":"Richland County","value":"87.99%","lci":"75.37%","uci":"100.00%"},{"county":"Roosevelt County","value":"41.18%","lci":"32.71%","uci":"49.64%"},{"county":"Rosebud County","value":"76.15%","lci":"58.90%","uci":"93.41%"},{"county":"Sanders County","value":"82.18%","lci":"71.99%","uci":"92.38%"},{"county":"Sheridan County","value":"77.00%","lci":"67.50%","uci":"86.40%"},{"county":"Silver Bow County","value":"84.08%","lci":"78.30%","uci":"89.86%"},{"county":"Stillwater County","value":"78.60%","lci":"69.80%","uci":"87.40%"},{"county":"Sweet Grass County","value":"78.60%","lci":"69.80%","uci":"87.40%"},{"county":"Teton County","value":"84.32%","lci":"72.51%","uci":"96.14%"},{"county":"Toole County","value":"77.70%","lci":"67.20%","uci":"88.30%"},{"county":"Treasure County","value":"78.60%","lci":"69.80%","uci":"87.40%"},{"county":"Valley County","value":"61.46%","lci":"45.29%","uci":"77.64%"},{"county":"Wheatland County","value":"78.60%","lci":"69.80%","uci":"87.40%"},{"county":"Wibaux County","value":"77.00%","lci":"67.50%","uci":"86.40%"},{"county":"Yellowstone County","value":"86.59%","lci":"82.87%","uci":"90.31%"}]

/***/ }),
/* 750 */
/***/ (function(module, exports) {

	module.exports = [{"county":"Montana","value":"32.50%","lci":"31.60%","uci":"33.40%"},{"county":"Beaverhead County","value":"39.78%","lci":"30.22%","uci":"49.35%"},{"county":"Big Horn County","value":"28.33%","lci":"21.25%","uci":"35.40%"},{"county":"Blaine County","value":"35.10%","lci":"28.99%","uci":"41.20%"},{"county":"Broadwater County","value":"24.70%","lci":"19.30%","uci":"30.20%"},{"county":"Carbon County","value":"26.81%","lci":"18.99%","uci":"34.64%"},{"county":"Carter County","value":"21.70%","lci":"15.90%","uci":"27.50%"},{"county":"Cascade County","value":"33.25%","lci":"30.32%","uci":"36.18%"},{"county":"Chouteau County","value":"28.38%","lci":"23.47%","uci":"33.29%"},{"county":"Custer County","value":"31.15%","lci":"24.12%","uci":"38.18%"},{"county":"Daniels County","value":"33.50%","lci":"25.00%","uci":"42.00%"},{"county":"Dawson County","value":"27.80%","lci":"17.31%","uci":"38.28%"},{"county":"Deer Lodge County","value":"55.72%","lci":"44.26%","uci":"67.18%"},{"county":"Fallon County","value":"21.70%","lci":"15.90%","uci":"27.50%"},{"county":"Fergus County","value":"24.70%","lci":"15.08%","uci":"34.32%"},{"county":"Flathead County","value":"31.67%","lci":"28.07%","uci":"35.27%"},{"county":"Gallatin County","value":"26.41%","lci":"23.88%","uci":"28.94%"},{"county":"Garfield County","value":"24.70%","lci":"15.50%","uci":"34.00%"},{"county":"Glacier County","value":"41.50%","lci":"34.90%","uci":"48.11%"},{"county":"Golden Valley County","value":"24.70%","lci":"15.50%","uci":"34.00%"},{"county":"Granite County","value":"33.62%","lci":"22.95%","uci":"44.29%"},{"county":"Hill County","value":"40.07%","lci":"33.33%","uci":"46.80%"},{"county":"Jefferson County","value":"24.70%","lci":"19.30%","uci":"30.20%"},{"county":"Judith Basin County","value":"24.70%","lci":"19.30%","uci":"30.20%"},{"county":"Lake County","value":"34.98%","lci":"30.67%","uci":"39.30%"},{"county":"Lewis and Clark County","value":"27.46%","lci":"23.96%","uci":"30.96%"},{"county":"Liberty County","value":"44.93%","lci":"32.33%","uci":"57.53%"},{"county":"Lincoln County","value":"45.54%","lci":"38.22%","uci":"52.86%"},{"county":"McCone County","value":"33.50%","lci":"25.00%","uci":"42.00%"},{"county":"Madison County","value":"23.81%","lci":"14.98%","uci":"32.64%"},{"county":"Meagher County","value":"24.70%","lci":"19.30%","uci":"30.20%"},{"county":"Mineral County","value":"45.51%","lci":"34.65%","uci":"56.38%"},{"county":"Missoula County","value":"35.57%","lci":"32.42%","uci":"38.73%"},{"county":"Musselshell County","value":"39.27%","lci":"29.66%","uci":"48.87%"},{"county":"Park County","value":"33.94%","lci":"25.62%","uci":"42.27%"},{"county":"Petroleum County","value":"24.70%","lci":"15.50%","uci":"34.00%"},{"county":"Phillips County","value":"45.79%","lci":"32.62%","uci":"58.97%"},{"county":"Pondera County","value":"30.12%","lci":"22.61%","uci":"37.64%"},{"county":"Powder River County","value":"21.70%","lci":"15.90%","uci":"27.50%"},{"county":"Powell County","value":"24.70%","lci":"14.99%","uci":"34.40%"},{"county":"Prairie County","value":"33.50%","lci":"25.00%","uci":"42.00%"},{"county":"Ravalli County","value":"38.33%","lci":"32.85%","uci":"43.82%"},{"county":"Richland County","value":"21.50%","lci":"15.93%","uci":"27.08%"},{"county":"Roosevelt County","value":"42.90%","lci":"37.21%","uci":"48.59%"},{"county":"Rosebud County","value":"31.48%","lci":"23.91%","uci":"39.06%"},{"county":"Sanders County","value":"42.87%","lci":"34.12%","uci":"51.62%"},{"county":"Sheridan County","value":"33.50%","lci":"25.00%","uci":"42.00%"},{"county":"Silver Bow County","value":"54.03%","lci":"46.70%","uci":"61.35%"},{"county":"Stillwater County","value":"18.69%","lci":"12.19%","uci":"25.19%"},{"county":"Sweet Grass County","value":"34.20%","lci":"25.00%","uci":"43.40%"},{"county":"Teton County","value":"28.69%","lci":"20.76%","uci":"36.62%"},{"county":"Toole County","value":"32.54%","lci":"22.41%","uci":"42.66%"},{"county":"Treasure County","value":"21.70%","lci":"15.90%","uci":"27.50%"},{"county":"Valley County","value":"37.91%","lci":"29.17%","uci":"46.66%"},{"county":"Wheatland County","value":"34.20%","lci":"25.00%","uci":"43.40%"},{"county":"Wibaux County","value":"33.50%","lci":"25.00%","uci":"42.00%"},{"county":"Yellowstone County","value":"26.60%","lci":"24.44%","uci":"28.76%"}]

/***/ }),
/* 751 */
/***/ (function(module, exports) {

	module.exports = [{"county":"Montana","value":"32.80%","lci":"32.40%","uci":"33.20%"},{"county":"Beaverhead County","value":"37%","lci":"33.70%","uci":"40.10%"},{"county":"Big Horn County","value":"39%","lci":"35.40%","uci":"42.60%"},{"county":"Blaine County","value":"39%","lci":"35.30%","uci":"42.70%"},{"county":"Broadwater County","value":"19%","lci":"14.70%","uci":"23.30%"},{"county":"Carbon County","value":"22%","lci":"19.20%","uci":"24.80%"},{"county":"Carter County","value":"19%","lci":"14.10%","uci":"23.90%"},{"county":"Cascade County","value":"36%","lci":"34.90%","uci":"37.50%"},{"county":"Chouteau County","value":"37%","lci":"33.50%","uci":"40.90%"},{"county":"Custer County","value":"30%","lci":"27.50%","uci":"33.30%"},{"county":"Daniels County","value":"23%","lci":"16.30%","uci":"29.30%"},{"county":"Dawson County","value":"32%","lci":"28.20%","uci":"35.80%"},{"county":"Deer Lodge County","value":"29%","lci":"24.50%","uci":"33.50%"},{"county":"Fallon County","value":"30%","lci":"24.40%","uci":"35.40%"},{"county":"Fergus County","value":"29%","lci":"24.60%","uci":"32.80%"},{"county":"Flathead County","value":"29%","lci":"27.40%","uci":"30.60%"},{"county":"Gallatin County","value":"39%","lci":"37.70%","uci":"40.70%"},{"county":"Garfield County","value":"28%","lci":"21.30%","uci":"33.70%"},{"county":"Glacier County","value":"41%","lci":"38.00%","uci":"44.00%"},{"county":"Golden Valley County","value":"27%","lci":"19.80%","uci":"34.20%"},{"county":"Granite County","value":"27%","lci":"21.80%","uci":"31.20%"},{"county":"Hill County","value":"35%","lci":"31.30%","uci":"37.70%"},{"county":"Jefferson County","value":"16%","lci":"12.50%","uci":"18.50%"},{"county":"Judith Basin County","value":"26%","lci":"21.40%","uci":"30.40%"},{"county":"Lake County","value":"30%","lci":"28.00%","uci":"31.60%"},{"county":"Lewis and Clark County","value":"31%","lci":"29.20%","uci":"32.60%"},{"county":"Liberty County","value":"33%","lci":"27.50%","uci":"38.70%"},{"county":"Lincoln County","value":"21%","lci":"18.20%","uci":"23.40%"},{"county":"McCone County","value":"18%","lci":"12.80%","uci":"23.20%"},{"county":"Madison County","value":"23%","lci":"18.90%","uci":"26.10%"},{"county":"Meagher County","value":"32%","lci":"25.40%","uci":"38.20%"},{"county":"Mineral County","value":"30%","lci":"23.80%","uci":"35.40%"},{"county":"Missoula County","value":"41%","lci":"40.10%","uci":"42.70%"},{"county":"Musselshell County","value":"29%","lci":"23.80%","uci":"33.40%"},{"county":"Park County","value":"28%","lci":"24.60%","uci":"30.60%"},{"county":"Petroleum County","value":"39%","lci":"29.60%","uci":"48.80%"},{"county":"Phillips County","value":"30%","lci":"24.10%","uci":"35.30%"},{"county":"Pondera County","value":"29%","lci":"25.20%","uci":"33.20%"},{"county":"Powder River County","value":"34%","lci":"28.20%","uci":"40.00%"},{"county":"Powell County","value":"31%","lci":"27.40%","uci":"35.40%"},{"county":"Prairie County","value":"9%","lci":"5.30%","uci":"11.70%"},{"county":"Ravalli County","value":"28%","lci":"25.30%","uci":"30.10%"},{"county":"Richland County","value":"37%","lci":"32.70%","uci":"41.50%"},{"county":"Roosevelt County","value":"44%","lci":"40.20%","uci":"47.60%"},{"county":"Rosebud County","value":"29%","lci":"25.70%","uci":"32.10%"},{"county":"Sanders County","value":"24%","lci":"21.70%","uci":"27.10%"},{"county":"Sheridan County","value":"24%","lci":"19.90%","uci":"27.50%"},{"county":"Silver Bow County","value":"34%","lci":"31.60%","uci":"36.40%"},{"county":"Stillwater County","value":"21%","lci":"17.90%","uci":"23.90%"},{"county":"Sweet Grass County","value":"27%","lci":"22.10%","uci":"30.90%"},{"county":"Teton County","value":"30%","lci":"26.90%","uci":"33.10%"},{"county":"Toole County","value":"41%","lci":"36.10%","uci":"46.30%"},{"county":"Treasure County","value":"35%","lci":"28.10%","uci":"41.70%"},{"county":"Valley County","value":"31%","lci":"26.50%","uci":"34.70%"},{"county":"Wheatland County","value":"33%","lci":"27.70%","uci":"38.90%"},{"county":"Wibaux County","value":"22%","lci":"15.30%","uci":"29.10%"},{"county":"Yellowstone County","value":"32%","lci":"31.00%","uci":"33.40%"}]

/***/ }),
/* 752 */
/***/ (function(module, exports) {

	module.exports = [{"county":"Montana","value":"73","lci":"","uci":""},{"county":"Beaverhead County","value":"64.275604","lci":"","uci":""},{"county":"Big Horn County","value":"65.502594","lci":"","uci":""},{"county":"Blaine County","value":"64.275604","lci":"","uci":""},{"county":"Broadwater County","value":"70.78811","lci":"","uci":""},{"county":"Carbon County","value":"81.07598","lci":"","uci":""},{"county":"Carter County","value":"64.275604","lci":"","uci":""},{"county":"Cascade County","value":"67.95658","lci":"","uci":""},{"county":"Chouteau County","value":"64.275604","lci":"","uci":""},{"county":"Custer County","value":"64.275604","lci":"","uci":""},{"county":"Daniels County","value":"64.275604","lci":"","uci":""},{"county":"Dawson County","value":"64.275604","lci":"","uci":""},{"county":"Deer Lodge County","value":"64.275604","lci":"","uci":""},{"county":"Fallon County","value":"64.275604","lci":"","uci":""},{"county":"Fergus County","value":"70.2218","lci":"","uci":""},{"county":"Flathead County","value":"70.50495","lci":"","uci":""},{"county":"Gallatin County","value":"80.03775","lci":"","uci":""},{"county":"Garfield County","value":"64.275604","lci":"","uci":""},{"county":"Glacier County","value":"64.275604","lci":"","uci":""},{"county":"Golden Valley County","value":"64.275604","lci":"","uci":""},{"county":"Granite County","value":"65.219444","lci":"","uci":""},{"county":"Hill County","value":"64.275604","lci":"","uci":""},{"county":"Jefferson County","value":"79.565834","lci":"","uci":""},{"county":"Judith Basin County","value":"64.275604","lci":"","uci":""},{"county":"Lake County","value":"65.59698","lci":"","uci":""},{"county":"Lewis and Clark County","value":"72.0151","lci":"","uci":""},{"county":"Liberty County","value":"64.275604","lci":"","uci":""},{"county":"Lincoln County","value":"64.275604","lci":"","uci":""},{"county":"McCone County","value":"64.275604","lci":"","uci":""},{"county":"Madison County","value":"70.78811","lci":"","uci":""},{"county":"Meagher County","value":"66.163284","lci":"","uci":""},{"county":"Mineral County","value":"64.275604","lci":"","uci":""},{"county":"Missoula County","value":"80.69844","lci":"","uci":""},{"county":"Musselshell County","value":"64.275604","lci":"","uci":""},{"county":"Park County","value":"80.509674","lci":"","uci":""},{"county":"Petroleum County","value":"69.27796","lci":"","uci":""},{"county":"Phillips County","value":"64.275604","lci":"","uci":""},{"county":"Pondera County","value":"64.275604","lci":"","uci":""},{"county":"Powder River County","value":"64.275604","lci":"","uci":""},{"county":"Powell County","value":"64.275604","lci":"","uci":""},{"county":"Prairie County","value":"64.275604","lci":"","uci":""},{"county":"Ravalli County","value":"68.050964","lci":"","uci":""},{"county":"Richland County","value":"72.298256","lci":"","uci":""},{"county":"Roosevelt County","value":"64.275604","lci":"","uci":""},{"county":"Rosebud County","value":"64.275604","lci":"","uci":""},{"county":"Sanders County","value":"64.275604","lci":"","uci":""},{"county":"Sheridan County","value":"64.275604","lci":"","uci":""},{"county":"Silver Bow County","value":"67.484665","lci":"","uci":""},{"county":"Stillwater County","value":"64.275604","lci":"","uci":""},{"county":"Sweet Grass County","value":"68.428505","lci":"","uci":""},{"county":"Teton County","value":"64.558754","lci":"","uci":""},{"county":"Toole County","value":"64.275604","lci":"","uci":""},{"county":"Treasure County","value":"69.27796","lci":"","uci":""},{"county":"Valley County","value":"64.275604","lci":"","uci":""},{"county":"Wheatland County","value":"64.275604","lci":"","uci":""},{"county":"Wibaux County","value":"70.50495","lci":"","uci":""},{"county":"Yellowstone County","value":"81.07598","lci":"","uci":""}]

/***/ }),
/* 753 */,
/* 754 */,
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! @preserve
	 * numeral.js
	 * version : 2.0.6
	 * author : Adam Draper
	 * license : MIT
	 * http://adamwdraper.github.com/Numeral-js/
	 */
	
	(function (global, factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof module === 'object' && module.exports) {
	        module.exports = factory();
	    } else {
	        global.numeral = factory();
	    }
	}(this, function () {
	    /************************************
	        Variables
	    ************************************/
	
	    var numeral,
	        _,
	        VERSION = '2.0.6',
	        formats = {},
	        locales = {},
	        defaults = {
	            currentLocale: 'en',
	            zeroFormat: null,
	            nullFormat: null,
	            defaultFormat: '0,0',
	            scalePercentBy100: true
	        },
	        options = {
	            currentLocale: defaults.currentLocale,
	            zeroFormat: defaults.zeroFormat,
	            nullFormat: defaults.nullFormat,
	            defaultFormat: defaults.defaultFormat,
	            scalePercentBy100: defaults.scalePercentBy100
	        };
	
	
	    /************************************
	        Constructors
	    ************************************/
	
	    // Numeral prototype object
	    function Numeral(input, number) {
	        this._input = input;
	
	        this._value = number;
	    }
	
	    numeral = function(input) {
	        var value,
	            kind,
	            unformatFunction,
	            regexp;
	
	        if (numeral.isNumeral(input)) {
	            value = input.value();
	        } else if (input === 0 || typeof input === 'undefined') {
	            value = 0;
	        } else if (input === null || _.isNaN(input)) {
	            value = null;
	        } else if (typeof input === 'string') {
	            if (options.zeroFormat && input === options.zeroFormat) {
	                value = 0;
	            } else if (options.nullFormat && input === options.nullFormat || !input.replace(/[^0-9]+/g, '').length) {
	                value = null;
	            } else {
	                for (kind in formats) {
	                    regexp = typeof formats[kind].regexps.unformat === 'function' ? formats[kind].regexps.unformat() : formats[kind].regexps.unformat;
	
	                    if (regexp && input.match(regexp)) {
	                        unformatFunction = formats[kind].unformat;
	
	                        break;
	                    }
	                }
	
	                unformatFunction = unformatFunction || numeral._.stringToNumber;
	
	                value = unformatFunction(input);
	            }
	        } else {
	            value = Number(input)|| null;
	        }
	
	        return new Numeral(input, value);
	    };
	
	    // version number
	    numeral.version = VERSION;
	
	    // compare numeral object
	    numeral.isNumeral = function(obj) {
	        return obj instanceof Numeral;
	    };
	
	    // helper functions
	    numeral._ = _ = {
	        // formats numbers separators, decimals places, signs, abbreviations
	        numberToFormat: function(value, format, roundingFunction) {
	            var locale = locales[numeral.options.currentLocale],
	                negP = false,
	                optDec = false,
	                leadingCount = 0,
	                abbr = '',
	                trillion = 1000000000000,
	                billion = 1000000000,
	                million = 1000000,
	                thousand = 1000,
	                decimal = '',
	                neg = false,
	                abbrForce, // force abbreviation
	                abs,
	                min,
	                max,
	                power,
	                int,
	                precision,
	                signed,
	                thousands,
	                output;
	
	            // make sure we never format a null value
	            value = value || 0;
	
	            abs = Math.abs(value);
	
	            // see if we should use parentheses for negative number or if we should prefix with a sign
	            // if both are present we default to parentheses
	            if (numeral._.includes(format, '(')) {
	                negP = true;
	                format = format.replace(/[\(|\)]/g, '');
	            } else if (numeral._.includes(format, '+') || numeral._.includes(format, '-')) {
	                signed = numeral._.includes(format, '+') ? format.indexOf('+') : value < 0 ? format.indexOf('-') : -1;
	                format = format.replace(/[\+|\-]/g, '');
	            }
	
	            // see if abbreviation is wanted
	            if (numeral._.includes(format, 'a')) {
	                abbrForce = format.match(/a(k|m|b|t)?/);
	
	                abbrForce = abbrForce ? abbrForce[1] : false;
	
	                // check for space before abbreviation
	                if (numeral._.includes(format, ' a')) {
	                    abbr = ' ';
	                }
	
	                format = format.replace(new RegExp(abbr + 'a[kmbt]?'), '');
	
	                if (abs >= trillion && !abbrForce || abbrForce === 't') {
	                    // trillion
	                    abbr += locale.abbreviations.trillion;
	                    value = value / trillion;
	                } else if (abs < trillion && abs >= billion && !abbrForce || abbrForce === 'b') {
	                    // billion
	                    abbr += locale.abbreviations.billion;
	                    value = value / billion;
	                } else if (abs < billion && abs >= million && !abbrForce || abbrForce === 'm') {
	                    // million
	                    abbr += locale.abbreviations.million;
	                    value = value / million;
	                } else if (abs < million && abs >= thousand && !abbrForce || abbrForce === 'k') {
	                    // thousand
	                    abbr += locale.abbreviations.thousand;
	                    value = value / thousand;
	                }
	            }
	
	            // check for optional decimals
	            if (numeral._.includes(format, '[.]')) {
	                optDec = true;
	                format = format.replace('[.]', '.');
	            }
	
	            // break number and format
	            int = value.toString().split('.')[0];
	            precision = format.split('.')[1];
	            thousands = format.indexOf(',');
	            leadingCount = (format.split('.')[0].split(',')[0].match(/0/g) || []).length;
	
	            if (precision) {
	                if (numeral._.includes(precision, '[')) {
	                    precision = precision.replace(']', '');
	                    precision = precision.split('[');
	                    decimal = numeral._.toFixed(value, (precision[0].length + precision[1].length), roundingFunction, precision[1].length);
	                } else {
	                    decimal = numeral._.toFixed(value, precision.length, roundingFunction);
	                }
	
	                int = decimal.split('.')[0];
	
	                if (numeral._.includes(decimal, '.')) {
	                    decimal = locale.delimiters.decimal + decimal.split('.')[1];
	                } else {
	                    decimal = '';
	                }
	
	                if (optDec && Number(decimal.slice(1)) === 0) {
	                    decimal = '';
	                }
	            } else {
	                int = numeral._.toFixed(value, 0, roundingFunction);
	            }
	
	            // check abbreviation again after rounding
	            if (abbr && !abbrForce && Number(int) >= 1000 && abbr !== locale.abbreviations.trillion) {
	                int = String(Number(int) / 1000);
	
	                switch (abbr) {
	                    case locale.abbreviations.thousand:
	                        abbr = locale.abbreviations.million;
	                        break;
	                    case locale.abbreviations.million:
	                        abbr = locale.abbreviations.billion;
	                        break;
	                    case locale.abbreviations.billion:
	                        abbr = locale.abbreviations.trillion;
	                        break;
	                }
	            }
	
	
	            // format number
	            if (numeral._.includes(int, '-')) {
	                int = int.slice(1);
	                neg = true;
	            }
	
	            if (int.length < leadingCount) {
	                for (var i = leadingCount - int.length; i > 0; i--) {
	                    int = '0' + int;
	                }
	            }
	
	            if (thousands > -1) {
	                int = int.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + locale.delimiters.thousands);
	            }
	
	            if (format.indexOf('.') === 0) {
	                int = '';
	            }
	
	            output = int + decimal + (abbr ? abbr : '');
	
	            if (negP) {
	                output = (negP && neg ? '(' : '') + output + (negP && neg ? ')' : '');
	            } else {
	                if (signed >= 0) {
	                    output = signed === 0 ? (neg ? '-' : '+') + output : output + (neg ? '-' : '+');
	                } else if (neg) {
	                    output = '-' + output;
	                }
	            }
	
	            return output;
	        },
	        // unformats numbers separators, decimals places, signs, abbreviations
	        stringToNumber: function(string) {
	            var locale = locales[options.currentLocale],
	                stringOriginal = string,
	                abbreviations = {
	                    thousand: 3,
	                    million: 6,
	                    billion: 9,
	                    trillion: 12
	                },
	                abbreviation,
	                value,
	                i,
	                regexp;
	
	            if (options.zeroFormat && string === options.zeroFormat) {
	                value = 0;
	            } else if (options.nullFormat && string === options.nullFormat || !string.replace(/[^0-9]+/g, '').length) {
	                value = null;
	            } else {
	                value = 1;
	
	                if (locale.delimiters.decimal !== '.') {
	                    string = string.replace(/\./g, '').replace(locale.delimiters.decimal, '.');
	                }
	
	                for (abbreviation in abbreviations) {
	                    regexp = new RegExp('[^a-zA-Z]' + locale.abbreviations[abbreviation] + '(?:\\)|(\\' + locale.currency.symbol + ')?(?:\\))?)?$');
	
	                    if (stringOriginal.match(regexp)) {
	                        value *= Math.pow(10, abbreviations[abbreviation]);
	                        break;
	                    }
	                }
	
	                // check for negative number
	                value *= (string.split('-').length + Math.min(string.split('(').length - 1, string.split(')').length - 1)) % 2 ? 1 : -1;
	
	                // remove non numbers
	                string = string.replace(/[^0-9\.]+/g, '');
	
	                value *= Number(string);
	            }
	
	            return value;
	        },
	        isNaN: function(value) {
	            return typeof value === 'number' && isNaN(value);
	        },
	        includes: function(string, search) {
	            return string.indexOf(search) !== -1;
	        },
	        insert: function(string, subString, start) {
	            return string.slice(0, start) + subString + string.slice(start);
	        },
	        reduce: function(array, callback /*, initialValue*/) {
	            if (this === null) {
	                throw new TypeError('Array.prototype.reduce called on null or undefined');
	            }
	
	            if (typeof callback !== 'function') {
	                throw new TypeError(callback + ' is not a function');
	            }
	
	            var t = Object(array),
	                len = t.length >>> 0,
	                k = 0,
	                value;
	
	            if (arguments.length === 3) {
	                value = arguments[2];
	            } else {
	                while (k < len && !(k in t)) {
	                    k++;
	                }
	
	                if (k >= len) {
	                    throw new TypeError('Reduce of empty array with no initial value');
	                }
	
	                value = t[k++];
	            }
	            for (; k < len; k++) {
	                if (k in t) {
	                    value = callback(value, t[k], k, t);
	                }
	            }
	            return value;
	        },
	        /**
	         * Computes the multiplier necessary to make x >= 1,
	         * effectively eliminating miscalculations caused by
	         * finite precision.
	         */
	        multiplier: function (x) {
	            var parts = x.toString().split('.');
	
	            return parts.length < 2 ? 1 : Math.pow(10, parts[1].length);
	        },
	        /**
	         * Given a variable number of arguments, returns the maximum
	         * multiplier that must be used to normalize an operation involving
	         * all of them.
	         */
	        correctionFactor: function () {
	            var args = Array.prototype.slice.call(arguments);
	
	            return args.reduce(function(accum, next) {
	                var mn = _.multiplier(next);
	                return accum > mn ? accum : mn;
	            }, 1);
	        },
	        /**
	         * Implementation of toFixed() that treats floats more like decimals
	         *
	         * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
	         * problems for accounting- and finance-related software.
	         */
	        toFixed: function(value, maxDecimals, roundingFunction, optionals) {
	            var splitValue = value.toString().split('.'),
	                minDecimals = maxDecimals - (optionals || 0),
	                boundedPrecision,
	                optionalsRegExp,
	                power,
	                output;
	
	            // Use the smallest precision value possible to avoid errors from floating point representation
	            if (splitValue.length === 2) {
	              boundedPrecision = Math.min(Math.max(splitValue[1].length, minDecimals), maxDecimals);
	            } else {
	              boundedPrecision = minDecimals;
	            }
	
	            power = Math.pow(10, boundedPrecision);
	
	            // Multiply up by precision, round accurately, then divide and use native toFixed():
	            output = (roundingFunction(value + 'e+' + boundedPrecision) / power).toFixed(boundedPrecision);
	
	            if (optionals > maxDecimals - boundedPrecision) {
	                optionalsRegExp = new RegExp('\\.?0{1,' + (optionals - (maxDecimals - boundedPrecision)) + '}$');
	                output = output.replace(optionalsRegExp, '');
	            }
	
	            return output;
	        }
	    };
	
	    // avaliable options
	    numeral.options = options;
	
	    // avaliable formats
	    numeral.formats = formats;
	
	    // avaliable formats
	    numeral.locales = locales;
	
	    // This function sets the current locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    numeral.locale = function(key) {
	        if (key) {
	            options.currentLocale = key.toLowerCase();
	        }
	
	        return options.currentLocale;
	    };
	
	    // This function provides access to the loaded locale data.  If
	    // no arguments are passed in, it will simply return the current
	    // global locale object.
	    numeral.localeData = function(key) {
	        if (!key) {
	            return locales[options.currentLocale];
	        }
	
	        key = key.toLowerCase();
	
	        if (!locales[key]) {
	            throw new Error('Unknown locale : ' + key);
	        }
	
	        return locales[key];
	    };
	
	    numeral.reset = function() {
	        for (var property in defaults) {
	            options[property] = defaults[property];
	        }
	    };
	
	    numeral.zeroFormat = function(format) {
	        options.zeroFormat = typeof(format) === 'string' ? format : null;
	    };
	
	    numeral.nullFormat = function (format) {
	        options.nullFormat = typeof(format) === 'string' ? format : null;
	    };
	
	    numeral.defaultFormat = function(format) {
	        options.defaultFormat = typeof(format) === 'string' ? format : '0.0';
	    };
	
	    numeral.register = function(type, name, format) {
	        name = name.toLowerCase();
	
	        if (this[type + 's'][name]) {
	            throw new TypeError(name + ' ' + type + ' already registered.');
	        }
	
	        this[type + 's'][name] = format;
	
	        return format;
	    };
	
	
	    numeral.validate = function(val, culture) {
	        var _decimalSep,
	            _thousandSep,
	            _currSymbol,
	            _valArray,
	            _abbrObj,
	            _thousandRegEx,
	            localeData,
	            temp;
	
	        //coerce val to string
	        if (typeof val !== 'string') {
	            val += '';
	
	            if (console.warn) {
	                console.warn('Numeral.js: Value is not string. It has been co-erced to: ', val);
	            }
	        }
	
	        //trim whitespaces from either sides
	        val = val.trim();
	
	        //if val is just digits return true
	        if (!!val.match(/^\d+$/)) {
	            return true;
	        }
	
	        //if val is empty return false
	        if (val === '') {
	            return false;
	        }
	
	        //get the decimal and thousands separator from numeral.localeData
	        try {
	            //check if the culture is understood by numeral. if not, default it to current locale
	            localeData = numeral.localeData(culture);
	        } catch (e) {
	            localeData = numeral.localeData(numeral.locale());
	        }
	
	        //setup the delimiters and currency symbol based on culture/locale
	        _currSymbol = localeData.currency.symbol;
	        _abbrObj = localeData.abbreviations;
	        _decimalSep = localeData.delimiters.decimal;
	        if (localeData.delimiters.thousands === '.') {
	            _thousandSep = '\\.';
	        } else {
	            _thousandSep = localeData.delimiters.thousands;
	        }
	
	        // validating currency symbol
	        temp = val.match(/^[^\d]+/);
	        if (temp !== null) {
	            val = val.substr(1);
	            if (temp[0] !== _currSymbol) {
	                return false;
	            }
	        }
	
	        //validating abbreviation symbol
	        temp = val.match(/[^\d]+$/);
	        if (temp !== null) {
	            val = val.slice(0, -1);
	            if (temp[0] !== _abbrObj.thousand && temp[0] !== _abbrObj.million && temp[0] !== _abbrObj.billion && temp[0] !== _abbrObj.trillion) {
	                return false;
	            }
	        }
	
	        _thousandRegEx = new RegExp(_thousandSep + '{2}');
	
	        if (!val.match(/[^\d.,]/g)) {
	            _valArray = val.split(_decimalSep);
	            if (_valArray.length > 2) {
	                return false;
	            } else {
	                if (_valArray.length < 2) {
	                    return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx));
	                } else {
	                    if (_valArray[0].length === 1) {
	                        return ( !! _valArray[0].match(/^\d+$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
	                    } else {
	                        return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
	                    }
	                }
	            }
	        }
	
	        return false;
	    };
	
	
	    /************************************
	        Numeral Prototype
	    ************************************/
	
	    numeral.fn = Numeral.prototype = {
	        clone: function() {
	            return numeral(this);
	        },
	        format: function(inputString, roundingFunction) {
	            var value = this._value,
	                format = inputString || options.defaultFormat,
	                kind,
	                output,
	                formatFunction;
	
	            // make sure we have a roundingFunction
	            roundingFunction = roundingFunction || Math.round;
	
	            // format based on value
	            if (value === 0 && options.zeroFormat !== null) {
	                output = options.zeroFormat;
	            } else if (value === null && options.nullFormat !== null) {
	                output = options.nullFormat;
	            } else {
	                for (kind in formats) {
	                    if (format.match(formats[kind].regexps.format)) {
	                        formatFunction = formats[kind].format;
	
	                        break;
	                    }
	                }
	
	                formatFunction = formatFunction || numeral._.numberToFormat;
	
	                output = formatFunction(value, format, roundingFunction);
	            }
	
	            return output;
	        },
	        value: function() {
	            return this._value;
	        },
	        input: function() {
	            return this._input;
	        },
	        set: function(value) {
	            this._value = Number(value);
	
	            return this;
	        },
	        add: function(value) {
	            var corrFactor = _.correctionFactor.call(null, this._value, value);
	
	            function cback(accum, curr, currI, O) {
	                return accum + Math.round(corrFactor * curr);
	            }
	
	            this._value = _.reduce([this._value, value], cback, 0) / corrFactor;
	
	            return this;
	        },
	        subtract: function(value) {
	            var corrFactor = _.correctionFactor.call(null, this._value, value);
	
	            function cback(accum, curr, currI, O) {
	                return accum - Math.round(corrFactor * curr);
	            }
	
	            this._value = _.reduce([value], cback, Math.round(this._value * corrFactor)) / corrFactor;
	
	            return this;
	        },
	        multiply: function(value) {
	            function cback(accum, curr, currI, O) {
	                var corrFactor = _.correctionFactor(accum, curr);
	                return Math.round(accum * corrFactor) * Math.round(curr * corrFactor) / Math.round(corrFactor * corrFactor);
	            }
	
	            this._value = _.reduce([this._value, value], cback, 1);
	
	            return this;
	        },
	        divide: function(value) {
	            function cback(accum, curr, currI, O) {
	                var corrFactor = _.correctionFactor(accum, curr);
	                return Math.round(accum * corrFactor) / Math.round(curr * corrFactor);
	            }
	
	            this._value = _.reduce([this._value, value], cback);
	
	            return this;
	        },
	        difference: function(value) {
	            return Math.abs(numeral(this._value).subtract(value).value());
	        }
	    };
	
	    /************************************
	        Default Locale && Format
	    ************************************/
	
	    numeral.register('locale', 'en', {
	        delimiters: {
	            thousands: ',',
	            decimal: '.'
	        },
	        abbreviations: {
	            thousand: 'k',
	            million: 'm',
	            billion: 'b',
	            trillion: 't'
	        },
	        ordinal: function(number) {
	            var b = number % 10;
	            return (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	        },
	        currency: {
	            symbol: '$'
	        }
	    });
	
	    
	
	(function() {
	        numeral.register('format', 'bps', {
	            regexps: {
	                format: /(BPS)/,
	                unformat: /(BPS)/
	            },
	            format: function(value, format, roundingFunction) {
	                var space = numeral._.includes(format, ' BPS') ? ' ' : '',
	                    output;
	
	                value = value * 10000;
	
	                // check for space before BPS
	                format = format.replace(/\s?BPS/, '');
	
	                output = numeral._.numberToFormat(value, format, roundingFunction);
	
	                if (numeral._.includes(output, ')')) {
	                    output = output.split('');
	
	                    output.splice(-1, 0, space + 'BPS');
	
	                    output = output.join('');
	                } else {
	                    output = output + space + 'BPS';
	                }
	
	                return output;
	            },
	            unformat: function(string) {
	                return +(numeral._.stringToNumber(string) * 0.0001).toFixed(15);
	            }
	        });
	})();
	
	
	(function() {
	        var decimal = {
	            base: 1000,
	            suffixes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
	        },
	        binary = {
	            base: 1024,
	            suffixes: ['B', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
	        };
	
	    var allSuffixes =  decimal.suffixes.concat(binary.suffixes.filter(function (item) {
	            return decimal.suffixes.indexOf(item) < 0;
	        }));
	        var unformatRegex = allSuffixes.join('|');
	        // Allow support for BPS (http://www.investopedia.com/terms/b/basispoint.asp)
	        unformatRegex = '(' + unformatRegex.replace('B', 'B(?!PS)') + ')';
	
	    numeral.register('format', 'bytes', {
	        regexps: {
	            format: /([0\s]i?b)/,
	            unformat: new RegExp(unformatRegex)
	        },
	        format: function(value, format, roundingFunction) {
	            var output,
	                bytes = numeral._.includes(format, 'ib') ? binary : decimal,
	                suffix = numeral._.includes(format, ' b') || numeral._.includes(format, ' ib') ? ' ' : '',
	                power,
	                min,
	                max;
	
	            // check for space before
	            format = format.replace(/\s?i?b/, '');
	
	            for (power = 0; power <= bytes.suffixes.length; power++) {
	                min = Math.pow(bytes.base, power);
	                max = Math.pow(bytes.base, power + 1);
	
	                if (value === null || value === 0 || value >= min && value < max) {
	                    suffix += bytes.suffixes[power];
	
	                    if (min > 0) {
	                        value = value / min;
	                    }
	
	                    break;
	                }
	            }
	
	            output = numeral._.numberToFormat(value, format, roundingFunction);
	
	            return output + suffix;
	        },
	        unformat: function(string) {
	            var value = numeral._.stringToNumber(string),
	                power,
	                bytesMultiplier;
	
	            if (value) {
	                for (power = decimal.suffixes.length - 1; power >= 0; power--) {
	                    if (numeral._.includes(string, decimal.suffixes[power])) {
	                        bytesMultiplier = Math.pow(decimal.base, power);
	
	                        break;
	                    }
	
	                    if (numeral._.includes(string, binary.suffixes[power])) {
	                        bytesMultiplier = Math.pow(binary.base, power);
	
	                        break;
	                    }
	                }
	
	                value *= (bytesMultiplier || 1);
	            }
	
	            return value;
	        }
	    });
	})();
	
	
	(function() {
	        numeral.register('format', 'currency', {
	        regexps: {
	            format: /(\$)/
	        },
	        format: function(value, format, roundingFunction) {
	            var locale = numeral.locales[numeral.options.currentLocale],
	                symbols = {
	                    before: format.match(/^([\+|\-|\(|\s|\$]*)/)[0],
	                    after: format.match(/([\+|\-|\)|\s|\$]*)$/)[0]
	                },
	                output,
	                symbol,
	                i;
	
	            // strip format of spaces and $
	            format = format.replace(/\s?\$\s?/, '');
	
	            // format the number
	            output = numeral._.numberToFormat(value, format, roundingFunction);
	
	            // update the before and after based on value
	            if (value >= 0) {
	                symbols.before = symbols.before.replace(/[\-\(]/, '');
	                symbols.after = symbols.after.replace(/[\-\)]/, '');
	            } else if (value < 0 && (!numeral._.includes(symbols.before, '-') && !numeral._.includes(symbols.before, '('))) {
	                symbols.before = '-' + symbols.before;
	            }
	
	            // loop through each before symbol
	            for (i = 0; i < symbols.before.length; i++) {
	                symbol = symbols.before[i];
	
	                switch (symbol) {
	                    case '$':
	                        output = numeral._.insert(output, locale.currency.symbol, i);
	                        break;
	                    case ' ':
	                        output = numeral._.insert(output, ' ', i + locale.currency.symbol.length - 1);
	                        break;
	                }
	            }
	
	            // loop through each after symbol
	            for (i = symbols.after.length - 1; i >= 0; i--) {
	                symbol = symbols.after[i];
	
	                switch (symbol) {
	                    case '$':
	                        output = i === symbols.after.length - 1 ? output + locale.currency.symbol : numeral._.insert(output, locale.currency.symbol, -(symbols.after.length - (1 + i)));
	                        break;
	                    case ' ':
	                        output = i === symbols.after.length - 1 ? output + ' ' : numeral._.insert(output, ' ', -(symbols.after.length - (1 + i) + locale.currency.symbol.length - 1));
	                        break;
	                }
	            }
	
	
	            return output;
	        }
	    });
	})();
	
	
	(function() {
	        numeral.register('format', 'exponential', {
	        regexps: {
	            format: /(e\+|e-)/,
	            unformat: /(e\+|e-)/
	        },
	        format: function(value, format, roundingFunction) {
	            var output,
	                exponential = typeof value === 'number' && !numeral._.isNaN(value) ? value.toExponential() : '0e+0',
	                parts = exponential.split('e');
	
	            format = format.replace(/e[\+|\-]{1}0/, '');
	
	            output = numeral._.numberToFormat(Number(parts[0]), format, roundingFunction);
	
	            return output + 'e' + parts[1];
	        },
	        unformat: function(string) {
	            var parts = numeral._.includes(string, 'e+') ? string.split('e+') : string.split('e-'),
	                value = Number(parts[0]),
	                power = Number(parts[1]);
	
	            power = numeral._.includes(string, 'e-') ? power *= -1 : power;
	
	            function cback(accum, curr, currI, O) {
	                var corrFactor = numeral._.correctionFactor(accum, curr),
	                    num = (accum * corrFactor) * (curr * corrFactor) / (corrFactor * corrFactor);
	                return num;
	            }
	
	            return numeral._.reduce([value, Math.pow(10, power)], cback, 1);
	        }
	    });
	})();
	
	
	(function() {
	        numeral.register('format', 'ordinal', {
	        regexps: {
	            format: /(o)/
	        },
	        format: function(value, format, roundingFunction) {
	            var locale = numeral.locales[numeral.options.currentLocale],
	                output,
	                ordinal = numeral._.includes(format, ' o') ? ' ' : '';
	
	            // check for space before
	            format = format.replace(/\s?o/, '');
	
	            ordinal += locale.ordinal(value);
	
	            output = numeral._.numberToFormat(value, format, roundingFunction);
	
	            return output + ordinal;
	        }
	    });
	})();
	
	
	(function() {
	        numeral.register('format', 'percentage', {
	        regexps: {
	            format: /(%)/,
	            unformat: /(%)/
	        },
	        format: function(value, format, roundingFunction) {
	            var space = numeral._.includes(format, ' %') ? ' ' : '',
	                output;
	
	            if (numeral.options.scalePercentBy100) {
	                value = value * 100;
	            }
	
	            // check for space before %
	            format = format.replace(/\s?\%/, '');
	
	            output = numeral._.numberToFormat(value, format, roundingFunction);
	
	            if (numeral._.includes(output, ')')) {
	                output = output.split('');
	
	                output.splice(-1, 0, space + '%');
	
	                output = output.join('');
	            } else {
	                output = output + space + '%';
	            }
	
	            return output;
	        },
	        unformat: function(string) {
	            var number = numeral._.stringToNumber(string);
	            if (numeral.options.scalePercentBy100) {
	                return number * 0.01;
	            }
	            return number;
	        }
	    });
	})();
	
	
	(function() {
	        numeral.register('format', 'time', {
	        regexps: {
	            format: /(:)/,
	            unformat: /(:)/
	        },
	        format: function(value, format, roundingFunction) {
	            var hours = Math.floor(value / 60 / 60),
	                minutes = Math.floor((value - (hours * 60 * 60)) / 60),
	                seconds = Math.round(value - (hours * 60 * 60) - (minutes * 60));
	
	            return hours + ':' + (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds);
	        },
	        unformat: function(string) {
	            var timeArray = string.split(':'),
	                seconds = 0;
	
	            // turn hours and minutes into seconds and add them all up
	            if (timeArray.length === 3) {
	                // hours
	                seconds = seconds + (Number(timeArray[0]) * 60 * 60);
	                // minutes
	                seconds = seconds + (Number(timeArray[1]) * 60);
	                // seconds
	                seconds = seconds + Number(timeArray[2]);
	            } else if (timeArray.length === 2) {
	                // minutes
	                seconds = seconds + (Number(timeArray[0]) * 60);
	                // seconds
	                seconds = seconds + Number(timeArray[1]);
	            }
	            return Number(seconds);
	        }
	    });
	})();
	
	return numeral;
	}));


/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
	(function() {
	  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - nodeLoadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    moduleLoadTime = getNanoSeconds();
	    upTime = process.uptime() * 1e9;
	    nodeLoadTime = moduleLoadTime - upTime;
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	//# sourceMappingURL=performance-now.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)))

/***/ }),
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(756)
	  , root = typeof window === 'undefined' ? global : window
	  , vendors = ['moz', 'webkit']
	  , suffix = 'AnimationFrame'
	  , raf = root['request' + suffix]
	  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]
	
	for(var i = 0; !raf && i < vendors.length; i++) {
	  raf = root[vendors[i] + 'Request' + suffix]
	  caf = root[vendors[i] + 'Cancel' + suffix]
	      || root[vendors[i] + 'CancelRequest' + suffix]
	}
	
	// Some versions of FF have rAF but not cAF
	if(!raf || !caf) {
	  var last = 0
	    , id = 0
	    , queue = []
	    , frameDuration = 1000 / 60
	
	  raf = function(callback) {
	    if(queue.length === 0) {
	      var _now = now()
	        , next = Math.max(0, frameDuration - (_now - last))
	      last = next + _now
	      setTimeout(function() {
	        var cp = queue.slice(0)
	        // Clear queue here to prevent
	        // callbacks from appending listeners
	        // to the current frame's queue
	        queue.length = 0
	        for(var i = 0; i < cp.length; i++) {
	          if(!cp[i].cancelled) {
	            try{
	              cp[i].callback(last)
	            } catch(e) {
	              setTimeout(function() { throw e }, 0)
	            }
	          }
	        }
	      }, Math.round(next))
	    }
	    queue.push({
	      handle: ++id,
	      callback: callback,
	      cancelled: false
	    })
	    return id
	  }
	
	  caf = function(handle) {
	    for(var i = 0; i < queue.length; i++) {
	      if(queue[i].handle === handle) {
	        queue[i].cancelled = true
	      }
	    }
	  }
	}
	
	module.exports = function(fn) {
	  // Wrap in a new function to prevent
	  // `cancel` potentially being assigned
	  // to the native rAF function
	  return raf.call(root, fn)
	}
	module.exports.cancel = function() {
	  caf.apply(root, arguments)
	}
	module.exports.polyfill = function(object) {
	  if (!object) {
	    object = root;
	  }
	  object.requestAnimationFrame = raf
	  object.cancelAnimationFrame = caf
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _class, _temp; /* eslint-disable no-restricted-syntax, react/forbid-prop-types */
	
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _raf = __webpack_require__(760);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var transitionEvent = function () {
	  if (typeof document === 'undefined') {
	    return;
	  }
	  var testElement = document.createElement('fakeelement');
	  var transitions = {
	    transition: 'transitionend',
	    OTransition: 'oTransitionEnd',
	    MozTransition: 'transitionend',
	    WebkitTransition: 'webkitTransitionEnd'
	
	    /* eslint-disable no-restricted-syntax */
	  };for (var t in transitions) {
	    if (testElement && testElement.style && testElement.style[t] !== undefined) {
	      return transitions[t];
	    }
	  }
	}();
	
	var easings = {
	  // Cubic
	  easeInCubic: 'cubic-bezier(0.550, 0.055, 0.675, 0.190)',
	  easeOutCubic: 'cubic-bezier(0.215, 0.610, 0.355, 1.000)',
	  easeInOutCubic: 'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
	
	  // Circ
	  easeInCirc: 'cubic-bezier(0.600, 0.040, 0.980, 0.335)',
	  easeOutCirc: 'cubic-bezier(0.075, 0.820, 0.165, 1.000)',
	  easeInOutCirc: 'cubic-bezier(0.785, 0.135, 0.150, 0.860)',
	
	  // Expo
	  easeInExpo: 'cubic-bezier(0.950, 0.050, 0.795, 0.035)',
	  easeOutExpo: 'cubic-bezier(0.190, 1.000, 0.220, 1.000)',
	  easeInOutExpo: 'cubic-bezier(1.000, 0.000, 0.000, 1.000)',
	
	  // Quad
	  easeInQuad: 'cubic-bezier(0.550, 0.085, 0.680, 0.530)',
	  easeOutQuad: 'cubic-bezier(0.250, 0.460, 0.450, 0.940)',
	  easeInOutQuad: 'cubic-bezier(0.455, 0.030, 0.515, 0.955)',
	
	  // Quart
	  easeInQuart: 'cubic-bezier(0.895, 0.030, 0.685, 0.220)',
	  easeOutQuart: 'cubic-bezier(0.165, 0.840, 0.440, 1.000)',
	  easeInOutQuart: 'cubic-bezier(0.770, 0.000, 0.175, 1.000)',
	
	  // Quint
	  easeInQuint: 'cubic-bezier(0.755, 0.050, 0.855, 0.060)',
	  easeOutQuint: 'cubic-bezier(0.230, 1.000, 0.320, 1.000)',
	  easeInOutQuint: 'cubic-bezier(0.860, 0.000, 0.070, 1.000)',
	
	  // Sine
	  easeInSine: 'cubic-bezier(0.470, 0.000, 0.745, 0.715)',
	  easeOutSine: 'cubic-bezier(0.390, 0.575, 0.565, 1.000)',
	  easeInOutSine: 'cubic-bezier(0.445, 0.050, 0.550, 0.950)',
	
	  // Back
	  easeInBack: 'cubic-bezier(0.600, -0.280, 0.735, 0.045)',
	  easeOutBack: 'cubic-bezier(0.175,  0.885, 0.320, 1.275)',
	  easeInOutBack: 'cubic-bezier(0.680, -0.550, 0.265, 1.550)'
	};
	
	var ReactShow = (_temp = _class = function (_React$Component) {
	  _inherits(ReactShow, _React$Component);
	
	  function ReactShow(props) {
	    _classCallCheck(this, ReactShow);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.onTransitionEnd = function (e) {
	      e.persist();
	      if (e.target !== _this.el) {
	        return;
	      }
	      var _this$props = _this.props,
	          unmountOnHide = _this$props.unmountOnHide,
	          show = _this$props.show,
	          styleShow = _this$props.styleShow,
	          styleHide = _this$props.styleHide;
	
	      if (_this.state.next === 'hidden' && unmountOnHide) {
	        _this.setState({
	          next: false,
	          mountContent: false
	        });
	      }
	      var isAuto = _this.stylePropIsAuto('width') || _this.stylePropIsAuto('height');
	      if (_this.state.next === 'auto') {
	        var currentStyle = show ? _extends({}, styleShow) : _extends({}, styleHide);
	        if (_this.stylePropIsAuto('width')) {
	          currentStyle.width = 'auto';
	        }
	        if (_this.stylePropIsAuto('height')) {
	          currentStyle.height = 'auto';
	        }
	        if (isAuto && !show) {
	          currentStyle.overflow = 'hidden';
	        }
	        _this.setState({
	          next: false,
	          currentStyle: currentStyle
	        });
	      }
	    };
	
	    _this.animateIn = function () {
	      var styleHide = _this.props.styleHide;
	      var _this$state = _this.state,
	          currentStyle = _this$state.currentStyle,
	          mountContent = _this$state.mountContent;
	
	
	      var nextStyle = mountContent ? _extends({}, currentStyle) : _extends({}, styleHide);
	
	      if (_this.stylePropIsAuto('width') || _this.stylePropIsAuto('height')) {
	        nextStyle.overflow = 'hidden';
	      }
	
	      _this.setState({
	        next: 'show',
	        mountContent: true,
	        currentStyle: nextStyle
	      });
	    };
	
	    _this.animateOut = function () {
	      // If we need to animate 'auto' values, measure first
	      var measurements = _this.checkNeedToMeasure() ? _this.measure() : {};
	      var isAuto = _this.stylePropIsAuto('width') || _this.stylePropIsAuto('height');
	      _this.setState({
	        next: 'hide',
	        currentStyle: _extends({}, _this.state.currentStyle, _this.stylePropIsAuto('width') ? { width: measurements.width + 'px' } : {}, _this.stylePropIsAuto('height') ? { height: measurements.height + 'px' } : {}, isAuto ? {
	          overflow: 'hidden'
	        } : {})
	      });
	    };
	
	    _this.checkNeedToMeasure = function () {
	      return _this.stylePropIsAuto('height') || _this.stylePropIsAuto('width');
	    };
	
	    _this.checkIsAuto = function () {
	      return _this.stylePropIsAuto('height') && _this.el && _this.el.style.height === 'auto' || _this.stylePropIsAuto('width') && _this.el && _this.el.style.width === 'auto';
	    };
	
	    _this.handleRef = function (el) {
	      _this.el = el;
	    };
	
	    _this.stylePropIsAuto = function (prop) {
	      return _this.props.styleShow[prop] === 'auto';
	    };
	
	    _this.measure = function () {
	      if (!_this.el) {
	        return {};
	      }
	      return {
	        width: _this.el.scrollWidth,
	        height: _this.el.scrollHeight
	      };
	    };
	
	    _this.makeStyles = function () {
	      var _this$props2 = _this.props,
	          style = _this$props2.style,
	          transitionProperty = _this$props2.transitionProperty,
	          duration = _this$props2.duration,
	          easing = _this$props2.easing;
	      var currentStyle = _this.state.currentStyle;
	
	
	      var resolvedEasing = easings[easing] || easing || 'ease-out';
	
	      return _extends({
	        transitionProperty: transitionProperty,
	        transitionDuration: duration + 'ms',
	        transitionTimingFunction: '' + resolvedEasing
	      }, style, currentStyle);
	    };
	
	    _this.state = {
	      next: false,
	      mountContent: props.show,
	      currentStyle: props.transitionOnMount || !props.show ? props.styleHide : props.styleShow
	    };
	    return _this;
	  }
	
	  ReactShow.prototype.componentDidMount = function componentDidMount() {
	    if (this.props.transitionOnMount && this.props.show) {
	      this.animateIn();
	    }
	  };
	
	  ReactShow.prototype.componentWillReceiveProps = function componentWillReceiveProps(next) {
	    if (!this.props.show && next.show) {
	      this.animateIn();
	    } else if (this.props.show && !next.show) {
	      this.animateOut();
	    }
	  };
	
	  ReactShow.prototype.componentDidUpdate = function componentDidUpdate() {
	    var _this2 = this;
	
	    var _props = this.props,
	        styleHide = _props.styleHide,
	        styleShow = _props.styleShow;
	
	
	    if (this.state.next === 'show') {
	      var measurements = {};
	      // Only measure if we need to
	      var isAuto = this.stylePropIsAuto('width') || this.stylePropIsAuto('height');
	      if (isAuto) {
	        measurements = this.measure();
	      }
	      (0, _raf2.default)(function () {
	        _this2.setState({
	          next: 'auto',
	          currentStyle: _extends({}, styleShow, _this2.stylePropIsAuto('width') ? { width: measurements.width + 'px' } : {}, _this2.stylePropIsAuto('height') ? { height: measurements.height + 'px' } : {}, isAuto ? {
	            overflow: 'hidden'
	          } : {})
	        });
	      });
	    }
	
	    if (this.state.next === 'hide') {
	      this.setState({
	        next: false
	      });
	      var queueFinalHide = function queueFinalHide() {
	        // If we still need to measure, delay a bit until element is ready.
	        // double RAF this to be sure that the browser has painted
	        (0, _raf2.default)(function () {
	          return (0, _raf2.default)(function () {
	            if (_this2.checkNeedToMeasure()) {
	              if (_this2.checkIsAuto()) {
	                queueFinalHide();
	                return;
	              }
	            }
	
	            var isAuto = _this2.stylePropIsAuto('width') || _this2.stylePropIsAuto('height');
	            if (!_this2.state.next) {
	              _this2.setState({
	                next: 'hidden',
	                currentStyle: _extends({}, styleHide, isAuto ? {
	                  overflow: 'hidden'
	                } : {})
	              });
	            }
	          });
	        });
	      };
	      queueFinalHide();
	    }
	  };
	
	  ReactShow.prototype.render = function render() {
	    var _props2 = this.props,
	        children = _props2.children,
	        originalShow = _props2.show,
	        easing = _props2.easing,
	        duration = _props2.duration,
	        transitionProperty = _props2.transitionProperty,
	        unmountOnHide = _props2.unmountOnHide,
	        transitionOnMount = _props2.transitionOnMount,
	        show = _props2.show,
	        style = _props2.style,
	        styleHide = _props2.styleHide,
	        styleShow = _props2.styleShow,
	        rest = _objectWithoutProperties(_props2, ['children', 'show', 'easing', 'duration', 'transitionProperty', 'unmountOnHide', 'transitionOnMount', 'show', 'style', 'styleHide', 'styleShow']);
	
	    var mountContent = this.state.mountContent;
	
	    return mountContent ? _react2.default.createElement(
	      'div',
	      _extends({
	        ref: this.handleRef,
	        onTransitionEnd: this.onTransitionEnd,
	        style: this.makeStyles()
	      }, rest),
	      children
	    ) : null;
	  };
	
	  return ReactShow;
	}(_react2.default.Component), _class.easings = easings, _class.defaultProps = {
	  show: false,
	  easing: 'easeOutQuad',
	  duration: 300,
	  transitionProperty: 'all',
	  unmountOnHide: true,
	  transitionOnMount: false,
	  style: {},
	  styleHide: {
	    height: 0
	  },
	  styleShow: {
	    height: 'auto'
	  }
	}, _temp);
	exports.default = ReactShow;
	ReactShow.propTypes =  false ? {
	  easing: _propTypes2.default.string,
	  duration: _propTypes2.default.number,
	  transitionProperty: _propTypes2.default.string,
	  unmountOnHide: _propTypes2.default.bool,
	  style: _propTypes2.default.object,
	  styleHide: _propTypes2.default.object,
	  styleShow: _propTypes2.default.object,
	  transitionOnMount: _propTypes2.default.bool,
	  children: _propTypes2.default.node.isRequired
	} : {};
	module.exports = exports['default'];

/***/ }),
/* 1006 */,
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _d3Geo = __webpack_require__(53);
	
	var _utils = __webpack_require__(191);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Annotation = function (_Component) {
	  _inherits(Annotation, _Component);
	
	  function Annotation() {
	    _classCallCheck(this, Annotation);
	
	    return _possibleConstructorReturn(this, (Annotation.__proto__ || Object.getPrototypeOf(Annotation)).apply(this, arguments));
	  }
	
	  _createClass(Annotation, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          projection = _props.projection,
	          subject = _props.subject,
	          style = _props.style,
	          hiddenStyle = _props.hiddenStyle,
	          dx = _props.dx,
	          dy = _props.dy,
	          zoom = _props.zoom,
	          stroke = _props.stroke,
	          strokeWidth = _props.strokeWidth,
	          children = _props.children,
	          curve = _props.curve,
	          markerEnd = _props.markerEnd,
	          width = _props.width,
	          height = _props.height;
	
	
	      var connectorPath = (0, _utils.createConnectorPath)(null, [-dx / zoom, -dy / zoom], curve);
	      var translation = projection(subject);
	
	      var lineString = {
	        "type": "Feature",
	        "geometry": {
	          "type": "LineString",
	          "coordinates": [projection.invert([width / 2, height / 2]), subject]
	        }
	      };
	
	      var radians = Math.PI / 2,
	          degrees = 90;
	      var isGlobe = projection.clipAngle && projection.clipAngle() === degrees;
	      var isHidden = isGlobe && (0, _d3Geo.geoLength)(lineString) > radians;
	
	      return _react2.default.createElement(
	        "g",
	        {
	          className: "rsm-annotation",
	          style: isHidden ? _extends({}, style, hiddenStyle) : style,
	          transform: "translate(\n          " + (translation[0] + dx / zoom) + "\n          " + (translation[1] + dy / zoom) + "\n        )",
	          textAnchor: (0, _utils.createTextAnchor)(dx)
	        },
	        children,
	        _react2.default.createElement("path", {
	          d: connectorPath,
	          stroke: stroke,
	          strokeWidth: strokeWidth,
	          fill: "none",
	          markerEnd: markerEnd
	        })
	      );
	    }
	  }]);
	
	  return Annotation;
	}(_react.Component);
	
	Annotation.defaultProps = {
	  curve: 0,
	  markerEnd: "none",
	  componentIdentifier: "Annotation",
	  stroke: "#000000",
	  strokeWidth: 1,
	  zoom: 1
	};
	
	exports.default = Annotation;

/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MapGroup = __webpack_require__(242);
	
	var _MapGroup2 = _interopRequireDefault(_MapGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Annotations = function Annotations(_ref) {
	  var groupName = _ref.groupName,
	      itemName = _ref.itemName,
	      componentIdentifier = _ref.componentIdentifier,
	      restProps = _objectWithoutProperties(_ref, ["groupName", "itemName", "componentIdentifier"]);
	
	  return _react2.default.createElement(_MapGroup2.default, _extends({
	    groupName: groupName,
	    itemName: itemName
	  }, restProps));
	};
	
	Annotations.defaultProps = {
	  componentIdentifier: "Annotations",
	  groupName: "annotations",
	  itemName: "annotation"
	};
	
	exports.default = Annotations;

/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _projections = __webpack_require__(1020);
	
	var _projections2 = _interopRequireDefault(_projections);
	
	var _projectionConfig = __webpack_require__(585);
	
	var _projectionConfig2 = _interopRequireDefault(_projectionConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ComposableMap = function (_Component) {
	  _inherits(ComposableMap, _Component);
	
	  function ComposableMap() {
	    _classCallCheck(this, ComposableMap);
	
	    var _this = _possibleConstructorReturn(this, (ComposableMap.__proto__ || Object.getPrototypeOf(ComposableMap)).call(this));
	
	    _this.projection = _this.projection.bind(_this);
	    return _this;
	  }
	
	  _createClass(ComposableMap, [{
	    key: "projection",
	    value: function projection() {
	      var _props = this.props,
	          projection = _props.projection,
	          projectionConfig = _props.projectionConfig,
	          width = _props.width,
	          height = _props.height;
	
	
	      return typeof projection !== "function" ? (0, _projections2.default)(width, height, projectionConfig, projection) : projection(width, height, projectionConfig);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props2 = this.props,
	          width = _props2.width,
	          height = _props2.height,
	          style = _props2.style,
	          className = _props2.className,
	          showCenter = _props2.showCenter,
	          children = _props2.children,
	          aspectRatio = _props2.aspectRatio,
	          viewBox = _props2.viewBox,
	          defs = _props2.defs;
	
	
	      return _react2.default.createElement(
	        "svg",
	        { width: width,
	          height: height,
	          viewBox: viewBox ? viewBox : "0 0 " + width + " " + height,
	          className: "rsm-svg " + (className || ''),
	          style: style,
	          preserveAspectRatio: aspectRatio },
	        defs && _react2.default.createElement(
	          "defs",
	          null,
	          defs
	        ),
	        _react2.default.cloneElement(this.props.children, {
	          projection: this.projection(),
	          width: width,
	          height: height
	        }),
	        showCenter && _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("rect", { x: width / 2 - 0.5, y: 0, width: 1, height: height, fill: "#e91e63" }),
	          _react2.default.createElement("rect", { x: 0, y: height / 2 - 0.5, width: width, height: 1, fill: "#e91e63" })
	        )
	      );
	    }
	  }]);
	
	  return ComposableMap;
	}(_react.Component);
	
	ComposableMap.defaultProps = {
	  width: 800,
	  height: 450,
	  projection: "times",
	  projectionConfig: _projectionConfig2.default,
	  aspectRatio: "xMidYMid",
	  viewBox: null
	};
	
	exports.default = ComposableMap;

/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _topojsonClient = __webpack_require__(1040);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Geographies = function (_Component) {
	  _inherits(Geographies, _Component);
	
	  function Geographies(props) {
	    _classCallCheck(this, Geographies);
	
	    var _this = _possibleConstructorReturn(this, (Geographies.__proto__ || Object.getPrototypeOf(Geographies)).call(this, props));
	
	    _this.state = {
	      geographyPaths: _this.shouldFetchGeographies(props.geography) ? [] : _this.parseGeographies(props.geography)
	    };
	    return _this;
	  }
	
	  _createClass(Geographies, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.geography !== this.props.geography) {
	        if (this.shouldFetchGeographies(nextProps.geography)) {
	          this.fetchGeographies(nextProps.geography);
	        } else {
	          this.setState({
	            geographyPaths: this.parseGeographies(nextProps.geography)
	          });
	        }
	      }
	    }
	  }, {
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      var geoPathsChanged = nextState.geographyPaths.length !== this.state.geographyPaths.length;
	      return geoPathsChanged || nextProps.disableOptimization;
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (this.props.geographyUrl || this.props.geographyPaths) {
	        console.warn("You are using the deprecated geographyUrl or geographyPaths props. Use the new geography prop instead. Check out the new docs here: https://github.com/zcreativelabs/react-simple-maps#Geographies-component");
	      }
	      if (this.shouldFetchGeographies(this.props.geography)) {
	        this.fetchGeographies(this.props.geography);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.cancelPendingRequest();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          projection = _props.projection,
	          style = _props.style,
	          children = _props.children;
	
	      return _react2.default.createElement(
	        "g",
	        { className: "rsm-geographies", style: style },
	        children(this.state.geographyPaths || [], projection)
	      );
	    }
	  }, {
	    key: "shouldFetchGeographies",
	    value: function shouldFetchGeographies(geography) {
	      return typeof geography === 'string';
	    }
	  }, {
	    key: "parseGeographies",
	    value: function parseGeographies(geography) {
	      if (Array.isArray(geography)) {
	        return geography;
	      }
	
	      if (Object.prototype.toString.call(geography) === '[object Object]') {
	        return (0, _topojsonClient.feature)(geography, geography.objects[Object.keys(geography.objects)[0]]).features;
	      }
	
	      return [];
	    }
	  }, {
	    key: "fetchGeographies",
	    value: function fetchGeographies(geography) {
	      var _this2 = this;
	
	      var request = new XMLHttpRequest();
	      request.open("GET", geography, true);
	      request.onload = function () {
	        if (request.status >= 200 && request.status < 400) {
	          var geographyPaths = JSON.parse(request.responseText);
	          _this2.setState({
	            geographyPaths: _this2.parseGeographies(geographyPaths)
	          }, function () {
	            if (_this2.props.onGeographyPathsLoaded) {
	              _this2.props.onGeographyPathsLoaded(String(request.status));
	            }
	          });
	        } else {
	          if (_this2.props.onGeographyPathsLoaded) {
	            _this2.props.onGeographyPathsLoaded(String(request.status));
	          }
	        }
	      };
	      request.onerror = function () {
	        console.log("There was a connection error...");
	      };
	      request.send();
	
	      this.cancelPendingRequest();
	      this._xhr = request;
	    }
	  }, {
	    key: "cancelPendingRequest",
	    value: function cancelPendingRequest() {
	      if (this._xhr) {
	        this._xhr.abort();
	        this._xhr = null;
	      }
	    }
	  }]);
	
	  return Geographies;
	}(_react.Component);
	
	Geographies.defaultProps = {
	  componentIdentifier: "Geographies",
	  disableOptimization: false,
	  geography: ""
	};
	
	exports.default = Geographies;

/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _d3Geo = __webpack_require__(53);
	
	var _utils = __webpack_require__(191);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var pathCache = {};
	
	var renderPath = function renderPath(cacheId, geography, projection, round, precision) {
	  if (pathCache[cacheId]) return pathCache[cacheId];
	
	  var pathString = cacheId ? pathCache[cacheId] ? pathCache[cacheId] : round ? (0, _utils.roundPath)((0, _d3Geo.geoPath)().projection(projection)(geography), precision) : (0, _d3Geo.geoPath)().projection(projection)(geography) : round ? (0, _utils.roundPath)((0, _d3Geo.geoPath)().projection(projection)(geography), precision) : (0, _d3Geo.geoPath)().projection(projection)(geography);
	
	  if (cacheId) pathCache[cacheId] = pathString;
	
	  return pathString;
	};
	
	var Geography = function (_Component) {
	  _inherits(Geography, _Component);
	
	  function Geography() {
	    _classCallCheck(this, Geography);
	
	    var _this = _possibleConstructorReturn(this, (Geography.__proto__ || Object.getPrototypeOf(Geography)).call(this));
	
	    _this.state = {
	      hover: false,
	      pressed: false
	    };
	
	    _this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
	    _this.handleMouseMove = _this.handleMouseMove.bind(_this);
	    _this.handleMouseLeave = _this.handleMouseLeave.bind(_this);
	    _this.handleMouseDown = _this.handleMouseDown.bind(_this);
	    _this.handleMouseUp = _this.handleMouseUp.bind(_this);
	    _this.handleMouseClick = _this.handleMouseClick.bind(_this);
	    _this.handleFocus = _this.handleFocus.bind(_this);
	    _this.handleBlur = _this.handleBlur.bind(_this);
	    return _this;
	  }
	
	  _createClass(Geography, [{
	    key: "handleMouseClick",
	    value: function handleMouseClick(evt) {
	      evt.persist();
	      var _props = this.props,
	          onClick = _props.onClick,
	          geography = _props.geography;
	
	      return onClick && onClick(geography, evt);
	    }
	  }, {
	    key: "handleMouseEnter",
	    value: function handleMouseEnter(evt) {
	      evt.persist();
	      var _props2 = this.props,
	          onMouseEnter = _props2.onMouseEnter,
	          geography = _props2.geography;
	
	      this.setState({
	        hover: true
	      }, function () {
	        return onMouseEnter && onMouseEnter(geography, evt);
	      });
	    }
	  }, {
	    key: "handleMouseMove",
	    value: function handleMouseMove(evt) {
	      evt.persist();
	      if (this.state.pressed) return;
	      var _props3 = this.props,
	          onMouseMove = _props3.onMouseMove,
	          geography = _props3.geography;
	
	      if (!this.state.hover) {
	        this.setState({
	          hover: true
	        }, function () {
	          return onMouseMove && onMouseMove(geography, evt);
	        });
	      } else if (onMouseMove) onMouseMove(geography, evt);else return;
	    }
	  }, {
	    key: "handleMouseLeave",
	    value: function handleMouseLeave(evt) {
	      evt.persist();
	      var _props4 = this.props,
	          onMouseLeave = _props4.onMouseLeave,
	          geography = _props4.geography;
	
	      this.setState({
	        hover: false,
	        pressed: false
	      }, function () {
	        return onMouseLeave && onMouseLeave(geography, evt);
	      });
	    }
	  }, {
	    key: "handleMouseDown",
	    value: function handleMouseDown(evt) {
	      evt.persist();
	      var _props5 = this.props,
	          onMouseDown = _props5.onMouseDown,
	          geography = _props5.geography;
	
	      this.setState({
	        pressed: true
	      }, function () {
	        return onMouseDown && onMouseDown(geography, evt);
	      });
	    }
	  }, {
	    key: "handleMouseUp",
	    value: function handleMouseUp(evt) {
	      evt.persist();
	      var _props6 = this.props,
	          onMouseUp = _props6.onMouseUp,
	          geography = _props6.geography;
	
	      this.setState({
	        pressed: false
	      }, function () {
	        return onMouseUp && onMouseUp(geography, evt);
	      });
	    }
	  }, {
	    key: "handleFocus",
	    value: function handleFocus(evt) {
	      evt.persist();
	      var _props7 = this.props,
	          onFocus = _props7.onFocus,
	          geography = _props7.geography;
	
	      this.setState({
	        hover: true
	      }, function () {
	        return onFocus && onFocus(geography, evt);
	      });
	    }
	  }, {
	    key: "handleBlur",
	    value: function handleBlur(evt) {
	      evt.persist();
	      var _props8 = this.props,
	          onBlur = _props8.onBlur,
	          geography = _props8.geography;
	
	      this.setState({
	        hover: false
	      }, function () {
	        return onBlur && onBlur(geography, evt);
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props9 = this.props,
	          geography = _props9.geography,
	          projection = _props9.projection,
	          round = _props9.round,
	          cacheId = _props9.cacheId,
	          precision = _props9.precision,
	          tabable = _props9.tabable,
	          style = _props9.style;
	      var _state = this.state,
	          hover = _state.hover,
	          pressed = _state.pressed;
	
	
	      var pathString = renderPath(cacheId, geography, projection, round, precision);
	
	      var excludeProps = ["geography", "projection", "round", "cacheId", "precision", "tabable", "style", "onClick", "onMouseEnter", "onMouseMove", "onMouseLeave", "onMouseDown", "onMouseUp", "onFocus", "onBlur"];
	
	      var restProps = Object.keys(this.props).filter(function (key) {
	        return excludeProps.indexOf(key) === -1;
	      }).reduce(function (obj, key) {
	        obj[key] = _this2.props[key];
	        return obj;
	      }, {});
	
	      return _react2.default.createElement("path", _extends({
	        d: pathString,
	        className: "rsm-geography" + (pressed ? " rsm-geography--pressed" : "") + (hover ? " rsm-geography--hover" : ""),
	        style: style[pressed || hover ? pressed ? "pressed" : "hover" : "default"],
	        onClick: this.handleMouseClick,
	        onMouseEnter: this.handleMouseEnter,
	        onMouseMove: this.handleMouseMove,
	        onMouseLeave: this.handleMouseLeave,
	        onMouseDown: this.handleMouseDown,
	        onMouseUp: this.handleMouseUp,
	        onFocus: this.handleFocus,
	        onBlur: this.handleBlur,
	        tabIndex: tabable ? 0 : -1
	      }, restProps));
	    }
	  }]);
	
	  return Geography;
	}(_react.Component);
	
	Geography.defaultProps = {
	  precision: 0.1,
	  cacheId: null,
	  round: false,
	  tabable: true,
	  style: {
	    default: {},
	    hover: {},
	    pressed: {}
	  }
	};
	
	exports.default = Geography;

/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _d3Geo = __webpack_require__(53);
	
	var _utils = __webpack_require__(191);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var computeGraticule = function computeGraticule(projection, step) {
	  return (0, _d3Geo.geoPath)().projection(projection)((0, _d3Geo.geoGraticule)().step(step)());
	};
	
	var computeOutline = function computeOutline(projection) {
	  return (0, _d3Geo.geoPath)().projection(projection)((0, _d3Geo.geoGraticule)().outline());
	};
	
	var Graticule = function (_Component) {
	  _inherits(Graticule, _Component);
	
	  function Graticule() {
	    _classCallCheck(this, Graticule);
	
	    var _this = _possibleConstructorReturn(this, (Graticule.__proto__ || Object.getPrototypeOf(Graticule)).call(this));
	
	    _this.state = {
	      renderGraticule: false,
	      graticulePath: "",
	      outlinePath: ""
	    };
	    _this.renderGraticule = _this.renderGraticule.bind(_this);
	    return _this;
	  }
	
	  _createClass(Graticule, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.renderGraticule();
	    }
	  }, {
	    key: "renderGraticule",
	    value: function renderGraticule() {
	      var _props = this.props,
	          step = _props.step,
	          projection = _props.projection,
	          round = _props.round,
	          precision = _props.precision;
	
	
	      this.setState({
	        renderGraticule: true,
	        graticulePath: round ? (0, _utils.roundPath)(computeGraticule(projection, step), precision) : computeGraticule(projection, step),
	        outlinePath: round ? (0, _utils.roundPath)(computeOutline(projection), precision) : computeOutline(projection)
	      });
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var _props2 = this.props,
	          step = _props2.step,
	          projection = _props2.projection,
	          round = _props2.round,
	          precision = _props2.precision,
	          globe = _props2.globe;
	
	
	      if (nextProps.round !== round || nextProps.precision !== precision || globe) {
	        this.setState({
	          graticulePath: nextProps.round ? (0, _utils.roundPath)(computeGraticule(projection, step), precision) : computeGraticule(projection, step),
	          outlinePath: nextProps.round ? (0, _utils.roundPath)(computeOutline(projection), precision) : computeOutline(projection)
	        });
	      }
	    }
	  }, {
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps) {
	      return nextProps.disableOptimization;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props3 = this.props,
	          zoom = _props3.zoom,
	          style = _props3.style,
	          outline = _props3.outline,
	          fill = _props3.fill,
	          stroke = _props3.stroke;
	
	
	      return this.state.renderGraticule && _react2.default.createElement(
	        "g",
	        { className: "rsm-graticule" },
	        _react2.default.createElement("path", {
	          fill: fill,
	          stroke: stroke,
	          d: this.state.graticulePath,
	          style: style
	        }),
	        outline && _react2.default.createElement("path", {
	          fill: fill,
	          stroke: stroke,
	          d: this.state.outlinePath,
	          style: style
	        })
	      );
	    }
	  }]);
	
	  return Graticule;
	}(_react.Component);
	
	Graticule.defaultProps = {
	  componentIdentifier: "Graticule",
	  disableOptimization: true,
	  globe: false,
	  round: true,
	  precision: 0.1,
	  step: [10, 10],
	  outline: true,
	  stroke: "#DDDDDD",
	  fill: "transparent",
	  style: {
	    pointerEvents: "none"
	  }
	};
	
	exports.default = Graticule;

/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _d3Geo = __webpack_require__(53);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Line = function (_Component) {
	  _inherits(Line, _Component);
	
	  function Line(props) {
	    _classCallCheck(this, Line);
	
	    var _this = _possibleConstructorReturn(this, (Line.__proto__ || Object.getPrototypeOf(Line)).call(this, props));
	
	    _this.state = {
	      hover: false,
	      pressed: false
	    };
	
	    _this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
	    _this.handleMouseLeave = _this.handleMouseLeave.bind(_this);
	    _this.handleMouseDown = _this.handleMouseDown.bind(_this);
	    _this.handleMouseUp = _this.handleMouseUp.bind(_this);
	    _this.handleMouseClick = _this.handleMouseClick.bind(_this);
	    _this.handleMouseMove = _this.handleMouseMove.bind(_this);
	    _this.handleFocus = _this.handleFocus.bind(_this);
	    _this.handleBlur = _this.handleBlur.bind(_this);
	    return _this;
	  }
	
	  _createClass(Line, [{
	    key: "handleMouseEnter",
	    value: function handleMouseEnter(evt) {
	      evt.persist();
	      var _props = this.props,
	          onMouseEnter = _props.onMouseEnter,
	          line = _props.line;
	
	      this.setState({
	        hover: true
	      }, function () {
	        return onMouseEnter && onMouseEnter(line, evt);
	      });
	    }
	  }, {
	    key: "handleMouseMove",
	    value: function handleMouseMove(evt) {
	      evt.persist();
	      if (this.state.pressed) return;
	      var _props2 = this.props,
	          onMouseMove = _props2.onMouseMove,
	          line = _props2.line;
	
	      if (!this.state.hover) {
	        this.setState({
	          hover: true
	        }, function () {
	          return onMouseMove && onMouseMove(line, evt);
	        });
	      } else if (onMouseMove) onMouseMove(line, evt);else return;
	    }
	  }, {
	    key: "handleMouseLeave",
	    value: function handleMouseLeave(evt) {
	      evt.persist();
	      var _props3 = this.props,
	          onMouseLeave = _props3.onMouseLeave,
	          line = _props3.line;
	
	      this.setState({
	        hover: false
	      }, function () {
	        return onMouseLeave && onMouseLeave(line, evt);
	      });
	    }
	  }, {
	    key: "handleMouseDown",
	    value: function handleMouseDown(evt) {
	      evt.persist();
	      var _props4 = this.props,
	          onMouseDown = _props4.onMouseDown,
	          line = _props4.line;
	
	      this.setState({
	        pressed: true
	      }, function () {
	        return onMouseDown && onMouseDown(line, evt);
	      });
	    }
	  }, {
	    key: "handleMouseUp",
	    value: function handleMouseUp(evt) {
	      evt.persist();
	      var _props5 = this.props,
	          onMouseUp = _props5.onMouseUp,
	          line = _props5.line;
	
	      this.setState({
	        pressed: false
	      }, function () {
	        return onMouseUp && onMouseUp(line, evt);
	      });
	    }
	  }, {
	    key: "handleMouseClick",
	    value: function handleMouseClick(evt) {
	      if (!this.props.onClick) return;
	      evt.persist();
	      var _props6 = this.props,
	          onClick = _props6.onClick,
	          line = _props6.line,
	          projection = _props6.projection;
	
	      return onClick && onClick(line, [projection(line.coordinates.start), projection(line.coordinates.end)], evt);
	    }
	  }, {
	    key: "handleFocus",
	    value: function handleFocus(evt) {
	      evt.persist();
	      var _props7 = this.props,
	          onFocus = _props7.onFocus,
	          line = _props7.line;
	
	      this.setState({
	        hover: true
	      }, function () {
	        return onFocus && onFocus(line, evt);
	      });
	    }
	  }, {
	    key: "handleBlur",
	    value: function handleBlur(evt) {
	      evt.persist();
	      var _props8 = this.props,
	          onBlur = _props8.onBlur,
	          line = _props8.line;
	
	      this.setState({
	        hover: false
	      }, function () {
	        return onBlur && onBlur(line, evt);
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props9 = this.props,
	          className = _props9.className,
	          projection = _props9.projection,
	          line = _props9.line,
	          style = _props9.style,
	          tabable = _props9.tabable,
	          zoom = _props9.zoom,
	          preserveMarkerAspect = _props9.preserveMarkerAspect,
	          width = _props9.width,
	          height = _props9.height,
	          buildPath = _props9.buildPath,
	          strokeWidth = _props9.strokeWidth;
	      var _state = this.state,
	          pressed = _state.pressed,
	          hover = _state.hover;
	
	
	      var scale = preserveMarkerAspect ? " scale(" + 1 / zoom + ")" : "";
	
	      var buildLineString = function buildLineString(coordinates) {
	        return {
	          type: "Feature",
	          geometry: {
	            type: "LineString",
	            coordinates: [projection.invert([width / 2, height / 2]), coordinates]
	          }
	        };
	      };
	      var startLineString = buildLineString(line.coordinates.start);
	      var endLineString = buildLineString(line.coordinates.end);
	
	      var radians = Math.PI / 2,
	          degrees = 90;
	      var isGlobe = projection.clipAngle && projection.clipAngle() === degrees;
	      var isHidden = isGlobe && ((0, _d3Geo.geoLength)(startLineString) > radians || (0, _d3Geo.geoLength)(endLineString) > radians);
	
	      var start = projection(line.coordinates.start);
	      var end = projection(line.coordinates.end);
	
	      var path = buildPath ? buildPath(start, end, line) : "M " + start.join(" ") + " L " + end.join(" ");
	
	      return _react2.default.createElement("path", {
	        className: "rsm-line" + (pressed ? " rsm-line--pressed" : "") + (hover ? " rsm-line--hover" : "") + " " + className,
	        transform: "" + scale,
	        style: style[isHidden ? "hidden" : pressed || hover ? pressed ? "pressed" : "hover" : "default"],
	        onMouseEnter: this.handleMouseEnter,
	        onMouseLeave: this.handleMouseLeave,
	        onMouseDown: this.handleMouseDown,
	        onMouseUp: this.handleMouseUp,
	        onClick: this.handleMouseClick,
	        onMouseMove: this.handleMouseMove,
	        onFocus: this.handleFocus,
	        onBlur: this.handleBlur,
	        tabIndex: tabable ? 0 : -1,
	        d: path,
	        strokeWidth: strokeWidth
	      });
	    }
	  }]);
	
	  return Line;
	}(_react.Component);
	
	Line.defaultProps = {
	  style: {
	    default: {},
	    hover: {},
	    pressed: {}
	  },
	  line: {
	    coordinates: {
	      start: [0, 0],
	      end: [-99.1, 19.4]
	    }
	  },
	  tabable: true,
	  preserveMarkerAspect: true,
	  strokeWidth: 1,
	  className: ""
	};
	
	exports.default = Line;

/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MapGroup = __webpack_require__(242);
	
	var _MapGroup2 = _interopRequireDefault(_MapGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Lines = function Lines(_ref) {
	  var groupName = _ref.groupName,
	      itemName = _ref.itemName,
	      componentIdentifier = _ref.componentIdentifier,
	      restProps = _objectWithoutProperties(_ref, ["groupName", "itemName", "componentIdentifier"]);
	
	  return _react2.default.createElement(_MapGroup2.default, _extends({
	    groupName: groupName,
	    itemName: itemName
	  }, restProps));
	};
	
	Lines.defaultProps = {
	  componentIdentifier: "Lines",
	  groupName: "lines",
	  itemName: "line"
	};
	
	exports.default = Lines;

/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _d3Geo = __webpack_require__(53);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Marker = function (_Component) {
	  _inherits(Marker, _Component);
	
	  function Marker() {
	    _classCallCheck(this, Marker);
	
	    var _this = _possibleConstructorReturn(this, (Marker.__proto__ || Object.getPrototypeOf(Marker)).call(this));
	
	    _this.state = {
	      hover: false,
	      pressed: false
	    };
	
	    _this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
	    _this.handleMouseLeave = _this.handleMouseLeave.bind(_this);
	    _this.handleMouseDown = _this.handleMouseDown.bind(_this);
	    _this.handleMouseUp = _this.handleMouseUp.bind(_this);
	    _this.handleMouseClick = _this.handleMouseClick.bind(_this);
	    _this.handleMouseMove = _this.handleMouseMove.bind(_this);
	    _this.handleFocus = _this.handleFocus.bind(_this);
	    _this.handleBlur = _this.handleBlur.bind(_this);
	    return _this;
	  }
	
	  _createClass(Marker, [{
	    key: "handleMouseEnter",
	    value: function handleMouseEnter(evt) {
	      evt.persist();
	      var _props = this.props,
	          onMouseEnter = _props.onMouseEnter,
	          marker = _props.marker;
	
	      this.setState({
	        hover: true
	      }, function () {
	        return onMouseEnter && onMouseEnter(marker, evt);
	      });
	    }
	  }, {
	    key: "handleMouseMove",
	    value: function handleMouseMove(evt) {
	      evt.persist();
	      if (this.state.pressed) return;
	      var _props2 = this.props,
	          onMouseMove = _props2.onMouseMove,
	          marker = _props2.marker;
	
	      if (!this.state.hover) {
	        this.setState({
	          hover: true
	        }, function () {
	          return onMouseMove && onMouseMove(marker, evt);
	        });
	      } else if (onMouseMove) onMouseMove(marker, evt);else return;
	    }
	  }, {
	    key: "handleMouseLeave",
	    value: function handleMouseLeave(evt) {
	      evt.persist();
	      var _props3 = this.props,
	          onMouseLeave = _props3.onMouseLeave,
	          marker = _props3.marker;
	
	      this.setState({
	        hover: false
	      }, function () {
	        return onMouseLeave && onMouseLeave(marker, evt);
	      });
	    }
	  }, {
	    key: "handleMouseDown",
	    value: function handleMouseDown(evt) {
	      evt.persist();
	      var _props4 = this.props,
	          onMouseDown = _props4.onMouseDown,
	          marker = _props4.marker;
	
	      this.setState({
	        pressed: true
	      }, function () {
	        return onMouseDown && onMouseDown(marker, evt);
	      });
	    }
	  }, {
	    key: "handleMouseUp",
	    value: function handleMouseUp(evt) {
	      evt.persist();
	      var _props5 = this.props,
	          onMouseUp = _props5.onMouseUp,
	          marker = _props5.marker;
	
	      this.setState({
	        pressed: false
	      }, function () {
	        return onMouseUp && onMouseUp(marker, evt);
	      });
	    }
	  }, {
	    key: "handleMouseClick",
	    value: function handleMouseClick(evt) {
	      if (!this.props.onClick) return;
	      evt.persist();
	      var _props6 = this.props,
	          onClick = _props6.onClick,
	          marker = _props6.marker,
	          projection = _props6.projection;
	
	      return onClick && onClick(marker, projection(marker.coordinates), evt);
	    }
	  }, {
	    key: "handleFocus",
	    value: function handleFocus(evt) {
	      evt.persist();
	      var _props7 = this.props,
	          onFocus = _props7.onFocus,
	          marker = _props7.marker;
	
	      this.setState({
	        hover: true
	      }, function () {
	        return onFocus && onFocus(marker, evt);
	      });
	    }
	  }, {
	    key: "handleBlur",
	    value: function handleBlur(evt) {
	      evt.persist();
	      var _props8 = this.props,
	          onBlur = _props8.onBlur,
	          marker = _props8.marker;
	
	      this.setState({
	        hover: false
	      }, function () {
	        return onBlur && onBlur(marker, evt);
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props9 = this.props,
	          projection = _props9.projection,
	          marker = _props9.marker,
	          style = _props9.style,
	          tabable = _props9.tabable,
	          zoom = _props9.zoom,
	          children = _props9.children,
	          preserveMarkerAspect = _props9.preserveMarkerAspect,
	          width = _props9.width,
	          height = _props9.height;
	      var _state = this.state,
	          pressed = _state.pressed,
	          hover = _state.hover;
	
	
	      var scale = preserveMarkerAspect ? " scale(" + 1 / zoom + ")" : "";
	      var translation = projection(marker.coordinates);
	
	      var lineString = {
	        "type": "Feature",
	        "geometry": {
	          "type": "LineString",
	          "coordinates": [projection.invert([width / 2, height / 2]), marker.coordinates]
	        }
	      };
	
	      var radians = Math.PI / 2,
	          degrees = 90;
	      var isGlobe = projection.clipAngle && projection.clipAngle() === degrees;
	      var isHidden = isGlobe && (0, _d3Geo.geoLength)(lineString) > radians;
	
	      return _react2.default.createElement(
	        "g",
	        { className: "rsm-marker" + (pressed ? " rsm-marker--pressed" : "") + (hover ? " rsm-marker--hover" : ""),
	          transform: "translate(\n           " + translation[0] + "\n           " + translation[1] + "\n         ) " + scale,
	          style: style[isHidden ? "hidden" : pressed || hover ? pressed ? "pressed" : "hover" : "default"],
	          onMouseEnter: this.handleMouseEnter,
	          onMouseLeave: this.handleMouseLeave,
	          onMouseDown: this.handleMouseDown,
	          onMouseUp: this.handleMouseUp,
	          onClick: this.handleMouseClick,
	          onMouseMove: this.handleMouseMove,
	          onFocus: this.handleFocus,
	          onBlur: this.handleBlur,
	          tabIndex: tabable ? 0 : -1
	        },
	        children
	      );
	    }
	  }]);
	
	  return Marker;
	}(_react.Component);
	
	Marker.defaultProps = {
	  style: {
	    default: {},
	    hover: {},
	    pressed: {}
	  },
	  marker: {
	    coordinates: [0, 0]
	  },
	  tabable: true,
	  preserveMarkerAspect: true
	};
	
	exports.default = Marker;

/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MapGroup = __webpack_require__(242);
	
	var _MapGroup2 = _interopRequireDefault(_MapGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Markers = function Markers(_ref) {
	  var groupName = _ref.groupName,
	      itemName = _ref.itemName,
	      componentIdentifier = _ref.componentIdentifier,
	      restProps = _objectWithoutProperties(_ref, ["groupName", "itemName", "componentIdentifier"]);
	
	  return _react2.default.createElement(_MapGroup2.default, _extends({
	    groupName: groupName,
	    itemName: itemName
	  }, restProps));
	};
	
	Markers.defaultProps = {
	  componentIdentifier: "Markers",
	  groupName: "markers",
	  itemName: "marker"
	};
	
	exports.default = Markers;

/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _d3Geo = __webpack_require__(53);
	
	var _utils = __webpack_require__(191);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ZoomableGlobe = function (_Component) {
	  _inherits(ZoomableGlobe, _Component);
	
	  function ZoomableGlobe(props) {
	    _classCallCheck(this, ZoomableGlobe);
	
	    var _this = _possibleConstructorReturn(this, (ZoomableGlobe.__proto__ || Object.getPrototypeOf(ZoomableGlobe)).call(this, props));
	
	    var initialRotation = props.projection.rotate();
	
	    _this.state = {
	      mouseX: 0,
	      mouseY: 0,
	      mouseXStart: 0,
	      mouseYStart: 0,
	      isPressed: false,
	      rotation: [initialRotation[0] - props.center[0], initialRotation[1] - props.center[1], initialRotation[2]]
	    };
	
	    _this.handleMouseMove = _this.handleMouseMove.bind(_this);
	    _this.handleMouseUp = _this.handleMouseUp.bind(_this);
	    _this.handleMouseDown = _this.handleMouseDown.bind(_this);
	    _this.handleTouchStart = _this.handleTouchStart.bind(_this);
	    _this.handleTouchMove = _this.handleTouchMove.bind(_this);
	    return _this;
	  }
	
	  _createClass(ZoomableGlobe, [{
	    key: "handleMouseMove",
	    value: function handleMouseMove(_ref) {
	      var pageX = _ref.pageX,
	          pageY = _ref.pageY,
	          clientX = _ref.clientX,
	          clientY = _ref.clientY;
	
	      if (this.props.disablePanning) return;
	      if (!this.state.isPressed) return;
	
	      var differenceX = clientX - this.state.mouseXStart;
	      var differenceY = clientY - this.state.mouseYStart;
	
	      this.setState({
	        mouseX: clientX,
	        mouseY: clientY,
	        mouseXStart: clientX,
	        mouseYStart: clientY,
	        rotation: [this.state.rotation[0] + differenceX * this.props.sensitivity, this.state.rotation[1] - differenceY * this.props.sensitivity, this.state.rotation[2]]
	      });
	    }
	  }, {
	    key: "handleTouchMove",
	    value: function handleTouchMove(_ref2) {
	      var touches = _ref2.touches;
	
	      this.handleMouseMove(touches[0]);
	    }
	  }, {
	    key: "handleMouseUp",
	    value: function handleMouseUp() {
	      if (this.props.disablePanning) return;
	      if (!this.state.isPressed) return;
	      this.setState({
	        isPressed: false
	      });
	      if (!this.props.onMoveEnd) return;
	      var newCenter = this.props.projection.invert([this.props.width / 2, this.props.height / 2]);
	      this.props.onMoveEnd(newCenter);
	    }
	  }, {
	    key: "handleMouseDown",
	    value: function handleMouseDown(_ref3) {
	      var pageX = _ref3.pageX,
	          pageY = _ref3.pageY,
	          clientX = _ref3.clientX,
	          clientY = _ref3.clientY;
	
	      if (this.props.disablePanning) return;
	      this.setState({
	        isPressed: true,
	        mouseXStart: clientX,
	        mouseYStart: clientY
	      });
	      if (!this.props.onMoveStart) return;
	      var currentCenter = this.props.projection.invert([this.props.width / 2, this.props.height / 2]);
	      this.props.onMoveStart(currentCenter);
	    }
	  }, {
	    key: "handleTouchStart",
	    value: function handleTouchStart(_ref4) {
	      var touches = _ref4.touches;
	
	      if (touches.length > 1) {
	        this.handleMouseDown(touches[0]);
	      } else {
	        this.handleMouseUp();
	      }
	    }
	  }, {
	    key: "preventTouchScroll",
	    value: function preventTouchScroll(evt) {
	      if (evt.touches.length > 1) {
	        evt.preventDefault();
	      }
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var _state = this.state,
	          mouseX = _state.mouseX,
	          mouseY = _state.mouseY;
	      var _props = this.props,
	          projection = _props.projection,
	          center = _props.center,
	          zoom = _props.zoom;
	
	
	      var zoomFactor = nextProps.zoom / zoom;
	      var centerChanged = JSON.stringify(nextProps.center) !== JSON.stringify(center);
	
	      this.setState({
	        zoom: nextProps.zoom,
	        rotation: centerChanged ? [-nextProps.center[0], -nextProps.center[1], this.state.rotation[2]] : this.state.rotation
	      });
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _props2 = this.props,
	          width = _props2.width,
	          height = _props2.height,
	          projection = _props2.projection,
	          zoom = _props2.zoom;
	
	
	      window.addEventListener("resize", this.handleResize);
	      window.addEventListener("mouseup", this.handleMouseUp);
	      this.zoomableGlobeNode.addEventListener("touchmove", this.preventTouchScroll);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      window.removeEventListener("resize", this.handleResize);
	      window.removeEventListener("mouseup", this.handleMouseUp);
	      this.zoomableGlobeNode.removeEventListener("touchmove", this.preventTouchScroll);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props3 = this.props,
	          width = _props3.width,
	          height = _props3.height,
	          zoom = _props3.zoom,
	          style = _props3.style,
	          projection = _props3.projection,
	          children = _props3.children;
	      var _state2 = this.state,
	          mouseX = _state2.mouseX,
	          mouseY = _state2.mouseY;
	
	
	      return _react2.default.createElement(
	        "g",
	        { className: "rsm-zoomable-globe",
	          ref: function ref(zoomableGlobeNode) {
	            return _this2.zoomableGlobeNode = zoomableGlobeNode;
	          },
	          transform: "\n           translate(" + width / 2 + " " + height / 2 + ")\n           scale(" + zoom + ")\n           translate(" + -width / 2 + " " + -height / 2 + ")\n         ",
	          onMouseMove: this.handleMouseMove,
	          onMouseUp: this.handleMouseUp,
	          onMouseDown: this.handleMouseDown,
	          onTouchStart: this.handleTouchStart,
	          onTouchMove: this.handleTouchMove,
	          onTouchEnd: this.handleMouseUp,
	          style: style
	        },
	        (0, _utils.createNewChildren)(children, {
	          width: width,
	          height: height,
	          center: this.center,
	          backdrop: this.backdrop,
	          zoom: this.props.zoom,
	          disablePanning: this.props.disablePanning,
	          children: children,
	          projection: projection.rotate(this.state.rotation)
	        })
	      );
	    }
	  }]);
	
	  return ZoomableGlobe;
	}(_react.Component);
	
	ZoomableGlobe.defaultProps = {
	  center: [0, 0],
	  zoom: 1,
	  disablePanning: false,
	  sensitivity: 0.25
	};
	
	exports.default = ZoomableGlobe;

/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _d3Geo = __webpack_require__(53);
	
	var _utils = __webpack_require__(191);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ZoomableGroup = function (_Component) {
	  _inherits(ZoomableGroup, _Component);
	
	  function ZoomableGroup(props) {
	    _classCallCheck(this, ZoomableGroup);
	
	    var _this = _possibleConstructorReturn(this, (ZoomableGroup.__proto__ || Object.getPrototypeOf(ZoomableGroup)).call(this, props));
	
	    var backdrop = (0, _utils.computeBackdrop)(props.projection, props.backdrop);
	
	    _this.state = {
	      mouseX: (0, _utils.calculateMousePosition)("x", props.projection, props, props.zoom, 1),
	      mouseY: (0, _utils.calculateMousePosition)("y", props.projection, props, props.zoom, 1),
	      mouseXStart: 0,
	      mouseYStart: 0,
	      isPressed: false,
	      resizeFactorX: 1,
	      resizeFactorY: 1,
	      backdrop: {
	        width: Math.round(backdrop.width),
	        height: Math.round(backdrop.height),
	        x: Math.round(backdrop.x),
	        y: Math.round(backdrop.y)
	      }
	    };
	
	    _this.handleMouseMove = _this.handleMouseMove.bind(_this);
	    _this.handleMouseUp = _this.handleMouseUp.bind(_this);
	    _this.handleMouseDown = _this.handleMouseDown.bind(_this);
	    _this.handleTouchStart = _this.handleTouchStart.bind(_this);
	    _this.handleTouchMove = _this.handleTouchMove.bind(_this);
	    _this.handleResize = _this.handleResize.bind(_this);
	
	    return _this;
	  }
	
	  _createClass(ZoomableGroup, [{
	    key: "handleMouseMove",
	    value: function handleMouseMove(_ref) {
	      var pageX = _ref.pageX,
	          pageY = _ref.pageY;
	
	      if (this.props.disablePanning) return;
	      if (!this.state.isPressed) return;
	      this.setState({
	        mouseX: pageX - this.state.mouseXStart,
	        mouseY: pageY - this.state.mouseYStart
	      });
	    }
	  }, {
	    key: "handleTouchMove",
	    value: function handleTouchMove(_ref2) {
	      var touches = _ref2.touches;
	
	      this.handleMouseMove(touches[0]);
	    }
	  }, {
	    key: "handleMouseUp",
	    value: function handleMouseUp() {
	      if (this.props.disablePanning) return;
	      if (!this.state.isPressed) return;
	      this.setState({
	        isPressed: false
	      });
	      if (!this.props.onMoveEnd) return;
	      var _state = this.state,
	          mouseX = _state.mouseX,
	          mouseY = _state.mouseY,
	          resizeFactorX = _state.resizeFactorX,
	          resizeFactorY = _state.resizeFactorY;
	      var _props = this.props,
	          zoom = _props.zoom,
	          width = _props.width,
	          height = _props.height,
	          projection = _props.projection,
	          onMoveEnd = _props.onMoveEnd;
	
	      var x = width / 2 - mouseX * resizeFactorX / zoom;
	      var y = height / 2 - mouseY * resizeFactorY / zoom;
	      var newCenter = projection.invert([x, y]);
	      onMoveEnd(newCenter);
	    }
	  }, {
	    key: "handleMouseDown",
	    value: function handleMouseDown(_ref3) {
	      var pageX = _ref3.pageX,
	          pageY = _ref3.pageY;
	
	      if (this.props.disablePanning) return;
	      var _state2 = this.state,
	          mouseX = _state2.mouseX,
	          mouseY = _state2.mouseY,
	          resizeFactorX = _state2.resizeFactorX,
	          resizeFactorY = _state2.resizeFactorY;
	      var _props2 = this.props,
	          zoom = _props2.zoom,
	          width = _props2.width,
	          height = _props2.height,
	          projection = _props2.projection,
	          onMoveStart = _props2.onMoveStart;
	
	      this.setState({
	        isPressed: true,
	        mouseXStart: pageX - mouseX,
	        mouseYStart: pageY - mouseY
	      });
	      if (!onMoveStart) return;
	      var x = width / 2 - mouseX * resizeFactorX / zoom;
	      var y = height / 2 - mouseY * resizeFactorY / zoom;
	      var currentCenter = projection.invert([x, y]);
	      onMoveStart(currentCenter);
	    }
	  }, {
	    key: "handleTouchStart",
	    value: function handleTouchStart(_ref4) {
	      var touches = _ref4.touches;
	
	      if (touches.length > 1) {
	        this.handleMouseDown(touches[0]);
	      } else {
	        this.handleMouseUp();
	      }
	    }
	  }, {
	    key: "preventTouchScroll",
	    value: function preventTouchScroll(evt) {
	      if (evt.touches.length > 1) {
	        evt.preventDefault();
	      }
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var _state3 = this.state,
	          mouseX = _state3.mouseX,
	          mouseY = _state3.mouseY,
	          resizeFactorX = _state3.resizeFactorX,
	          resizeFactorY = _state3.resizeFactorY;
	      var _props3 = this.props,
	          projection = _props3.projection,
	          center = _props3.center,
	          zoom = _props3.zoom;
	
	
	      var zoomFactor = nextProps.zoom / zoom;
	      var centerChanged = JSON.stringify(nextProps.center) !== JSON.stringify(center);
	
	      this.setState({
	        zoom: nextProps.zoom,
	        mouseX: centerChanged ? (0, _utils.calculateMousePosition)("x", nextProps.projection, nextProps, nextProps.zoom, resizeFactorX) : mouseX * zoomFactor,
	        mouseY: centerChanged ? (0, _utils.calculateMousePosition)("y", nextProps.projection, nextProps, nextProps.zoom, resizeFactorY) : mouseY * zoomFactor
	      });
	    }
	  }, {
	    key: "handleResize",
	    value: function handleResize() {
	      var _props4 = this.props,
	          width = _props4.width,
	          height = _props4.height,
	          projection = _props4.projection,
	          zoom = _props4.zoom;
	
	
	      var resizeFactorX = (0, _utils.calculateResizeFactor)(this.zoomableGroupNode.parentNode.getBoundingClientRect().width, width);
	      var resizeFactorY = (0, _utils.calculateResizeFactor)(this.zoomableGroupNode.parentNode.getBoundingClientRect().height, height);
	
	      var xPercentageChange = 1 / resizeFactorX * this.state.resizeFactorX;
	      var yPercentageChange = 1 / resizeFactorY * this.state.resizeFactorY;
	
	      this.setState({
	        resizeFactorX: resizeFactorX,
	        resizeFactorY: resizeFactorY,
	        mouseX: this.state.mouseX * xPercentageChange,
	        mouseY: this.state.mouseY * yPercentageChange
	      });
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _props5 = this.props,
	          width = _props5.width,
	          height = _props5.height,
	          projection = _props5.projection,
	          zoom = _props5.zoom;
	
	
	      var resizeFactorX = (0, _utils.calculateResizeFactor)(this.zoomableGroupNode.parentNode.getBoundingClientRect().width, width);
	      var resizeFactorY = (0, _utils.calculateResizeFactor)(this.zoomableGroupNode.parentNode.getBoundingClientRect().height, height);
	
	      this.setState({
	        resizeFactorX: resizeFactorX,
	        resizeFactorY: resizeFactorY,
	        mouseX: (0, _utils.calculateMousePosition)("x", projection, this.props, zoom, resizeFactorX),
	        mouseY: (0, _utils.calculateMousePosition)("y", projection, this.props, zoom, resizeFactorY)
	      });
	
	      window.addEventListener("resize", this.handleResize);
	      window.addEventListener("mouseup", this.handleMouseUp);
	      this.zoomableGroupNode.addEventListener("touchmove", this.preventTouchScroll);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      window.removeEventListener("resize", this.handleResize);
	      window.removeEventListener("mouseup", this.handleMouseUp);
	      this.zoomableGroupNode.removeEventListener("touchmove", this.preventTouchScroll);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props6 = this.props,
	          width = _props6.width,
	          height = _props6.height,
	          zoom = _props6.zoom,
	          style = _props6.style,
	          projection = _props6.projection,
	          children = _props6.children;
	      var _state4 = this.state,
	          mouseX = _state4.mouseX,
	          mouseY = _state4.mouseY,
	          resizeFactorX = _state4.resizeFactorX,
	          resizeFactorY = _state4.resizeFactorY;
	
	
	      return _react2.default.createElement(
	        "g",
	        { className: "rsm-zoomable-group",
	          ref: function ref(zoomableGroupNode) {
	            return _this2.zoomableGroupNode = zoomableGroupNode;
	          },
	          transform: "\n           translate(\n             " + Math.round((width / 2 + resizeFactorX * mouseX) * 100) / 100 + "\n             " + Math.round((height / 2 + resizeFactorY * mouseY) * 100) / 100 + "\n           )\n           scale(" + zoom + ")\n           translate(" + -width / 2 + " " + -height / 2 + ")\n         ",
	          onMouseMove: this.handleMouseMove,
	          onMouseUp: this.handleMouseUp,
	          onMouseDown: this.handleMouseDown,
	          onTouchStart: this.handleTouchStart,
	          onTouchMove: this.handleTouchMove,
	          onTouchEnd: this.handleMouseUp,
	          style: style
	        },
	        _react2.default.createElement("rect", {
	          x: this.state.backdrop.x,
	          y: this.state.backdrop.y,
	          width: this.state.backdrop.width,
	          height: this.state.backdrop.height,
	          fill: "transparent",
	          style: { strokeWidth: 0 }
	        }),
	        (0, _utils.createNewChildren)(children, this.props)
	      );
	    }
	  }]);
	
	  return ZoomableGroup;
	}(_react.Component);
	
	ZoomableGroup.defaultProps = {
	  center: [0, 0],
	  backdrop: {
	    x: [-179.9, 179.9],
	    y: [89.9, -89.9]
	  },
	  zoom: 1,
	  disablePanning: false
	};
	
	exports.default = ZoomableGroup;

/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ComposableMap = __webpack_require__(1009);
	
	Object.defineProperty(exports, "ComposableMap", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ComposableMap).default;
	  }
	});
	
	var _ZoomableGroup = __webpack_require__(1018);
	
	Object.defineProperty(exports, "ZoomableGroup", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ZoomableGroup).default;
	  }
	});
	
	var _ZoomableGlobe = __webpack_require__(1017);
	
	Object.defineProperty(exports, "ZoomableGlobe", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ZoomableGlobe).default;
	  }
	});
	
	var _Geographies = __webpack_require__(1010);
	
	Object.defineProperty(exports, "Geographies", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Geographies).default;
	  }
	});
	
	var _Geography = __webpack_require__(1011);
	
	Object.defineProperty(exports, "Geography", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Geography).default;
	  }
	});
	
	var _Marker = __webpack_require__(1015);
	
	Object.defineProperty(exports, "Marker", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Marker).default;
	  }
	});
	
	var _Markers = __webpack_require__(1016);
	
	Object.defineProperty(exports, "Markers", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Markers).default;
	  }
	});
	
	var _Line = __webpack_require__(1013);
	
	Object.defineProperty(exports, "Line", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Line).default;
	  }
	});
	
	var _Lines = __webpack_require__(1014);
	
	Object.defineProperty(exports, "Lines", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Lines).default;
	  }
	});
	
	var _MapGroup = __webpack_require__(242);
	
	Object.defineProperty(exports, "MapGroup", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MapGroup).default;
	  }
	});
	
	var _Annotation = __webpack_require__(1007);
	
	Object.defineProperty(exports, "Annotation", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Annotation).default;
	  }
	});
	
	var _Annotations = __webpack_require__(1008);
	
	Object.defineProperty(exports, "Annotations", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Annotations).default;
	  }
	});
	
	var _Graticule = __webpack_require__(1012);
	
	Object.defineProperty(exports, "Graticule", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Graticule).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (width, height, config, projectionName) {
	
	  var scale = config.scale || _projectionConfig2.default.scale;
	  var xOffset = config.xOffset || _projectionConfig2.default.xOffset;
	  var yOffset = config.yOffset || _projectionConfig2.default.yOffset;
	  var rotation = config.rotation || _projectionConfig2.default.rotation;
	  var precision = config.precision || _projectionConfig2.default.precision;
	
	  var baseProjection = projectionReference[projectionName]().scale(scale).translate([xOffset + width / 2, yOffset + height / 2]).precision(precision);
	
	  return projectionName === "albersUsa" ? baseProjection : projectionName === "orthographic" ? baseProjection.rotate(rotation).clipAngle(90) : baseProjection.rotate(rotation);
	};
	
	var _d3GeoProjection = __webpack_require__(694);
	
	var _d3Geo = __webpack_require__(53);
	
	var _projectionConfig = __webpack_require__(585);
	
	var _projectionConfig2 = _interopRequireDefault(_projectionConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var projectionReference = {
	  mercator: _d3Geo.geoMercator,
	  miller: _d3GeoProjection.geoMiller,
	  times: _d3GeoProjection.geoTimes,
	  robinson: _d3GeoProjection.geoRobinson,
	  winkel3: _d3GeoProjection.geoWinkel3,
	  eckert4: _d3GeoProjection.geoEckert4,
	  albersUsa: _d3Geo.geoAlbersUsa,
	  orthographic: _d3Geo.geoOrthographic
	};

/***/ }),
/* 1021 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (target) {
	  target.prototype.isCustomEvent = function (ele) {
	    var event = this.state.event;
	
	    return event || !!ele.getAttribute('data-event');
	  };
	
	  /* Bind listener for custom event */
	  target.prototype.customBindListener = function (ele) {
	    var _this = this;
	
	    var _state = this.state,
	        event = _state.event,
	        eventOff = _state.eventOff;
	
	    var dataEvent = ele.getAttribute('data-event') || event;
	    var dataEventOff = ele.getAttribute('data-event-off') || eventOff;
	
	    dataEvent.split(' ').forEach(function (event) {
	      ele.removeEventListener(event, customListener);
	      customListener = checkStatus.bind(_this, dataEventOff);
	      ele.addEventListener(event, customListener, false);
	    });
	    if (dataEventOff) {
	      dataEventOff.split(' ').forEach(function (event) {
	        ele.removeEventListener(event, _this.hideTooltip);
	        ele.addEventListener(event, _this.hideTooltip, false);
	      });
	    }
	  };
	
	  /* Unbind listener for custom event */
	  target.prototype.customUnbindListener = function (ele) {
	    var _state2 = this.state,
	        event = _state2.event,
	        eventOff = _state2.eventOff;
	
	    var dataEvent = event || ele.getAttribute('data-event');
	    var dataEventOff = eventOff || ele.getAttribute('data-event-off');
	
	    ele.removeEventListener(dataEvent, customListener);
	    if (dataEventOff) ele.removeEventListener(dataEventOff, this.hideTooltip);
	  };
	};
	
	/**
	 * Custom events to control showing and hiding of tooltip
	 *
	 * @attributes
	 * - `event` {String}
	 * - `eventOff` {String}
	 */
	
	var checkStatus = function checkStatus(dataEventOff, e) {
	  var show = this.state.show;
	  var id = this.props.id;
	
	  var dataIsCapture = e.currentTarget.getAttribute('data-iscapture');
	  var isCapture = dataIsCapture && dataIsCapture === 'true' || this.props.isCapture;
	  var currentItem = e.currentTarget.getAttribute('currentItem');
	
	  if (!isCapture) e.stopPropagation();
	  if (show && currentItem === 'true') {
	    if (!dataEventOff) this.hideTooltip(e);
	  } else {
	    e.currentTarget.setAttribute('currentItem', 'true');
	    setUntargetItems(e.currentTarget, this.getTargetArray(id));
	    this.showTooltip(e);
	  }
	};
	
	var setUntargetItems = function setUntargetItems(currentTarget, targetArray) {
	  for (var i = 0; i < targetArray.length; i++) {
	    if (currentTarget !== targetArray[i]) {
	      targetArray[i].setAttribute('currentItem', 'false');
	    } else {
	      targetArray[i].setAttribute('currentItem', 'true');
	    }
	  }
	};
	
	var customListener = void 0;

/***/ }),
/* 1022 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (target) {
	  target.prototype.getEffect = function (currentTarget) {
	    var dataEffect = currentTarget.getAttribute('data-effect');
	    return dataEffect || this.props.effect || 'float';
	  };
	};

/***/ }),
/* 1023 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (target) {
	  target.prototype.isCapture = function (currentTarget) {
	    var dataIsCapture = currentTarget.getAttribute('data-iscapture');
	    return dataIsCapture && dataIsCapture === 'true' || this.props.isCapture || false;
	  };
	};

/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (target) {
	  /**
	   * Hide all tooltip
	   * @trigger ReactTooltip.hide()
	   */
	  target.hide = function (target) {
	    dispatchGlobalEvent(_constant2.default.GLOBAL.HIDE, { target: target });
	  };
	
	  /**
	   * Rebuild all tooltip
	   * @trigger ReactTooltip.rebuild()
	   */
	  target.rebuild = function () {
	    dispatchGlobalEvent(_constant2.default.GLOBAL.REBUILD);
	  };
	
	  /**
	   * Show specific tooltip
	   * @trigger ReactTooltip.show()
	   */
	  target.show = function (target) {
	    dispatchGlobalEvent(_constant2.default.GLOBAL.SHOW, { target: target });
	  };
	
	  target.prototype.globalRebuild = function () {
	    if (this.mount) {
	      this.unbindListener();
	      this.bindListener();
	    }
	  };
	
	  target.prototype.globalShow = function (event) {
	    if (this.mount) {
	      // Create a fake event, specific show will limit the type to `solid`
	      // only `float` type cares e.clientX e.clientY
	      var e = { currentTarget: event.detail.target };
	      this.showTooltip(e, true);
	    }
	  };
	
	  target.prototype.globalHide = function (event) {
	    if (this.mount) {
	      var hasTarget = event && event.detail && event.detail.target && true || false;
	      this.hideTooltip({ currentTarget: hasTarget && event.detail.target }, hasTarget);
	    }
	  };
	};
	
	var _constant = __webpack_require__(586);
	
	var _constant2 = _interopRequireDefault(_constant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dispatchGlobalEvent = function dispatchGlobalEvent(eventName, opts) {
	  // Compatibale with IE
	  // @see http://stackoverflow.com/questions/26596123/internet-explorer-9-10-11-event-constructor-doesnt-work
	  var event = void 0;
	
	  if (typeof window.CustomEvent === 'function') {
	    event = new window.CustomEvent(eventName, { detail: opts });
	  } else {
	    event = document.createEvent('Event');
	    event.initEvent(eventName, false, true);
	    event.detail = opts;
	  }
	
	  window.dispatchEvent(event);
	}; /**
	    * Static methods for react-tooltip
	    */

/***/ }),
/* 1025 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (target) {
	  target.prototype.bindRemovalTracker = function () {
	    var _this = this;
	
	    var MutationObserver = getMutationObserverClass();
	    if (MutationObserver == null) return;
	
	    var observer = new MutationObserver(function (mutations) {
	      for (var m1 = 0; m1 < mutations.length; m1++) {
	        var mutation = mutations[m1];
	        for (var m2 = 0; m2 < mutation.removedNodes.length; m2++) {
	          var element = mutation.removedNodes[m2];
	          if (element === _this.state.currentTarget) {
	            _this.hideTooltip();
	            return;
	          }
	        }
	      }
	    });
	
	    observer.observe(window.document, { childList: true, subtree: true });
	
	    this.removalTracker = observer;
	  };
	
	  target.prototype.unbindRemovalTracker = function () {
	    if (this.removalTracker) {
	      this.removalTracker.disconnect();
	      this.removalTracker = null;
	    }
	  };
	};
	
	/**
	 * Tracking target removing from DOM.
	 * It's nessesary to hide tooltip when it's target disappears.
	 * Otherwise, the tooltip would be shown forever until another target
	 * is triggered.
	 *
	 * If MutationObserver is not available, this feature just doesn't work.
	 */
	
	// https://hacks.mozilla.org/2012/05/dom-mutationobserver-reacting-to-dom-changes-without-killing-browser-performance/
	var getMutationObserverClass = function getMutationObserverClass() {
	  return window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
	};

/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (target) {
	  target.prototype.bindWindowEvents = function (resizeHide) {
	    // ReactTooltip.hide
	    window.removeEventListener(_constant2.default.GLOBAL.HIDE, this.globalHide);
	    window.addEventListener(_constant2.default.GLOBAL.HIDE, this.globalHide, false);
	
	    // ReactTooltip.rebuild
	    window.removeEventListener(_constant2.default.GLOBAL.REBUILD, this.globalRebuild);
	    window.addEventListener(_constant2.default.GLOBAL.REBUILD, this.globalRebuild, false);
	
	    // ReactTooltip.show
	    window.removeEventListener(_constant2.default.GLOBAL.SHOW, this.globalShow);
	    window.addEventListener(_constant2.default.GLOBAL.SHOW, this.globalShow, false);
	
	    // Resize
	    if (resizeHide) {
	      window.removeEventListener('resize', this.onWindowResize);
	      window.addEventListener('resize', this.onWindowResize, false);
	    }
	  };
	
	  target.prototype.unbindWindowEvents = function () {
	    window.removeEventListener(_constant2.default.GLOBAL.HIDE, this.globalHide);
	    window.removeEventListener(_constant2.default.GLOBAL.REBUILD, this.globalRebuild);
	    window.removeEventListener(_constant2.default.GLOBAL.SHOW, this.globalShow);
	    window.removeEventListener('resize', this.onWindowResize);
	  };
	
	  /**
	   * invoked by resize event of window
	   */
	  target.prototype.onWindowResize = function () {
	    if (!this.mount) return;
	    this.hideTooltip();
	  };
	};
	
	var _constant = __webpack_require__(586);
	
	var _constant2 = _interopRequireDefault(_constant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp;
	
	/* Decoraters */
	
	
	/* Utils */
	
	
	/* CSS */
	
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(337);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _classnames = __webpack_require__(619);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _staticMethods = __webpack_require__(1024);
	
	var _staticMethods2 = _interopRequireDefault(_staticMethods);
	
	var _windowListener = __webpack_require__(1026);
	
	var _windowListener2 = _interopRequireDefault(_windowListener);
	
	var _customEvent = __webpack_require__(1021);
	
	var _customEvent2 = _interopRequireDefault(_customEvent);
	
	var _isCapture = __webpack_require__(1023);
	
	var _isCapture2 = _interopRequireDefault(_isCapture);
	
	var _getEffect = __webpack_require__(1022);
	
	var _getEffect2 = _interopRequireDefault(_getEffect);
	
	var _trackRemoval = __webpack_require__(1025);
	
	var _trackRemoval2 = _interopRequireDefault(_trackRemoval);
	
	var _getPosition = __webpack_require__(1030);
	
	var _getPosition2 = _interopRequireDefault(_getPosition);
	
	var _getTipContent = __webpack_require__(1031);
	
	var _getTipContent2 = _interopRequireDefault(_getTipContent);
	
	var _aria = __webpack_require__(1029);
	
	var _nodeListToArray = __webpack_require__(1032);
	
	var _nodeListToArray2 = _interopRequireDefault(_nodeListToArray);
	
	var _style = __webpack_require__(1028);
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReactTooltip = (0, _staticMethods2.default)(_class = (0, _windowListener2.default)(_class = (0, _customEvent2.default)(_class = (0, _isCapture2.default)(_class = (0, _getEffect2.default)(_class = (0, _trackRemoval2.default)(_class = (_temp = _class2 = function (_React$Component) {
	  _inherits(ReactTooltip, _React$Component);
	
	  function ReactTooltip(props) {
	    _classCallCheck(this, ReactTooltip);
	
	    var _this = _possibleConstructorReturn(this, (ReactTooltip.__proto__ || Object.getPrototypeOf(ReactTooltip)).call(this, props));
	
	    _this.state = {
	      place: 'top', // Direction of tooltip
	      type: 'dark', // Color theme of tooltip
	      effect: 'float', // float or fixed
	      show: false,
	      border: false,
	      offset: {},
	      extraClass: '',
	      html: false,
	      delayHide: 0,
	      delayShow: 0,
	      event: props.event || null,
	      eventOff: props.eventOff || null,
	      currentEvent: null, // Current mouse event
	      currentTarget: null, // Current target of mouse event
	      ariaProps: (0, _aria.parseAria)(props), // aria- and role attributes
	      isEmptyTip: false,
	      disable: false,
	      originTooltip: null,
	      isMultiline: false
	    };
	
	    _this.bind(['showTooltip', 'updateTooltip', 'hideTooltip', 'getTooltipContent', 'globalRebuild', 'globalShow', 'globalHide', 'onWindowResize']);
	
	    _this.mount = true;
	    _this.delayShowLoop = null;
	    _this.delayHideLoop = null;
	    _this.intervalUpdateContent = null;
	    return _this;
	  }
	
	  /**
	   * For unify the bind and unbind listener
	   */
	
	
	  _createClass(ReactTooltip, [{
	    key: 'bind',
	    value: function bind(methodArray) {
	      var _this2 = this;
	
	      methodArray.forEach(function (method) {
	        _this2[method] = _this2[method].bind(_this2);
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          insecure = _props.insecure,
	          resizeHide = _props.resizeHide;
	
	      if (insecure) {
	        this.setStyleHeader(); // Set the style to the <link>
	      }
	      this.bindListener(); // Bind listener for tooltip
	      this.bindWindowEvents(resizeHide); // Bind global event for static method
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(props) {
	      var ariaProps = this.state.ariaProps;
	
	      var newAriaProps = (0, _aria.parseAria)(props);
	
	      var isChanged = Object.keys(newAriaProps).some(function (props) {
	        return newAriaProps[props] !== ariaProps[props];
	      });
	      if (isChanged) {
	        this.setState({ ariaProps: newAriaProps });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.mount = false;
	
	      this.clearTimer();
	
	      this.unbindListener();
	      this.removeScrollListener();
	      this.unbindWindowEvents();
	    }
	
	    /**
	     * Pick out corresponded target elements
	     */
	
	  }, {
	    key: 'getTargetArray',
	    value: function getTargetArray(id) {
	      var targetArray = void 0;
	      if (!id) {
	        targetArray = document.querySelectorAll('[data-tip]:not([data-for])');
	      } else {
	        var escaped = id.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
	        targetArray = document.querySelectorAll('[data-tip][data-for="' + escaped + '"]');
	      }
	      // targetArray is a NodeList, convert it to a real array
	      return (0, _nodeListToArray2.default)(targetArray);
	    }
	
	    /**
	     * Bind listener to the target elements
	     * These listeners used to trigger showing or hiding the tooltip
	     */
	
	  }, {
	    key: 'bindListener',
	    value: function bindListener() {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          id = _props2.id,
	          globalEventOff = _props2.globalEventOff;
	
	      var targetArray = this.getTargetArray(id);
	
	      targetArray.forEach(function (target) {
	        var isCaptureMode = _this3.isCapture(target);
	        var effect = _this3.getEffect(target);
	        if (target.getAttribute('currentItem') === null) {
	          target.setAttribute('currentItem', 'false');
	        }
	        _this3.unbindBasicListener(target);
	
	        if (_this3.isCustomEvent(target)) {
	          _this3.customBindListener(target);
	          return;
	        }
	
	        target.addEventListener('mouseenter', _this3.showTooltip, isCaptureMode);
	        if (effect === 'float') {
	          target.addEventListener('mousemove', _this3.updateTooltip, isCaptureMode);
	        }
	        target.addEventListener('mouseleave', _this3.hideTooltip, isCaptureMode);
	      });
	
	      // Global event to hide tooltip
	      if (globalEventOff) {
	        window.removeEventListener(globalEventOff, this.hideTooltip);
	        window.addEventListener(globalEventOff, this.hideTooltip, false);
	      }
	
	      // Track removal of targetArray elements from DOM
	      this.bindRemovalTracker();
	    }
	
	    /**
	     * Unbind listeners on target elements
	     */
	
	  }, {
	    key: 'unbindListener',
	    value: function unbindListener() {
	      var _this4 = this;
	
	      var _props3 = this.props,
	          id = _props3.id,
	          globalEventOff = _props3.globalEventOff;
	
	      var targetArray = this.getTargetArray(id);
	      targetArray.forEach(function (target) {
	        _this4.unbindBasicListener(target);
	        if (_this4.isCustomEvent(target)) _this4.customUnbindListener(target);
	      });
	
	      if (globalEventOff) window.removeEventListener(globalEventOff, this.hideTooltip);
	      this.unbindRemovalTracker();
	    }
	
	    /**
	     * Invoke this before bind listener and ummount the compont
	     * it is necessary to invloke this even when binding custom event
	     * so that the tooltip can switch between custom and default listener
	     */
	
	  }, {
	    key: 'unbindBasicListener',
	    value: function unbindBasicListener(target) {
	      var isCaptureMode = this.isCapture(target);
	      target.removeEventListener('mouseenter', this.showTooltip, isCaptureMode);
	      target.removeEventListener('mousemove', this.updateTooltip, isCaptureMode);
	      target.removeEventListener('mouseleave', this.hideTooltip, isCaptureMode);
	    }
	  }, {
	    key: 'getTooltipContent',
	    value: function getTooltipContent() {
	      var _props4 = this.props,
	          getContent = _props4.getContent,
	          children = _props4.children;
	
	      // Generate tooltip content
	
	      var content = void 0;
	      if (getContent) {
	        if (Array.isArray(getContent)) {
	          content = getContent[0] && getContent[0](this.state.originTooltip);
	        } else {
	          content = getContent(this.state.originTooltip);
	        }
	      }
	
	      return (0, _getTipContent2.default)(this.state.originTooltip, children, content, this.state.isMultiline);
	    }
	  }, {
	    key: 'isEmptyTip',
	    value: function isEmptyTip(placeholder) {
	      return typeof placeholder === 'string' && placeholder === '' || placeholder === null;
	    }
	
	    /**
	     * When mouse enter, show the tooltip
	     */
	
	  }, {
	    key: 'showTooltip',
	    value: function showTooltip(e, isGlobalCall) {
	      var _this5 = this;
	
	      if (isGlobalCall) {
	        // Don't trigger other elements belongs to other ReactTooltip
	        var targetArray = this.getTargetArray(this.props.id);
	        var isMyElement = targetArray.some(function (ele) {
	          return ele === e.currentTarget;
	        });
	        if (!isMyElement) return;
	      }
	      // Get the tooltip content
	      // calculate in this phrase so that tip width height can be detected
	      var _props5 = this.props,
	          multiline = _props5.multiline,
	          getContent = _props5.getContent;
	
	      var originTooltip = e.currentTarget.getAttribute('data-tip');
	      var isMultiline = e.currentTarget.getAttribute('data-multiline') || multiline || false;
	
	      // If it is focus event or called by ReactTooltip.show, switch to `solid` effect
	      var switchToSolid = e instanceof window.FocusEvent || isGlobalCall;
	
	      // if it needs to skip adding hide listener to scroll
	      var scrollHide = true;
	      if (e.currentTarget.getAttribute('data-scroll-hide')) {
	        scrollHide = e.currentTarget.getAttribute('data-scroll-hide') === 'true';
	      } else if (this.props.scrollHide != null) {
	        scrollHide = this.props.scrollHide;
	      }
	
	      // To prevent previously created timers from triggering
	      this.clearTimer();
	
	      this.setState({
	        originTooltip: originTooltip,
	        isMultiline: isMultiline,
	        desiredPlace: e.currentTarget.getAttribute('data-place') || this.props.place || 'top',
	        place: e.currentTarget.getAttribute('data-place') || this.props.place || 'top',
	        type: e.currentTarget.getAttribute('data-type') || this.props.type || 'dark',
	        effect: switchToSolid && 'solid' || this.getEffect(e.currentTarget),
	        offset: e.currentTarget.getAttribute('data-offset') || this.props.offset || {},
	        html: e.currentTarget.getAttribute('data-html') ? e.currentTarget.getAttribute('data-html') === 'true' : this.props.html || false,
	        delayShow: e.currentTarget.getAttribute('data-delay-show') || this.props.delayShow || 0,
	        delayHide: e.currentTarget.getAttribute('data-delay-hide') || this.props.delayHide || 0,
	        border: e.currentTarget.getAttribute('data-border') ? e.currentTarget.getAttribute('data-border') === 'true' : this.props.border || false,
	        extraClass: e.currentTarget.getAttribute('data-class') || this.props.class || this.props.className || '',
	        disable: e.currentTarget.getAttribute('data-tip-disable') ? e.currentTarget.getAttribute('data-tip-disable') === 'true' : this.props.disable || false
	      }, function () {
	        if (scrollHide) _this5.addScrollListener(e);
	        _this5.updateTooltip(e);
	
	        if (getContent && Array.isArray(getContent)) {
	          _this5.intervalUpdateContent = setInterval(function () {
	            if (_this5.mount) {
	              var _getContent = _this5.props.getContent;
	
	              var placeholder = (0, _getTipContent2.default)(originTooltip, '', _getContent[0](), isMultiline);
	              var isEmptyTip = _this5.isEmptyTip(placeholder);
	              _this5.setState({
	                isEmptyTip: isEmptyTip
	              });
	              _this5.updatePosition();
	            }
	          }, getContent[1]);
	        }
	      });
	    }
	
	    /**
	     * When mouse hover, updatetooltip
	     */
	
	  }, {
	    key: 'updateTooltip',
	    value: function updateTooltip(e) {
	      var _this6 = this;
	
	      var _state = this.state,
	          delayShow = _state.delayShow,
	          show = _state.show,
	          disable = _state.disable;
	      var afterShow = this.props.afterShow;
	
	      var placeholder = this.getTooltipContent();
	      var delayTime = show ? 0 : parseInt(delayShow, 10);
	      var eventTarget = e.currentTarget;
	
	      if (this.isEmptyTip(placeholder) || disable) return; // if the tooltip is empty, disable the tooltip
	      var updateState = function updateState() {
	        if (Array.isArray(placeholder) && placeholder.length > 0 || placeholder) {
	          var isInvisible = !_this6.state.show;
	          _this6.setState({
	            currentEvent: e,
	            currentTarget: eventTarget,
	            show: true
	          }, function () {
	            _this6.updatePosition();
	            if (isInvisible && afterShow) afterShow();
	          });
	        }
	      };
	
	      clearTimeout(this.delayShowLoop);
	      if (delayShow) {
	        this.delayShowLoop = setTimeout(updateState, delayTime);
	      } else {
	        updateState();
	      }
	    }
	
	    /**
	     * When mouse leave, hide tooltip
	     */
	
	  }, {
	    key: 'hideTooltip',
	    value: function hideTooltip(e, hasTarget) {
	      var _this7 = this;
	
	      var _state2 = this.state,
	          delayHide = _state2.delayHide,
	          disable = _state2.disable;
	      var afterHide = this.props.afterHide;
	
	      var placeholder = this.getTooltipContent();
	      if (!this.mount) return;
	      if (this.isEmptyTip(placeholder) || disable) return; // if the tooltip is empty, disable the tooltip
	      if (hasTarget) {
	        // Don't trigger other elements belongs to other ReactTooltip
	        var targetArray = this.getTargetArray(this.props.id);
	        var isMyElement = targetArray.some(function (ele) {
	          return ele === e.currentTarget;
	        });
	        if (!isMyElement || !this.state.show) return;
	      }
	      var resetState = function resetState() {
	        var isVisible = _this7.state.show;
	        _this7.setState({
	          show: false
	        }, function () {
	          _this7.removeScrollListener();
	          if (isVisible && afterHide) afterHide();
	        });
	      };
	
	      this.clearTimer();
	      if (delayHide) {
	        this.delayHideLoop = setTimeout(resetState, parseInt(delayHide, 10));
	      } else {
	        resetState();
	      }
	    }
	
	    /**
	     * Add scroll eventlistener when tooltip show
	     * automatically hide the tooltip when scrolling
	     */
	
	  }, {
	    key: 'addScrollListener',
	    value: function addScrollListener(e) {
	      var isCaptureMode = this.isCapture(e.currentTarget);
	      window.addEventListener('scroll', this.hideTooltip, isCaptureMode);
	    }
	  }, {
	    key: 'removeScrollListener',
	    value: function removeScrollListener() {
	      window.removeEventListener('scroll', this.hideTooltip);
	    }
	
	    // Calculation the position
	
	  }, {
	    key: 'updatePosition',
	    value: function updatePosition() {
	      var _this8 = this;
	
	      var _state3 = this.state,
	          currentEvent = _state3.currentEvent,
	          currentTarget = _state3.currentTarget,
	          place = _state3.place,
	          desiredPlace = _state3.desiredPlace,
	          effect = _state3.effect,
	          offset = _state3.offset;
	
	      var node = _reactDom2.default.findDOMNode(this);
	      var result = (0, _getPosition2.default)(currentEvent, currentTarget, node, place, desiredPlace, effect, offset);
	
	      if (result.isNewState) {
	        // Switch to reverse placement
	        return this.setState(result.newState, function () {
	          _this8.updatePosition();
	        });
	      }
	      // Set tooltip position
	      node.style.left = result.position.left + 'px';
	      node.style.top = result.position.top + 'px';
	    }
	
	    /**
	     * Set style tag in header
	     * in this way we can insert default css
	     */
	
	  }, {
	    key: 'setStyleHeader',
	    value: function setStyleHeader() {
	      var head = document.getElementsByTagName('head')[0];
	      if (!head.querySelector('style[id="react-tooltip"]')) {
	        var tag = document.createElement('style');
	        tag.id = 'react-tooltip';
	        tag.innerHTML = _style2.default;
	        head.insertBefore(tag, head.firstChild);
	      }
	    }
	
	    /**
	     * CLear all kinds of timeout of interval
	     */
	
	  }, {
	    key: 'clearTimer',
	    value: function clearTimer() {
	      clearTimeout(this.delayShowLoop);
	      clearTimeout(this.delayHideLoop);
	      clearInterval(this.intervalUpdateContent);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state4 = this.state,
	          extraClass = _state4.extraClass,
	          html = _state4.html,
	          ariaProps = _state4.ariaProps,
	          disable = _state4.disable;
	
	      var placeholder = this.getTooltipContent();
	      var isEmptyTip = this.isEmptyTip(placeholder);
	      var tooltipClass = (0, _classnames2.default)('__react_component_tooltip', { 'show': this.state.show && !disable && !isEmptyTip }, { 'border': this.state.border }, { 'place-top': this.state.place === 'top' }, { 'place-bottom': this.state.place === 'bottom' }, { 'place-left': this.state.place === 'left' }, { 'place-right': this.state.place === 'right' }, { 'type-dark': this.state.type === 'dark' }, { 'type-success': this.state.type === 'success' }, { 'type-warning': this.state.type === 'warning' }, { 'type-error': this.state.type === 'error' }, { 'type-info': this.state.type === 'info' }, { 'type-light': this.state.type === 'light' });
	
	      var Wrapper = this.props.wrapper;
	      if (ReactTooltip.supportedWrappers.indexOf(Wrapper) < 0) {
	        Wrapper = ReactTooltip.defaultProps.wrapper;
	      }
	
	      if (html) {
	        return _react2.default.createElement(Wrapper, _extends({ className: tooltipClass + ' ' + extraClass,
	          id: this.props.id
	        }, ariaProps, {
	          'data-id': 'tooltip',
	          dangerouslySetInnerHTML: { __html: placeholder } }));
	      } else {
	        return _react2.default.createElement(
	          Wrapper,
	          _extends({ className: tooltipClass + ' ' + extraClass,
	            id: this.props.id
	          }, ariaProps, {
	            'data-id': 'tooltip' }),
	          placeholder
	        );
	      }
	    }
	  }]);
	
	  return ReactTooltip;
	}(_react2.default.Component), _class2.propTypes = {
	  children: _propTypes2.default.any,
	  place: _propTypes2.default.string,
	  type: _propTypes2.default.string,
	  effect: _propTypes2.default.string,
	  offset: _propTypes2.default.object,
	  multiline: _propTypes2.default.bool,
	  border: _propTypes2.default.bool,
	  insecure: _propTypes2.default.bool,
	  class: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  id: _propTypes2.default.string,
	  html: _propTypes2.default.bool,
	  delayHide: _propTypes2.default.number,
	  delayShow: _propTypes2.default.number,
	  event: _propTypes2.default.string,
	  eventOff: _propTypes2.default.string,
	  watchWindow: _propTypes2.default.bool,
	  isCapture: _propTypes2.default.bool,
	  globalEventOff: _propTypes2.default.string,
	  getContent: _propTypes2.default.any,
	  afterShow: _propTypes2.default.func,
	  afterHide: _propTypes2.default.func,
	  disable: _propTypes2.default.bool,
	  scrollHide: _propTypes2.default.bool,
	  resizeHide: _propTypes2.default.bool,
	  wrapper: _propTypes2.default.string
	}, _class2.defaultProps = {
	  insecure: true,
	  resizeHide: true,
	  wrapper: 'div'
	}, _class2.supportedWrappers = ['div', 'span'], _class2.displayName = 'ReactTooltip', _temp)) || _class) || _class) || _class) || _class) || _class) || _class;
	
	/* export default not fit for standalone, it will exports {default:...} */
	
	
	module.exports = ReactTooltip;

/***/ }),
/* 1028 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = '.__react_component_tooltip{border-radius:3px;display:inline-block;font-size:13px;left:-999em;opacity:0;padding:8px 21px;position:fixed;pointer-events:none;transition:opacity 0.3s ease-out;top:-999em;visibility:hidden;z-index:999}.__react_component_tooltip:before,.__react_component_tooltip:after{content:"";width:0;height:0;position:absolute}.__react_component_tooltip.show{opacity:0.9;margin-top:0px;margin-left:0px;visibility:visible}.__react_component_tooltip.type-dark{color:#fff;background-color:#222}.__react_component_tooltip.type-dark.place-top:after{border-top-color:#222;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-dark.place-bottom:after{border-bottom-color:#222;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-dark.place-left:after{border-left-color:#222;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-dark.place-right:after{border-right-color:#222;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-dark.border{border:1px solid #fff}.__react_component_tooltip.type-dark.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-dark.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-dark.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-dark.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-success{color:#fff;background-color:#8DC572}.__react_component_tooltip.type-success.place-top:after{border-top-color:#8DC572;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-success.place-bottom:after{border-bottom-color:#8DC572;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-success.place-left:after{border-left-color:#8DC572;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-success.place-right:after{border-right-color:#8DC572;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-success.border{border:1px solid #fff}.__react_component_tooltip.type-success.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-success.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-success.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-success.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-warning{color:#fff;background-color:#F0AD4E}.__react_component_tooltip.type-warning.place-top:after{border-top-color:#F0AD4E;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-warning.place-bottom:after{border-bottom-color:#F0AD4E;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-warning.place-left:after{border-left-color:#F0AD4E;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-warning.place-right:after{border-right-color:#F0AD4E;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-warning.border{border:1px solid #fff}.__react_component_tooltip.type-warning.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-warning.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-warning.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-warning.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-error{color:#fff;background-color:#BE6464}.__react_component_tooltip.type-error.place-top:after{border-top-color:#BE6464;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-error.place-bottom:after{border-bottom-color:#BE6464;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-error.place-left:after{border-left-color:#BE6464;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-error.place-right:after{border-right-color:#BE6464;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-error.border{border:1px solid #fff}.__react_component_tooltip.type-error.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-error.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-error.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-error.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-info{color:#fff;background-color:#337AB7}.__react_component_tooltip.type-info.place-top:after{border-top-color:#337AB7;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-info.place-bottom:after{border-bottom-color:#337AB7;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-info.place-left:after{border-left-color:#337AB7;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-info.place-right:after{border-right-color:#337AB7;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-info.border{border:1px solid #fff}.__react_component_tooltip.type-info.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-info.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-info.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-info.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-light{color:#222;background-color:#fff}.__react_component_tooltip.type-light.place-top:after{border-top-color:#fff;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-light.place-bottom:after{border-bottom-color:#fff;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-light.place-left:after{border-left-color:#fff;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-light.place-right:after{border-right-color:#fff;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-light.border{border:1px solid #222}.__react_component_tooltip.type-light.border.place-top:before{border-top:8px solid #222}.__react_component_tooltip.type-light.border.place-bottom:before{border-bottom:8px solid #222}.__react_component_tooltip.type-light.border.place-left:before{border-left:8px solid #222}.__react_component_tooltip.type-light.border.place-right:before{border-right:8px solid #222}.__react_component_tooltip.place-top{margin-top:-10px}.__react_component_tooltip.place-top:before{border-left:10px solid transparent;border-right:10px solid transparent;bottom:-8px;left:50%;margin-left:-10px}.__react_component_tooltip.place-top:after{border-left:8px solid transparent;border-right:8px solid transparent;bottom:-6px;left:50%;margin-left:-8px}.__react_component_tooltip.place-bottom{margin-top:10px}.__react_component_tooltip.place-bottom:before{border-left:10px solid transparent;border-right:10px solid transparent;top:-8px;left:50%;margin-left:-10px}.__react_component_tooltip.place-bottom:after{border-left:8px solid transparent;border-right:8px solid transparent;top:-6px;left:50%;margin-left:-8px}.__react_component_tooltip.place-left{margin-left:-10px}.__react_component_tooltip.place-left:before{border-top:6px solid transparent;border-bottom:6px solid transparent;right:-8px;top:50%;margin-top:-5px}.__react_component_tooltip.place-left:after{border-top:5px solid transparent;border-bottom:5px solid transparent;right:-6px;top:50%;margin-top:-4px}.__react_component_tooltip.place-right{margin-left:10px}.__react_component_tooltip.place-right:before{border-top:6px solid transparent;border-bottom:6px solid transparent;left:-8px;top:50%;margin-top:-5px}.__react_component_tooltip.place-right:after{border-top:5px solid transparent;border-bottom:5px solid transparent;left:-6px;top:50%;margin-top:-4px}.__react_component_tooltip .multi-line{display:block;padding:2px 0px;text-align:center}';

/***/ }),
/* 1029 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.parseAria = parseAria;
	/**
	 * Support aria- and role in ReactTooltip
	 *
	 * @params props {Object}
	 * @return {Object}
	 */
	function parseAria(props) {
	  var ariaObj = {};
	  Object.keys(props).filter(function (prop) {
	    // aria-xxx and role is acceptable
	    return (/(^aria-\w+$|^role$)/.test(prop)
	    );
	  }).forEach(function (prop) {
	    ariaObj[prop] = props[prop];
	  });
	
	  return ariaObj;
	}

/***/ }),
/* 1030 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (e, target, node, place, desiredPlace, effect, offset) {
	  var _getDimensions = getDimensions(node),
	      tipWidth = _getDimensions.width,
	      tipHeight = _getDimensions.height;
	
	  var _getDimensions2 = getDimensions(target),
	      targetWidth = _getDimensions2.width,
	      targetHeight = _getDimensions2.height;
	
	  var _getCurrentOffset = getCurrentOffset(e, target, effect),
	      mouseX = _getCurrentOffset.mouseX,
	      mouseY = _getCurrentOffset.mouseY;
	
	  var defaultOffset = getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight);
	
	  var _calculateOffset = calculateOffset(offset),
	      extraOffset_X = _calculateOffset.extraOffset_X,
	      extraOffset_Y = _calculateOffset.extraOffset_Y;
	
	  var windowWidth = window.innerWidth;
	  var windowHeight = window.innerHeight;
	
	  var _getParent = getParent(node),
	      parentTop = _getParent.parentTop,
	      parentLeft = _getParent.parentLeft;
	
	  // Get the edge offset of the tooltip
	
	
	  var getTipOffsetLeft = function getTipOffsetLeft(place) {
	    var offset_X = defaultOffset[place].l;
	    return mouseX + offset_X + extraOffset_X;
	  };
	  var getTipOffsetRight = function getTipOffsetRight(place) {
	    var offset_X = defaultOffset[place].r;
	    return mouseX + offset_X + extraOffset_X;
	  };
	  var getTipOffsetTop = function getTipOffsetTop(place) {
	    var offset_Y = defaultOffset[place].t;
	    return mouseY + offset_Y + extraOffset_Y;
	  };
	  var getTipOffsetBottom = function getTipOffsetBottom(place) {
	    var offset_Y = defaultOffset[place].b;
	    return mouseY + offset_Y + extraOffset_Y;
	  };
	
	  // Judge if the tooltip has over the window(screen)
	  var outsideVertical = function outsideVertical() {
	    var result = false;
	    var newPlace = void 0;
	    if (getTipOffsetTop('left') < 0 && getTipOffsetBottom('left') <= windowHeight && getTipOffsetBottom('bottom') <= windowHeight) {
	      result = true;
	      newPlace = 'bottom';
	    } else if (getTipOffsetBottom('left') > windowHeight && getTipOffsetTop('left') >= 0 && getTipOffsetTop('top') >= 0) {
	      result = true;
	      newPlace = 'top';
	    }
	    return { result: result, newPlace: newPlace };
	  };
	  var outsideLeft = function outsideLeft() {
	    var _outsideVertical = outsideVertical(),
	        result = _outsideVertical.result,
	        newPlace = _outsideVertical.newPlace; // Deal with vertical as first priority
	
	
	    if (result && outsideHorizontal().result) {
	      return { result: false // No need to change, if change to vertical will out of space
	      };
	    }
	    if (!result && getTipOffsetLeft('left') < 0 && getTipOffsetRight('right') <= windowWidth) {
	      result = true; // If vertical ok, but let out of side and right won't out of side
	      newPlace = 'right';
	    }
	    return { result: result, newPlace: newPlace };
	  };
	  var outsideRight = function outsideRight() {
	    var _outsideVertical2 = outsideVertical(),
	        result = _outsideVertical2.result,
	        newPlace = _outsideVertical2.newPlace;
	
	    if (result && outsideHorizontal().result) {
	      return { result: false // No need to change, if change to vertical will out of space
	      };
	    }
	    if (!result && getTipOffsetRight('right') > windowWidth && getTipOffsetLeft('left') >= 0) {
	      result = true;
	      newPlace = 'left';
	    }
	    return { result: result, newPlace: newPlace };
	  };
	
	  var outsideHorizontal = function outsideHorizontal() {
	    var result = false;
	    var newPlace = void 0;
	    if (getTipOffsetLeft('top') < 0 && getTipOffsetRight('top') <= windowWidth && getTipOffsetRight('right') <= windowWidth) {
	      result = true;
	      newPlace = 'right';
	    } else if (getTipOffsetRight('top') > windowWidth && getTipOffsetLeft('top') >= 0 && getTipOffsetLeft('left') >= 0) {
	      result = true;
	      newPlace = 'left';
	    }
	    return { result: result, newPlace: newPlace };
	  };
	  var outsideTop = function outsideTop() {
	    var _outsideHorizontal = outsideHorizontal(),
	        result = _outsideHorizontal.result,
	        newPlace = _outsideHorizontal.newPlace;
	
	    if (result && outsideVertical().result) {
	      return { result: false };
	    }
	    if (!result && getTipOffsetTop('top') < 0 && getTipOffsetBottom('bottom') <= windowHeight) {
	      result = true;
	      newPlace = 'bottom';
	    }
	    return { result: result, newPlace: newPlace };
	  };
	  var outsideBottom = function outsideBottom() {
	    var _outsideHorizontal2 = outsideHorizontal(),
	        result = _outsideHorizontal2.result,
	        newPlace = _outsideHorizontal2.newPlace;
	
	    if (result && outsideVertical().result) {
	      return { result: false };
	    }
	    if (!result && getTipOffsetBottom('bottom') > windowHeight && getTipOffsetTop('top') >= 0) {
	      result = true;
	      newPlace = 'top';
	    }
	    return { result: result, newPlace: newPlace };
	  };
	
	  // Return new state to change the placement to the reverse if possible
	  var outsideLeftResult = outsideLeft();
	  var outsideRightResult = outsideRight();
	  var outsideTopResult = outsideTop();
	  var outsideBottomResult = outsideBottom();
	
	  if (place === 'left' && outsideLeftResult.result) {
	    return {
	      isNewState: true,
	      newState: { place: outsideLeftResult.newPlace }
	    };
	  } else if (place === 'right' && outsideRightResult.result) {
	    return {
	      isNewState: true,
	      newState: { place: outsideRightResult.newPlace }
	    };
	  } else if (place === 'top' && outsideTopResult.result) {
	    return {
	      isNewState: true,
	      newState: { place: outsideTopResult.newPlace }
	    };
	  } else if (place === 'bottom' && outsideBottomResult.result) {
	    return {
	      isNewState: true,
	      newState: { place: outsideBottomResult.newPlace }
	    };
	  }
	
	  // Change back to original place if possible
	  if (place !== desiredPlace) {
	    if (desiredPlace === 'top' && !outsideTopResult.result) {
	      return {
	        isNewState: true,
	        newState: { place: 'top' }
	      };
	    } else if (desiredPlace === 'left' && !outsideLeftResult.result) {
	      return {
	        isNewState: true,
	        newState: { place: 'left' }
	      };
	    } else if (desiredPlace === 'right' && !outsideRightResult.result) {
	      return {
	        isNewState: true,
	        newState: { place: 'right' }
	      };
	    } else if (desiredPlace === 'bottom' && !outsideBottomResult.result) {
	      return {
	        isNewState: true,
	        newState: { place: 'bottom' }
	      };
	    }
	  }
	
	  // Return tooltip offset position
	  return {
	    isNewState: false,
	    position: {
	      left: parseInt(getTipOffsetLeft(place) - parentLeft, 10),
	      top: parseInt(getTipOffsetTop(place) - parentTop, 10)
	    }
	  };
	};
	
	var getDimensions = function getDimensions(node) {
	  var _node$getBoundingClie = node.getBoundingClientRect(),
	      height = _node$getBoundingClie.height,
	      width = _node$getBoundingClie.width;
	
	  return {
	    height: parseInt(height, 10),
	    width: parseInt(width, 10)
	  };
	};
	
	// Get current mouse offset
	/**
	 * Calculate the position of tooltip
	 *
	 * @params
	 * - `e` {Event} the event of current mouse
	 * - `target` {Element} the currentTarget of the event
	 * - `node` {DOM} the react-tooltip object
	 * - `place` {String} top / right / bottom / left
	 * - `effect` {String} float / solid
	 * - `offset` {Object} the offset to default position
	 *
	 * @return {Object
	 * - `isNewState` {Bool} required
	 * - `newState` {Object}
	 * - `position` {OBject} {left: {Number}, top: {Number}}
	 */
	var getCurrentOffset = function getCurrentOffset(e, currentTarget, effect) {
	  var boundingClientRect = currentTarget.getBoundingClientRect();
	  var targetTop = boundingClientRect.top;
	  var targetLeft = boundingClientRect.left;
	
	  var _getDimensions3 = getDimensions(currentTarget),
	      targetWidth = _getDimensions3.width,
	      targetHeight = _getDimensions3.height;
	
	  if (effect === 'float') {
	    return {
	      mouseX: e.clientX,
	      mouseY: e.clientY
	    };
	  }
	  return {
	    mouseX: targetLeft + targetWidth / 2,
	    mouseY: targetTop + targetHeight / 2
	  };
	};
	
	// List all possibility of tooltip final offset
	// This is useful in judging if it is necessary for tooltip to switch position when out of window
	var getDefaultPosition = function getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight) {
	  var top = void 0;
	  var right = void 0;
	  var bottom = void 0;
	  var left = void 0;
	  var disToMouse = 3;
	  var triangleHeight = 2;
	  var cursorHeight = 12; // Optimize for float bottom only, cause the cursor will hide the tooltip
	
	  if (effect === 'float') {
	    top = {
	      l: -(tipWidth / 2),
	      r: tipWidth / 2,
	      t: -(tipHeight + disToMouse + triangleHeight),
	      b: -disToMouse
	    };
	    bottom = {
	      l: -(tipWidth / 2),
	      r: tipWidth / 2,
	      t: disToMouse + cursorHeight,
	      b: tipHeight + disToMouse + triangleHeight + cursorHeight
	    };
	    left = {
	      l: -(tipWidth + disToMouse + triangleHeight),
	      r: -disToMouse,
	      t: -(tipHeight / 2),
	      b: tipHeight / 2
	    };
	    right = {
	      l: disToMouse,
	      r: tipWidth + disToMouse + triangleHeight,
	      t: -(tipHeight / 2),
	      b: tipHeight / 2
	    };
	  } else if (effect === 'solid') {
	    top = {
	      l: -(tipWidth / 2),
	      r: tipWidth / 2,
	      t: -(targetHeight / 2 + tipHeight + triangleHeight),
	      b: -(targetHeight / 2)
	    };
	    bottom = {
	      l: -(tipWidth / 2),
	      r: tipWidth / 2,
	      t: targetHeight / 2,
	      b: targetHeight / 2 + tipHeight + triangleHeight
	    };
	    left = {
	      l: -(tipWidth + targetWidth / 2 + triangleHeight),
	      r: -(targetWidth / 2),
	      t: -(tipHeight / 2),
	      b: tipHeight / 2
	    };
	    right = {
	      l: targetWidth / 2,
	      r: tipWidth + targetWidth / 2 + triangleHeight,
	      t: -(tipHeight / 2),
	      b: tipHeight / 2
	    };
	  }
	
	  return { top: top, bottom: bottom, left: left, right: right };
	};
	
	// Consider additional offset into position calculation
	var calculateOffset = function calculateOffset(offset) {
	  var extraOffset_X = 0;
	  var extraOffset_Y = 0;
	
	  if (Object.prototype.toString.apply(offset) === '[object String]') {
	    offset = JSON.parse(offset.toString().replace(/\'/g, '\"'));
	  }
	  for (var key in offset) {
	    if (key === 'top') {
	      extraOffset_Y -= parseInt(offset[key], 10);
	    } else if (key === 'bottom') {
	      extraOffset_Y += parseInt(offset[key], 10);
	    } else if (key === 'left') {
	      extraOffset_X -= parseInt(offset[key], 10);
	    } else if (key === 'right') {
	      extraOffset_X += parseInt(offset[key], 10);
	    }
	  }
	
	  return { extraOffset_X: extraOffset_X, extraOffset_Y: extraOffset_Y };
	};
	
	// Get the offset of the parent elements
	var getParent = function getParent(currentTarget) {
	  var currentParent = currentTarget;
	  while (currentParent) {
	    if (window.getComputedStyle(currentParent).getPropertyValue('transform') !== 'none') break;
	    currentParent = currentParent.parentElement;
	  }
	
	  var parentTop = currentParent && currentParent.getBoundingClientRect().top || 0;
	  var parentLeft = currentParent && currentParent.getBoundingClientRect().left || 0;
	
	  return { parentTop: parentTop, parentLeft: parentLeft };
	};

/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (tip, children, getContent, multiline) {
	  if (children) return children;
	  if (getContent !== undefined && getContent !== null) return getContent; // getContent can be 0, '', etc.
	  if (getContent === null) return null; // Tip not exist and childern is null or undefined
	
	  var regexp = /<br\s*\/?>/;
	  if (!multiline || multiline === 'false' || !regexp.test(tip)) {
	    // No trim(), so that user can keep their input
	    return tip;
	  }
	
	  // Multiline tooltip content
	  return tip.split(regexp).map(function (d, i) {
	    return _react2.default.createElement(
	      'span',
	      { key: i, className: 'multi-line' },
	      d
	    );
	  });
	};
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1032 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (nodeList) {
	  var length = nodeList.length;
	  if (nodeList.hasOwnProperty) {
	    return Array.prototype.slice.call(nodeList);
	  }
	  return new Array(length).fill().map(function (index) {
	    return nodeList[index];
	  });
	};

/***/ }),
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/topojson/topojson-client Version 2.1.0. Copyright 2016 Mike Bostock.
	(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (factory((global.topojson = global.topojson || {})));
	}(this, (function (exports) { 'use strict';
	
	var identity = function(x) {
	  return x;
	};
	
	var transform = function(topology) {
	  if ((transform = topology.transform) == null) return identity;
	  var transform,
	      x0,
	      y0,
	      kx = transform.scale[0],
	      ky = transform.scale[1],
	      dx = transform.translate[0],
	      dy = transform.translate[1];
	  return function(point, i) {
	    if (!i) x0 = y0 = 0;
	    point[0] = (x0 += point[0]) * kx + dx;
	    point[1] = (y0 += point[1]) * ky + dy;
	    return point;
	  };
	};
	
	var bbox = function(topology) {
	  var bbox = topology.bbox;
	
	  function bboxPoint(p0) {
	    p1[0] = p0[0], p1[1] = p0[1], t(p1);
	    if (p1[0] < x0) x0 = p1[0];
	    if (p1[0] > x1) x1 = p1[0];
	    if (p1[1] < y0) y0 = p1[1];
	    if (p1[1] > y1) y1 = p1[1];
	  }
	
	  function bboxGeometry(o) {
	    switch (o.type) {
	      case "GeometryCollection": o.geometries.forEach(bboxGeometry); break;
	      case "Point": bboxPoint(o.coordinates); break;
	      case "MultiPoint": o.coordinates.forEach(bboxPoint); break;
	    }
	  }
	
	  if (!bbox) {
	    var t = transform(topology), p0, p1 = new Array(2), name,
	        x0 = Infinity, y0 = x0, x1 = -x0, y1 = -x0;
	
	    topology.arcs.forEach(function(arc) {
	      var i = -1, n = arc.length;
	      while (++i < n) {
	        p0 = arc[i], p1[0] = p0[0], p1[1] = p0[1], t(p1, i);
	        if (p1[0] < x0) x0 = p1[0];
	        if (p1[0] > x1) x1 = p1[0];
	        if (p1[1] < y0) y0 = p1[1];
	        if (p1[1] > y1) y1 = p1[1];
	      }
	    });
	
	    for (name in topology.objects) {
	      bboxGeometry(topology.objects[name]);
	    }
	
	    bbox = topology.bbox = [x0, y0, x1, y1];
	  }
	
	  return bbox;
	};
	
	var reverse = function(array, n) {
	  var t, j = array.length, i = j - n;
	  while (i < --j) t = array[i], array[i++] = array[j], array[j] = t;
	};
	
	var feature = function(topology, o) {
	  return o.type === "GeometryCollection"
	      ? {type: "FeatureCollection", features: o.geometries.map(function(o) { return feature$1(topology, o); })}
	      : feature$1(topology, o);
	};
	
	function feature$1(topology, o) {
	  var id = o.id,
	      bbox = o.bbox,
	      properties = o.properties == null ? {} : o.properties,
	      geometry = object(topology, o);
	  return id == null && bbox == null ? {type: "Feature", properties: properties, geometry: geometry}
	      : bbox == null ? {type: "Feature", id: id, properties: properties, geometry: geometry}
	      : {type: "Feature", id: id, bbox: bbox, properties: properties, geometry: geometry};
	}
	
	function object(topology, o) {
	  var transformPoint = transform(topology),
	      arcs = topology.arcs;
	
	  function arc(i, points) {
	    if (points.length) points.pop();
	    for (var a = arcs[i < 0 ? ~i : i], k = 0, n = a.length; k < n; ++k) {
	      points.push(transformPoint(a[k].slice(), k));
	    }
	    if (i < 0) reverse(points, n);
	  }
	
	  function point(p) {
	    return transformPoint(p.slice());
	  }
	
	  function line(arcs) {
	    var points = [];
	    for (var i = 0, n = arcs.length; i < n; ++i) arc(arcs[i], points);
	    if (points.length < 2) points.push(points[0].slice());
	    return points;
	  }
	
	  function ring(arcs) {
	    var points = line(arcs);
	    while (points.length < 4) points.push(points[0].slice());
	    return points;
	  }
	
	  function polygon(arcs) {
	    return arcs.map(ring);
	  }
	
	  function geometry(o) {
	    var type = o.type, coordinates;
	    switch (type) {
	      case "GeometryCollection": return {type: type, geometries: o.geometries.map(geometry)};
	      case "Point": coordinates = point(o.coordinates); break;
	      case "MultiPoint": coordinates = o.coordinates.map(point); break;
	      case "LineString": coordinates = line(o.arcs); break;
	      case "MultiLineString": coordinates = o.arcs.map(line); break;
	      case "Polygon": coordinates = polygon(o.arcs); break;
	      case "MultiPolygon": coordinates = o.arcs.map(polygon); break;
	      default: return null;
	    }
	    return {type: type, coordinates: coordinates};
	  }
	
	  return geometry(o);
	}
	
	var stitch = function(topology, arcs) {
	  var stitchedArcs = {},
	      fragmentByStart = {},
	      fragmentByEnd = {},
	      fragments = [],
	      emptyIndex = -1;
	
	  // Stitch empty arcs first, since they may be subsumed by other arcs.
	  arcs.forEach(function(i, j) {
	    var arc = topology.arcs[i < 0 ? ~i : i], t;
	    if (arc.length < 3 && !arc[1][0] && !arc[1][1]) {
	      t = arcs[++emptyIndex], arcs[emptyIndex] = i, arcs[j] = t;
	    }
	  });
	
	  arcs.forEach(function(i) {
	    var e = ends(i),
	        start = e[0],
	        end = e[1],
	        f, g;
	
	    if (f = fragmentByEnd[start]) {
	      delete fragmentByEnd[f.end];
	      f.push(i);
	      f.end = end;
	      if (g = fragmentByStart[end]) {
	        delete fragmentByStart[g.start];
	        var fg = g === f ? f : f.concat(g);
	        fragmentByStart[fg.start = f.start] = fragmentByEnd[fg.end = g.end] = fg;
	      } else {
	        fragmentByStart[f.start] = fragmentByEnd[f.end] = f;
	      }
	    } else if (f = fragmentByStart[end]) {
	      delete fragmentByStart[f.start];
	      f.unshift(i);
	      f.start = start;
	      if (g = fragmentByEnd[start]) {
	        delete fragmentByEnd[g.end];
	        var gf = g === f ? f : g.concat(f);
	        fragmentByStart[gf.start = g.start] = fragmentByEnd[gf.end = f.end] = gf;
	      } else {
	        fragmentByStart[f.start] = fragmentByEnd[f.end] = f;
	      }
	    } else {
	      f = [i];
	      fragmentByStart[f.start = start] = fragmentByEnd[f.end = end] = f;
	    }
	  });
	
	  function ends(i) {
	    var arc = topology.arcs[i < 0 ? ~i : i], p0 = arc[0], p1;
	    if (topology.transform) p1 = [0, 0], arc.forEach(function(dp) { p1[0] += dp[0], p1[1] += dp[1]; });
	    else p1 = arc[arc.length - 1];
	    return i < 0 ? [p1, p0] : [p0, p1];
	  }
	
	  function flush(fragmentByEnd, fragmentByStart) {
	    for (var k in fragmentByEnd) {
	      var f = fragmentByEnd[k];
	      delete fragmentByStart[f.start];
	      delete f.start;
	      delete f.end;
	      f.forEach(function(i) { stitchedArcs[i < 0 ? ~i : i] = 1; });
	      fragments.push(f);
	    }
	  }
	
	  flush(fragmentByEnd, fragmentByStart);
	  flush(fragmentByStart, fragmentByEnd);
	  arcs.forEach(function(i) { if (!stitchedArcs[i < 0 ? ~i : i]) fragments.push([i]); });
	
	  return fragments;
	};
	
	var mesh = function(topology) {
	  return object(topology, meshArcs.apply(this, arguments));
	};
	
	function meshArcs(topology, object$$1, filter) {
	  var arcs, i, n;
	  if (arguments.length > 1) arcs = extractArcs(topology, object$$1, filter);
	  else for (i = 0, arcs = new Array(n = topology.arcs.length); i < n; ++i) arcs[i] = i;
	  return {type: "MultiLineString", arcs: stitch(topology, arcs)};
	}
	
	function extractArcs(topology, object$$1, filter) {
	  var arcs = [],
	      geomsByArc = [],
	      geom;
	
	  function extract0(i) {
	    var j = i < 0 ? ~i : i;
	    (geomsByArc[j] || (geomsByArc[j] = [])).push({i: i, g: geom});
	  }
	
	  function extract1(arcs) {
	    arcs.forEach(extract0);
	  }
	
	  function extract2(arcs) {
	    arcs.forEach(extract1);
	  }
	
	  function extract3(arcs) {
	    arcs.forEach(extract2);
	  }
	
	  function geometry(o) {
	    switch (geom = o, o.type) {
	      case "GeometryCollection": o.geometries.forEach(geometry); break;
	      case "LineString": extract1(o.arcs); break;
	      case "MultiLineString": case "Polygon": extract2(o.arcs); break;
	      case "MultiPolygon": extract3(o.arcs); break;
	    }
	  }
	
	  geometry(object$$1);
	
	  geomsByArc.forEach(filter == null
	      ? function(geoms) { arcs.push(geoms[0].i); }
	      : function(geoms) { if (filter(geoms[0].g, geoms[geoms.length - 1].g)) arcs.push(geoms[0].i); });
	
	  return arcs;
	}
	
	function planarRingArea(ring) {
	  var i = -1, n = ring.length, a, b = ring[n - 1], area = 0;
	  while (++i < n) a = b, b = ring[i], area += a[0] * b[1] - a[1] * b[0];
	  return Math.abs(area); // Note: doubled area!
	}
	
	var merge = function(topology) {
	  return object(topology, mergeArcs.apply(this, arguments));
	};
	
	function mergeArcs(topology, objects) {
	  var polygonsByArc = {},
	      polygons = [],
	      groups = [];
	
	  objects.forEach(geometry);
	
	  function geometry(o) {
	    switch (o.type) {
	      case "GeometryCollection": o.geometries.forEach(geometry); break;
	      case "Polygon": extract(o.arcs); break;
	      case "MultiPolygon": o.arcs.forEach(extract); break;
	    }
	  }
	
	  function extract(polygon) {
	    polygon.forEach(function(ring) {
	      ring.forEach(function(arc) {
	        (polygonsByArc[arc = arc < 0 ? ~arc : arc] || (polygonsByArc[arc] = [])).push(polygon);
	      });
	    });
	    polygons.push(polygon);
	  }
	
	  function area(ring) {
	    return planarRingArea(object(topology, {type: "Polygon", arcs: [ring]}).coordinates[0]);
	  }
	
	  polygons.forEach(function(polygon) {
	    if (!polygon._) {
	      var group = [],
	          neighbors = [polygon];
	      polygon._ = 1;
	      groups.push(group);
	      while (polygon = neighbors.pop()) {
	        group.push(polygon);
	        polygon.forEach(function(ring) {
	          ring.forEach(function(arc) {
	            polygonsByArc[arc < 0 ? ~arc : arc].forEach(function(polygon) {
	              if (!polygon._) {
	                polygon._ = 1;
	                neighbors.push(polygon);
	              }
	            });
	          });
	        });
	      }
	    }
	  });
	
	  polygons.forEach(function(polygon) {
	    delete polygon._;
	  });
	
	  return {
	    type: "MultiPolygon",
	    arcs: groups.map(function(polygons) {
	      var arcs = [], n;
	
	      // Extract the exterior (unique) arcs.
	      polygons.forEach(function(polygon) {
	        polygon.forEach(function(ring) {
	          ring.forEach(function(arc) {
	            if (polygonsByArc[arc < 0 ? ~arc : arc].length < 2) {
	              arcs.push(arc);
	            }
	          });
	        });
	      });
	
	      // Stitch the arcs into one or more rings.
	      arcs = stitch(topology, arcs);
	
	      // If more than one ring is returned,
	      // at most one of these rings can be the exterior;
	      // choose the one with the greatest absolute area.
	      if ((n = arcs.length) > 1) {
	        for (var i = 1, k = area(arcs[0]), ki, t; i < n; ++i) {
	          if ((ki = area(arcs[i])) > k) {
	            t = arcs[0], arcs[0] = arcs[i], arcs[i] = t, k = ki;
	          }
	        }
	      }
	
	      return arcs;
	    })
	  };
	}
	
	var bisect = function(a, x) {
	  var lo = 0, hi = a.length;
	  while (lo < hi) {
	    var mid = lo + hi >>> 1;
	    if (a[mid] < x) lo = mid + 1;
	    else hi = mid;
	  }
	  return lo;
	};
	
	var neighbors = function(objects) {
	  var indexesByArc = {}, // arc index -> array of object indexes
	      neighbors = objects.map(function() { return []; });
	
	  function line(arcs, i) {
	    arcs.forEach(function(a) {
	      if (a < 0) a = ~a;
	      var o = indexesByArc[a];
	      if (o) o.push(i);
	      else indexesByArc[a] = [i];
	    });
	  }
	
	  function polygon(arcs, i) {
	    arcs.forEach(function(arc) { line(arc, i); });
	  }
	
	  function geometry(o, i) {
	    if (o.type === "GeometryCollection") o.geometries.forEach(function(o) { geometry(o, i); });
	    else if (o.type in geometryType) geometryType[o.type](o.arcs, i);
	  }
	
	  var geometryType = {
	    LineString: line,
	    MultiLineString: polygon,
	    Polygon: polygon,
	    MultiPolygon: function(arcs, i) { arcs.forEach(function(arc) { polygon(arc, i); }); }
	  };
	
	  objects.forEach(geometry);
	
	  for (var i in indexesByArc) {
	    for (var indexes = indexesByArc[i], m = indexes.length, j = 0; j < m; ++j) {
	      for (var k = j + 1; k < m; ++k) {
	        var ij = indexes[j], ik = indexes[k], n;
	        if ((n = neighbors[ij])[i = bisect(n, ik)] !== ik) n.splice(i, 0, ik);
	        if ((n = neighbors[ik])[i = bisect(n, ij)] !== ij) n.splice(i, 0, ij);
	      }
	    }
	  }
	
	  return neighbors;
	};
	
	var quantize = function(topology, n) {
	  if (!((n = Math.floor(n)) >= 2)) throw new Error("n must be ≥2");
	  if (topology.transform) throw new Error("already quantized");
	  var bb = bbox(topology), name,
	      dx = bb[0], kx = (bb[2] - dx) / (n - 1) || 1,
	      dy = bb[1], ky = (bb[3] - dy) / (n - 1) || 1;
	
	  function quantizePoint(p) {
	    p[0] = Math.round((p[0] - dx) / kx);
	    p[1] = Math.round((p[1] - dy) / ky);
	  }
	
	  function quantizeGeometry(o) {
	    switch (o.type) {
	      case "GeometryCollection": o.geometries.forEach(quantizeGeometry); break;
	      case "Point": quantizePoint(o.coordinates); break;
	      case "MultiPoint": o.coordinates.forEach(quantizePoint); break;
	    }
	  }
	
	  topology.arcs.forEach(function(arc) {
	    var i = 1,
	        j = 1,
	        n = arc.length,
	        pi = arc[0],
	        x0 = pi[0] = Math.round((pi[0] - dx) / kx),
	        y0 = pi[1] = Math.round((pi[1] - dy) / ky),
	        pj,
	        x1,
	        y1;
	
	    for (; i < n; ++i) {
	      pi = arc[i];
	      x1 = Math.round((pi[0] - dx) / kx);
	      y1 = Math.round((pi[1] - dy) / ky);
	      if (x1 !== x0 || y1 !== y0) {
	        pj = arc[j++];
	        pj[0] = x1 - x0, x0 = x1;
	        pj[1] = y1 - y0, y0 = y1;
	      }
	    }
	
	    if (j < 2) {
	      pj = arc[j++];
	      pj[0] = 0;
	      pj[1] = 0;
	    }
	
	    arc.length = j;
	  });
	
	  for (name in topology.objects) {
	    quantizeGeometry(topology.objects[name]);
	  }
	
	  topology.transform = {
	    scale: [kx, ky],
	    translate: [dx, dy]
	  };
	
	  return topology;
	};
	
	var untransform = function(topology) {
	  if ((transform = topology.transform) == null) return identity;
	  var transform,
	      x0,
	      y0,
	      kx = transform.scale[0],
	      ky = transform.scale[1],
	      dx = transform.translate[0],
	      dy = transform.translate[1];
	  return function(point, i) {
	    if (!i) x0 = y0 = 0;
	    var x1 = Math.round((point[0] - dx) / kx),
	        y1 = Math.round((point[1] - dy) / ky);
	    point[0] = x1 - x0, x0 = x1;
	    point[1] = y1 - y0, y0 = y1;
	    return point;
	  };
	};
	
	exports.bbox = bbox;
	exports.feature = feature;
	exports.mesh = mesh;
	exports.meshArcs = meshArcs;
	exports.merge = merge;
	exports.mergeArcs = mergeArcs;
	exports.neighbors = neighbors;
	exports.quantize = quantize;
	exports.transform = transform;
	exports.untransform = untransform;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ })
]);


// WEBPACK FOOTER //
// component---src-pages-map-js-b43c59fe8599f882602a.js